(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cliSa", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $8fc615f169c24dfa$export$ffb0004e005737fa; }, function (v) { return $8fc615f169c24dfa$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $8fc615f169c24dfa$export$34b9dba7ce09269b; }, function (v) { return $8fc615f169c24dfa$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $8fc615f169c24dfa$export$25062201e9e25d76; }, function (v) { return $8fc615f169c24dfa$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8fc615f169c24dfa$export$ffb0004e005737fa;
var $8fc615f169c24dfa$export$34b9dba7ce09269b;
var $8fc615f169c24dfa$export$25062201e9e25d76;
'use strict';

var $e7uJ5 = parcelRequire("e7uJ5");
var $8fc615f169c24dfa$var$k = Symbol.for("react.element"), $8fc615f169c24dfa$var$l = Symbol.for("react.fragment"), $8fc615f169c24dfa$var$m = Object.prototype.hasOwnProperty, $8fc615f169c24dfa$var$n = $e7uJ5.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $8fc615f169c24dfa$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $8fc615f169c24dfa$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$8fc615f169c24dfa$var$m.call(a, b) && !$8fc615f169c24dfa$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $8fc615f169c24dfa$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $8fc615f169c24dfa$var$n.current
    };
}
$8fc615f169c24dfa$export$ffb0004e005737fa = $8fc615f169c24dfa$var$l;
$8fc615f169c24dfa$export$34b9dba7ce09269b = $8fc615f169c24dfa$var$q;
$8fc615f169c24dfa$export$25062201e9e25d76 = $8fc615f169c24dfa$var$q;

});
parcelRegister("e7uJ5", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3a6BM"));

});
parcelRegister("3a6BM", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $24d76e86b6696907$export$dca3b0875bd9a954; }, function (v) { return $24d76e86b6696907$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $24d76e86b6696907$export$16fa2f45be04daa8; }, function (v) { return $24d76e86b6696907$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $24d76e86b6696907$export$ffb0004e005737fa; }, function (v) { return $24d76e86b6696907$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $24d76e86b6696907$export$e2c29f18771995cb; }, function (v) { return $24d76e86b6696907$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $24d76e86b6696907$export$221d75b3f55bb0bd; }, function (v) { return $24d76e86b6696907$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $24d76e86b6696907$export$5f8d39834fd61797; }, function (v) { return $24d76e86b6696907$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $24d76e86b6696907$export$74bf444e3cd11ea5; }, function (v) { return $24d76e86b6696907$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $24d76e86b6696907$export$ae55be85d98224ed; }, function (v) { return $24d76e86b6696907$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $24d76e86b6696907$export$3ba232387fd5d6dd; }, function (v) { return $24d76e86b6696907$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $24d76e86b6696907$export$e530037191fcd5d7; }, function (v) { return $24d76e86b6696907$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $24d76e86b6696907$export$fd42f52fd3ae1109; }, function (v) { return $24d76e86b6696907$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $24d76e86b6696907$export$c8a8987d4410bf2d; }, function (v) { return $24d76e86b6696907$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $24d76e86b6696907$export$d38cd72104c1f0e9; }, function (v) { return $24d76e86b6696907$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $24d76e86b6696907$export$7d1e3a5e95ceca43; }, function (v) { return $24d76e86b6696907$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $24d76e86b6696907$export$257a8862b851cb5b; }, function (v) { return $24d76e86b6696907$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $24d76e86b6696907$export$a8257692ac88316c; }, function (v) { return $24d76e86b6696907$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $24d76e86b6696907$export$488013bae63b21da; }, function (v) { return $24d76e86b6696907$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $24d76e86b6696907$export$7c73462e0d25e514; }, function (v) { return $24d76e86b6696907$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $24d76e86b6696907$export$7568632d0d33d16d; }, function (v) { return $24d76e86b6696907$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $24d76e86b6696907$export$88948ce120ea2619; }, function (v) { return $24d76e86b6696907$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $24d76e86b6696907$export$35808ee640e87ca7; }, function (v) { return $24d76e86b6696907$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $24d76e86b6696907$export$fae74005e78b1a27; }, function (v) { return $24d76e86b6696907$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $24d76e86b6696907$export$dc8fbce3eb94dc1e; }, function (v) { return $24d76e86b6696907$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $24d76e86b6696907$export$6a7bc4e911dc01cf; }, function (v) { return $24d76e86b6696907$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $24d76e86b6696907$export$6d9c69b0de29b591; }, function (v) { return $24d76e86b6696907$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $24d76e86b6696907$export$f680877a34711e37; }, function (v) { return $24d76e86b6696907$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $24d76e86b6696907$export$d5a552a76deda3c2; }, function (v) { return $24d76e86b6696907$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $24d76e86b6696907$export$aaabe4eda9ed9969; }, function (v) { return $24d76e86b6696907$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $24d76e86b6696907$export$e5c5a5f917a5871c; }, function (v) { return $24d76e86b6696907$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $24d76e86b6696907$export$1538c33de8887b59; }, function (v) { return $24d76e86b6696907$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $24d76e86b6696907$export$13e3392192263954; }, function (v) { return $24d76e86b6696907$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $24d76e86b6696907$export$b8f5890fc79d6aca; }, function (v) { return $24d76e86b6696907$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $24d76e86b6696907$export$60241385465d0a34; }, function (v) { return $24d76e86b6696907$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $24d76e86b6696907$export$306c0aa65ff9ec16; }, function (v) { return $24d76e86b6696907$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $24d76e86b6696907$export$7b286972b8d8ccbf; }, function (v) { return $24d76e86b6696907$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $24d76e86b6696907$export$83d89fbfd8236492; }, function (v) { return $24d76e86b6696907$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $27SFb = parcelRequire("27SFb");
var $24d76e86b6696907$export$dca3b0875bd9a954;
var $24d76e86b6696907$export$16fa2f45be04daa8;
var $24d76e86b6696907$export$ffb0004e005737fa;
var $24d76e86b6696907$export$e2c29f18771995cb;
var $24d76e86b6696907$export$221d75b3f55bb0bd;
var $24d76e86b6696907$export$5f8d39834fd61797;
var $24d76e86b6696907$export$74bf444e3cd11ea5;
var $24d76e86b6696907$export$ae55be85d98224ed;
var $24d76e86b6696907$export$3ba232387fd5d6dd;
var $24d76e86b6696907$export$e530037191fcd5d7;
var $24d76e86b6696907$export$fd42f52fd3ae1109;
var $24d76e86b6696907$export$c8a8987d4410bf2d;
var $24d76e86b6696907$export$d38cd72104c1f0e9;
var $24d76e86b6696907$export$7d1e3a5e95ceca43;
var $24d76e86b6696907$export$257a8862b851cb5b;
var $24d76e86b6696907$export$a8257692ac88316c;
var $24d76e86b6696907$export$488013bae63b21da;
var $24d76e86b6696907$export$7c73462e0d25e514;
var $24d76e86b6696907$export$7568632d0d33d16d;
var $24d76e86b6696907$export$88948ce120ea2619;
var $24d76e86b6696907$export$35808ee640e87ca7;
var $24d76e86b6696907$export$fae74005e78b1a27;
var $24d76e86b6696907$export$dc8fbce3eb94dc1e;
var $24d76e86b6696907$export$6a7bc4e911dc01cf;
var $24d76e86b6696907$export$6d9c69b0de29b591;
var $24d76e86b6696907$export$f680877a34711e37;
var $24d76e86b6696907$export$d5a552a76deda3c2;
var $24d76e86b6696907$export$aaabe4eda9ed9969;
var $24d76e86b6696907$export$e5c5a5f917a5871c;
var $24d76e86b6696907$export$1538c33de8887b59;
var $24d76e86b6696907$export$13e3392192263954;
var $24d76e86b6696907$export$b8f5890fc79d6aca;
var $24d76e86b6696907$export$60241385465d0a34;
var $24d76e86b6696907$export$306c0aa65ff9ec16;
var $24d76e86b6696907$export$7b286972b8d8ccbf;
var $24d76e86b6696907$export$83d89fbfd8236492;
'use strict';
var $24d76e86b6696907$var$l = Symbol.for("react.element"), $24d76e86b6696907$var$n = Symbol.for("react.portal"), $24d76e86b6696907$var$p = Symbol.for("react.fragment"), $24d76e86b6696907$var$q = Symbol.for("react.strict_mode"), $24d76e86b6696907$var$r = Symbol.for("react.profiler"), $24d76e86b6696907$var$t = Symbol.for("react.provider"), $24d76e86b6696907$var$u = Symbol.for("react.context"), $24d76e86b6696907$var$v = Symbol.for("react.forward_ref"), $24d76e86b6696907$var$w = Symbol.for("react.suspense"), $24d76e86b6696907$var$x = Symbol.for("react.memo"), $24d76e86b6696907$var$y = Symbol.for("react.lazy"), $24d76e86b6696907$var$z = Symbol.iterator;
function $24d76e86b6696907$var$A(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $27SFb._)(a))) return null;
    a = $24d76e86b6696907$var$z && a[$24d76e86b6696907$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $24d76e86b6696907$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $24d76e86b6696907$var$C = Object.assign, $24d76e86b6696907$var$D = {};
function $24d76e86b6696907$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $24d76e86b6696907$var$D;
    this.updater = e || $24d76e86b6696907$var$B;
}
$24d76e86b6696907$var$E.prototype.isReactComponent = {};
$24d76e86b6696907$var$E.prototype.setState = function(a, b) {
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $27SFb._)(a)) && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$24d76e86b6696907$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $24d76e86b6696907$var$F() {}
$24d76e86b6696907$var$F.prototype = $24d76e86b6696907$var$E.prototype;
function $24d76e86b6696907$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $24d76e86b6696907$var$D;
    this.updater = e || $24d76e86b6696907$var$B;
}
var $24d76e86b6696907$var$H = $24d76e86b6696907$var$G.prototype = new $24d76e86b6696907$var$F;
$24d76e86b6696907$var$H.constructor = $24d76e86b6696907$var$G;
$24d76e86b6696907$var$C($24d76e86b6696907$var$H, $24d76e86b6696907$var$E.prototype);
$24d76e86b6696907$var$H.isPureReactComponent = !0;
var $24d76e86b6696907$var$I = Array.isArray, $24d76e86b6696907$var$J = Object.prototype.hasOwnProperty, $24d76e86b6696907$var$K = {
    current: null
}, $24d76e86b6696907$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $24d76e86b6696907$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$24d76e86b6696907$var$J.call(b, d) && !$24d76e86b6696907$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $24d76e86b6696907$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $24d76e86b6696907$var$K.current
    };
}
function $24d76e86b6696907$var$N(a, b) {
    return {
        $$typeof: $24d76e86b6696907$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $24d76e86b6696907$var$O(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $27SFb._)(a)) && null !== a && a.$$typeof === $24d76e86b6696907$var$l;
}
function $24d76e86b6696907$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $24d76e86b6696907$var$P = /\/+/g;
function $24d76e86b6696907$var$Q(a, b) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $27SFb._)(a)) && null !== a && null != a.key ? $24d76e86b6696907$var$escape("" + a.key) : b.toString(36);
}
function $24d76e86b6696907$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $27SFb._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $24d76e86b6696907$var$l:
                case $24d76e86b6696907$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $24d76e86b6696907$var$Q(h, 0) : d, $24d76e86b6696907$var$I(c) ? (e = "", null != a && (e = a.replace($24d76e86b6696907$var$P, "$&/") + "/"), $24d76e86b6696907$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($24d76e86b6696907$var$O(c) && (c = $24d76e86b6696907$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($24d76e86b6696907$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($24d76e86b6696907$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $24d76e86b6696907$var$Q(k, g);
        h += $24d76e86b6696907$var$R(k, b, e, f, c);
    }
    else if (f = $24d76e86b6696907$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $24d76e86b6696907$var$Q(k, g++), h += $24d76e86b6696907$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $24d76e86b6696907$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $24d76e86b6696907$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $24d76e86b6696907$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $24d76e86b6696907$var$U = {
    current: null
}, $24d76e86b6696907$var$V = {
    transition: null
}, $24d76e86b6696907$var$W = {
    ReactCurrentDispatcher: $24d76e86b6696907$var$U,
    ReactCurrentBatchConfig: $24d76e86b6696907$var$V,
    ReactCurrentOwner: $24d76e86b6696907$var$K
};
function $24d76e86b6696907$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$24d76e86b6696907$export$dca3b0875bd9a954 = {
    map: $24d76e86b6696907$var$S,
    forEach: function forEach(a, b, e) {
        $24d76e86b6696907$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $24d76e86b6696907$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $24d76e86b6696907$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$24d76e86b6696907$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$24d76e86b6696907$export$16fa2f45be04daa8 = $24d76e86b6696907$var$E;
$24d76e86b6696907$export$ffb0004e005737fa = $24d76e86b6696907$var$p;
$24d76e86b6696907$export$e2c29f18771995cb = $24d76e86b6696907$var$r;
$24d76e86b6696907$export$221d75b3f55bb0bd = $24d76e86b6696907$var$G;
$24d76e86b6696907$export$5f8d39834fd61797 = $24d76e86b6696907$var$q;
$24d76e86b6696907$export$74bf444e3cd11ea5 = $24d76e86b6696907$var$w;
$24d76e86b6696907$export$ae55be85d98224ed = $24d76e86b6696907$var$W;
$24d76e86b6696907$export$3ba232387fd5d6dd = $24d76e86b6696907$var$X;
$24d76e86b6696907$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $24d76e86b6696907$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $24d76e86b6696907$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$24d76e86b6696907$var$J.call(b, f) && !$24d76e86b6696907$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $24d76e86b6696907$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$24d76e86b6696907$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $24d76e86b6696907$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $24d76e86b6696907$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$24d76e86b6696907$export$c8a8987d4410bf2d = $24d76e86b6696907$var$M;
$24d76e86b6696907$export$d38cd72104c1f0e9 = function(a) {
    var b = $24d76e86b6696907$var$M.bind(null, a);
    b.type = a;
    return b;
};
$24d76e86b6696907$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$24d76e86b6696907$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $24d76e86b6696907$var$v,
        render: a
    };
};
$24d76e86b6696907$export$a8257692ac88316c = $24d76e86b6696907$var$O;
$24d76e86b6696907$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $24d76e86b6696907$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $24d76e86b6696907$var$T
    };
};
$24d76e86b6696907$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $24d76e86b6696907$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$24d76e86b6696907$export$7568632d0d33d16d = function(a) {
    var b = $24d76e86b6696907$var$V.transition;
    $24d76e86b6696907$var$V.transition = {};
    try {
        a();
    } finally{
        $24d76e86b6696907$var$V.transition = b;
    }
};
$24d76e86b6696907$export$88948ce120ea2619 = $24d76e86b6696907$var$X;
$24d76e86b6696907$export$35808ee640e87ca7 = function(a, b) {
    return $24d76e86b6696907$var$U.current.useCallback(a, b);
};
$24d76e86b6696907$export$fae74005e78b1a27 = function(a) {
    return $24d76e86b6696907$var$U.current.useContext(a);
};
$24d76e86b6696907$export$dc8fbce3eb94dc1e = function() {};
$24d76e86b6696907$export$6a7bc4e911dc01cf = function(a) {
    return $24d76e86b6696907$var$U.current.useDeferredValue(a);
};
$24d76e86b6696907$export$6d9c69b0de29b591 = function(a, b) {
    return $24d76e86b6696907$var$U.current.useEffect(a, b);
};
$24d76e86b6696907$export$f680877a34711e37 = function() {
    return $24d76e86b6696907$var$U.current.useId();
};
$24d76e86b6696907$export$d5a552a76deda3c2 = function(a, b, e) {
    return $24d76e86b6696907$var$U.current.useImperativeHandle(a, b, e);
};
$24d76e86b6696907$export$aaabe4eda9ed9969 = function(a, b) {
    return $24d76e86b6696907$var$U.current.useInsertionEffect(a, b);
};
$24d76e86b6696907$export$e5c5a5f917a5871c = function(a, b) {
    return $24d76e86b6696907$var$U.current.useLayoutEffect(a, b);
};
$24d76e86b6696907$export$1538c33de8887b59 = function(a, b) {
    return $24d76e86b6696907$var$U.current.useMemo(a, b);
};
$24d76e86b6696907$export$13e3392192263954 = function(a, b, e) {
    return $24d76e86b6696907$var$U.current.useReducer(a, b, e);
};
$24d76e86b6696907$export$b8f5890fc79d6aca = function(a) {
    return $24d76e86b6696907$var$U.current.useRef(a);
};
$24d76e86b6696907$export$60241385465d0a34 = function(a) {
    return $24d76e86b6696907$var$U.current.useState(a);
};
$24d76e86b6696907$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $24d76e86b6696907$var$U.current.useSyncExternalStore(a, b, e);
};
$24d76e86b6696907$export$7b286972b8d8ccbf = function() {
    return $24d76e86b6696907$var$U.current.useTransition();
};
$24d76e86b6696907$export$83d89fbfd8236492 = "18.3.1";

});
parcelRegister("27SFb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $18c6a338b552b1b0$export$71511d61b312f219; });
function $18c6a338b552b1b0$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});




parcelRegister("aDicf", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $7bdba95e5cda5a33$export$ae55be85d98224ed; }, function (v) { return $7bdba95e5cda5a33$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $7bdba95e5cda5a33$export$d39a5bbd09211389; }, function (v) { return $7bdba95e5cda5a33$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $7bdba95e5cda5a33$export$882461b6382ed46c; }, function (v) { return $7bdba95e5cda5a33$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $7bdba95e5cda5a33$export$466bfc07425424d5; }, function (v) { return $7bdba95e5cda5a33$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $7bdba95e5cda5a33$export$cd75ccfd720a3cd4; }, function (v) { return $7bdba95e5cda5a33$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $7bdba95e5cda5a33$export$fa8d919ba61d84db; }, function (v) { return $7bdba95e5cda5a33$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $7bdba95e5cda5a33$export$757ceba2d55c277e; }, function (v) { return $7bdba95e5cda5a33$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $7bdba95e5cda5a33$export$b3890eb0ae9dca99; }, function (v) { return $7bdba95e5cda5a33$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $7bdba95e5cda5a33$export$502457920280e6be; }, function (v) { return $7bdba95e5cda5a33$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $7bdba95e5cda5a33$export$c78a37762a8d58e1; }, function (v) { return $7bdba95e5cda5a33$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $7bdba95e5cda5a33$export$dc54d992c10e8a18; }, function (v) { return $7bdba95e5cda5a33$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $7bdba95e5cda5a33$export$83d89fbfd8236492; }, function (v) { return $7bdba95e5cda5a33$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $27SFb = parcelRequire("27SFb");
var $7bdba95e5cda5a33$export$ae55be85d98224ed;
var $7bdba95e5cda5a33$export$d39a5bbd09211389;
var $7bdba95e5cda5a33$export$882461b6382ed46c;
var $7bdba95e5cda5a33$export$466bfc07425424d5;
var $7bdba95e5cda5a33$export$cd75ccfd720a3cd4;
var $7bdba95e5cda5a33$export$fa8d919ba61d84db;
var $7bdba95e5cda5a33$export$757ceba2d55c277e;
var $7bdba95e5cda5a33$export$b3890eb0ae9dca99;
var $7bdba95e5cda5a33$export$502457920280e6be;
var $7bdba95e5cda5a33$export$c78a37762a8d58e1;
var $7bdba95e5cda5a33$export$dc54d992c10e8a18;
var $7bdba95e5cda5a33$export$83d89fbfd8236492;
'use strict';

var $e7uJ5 = parcelRequire("e7uJ5");

var $4s3M8 = parcelRequire("4s3M8");
function $7bdba95e5cda5a33$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $7bdba95e5cda5a33$var$da = new Set, $7bdba95e5cda5a33$var$ea = {};
function $7bdba95e5cda5a33$var$fa(a, b) {
    $7bdba95e5cda5a33$var$ha(a, b);
    $7bdba95e5cda5a33$var$ha(a + "Capture", b);
}
function $7bdba95e5cda5a33$var$ha(a, b) {
    $7bdba95e5cda5a33$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$7bdba95e5cda5a33$var$da.add(b[a]);
}
var $7bdba95e5cda5a33$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $7bdba95e5cda5a33$var$ja = Object.prototype.hasOwnProperty, $7bdba95e5cda5a33$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $7bdba95e5cda5a33$var$la = {}, $7bdba95e5cda5a33$var$ma = {};
function $7bdba95e5cda5a33$var$oa(a) {
    if ($7bdba95e5cda5a33$var$ja.call($7bdba95e5cda5a33$var$ma, a)) return !0;
    if ($7bdba95e5cda5a33$var$ja.call($7bdba95e5cda5a33$var$la, a)) return !1;
    if ($7bdba95e5cda5a33$var$ka.test(a)) return $7bdba95e5cda5a33$var$ma[a] = !0;
    $7bdba95e5cda5a33$var$la[a] = !0;
    return !1;
}
function $7bdba95e5cda5a33$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $27SFb._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $7bdba95e5cda5a33$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $7bdba95e5cda5a33$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $7bdba95e5cda5a33$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $7bdba95e5cda5a33$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $7bdba95e5cda5a33$var$z[a] = new $7bdba95e5cda5a33$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $7bdba95e5cda5a33$var$z[b] = new $7bdba95e5cda5a33$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $7bdba95e5cda5a33$var$z[a] = new $7bdba95e5cda5a33$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $7bdba95e5cda5a33$var$z[a] = new $7bdba95e5cda5a33$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $7bdba95e5cda5a33$var$z[a] = new $7bdba95e5cda5a33$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $7bdba95e5cda5a33$var$z[a] = new $7bdba95e5cda5a33$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $7bdba95e5cda5a33$var$z[a] = new $7bdba95e5cda5a33$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $7bdba95e5cda5a33$var$z[a] = new $7bdba95e5cda5a33$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $7bdba95e5cda5a33$var$z[a] = new $7bdba95e5cda5a33$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $7bdba95e5cda5a33$var$ra = /[\-:]([a-z])/g;
function $7bdba95e5cda5a33$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($7bdba95e5cda5a33$var$ra, $7bdba95e5cda5a33$var$sa);
    $7bdba95e5cda5a33$var$z[b] = new $7bdba95e5cda5a33$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($7bdba95e5cda5a33$var$ra, $7bdba95e5cda5a33$var$sa);
    $7bdba95e5cda5a33$var$z[b] = new $7bdba95e5cda5a33$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($7bdba95e5cda5a33$var$ra, $7bdba95e5cda5a33$var$sa);
    $7bdba95e5cda5a33$var$z[b] = new $7bdba95e5cda5a33$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $7bdba95e5cda5a33$var$z[a] = new $7bdba95e5cda5a33$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$7bdba95e5cda5a33$var$z.xlinkHref = new $7bdba95e5cda5a33$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $7bdba95e5cda5a33$var$z[a] = new $7bdba95e5cda5a33$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $7bdba95e5cda5a33$var$ta(a, b, c, d) {
    var e = $7bdba95e5cda5a33$var$z.hasOwnProperty(b) ? $7bdba95e5cda5a33$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $7bdba95e5cda5a33$var$qa(b, c, e, d) && (c = null), d || null === e ? $7bdba95e5cda5a33$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $7bdba95e5cda5a33$var$ua = $e7uJ5.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $7bdba95e5cda5a33$var$va = Symbol.for("react.element"), $7bdba95e5cda5a33$var$wa = Symbol.for("react.portal"), $7bdba95e5cda5a33$var$ya = Symbol.for("react.fragment"), $7bdba95e5cda5a33$var$za = Symbol.for("react.strict_mode"), $7bdba95e5cda5a33$var$Aa = Symbol.for("react.profiler"), $7bdba95e5cda5a33$var$Ba = Symbol.for("react.provider"), $7bdba95e5cda5a33$var$Ca = Symbol.for("react.context"), $7bdba95e5cda5a33$var$Da = Symbol.for("react.forward_ref"), $7bdba95e5cda5a33$var$Ea = Symbol.for("react.suspense"), $7bdba95e5cda5a33$var$Fa = Symbol.for("react.suspense_list"), $7bdba95e5cda5a33$var$Ga = Symbol.for("react.memo"), $7bdba95e5cda5a33$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $7bdba95e5cda5a33$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $7bdba95e5cda5a33$var$Ja = Symbol.iterator;
function $7bdba95e5cda5a33$var$Ka(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $27SFb._)(a))) return null;
    a = $7bdba95e5cda5a33$var$Ja && a[$7bdba95e5cda5a33$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $7bdba95e5cda5a33$var$A = Object.assign, $7bdba95e5cda5a33$var$La;
function $7bdba95e5cda5a33$var$Ma(a) {
    if (void 0 === $7bdba95e5cda5a33$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $7bdba95e5cda5a33$var$La = b && b[1] || "";
    }
    return "\n" + $7bdba95e5cda5a33$var$La + a;
}
var $7bdba95e5cda5a33$var$Na = !1;
function $7bdba95e5cda5a33$var$Oa(a, b) {
    if (!a || $7bdba95e5cda5a33$var$Na) return "";
    $7bdba95e5cda5a33$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === (typeof Reflect === "undefined" ? "undefined" : (0, $27SFb._)(Reflect)) && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $7bdba95e5cda5a33$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $7bdba95e5cda5a33$var$Ma(a) : "";
}
function $7bdba95e5cda5a33$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $7bdba95e5cda5a33$var$Ma(a.type);
        case 16:
            return $7bdba95e5cda5a33$var$Ma("Lazy");
        case 13:
            return $7bdba95e5cda5a33$var$Ma("Suspense");
        case 19:
            return $7bdba95e5cda5a33$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $7bdba95e5cda5a33$var$Oa(a.type, !1), a;
        case 11:
            return a = $7bdba95e5cda5a33$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $7bdba95e5cda5a33$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $7bdba95e5cda5a33$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $7bdba95e5cda5a33$var$ya:
            return "Fragment";
        case $7bdba95e5cda5a33$var$wa:
            return "Portal";
        case $7bdba95e5cda5a33$var$Aa:
            return "Profiler";
        case $7bdba95e5cda5a33$var$za:
            return "StrictMode";
        case $7bdba95e5cda5a33$var$Ea:
            return "Suspense";
        case $7bdba95e5cda5a33$var$Fa:
            return "SuspenseList";
    }
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $27SFb._)(a))) switch(a.$$typeof){
        case $7bdba95e5cda5a33$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $7bdba95e5cda5a33$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $7bdba95e5cda5a33$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $7bdba95e5cda5a33$var$Ga:
            return b = a.displayName || null, null !== b ? b : $7bdba95e5cda5a33$var$Qa(a.type) || "Memo";
        case $7bdba95e5cda5a33$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $7bdba95e5cda5a33$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $7bdba95e5cda5a33$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $7bdba95e5cda5a33$var$Qa(b);
        case 8:
            return b === $7bdba95e5cda5a33$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $7bdba95e5cda5a33$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $27SFb._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $7bdba95e5cda5a33$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $7bdba95e5cda5a33$var$Ua(a) {
    var b = $7bdba95e5cda5a33$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $7bdba95e5cda5a33$var$Va(a) {
    a._valueTracker || (a._valueTracker = $7bdba95e5cda5a33$var$Ua(a));
}
function $7bdba95e5cda5a33$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $7bdba95e5cda5a33$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $7bdba95e5cda5a33$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $7bdba95e5cda5a33$var$Ya(a, b) {
    var c = b.checked;
    return $7bdba95e5cda5a33$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $7bdba95e5cda5a33$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $7bdba95e5cda5a33$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $7bdba95e5cda5a33$var$ab(a, b) {
    b = b.checked;
    null != b && $7bdba95e5cda5a33$var$ta(a, "checked", b, !1);
}
function $7bdba95e5cda5a33$var$bb(a, b) {
    $7bdba95e5cda5a33$var$ab(a, b);
    var c = $7bdba95e5cda5a33$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $7bdba95e5cda5a33$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $7bdba95e5cda5a33$var$cb(a, b.type, $7bdba95e5cda5a33$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $7bdba95e5cda5a33$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $7bdba95e5cda5a33$var$cb(a, b, c) {
    if ("number" !== b || $7bdba95e5cda5a33$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $7bdba95e5cda5a33$var$eb = Array.isArray;
function $7bdba95e5cda5a33$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $7bdba95e5cda5a33$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $7bdba95e5cda5a33$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($7bdba95e5cda5a33$var$p(91));
    return $7bdba95e5cda5a33$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $7bdba95e5cda5a33$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($7bdba95e5cda5a33$var$p(92));
            if ($7bdba95e5cda5a33$var$eb(c)) {
                if (1 < c.length) throw Error($7bdba95e5cda5a33$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $7bdba95e5cda5a33$var$Sa(c)
    };
}
function $7bdba95e5cda5a33$var$ib(a, b) {
    var c = $7bdba95e5cda5a33$var$Sa(b.value), d = $7bdba95e5cda5a33$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $7bdba95e5cda5a33$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $7bdba95e5cda5a33$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $7bdba95e5cda5a33$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $7bdba95e5cda5a33$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $7bdba95e5cda5a33$var$mb, $7bdba95e5cda5a33$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $7bdba95e5cda5a33$var$mb = $7bdba95e5cda5a33$var$mb || document.createElement("div");
        $7bdba95e5cda5a33$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $7bdba95e5cda5a33$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $7bdba95e5cda5a33$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $7bdba95e5cda5a33$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $7bdba95e5cda5a33$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($7bdba95e5cda5a33$var$pb).forEach(function(a) {
    $7bdba95e5cda5a33$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $7bdba95e5cda5a33$var$pb[b] = $7bdba95e5cda5a33$var$pb[a];
    });
});
function $7bdba95e5cda5a33$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $7bdba95e5cda5a33$var$pb.hasOwnProperty(a) && $7bdba95e5cda5a33$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $7bdba95e5cda5a33$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $7bdba95e5cda5a33$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $7bdba95e5cda5a33$var$tb = $7bdba95e5cda5a33$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $7bdba95e5cda5a33$var$ub(a, b) {
    if (b) {
        if ($7bdba95e5cda5a33$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($7bdba95e5cda5a33$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($7bdba95e5cda5a33$var$p(60));
            if ("object" !== (0, $27SFb._)(b.dangerouslySetInnerHTML) || !("__html" in b.dangerouslySetInnerHTML)) throw Error($7bdba95e5cda5a33$var$p(61));
        }
        if (null != b.style && "object" !== (0, $27SFb._)(b.style)) throw Error($7bdba95e5cda5a33$var$p(62));
    }
}
function $7bdba95e5cda5a33$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $7bdba95e5cda5a33$var$wb = null;
function $7bdba95e5cda5a33$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $7bdba95e5cda5a33$var$yb = null, $7bdba95e5cda5a33$var$zb = null, $7bdba95e5cda5a33$var$Ab = null;
function $7bdba95e5cda5a33$var$Bb(a) {
    if (a = $7bdba95e5cda5a33$var$Cb(a)) {
        if ("function" !== typeof $7bdba95e5cda5a33$var$yb) throw Error($7bdba95e5cda5a33$var$p(280));
        var b = a.stateNode;
        b && (b = $7bdba95e5cda5a33$var$Db(b), $7bdba95e5cda5a33$var$yb(a.stateNode, a.type, b));
    }
}
function $7bdba95e5cda5a33$var$Eb(a) {
    $7bdba95e5cda5a33$var$zb ? $7bdba95e5cda5a33$var$Ab ? $7bdba95e5cda5a33$var$Ab.push(a) : $7bdba95e5cda5a33$var$Ab = [
        a
    ] : $7bdba95e5cda5a33$var$zb = a;
}
function $7bdba95e5cda5a33$var$Fb() {
    if ($7bdba95e5cda5a33$var$zb) {
        var a = $7bdba95e5cda5a33$var$zb, b = $7bdba95e5cda5a33$var$Ab;
        $7bdba95e5cda5a33$var$Ab = $7bdba95e5cda5a33$var$zb = null;
        $7bdba95e5cda5a33$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$7bdba95e5cda5a33$var$Bb(b[a]);
    }
}
function $7bdba95e5cda5a33$var$Gb(a, b) {
    return a(b);
}
function $7bdba95e5cda5a33$var$Hb() {}
var $7bdba95e5cda5a33$var$Ib = !1;
function $7bdba95e5cda5a33$var$Jb(a, b, c) {
    if ($7bdba95e5cda5a33$var$Ib) return a(b, c);
    $7bdba95e5cda5a33$var$Ib = !0;
    try {
        return $7bdba95e5cda5a33$var$Gb(a, b, c);
    } finally{
        if ($7bdba95e5cda5a33$var$Ib = !1, null !== $7bdba95e5cda5a33$var$zb || null !== $7bdba95e5cda5a33$var$Ab) $7bdba95e5cda5a33$var$Hb(), $7bdba95e5cda5a33$var$Fb();
    }
}
function $7bdba95e5cda5a33$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $7bdba95e5cda5a33$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($7bdba95e5cda5a33$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $27SFb._)(c)));
    return c;
}
var $7bdba95e5cda5a33$var$Lb = !1;
if ($7bdba95e5cda5a33$var$ia) try {
    var $7bdba95e5cda5a33$var$Mb = {};
    Object.defineProperty($7bdba95e5cda5a33$var$Mb, "passive", {
        get: function get() {
            $7bdba95e5cda5a33$var$Lb = !0;
        }
    });
    window.addEventListener("test", $7bdba95e5cda5a33$var$Mb, $7bdba95e5cda5a33$var$Mb);
    window.removeEventListener("test", $7bdba95e5cda5a33$var$Mb, $7bdba95e5cda5a33$var$Mb);
} catch (a) {
    $7bdba95e5cda5a33$var$Lb = !1;
}
function $7bdba95e5cda5a33$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $7bdba95e5cda5a33$var$Ob = !1, $7bdba95e5cda5a33$var$Pb = null, $7bdba95e5cda5a33$var$Qb = !1, $7bdba95e5cda5a33$var$Rb = null, $7bdba95e5cda5a33$var$Sb = {
    onError: function onError(a) {
        $7bdba95e5cda5a33$var$Ob = !0;
        $7bdba95e5cda5a33$var$Pb = a;
    }
};
function $7bdba95e5cda5a33$var$Tb(a, b, c, d, e, f, g, h, k) {
    $7bdba95e5cda5a33$var$Ob = !1;
    $7bdba95e5cda5a33$var$Pb = null;
    $7bdba95e5cda5a33$var$Nb.apply($7bdba95e5cda5a33$var$Sb, arguments);
}
function $7bdba95e5cda5a33$var$Ub(a, b, c, d, e, f, g, h, k) {
    $7bdba95e5cda5a33$var$Tb.apply(this, arguments);
    if ($7bdba95e5cda5a33$var$Ob) {
        if ($7bdba95e5cda5a33$var$Ob) {
            var l = $7bdba95e5cda5a33$var$Pb;
            $7bdba95e5cda5a33$var$Ob = !1;
            $7bdba95e5cda5a33$var$Pb = null;
        } else throw Error($7bdba95e5cda5a33$var$p(198));
        $7bdba95e5cda5a33$var$Qb || ($7bdba95e5cda5a33$var$Qb = !0, $7bdba95e5cda5a33$var$Rb = l);
    }
}
function $7bdba95e5cda5a33$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $7bdba95e5cda5a33$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $7bdba95e5cda5a33$var$Xb(a) {
    if ($7bdba95e5cda5a33$var$Vb(a) !== a) throw Error($7bdba95e5cda5a33$var$p(188));
}
function $7bdba95e5cda5a33$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $7bdba95e5cda5a33$var$Vb(a);
        if (null === b) throw Error($7bdba95e5cda5a33$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $7bdba95e5cda5a33$var$Xb(e), a;
                if (f === d) return $7bdba95e5cda5a33$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($7bdba95e5cda5a33$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($7bdba95e5cda5a33$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($7bdba95e5cda5a33$var$p(190));
    }
    if (3 !== c.tag) throw Error($7bdba95e5cda5a33$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $7bdba95e5cda5a33$var$Zb(a) {
    a = $7bdba95e5cda5a33$var$Yb(a);
    return null !== a ? $7bdba95e5cda5a33$var$$b(a) : null;
}
function $7bdba95e5cda5a33$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $7bdba95e5cda5a33$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $7bdba95e5cda5a33$var$ac = $4s3M8.unstable_scheduleCallback, $7bdba95e5cda5a33$var$bc = $4s3M8.unstable_cancelCallback, $7bdba95e5cda5a33$var$cc = $4s3M8.unstable_shouldYield, $7bdba95e5cda5a33$var$dc = $4s3M8.unstable_requestPaint, $7bdba95e5cda5a33$var$B = $4s3M8.unstable_now, $7bdba95e5cda5a33$var$ec = $4s3M8.unstable_getCurrentPriorityLevel, $7bdba95e5cda5a33$var$fc = $4s3M8.unstable_ImmediatePriority, $7bdba95e5cda5a33$var$gc = $4s3M8.unstable_UserBlockingPriority, $7bdba95e5cda5a33$var$hc = $4s3M8.unstable_NormalPriority, $7bdba95e5cda5a33$var$ic = $4s3M8.unstable_LowPriority, $7bdba95e5cda5a33$var$jc = $4s3M8.unstable_IdlePriority, $7bdba95e5cda5a33$var$kc = null, $7bdba95e5cda5a33$var$lc = null;
function $7bdba95e5cda5a33$var$mc(a) {
    if ($7bdba95e5cda5a33$var$lc && "function" === typeof $7bdba95e5cda5a33$var$lc.onCommitFiberRoot) try {
        $7bdba95e5cda5a33$var$lc.onCommitFiberRoot($7bdba95e5cda5a33$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $7bdba95e5cda5a33$var$oc = Math.clz32 ? Math.clz32 : $7bdba95e5cda5a33$var$nc, $7bdba95e5cda5a33$var$pc = Math.log, $7bdba95e5cda5a33$var$qc = Math.LN2;
function $7bdba95e5cda5a33$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($7bdba95e5cda5a33$var$pc(a) / $7bdba95e5cda5a33$var$qc | 0) | 0;
}
var $7bdba95e5cda5a33$var$rc = 64, $7bdba95e5cda5a33$var$sc = 4194304;
function $7bdba95e5cda5a33$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $7bdba95e5cda5a33$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $7bdba95e5cda5a33$var$tc(h) : (f &= g, 0 !== f && (d = $7bdba95e5cda5a33$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $7bdba95e5cda5a33$var$tc(g) : 0 !== f && (d = $7bdba95e5cda5a33$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $7bdba95e5cda5a33$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $7bdba95e5cda5a33$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $7bdba95e5cda5a33$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $7bdba95e5cda5a33$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $7bdba95e5cda5a33$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $7bdba95e5cda5a33$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $7bdba95e5cda5a33$var$yc() {
    var a = $7bdba95e5cda5a33$var$rc;
    $7bdba95e5cda5a33$var$rc <<= 1;
    0 === ($7bdba95e5cda5a33$var$rc & 4194240) && ($7bdba95e5cda5a33$var$rc = 64);
    return a;
}
function $7bdba95e5cda5a33$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $7bdba95e5cda5a33$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $7bdba95e5cda5a33$var$oc(b);
    a[b] = c;
}
function $7bdba95e5cda5a33$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $7bdba95e5cda5a33$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $7bdba95e5cda5a33$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $7bdba95e5cda5a33$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $7bdba95e5cda5a33$var$C = 0;
function $7bdba95e5cda5a33$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $7bdba95e5cda5a33$var$Ec, $7bdba95e5cda5a33$var$Fc, $7bdba95e5cda5a33$var$Gc, $7bdba95e5cda5a33$var$Hc, $7bdba95e5cda5a33$var$Ic, $7bdba95e5cda5a33$var$Jc = !1, $7bdba95e5cda5a33$var$Kc = [], $7bdba95e5cda5a33$var$Lc = null, $7bdba95e5cda5a33$var$Mc = null, $7bdba95e5cda5a33$var$Nc = null, $7bdba95e5cda5a33$var$Oc = new Map, $7bdba95e5cda5a33$var$Pc = new Map, $7bdba95e5cda5a33$var$Qc = [], $7bdba95e5cda5a33$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $7bdba95e5cda5a33$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $7bdba95e5cda5a33$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $7bdba95e5cda5a33$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $7bdba95e5cda5a33$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $7bdba95e5cda5a33$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $7bdba95e5cda5a33$var$Pc.delete(b.pointerId);
    }
}
function $7bdba95e5cda5a33$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $7bdba95e5cda5a33$var$Cb(b), null !== b && $7bdba95e5cda5a33$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $7bdba95e5cda5a33$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $7bdba95e5cda5a33$var$Lc = $7bdba95e5cda5a33$var$Tc($7bdba95e5cda5a33$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $7bdba95e5cda5a33$var$Mc = $7bdba95e5cda5a33$var$Tc($7bdba95e5cda5a33$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $7bdba95e5cda5a33$var$Nc = $7bdba95e5cda5a33$var$Tc($7bdba95e5cda5a33$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $7bdba95e5cda5a33$var$Oc.set(f, $7bdba95e5cda5a33$var$Tc($7bdba95e5cda5a33$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $7bdba95e5cda5a33$var$Pc.set(f, $7bdba95e5cda5a33$var$Tc($7bdba95e5cda5a33$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $7bdba95e5cda5a33$var$Vc(a) {
    var b = $7bdba95e5cda5a33$var$Wc(a.target);
    if (null !== b) {
        var c = $7bdba95e5cda5a33$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $7bdba95e5cda5a33$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $7bdba95e5cda5a33$var$Ic(a.priority, function() {
                        $7bdba95e5cda5a33$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $7bdba95e5cda5a33$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $7bdba95e5cda5a33$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $7bdba95e5cda5a33$var$wb = d;
            c.target.dispatchEvent(d);
            $7bdba95e5cda5a33$var$wb = null;
        } else return b = $7bdba95e5cda5a33$var$Cb(c), null !== b && $7bdba95e5cda5a33$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $7bdba95e5cda5a33$var$Zc(a, b, c) {
    $7bdba95e5cda5a33$var$Xc(a) && c.delete(b);
}
function $7bdba95e5cda5a33$var$$c() {
    $7bdba95e5cda5a33$var$Jc = !1;
    null !== $7bdba95e5cda5a33$var$Lc && $7bdba95e5cda5a33$var$Xc($7bdba95e5cda5a33$var$Lc) && ($7bdba95e5cda5a33$var$Lc = null);
    null !== $7bdba95e5cda5a33$var$Mc && $7bdba95e5cda5a33$var$Xc($7bdba95e5cda5a33$var$Mc) && ($7bdba95e5cda5a33$var$Mc = null);
    null !== $7bdba95e5cda5a33$var$Nc && $7bdba95e5cda5a33$var$Xc($7bdba95e5cda5a33$var$Nc) && ($7bdba95e5cda5a33$var$Nc = null);
    $7bdba95e5cda5a33$var$Oc.forEach($7bdba95e5cda5a33$var$Zc);
    $7bdba95e5cda5a33$var$Pc.forEach($7bdba95e5cda5a33$var$Zc);
}
function $7bdba95e5cda5a33$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $7bdba95e5cda5a33$var$Jc || ($7bdba95e5cda5a33$var$Jc = !0, $4s3M8.unstable_scheduleCallback($4s3M8.unstable_NormalPriority, $7bdba95e5cda5a33$var$$c)));
}
function $7bdba95e5cda5a33$var$bd(a) {
    function b(b) {
        return $7bdba95e5cda5a33$var$ad(b, a);
    }
    if (0 < $7bdba95e5cda5a33$var$Kc.length) {
        $7bdba95e5cda5a33$var$ad($7bdba95e5cda5a33$var$Kc[0], a);
        for(var c = 1; c < $7bdba95e5cda5a33$var$Kc.length; c++){
            var d = $7bdba95e5cda5a33$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $7bdba95e5cda5a33$var$Lc && $7bdba95e5cda5a33$var$ad($7bdba95e5cda5a33$var$Lc, a);
    null !== $7bdba95e5cda5a33$var$Mc && $7bdba95e5cda5a33$var$ad($7bdba95e5cda5a33$var$Mc, a);
    null !== $7bdba95e5cda5a33$var$Nc && $7bdba95e5cda5a33$var$ad($7bdba95e5cda5a33$var$Nc, a);
    $7bdba95e5cda5a33$var$Oc.forEach(b);
    $7bdba95e5cda5a33$var$Pc.forEach(b);
    for(c = 0; c < $7bdba95e5cda5a33$var$Qc.length; c++)d = $7bdba95e5cda5a33$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $7bdba95e5cda5a33$var$Qc.length && (c = $7bdba95e5cda5a33$var$Qc[0], null === c.blockedOn);)$7bdba95e5cda5a33$var$Vc(c), null === c.blockedOn && $7bdba95e5cda5a33$var$Qc.shift();
}
var $7bdba95e5cda5a33$var$cd = $7bdba95e5cda5a33$var$ua.ReactCurrentBatchConfig, $7bdba95e5cda5a33$var$dd = !0;
function $7bdba95e5cda5a33$var$ed(a, b, c, d) {
    var e = $7bdba95e5cda5a33$var$C, f = $7bdba95e5cda5a33$var$cd.transition;
    $7bdba95e5cda5a33$var$cd.transition = null;
    try {
        $7bdba95e5cda5a33$var$C = 1, $7bdba95e5cda5a33$var$fd(a, b, c, d);
    } finally{
        $7bdba95e5cda5a33$var$C = e, $7bdba95e5cda5a33$var$cd.transition = f;
    }
}
function $7bdba95e5cda5a33$var$gd(a, b, c, d) {
    var e = $7bdba95e5cda5a33$var$C, f = $7bdba95e5cda5a33$var$cd.transition;
    $7bdba95e5cda5a33$var$cd.transition = null;
    try {
        $7bdba95e5cda5a33$var$C = 4, $7bdba95e5cda5a33$var$fd(a, b, c, d);
    } finally{
        $7bdba95e5cda5a33$var$C = e, $7bdba95e5cda5a33$var$cd.transition = f;
    }
}
function $7bdba95e5cda5a33$var$fd(a, b, c, d) {
    if ($7bdba95e5cda5a33$var$dd) {
        var e = $7bdba95e5cda5a33$var$Yc(a, b, c, d);
        if (null === e) $7bdba95e5cda5a33$var$hd(a, b, d, $7bdba95e5cda5a33$var$id, c), $7bdba95e5cda5a33$var$Sc(a, d);
        else if ($7bdba95e5cda5a33$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($7bdba95e5cda5a33$var$Sc(a, d), b & 4 && -1 < $7bdba95e5cda5a33$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $7bdba95e5cda5a33$var$Cb(e);
                null !== f && $7bdba95e5cda5a33$var$Ec(f);
                f = $7bdba95e5cda5a33$var$Yc(a, b, c, d);
                null === f && $7bdba95e5cda5a33$var$hd(a, b, d, $7bdba95e5cda5a33$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $7bdba95e5cda5a33$var$hd(a, b, d, null, c);
    }
}
var $7bdba95e5cda5a33$var$id = null;
function $7bdba95e5cda5a33$var$Yc(a, b, c, d) {
    $7bdba95e5cda5a33$var$id = null;
    a = $7bdba95e5cda5a33$var$xb(d);
    a = $7bdba95e5cda5a33$var$Wc(a);
    if (null !== a) {
        if (b = $7bdba95e5cda5a33$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $7bdba95e5cda5a33$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $7bdba95e5cda5a33$var$id = a;
    return null;
}
function $7bdba95e5cda5a33$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($7bdba95e5cda5a33$var$ec()){
                case $7bdba95e5cda5a33$var$fc:
                    return 1;
                case $7bdba95e5cda5a33$var$gc:
                    return 4;
                case $7bdba95e5cda5a33$var$hc:
                case $7bdba95e5cda5a33$var$ic:
                    return 16;
                case $7bdba95e5cda5a33$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $7bdba95e5cda5a33$var$kd = null, $7bdba95e5cda5a33$var$ld = null, $7bdba95e5cda5a33$var$md = null;
function $7bdba95e5cda5a33$var$nd() {
    if ($7bdba95e5cda5a33$var$md) return $7bdba95e5cda5a33$var$md;
    var a, b = $7bdba95e5cda5a33$var$ld, c = b.length, d, e = "value" in $7bdba95e5cda5a33$var$kd ? $7bdba95e5cda5a33$var$kd.value : $7bdba95e5cda5a33$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $7bdba95e5cda5a33$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $7bdba95e5cda5a33$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $7bdba95e5cda5a33$var$pd() {
    return !0;
}
function $7bdba95e5cda5a33$var$qd() {
    return !1;
}
function $7bdba95e5cda5a33$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $7bdba95e5cda5a33$var$pd : $7bdba95e5cda5a33$var$qd;
        this.isPropagationStopped = $7bdba95e5cda5a33$var$qd;
        return this;
    }
    $7bdba95e5cda5a33$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $27SFb._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $7bdba95e5cda5a33$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $27SFb._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $7bdba95e5cda5a33$var$pd);
        },
        persist: function persist() {},
        isPersistent: $7bdba95e5cda5a33$var$pd
    });
    return b;
}
var $7bdba95e5cda5a33$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $7bdba95e5cda5a33$var$td = $7bdba95e5cda5a33$var$rd($7bdba95e5cda5a33$var$sd), $7bdba95e5cda5a33$var$ud = $7bdba95e5cda5a33$var$A({}, $7bdba95e5cda5a33$var$sd, {
    view: 0,
    detail: 0
}), $7bdba95e5cda5a33$var$vd = $7bdba95e5cda5a33$var$rd($7bdba95e5cda5a33$var$ud), $7bdba95e5cda5a33$var$wd, $7bdba95e5cda5a33$var$xd, $7bdba95e5cda5a33$var$yd, $7bdba95e5cda5a33$var$Ad = $7bdba95e5cda5a33$var$A({}, $7bdba95e5cda5a33$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $7bdba95e5cda5a33$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $7bdba95e5cda5a33$var$yd && ($7bdba95e5cda5a33$var$yd && "mousemove" === a.type ? ($7bdba95e5cda5a33$var$wd = a.screenX - $7bdba95e5cda5a33$var$yd.screenX, $7bdba95e5cda5a33$var$xd = a.screenY - $7bdba95e5cda5a33$var$yd.screenY) : $7bdba95e5cda5a33$var$xd = $7bdba95e5cda5a33$var$wd = 0, $7bdba95e5cda5a33$var$yd = a);
        return $7bdba95e5cda5a33$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $7bdba95e5cda5a33$var$xd;
    }
}), $7bdba95e5cda5a33$var$Bd = $7bdba95e5cda5a33$var$rd($7bdba95e5cda5a33$var$Ad), $7bdba95e5cda5a33$var$Cd = $7bdba95e5cda5a33$var$A({}, $7bdba95e5cda5a33$var$Ad, {
    dataTransfer: 0
}), $7bdba95e5cda5a33$var$Dd = $7bdba95e5cda5a33$var$rd($7bdba95e5cda5a33$var$Cd), $7bdba95e5cda5a33$var$Ed = $7bdba95e5cda5a33$var$A({}, $7bdba95e5cda5a33$var$ud, {
    relatedTarget: 0
}), $7bdba95e5cda5a33$var$Fd = $7bdba95e5cda5a33$var$rd($7bdba95e5cda5a33$var$Ed), $7bdba95e5cda5a33$var$Gd = $7bdba95e5cda5a33$var$A({}, $7bdba95e5cda5a33$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $7bdba95e5cda5a33$var$Hd = $7bdba95e5cda5a33$var$rd($7bdba95e5cda5a33$var$Gd), $7bdba95e5cda5a33$var$Id = $7bdba95e5cda5a33$var$A({}, $7bdba95e5cda5a33$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $7bdba95e5cda5a33$var$Jd = $7bdba95e5cda5a33$var$rd($7bdba95e5cda5a33$var$Id), $7bdba95e5cda5a33$var$Kd = $7bdba95e5cda5a33$var$A({}, $7bdba95e5cda5a33$var$sd, {
    data: 0
}), $7bdba95e5cda5a33$var$Ld = $7bdba95e5cda5a33$var$rd($7bdba95e5cda5a33$var$Kd), $7bdba95e5cda5a33$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $7bdba95e5cda5a33$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $7bdba95e5cda5a33$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $7bdba95e5cda5a33$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $7bdba95e5cda5a33$var$Od[a]) ? !!b[a] : !1;
}
function $7bdba95e5cda5a33$var$zd() {
    return $7bdba95e5cda5a33$var$Pd;
}
var $7bdba95e5cda5a33$var$Qd = $7bdba95e5cda5a33$var$A({}, $7bdba95e5cda5a33$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $7bdba95e5cda5a33$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $7bdba95e5cda5a33$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $7bdba95e5cda5a33$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $7bdba95e5cda5a33$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $7bdba95e5cda5a33$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $7bdba95e5cda5a33$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $7bdba95e5cda5a33$var$Rd = $7bdba95e5cda5a33$var$rd($7bdba95e5cda5a33$var$Qd), $7bdba95e5cda5a33$var$Sd = $7bdba95e5cda5a33$var$A({}, $7bdba95e5cda5a33$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $7bdba95e5cda5a33$var$Td = $7bdba95e5cda5a33$var$rd($7bdba95e5cda5a33$var$Sd), $7bdba95e5cda5a33$var$Ud = $7bdba95e5cda5a33$var$A({}, $7bdba95e5cda5a33$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $7bdba95e5cda5a33$var$zd
}), $7bdba95e5cda5a33$var$Vd = $7bdba95e5cda5a33$var$rd($7bdba95e5cda5a33$var$Ud), $7bdba95e5cda5a33$var$Wd = $7bdba95e5cda5a33$var$A({}, $7bdba95e5cda5a33$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $7bdba95e5cda5a33$var$Xd = $7bdba95e5cda5a33$var$rd($7bdba95e5cda5a33$var$Wd), $7bdba95e5cda5a33$var$Yd = $7bdba95e5cda5a33$var$A({}, $7bdba95e5cda5a33$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $7bdba95e5cda5a33$var$Zd = $7bdba95e5cda5a33$var$rd($7bdba95e5cda5a33$var$Yd), $7bdba95e5cda5a33$var$$d = [
    9,
    13,
    27,
    32
], $7bdba95e5cda5a33$var$ae = $7bdba95e5cda5a33$var$ia && "CompositionEvent" in window, $7bdba95e5cda5a33$var$be = null;
$7bdba95e5cda5a33$var$ia && "documentMode" in document && ($7bdba95e5cda5a33$var$be = document.documentMode);
var $7bdba95e5cda5a33$var$ce = $7bdba95e5cda5a33$var$ia && "TextEvent" in window && !$7bdba95e5cda5a33$var$be, $7bdba95e5cda5a33$var$de = $7bdba95e5cda5a33$var$ia && (!$7bdba95e5cda5a33$var$ae || $7bdba95e5cda5a33$var$be && 8 < $7bdba95e5cda5a33$var$be && 11 >= $7bdba95e5cda5a33$var$be), $7bdba95e5cda5a33$var$ee = String.fromCharCode(32), $7bdba95e5cda5a33$var$fe = !1;
function $7bdba95e5cda5a33$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $7bdba95e5cda5a33$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $7bdba95e5cda5a33$var$he(a) {
    a = a.detail;
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $27SFb._)(a)) && "data" in a ? a.data : null;
}
var $7bdba95e5cda5a33$var$ie = !1;
function $7bdba95e5cda5a33$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $7bdba95e5cda5a33$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $7bdba95e5cda5a33$var$fe = !0;
            return $7bdba95e5cda5a33$var$ee;
        case "textInput":
            return a = b.data, a === $7bdba95e5cda5a33$var$ee && $7bdba95e5cda5a33$var$fe ? null : a;
        default:
            return null;
    }
}
function $7bdba95e5cda5a33$var$ke(a, b) {
    if ($7bdba95e5cda5a33$var$ie) return "compositionend" === a || !$7bdba95e5cda5a33$var$ae && $7bdba95e5cda5a33$var$ge(a, b) ? (a = $7bdba95e5cda5a33$var$nd(), $7bdba95e5cda5a33$var$md = $7bdba95e5cda5a33$var$ld = $7bdba95e5cda5a33$var$kd = null, $7bdba95e5cda5a33$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $7bdba95e5cda5a33$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $7bdba95e5cda5a33$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $7bdba95e5cda5a33$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$7bdba95e5cda5a33$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $7bdba95e5cda5a33$var$ne(a, b, c, d) {
    $7bdba95e5cda5a33$var$Eb(d);
    b = $7bdba95e5cda5a33$var$oe(b, "onChange");
    0 < b.length && (c = new $7bdba95e5cda5a33$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $7bdba95e5cda5a33$var$pe = null, $7bdba95e5cda5a33$var$qe = null;
function $7bdba95e5cda5a33$var$re(a) {
    $7bdba95e5cda5a33$var$se(a, 0);
}
function $7bdba95e5cda5a33$var$te(a) {
    var b = $7bdba95e5cda5a33$var$ue(a);
    if ($7bdba95e5cda5a33$var$Wa(b)) return a;
}
function $7bdba95e5cda5a33$var$ve(a, b) {
    if ("change" === a) return b;
}
var $7bdba95e5cda5a33$var$we = !1;
if ($7bdba95e5cda5a33$var$ia) {
    var $7bdba95e5cda5a33$var$xe;
    if ($7bdba95e5cda5a33$var$ia) {
        var $7bdba95e5cda5a33$var$ye = "oninput" in document;
        if (!$7bdba95e5cda5a33$var$ye) {
            var $7bdba95e5cda5a33$var$ze = document.createElement("div");
            $7bdba95e5cda5a33$var$ze.setAttribute("oninput", "return;");
            $7bdba95e5cda5a33$var$ye = "function" === typeof $7bdba95e5cda5a33$var$ze.oninput;
        }
        $7bdba95e5cda5a33$var$xe = $7bdba95e5cda5a33$var$ye;
    } else $7bdba95e5cda5a33$var$xe = !1;
    $7bdba95e5cda5a33$var$we = $7bdba95e5cda5a33$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $7bdba95e5cda5a33$var$Ae() {
    $7bdba95e5cda5a33$var$pe && ($7bdba95e5cda5a33$var$pe.detachEvent("onpropertychange", $7bdba95e5cda5a33$var$Be), $7bdba95e5cda5a33$var$qe = $7bdba95e5cda5a33$var$pe = null);
}
function $7bdba95e5cda5a33$var$Be(a) {
    if ("value" === a.propertyName && $7bdba95e5cda5a33$var$te($7bdba95e5cda5a33$var$qe)) {
        var b = [];
        $7bdba95e5cda5a33$var$ne(b, $7bdba95e5cda5a33$var$qe, a, $7bdba95e5cda5a33$var$xb(a));
        $7bdba95e5cda5a33$var$Jb($7bdba95e5cda5a33$var$re, b);
    }
}
function $7bdba95e5cda5a33$var$Ce(a, b, c) {
    "focusin" === a ? ($7bdba95e5cda5a33$var$Ae(), $7bdba95e5cda5a33$var$pe = b, $7bdba95e5cda5a33$var$qe = c, $7bdba95e5cda5a33$var$pe.attachEvent("onpropertychange", $7bdba95e5cda5a33$var$Be)) : "focusout" === a && $7bdba95e5cda5a33$var$Ae();
}
function $7bdba95e5cda5a33$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $7bdba95e5cda5a33$var$te($7bdba95e5cda5a33$var$qe);
}
function $7bdba95e5cda5a33$var$Ee(a, b) {
    if ("click" === a) return $7bdba95e5cda5a33$var$te(b);
}
function $7bdba95e5cda5a33$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $7bdba95e5cda5a33$var$te(b);
}
function $7bdba95e5cda5a33$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $7bdba95e5cda5a33$var$He = "function" === typeof Object.is ? Object.is : $7bdba95e5cda5a33$var$Ge;
function $7bdba95e5cda5a33$var$Ie(a, b) {
    if ($7bdba95e5cda5a33$var$He(a, b)) return !0;
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $27SFb._)(a)) || null === a || "object" !== (typeof b === "undefined" ? "undefined" : (0, $27SFb._)(b)) || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$7bdba95e5cda5a33$var$ja.call(b, e) || !$7bdba95e5cda5a33$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $7bdba95e5cda5a33$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $7bdba95e5cda5a33$var$Ke(a, b) {
    var c = $7bdba95e5cda5a33$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $7bdba95e5cda5a33$var$Je(c);
    }
}
function $7bdba95e5cda5a33$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $7bdba95e5cda5a33$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $7bdba95e5cda5a33$var$Me() {
    for(var a = window, b = $7bdba95e5cda5a33$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $7bdba95e5cda5a33$var$Xa(a.document);
    }
    return b;
}
function $7bdba95e5cda5a33$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $7bdba95e5cda5a33$var$Oe(a) {
    var b = $7bdba95e5cda5a33$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $7bdba95e5cda5a33$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $7bdba95e5cda5a33$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $7bdba95e5cda5a33$var$Ke(c, f);
                var g = $7bdba95e5cda5a33$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $7bdba95e5cda5a33$var$Pe = $7bdba95e5cda5a33$var$ia && "documentMode" in document && 11 >= document.documentMode, $7bdba95e5cda5a33$var$Qe = null, $7bdba95e5cda5a33$var$Re = null, $7bdba95e5cda5a33$var$Se = null, $7bdba95e5cda5a33$var$Te = !1;
function $7bdba95e5cda5a33$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $7bdba95e5cda5a33$var$Te || null == $7bdba95e5cda5a33$var$Qe || $7bdba95e5cda5a33$var$Qe !== $7bdba95e5cda5a33$var$Xa(d) || (d = $7bdba95e5cda5a33$var$Qe, "selectionStart" in d && $7bdba95e5cda5a33$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $7bdba95e5cda5a33$var$Se && $7bdba95e5cda5a33$var$Ie($7bdba95e5cda5a33$var$Se, d) || ($7bdba95e5cda5a33$var$Se = d, d = $7bdba95e5cda5a33$var$oe($7bdba95e5cda5a33$var$Re, "onSelect"), 0 < d.length && (b = new $7bdba95e5cda5a33$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $7bdba95e5cda5a33$var$Qe)));
}
function $7bdba95e5cda5a33$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $7bdba95e5cda5a33$var$We = {
    animationend: $7bdba95e5cda5a33$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $7bdba95e5cda5a33$var$Ve("Animation", "AnimationIteration"),
    animationstart: $7bdba95e5cda5a33$var$Ve("Animation", "AnimationStart"),
    transitionend: $7bdba95e5cda5a33$var$Ve("Transition", "TransitionEnd")
}, $7bdba95e5cda5a33$var$Xe = {}, $7bdba95e5cda5a33$var$Ye = {};
$7bdba95e5cda5a33$var$ia && ($7bdba95e5cda5a33$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $7bdba95e5cda5a33$var$We.animationend.animation, delete $7bdba95e5cda5a33$var$We.animationiteration.animation, delete $7bdba95e5cda5a33$var$We.animationstart.animation), "TransitionEvent" in window || delete $7bdba95e5cda5a33$var$We.transitionend.transition);
function $7bdba95e5cda5a33$var$Ze(a) {
    if ($7bdba95e5cda5a33$var$Xe[a]) return $7bdba95e5cda5a33$var$Xe[a];
    if (!$7bdba95e5cda5a33$var$We[a]) return a;
    var b = $7bdba95e5cda5a33$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $7bdba95e5cda5a33$var$Ye) return $7bdba95e5cda5a33$var$Xe[a] = b[c];
    return a;
}
var $7bdba95e5cda5a33$var$$e = $7bdba95e5cda5a33$var$Ze("animationend"), $7bdba95e5cda5a33$var$af = $7bdba95e5cda5a33$var$Ze("animationiteration"), $7bdba95e5cda5a33$var$bf = $7bdba95e5cda5a33$var$Ze("animationstart"), $7bdba95e5cda5a33$var$cf = $7bdba95e5cda5a33$var$Ze("transitionend"), $7bdba95e5cda5a33$var$df = new Map, $7bdba95e5cda5a33$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $7bdba95e5cda5a33$var$ff(a, b) {
    $7bdba95e5cda5a33$var$df.set(a, b);
    $7bdba95e5cda5a33$var$fa(b, [
        a
    ]);
}
for(var $7bdba95e5cda5a33$var$gf = 0; $7bdba95e5cda5a33$var$gf < $7bdba95e5cda5a33$var$ef.length; $7bdba95e5cda5a33$var$gf++){
    var $7bdba95e5cda5a33$var$hf = $7bdba95e5cda5a33$var$ef[$7bdba95e5cda5a33$var$gf], $7bdba95e5cda5a33$var$jf = $7bdba95e5cda5a33$var$hf.toLowerCase(), $7bdba95e5cda5a33$var$kf = $7bdba95e5cda5a33$var$hf[0].toUpperCase() + $7bdba95e5cda5a33$var$hf.slice(1);
    $7bdba95e5cda5a33$var$ff($7bdba95e5cda5a33$var$jf, "on" + $7bdba95e5cda5a33$var$kf);
}
$7bdba95e5cda5a33$var$ff($7bdba95e5cda5a33$var$$e, "onAnimationEnd");
$7bdba95e5cda5a33$var$ff($7bdba95e5cda5a33$var$af, "onAnimationIteration");
$7bdba95e5cda5a33$var$ff($7bdba95e5cda5a33$var$bf, "onAnimationStart");
$7bdba95e5cda5a33$var$ff("dblclick", "onDoubleClick");
$7bdba95e5cda5a33$var$ff("focusin", "onFocus");
$7bdba95e5cda5a33$var$ff("focusout", "onBlur");
$7bdba95e5cda5a33$var$ff($7bdba95e5cda5a33$var$cf, "onTransitionEnd");
$7bdba95e5cda5a33$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$7bdba95e5cda5a33$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$7bdba95e5cda5a33$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$7bdba95e5cda5a33$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$7bdba95e5cda5a33$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$7bdba95e5cda5a33$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$7bdba95e5cda5a33$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$7bdba95e5cda5a33$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$7bdba95e5cda5a33$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$7bdba95e5cda5a33$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $7bdba95e5cda5a33$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $7bdba95e5cda5a33$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($7bdba95e5cda5a33$var$lf));
function $7bdba95e5cda5a33$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $7bdba95e5cda5a33$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $7bdba95e5cda5a33$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $7bdba95e5cda5a33$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $7bdba95e5cda5a33$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($7bdba95e5cda5a33$var$Qb) throw a = $7bdba95e5cda5a33$var$Rb, $7bdba95e5cda5a33$var$Qb = !1, $7bdba95e5cda5a33$var$Rb = null, a;
}
function $7bdba95e5cda5a33$var$D(a, b) {
    var c = b[$7bdba95e5cda5a33$var$of];
    void 0 === c && (c = b[$7bdba95e5cda5a33$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($7bdba95e5cda5a33$var$pf(b, a, 2, !1), c.add(d));
}
function $7bdba95e5cda5a33$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $7bdba95e5cda5a33$var$pf(c, a, d, b);
}
var $7bdba95e5cda5a33$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $7bdba95e5cda5a33$var$sf(a) {
    if (!a[$7bdba95e5cda5a33$var$rf]) {
        a[$7bdba95e5cda5a33$var$rf] = !0;
        $7bdba95e5cda5a33$var$da.forEach(function(b) {
            "selectionchange" !== b && ($7bdba95e5cda5a33$var$mf.has(b) || $7bdba95e5cda5a33$var$qf(b, !1, a), $7bdba95e5cda5a33$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$7bdba95e5cda5a33$var$rf] || (b[$7bdba95e5cda5a33$var$rf] = !0, $7bdba95e5cda5a33$var$qf("selectionchange", !1, b));
    }
}
function $7bdba95e5cda5a33$var$pf(a, b, c, d) {
    switch($7bdba95e5cda5a33$var$jd(b)){
        case 1:
            var e = $7bdba95e5cda5a33$var$ed;
            break;
        case 4:
            e = $7bdba95e5cda5a33$var$gd;
            break;
        default:
            e = $7bdba95e5cda5a33$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$7bdba95e5cda5a33$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $7bdba95e5cda5a33$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $7bdba95e5cda5a33$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $7bdba95e5cda5a33$var$Jb(function() {
        var _$d = f, _$e = $7bdba95e5cda5a33$var$xb(c), g = [];
        a: {
            var h = $7bdba95e5cda5a33$var$df.get(a);
            if (void 0 !== h) {
                var k = $7bdba95e5cda5a33$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $7bdba95e5cda5a33$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $7bdba95e5cda5a33$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $7bdba95e5cda5a33$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $7bdba95e5cda5a33$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $7bdba95e5cda5a33$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $7bdba95e5cda5a33$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $7bdba95e5cda5a33$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $7bdba95e5cda5a33$var$Vd;
                        break;
                    case $7bdba95e5cda5a33$var$$e:
                    case $7bdba95e5cda5a33$var$af:
                    case $7bdba95e5cda5a33$var$bf:
                        k = $7bdba95e5cda5a33$var$Hd;
                        break;
                    case $7bdba95e5cda5a33$var$cf:
                        k = $7bdba95e5cda5a33$var$Xd;
                        break;
                    case "scroll":
                        k = $7bdba95e5cda5a33$var$vd;
                        break;
                    case "wheel":
                        k = $7bdba95e5cda5a33$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $7bdba95e5cda5a33$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $7bdba95e5cda5a33$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $7bdba95e5cda5a33$var$Kb(w, x), null != F && t.push($7bdba95e5cda5a33$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $7bdba95e5cda5a33$var$wb && (n = c.relatedTarget || c.fromElement) && ($7bdba95e5cda5a33$var$Wc(n) || n[$7bdba95e5cda5a33$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $7bdba95e5cda5a33$var$Wc(n) : null, null !== n && (J = $7bdba95e5cda5a33$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $7bdba95e5cda5a33$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $7bdba95e5cda5a33$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $7bdba95e5cda5a33$var$ue(k);
                        u = null == n ? h : $7bdba95e5cda5a33$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $7bdba95e5cda5a33$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $7bdba95e5cda5a33$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $7bdba95e5cda5a33$var$vf(F))u++;
                            for(; 0 < w - u;)t = $7bdba95e5cda5a33$var$vf(t), w--;
                            for(; 0 < u - w;)x = $7bdba95e5cda5a33$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $7bdba95e5cda5a33$var$vf(t);
                                x = $7bdba95e5cda5a33$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $7bdba95e5cda5a33$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $7bdba95e5cda5a33$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $7bdba95e5cda5a33$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $7bdba95e5cda5a33$var$ve;
                else if ($7bdba95e5cda5a33$var$me(h)) {
                    if ($7bdba95e5cda5a33$var$we) na = $7bdba95e5cda5a33$var$Fe;
                    else {
                        na = $7bdba95e5cda5a33$var$De;
                        var xa = $7bdba95e5cda5a33$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $7bdba95e5cda5a33$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $7bdba95e5cda5a33$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $7bdba95e5cda5a33$var$cb(h, "number", h.value);
            }
            xa = _$d ? $7bdba95e5cda5a33$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($7bdba95e5cda5a33$var$me(xa) || "true" === xa.contentEditable) $7bdba95e5cda5a33$var$Qe = xa, $7bdba95e5cda5a33$var$Re = _$d, $7bdba95e5cda5a33$var$Se = null;
                    break;
                case "focusout":
                    $7bdba95e5cda5a33$var$Se = $7bdba95e5cda5a33$var$Re = $7bdba95e5cda5a33$var$Qe = null;
                    break;
                case "mousedown":
                    $7bdba95e5cda5a33$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $7bdba95e5cda5a33$var$Te = !1;
                    $7bdba95e5cda5a33$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($7bdba95e5cda5a33$var$Pe) break;
                case "keydown":
                case "keyup":
                    $7bdba95e5cda5a33$var$Ue(g, c, _$e);
            }
            var $a;
            if ($7bdba95e5cda5a33$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $7bdba95e5cda5a33$var$ie ? $7bdba95e5cda5a33$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($7bdba95e5cda5a33$var$de && "ko" !== c.locale && ($7bdba95e5cda5a33$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $7bdba95e5cda5a33$var$ie && ($a = $7bdba95e5cda5a33$var$nd()) : ($7bdba95e5cda5a33$var$kd = _$e, $7bdba95e5cda5a33$var$ld = "value" in $7bdba95e5cda5a33$var$kd ? $7bdba95e5cda5a33$var$kd.value : $7bdba95e5cda5a33$var$kd.textContent, $7bdba95e5cda5a33$var$ie = !0)), xa = $7bdba95e5cda5a33$var$oe(_$d, ba), 0 < xa.length && (ba = new $7bdba95e5cda5a33$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $7bdba95e5cda5a33$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $7bdba95e5cda5a33$var$ce ? $7bdba95e5cda5a33$var$je(a, c) : $7bdba95e5cda5a33$var$ke(a, c)) _$d = $7bdba95e5cda5a33$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $7bdba95e5cda5a33$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $7bdba95e5cda5a33$var$se(g, b);
    });
}
function $7bdba95e5cda5a33$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $7bdba95e5cda5a33$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $7bdba95e5cda5a33$var$Kb(a, c), null != f && d.unshift($7bdba95e5cda5a33$var$tf(a, f, e)), f = $7bdba95e5cda5a33$var$Kb(a, b), null != f && d.push($7bdba95e5cda5a33$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $7bdba95e5cda5a33$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $7bdba95e5cda5a33$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $7bdba95e5cda5a33$var$Kb(c, f), null != k && g.unshift($7bdba95e5cda5a33$var$tf(c, k, h))) : e || (k = $7bdba95e5cda5a33$var$Kb(c, f), null != k && g.push($7bdba95e5cda5a33$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $7bdba95e5cda5a33$var$xf = /\r\n?/g, $7bdba95e5cda5a33$var$yf = /\u0000|\uFFFD/g;
function $7bdba95e5cda5a33$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($7bdba95e5cda5a33$var$xf, "\n").replace($7bdba95e5cda5a33$var$yf, "");
}
function $7bdba95e5cda5a33$var$Af(a, b, c) {
    b = $7bdba95e5cda5a33$var$zf(b);
    if ($7bdba95e5cda5a33$var$zf(a) !== b && c) throw Error($7bdba95e5cda5a33$var$p(425));
}
function $7bdba95e5cda5a33$var$Bf() {}
var $7bdba95e5cda5a33$var$Cf = null, $7bdba95e5cda5a33$var$Df = null;
function $7bdba95e5cda5a33$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === (0, $27SFb._)(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $7bdba95e5cda5a33$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $7bdba95e5cda5a33$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $7bdba95e5cda5a33$var$Hf = "function" === typeof Promise ? Promise : void 0, $7bdba95e5cda5a33$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $7bdba95e5cda5a33$var$Hf ? function Jf(a) {
    return $7bdba95e5cda5a33$var$Hf.resolve(null).then(a).catch($7bdba95e5cda5a33$var$If);
} : $7bdba95e5cda5a33$var$Ff;
function $7bdba95e5cda5a33$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $7bdba95e5cda5a33$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $7bdba95e5cda5a33$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $7bdba95e5cda5a33$var$bd(b);
}
function $7bdba95e5cda5a33$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $7bdba95e5cda5a33$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $7bdba95e5cda5a33$var$Nf = Math.random().toString(36).slice(2), $7bdba95e5cda5a33$var$Of = "__reactFiber$" + $7bdba95e5cda5a33$var$Nf, $7bdba95e5cda5a33$var$Pf = "__reactProps$" + $7bdba95e5cda5a33$var$Nf, $7bdba95e5cda5a33$var$uf = "__reactContainer$" + $7bdba95e5cda5a33$var$Nf, $7bdba95e5cda5a33$var$of = "__reactEvents$" + $7bdba95e5cda5a33$var$Nf, $7bdba95e5cda5a33$var$Qf = "__reactListeners$" + $7bdba95e5cda5a33$var$Nf, $7bdba95e5cda5a33$var$Rf = "__reactHandles$" + $7bdba95e5cda5a33$var$Nf;
function $7bdba95e5cda5a33$var$Wc(a) {
    var b = a[$7bdba95e5cda5a33$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$7bdba95e5cda5a33$var$uf] || c[$7bdba95e5cda5a33$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $7bdba95e5cda5a33$var$Mf(a); null !== a;){
                if (c = a[$7bdba95e5cda5a33$var$Of]) return c;
                a = $7bdba95e5cda5a33$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $7bdba95e5cda5a33$var$Cb(a) {
    a = a[$7bdba95e5cda5a33$var$Of] || a[$7bdba95e5cda5a33$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $7bdba95e5cda5a33$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($7bdba95e5cda5a33$var$p(33));
}
function $7bdba95e5cda5a33$var$Db(a) {
    return a[$7bdba95e5cda5a33$var$Pf] || null;
}
var $7bdba95e5cda5a33$var$Sf = [], $7bdba95e5cda5a33$var$Tf = -1;
function $7bdba95e5cda5a33$var$Uf(a) {
    return {
        current: a
    };
}
function $7bdba95e5cda5a33$var$E(a) {
    0 > $7bdba95e5cda5a33$var$Tf || (a.current = $7bdba95e5cda5a33$var$Sf[$7bdba95e5cda5a33$var$Tf], $7bdba95e5cda5a33$var$Sf[$7bdba95e5cda5a33$var$Tf] = null, $7bdba95e5cda5a33$var$Tf--);
}
function $7bdba95e5cda5a33$var$G(a, b) {
    $7bdba95e5cda5a33$var$Tf++;
    $7bdba95e5cda5a33$var$Sf[$7bdba95e5cda5a33$var$Tf] = a.current;
    a.current = b;
}
var $7bdba95e5cda5a33$var$Vf = {}, $7bdba95e5cda5a33$var$H = $7bdba95e5cda5a33$var$Uf($7bdba95e5cda5a33$var$Vf), $7bdba95e5cda5a33$var$Wf = $7bdba95e5cda5a33$var$Uf(!1), $7bdba95e5cda5a33$var$Xf = $7bdba95e5cda5a33$var$Vf;
function $7bdba95e5cda5a33$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $7bdba95e5cda5a33$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $7bdba95e5cda5a33$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $7bdba95e5cda5a33$var$$f() {
    $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$Wf);
    $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$H);
}
function $7bdba95e5cda5a33$var$ag(a, b, c) {
    if ($7bdba95e5cda5a33$var$H.current !== $7bdba95e5cda5a33$var$Vf) throw Error($7bdba95e5cda5a33$var$p(168));
    $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$H, b);
    $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$Wf, c);
}
function $7bdba95e5cda5a33$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($7bdba95e5cda5a33$var$p(108, $7bdba95e5cda5a33$var$Ra(a) || "Unknown", e));
    return $7bdba95e5cda5a33$var$A({}, c, d);
}
function $7bdba95e5cda5a33$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $7bdba95e5cda5a33$var$Vf;
    $7bdba95e5cda5a33$var$Xf = $7bdba95e5cda5a33$var$H.current;
    $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$H, a);
    $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$Wf, $7bdba95e5cda5a33$var$Wf.current);
    return !0;
}
function $7bdba95e5cda5a33$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($7bdba95e5cda5a33$var$p(169));
    c ? (a = $7bdba95e5cda5a33$var$bg(a, b, $7bdba95e5cda5a33$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$Wf), $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$H), $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$H, a)) : $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$Wf);
    $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$Wf, c);
}
var $7bdba95e5cda5a33$var$eg = null, $7bdba95e5cda5a33$var$fg = !1, $7bdba95e5cda5a33$var$gg = !1;
function $7bdba95e5cda5a33$var$hg(a) {
    null === $7bdba95e5cda5a33$var$eg ? $7bdba95e5cda5a33$var$eg = [
        a
    ] : $7bdba95e5cda5a33$var$eg.push(a);
}
function $7bdba95e5cda5a33$var$ig(a) {
    $7bdba95e5cda5a33$var$fg = !0;
    $7bdba95e5cda5a33$var$hg(a);
}
function $7bdba95e5cda5a33$var$jg() {
    if (!$7bdba95e5cda5a33$var$gg && null !== $7bdba95e5cda5a33$var$eg) {
        $7bdba95e5cda5a33$var$gg = !0;
        var a = 0, b = $7bdba95e5cda5a33$var$C;
        try {
            var c = $7bdba95e5cda5a33$var$eg;
            for($7bdba95e5cda5a33$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $7bdba95e5cda5a33$var$eg = null;
            $7bdba95e5cda5a33$var$fg = !1;
        } catch (e) {
            throw null !== $7bdba95e5cda5a33$var$eg && ($7bdba95e5cda5a33$var$eg = $7bdba95e5cda5a33$var$eg.slice(a + 1)), $7bdba95e5cda5a33$var$ac($7bdba95e5cda5a33$var$fc, $7bdba95e5cda5a33$var$jg), e;
        } finally{
            $7bdba95e5cda5a33$var$C = b, $7bdba95e5cda5a33$var$gg = !1;
        }
    }
    return null;
}
var $7bdba95e5cda5a33$var$kg = [], $7bdba95e5cda5a33$var$lg = 0, $7bdba95e5cda5a33$var$mg = null, $7bdba95e5cda5a33$var$ng = 0, $7bdba95e5cda5a33$var$og = [], $7bdba95e5cda5a33$var$pg = 0, $7bdba95e5cda5a33$var$qg = null, $7bdba95e5cda5a33$var$rg = 1, $7bdba95e5cda5a33$var$sg = "";
function $7bdba95e5cda5a33$var$tg(a, b) {
    $7bdba95e5cda5a33$var$kg[$7bdba95e5cda5a33$var$lg++] = $7bdba95e5cda5a33$var$ng;
    $7bdba95e5cda5a33$var$kg[$7bdba95e5cda5a33$var$lg++] = $7bdba95e5cda5a33$var$mg;
    $7bdba95e5cda5a33$var$mg = a;
    $7bdba95e5cda5a33$var$ng = b;
}
function $7bdba95e5cda5a33$var$ug(a, b, c) {
    $7bdba95e5cda5a33$var$og[$7bdba95e5cda5a33$var$pg++] = $7bdba95e5cda5a33$var$rg;
    $7bdba95e5cda5a33$var$og[$7bdba95e5cda5a33$var$pg++] = $7bdba95e5cda5a33$var$sg;
    $7bdba95e5cda5a33$var$og[$7bdba95e5cda5a33$var$pg++] = $7bdba95e5cda5a33$var$qg;
    $7bdba95e5cda5a33$var$qg = a;
    var d = $7bdba95e5cda5a33$var$rg;
    a = $7bdba95e5cda5a33$var$sg;
    var e = 32 - $7bdba95e5cda5a33$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $7bdba95e5cda5a33$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $7bdba95e5cda5a33$var$rg = 1 << 32 - $7bdba95e5cda5a33$var$oc(b) + e | c << e | d;
        $7bdba95e5cda5a33$var$sg = f + a;
    } else $7bdba95e5cda5a33$var$rg = 1 << f | c << e | d, $7bdba95e5cda5a33$var$sg = a;
}
function $7bdba95e5cda5a33$var$vg(a) {
    null !== a.return && ($7bdba95e5cda5a33$var$tg(a, 1), $7bdba95e5cda5a33$var$ug(a, 1, 0));
}
function $7bdba95e5cda5a33$var$wg(a) {
    for(; a === $7bdba95e5cda5a33$var$mg;)$7bdba95e5cda5a33$var$mg = $7bdba95e5cda5a33$var$kg[--$7bdba95e5cda5a33$var$lg], $7bdba95e5cda5a33$var$kg[$7bdba95e5cda5a33$var$lg] = null, $7bdba95e5cda5a33$var$ng = $7bdba95e5cda5a33$var$kg[--$7bdba95e5cda5a33$var$lg], $7bdba95e5cda5a33$var$kg[$7bdba95e5cda5a33$var$lg] = null;
    for(; a === $7bdba95e5cda5a33$var$qg;)$7bdba95e5cda5a33$var$qg = $7bdba95e5cda5a33$var$og[--$7bdba95e5cda5a33$var$pg], $7bdba95e5cda5a33$var$og[$7bdba95e5cda5a33$var$pg] = null, $7bdba95e5cda5a33$var$sg = $7bdba95e5cda5a33$var$og[--$7bdba95e5cda5a33$var$pg], $7bdba95e5cda5a33$var$og[$7bdba95e5cda5a33$var$pg] = null, $7bdba95e5cda5a33$var$rg = $7bdba95e5cda5a33$var$og[--$7bdba95e5cda5a33$var$pg], $7bdba95e5cda5a33$var$og[$7bdba95e5cda5a33$var$pg] = null;
}
var $7bdba95e5cda5a33$var$xg = null, $7bdba95e5cda5a33$var$yg = null, $7bdba95e5cda5a33$var$I = !1, $7bdba95e5cda5a33$var$zg = null;
function $7bdba95e5cda5a33$var$Ag(a, b) {
    var c = $7bdba95e5cda5a33$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $7bdba95e5cda5a33$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $7bdba95e5cda5a33$var$xg = a, $7bdba95e5cda5a33$var$yg = $7bdba95e5cda5a33$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $7bdba95e5cda5a33$var$xg = a, $7bdba95e5cda5a33$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $7bdba95e5cda5a33$var$qg ? {
                id: $7bdba95e5cda5a33$var$rg,
                overflow: $7bdba95e5cda5a33$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $7bdba95e5cda5a33$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $7bdba95e5cda5a33$var$xg = a, $7bdba95e5cda5a33$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $7bdba95e5cda5a33$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $7bdba95e5cda5a33$var$Eg(a) {
    if ($7bdba95e5cda5a33$var$I) {
        var b = $7bdba95e5cda5a33$var$yg;
        if (b) {
            var c = b;
            if (!$7bdba95e5cda5a33$var$Cg(a, b)) {
                if ($7bdba95e5cda5a33$var$Dg(a)) throw Error($7bdba95e5cda5a33$var$p(418));
                b = $7bdba95e5cda5a33$var$Lf(c.nextSibling);
                var d = $7bdba95e5cda5a33$var$xg;
                b && $7bdba95e5cda5a33$var$Cg(a, b) ? $7bdba95e5cda5a33$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $7bdba95e5cda5a33$var$I = !1, $7bdba95e5cda5a33$var$xg = a);
            }
        } else {
            if ($7bdba95e5cda5a33$var$Dg(a)) throw Error($7bdba95e5cda5a33$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $7bdba95e5cda5a33$var$I = !1;
            $7bdba95e5cda5a33$var$xg = a;
        }
    }
}
function $7bdba95e5cda5a33$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $7bdba95e5cda5a33$var$xg = a;
}
function $7bdba95e5cda5a33$var$Gg(a) {
    if (a !== $7bdba95e5cda5a33$var$xg) return !1;
    if (!$7bdba95e5cda5a33$var$I) return $7bdba95e5cda5a33$var$Fg(a), $7bdba95e5cda5a33$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$7bdba95e5cda5a33$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $7bdba95e5cda5a33$var$yg)) {
        if ($7bdba95e5cda5a33$var$Dg(a)) throw $7bdba95e5cda5a33$var$Hg(), Error($7bdba95e5cda5a33$var$p(418));
        for(; b;)$7bdba95e5cda5a33$var$Ag(a, b), b = $7bdba95e5cda5a33$var$Lf(b.nextSibling);
    }
    $7bdba95e5cda5a33$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($7bdba95e5cda5a33$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $7bdba95e5cda5a33$var$yg = $7bdba95e5cda5a33$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $7bdba95e5cda5a33$var$yg = null;
        }
    } else $7bdba95e5cda5a33$var$yg = $7bdba95e5cda5a33$var$xg ? $7bdba95e5cda5a33$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $7bdba95e5cda5a33$var$Hg() {
    for(var a = $7bdba95e5cda5a33$var$yg; a;)a = $7bdba95e5cda5a33$var$Lf(a.nextSibling);
}
function $7bdba95e5cda5a33$var$Ig() {
    $7bdba95e5cda5a33$var$yg = $7bdba95e5cda5a33$var$xg = null;
    $7bdba95e5cda5a33$var$I = !1;
}
function $7bdba95e5cda5a33$var$Jg(a) {
    null === $7bdba95e5cda5a33$var$zg ? $7bdba95e5cda5a33$var$zg = [
        a
    ] : $7bdba95e5cda5a33$var$zg.push(a);
}
var $7bdba95e5cda5a33$var$Kg = $7bdba95e5cda5a33$var$ua.ReactCurrentBatchConfig;
function $7bdba95e5cda5a33$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : (0, $27SFb._)(a))) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($7bdba95e5cda5a33$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($7bdba95e5cda5a33$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($7bdba95e5cda5a33$var$p(284));
        if (!c._owner) throw Error($7bdba95e5cda5a33$var$p(290, a));
    }
    return a;
}
function $7bdba95e5cda5a33$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($7bdba95e5cda5a33$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $7bdba95e5cda5a33$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $7bdba95e5cda5a33$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $7bdba95e5cda5a33$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $7bdba95e5cda5a33$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $7bdba95e5cda5a33$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === (typeof f === "undefined" ? "undefined" : (0, $27SFb._)(f)) && null !== f && f.$$typeof === $7bdba95e5cda5a33$var$Ha && $7bdba95e5cda5a33$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $7bdba95e5cda5a33$var$Lg(a, b, c), d.return = a, d;
        d = $7bdba95e5cda5a33$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $7bdba95e5cda5a33$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $7bdba95e5cda5a33$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $7bdba95e5cda5a33$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $7bdba95e5cda5a33$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === (typeof b === "undefined" ? "undefined" : (0, $27SFb._)(b)) && null !== b) {
            switch(b.$$typeof){
                case $7bdba95e5cda5a33$var$va:
                    return c = $7bdba95e5cda5a33$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $7bdba95e5cda5a33$var$Lg(a, null, b), c.return = a, c;
                case $7bdba95e5cda5a33$var$wa:
                    return b = $7bdba95e5cda5a33$var$Sg(b, a.mode, c), b.return = a, b;
                case $7bdba95e5cda5a33$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($7bdba95e5cda5a33$var$eb(b) || $7bdba95e5cda5a33$var$Ka(b)) return b = $7bdba95e5cda5a33$var$Tg(b, a.mode, c, null), b.return = a, b;
            $7bdba95e5cda5a33$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === (typeof c === "undefined" ? "undefined" : (0, $27SFb._)(c)) && null !== c) {
            switch(c.$$typeof){
                case $7bdba95e5cda5a33$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $7bdba95e5cda5a33$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $7bdba95e5cda5a33$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($7bdba95e5cda5a33$var$eb(c) || $7bdba95e5cda5a33$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $7bdba95e5cda5a33$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === (typeof d === "undefined" ? "undefined" : (0, $27SFb._)(d)) && null !== d) {
            switch(d.$$typeof){
                case $7bdba95e5cda5a33$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $7bdba95e5cda5a33$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $7bdba95e5cda5a33$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($7bdba95e5cda5a33$var$eb(d) || $7bdba95e5cda5a33$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $7bdba95e5cda5a33$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $7bdba95e5cda5a33$var$I && $7bdba95e5cda5a33$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $7bdba95e5cda5a33$var$I && $7bdba95e5cda5a33$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $7bdba95e5cda5a33$var$I && $7bdba95e5cda5a33$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $7bdba95e5cda5a33$var$Ka(h);
        if ("function" !== typeof l) throw Error($7bdba95e5cda5a33$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($7bdba95e5cda5a33$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $7bdba95e5cda5a33$var$I && $7bdba95e5cda5a33$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $7bdba95e5cda5a33$var$I && $7bdba95e5cda5a33$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $7bdba95e5cda5a33$var$I && $7bdba95e5cda5a33$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === (typeof f === "undefined" ? "undefined" : (0, $27SFb._)(f)) && null !== f && f.type === $7bdba95e5cda5a33$var$ya && null === f.key && (f = f.props.children);
        if ("object" === (typeof f === "undefined" ? "undefined" : (0, $27SFb._)(f)) && null !== f) {
            switch(f.$$typeof){
                case $7bdba95e5cda5a33$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $7bdba95e5cda5a33$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === (typeof k === "undefined" ? "undefined" : (0, $27SFb._)(k)) && null !== k && k.$$typeof === $7bdba95e5cda5a33$var$Ha && $7bdba95e5cda5a33$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $7bdba95e5cda5a33$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $7bdba95e5cda5a33$var$ya ? (d = $7bdba95e5cda5a33$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $7bdba95e5cda5a33$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $7bdba95e5cda5a33$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $7bdba95e5cda5a33$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $7bdba95e5cda5a33$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $7bdba95e5cda5a33$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($7bdba95e5cda5a33$var$eb(f)) return n(a, d, f, h);
            if ($7bdba95e5cda5a33$var$Ka(f)) return t(a, d, f, h);
            $7bdba95e5cda5a33$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $7bdba95e5cda5a33$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $7bdba95e5cda5a33$var$Ug = $7bdba95e5cda5a33$var$Og(!0), $7bdba95e5cda5a33$var$Vg = $7bdba95e5cda5a33$var$Og(!1), $7bdba95e5cda5a33$var$Wg = $7bdba95e5cda5a33$var$Uf(null), $7bdba95e5cda5a33$var$Xg = null, $7bdba95e5cda5a33$var$Yg = null, $7bdba95e5cda5a33$var$Zg = null;
function $7bdba95e5cda5a33$var$$g() {
    $7bdba95e5cda5a33$var$Zg = $7bdba95e5cda5a33$var$Yg = $7bdba95e5cda5a33$var$Xg = null;
}
function $7bdba95e5cda5a33$var$ah(a) {
    var b = $7bdba95e5cda5a33$var$Wg.current;
    $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$Wg);
    a._currentValue = b;
}
function $7bdba95e5cda5a33$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $7bdba95e5cda5a33$var$ch(a, b) {
    $7bdba95e5cda5a33$var$Xg = a;
    $7bdba95e5cda5a33$var$Zg = $7bdba95e5cda5a33$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($7bdba95e5cda5a33$var$dh = !0), a.firstContext = null);
}
function $7bdba95e5cda5a33$var$eh(a) {
    var b = a._currentValue;
    if ($7bdba95e5cda5a33$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $7bdba95e5cda5a33$var$Yg) {
            if (null === $7bdba95e5cda5a33$var$Xg) throw Error($7bdba95e5cda5a33$var$p(308));
            $7bdba95e5cda5a33$var$Yg = a;
            $7bdba95e5cda5a33$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $7bdba95e5cda5a33$var$Yg = $7bdba95e5cda5a33$var$Yg.next = a;
    }
    return b;
}
var $7bdba95e5cda5a33$var$fh = null;
function $7bdba95e5cda5a33$var$gh(a) {
    null === $7bdba95e5cda5a33$var$fh ? $7bdba95e5cda5a33$var$fh = [
        a
    ] : $7bdba95e5cda5a33$var$fh.push(a);
}
function $7bdba95e5cda5a33$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $7bdba95e5cda5a33$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $7bdba95e5cda5a33$var$ih(a, d);
}
function $7bdba95e5cda5a33$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $7bdba95e5cda5a33$var$jh = !1;
function $7bdba95e5cda5a33$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $7bdba95e5cda5a33$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $7bdba95e5cda5a33$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $7bdba95e5cda5a33$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($7bdba95e5cda5a33$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $7bdba95e5cda5a33$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $7bdba95e5cda5a33$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $7bdba95e5cda5a33$var$ih(a, c);
}
function $7bdba95e5cda5a33$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $7bdba95e5cda5a33$var$Cc(a, c);
    }
}
function $7bdba95e5cda5a33$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $7bdba95e5cda5a33$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $7bdba95e5cda5a33$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $7bdba95e5cda5a33$var$A({}, q, r);
                            break a;
                        case 2:
                            $7bdba95e5cda5a33$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $7bdba95e5cda5a33$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $7bdba95e5cda5a33$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($7bdba95e5cda5a33$var$p(191, e));
            e.call(d);
        }
    }
}
var $7bdba95e5cda5a33$var$th = {}, $7bdba95e5cda5a33$var$uh = $7bdba95e5cda5a33$var$Uf($7bdba95e5cda5a33$var$th), $7bdba95e5cda5a33$var$vh = $7bdba95e5cda5a33$var$Uf($7bdba95e5cda5a33$var$th), $7bdba95e5cda5a33$var$wh = $7bdba95e5cda5a33$var$Uf($7bdba95e5cda5a33$var$th);
function $7bdba95e5cda5a33$var$xh(a) {
    if (a === $7bdba95e5cda5a33$var$th) throw Error($7bdba95e5cda5a33$var$p(174));
    return a;
}
function $7bdba95e5cda5a33$var$yh(a, b) {
    $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$wh, b);
    $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$vh, a);
    $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$uh, $7bdba95e5cda5a33$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $7bdba95e5cda5a33$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $7bdba95e5cda5a33$var$lb(b, a);
    }
    $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$uh);
    $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$uh, b);
}
function $7bdba95e5cda5a33$var$zh() {
    $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$uh);
    $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$vh);
    $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$wh);
}
function $7bdba95e5cda5a33$var$Ah(a) {
    $7bdba95e5cda5a33$var$xh($7bdba95e5cda5a33$var$wh.current);
    var b = $7bdba95e5cda5a33$var$xh($7bdba95e5cda5a33$var$uh.current);
    var c = $7bdba95e5cda5a33$var$lb(b, a.type);
    b !== c && ($7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$vh, a), $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$uh, c));
}
function $7bdba95e5cda5a33$var$Bh(a) {
    $7bdba95e5cda5a33$var$vh.current === a && ($7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$uh), $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$vh));
}
var $7bdba95e5cda5a33$var$L = $7bdba95e5cda5a33$var$Uf(0);
function $7bdba95e5cda5a33$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $7bdba95e5cda5a33$var$Dh = [];
function $7bdba95e5cda5a33$var$Eh() {
    for(var a = 0; a < $7bdba95e5cda5a33$var$Dh.length; a++)$7bdba95e5cda5a33$var$Dh[a]._workInProgressVersionPrimary = null;
    $7bdba95e5cda5a33$var$Dh.length = 0;
}
var $7bdba95e5cda5a33$var$Fh = $7bdba95e5cda5a33$var$ua.ReactCurrentDispatcher, $7bdba95e5cda5a33$var$Gh = $7bdba95e5cda5a33$var$ua.ReactCurrentBatchConfig, $7bdba95e5cda5a33$var$Hh = 0, $7bdba95e5cda5a33$var$M = null, $7bdba95e5cda5a33$var$N = null, $7bdba95e5cda5a33$var$O = null, $7bdba95e5cda5a33$var$Ih = !1, $7bdba95e5cda5a33$var$Jh = !1, $7bdba95e5cda5a33$var$Kh = 0, $7bdba95e5cda5a33$var$Lh = 0;
function $7bdba95e5cda5a33$var$P() {
    throw Error($7bdba95e5cda5a33$var$p(321));
}
function $7bdba95e5cda5a33$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$7bdba95e5cda5a33$var$He(a[c], b[c])) return !1;
    return !0;
}
function $7bdba95e5cda5a33$var$Nh(a, b, c, d, e, f) {
    $7bdba95e5cda5a33$var$Hh = f;
    $7bdba95e5cda5a33$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $7bdba95e5cda5a33$var$Fh.current = null === a || null === a.memoizedState ? $7bdba95e5cda5a33$var$Oh : $7bdba95e5cda5a33$var$Ph;
    a = c(d, e);
    if ($7bdba95e5cda5a33$var$Jh) {
        f = 0;
        do {
            $7bdba95e5cda5a33$var$Jh = !1;
            $7bdba95e5cda5a33$var$Kh = 0;
            if (25 <= f) throw Error($7bdba95e5cda5a33$var$p(301));
            f += 1;
            $7bdba95e5cda5a33$var$O = $7bdba95e5cda5a33$var$N = null;
            b.updateQueue = null;
            $7bdba95e5cda5a33$var$Fh.current = $7bdba95e5cda5a33$var$Qh;
            a = c(d, e);
        }while ($7bdba95e5cda5a33$var$Jh);
    }
    $7bdba95e5cda5a33$var$Fh.current = $7bdba95e5cda5a33$var$Rh;
    b = null !== $7bdba95e5cda5a33$var$N && null !== $7bdba95e5cda5a33$var$N.next;
    $7bdba95e5cda5a33$var$Hh = 0;
    $7bdba95e5cda5a33$var$O = $7bdba95e5cda5a33$var$N = $7bdba95e5cda5a33$var$M = null;
    $7bdba95e5cda5a33$var$Ih = !1;
    if (b) throw Error($7bdba95e5cda5a33$var$p(300));
    return a;
}
function $7bdba95e5cda5a33$var$Sh() {
    var a = 0 !== $7bdba95e5cda5a33$var$Kh;
    $7bdba95e5cda5a33$var$Kh = 0;
    return a;
}
function $7bdba95e5cda5a33$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $7bdba95e5cda5a33$var$O ? $7bdba95e5cda5a33$var$M.memoizedState = $7bdba95e5cda5a33$var$O = a : $7bdba95e5cda5a33$var$O = $7bdba95e5cda5a33$var$O.next = a;
    return $7bdba95e5cda5a33$var$O;
}
function $7bdba95e5cda5a33$var$Uh() {
    if (null === $7bdba95e5cda5a33$var$N) {
        var a = $7bdba95e5cda5a33$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $7bdba95e5cda5a33$var$N.next;
    var b = null === $7bdba95e5cda5a33$var$O ? $7bdba95e5cda5a33$var$M.memoizedState : $7bdba95e5cda5a33$var$O.next;
    if (null !== b) $7bdba95e5cda5a33$var$O = b, $7bdba95e5cda5a33$var$N = a;
    else {
        if (null === a) throw Error($7bdba95e5cda5a33$var$p(310));
        $7bdba95e5cda5a33$var$N = a;
        a = {
            memoizedState: $7bdba95e5cda5a33$var$N.memoizedState,
            baseState: $7bdba95e5cda5a33$var$N.baseState,
            baseQueue: $7bdba95e5cda5a33$var$N.baseQueue,
            queue: $7bdba95e5cda5a33$var$N.queue,
            next: null
        };
        null === $7bdba95e5cda5a33$var$O ? $7bdba95e5cda5a33$var$M.memoizedState = $7bdba95e5cda5a33$var$O = a : $7bdba95e5cda5a33$var$O = $7bdba95e5cda5a33$var$O.next = a;
    }
    return $7bdba95e5cda5a33$var$O;
}
function $7bdba95e5cda5a33$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $7bdba95e5cda5a33$var$Wh(a) {
    var b = $7bdba95e5cda5a33$var$Uh(), c = b.queue;
    if (null === c) throw Error($7bdba95e5cda5a33$var$p(311));
    c.lastRenderedReducer = a;
    var d = $7bdba95e5cda5a33$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($7bdba95e5cda5a33$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $7bdba95e5cda5a33$var$M.lanes |= m;
                $7bdba95e5cda5a33$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $7bdba95e5cda5a33$var$He(d, b.memoizedState) || ($7bdba95e5cda5a33$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $7bdba95e5cda5a33$var$M.lanes |= f, $7bdba95e5cda5a33$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $7bdba95e5cda5a33$var$Xh(a) {
    var b = $7bdba95e5cda5a33$var$Uh(), c = b.queue;
    if (null === c) throw Error($7bdba95e5cda5a33$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $7bdba95e5cda5a33$var$He(f, b.memoizedState) || ($7bdba95e5cda5a33$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $7bdba95e5cda5a33$var$Yh() {}
function $7bdba95e5cda5a33$var$Zh(a, b) {
    var c = $7bdba95e5cda5a33$var$M, d = $7bdba95e5cda5a33$var$Uh(), e = b(), f = !$7bdba95e5cda5a33$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $7bdba95e5cda5a33$var$dh = !0);
    d = d.queue;
    $7bdba95e5cda5a33$var$$h($7bdba95e5cda5a33$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $7bdba95e5cda5a33$var$O && $7bdba95e5cda5a33$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $7bdba95e5cda5a33$var$bi(9, $7bdba95e5cda5a33$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $7bdba95e5cda5a33$var$Q) throw Error($7bdba95e5cda5a33$var$p(349));
        0 !== ($7bdba95e5cda5a33$var$Hh & 30) || $7bdba95e5cda5a33$var$di(c, b, e);
    }
    return e;
}
function $7bdba95e5cda5a33$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $7bdba95e5cda5a33$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $7bdba95e5cda5a33$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $7bdba95e5cda5a33$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $7bdba95e5cda5a33$var$ei(b) && $7bdba95e5cda5a33$var$fi(a);
}
function $7bdba95e5cda5a33$var$ai(a, b, c) {
    return c(function() {
        $7bdba95e5cda5a33$var$ei(b) && $7bdba95e5cda5a33$var$fi(a);
    });
}
function $7bdba95e5cda5a33$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$7bdba95e5cda5a33$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $7bdba95e5cda5a33$var$fi(a) {
    var b = $7bdba95e5cda5a33$var$ih(a, 1);
    null !== b && $7bdba95e5cda5a33$var$gi(b, a, 1, -1);
}
function $7bdba95e5cda5a33$var$hi(a) {
    var b = $7bdba95e5cda5a33$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $7bdba95e5cda5a33$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $7bdba95e5cda5a33$var$ii.bind(null, $7bdba95e5cda5a33$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $7bdba95e5cda5a33$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $7bdba95e5cda5a33$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $7bdba95e5cda5a33$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $7bdba95e5cda5a33$var$ji() {
    return $7bdba95e5cda5a33$var$Uh().memoizedState;
}
function $7bdba95e5cda5a33$var$ki(a, b, c, d) {
    var e = $7bdba95e5cda5a33$var$Th();
    $7bdba95e5cda5a33$var$M.flags |= a;
    e.memoizedState = $7bdba95e5cda5a33$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $7bdba95e5cda5a33$var$li(a, b, c, d) {
    var e = $7bdba95e5cda5a33$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $7bdba95e5cda5a33$var$N) {
        var g = $7bdba95e5cda5a33$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $7bdba95e5cda5a33$var$Mh(d, g.deps)) {
            e.memoizedState = $7bdba95e5cda5a33$var$bi(b, c, f, d);
            return;
        }
    }
    $7bdba95e5cda5a33$var$M.flags |= a;
    e.memoizedState = $7bdba95e5cda5a33$var$bi(1 | b, c, f, d);
}
function $7bdba95e5cda5a33$var$mi(a, b) {
    return $7bdba95e5cda5a33$var$ki(8390656, 8, a, b);
}
function $7bdba95e5cda5a33$var$$h(a, b) {
    return $7bdba95e5cda5a33$var$li(2048, 8, a, b);
}
function $7bdba95e5cda5a33$var$ni(a, b) {
    return $7bdba95e5cda5a33$var$li(4, 2, a, b);
}
function $7bdba95e5cda5a33$var$oi(a, b) {
    return $7bdba95e5cda5a33$var$li(4, 4, a, b);
}
function $7bdba95e5cda5a33$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $7bdba95e5cda5a33$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $7bdba95e5cda5a33$var$li(4, 4, $7bdba95e5cda5a33$var$pi.bind(null, b, a), c);
}
function $7bdba95e5cda5a33$var$ri() {}
function $7bdba95e5cda5a33$var$si(a, b) {
    var c = $7bdba95e5cda5a33$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $7bdba95e5cda5a33$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $7bdba95e5cda5a33$var$ti(a, b) {
    var c = $7bdba95e5cda5a33$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $7bdba95e5cda5a33$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $7bdba95e5cda5a33$var$ui(a, b, c) {
    if (0 === ($7bdba95e5cda5a33$var$Hh & 21)) return a.baseState && (a.baseState = !1, $7bdba95e5cda5a33$var$dh = !0), a.memoizedState = c;
    $7bdba95e5cda5a33$var$He(c, b) || (c = $7bdba95e5cda5a33$var$yc(), $7bdba95e5cda5a33$var$M.lanes |= c, $7bdba95e5cda5a33$var$rh |= c, a.baseState = !0);
    return b;
}
function $7bdba95e5cda5a33$var$vi(a, b) {
    var c = $7bdba95e5cda5a33$var$C;
    $7bdba95e5cda5a33$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $7bdba95e5cda5a33$var$Gh.transition;
    $7bdba95e5cda5a33$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $7bdba95e5cda5a33$var$C = c, $7bdba95e5cda5a33$var$Gh.transition = d;
    }
}
function $7bdba95e5cda5a33$var$wi() {
    return $7bdba95e5cda5a33$var$Uh().memoizedState;
}
function $7bdba95e5cda5a33$var$xi(a, b, c) {
    var d = $7bdba95e5cda5a33$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($7bdba95e5cda5a33$var$zi(a)) $7bdba95e5cda5a33$var$Ai(b, c);
    else if (c = $7bdba95e5cda5a33$var$hh(a, b, c, d), null !== c) {
        var e = $7bdba95e5cda5a33$var$R();
        $7bdba95e5cda5a33$var$gi(c, a, d, e);
        $7bdba95e5cda5a33$var$Bi(c, b, d);
    }
}
function $7bdba95e5cda5a33$var$ii(a, b, c) {
    var d = $7bdba95e5cda5a33$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($7bdba95e5cda5a33$var$zi(a)) $7bdba95e5cda5a33$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($7bdba95e5cda5a33$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $7bdba95e5cda5a33$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $7bdba95e5cda5a33$var$hh(a, b, e, d);
        null !== c && (e = $7bdba95e5cda5a33$var$R(), $7bdba95e5cda5a33$var$gi(c, a, d, e), $7bdba95e5cda5a33$var$Bi(c, b, d));
    }
}
function $7bdba95e5cda5a33$var$zi(a) {
    var b = a.alternate;
    return a === $7bdba95e5cda5a33$var$M || null !== b && b === $7bdba95e5cda5a33$var$M;
}
function $7bdba95e5cda5a33$var$Ai(a, b) {
    $7bdba95e5cda5a33$var$Jh = $7bdba95e5cda5a33$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $7bdba95e5cda5a33$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $7bdba95e5cda5a33$var$Cc(a, c);
    }
}
var $7bdba95e5cda5a33$var$Rh = {
    readContext: $7bdba95e5cda5a33$var$eh,
    useCallback: $7bdba95e5cda5a33$var$P,
    useContext: $7bdba95e5cda5a33$var$P,
    useEffect: $7bdba95e5cda5a33$var$P,
    useImperativeHandle: $7bdba95e5cda5a33$var$P,
    useInsertionEffect: $7bdba95e5cda5a33$var$P,
    useLayoutEffect: $7bdba95e5cda5a33$var$P,
    useMemo: $7bdba95e5cda5a33$var$P,
    useReducer: $7bdba95e5cda5a33$var$P,
    useRef: $7bdba95e5cda5a33$var$P,
    useState: $7bdba95e5cda5a33$var$P,
    useDebugValue: $7bdba95e5cda5a33$var$P,
    useDeferredValue: $7bdba95e5cda5a33$var$P,
    useTransition: $7bdba95e5cda5a33$var$P,
    useMutableSource: $7bdba95e5cda5a33$var$P,
    useSyncExternalStore: $7bdba95e5cda5a33$var$P,
    useId: $7bdba95e5cda5a33$var$P,
    unstable_isNewReconciler: !1
}, $7bdba95e5cda5a33$var$Oh = {
    readContext: $7bdba95e5cda5a33$var$eh,
    useCallback: function useCallback(a, b) {
        $7bdba95e5cda5a33$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $7bdba95e5cda5a33$var$eh,
    useEffect: $7bdba95e5cda5a33$var$mi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $7bdba95e5cda5a33$var$ki(4194308, 4, $7bdba95e5cda5a33$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $7bdba95e5cda5a33$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $7bdba95e5cda5a33$var$ki(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $7bdba95e5cda5a33$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $7bdba95e5cda5a33$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $7bdba95e5cda5a33$var$xi.bind(null, $7bdba95e5cda5a33$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $7bdba95e5cda5a33$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $7bdba95e5cda5a33$var$hi,
    useDebugValue: $7bdba95e5cda5a33$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        return $7bdba95e5cda5a33$var$Th().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $7bdba95e5cda5a33$var$hi(!1), b = a[0];
        a = $7bdba95e5cda5a33$var$vi.bind(null, a[1]);
        $7bdba95e5cda5a33$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $7bdba95e5cda5a33$var$M, e = $7bdba95e5cda5a33$var$Th();
        if ($7bdba95e5cda5a33$var$I) {
            if (void 0 === c) throw Error($7bdba95e5cda5a33$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $7bdba95e5cda5a33$var$Q) throw Error($7bdba95e5cda5a33$var$p(349));
            0 !== ($7bdba95e5cda5a33$var$Hh & 30) || $7bdba95e5cda5a33$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $7bdba95e5cda5a33$var$mi($7bdba95e5cda5a33$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $7bdba95e5cda5a33$var$bi(9, $7bdba95e5cda5a33$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $7bdba95e5cda5a33$var$Th(), b = $7bdba95e5cda5a33$var$Q.identifierPrefix;
        if ($7bdba95e5cda5a33$var$I) {
            var c = $7bdba95e5cda5a33$var$sg;
            var d = $7bdba95e5cda5a33$var$rg;
            c = (d & ~(1 << 32 - $7bdba95e5cda5a33$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $7bdba95e5cda5a33$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $7bdba95e5cda5a33$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $7bdba95e5cda5a33$var$Ph = {
    readContext: $7bdba95e5cda5a33$var$eh,
    useCallback: $7bdba95e5cda5a33$var$si,
    useContext: $7bdba95e5cda5a33$var$eh,
    useEffect: $7bdba95e5cda5a33$var$$h,
    useImperativeHandle: $7bdba95e5cda5a33$var$qi,
    useInsertionEffect: $7bdba95e5cda5a33$var$ni,
    useLayoutEffect: $7bdba95e5cda5a33$var$oi,
    useMemo: $7bdba95e5cda5a33$var$ti,
    useReducer: $7bdba95e5cda5a33$var$Wh,
    useRef: $7bdba95e5cda5a33$var$ji,
    useState: function useState() {
        return $7bdba95e5cda5a33$var$Wh($7bdba95e5cda5a33$var$Vh);
    },
    useDebugValue: $7bdba95e5cda5a33$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $7bdba95e5cda5a33$var$Uh();
        return $7bdba95e5cda5a33$var$ui(b, $7bdba95e5cda5a33$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $7bdba95e5cda5a33$var$Wh($7bdba95e5cda5a33$var$Vh)[0], b = $7bdba95e5cda5a33$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $7bdba95e5cda5a33$var$Yh,
    useSyncExternalStore: $7bdba95e5cda5a33$var$Zh,
    useId: $7bdba95e5cda5a33$var$wi,
    unstable_isNewReconciler: !1
}, $7bdba95e5cda5a33$var$Qh = {
    readContext: $7bdba95e5cda5a33$var$eh,
    useCallback: $7bdba95e5cda5a33$var$si,
    useContext: $7bdba95e5cda5a33$var$eh,
    useEffect: $7bdba95e5cda5a33$var$$h,
    useImperativeHandle: $7bdba95e5cda5a33$var$qi,
    useInsertionEffect: $7bdba95e5cda5a33$var$ni,
    useLayoutEffect: $7bdba95e5cda5a33$var$oi,
    useMemo: $7bdba95e5cda5a33$var$ti,
    useReducer: $7bdba95e5cda5a33$var$Xh,
    useRef: $7bdba95e5cda5a33$var$ji,
    useState: function useState() {
        return $7bdba95e5cda5a33$var$Xh($7bdba95e5cda5a33$var$Vh);
    },
    useDebugValue: $7bdba95e5cda5a33$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $7bdba95e5cda5a33$var$Uh();
        return null === $7bdba95e5cda5a33$var$N ? b.memoizedState = a : $7bdba95e5cda5a33$var$ui(b, $7bdba95e5cda5a33$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $7bdba95e5cda5a33$var$Xh($7bdba95e5cda5a33$var$Vh)[0], b = $7bdba95e5cda5a33$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $7bdba95e5cda5a33$var$Yh,
    useSyncExternalStore: $7bdba95e5cda5a33$var$Zh,
    useId: $7bdba95e5cda5a33$var$wi,
    unstable_isNewReconciler: !1
};
function $7bdba95e5cda5a33$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $7bdba95e5cda5a33$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $7bdba95e5cda5a33$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $7bdba95e5cda5a33$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $7bdba95e5cda5a33$var$Ei = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $7bdba95e5cda5a33$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $7bdba95e5cda5a33$var$R(), e = $7bdba95e5cda5a33$var$yi(a), f = $7bdba95e5cda5a33$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $7bdba95e5cda5a33$var$nh(a, f, e);
        null !== b && ($7bdba95e5cda5a33$var$gi(b, a, e, d), $7bdba95e5cda5a33$var$oh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $7bdba95e5cda5a33$var$R(), e = $7bdba95e5cda5a33$var$yi(a), f = $7bdba95e5cda5a33$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $7bdba95e5cda5a33$var$nh(a, f, e);
        null !== b && ($7bdba95e5cda5a33$var$gi(b, a, e, d), $7bdba95e5cda5a33$var$oh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $7bdba95e5cda5a33$var$R(), d = $7bdba95e5cda5a33$var$yi(a), e = $7bdba95e5cda5a33$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $7bdba95e5cda5a33$var$nh(a, e, d);
        null !== b && ($7bdba95e5cda5a33$var$gi(b, a, d, c), $7bdba95e5cda5a33$var$oh(b, a, d));
    }
};
function $7bdba95e5cda5a33$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$7bdba95e5cda5a33$var$Ie(c, d) || !$7bdba95e5cda5a33$var$Ie(e, f) : !0;
}
function $7bdba95e5cda5a33$var$Gi(a, b, c) {
    var d = !1, e = $7bdba95e5cda5a33$var$Vf;
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $27SFb._)(f)) && null !== f ? f = $7bdba95e5cda5a33$var$eh(f) : (e = $7bdba95e5cda5a33$var$Zf(b) ? $7bdba95e5cda5a33$var$Xf : $7bdba95e5cda5a33$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $7bdba95e5cda5a33$var$Yf(a, e) : $7bdba95e5cda5a33$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $7bdba95e5cda5a33$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $7bdba95e5cda5a33$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $7bdba95e5cda5a33$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $7bdba95e5cda5a33$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $7bdba95e5cda5a33$var$kh(a);
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $27SFb._)(f)) && null !== f ? e.context = $7bdba95e5cda5a33$var$eh(f) : (f = $7bdba95e5cda5a33$var$Zf(b) ? $7bdba95e5cda5a33$var$Xf : $7bdba95e5cda5a33$var$H.current, e.context = $7bdba95e5cda5a33$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($7bdba95e5cda5a33$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $7bdba95e5cda5a33$var$Ei.enqueueReplaceState(e, e.state, null), $7bdba95e5cda5a33$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $7bdba95e5cda5a33$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $7bdba95e5cda5a33$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $7bdba95e5cda5a33$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $7bdba95e5cda5a33$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $7bdba95e5cda5a33$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $7bdba95e5cda5a33$var$Ni(a, b, c) {
    c = $7bdba95e5cda5a33$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $7bdba95e5cda5a33$var$Oi || ($7bdba95e5cda5a33$var$Oi = !0, $7bdba95e5cda5a33$var$Pi = d);
        $7bdba95e5cda5a33$var$Li(a, b);
    };
    return c;
}
function $7bdba95e5cda5a33$var$Qi(a, b, c) {
    c = $7bdba95e5cda5a33$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $7bdba95e5cda5a33$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $7bdba95e5cda5a33$var$Li(a, b);
        "function" !== typeof d && (null === $7bdba95e5cda5a33$var$Ri ? $7bdba95e5cda5a33$var$Ri = new Set([
            this
        ]) : $7bdba95e5cda5a33$var$Ri.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $7bdba95e5cda5a33$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $7bdba95e5cda5a33$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $7bdba95e5cda5a33$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $7bdba95e5cda5a33$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $7bdba95e5cda5a33$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $7bdba95e5cda5a33$var$mh(-1, 1), b.tag = 2, $7bdba95e5cda5a33$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $7bdba95e5cda5a33$var$Wi = $7bdba95e5cda5a33$var$ua.ReactCurrentOwner, $7bdba95e5cda5a33$var$dh = !1;
function $7bdba95e5cda5a33$var$Xi(a, b, c, d) {
    b.child = null === a ? $7bdba95e5cda5a33$var$Vg(b, null, c, d) : $7bdba95e5cda5a33$var$Ug(b, a.child, c, d);
}
function $7bdba95e5cda5a33$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $7bdba95e5cda5a33$var$ch(b, e);
    d = $7bdba95e5cda5a33$var$Nh(a, b, c, d, f, e);
    c = $7bdba95e5cda5a33$var$Sh();
    if (null !== a && !$7bdba95e5cda5a33$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $7bdba95e5cda5a33$var$Zi(a, b, e);
    $7bdba95e5cda5a33$var$I && c && $7bdba95e5cda5a33$var$vg(b);
    b.flags |= 1;
    $7bdba95e5cda5a33$var$Xi(a, b, d, e);
    return b.child;
}
function $7bdba95e5cda5a33$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$7bdba95e5cda5a33$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $7bdba95e5cda5a33$var$bj(a, b, f, d, e);
        a = $7bdba95e5cda5a33$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $7bdba95e5cda5a33$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $7bdba95e5cda5a33$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $7bdba95e5cda5a33$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $7bdba95e5cda5a33$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($7bdba95e5cda5a33$var$Ie(f, d) && a.ref === b.ref) {
            if ($7bdba95e5cda5a33$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($7bdba95e5cda5a33$var$dh = !0);
            else return b.lanes = a.lanes, $7bdba95e5cda5a33$var$Zi(a, b, e);
        }
    }
    return $7bdba95e5cda5a33$var$cj(a, b, c, d, e);
}
function $7bdba95e5cda5a33$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$ej, $7bdba95e5cda5a33$var$fj), $7bdba95e5cda5a33$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$ej, $7bdba95e5cda5a33$var$fj), $7bdba95e5cda5a33$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$ej, $7bdba95e5cda5a33$var$fj);
            $7bdba95e5cda5a33$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$ej, $7bdba95e5cda5a33$var$fj), $7bdba95e5cda5a33$var$fj |= d;
    $7bdba95e5cda5a33$var$Xi(a, b, e, c);
    return b.child;
}
function $7bdba95e5cda5a33$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $7bdba95e5cda5a33$var$cj(a, b, c, d, e) {
    var f = $7bdba95e5cda5a33$var$Zf(c) ? $7bdba95e5cda5a33$var$Xf : $7bdba95e5cda5a33$var$H.current;
    f = $7bdba95e5cda5a33$var$Yf(b, f);
    $7bdba95e5cda5a33$var$ch(b, e);
    c = $7bdba95e5cda5a33$var$Nh(a, b, c, d, f, e);
    d = $7bdba95e5cda5a33$var$Sh();
    if (null !== a && !$7bdba95e5cda5a33$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $7bdba95e5cda5a33$var$Zi(a, b, e);
    $7bdba95e5cda5a33$var$I && d && $7bdba95e5cda5a33$var$vg(b);
    b.flags |= 1;
    $7bdba95e5cda5a33$var$Xi(a, b, c, e);
    return b.child;
}
function $7bdba95e5cda5a33$var$hj(a, b, c, d, e) {
    if ($7bdba95e5cda5a33$var$Zf(c)) {
        var f = !0;
        $7bdba95e5cda5a33$var$cg(b);
    } else f = !1;
    $7bdba95e5cda5a33$var$ch(b, e);
    if (null === b.stateNode) $7bdba95e5cda5a33$var$ij(a, b), $7bdba95e5cda5a33$var$Gi(b, c, d), $7bdba95e5cda5a33$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === (typeof l === "undefined" ? "undefined" : (0, $27SFb._)(l)) && null !== l ? l = $7bdba95e5cda5a33$var$eh(l) : (l = $7bdba95e5cda5a33$var$Zf(c) ? $7bdba95e5cda5a33$var$Xf : $7bdba95e5cda5a33$var$H.current, l = $7bdba95e5cda5a33$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $7bdba95e5cda5a33$var$Hi(b, g, d, l);
        $7bdba95e5cda5a33$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $7bdba95e5cda5a33$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $7bdba95e5cda5a33$var$Wf.current || $7bdba95e5cda5a33$var$jh ? ("function" === typeof m && ($7bdba95e5cda5a33$var$Di(b, c, m, d), k = b.memoizedState), (h = $7bdba95e5cda5a33$var$jh || $7bdba95e5cda5a33$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $7bdba95e5cda5a33$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $7bdba95e5cda5a33$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === (typeof k === "undefined" ? "undefined" : (0, $27SFb._)(k)) && null !== k ? k = $7bdba95e5cda5a33$var$eh(k) : (k = $7bdba95e5cda5a33$var$Zf(c) ? $7bdba95e5cda5a33$var$Xf : $7bdba95e5cda5a33$var$H.current, k = $7bdba95e5cda5a33$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $7bdba95e5cda5a33$var$Hi(b, g, d, k);
        $7bdba95e5cda5a33$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $7bdba95e5cda5a33$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $7bdba95e5cda5a33$var$Wf.current || $7bdba95e5cda5a33$var$jh ? ("function" === typeof y && ($7bdba95e5cda5a33$var$Di(b, c, y, d), n = b.memoizedState), (l = $7bdba95e5cda5a33$var$jh || $7bdba95e5cda5a33$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $7bdba95e5cda5a33$var$jj(a, b, c, d, f, e);
}
function $7bdba95e5cda5a33$var$jj(a, b, c, d, e, f) {
    $7bdba95e5cda5a33$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $7bdba95e5cda5a33$var$dg(b, c, !1), $7bdba95e5cda5a33$var$Zi(a, b, f);
    d = b.stateNode;
    $7bdba95e5cda5a33$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $7bdba95e5cda5a33$var$Ug(b, a.child, null, f), b.child = $7bdba95e5cda5a33$var$Ug(b, null, h, f)) : $7bdba95e5cda5a33$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $7bdba95e5cda5a33$var$dg(b, c, !0);
    return b.child;
}
function $7bdba95e5cda5a33$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $7bdba95e5cda5a33$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $7bdba95e5cda5a33$var$ag(a, b.context, !1);
    $7bdba95e5cda5a33$var$yh(a, b.containerInfo);
}
function $7bdba95e5cda5a33$var$lj(a, b, c, d, e) {
    $7bdba95e5cda5a33$var$Ig();
    $7bdba95e5cda5a33$var$Jg(e);
    b.flags |= 256;
    $7bdba95e5cda5a33$var$Xi(a, b, c, d);
    return b.child;
}
var $7bdba95e5cda5a33$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $7bdba95e5cda5a33$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $7bdba95e5cda5a33$var$oj(a, b, c) {
    var d = b.pendingProps, e = $7bdba95e5cda5a33$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$L, e & 1);
    if (null === a) {
        $7bdba95e5cda5a33$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $7bdba95e5cda5a33$var$pj(g, d, 0, null), a = $7bdba95e5cda5a33$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $7bdba95e5cda5a33$var$nj(c), b.memoizedState = $7bdba95e5cda5a33$var$mj, a) : $7bdba95e5cda5a33$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $7bdba95e5cda5a33$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $7bdba95e5cda5a33$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $7bdba95e5cda5a33$var$Pg(h, f) : (f = $7bdba95e5cda5a33$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $7bdba95e5cda5a33$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $7bdba95e5cda5a33$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $7bdba95e5cda5a33$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $7bdba95e5cda5a33$var$qj(a, b) {
    b = $7bdba95e5cda5a33$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $7bdba95e5cda5a33$var$sj(a, b, c, d) {
    null !== d && $7bdba95e5cda5a33$var$Jg(d);
    $7bdba95e5cda5a33$var$Ug(b, a.child, null, c);
    a = $7bdba95e5cda5a33$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $7bdba95e5cda5a33$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $7bdba95e5cda5a33$var$Ki(Error($7bdba95e5cda5a33$var$p(422))), $7bdba95e5cda5a33$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $7bdba95e5cda5a33$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $7bdba95e5cda5a33$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $7bdba95e5cda5a33$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $7bdba95e5cda5a33$var$nj(g);
        b.memoizedState = $7bdba95e5cda5a33$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $7bdba95e5cda5a33$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($7bdba95e5cda5a33$var$p(419));
        d = $7bdba95e5cda5a33$var$Ki(f, d, void 0);
        return $7bdba95e5cda5a33$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($7bdba95e5cda5a33$var$dh || h) {
        d = $7bdba95e5cda5a33$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $7bdba95e5cda5a33$var$ih(a, e), $7bdba95e5cda5a33$var$gi(d, a, e, -1));
        }
        $7bdba95e5cda5a33$var$tj();
        d = $7bdba95e5cda5a33$var$Ki(Error($7bdba95e5cda5a33$var$p(421)));
        return $7bdba95e5cda5a33$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $7bdba95e5cda5a33$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $7bdba95e5cda5a33$var$yg = $7bdba95e5cda5a33$var$Lf(e.nextSibling);
    $7bdba95e5cda5a33$var$xg = b;
    $7bdba95e5cda5a33$var$I = !0;
    $7bdba95e5cda5a33$var$zg = null;
    null !== a && ($7bdba95e5cda5a33$var$og[$7bdba95e5cda5a33$var$pg++] = $7bdba95e5cda5a33$var$rg, $7bdba95e5cda5a33$var$og[$7bdba95e5cda5a33$var$pg++] = $7bdba95e5cda5a33$var$sg, $7bdba95e5cda5a33$var$og[$7bdba95e5cda5a33$var$pg++] = $7bdba95e5cda5a33$var$qg, $7bdba95e5cda5a33$var$rg = a.id, $7bdba95e5cda5a33$var$sg = a.overflow, $7bdba95e5cda5a33$var$qg = b);
    b = $7bdba95e5cda5a33$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $7bdba95e5cda5a33$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $7bdba95e5cda5a33$var$bh(a.return, b, c);
}
function $7bdba95e5cda5a33$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $7bdba95e5cda5a33$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $7bdba95e5cda5a33$var$Xi(a, b, d.children, c);
    d = $7bdba95e5cda5a33$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $7bdba95e5cda5a33$var$vj(a, c, b);
            else if (19 === a.tag) $7bdba95e5cda5a33$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $7bdba95e5cda5a33$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $7bdba95e5cda5a33$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $7bdba95e5cda5a33$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $7bdba95e5cda5a33$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $7bdba95e5cda5a33$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $7bdba95e5cda5a33$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $7bdba95e5cda5a33$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $7bdba95e5cda5a33$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($7bdba95e5cda5a33$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $7bdba95e5cda5a33$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $7bdba95e5cda5a33$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $7bdba95e5cda5a33$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $7bdba95e5cda5a33$var$kj(b);
            $7bdba95e5cda5a33$var$Ig();
            break;
        case 5:
            $7bdba95e5cda5a33$var$Ah(b);
            break;
        case 1:
            $7bdba95e5cda5a33$var$Zf(b.type) && $7bdba95e5cda5a33$var$cg(b);
            break;
        case 4:
            $7bdba95e5cda5a33$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$L, $7bdba95e5cda5a33$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $7bdba95e5cda5a33$var$oj(a, b, c);
                $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$L, $7bdba95e5cda5a33$var$L.current & 1);
                a = $7bdba95e5cda5a33$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$L, $7bdba95e5cda5a33$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $7bdba95e5cda5a33$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$L, $7bdba95e5cda5a33$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $7bdba95e5cda5a33$var$dj(a, b, c);
    }
    return $7bdba95e5cda5a33$var$Zi(a, b, c);
}
var $7bdba95e5cda5a33$var$zj, $7bdba95e5cda5a33$var$Aj, $7bdba95e5cda5a33$var$Bj, $7bdba95e5cda5a33$var$Cj;
$7bdba95e5cda5a33$var$zj = function zj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$7bdba95e5cda5a33$var$Aj = function Aj() {};
$7bdba95e5cda5a33$var$Bj = function Bj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $7bdba95e5cda5a33$var$xh($7bdba95e5cda5a33$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $7bdba95e5cda5a33$var$Ya(a, e);
                d = $7bdba95e5cda5a33$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $7bdba95e5cda5a33$var$A({}, e, {
                    value: void 0
                });
                d = $7bdba95e5cda5a33$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $7bdba95e5cda5a33$var$gb(a, e);
                d = $7bdba95e5cda5a33$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $7bdba95e5cda5a33$var$Bf);
        }
        $7bdba95e5cda5a33$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($7bdba95e5cda5a33$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($7bdba95e5cda5a33$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $7bdba95e5cda5a33$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$7bdba95e5cda5a33$var$Cj = function Cj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $7bdba95e5cda5a33$var$Dj(a, b) {
    if (!$7bdba95e5cda5a33$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $7bdba95e5cda5a33$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $7bdba95e5cda5a33$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $7bdba95e5cda5a33$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $7bdba95e5cda5a33$var$S(b), null;
        case 1:
            return $7bdba95e5cda5a33$var$Zf(b.type) && $7bdba95e5cda5a33$var$$f(), $7bdba95e5cda5a33$var$S(b), null;
        case 3:
            d = b.stateNode;
            $7bdba95e5cda5a33$var$zh();
            $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$Wf);
            $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$H);
            $7bdba95e5cda5a33$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $7bdba95e5cda5a33$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $7bdba95e5cda5a33$var$zg && ($7bdba95e5cda5a33$var$Fj($7bdba95e5cda5a33$var$zg), $7bdba95e5cda5a33$var$zg = null));
            $7bdba95e5cda5a33$var$Aj(a, b);
            $7bdba95e5cda5a33$var$S(b);
            return null;
        case 5:
            $7bdba95e5cda5a33$var$Bh(b);
            var e = $7bdba95e5cda5a33$var$xh($7bdba95e5cda5a33$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $7bdba95e5cda5a33$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($7bdba95e5cda5a33$var$p(166));
                    $7bdba95e5cda5a33$var$S(b);
                    return null;
                }
                a = $7bdba95e5cda5a33$var$xh($7bdba95e5cda5a33$var$uh.current);
                if ($7bdba95e5cda5a33$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$7bdba95e5cda5a33$var$Of] = b;
                    d[$7bdba95e5cda5a33$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $7bdba95e5cda5a33$var$D("cancel", d);
                            $7bdba95e5cda5a33$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $7bdba95e5cda5a33$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $7bdba95e5cda5a33$var$lf.length; e++)$7bdba95e5cda5a33$var$D($7bdba95e5cda5a33$var$lf[e], d);
                            break;
                        case "source":
                            $7bdba95e5cda5a33$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $7bdba95e5cda5a33$var$D("error", d);
                            $7bdba95e5cda5a33$var$D("load", d);
                            break;
                        case "details":
                            $7bdba95e5cda5a33$var$D("toggle", d);
                            break;
                        case "input":
                            $7bdba95e5cda5a33$var$Za(d, f);
                            $7bdba95e5cda5a33$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $7bdba95e5cda5a33$var$D("invalid", d);
                            break;
                        case "textarea":
                            $7bdba95e5cda5a33$var$hb(d, f), $7bdba95e5cda5a33$var$D("invalid", d);
                    }
                    $7bdba95e5cda5a33$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $7bdba95e5cda5a33$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $7bdba95e5cda5a33$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $7bdba95e5cda5a33$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $7bdba95e5cda5a33$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $7bdba95e5cda5a33$var$Va(d);
                            $7bdba95e5cda5a33$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $7bdba95e5cda5a33$var$Va(d);
                            $7bdba95e5cda5a33$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $7bdba95e5cda5a33$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $7bdba95e5cda5a33$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$7bdba95e5cda5a33$var$Of] = b;
                    a[$7bdba95e5cda5a33$var$Pf] = d;
                    $7bdba95e5cda5a33$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $7bdba95e5cda5a33$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $7bdba95e5cda5a33$var$D("cancel", a);
                                $7bdba95e5cda5a33$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $7bdba95e5cda5a33$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $7bdba95e5cda5a33$var$lf.length; e++)$7bdba95e5cda5a33$var$D($7bdba95e5cda5a33$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $7bdba95e5cda5a33$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $7bdba95e5cda5a33$var$D("error", a);
                                $7bdba95e5cda5a33$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $7bdba95e5cda5a33$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $7bdba95e5cda5a33$var$Za(a, d);
                                e = $7bdba95e5cda5a33$var$Ya(a, d);
                                $7bdba95e5cda5a33$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $7bdba95e5cda5a33$var$A({}, d, {
                                    value: void 0
                                });
                                $7bdba95e5cda5a33$var$D("invalid", a);
                                break;
                            case "textarea":
                                $7bdba95e5cda5a33$var$hb(a, d);
                                e = $7bdba95e5cda5a33$var$gb(a, d);
                                $7bdba95e5cda5a33$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $7bdba95e5cda5a33$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $7bdba95e5cda5a33$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $7bdba95e5cda5a33$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $7bdba95e5cda5a33$var$ob(a, k) : "number" === typeof k && $7bdba95e5cda5a33$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($7bdba95e5cda5a33$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $7bdba95e5cda5a33$var$D("scroll", a) : null != k && $7bdba95e5cda5a33$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $7bdba95e5cda5a33$var$Va(a);
                                $7bdba95e5cda5a33$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $7bdba95e5cda5a33$var$Va(a);
                                $7bdba95e5cda5a33$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $7bdba95e5cda5a33$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $7bdba95e5cda5a33$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $7bdba95e5cda5a33$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $7bdba95e5cda5a33$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $7bdba95e5cda5a33$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $7bdba95e5cda5a33$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($7bdba95e5cda5a33$var$p(166));
                c = $7bdba95e5cda5a33$var$xh($7bdba95e5cda5a33$var$wh.current);
                $7bdba95e5cda5a33$var$xh($7bdba95e5cda5a33$var$uh.current);
                if ($7bdba95e5cda5a33$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$7bdba95e5cda5a33$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $7bdba95e5cda5a33$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $7bdba95e5cda5a33$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $7bdba95e5cda5a33$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$7bdba95e5cda5a33$var$Of] = b, b.stateNode = d;
            }
            $7bdba95e5cda5a33$var$S(b);
            return null;
        case 13:
            $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($7bdba95e5cda5a33$var$I && null !== $7bdba95e5cda5a33$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $7bdba95e5cda5a33$var$Hg(), $7bdba95e5cda5a33$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $7bdba95e5cda5a33$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($7bdba95e5cda5a33$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($7bdba95e5cda5a33$var$p(317));
                        f[$7bdba95e5cda5a33$var$Of] = b;
                    } else $7bdba95e5cda5a33$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $7bdba95e5cda5a33$var$S(b);
                    f = !1;
                } else null !== $7bdba95e5cda5a33$var$zg && ($7bdba95e5cda5a33$var$Fj($7bdba95e5cda5a33$var$zg), $7bdba95e5cda5a33$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($7bdba95e5cda5a33$var$L.current & 1) ? 0 === $7bdba95e5cda5a33$var$T && ($7bdba95e5cda5a33$var$T = 3) : $7bdba95e5cda5a33$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $7bdba95e5cda5a33$var$S(b);
            return null;
        case 4:
            return $7bdba95e5cda5a33$var$zh(), $7bdba95e5cda5a33$var$Aj(a, b), null === a && $7bdba95e5cda5a33$var$sf(b.stateNode.containerInfo), $7bdba95e5cda5a33$var$S(b), null;
        case 10:
            return $7bdba95e5cda5a33$var$ah(b.type._context), $7bdba95e5cda5a33$var$S(b), null;
        case 17:
            return $7bdba95e5cda5a33$var$Zf(b.type) && $7bdba95e5cda5a33$var$$f(), $7bdba95e5cda5a33$var$S(b), null;
        case 19:
            $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$L);
            f = b.memoizedState;
            if (null === f) return $7bdba95e5cda5a33$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $7bdba95e5cda5a33$var$Dj(f, !1);
                else {
                    if (0 !== $7bdba95e5cda5a33$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $7bdba95e5cda5a33$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $7bdba95e5cda5a33$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$L, $7bdba95e5cda5a33$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $7bdba95e5cda5a33$var$B() > $7bdba95e5cda5a33$var$Gj && (b.flags |= 128, d = !0, $7bdba95e5cda5a33$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $7bdba95e5cda5a33$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $7bdba95e5cda5a33$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$7bdba95e5cda5a33$var$I) return $7bdba95e5cda5a33$var$S(b), null;
                    } else 2 * $7bdba95e5cda5a33$var$B() - f.renderingStartTime > $7bdba95e5cda5a33$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $7bdba95e5cda5a33$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $7bdba95e5cda5a33$var$B(), b.sibling = null, c = $7bdba95e5cda5a33$var$L.current, $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$L, d ? c & 1 | 2 : c & 1), b;
            $7bdba95e5cda5a33$var$S(b);
            return null;
        case 22:
        case 23:
            return $7bdba95e5cda5a33$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($7bdba95e5cda5a33$var$fj & 1073741824) && ($7bdba95e5cda5a33$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $7bdba95e5cda5a33$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($7bdba95e5cda5a33$var$p(156, b.tag));
}
function $7bdba95e5cda5a33$var$Ij(a, b) {
    $7bdba95e5cda5a33$var$wg(b);
    switch(b.tag){
        case 1:
            return $7bdba95e5cda5a33$var$Zf(b.type) && $7bdba95e5cda5a33$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $7bdba95e5cda5a33$var$zh(), $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$Wf), $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$H), $7bdba95e5cda5a33$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $7bdba95e5cda5a33$var$Bh(b), null;
        case 13:
            $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($7bdba95e5cda5a33$var$p(340));
                $7bdba95e5cda5a33$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$L), null;
        case 4:
            return $7bdba95e5cda5a33$var$zh(), null;
        case 10:
            return $7bdba95e5cda5a33$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $7bdba95e5cda5a33$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $7bdba95e5cda5a33$var$Jj = !1, $7bdba95e5cda5a33$var$U = !1, $7bdba95e5cda5a33$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $7bdba95e5cda5a33$var$V = null;
function $7bdba95e5cda5a33$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $7bdba95e5cda5a33$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $7bdba95e5cda5a33$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $7bdba95e5cda5a33$var$W(a, b, d);
    }
}
var $7bdba95e5cda5a33$var$Nj = !1;
function $7bdba95e5cda5a33$var$Oj(a, b) {
    $7bdba95e5cda5a33$var$Cf = $7bdba95e5cda5a33$var$dd;
    a = $7bdba95e5cda5a33$var$Me();
    if ($7bdba95e5cda5a33$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $7bdba95e5cda5a33$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $7bdba95e5cda5a33$var$dd = !1;
    for($7bdba95e5cda5a33$var$V = b; null !== $7bdba95e5cda5a33$var$V;)if (b = $7bdba95e5cda5a33$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $7bdba95e5cda5a33$var$V = a;
    else for(; null !== $7bdba95e5cda5a33$var$V;){
        b = $7bdba95e5cda5a33$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $7bdba95e5cda5a33$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($7bdba95e5cda5a33$var$p(163));
            }
        } catch (F) {
            $7bdba95e5cda5a33$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $7bdba95e5cda5a33$var$V = a;
            break;
        }
        $7bdba95e5cda5a33$var$V = b.return;
    }
    n = $7bdba95e5cda5a33$var$Nj;
    $7bdba95e5cda5a33$var$Nj = !1;
    return n;
}
function $7bdba95e5cda5a33$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $7bdba95e5cda5a33$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $7bdba95e5cda5a33$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $7bdba95e5cda5a33$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $7bdba95e5cda5a33$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $7bdba95e5cda5a33$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$7bdba95e5cda5a33$var$Of], delete b[$7bdba95e5cda5a33$var$Pf], delete b[$7bdba95e5cda5a33$var$of], delete b[$7bdba95e5cda5a33$var$Qf], delete b[$7bdba95e5cda5a33$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $7bdba95e5cda5a33$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $7bdba95e5cda5a33$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $7bdba95e5cda5a33$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $7bdba95e5cda5a33$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $7bdba95e5cda5a33$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($7bdba95e5cda5a33$var$Vj(a, b, c), a = a.sibling; null !== a;)$7bdba95e5cda5a33$var$Vj(a, b, c), a = a.sibling;
}
function $7bdba95e5cda5a33$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($7bdba95e5cda5a33$var$Wj(a, b, c), a = a.sibling; null !== a;)$7bdba95e5cda5a33$var$Wj(a, b, c), a = a.sibling;
}
var $7bdba95e5cda5a33$var$X = null, $7bdba95e5cda5a33$var$Xj = !1;
function $7bdba95e5cda5a33$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$7bdba95e5cda5a33$var$Zj(a, b, c), c = c.sibling;
}
function $7bdba95e5cda5a33$var$Zj(a, b, c) {
    if ($7bdba95e5cda5a33$var$lc && "function" === typeof $7bdba95e5cda5a33$var$lc.onCommitFiberUnmount) try {
        $7bdba95e5cda5a33$var$lc.onCommitFiberUnmount($7bdba95e5cda5a33$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $7bdba95e5cda5a33$var$U || $7bdba95e5cda5a33$var$Lj(c, b);
        case 6:
            var d = $7bdba95e5cda5a33$var$X, e = $7bdba95e5cda5a33$var$Xj;
            $7bdba95e5cda5a33$var$X = null;
            $7bdba95e5cda5a33$var$Yj(a, b, c);
            $7bdba95e5cda5a33$var$X = d;
            $7bdba95e5cda5a33$var$Xj = e;
            null !== $7bdba95e5cda5a33$var$X && ($7bdba95e5cda5a33$var$Xj ? (a = $7bdba95e5cda5a33$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $7bdba95e5cda5a33$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $7bdba95e5cda5a33$var$X && ($7bdba95e5cda5a33$var$Xj ? (a = $7bdba95e5cda5a33$var$X, c = c.stateNode, 8 === a.nodeType ? $7bdba95e5cda5a33$var$Kf(a.parentNode, c) : 1 === a.nodeType && $7bdba95e5cda5a33$var$Kf(a, c), $7bdba95e5cda5a33$var$bd(a)) : $7bdba95e5cda5a33$var$Kf($7bdba95e5cda5a33$var$X, c.stateNode));
            break;
        case 4:
            d = $7bdba95e5cda5a33$var$X;
            e = $7bdba95e5cda5a33$var$Xj;
            $7bdba95e5cda5a33$var$X = c.stateNode.containerInfo;
            $7bdba95e5cda5a33$var$Xj = !0;
            $7bdba95e5cda5a33$var$Yj(a, b, c);
            $7bdba95e5cda5a33$var$X = d;
            $7bdba95e5cda5a33$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$7bdba95e5cda5a33$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $7bdba95e5cda5a33$var$Mj(c, b, g) : 0 !== (f & 4) && $7bdba95e5cda5a33$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $7bdba95e5cda5a33$var$Yj(a, b, c);
            break;
        case 1:
            if (!$7bdba95e5cda5a33$var$U && ($7bdba95e5cda5a33$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $7bdba95e5cda5a33$var$W(c, b, h);
            }
            $7bdba95e5cda5a33$var$Yj(a, b, c);
            break;
        case 21:
            $7bdba95e5cda5a33$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($7bdba95e5cda5a33$var$U = (d = $7bdba95e5cda5a33$var$U) || null !== c.memoizedState, $7bdba95e5cda5a33$var$Yj(a, b, c), $7bdba95e5cda5a33$var$U = d) : $7bdba95e5cda5a33$var$Yj(a, b, c);
            break;
        default:
            $7bdba95e5cda5a33$var$Yj(a, b, c);
    }
}
function $7bdba95e5cda5a33$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $7bdba95e5cda5a33$var$Kj);
        b.forEach(function(b) {
            var d = $7bdba95e5cda5a33$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $7bdba95e5cda5a33$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $7bdba95e5cda5a33$var$X = h.stateNode;
                        $7bdba95e5cda5a33$var$Xj = !1;
                        break a;
                    case 3:
                        $7bdba95e5cda5a33$var$X = h.stateNode.containerInfo;
                        $7bdba95e5cda5a33$var$Xj = !0;
                        break a;
                    case 4:
                        $7bdba95e5cda5a33$var$X = h.stateNode.containerInfo;
                        $7bdba95e5cda5a33$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $7bdba95e5cda5a33$var$X) throw Error($7bdba95e5cda5a33$var$p(160));
            $7bdba95e5cda5a33$var$Zj(f, g, e);
            $7bdba95e5cda5a33$var$X = null;
            $7bdba95e5cda5a33$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $7bdba95e5cda5a33$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$7bdba95e5cda5a33$var$dk(b, a), b = b.sibling;
}
function $7bdba95e5cda5a33$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $7bdba95e5cda5a33$var$ck(b, a);
            $7bdba95e5cda5a33$var$ek(a);
            if (d & 4) {
                try {
                    $7bdba95e5cda5a33$var$Pj(3, a, a.return), $7bdba95e5cda5a33$var$Qj(3, a);
                } catch (t) {
                    $7bdba95e5cda5a33$var$W(a, a.return, t);
                }
                try {
                    $7bdba95e5cda5a33$var$Pj(5, a, a.return);
                } catch (t) {
                    $7bdba95e5cda5a33$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $7bdba95e5cda5a33$var$ck(b, a);
            $7bdba95e5cda5a33$var$ek(a);
            d & 512 && null !== c && $7bdba95e5cda5a33$var$Lj(c, c.return);
            break;
        case 5:
            $7bdba95e5cda5a33$var$ck(b, a);
            $7bdba95e5cda5a33$var$ek(a);
            d & 512 && null !== c && $7bdba95e5cda5a33$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $7bdba95e5cda5a33$var$ob(e, "");
                } catch (t) {
                    $7bdba95e5cda5a33$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $7bdba95e5cda5a33$var$ab(e, f);
                    $7bdba95e5cda5a33$var$vb(h, g);
                    var l = $7bdba95e5cda5a33$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $7bdba95e5cda5a33$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $7bdba95e5cda5a33$var$nb(e, q) : "children" === m ? $7bdba95e5cda5a33$var$ob(e, q) : $7bdba95e5cda5a33$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $7bdba95e5cda5a33$var$bb(e, f);
                            break;
                        case "textarea":
                            $7bdba95e5cda5a33$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $7bdba95e5cda5a33$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $7bdba95e5cda5a33$var$fb(e, !!f.multiple, f.defaultValue, !0) : $7bdba95e5cda5a33$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$7bdba95e5cda5a33$var$Pf] = f;
                } catch (t) {
                    $7bdba95e5cda5a33$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $7bdba95e5cda5a33$var$ck(b, a);
            $7bdba95e5cda5a33$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($7bdba95e5cda5a33$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $7bdba95e5cda5a33$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $7bdba95e5cda5a33$var$ck(b, a);
            $7bdba95e5cda5a33$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $7bdba95e5cda5a33$var$bd(b.containerInfo);
            } catch (t) {
                $7bdba95e5cda5a33$var$W(a, a.return, t);
            }
            break;
        case 4:
            $7bdba95e5cda5a33$var$ck(b, a);
            $7bdba95e5cda5a33$var$ek(a);
            break;
        case 13:
            $7bdba95e5cda5a33$var$ck(b, a);
            $7bdba95e5cda5a33$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($7bdba95e5cda5a33$var$fk = $7bdba95e5cda5a33$var$B()));
            d & 4 && $7bdba95e5cda5a33$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($7bdba95e5cda5a33$var$U = (l = $7bdba95e5cda5a33$var$U) || m, $7bdba95e5cda5a33$var$ck(b, a), $7bdba95e5cda5a33$var$U = l) : $7bdba95e5cda5a33$var$ck(b, a);
            $7bdba95e5cda5a33$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($7bdba95e5cda5a33$var$V = a, m = a.child; null !== m;){
                    for(q = $7bdba95e5cda5a33$var$V = m; null !== $7bdba95e5cda5a33$var$V;){
                        r = $7bdba95e5cda5a33$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $7bdba95e5cda5a33$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $7bdba95e5cda5a33$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $7bdba95e5cda5a33$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $7bdba95e5cda5a33$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $7bdba95e5cda5a33$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $7bdba95e5cda5a33$var$V = y) : $7bdba95e5cda5a33$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $7bdba95e5cda5a33$var$rb("display", g));
                            } catch (t) {
                                $7bdba95e5cda5a33$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $7bdba95e5cda5a33$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $7bdba95e5cda5a33$var$ck(b, a);
            $7bdba95e5cda5a33$var$ek(a);
            d & 4 && $7bdba95e5cda5a33$var$ak(a);
            break;
        case 21:
            break;
        default:
            $7bdba95e5cda5a33$var$ck(b, a), $7bdba95e5cda5a33$var$ek(a);
    }
}
function $7bdba95e5cda5a33$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($7bdba95e5cda5a33$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($7bdba95e5cda5a33$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($7bdba95e5cda5a33$var$ob(e, ""), d.flags &= -33);
                    var f = $7bdba95e5cda5a33$var$Uj(a);
                    $7bdba95e5cda5a33$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $7bdba95e5cda5a33$var$Uj(a);
                    $7bdba95e5cda5a33$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($7bdba95e5cda5a33$var$p(161));
            }
        } catch (k) {
            $7bdba95e5cda5a33$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $7bdba95e5cda5a33$var$hk(a, b, c) {
    $7bdba95e5cda5a33$var$V = a;
    $7bdba95e5cda5a33$var$ik(a, b, c);
}
function $7bdba95e5cda5a33$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $7bdba95e5cda5a33$var$V;){
        var e = $7bdba95e5cda5a33$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $7bdba95e5cda5a33$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $7bdba95e5cda5a33$var$U;
                h = $7bdba95e5cda5a33$var$Jj;
                var l = $7bdba95e5cda5a33$var$U;
                $7bdba95e5cda5a33$var$Jj = g;
                if (($7bdba95e5cda5a33$var$U = k) && !l) for($7bdba95e5cda5a33$var$V = e; null !== $7bdba95e5cda5a33$var$V;)g = $7bdba95e5cda5a33$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $7bdba95e5cda5a33$var$jk(e) : null !== k ? (k.return = g, $7bdba95e5cda5a33$var$V = k) : $7bdba95e5cda5a33$var$jk(e);
                for(; null !== f;)$7bdba95e5cda5a33$var$V = f, $7bdba95e5cda5a33$var$ik(f, b, c), f = f.sibling;
                $7bdba95e5cda5a33$var$V = e;
                $7bdba95e5cda5a33$var$Jj = h;
                $7bdba95e5cda5a33$var$U = l;
            }
            $7bdba95e5cda5a33$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $7bdba95e5cda5a33$var$V = f) : $7bdba95e5cda5a33$var$kk(a, b, c);
    }
}
function $7bdba95e5cda5a33$var$kk(a) {
    for(; null !== $7bdba95e5cda5a33$var$V;){
        var b = $7bdba95e5cda5a33$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $7bdba95e5cda5a33$var$U || $7bdba95e5cda5a33$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$7bdba95e5cda5a33$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $7bdba95e5cda5a33$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $7bdba95e5cda5a33$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $7bdba95e5cda5a33$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $7bdba95e5cda5a33$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($7bdba95e5cda5a33$var$p(163));
                }
                $7bdba95e5cda5a33$var$U || b.flags & 512 && $7bdba95e5cda5a33$var$Rj(b);
            } catch (r) {
                $7bdba95e5cda5a33$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $7bdba95e5cda5a33$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $7bdba95e5cda5a33$var$V = c;
            break;
        }
        $7bdba95e5cda5a33$var$V = b.return;
    }
}
function $7bdba95e5cda5a33$var$gk(a) {
    for(; null !== $7bdba95e5cda5a33$var$V;){
        var b = $7bdba95e5cda5a33$var$V;
        if (b === a) {
            $7bdba95e5cda5a33$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $7bdba95e5cda5a33$var$V = c;
            break;
        }
        $7bdba95e5cda5a33$var$V = b.return;
    }
}
function $7bdba95e5cda5a33$var$jk(a) {
    for(; null !== $7bdba95e5cda5a33$var$V;){
        var b = $7bdba95e5cda5a33$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $7bdba95e5cda5a33$var$Qj(4, b);
                    } catch (k) {
                        $7bdba95e5cda5a33$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $7bdba95e5cda5a33$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $7bdba95e5cda5a33$var$Rj(b);
                    } catch (k) {
                        $7bdba95e5cda5a33$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $7bdba95e5cda5a33$var$Rj(b);
                    } catch (k) {
                        $7bdba95e5cda5a33$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $7bdba95e5cda5a33$var$W(b, b.return, k);
        }
        if (b === a) {
            $7bdba95e5cda5a33$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $7bdba95e5cda5a33$var$V = h;
            break;
        }
        $7bdba95e5cda5a33$var$V = b.return;
    }
}
var $7bdba95e5cda5a33$var$lk = Math.ceil, $7bdba95e5cda5a33$var$mk = $7bdba95e5cda5a33$var$ua.ReactCurrentDispatcher, $7bdba95e5cda5a33$var$nk = $7bdba95e5cda5a33$var$ua.ReactCurrentOwner, $7bdba95e5cda5a33$var$ok = $7bdba95e5cda5a33$var$ua.ReactCurrentBatchConfig, $7bdba95e5cda5a33$var$K = 0, $7bdba95e5cda5a33$var$Q = null, $7bdba95e5cda5a33$var$Y = null, $7bdba95e5cda5a33$var$Z = 0, $7bdba95e5cda5a33$var$fj = 0, $7bdba95e5cda5a33$var$ej = $7bdba95e5cda5a33$var$Uf(0), $7bdba95e5cda5a33$var$T = 0, $7bdba95e5cda5a33$var$pk = null, $7bdba95e5cda5a33$var$rh = 0, $7bdba95e5cda5a33$var$qk = 0, $7bdba95e5cda5a33$var$rk = 0, $7bdba95e5cda5a33$var$sk = null, $7bdba95e5cda5a33$var$tk = null, $7bdba95e5cda5a33$var$fk = 0, $7bdba95e5cda5a33$var$Gj = Infinity, $7bdba95e5cda5a33$var$uk = null, $7bdba95e5cda5a33$var$Oi = !1, $7bdba95e5cda5a33$var$Pi = null, $7bdba95e5cda5a33$var$Ri = null, $7bdba95e5cda5a33$var$vk = !1, $7bdba95e5cda5a33$var$wk = null, $7bdba95e5cda5a33$var$xk = 0, $7bdba95e5cda5a33$var$yk = 0, $7bdba95e5cda5a33$var$zk = null, $7bdba95e5cda5a33$var$Ak = -1, $7bdba95e5cda5a33$var$Bk = 0;
function $7bdba95e5cda5a33$var$R() {
    return 0 !== ($7bdba95e5cda5a33$var$K & 6) ? $7bdba95e5cda5a33$var$B() : -1 !== $7bdba95e5cda5a33$var$Ak ? $7bdba95e5cda5a33$var$Ak : $7bdba95e5cda5a33$var$Ak = $7bdba95e5cda5a33$var$B();
}
function $7bdba95e5cda5a33$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($7bdba95e5cda5a33$var$K & 2) && 0 !== $7bdba95e5cda5a33$var$Z) return $7bdba95e5cda5a33$var$Z & -$7bdba95e5cda5a33$var$Z;
    if (null !== $7bdba95e5cda5a33$var$Kg.transition) return 0 === $7bdba95e5cda5a33$var$Bk && ($7bdba95e5cda5a33$var$Bk = $7bdba95e5cda5a33$var$yc()), $7bdba95e5cda5a33$var$Bk;
    a = $7bdba95e5cda5a33$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $7bdba95e5cda5a33$var$jd(a.type);
    return a;
}
function $7bdba95e5cda5a33$var$gi(a, b, c, d) {
    if (50 < $7bdba95e5cda5a33$var$yk) throw $7bdba95e5cda5a33$var$yk = 0, $7bdba95e5cda5a33$var$zk = null, Error($7bdba95e5cda5a33$var$p(185));
    $7bdba95e5cda5a33$var$Ac(a, c, d);
    if (0 === ($7bdba95e5cda5a33$var$K & 2) || a !== $7bdba95e5cda5a33$var$Q) a === $7bdba95e5cda5a33$var$Q && (0 === ($7bdba95e5cda5a33$var$K & 2) && ($7bdba95e5cda5a33$var$qk |= c), 4 === $7bdba95e5cda5a33$var$T && $7bdba95e5cda5a33$var$Ck(a, $7bdba95e5cda5a33$var$Z)), $7bdba95e5cda5a33$var$Dk(a, d), 1 === c && 0 === $7bdba95e5cda5a33$var$K && 0 === (b.mode & 1) && ($7bdba95e5cda5a33$var$Gj = $7bdba95e5cda5a33$var$B() + 500, $7bdba95e5cda5a33$var$fg && $7bdba95e5cda5a33$var$jg());
}
function $7bdba95e5cda5a33$var$Dk(a, b) {
    var c = a.callbackNode;
    $7bdba95e5cda5a33$var$wc(a, b);
    var d = $7bdba95e5cda5a33$var$uc(a, a === $7bdba95e5cda5a33$var$Q ? $7bdba95e5cda5a33$var$Z : 0);
    if (0 === d) null !== c && $7bdba95e5cda5a33$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $7bdba95e5cda5a33$var$bc(c);
        if (1 === b) 0 === a.tag ? $7bdba95e5cda5a33$var$ig($7bdba95e5cda5a33$var$Ek.bind(null, a)) : $7bdba95e5cda5a33$var$hg($7bdba95e5cda5a33$var$Ek.bind(null, a)), $7bdba95e5cda5a33$var$Jf(function() {
            0 === ($7bdba95e5cda5a33$var$K & 6) && $7bdba95e5cda5a33$var$jg();
        }), c = null;
        else {
            switch($7bdba95e5cda5a33$var$Dc(d)){
                case 1:
                    c = $7bdba95e5cda5a33$var$fc;
                    break;
                case 4:
                    c = $7bdba95e5cda5a33$var$gc;
                    break;
                case 16:
                    c = $7bdba95e5cda5a33$var$hc;
                    break;
                case 536870912:
                    c = $7bdba95e5cda5a33$var$jc;
                    break;
                default:
                    c = $7bdba95e5cda5a33$var$hc;
            }
            c = $7bdba95e5cda5a33$var$Fk(c, $7bdba95e5cda5a33$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $7bdba95e5cda5a33$var$Gk(a, b) {
    $7bdba95e5cda5a33$var$Ak = -1;
    $7bdba95e5cda5a33$var$Bk = 0;
    if (0 !== ($7bdba95e5cda5a33$var$K & 6)) throw Error($7bdba95e5cda5a33$var$p(327));
    var c = a.callbackNode;
    if ($7bdba95e5cda5a33$var$Hk() && a.callbackNode !== c) return null;
    var d = $7bdba95e5cda5a33$var$uc(a, a === $7bdba95e5cda5a33$var$Q ? $7bdba95e5cda5a33$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $7bdba95e5cda5a33$var$Ik(a, d);
    else {
        b = d;
        var e = $7bdba95e5cda5a33$var$K;
        $7bdba95e5cda5a33$var$K |= 2;
        var f = $7bdba95e5cda5a33$var$Jk();
        if ($7bdba95e5cda5a33$var$Q !== a || $7bdba95e5cda5a33$var$Z !== b) $7bdba95e5cda5a33$var$uk = null, $7bdba95e5cda5a33$var$Gj = $7bdba95e5cda5a33$var$B() + 500, $7bdba95e5cda5a33$var$Kk(a, b);
        for(;;)try {
            $7bdba95e5cda5a33$var$Lk();
            break;
        } catch (h) {
            $7bdba95e5cda5a33$var$Mk(a, h);
        }
        $7bdba95e5cda5a33$var$$g();
        $7bdba95e5cda5a33$var$mk.current = f;
        $7bdba95e5cda5a33$var$K = e;
        null !== $7bdba95e5cda5a33$var$Y ? b = 0 : ($7bdba95e5cda5a33$var$Q = null, $7bdba95e5cda5a33$var$Z = 0, b = $7bdba95e5cda5a33$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $7bdba95e5cda5a33$var$xc(a), 0 !== e && (d = e, b = $7bdba95e5cda5a33$var$Nk(a, e)));
        if (1 === b) throw c = $7bdba95e5cda5a33$var$pk, $7bdba95e5cda5a33$var$Kk(a, 0), $7bdba95e5cda5a33$var$Ck(a, d), $7bdba95e5cda5a33$var$Dk(a, $7bdba95e5cda5a33$var$B()), c;
        if (6 === b) $7bdba95e5cda5a33$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$7bdba95e5cda5a33$var$Ok(e) && (b = $7bdba95e5cda5a33$var$Ik(a, d), 2 === b && (f = $7bdba95e5cda5a33$var$xc(a), 0 !== f && (d = f, b = $7bdba95e5cda5a33$var$Nk(a, f))), 1 === b)) throw c = $7bdba95e5cda5a33$var$pk, $7bdba95e5cda5a33$var$Kk(a, 0), $7bdba95e5cda5a33$var$Ck(a, d), $7bdba95e5cda5a33$var$Dk(a, $7bdba95e5cda5a33$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($7bdba95e5cda5a33$var$p(345));
                case 2:
                    $7bdba95e5cda5a33$var$Pk(a, $7bdba95e5cda5a33$var$tk, $7bdba95e5cda5a33$var$uk);
                    break;
                case 3:
                    $7bdba95e5cda5a33$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $7bdba95e5cda5a33$var$fk + 500 - $7bdba95e5cda5a33$var$B(), 10 < b)) {
                        if (0 !== $7bdba95e5cda5a33$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $7bdba95e5cda5a33$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $7bdba95e5cda5a33$var$Ff($7bdba95e5cda5a33$var$Pk.bind(null, a, $7bdba95e5cda5a33$var$tk, $7bdba95e5cda5a33$var$uk), b);
                        break;
                    }
                    $7bdba95e5cda5a33$var$Pk(a, $7bdba95e5cda5a33$var$tk, $7bdba95e5cda5a33$var$uk);
                    break;
                case 4:
                    $7bdba95e5cda5a33$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $7bdba95e5cda5a33$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $7bdba95e5cda5a33$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $7bdba95e5cda5a33$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $7bdba95e5cda5a33$var$Ff($7bdba95e5cda5a33$var$Pk.bind(null, a, $7bdba95e5cda5a33$var$tk, $7bdba95e5cda5a33$var$uk), d);
                        break;
                    }
                    $7bdba95e5cda5a33$var$Pk(a, $7bdba95e5cda5a33$var$tk, $7bdba95e5cda5a33$var$uk);
                    break;
                case 5:
                    $7bdba95e5cda5a33$var$Pk(a, $7bdba95e5cda5a33$var$tk, $7bdba95e5cda5a33$var$uk);
                    break;
                default:
                    throw Error($7bdba95e5cda5a33$var$p(329));
            }
        }
    }
    $7bdba95e5cda5a33$var$Dk(a, $7bdba95e5cda5a33$var$B());
    return a.callbackNode === c ? $7bdba95e5cda5a33$var$Gk.bind(null, a) : null;
}
function $7bdba95e5cda5a33$var$Nk(a, b) {
    var c = $7bdba95e5cda5a33$var$sk;
    a.current.memoizedState.isDehydrated && ($7bdba95e5cda5a33$var$Kk(a, b).flags |= 256);
    a = $7bdba95e5cda5a33$var$Ik(a, b);
    2 !== a && (b = $7bdba95e5cda5a33$var$tk, $7bdba95e5cda5a33$var$tk = c, null !== b && $7bdba95e5cda5a33$var$Fj(b));
    return a;
}
function $7bdba95e5cda5a33$var$Fj(a) {
    null === $7bdba95e5cda5a33$var$tk ? $7bdba95e5cda5a33$var$tk = a : $7bdba95e5cda5a33$var$tk.push.apply($7bdba95e5cda5a33$var$tk, a);
}
function $7bdba95e5cda5a33$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$7bdba95e5cda5a33$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $7bdba95e5cda5a33$var$Ck(a, b) {
    b &= ~$7bdba95e5cda5a33$var$rk;
    b &= ~$7bdba95e5cda5a33$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $7bdba95e5cda5a33$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $7bdba95e5cda5a33$var$Ek(a) {
    if (0 !== ($7bdba95e5cda5a33$var$K & 6)) throw Error($7bdba95e5cda5a33$var$p(327));
    $7bdba95e5cda5a33$var$Hk();
    var b = $7bdba95e5cda5a33$var$uc(a, 0);
    if (0 === (b & 1)) return $7bdba95e5cda5a33$var$Dk(a, $7bdba95e5cda5a33$var$B()), null;
    var c = $7bdba95e5cda5a33$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $7bdba95e5cda5a33$var$xc(a);
        0 !== d && (b = d, c = $7bdba95e5cda5a33$var$Nk(a, d));
    }
    if (1 === c) throw c = $7bdba95e5cda5a33$var$pk, $7bdba95e5cda5a33$var$Kk(a, 0), $7bdba95e5cda5a33$var$Ck(a, b), $7bdba95e5cda5a33$var$Dk(a, $7bdba95e5cda5a33$var$B()), c;
    if (6 === c) throw Error($7bdba95e5cda5a33$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $7bdba95e5cda5a33$var$Pk(a, $7bdba95e5cda5a33$var$tk, $7bdba95e5cda5a33$var$uk);
    $7bdba95e5cda5a33$var$Dk(a, $7bdba95e5cda5a33$var$B());
    return null;
}
function $7bdba95e5cda5a33$var$Qk(a, b) {
    var c = $7bdba95e5cda5a33$var$K;
    $7bdba95e5cda5a33$var$K |= 1;
    try {
        return a(b);
    } finally{
        $7bdba95e5cda5a33$var$K = c, 0 === $7bdba95e5cda5a33$var$K && ($7bdba95e5cda5a33$var$Gj = $7bdba95e5cda5a33$var$B() + 500, $7bdba95e5cda5a33$var$fg && $7bdba95e5cda5a33$var$jg());
    }
}
function $7bdba95e5cda5a33$var$Rk(a) {
    null !== $7bdba95e5cda5a33$var$wk && 0 === $7bdba95e5cda5a33$var$wk.tag && 0 === ($7bdba95e5cda5a33$var$K & 6) && $7bdba95e5cda5a33$var$Hk();
    var b = $7bdba95e5cda5a33$var$K;
    $7bdba95e5cda5a33$var$K |= 1;
    var c = $7bdba95e5cda5a33$var$ok.transition, d = $7bdba95e5cda5a33$var$C;
    try {
        if ($7bdba95e5cda5a33$var$ok.transition = null, $7bdba95e5cda5a33$var$C = 1, a) return a();
    } finally{
        $7bdba95e5cda5a33$var$C = d, $7bdba95e5cda5a33$var$ok.transition = c, $7bdba95e5cda5a33$var$K = b, 0 === ($7bdba95e5cda5a33$var$K & 6) && $7bdba95e5cda5a33$var$jg();
    }
}
function $7bdba95e5cda5a33$var$Hj() {
    $7bdba95e5cda5a33$var$fj = $7bdba95e5cda5a33$var$ej.current;
    $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$ej);
}
function $7bdba95e5cda5a33$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $7bdba95e5cda5a33$var$Gf(c));
    if (null !== $7bdba95e5cda5a33$var$Y) for(c = $7bdba95e5cda5a33$var$Y.return; null !== c;){
        var d = c;
        $7bdba95e5cda5a33$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $7bdba95e5cda5a33$var$$f();
                break;
            case 3:
                $7bdba95e5cda5a33$var$zh();
                $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$Wf);
                $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$H);
                $7bdba95e5cda5a33$var$Eh();
                break;
            case 5:
                $7bdba95e5cda5a33$var$Bh(d);
                break;
            case 4:
                $7bdba95e5cda5a33$var$zh();
                break;
            case 13:
                $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$L);
                break;
            case 19:
                $7bdba95e5cda5a33$var$E($7bdba95e5cda5a33$var$L);
                break;
            case 10:
                $7bdba95e5cda5a33$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $7bdba95e5cda5a33$var$Hj();
        }
        c = c.return;
    }
    $7bdba95e5cda5a33$var$Q = a;
    $7bdba95e5cda5a33$var$Y = a = $7bdba95e5cda5a33$var$Pg(a.current, null);
    $7bdba95e5cda5a33$var$Z = $7bdba95e5cda5a33$var$fj = b;
    $7bdba95e5cda5a33$var$T = 0;
    $7bdba95e5cda5a33$var$pk = null;
    $7bdba95e5cda5a33$var$rk = $7bdba95e5cda5a33$var$qk = $7bdba95e5cda5a33$var$rh = 0;
    $7bdba95e5cda5a33$var$tk = $7bdba95e5cda5a33$var$sk = null;
    if (null !== $7bdba95e5cda5a33$var$fh) {
        for(b = 0; b < $7bdba95e5cda5a33$var$fh.length; b++)if (c = $7bdba95e5cda5a33$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $7bdba95e5cda5a33$var$fh = null;
    }
    return a;
}
function $7bdba95e5cda5a33$var$Mk(a, b) {
    do {
        var c = $7bdba95e5cda5a33$var$Y;
        try {
            $7bdba95e5cda5a33$var$$g();
            $7bdba95e5cda5a33$var$Fh.current = $7bdba95e5cda5a33$var$Rh;
            if ($7bdba95e5cda5a33$var$Ih) {
                for(var d = $7bdba95e5cda5a33$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $7bdba95e5cda5a33$var$Ih = !1;
            }
            $7bdba95e5cda5a33$var$Hh = 0;
            $7bdba95e5cda5a33$var$O = $7bdba95e5cda5a33$var$N = $7bdba95e5cda5a33$var$M = null;
            $7bdba95e5cda5a33$var$Jh = !1;
            $7bdba95e5cda5a33$var$Kh = 0;
            $7bdba95e5cda5a33$var$nk.current = null;
            if (null === c || null === c.return) {
                $7bdba95e5cda5a33$var$T = 1;
                $7bdba95e5cda5a33$var$pk = b;
                $7bdba95e5cda5a33$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $7bdba95e5cda5a33$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === (typeof k === "undefined" ? "undefined" : (0, $27SFb._)(k)) && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $7bdba95e5cda5a33$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $7bdba95e5cda5a33$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $7bdba95e5cda5a33$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $7bdba95e5cda5a33$var$Si(f, l, b);
                            $7bdba95e5cda5a33$var$tj();
                            break a;
                        }
                        k = Error($7bdba95e5cda5a33$var$p(426));
                    }
                } else if ($7bdba95e5cda5a33$var$I && h.mode & 1) {
                    var J = $7bdba95e5cda5a33$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $7bdba95e5cda5a33$var$Vi(J, g, h, f, b);
                        $7bdba95e5cda5a33$var$Jg($7bdba95e5cda5a33$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $7bdba95e5cda5a33$var$Ji(k, h);
                4 !== $7bdba95e5cda5a33$var$T && ($7bdba95e5cda5a33$var$T = 2);
                null === $7bdba95e5cda5a33$var$sk ? $7bdba95e5cda5a33$var$sk = [
                    f
                ] : $7bdba95e5cda5a33$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $7bdba95e5cda5a33$var$Ni(f, k, b);
                            $7bdba95e5cda5a33$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $7bdba95e5cda5a33$var$Ri || !$7bdba95e5cda5a33$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $7bdba95e5cda5a33$var$Qi(f, h, b);
                                $7bdba95e5cda5a33$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $7bdba95e5cda5a33$var$Sk(c);
        } catch (na) {
            b = na;
            $7bdba95e5cda5a33$var$Y === c && null !== c && ($7bdba95e5cda5a33$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $7bdba95e5cda5a33$var$Jk() {
    var a = $7bdba95e5cda5a33$var$mk.current;
    $7bdba95e5cda5a33$var$mk.current = $7bdba95e5cda5a33$var$Rh;
    return null === a ? $7bdba95e5cda5a33$var$Rh : a;
}
function $7bdba95e5cda5a33$var$tj() {
    if (0 === $7bdba95e5cda5a33$var$T || 3 === $7bdba95e5cda5a33$var$T || 2 === $7bdba95e5cda5a33$var$T) $7bdba95e5cda5a33$var$T = 4;
    null === $7bdba95e5cda5a33$var$Q || 0 === ($7bdba95e5cda5a33$var$rh & 268435455) && 0 === ($7bdba95e5cda5a33$var$qk & 268435455) || $7bdba95e5cda5a33$var$Ck($7bdba95e5cda5a33$var$Q, $7bdba95e5cda5a33$var$Z);
}
function $7bdba95e5cda5a33$var$Ik(a, b) {
    var c = $7bdba95e5cda5a33$var$K;
    $7bdba95e5cda5a33$var$K |= 2;
    var d = $7bdba95e5cda5a33$var$Jk();
    if ($7bdba95e5cda5a33$var$Q !== a || $7bdba95e5cda5a33$var$Z !== b) $7bdba95e5cda5a33$var$uk = null, $7bdba95e5cda5a33$var$Kk(a, b);
    for(;;)try {
        $7bdba95e5cda5a33$var$Tk();
        break;
    } catch (e) {
        $7bdba95e5cda5a33$var$Mk(a, e);
    }
    $7bdba95e5cda5a33$var$$g();
    $7bdba95e5cda5a33$var$K = c;
    $7bdba95e5cda5a33$var$mk.current = d;
    if (null !== $7bdba95e5cda5a33$var$Y) throw Error($7bdba95e5cda5a33$var$p(261));
    $7bdba95e5cda5a33$var$Q = null;
    $7bdba95e5cda5a33$var$Z = 0;
    return $7bdba95e5cda5a33$var$T;
}
function $7bdba95e5cda5a33$var$Tk() {
    for(; null !== $7bdba95e5cda5a33$var$Y;)$7bdba95e5cda5a33$var$Uk($7bdba95e5cda5a33$var$Y);
}
function $7bdba95e5cda5a33$var$Lk() {
    for(; null !== $7bdba95e5cda5a33$var$Y && !$7bdba95e5cda5a33$var$cc();)$7bdba95e5cda5a33$var$Uk($7bdba95e5cda5a33$var$Y);
}
function $7bdba95e5cda5a33$var$Uk(a) {
    var b = $7bdba95e5cda5a33$var$Vk(a.alternate, a, $7bdba95e5cda5a33$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $7bdba95e5cda5a33$var$Sk(a) : $7bdba95e5cda5a33$var$Y = b;
    $7bdba95e5cda5a33$var$nk.current = null;
}
function $7bdba95e5cda5a33$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $7bdba95e5cda5a33$var$Ej(c, b, $7bdba95e5cda5a33$var$fj), null !== c) {
                $7bdba95e5cda5a33$var$Y = c;
                return;
            }
        } else {
            c = $7bdba95e5cda5a33$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $7bdba95e5cda5a33$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $7bdba95e5cda5a33$var$T = 6;
                $7bdba95e5cda5a33$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $7bdba95e5cda5a33$var$Y = b;
            return;
        }
        $7bdba95e5cda5a33$var$Y = b = a;
    }while (null !== b);
    0 === $7bdba95e5cda5a33$var$T && ($7bdba95e5cda5a33$var$T = 5);
}
function $7bdba95e5cda5a33$var$Pk(a, b, c) {
    var d = $7bdba95e5cda5a33$var$C, e = $7bdba95e5cda5a33$var$ok.transition;
    try {
        $7bdba95e5cda5a33$var$ok.transition = null, $7bdba95e5cda5a33$var$C = 1, $7bdba95e5cda5a33$var$Wk(a, b, c, d);
    } finally{
        $7bdba95e5cda5a33$var$ok.transition = e, $7bdba95e5cda5a33$var$C = d;
    }
    return null;
}
function $7bdba95e5cda5a33$var$Wk(a, b, c, d) {
    do $7bdba95e5cda5a33$var$Hk();
    while (null !== $7bdba95e5cda5a33$var$wk);
    if (0 !== ($7bdba95e5cda5a33$var$K & 6)) throw Error($7bdba95e5cda5a33$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($7bdba95e5cda5a33$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $7bdba95e5cda5a33$var$Bc(a, f);
    a === $7bdba95e5cda5a33$var$Q && ($7bdba95e5cda5a33$var$Y = $7bdba95e5cda5a33$var$Q = null, $7bdba95e5cda5a33$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $7bdba95e5cda5a33$var$vk || ($7bdba95e5cda5a33$var$vk = !0, $7bdba95e5cda5a33$var$Fk($7bdba95e5cda5a33$var$hc, function() {
        $7bdba95e5cda5a33$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $7bdba95e5cda5a33$var$ok.transition;
        $7bdba95e5cda5a33$var$ok.transition = null;
        var g = $7bdba95e5cda5a33$var$C;
        $7bdba95e5cda5a33$var$C = 1;
        var h = $7bdba95e5cda5a33$var$K;
        $7bdba95e5cda5a33$var$K |= 4;
        $7bdba95e5cda5a33$var$nk.current = null;
        $7bdba95e5cda5a33$var$Oj(a, c);
        $7bdba95e5cda5a33$var$dk(c, a);
        $7bdba95e5cda5a33$var$Oe($7bdba95e5cda5a33$var$Df);
        $7bdba95e5cda5a33$var$dd = !!$7bdba95e5cda5a33$var$Cf;
        $7bdba95e5cda5a33$var$Df = $7bdba95e5cda5a33$var$Cf = null;
        a.current = c;
        $7bdba95e5cda5a33$var$hk(c, a, e);
        $7bdba95e5cda5a33$var$dc();
        $7bdba95e5cda5a33$var$K = h;
        $7bdba95e5cda5a33$var$C = g;
        $7bdba95e5cda5a33$var$ok.transition = f;
    } else a.current = c;
    $7bdba95e5cda5a33$var$vk && ($7bdba95e5cda5a33$var$vk = !1, $7bdba95e5cda5a33$var$wk = a, $7bdba95e5cda5a33$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($7bdba95e5cda5a33$var$Ri = null);
    $7bdba95e5cda5a33$var$mc(c.stateNode, d);
    $7bdba95e5cda5a33$var$Dk(a, $7bdba95e5cda5a33$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($7bdba95e5cda5a33$var$Oi) throw $7bdba95e5cda5a33$var$Oi = !1, a = $7bdba95e5cda5a33$var$Pi, $7bdba95e5cda5a33$var$Pi = null, a;
    0 !== ($7bdba95e5cda5a33$var$xk & 1) && 0 !== a.tag && $7bdba95e5cda5a33$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $7bdba95e5cda5a33$var$zk ? $7bdba95e5cda5a33$var$yk++ : ($7bdba95e5cda5a33$var$yk = 0, $7bdba95e5cda5a33$var$zk = a) : $7bdba95e5cda5a33$var$yk = 0;
    $7bdba95e5cda5a33$var$jg();
    return null;
}
function $7bdba95e5cda5a33$var$Hk() {
    if (null !== $7bdba95e5cda5a33$var$wk) {
        var a = $7bdba95e5cda5a33$var$Dc($7bdba95e5cda5a33$var$xk), b = $7bdba95e5cda5a33$var$ok.transition, c = $7bdba95e5cda5a33$var$C;
        try {
            $7bdba95e5cda5a33$var$ok.transition = null;
            $7bdba95e5cda5a33$var$C = 16 > a ? 16 : a;
            if (null === $7bdba95e5cda5a33$var$wk) var d = !1;
            else {
                a = $7bdba95e5cda5a33$var$wk;
                $7bdba95e5cda5a33$var$wk = null;
                $7bdba95e5cda5a33$var$xk = 0;
                if (0 !== ($7bdba95e5cda5a33$var$K & 6)) throw Error($7bdba95e5cda5a33$var$p(331));
                var e = $7bdba95e5cda5a33$var$K;
                $7bdba95e5cda5a33$var$K |= 4;
                for($7bdba95e5cda5a33$var$V = a.current; null !== $7bdba95e5cda5a33$var$V;){
                    var f = $7bdba95e5cda5a33$var$V, g = f.child;
                    if (0 !== ($7bdba95e5cda5a33$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($7bdba95e5cda5a33$var$V = l; null !== $7bdba95e5cda5a33$var$V;){
                                    var m = $7bdba95e5cda5a33$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $7bdba95e5cda5a33$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $7bdba95e5cda5a33$var$V = q;
                                    else for(; null !== $7bdba95e5cda5a33$var$V;){
                                        m = $7bdba95e5cda5a33$var$V;
                                        var r = m.sibling, y = m.return;
                                        $7bdba95e5cda5a33$var$Sj(m);
                                        if (m === l) {
                                            $7bdba95e5cda5a33$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $7bdba95e5cda5a33$var$V = r;
                                            break;
                                        }
                                        $7bdba95e5cda5a33$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $7bdba95e5cda5a33$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $7bdba95e5cda5a33$var$V = g;
                    else b: for(; null !== $7bdba95e5cda5a33$var$V;){
                        f = $7bdba95e5cda5a33$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $7bdba95e5cda5a33$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $7bdba95e5cda5a33$var$V = x;
                            break b;
                        }
                        $7bdba95e5cda5a33$var$V = f.return;
                    }
                }
                var w = a.current;
                for($7bdba95e5cda5a33$var$V = w; null !== $7bdba95e5cda5a33$var$V;){
                    g = $7bdba95e5cda5a33$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $7bdba95e5cda5a33$var$V = u;
                    else b: for(g = w; null !== $7bdba95e5cda5a33$var$V;){
                        h = $7bdba95e5cda5a33$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $7bdba95e5cda5a33$var$Qj(9, h);
                            }
                        } catch (na) {
                            $7bdba95e5cda5a33$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $7bdba95e5cda5a33$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $7bdba95e5cda5a33$var$V = F;
                            break b;
                        }
                        $7bdba95e5cda5a33$var$V = h.return;
                    }
                }
                $7bdba95e5cda5a33$var$K = e;
                $7bdba95e5cda5a33$var$jg();
                if ($7bdba95e5cda5a33$var$lc && "function" === typeof $7bdba95e5cda5a33$var$lc.onPostCommitFiberRoot) try {
                    $7bdba95e5cda5a33$var$lc.onPostCommitFiberRoot($7bdba95e5cda5a33$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $7bdba95e5cda5a33$var$C = c, $7bdba95e5cda5a33$var$ok.transition = b;
        }
    }
    return !1;
}
function $7bdba95e5cda5a33$var$Xk(a, b, c) {
    b = $7bdba95e5cda5a33$var$Ji(c, b);
    b = $7bdba95e5cda5a33$var$Ni(a, b, 1);
    a = $7bdba95e5cda5a33$var$nh(a, b, 1);
    b = $7bdba95e5cda5a33$var$R();
    null !== a && ($7bdba95e5cda5a33$var$Ac(a, 1, b), $7bdba95e5cda5a33$var$Dk(a, b));
}
function $7bdba95e5cda5a33$var$W(a, b, c) {
    if (3 === a.tag) $7bdba95e5cda5a33$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $7bdba95e5cda5a33$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $7bdba95e5cda5a33$var$Ri || !$7bdba95e5cda5a33$var$Ri.has(d))) {
                a = $7bdba95e5cda5a33$var$Ji(c, a);
                a = $7bdba95e5cda5a33$var$Qi(b, a, 1);
                b = $7bdba95e5cda5a33$var$nh(b, a, 1);
                a = $7bdba95e5cda5a33$var$R();
                null !== b && ($7bdba95e5cda5a33$var$Ac(b, 1, a), $7bdba95e5cda5a33$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $7bdba95e5cda5a33$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $7bdba95e5cda5a33$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $7bdba95e5cda5a33$var$Q === a && ($7bdba95e5cda5a33$var$Z & c) === c && (4 === $7bdba95e5cda5a33$var$T || 3 === $7bdba95e5cda5a33$var$T && ($7bdba95e5cda5a33$var$Z & 130023424) === $7bdba95e5cda5a33$var$Z && 500 > $7bdba95e5cda5a33$var$B() - $7bdba95e5cda5a33$var$fk ? $7bdba95e5cda5a33$var$Kk(a, 0) : $7bdba95e5cda5a33$var$rk |= c);
    $7bdba95e5cda5a33$var$Dk(a, b);
}
function $7bdba95e5cda5a33$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $7bdba95e5cda5a33$var$sc, $7bdba95e5cda5a33$var$sc <<= 1, 0 === ($7bdba95e5cda5a33$var$sc & 130023424) && ($7bdba95e5cda5a33$var$sc = 4194304)));
    var c = $7bdba95e5cda5a33$var$R();
    a = $7bdba95e5cda5a33$var$ih(a, b);
    null !== a && ($7bdba95e5cda5a33$var$Ac(a, b, c), $7bdba95e5cda5a33$var$Dk(a, c));
}
function $7bdba95e5cda5a33$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $7bdba95e5cda5a33$var$Yk(a, c);
}
function $7bdba95e5cda5a33$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($7bdba95e5cda5a33$var$p(314));
    }
    null !== d && d.delete(b);
    $7bdba95e5cda5a33$var$Yk(a, c);
}
var $7bdba95e5cda5a33$var$Vk;
$7bdba95e5cda5a33$var$Vk = function Vk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $7bdba95e5cda5a33$var$Wf.current) $7bdba95e5cda5a33$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $7bdba95e5cda5a33$var$dh = !1, $7bdba95e5cda5a33$var$yj(a, b, c);
            $7bdba95e5cda5a33$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $7bdba95e5cda5a33$var$dh = !1, $7bdba95e5cda5a33$var$I && 0 !== (b.flags & 1048576) && $7bdba95e5cda5a33$var$ug(b, $7bdba95e5cda5a33$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $7bdba95e5cda5a33$var$ij(a, b);
            a = b.pendingProps;
            var e = $7bdba95e5cda5a33$var$Yf(b, $7bdba95e5cda5a33$var$H.current);
            $7bdba95e5cda5a33$var$ch(b, c);
            e = $7bdba95e5cda5a33$var$Nh(null, b, d, a, e, c);
            var f = $7bdba95e5cda5a33$var$Sh();
            b.flags |= 1;
            "object" === (typeof e === "undefined" ? "undefined" : (0, $27SFb._)(e)) && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $7bdba95e5cda5a33$var$Zf(d) ? (f = !0, $7bdba95e5cda5a33$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $7bdba95e5cda5a33$var$kh(b), e.updater = $7bdba95e5cda5a33$var$Ei, b.stateNode = e, e._reactInternals = b, $7bdba95e5cda5a33$var$Ii(b, d, a, c), b = $7bdba95e5cda5a33$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $7bdba95e5cda5a33$var$I && f && $7bdba95e5cda5a33$var$vg(b), $7bdba95e5cda5a33$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $7bdba95e5cda5a33$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $7bdba95e5cda5a33$var$Zk(d);
                a = $7bdba95e5cda5a33$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $7bdba95e5cda5a33$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $7bdba95e5cda5a33$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $7bdba95e5cda5a33$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $7bdba95e5cda5a33$var$$i(null, b, d, $7bdba95e5cda5a33$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($7bdba95e5cda5a33$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $7bdba95e5cda5a33$var$Ci(d, e), $7bdba95e5cda5a33$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $7bdba95e5cda5a33$var$Ci(d, e), $7bdba95e5cda5a33$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $7bdba95e5cda5a33$var$kj(b);
                if (null === a) throw Error($7bdba95e5cda5a33$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $7bdba95e5cda5a33$var$lh(a, b);
                $7bdba95e5cda5a33$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $7bdba95e5cda5a33$var$Ji(Error($7bdba95e5cda5a33$var$p(423)), b);
                        b = $7bdba95e5cda5a33$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $7bdba95e5cda5a33$var$Ji(Error($7bdba95e5cda5a33$var$p(424)), b);
                        b = $7bdba95e5cda5a33$var$lj(a, b, d, c, e);
                        break a;
                    } else for($7bdba95e5cda5a33$var$yg = $7bdba95e5cda5a33$var$Lf(b.stateNode.containerInfo.firstChild), $7bdba95e5cda5a33$var$xg = b, $7bdba95e5cda5a33$var$I = !0, $7bdba95e5cda5a33$var$zg = null, c = $7bdba95e5cda5a33$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $7bdba95e5cda5a33$var$Ig();
                    if (d === e) {
                        b = $7bdba95e5cda5a33$var$Zi(a, b, c);
                        break a;
                    }
                    $7bdba95e5cda5a33$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $7bdba95e5cda5a33$var$Ah(b), null === a && $7bdba95e5cda5a33$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $7bdba95e5cda5a33$var$Ef(d, e) ? g = null : null !== f && $7bdba95e5cda5a33$var$Ef(d, f) && (b.flags |= 32), $7bdba95e5cda5a33$var$gj(a, b), $7bdba95e5cda5a33$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $7bdba95e5cda5a33$var$Eg(b), null;
        case 13:
            return $7bdba95e5cda5a33$var$oj(a, b, c);
        case 4:
            return $7bdba95e5cda5a33$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $7bdba95e5cda5a33$var$Ug(b, null, d, c) : $7bdba95e5cda5a33$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $7bdba95e5cda5a33$var$Ci(d, e), $7bdba95e5cda5a33$var$Yi(a, b, d, e, c);
        case 7:
            return $7bdba95e5cda5a33$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $7bdba95e5cda5a33$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $7bdba95e5cda5a33$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $7bdba95e5cda5a33$var$G($7bdba95e5cda5a33$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($7bdba95e5cda5a33$var$He(f.value, g)) {
                        if (f.children === e.children && !$7bdba95e5cda5a33$var$Wf.current) {
                            b = $7bdba95e5cda5a33$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $7bdba95e5cda5a33$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $7bdba95e5cda5a33$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($7bdba95e5cda5a33$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $7bdba95e5cda5a33$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $7bdba95e5cda5a33$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $7bdba95e5cda5a33$var$ch(b, c), e = $7bdba95e5cda5a33$var$eh(e), d = d(e), b.flags |= 1, $7bdba95e5cda5a33$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $7bdba95e5cda5a33$var$Ci(d, b.pendingProps), e = $7bdba95e5cda5a33$var$Ci(d.type, e), $7bdba95e5cda5a33$var$$i(a, b, d, e, c);
        case 15:
            return $7bdba95e5cda5a33$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $7bdba95e5cda5a33$var$Ci(d, e), $7bdba95e5cda5a33$var$ij(a, b), b.tag = 1, $7bdba95e5cda5a33$var$Zf(d) ? (a = !0, $7bdba95e5cda5a33$var$cg(b)) : a = !1, $7bdba95e5cda5a33$var$ch(b, c), $7bdba95e5cda5a33$var$Gi(b, d, e), $7bdba95e5cda5a33$var$Ii(b, d, e, c), $7bdba95e5cda5a33$var$jj(null, b, d, !0, a, c);
        case 19:
            return $7bdba95e5cda5a33$var$xj(a, b, c);
        case 22:
            return $7bdba95e5cda5a33$var$dj(a, b, c);
    }
    throw Error($7bdba95e5cda5a33$var$p(156, b.tag));
};
function $7bdba95e5cda5a33$var$Fk(a, b) {
    return $7bdba95e5cda5a33$var$ac(a, b);
}
function $7bdba95e5cda5a33$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $7bdba95e5cda5a33$var$Bg(a, b, c, d) {
    return new $7bdba95e5cda5a33$var$$k(a, b, c, d);
}
function $7bdba95e5cda5a33$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $7bdba95e5cda5a33$var$Zk(a) {
    if ("function" === typeof a) return $7bdba95e5cda5a33$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $7bdba95e5cda5a33$var$Da) return 11;
        if (a === $7bdba95e5cda5a33$var$Ga) return 14;
    }
    return 2;
}
function $7bdba95e5cda5a33$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $7bdba95e5cda5a33$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $7bdba95e5cda5a33$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $7bdba95e5cda5a33$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $7bdba95e5cda5a33$var$ya:
            return $7bdba95e5cda5a33$var$Tg(c.children, e, f, b);
        case $7bdba95e5cda5a33$var$za:
            g = 8;
            e |= 8;
            break;
        case $7bdba95e5cda5a33$var$Aa:
            return a = $7bdba95e5cda5a33$var$Bg(12, c, b, e | 2), a.elementType = $7bdba95e5cda5a33$var$Aa, a.lanes = f, a;
        case $7bdba95e5cda5a33$var$Ea:
            return a = $7bdba95e5cda5a33$var$Bg(13, c, b, e), a.elementType = $7bdba95e5cda5a33$var$Ea, a.lanes = f, a;
        case $7bdba95e5cda5a33$var$Fa:
            return a = $7bdba95e5cda5a33$var$Bg(19, c, b, e), a.elementType = $7bdba95e5cda5a33$var$Fa, a.lanes = f, a;
        case $7bdba95e5cda5a33$var$Ia:
            return $7bdba95e5cda5a33$var$pj(c, e, f, b);
        default:
            if ("object" === (typeof a === "undefined" ? "undefined" : (0, $27SFb._)(a)) && null !== a) switch(a.$$typeof){
                case $7bdba95e5cda5a33$var$Ba:
                    g = 10;
                    break a;
                case $7bdba95e5cda5a33$var$Ca:
                    g = 9;
                    break a;
                case $7bdba95e5cda5a33$var$Da:
                    g = 11;
                    break a;
                case $7bdba95e5cda5a33$var$Ga:
                    g = 14;
                    break a;
                case $7bdba95e5cda5a33$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($7bdba95e5cda5a33$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $27SFb._)(a), ""));
    }
    b = $7bdba95e5cda5a33$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $7bdba95e5cda5a33$var$Tg(a, b, c, d) {
    a = $7bdba95e5cda5a33$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $7bdba95e5cda5a33$var$pj(a, b, c, d) {
    a = $7bdba95e5cda5a33$var$Bg(22, a, d, b);
    a.elementType = $7bdba95e5cda5a33$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $7bdba95e5cda5a33$var$Qg(a, b, c) {
    a = $7bdba95e5cda5a33$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $7bdba95e5cda5a33$var$Sg(a, b, c) {
    b = $7bdba95e5cda5a33$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $7bdba95e5cda5a33$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $7bdba95e5cda5a33$var$zc(0);
    this.expirationTimes = $7bdba95e5cda5a33$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $7bdba95e5cda5a33$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $7bdba95e5cda5a33$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $7bdba95e5cda5a33$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $7bdba95e5cda5a33$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $7bdba95e5cda5a33$var$kh(f);
    return a;
}
function $7bdba95e5cda5a33$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $7bdba95e5cda5a33$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $7bdba95e5cda5a33$var$dl(a) {
    if (!a) return $7bdba95e5cda5a33$var$Vf;
    a = a._reactInternals;
    a: {
        if ($7bdba95e5cda5a33$var$Vb(a) !== a || 1 !== a.tag) throw Error($7bdba95e5cda5a33$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($7bdba95e5cda5a33$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($7bdba95e5cda5a33$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($7bdba95e5cda5a33$var$Zf(c)) return $7bdba95e5cda5a33$var$bg(a, c, b);
    }
    return b;
}
function $7bdba95e5cda5a33$var$el(a, b, c, d, e, f, g, h, k) {
    a = $7bdba95e5cda5a33$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $7bdba95e5cda5a33$var$dl(null);
    c = a.current;
    d = $7bdba95e5cda5a33$var$R();
    e = $7bdba95e5cda5a33$var$yi(c);
    f = $7bdba95e5cda5a33$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $7bdba95e5cda5a33$var$nh(c, f, e);
    a.current.lanes = e;
    $7bdba95e5cda5a33$var$Ac(a, e, d);
    $7bdba95e5cda5a33$var$Dk(a, d);
    return a;
}
function $7bdba95e5cda5a33$var$fl(a, b, c, d) {
    var e = b.current, f = $7bdba95e5cda5a33$var$R(), g = $7bdba95e5cda5a33$var$yi(e);
    c = $7bdba95e5cda5a33$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $7bdba95e5cda5a33$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $7bdba95e5cda5a33$var$nh(e, b, g);
    null !== a && ($7bdba95e5cda5a33$var$gi(a, e, g, f), $7bdba95e5cda5a33$var$oh(a, e, g));
    return g;
}
function $7bdba95e5cda5a33$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $7bdba95e5cda5a33$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $7bdba95e5cda5a33$var$il(a, b) {
    $7bdba95e5cda5a33$var$hl(a, b);
    (a = a.alternate) && $7bdba95e5cda5a33$var$hl(a, b);
}
function $7bdba95e5cda5a33$var$jl() {
    return null;
}
var $7bdba95e5cda5a33$var$kl = "function" === typeof reportError ? reportError : function kl(a) {
    console.error(a);
};
function $7bdba95e5cda5a33$var$ll(a) {
    this._internalRoot = a;
}
$7bdba95e5cda5a33$var$ml.prototype.render = $7bdba95e5cda5a33$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($7bdba95e5cda5a33$var$p(409));
    $7bdba95e5cda5a33$var$fl(a, b, null, null);
};
$7bdba95e5cda5a33$var$ml.prototype.unmount = $7bdba95e5cda5a33$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $7bdba95e5cda5a33$var$Rk(function() {
            $7bdba95e5cda5a33$var$fl(null, a, null, null);
        });
        b[$7bdba95e5cda5a33$var$uf] = null;
    }
};
function $7bdba95e5cda5a33$var$ml(a) {
    this._internalRoot = a;
}
$7bdba95e5cda5a33$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $7bdba95e5cda5a33$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $7bdba95e5cda5a33$var$Qc.length && 0 !== b && b < $7bdba95e5cda5a33$var$Qc[c].priority; c++);
        $7bdba95e5cda5a33$var$Qc.splice(c, 0, a);
        0 === c && $7bdba95e5cda5a33$var$Vc(a);
    }
};
function $7bdba95e5cda5a33$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $7bdba95e5cda5a33$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $7bdba95e5cda5a33$var$pl() {}
function $7bdba95e5cda5a33$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $7bdba95e5cda5a33$var$gl(g);
                f.call(_$a);
            };
        }
        var g = $7bdba95e5cda5a33$var$el(b, d, a, 0, null, !1, !1, "", $7bdba95e5cda5a33$var$pl);
        a._reactRootContainer = g;
        a[$7bdba95e5cda5a33$var$uf] = g.current;
        $7bdba95e5cda5a33$var$sf(8 === a.nodeType ? a.parentNode : a);
        $7bdba95e5cda5a33$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $7bdba95e5cda5a33$var$gl(k);
            h.call(_$a);
        };
    }
    var k = $7bdba95e5cda5a33$var$bl(a, 0, !1, null, null, !1, !1, "", $7bdba95e5cda5a33$var$pl);
    a._reactRootContainer = k;
    a[$7bdba95e5cda5a33$var$uf] = k.current;
    $7bdba95e5cda5a33$var$sf(8 === a.nodeType ? a.parentNode : a);
    $7bdba95e5cda5a33$var$Rk(function() {
        $7bdba95e5cda5a33$var$fl(b, k, c, d);
    });
    return k;
}
function $7bdba95e5cda5a33$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $7bdba95e5cda5a33$var$gl(g);
                h.call(_$a);
            };
        }
        $7bdba95e5cda5a33$var$fl(b, g, a, e);
    } else g = $7bdba95e5cda5a33$var$ql(c, b, a, e, d);
    return $7bdba95e5cda5a33$var$gl(g);
}
$7bdba95e5cda5a33$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $7bdba95e5cda5a33$var$tc(b.pendingLanes);
                0 !== c && ($7bdba95e5cda5a33$var$Cc(b, c | 1), $7bdba95e5cda5a33$var$Dk(b, $7bdba95e5cda5a33$var$B()), 0 === ($7bdba95e5cda5a33$var$K & 6) && ($7bdba95e5cda5a33$var$Gj = $7bdba95e5cda5a33$var$B() + 500, $7bdba95e5cda5a33$var$jg()));
            }
            break;
        case 13:
            $7bdba95e5cda5a33$var$Rk(function() {
                var b = $7bdba95e5cda5a33$var$ih(a, 1);
                if (null !== b) {
                    var c = $7bdba95e5cda5a33$var$R();
                    $7bdba95e5cda5a33$var$gi(b, a, 1, c);
                }
            }), $7bdba95e5cda5a33$var$il(a, 1);
    }
};
$7bdba95e5cda5a33$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $7bdba95e5cda5a33$var$ih(a, 134217728);
        if (null !== b) {
            var c = $7bdba95e5cda5a33$var$R();
            $7bdba95e5cda5a33$var$gi(b, a, 134217728, c);
        }
        $7bdba95e5cda5a33$var$il(a, 134217728);
    }
};
$7bdba95e5cda5a33$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $7bdba95e5cda5a33$var$yi(a), c = $7bdba95e5cda5a33$var$ih(a, b);
        if (null !== c) {
            var d = $7bdba95e5cda5a33$var$R();
            $7bdba95e5cda5a33$var$gi(c, a, b, d);
        }
        $7bdba95e5cda5a33$var$il(a, b);
    }
};
$7bdba95e5cda5a33$var$Hc = function Hc() {
    return $7bdba95e5cda5a33$var$C;
};
$7bdba95e5cda5a33$var$Ic = function Ic(a, b) {
    var c = $7bdba95e5cda5a33$var$C;
    try {
        return $7bdba95e5cda5a33$var$C = a, b();
    } finally{
        $7bdba95e5cda5a33$var$C = c;
    }
};
$7bdba95e5cda5a33$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $7bdba95e5cda5a33$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $7bdba95e5cda5a33$var$Db(d);
                        if (!e) throw Error($7bdba95e5cda5a33$var$p(90));
                        $7bdba95e5cda5a33$var$Wa(d);
                        $7bdba95e5cda5a33$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $7bdba95e5cda5a33$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $7bdba95e5cda5a33$var$fb(a, !!c.multiple, b, !1);
    }
};
$7bdba95e5cda5a33$var$Gb = $7bdba95e5cda5a33$var$Qk;
$7bdba95e5cda5a33$var$Hb = $7bdba95e5cda5a33$var$Rk;
var $7bdba95e5cda5a33$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $7bdba95e5cda5a33$var$Cb,
        $7bdba95e5cda5a33$var$ue,
        $7bdba95e5cda5a33$var$Db,
        $7bdba95e5cda5a33$var$Eb,
        $7bdba95e5cda5a33$var$Fb,
        $7bdba95e5cda5a33$var$Qk
    ]
}, $7bdba95e5cda5a33$var$tl = {
    findFiberByHostInstance: $7bdba95e5cda5a33$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $7bdba95e5cda5a33$var$ul = {
    bundleType: $7bdba95e5cda5a33$var$tl.bundleType,
    version: $7bdba95e5cda5a33$var$tl.version,
    rendererPackageName: $7bdba95e5cda5a33$var$tl.rendererPackageName,
    rendererConfig: $7bdba95e5cda5a33$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $7bdba95e5cda5a33$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $7bdba95e5cda5a33$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $7bdba95e5cda5a33$var$tl.findFiberByHostInstance || $7bdba95e5cda5a33$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $7bdba95e5cda5a33$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$7bdba95e5cda5a33$var$vl.isDisabled && $7bdba95e5cda5a33$var$vl.supportsFiber) try {
        $7bdba95e5cda5a33$var$kc = $7bdba95e5cda5a33$var$vl.inject($7bdba95e5cda5a33$var$ul), $7bdba95e5cda5a33$var$lc = $7bdba95e5cda5a33$var$vl;
    } catch (a) {}
}
$7bdba95e5cda5a33$export$ae55be85d98224ed = $7bdba95e5cda5a33$var$sl;
$7bdba95e5cda5a33$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$7bdba95e5cda5a33$var$nl(b)) throw Error($7bdba95e5cda5a33$var$p(200));
    return $7bdba95e5cda5a33$var$cl(a, b, null, c);
};
$7bdba95e5cda5a33$export$882461b6382ed46c = function(a, b) {
    if (!$7bdba95e5cda5a33$var$nl(a)) throw Error($7bdba95e5cda5a33$var$p(299));
    var c = !1, d = "", e = $7bdba95e5cda5a33$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $7bdba95e5cda5a33$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$7bdba95e5cda5a33$var$uf] = b.current;
    $7bdba95e5cda5a33$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $7bdba95e5cda5a33$var$ll(b);
};
$7bdba95e5cda5a33$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($7bdba95e5cda5a33$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($7bdba95e5cda5a33$var$p(268, a));
    }
    a = $7bdba95e5cda5a33$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$7bdba95e5cda5a33$export$cd75ccfd720a3cd4 = function(a) {
    return $7bdba95e5cda5a33$var$Rk(a);
};
$7bdba95e5cda5a33$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$7bdba95e5cda5a33$var$ol(b)) throw Error($7bdba95e5cda5a33$var$p(200));
    return $7bdba95e5cda5a33$var$rl(null, a, b, !0, c);
};
$7bdba95e5cda5a33$export$757ceba2d55c277e = function(a, b, c) {
    if (!$7bdba95e5cda5a33$var$nl(a)) throw Error($7bdba95e5cda5a33$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $7bdba95e5cda5a33$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $7bdba95e5cda5a33$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$7bdba95e5cda5a33$var$uf] = b.current;
    $7bdba95e5cda5a33$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $7bdba95e5cda5a33$var$ml(b);
};
$7bdba95e5cda5a33$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$7bdba95e5cda5a33$var$ol(b)) throw Error($7bdba95e5cda5a33$var$p(200));
    return $7bdba95e5cda5a33$var$rl(null, a, b, !1, c);
};
$7bdba95e5cda5a33$export$502457920280e6be = function(a) {
    if (!$7bdba95e5cda5a33$var$ol(a)) throw Error($7bdba95e5cda5a33$var$p(40));
    return a._reactRootContainer ? ($7bdba95e5cda5a33$var$Rk(function() {
        $7bdba95e5cda5a33$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$7bdba95e5cda5a33$var$uf] = null;
        });
    }), !0) : !1;
};
$7bdba95e5cda5a33$export$c78a37762a8d58e1 = $7bdba95e5cda5a33$var$Qk;
$7bdba95e5cda5a33$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$7bdba95e5cda5a33$var$ol(c)) throw Error($7bdba95e5cda5a33$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($7bdba95e5cda5a33$var$p(38));
    return $7bdba95e5cda5a33$var$rl(a, b, c, !1, d);
};
$7bdba95e5cda5a33$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("4s3M8", function(module, exports) {
'use strict';

module.exports = (parcelRequire("96ilu"));

});
parcelRegister("96ilu", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6a02e7a2d8ad057c$export$c4744153514ff05d; }, function (v) { return $6a02e7a2d8ad057c$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6a02e7a2d8ad057c$export$3e506c1ccc9cc1a7; }, function (v) { return $6a02e7a2d8ad057c$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6a02e7a2d8ad057c$export$e26fe2ed2fa76875; }, function (v) { return $6a02e7a2d8ad057c$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6a02e7a2d8ad057c$export$502329bbf4b505b1; }, function (v) { return $6a02e7a2d8ad057c$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6a02e7a2d8ad057c$export$6e3807111c4874c4; }, function (v) { return $6a02e7a2d8ad057c$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6a02e7a2d8ad057c$export$c27134553091fb3a; }, function (v) { return $6a02e7a2d8ad057c$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6a02e7a2d8ad057c$export$33ee1acdc04fd2a2; }, function (v) { return $6a02e7a2d8ad057c$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6a02e7a2d8ad057c$export$b00a404bbd5edef2; }, function (v) { return $6a02e7a2d8ad057c$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6a02e7a2d8ad057c$export$8352ce38b91d0c62; }, function (v) { return $6a02e7a2d8ad057c$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6a02e7a2d8ad057c$export$d66a1c1c77bd778b; }, function (v) { return $6a02e7a2d8ad057c$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6a02e7a2d8ad057c$export$d3dfb8e4810cb555; }, function (v) { return $6a02e7a2d8ad057c$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6a02e7a2d8ad057c$export$839f9183b0465a69; }, function (v) { return $6a02e7a2d8ad057c$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6a02e7a2d8ad057c$export$72fdf0e06517287b; }, function (v) { return $6a02e7a2d8ad057c$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6a02e7a2d8ad057c$export$4b844e58a3e414b4; }, function (v) { return $6a02e7a2d8ad057c$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6a02e7a2d8ad057c$export$816d2913ae6b83b1; }, function (v) { return $6a02e7a2d8ad057c$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6a02e7a2d8ad057c$export$61bcfe829111a1d0; }, function (v) { return $6a02e7a2d8ad057c$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6a02e7a2d8ad057c$export$7ee8c9beb337bc3f; }, function (v) { return $6a02e7a2d8ad057c$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6a02e7a2d8ad057c$export$b5836b71941fa3ed; }, function (v) { return $6a02e7a2d8ad057c$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6a02e7a2d8ad057c$export$cf845f2c119da08a; }, function (v) { return $6a02e7a2d8ad057c$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $27SFb = parcelRequire("27SFb");
var $6a02e7a2d8ad057c$export$c4744153514ff05d;
var $6a02e7a2d8ad057c$export$3e506c1ccc9cc1a7;
var $6a02e7a2d8ad057c$export$e26fe2ed2fa76875;
var $6a02e7a2d8ad057c$export$502329bbf4b505b1;
var $6a02e7a2d8ad057c$export$6e3807111c4874c4;
var $6a02e7a2d8ad057c$export$c27134553091fb3a;
var $6a02e7a2d8ad057c$export$33ee1acdc04fd2a2;
var $6a02e7a2d8ad057c$export$b00a404bbd5edef2;
var $6a02e7a2d8ad057c$export$8352ce38b91d0c62;
var $6a02e7a2d8ad057c$export$d66a1c1c77bd778b;
var $6a02e7a2d8ad057c$export$d3dfb8e4810cb555;
var $6a02e7a2d8ad057c$export$839f9183b0465a69;
var $6a02e7a2d8ad057c$export$72fdf0e06517287b;
var $6a02e7a2d8ad057c$export$4b844e58a3e414b4;
var $6a02e7a2d8ad057c$export$816d2913ae6b83b1;
var $6a02e7a2d8ad057c$export$61bcfe829111a1d0;
var $6a02e7a2d8ad057c$export$7ee8c9beb337bc3f;
var $6a02e7a2d8ad057c$export$b5836b71941fa3ed;
var $6a02e7a2d8ad057c$export$cf845f2c119da08a;
'use strict';
function $6a02e7a2d8ad057c$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6a02e7a2d8ad057c$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6a02e7a2d8ad057c$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6a02e7a2d8ad057c$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6a02e7a2d8ad057c$var$g(C, c)) n < e && 0 > $6a02e7a2d8ad057c$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6a02e7a2d8ad057c$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6a02e7a2d8ad057c$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, $27SFb._)(performance)) && "function" === typeof performance.now) {
    var $6a02e7a2d8ad057c$var$l = performance;
    $6a02e7a2d8ad057c$export$c4744153514ff05d = function() {
        return $6a02e7a2d8ad057c$var$l.now();
    };
} else {
    var $6a02e7a2d8ad057c$var$p = Date, $6a02e7a2d8ad057c$var$q = $6a02e7a2d8ad057c$var$p.now();
    $6a02e7a2d8ad057c$export$c4744153514ff05d = function() {
        return $6a02e7a2d8ad057c$var$p.now() - $6a02e7a2d8ad057c$var$q;
    };
}
var $6a02e7a2d8ad057c$var$r = [], $6a02e7a2d8ad057c$var$t = [], $6a02e7a2d8ad057c$var$u = 1, $6a02e7a2d8ad057c$var$v = null, $6a02e7a2d8ad057c$var$y = 3, $6a02e7a2d8ad057c$var$z = !1, $6a02e7a2d8ad057c$var$A = !1, $6a02e7a2d8ad057c$var$B = !1, $6a02e7a2d8ad057c$var$D = "function" === typeof setTimeout ? setTimeout : null, $6a02e7a2d8ad057c$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6a02e7a2d8ad057c$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6a02e7a2d8ad057c$var$G(a) {
    for(var b = $6a02e7a2d8ad057c$var$h($6a02e7a2d8ad057c$var$t); null !== b;){
        if (null === b.callback) $6a02e7a2d8ad057c$var$k($6a02e7a2d8ad057c$var$t);
        else if (b.startTime <= a) $6a02e7a2d8ad057c$var$k($6a02e7a2d8ad057c$var$t), b.sortIndex = b.expirationTime, $6a02e7a2d8ad057c$var$f($6a02e7a2d8ad057c$var$r, b);
        else break;
        b = $6a02e7a2d8ad057c$var$h($6a02e7a2d8ad057c$var$t);
    }
}
function $6a02e7a2d8ad057c$var$H(a) {
    $6a02e7a2d8ad057c$var$B = !1;
    $6a02e7a2d8ad057c$var$G(a);
    if (!$6a02e7a2d8ad057c$var$A) {
        if (null !== $6a02e7a2d8ad057c$var$h($6a02e7a2d8ad057c$var$r)) $6a02e7a2d8ad057c$var$A = !0, $6a02e7a2d8ad057c$var$I($6a02e7a2d8ad057c$var$J);
        else {
            var b = $6a02e7a2d8ad057c$var$h($6a02e7a2d8ad057c$var$t);
            null !== b && $6a02e7a2d8ad057c$var$K($6a02e7a2d8ad057c$var$H, b.startTime - a);
        }
    }
}
function $6a02e7a2d8ad057c$var$J(a, b) {
    $6a02e7a2d8ad057c$var$A = !1;
    $6a02e7a2d8ad057c$var$B && ($6a02e7a2d8ad057c$var$B = !1, $6a02e7a2d8ad057c$var$E($6a02e7a2d8ad057c$var$L), $6a02e7a2d8ad057c$var$L = -1);
    $6a02e7a2d8ad057c$var$z = !0;
    var c = $6a02e7a2d8ad057c$var$y;
    try {
        $6a02e7a2d8ad057c$var$G(b);
        for($6a02e7a2d8ad057c$var$v = $6a02e7a2d8ad057c$var$h($6a02e7a2d8ad057c$var$r); null !== $6a02e7a2d8ad057c$var$v && (!($6a02e7a2d8ad057c$var$v.expirationTime > b) || a && !$6a02e7a2d8ad057c$var$M());){
            var d = $6a02e7a2d8ad057c$var$v.callback;
            if ("function" === typeof d) {
                $6a02e7a2d8ad057c$var$v.callback = null;
                $6a02e7a2d8ad057c$var$y = $6a02e7a2d8ad057c$var$v.priorityLevel;
                var e = d($6a02e7a2d8ad057c$var$v.expirationTime <= b);
                b = $6a02e7a2d8ad057c$export$c4744153514ff05d();
                "function" === typeof e ? $6a02e7a2d8ad057c$var$v.callback = e : $6a02e7a2d8ad057c$var$v === $6a02e7a2d8ad057c$var$h($6a02e7a2d8ad057c$var$r) && $6a02e7a2d8ad057c$var$k($6a02e7a2d8ad057c$var$r);
                $6a02e7a2d8ad057c$var$G(b);
            } else $6a02e7a2d8ad057c$var$k($6a02e7a2d8ad057c$var$r);
            $6a02e7a2d8ad057c$var$v = $6a02e7a2d8ad057c$var$h($6a02e7a2d8ad057c$var$r);
        }
        if (null !== $6a02e7a2d8ad057c$var$v) var w = !0;
        else {
            var m = $6a02e7a2d8ad057c$var$h($6a02e7a2d8ad057c$var$t);
            null !== m && $6a02e7a2d8ad057c$var$K($6a02e7a2d8ad057c$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6a02e7a2d8ad057c$var$v = null, $6a02e7a2d8ad057c$var$y = c, $6a02e7a2d8ad057c$var$z = !1;
    }
}
var $6a02e7a2d8ad057c$var$N = !1, $6a02e7a2d8ad057c$var$O = null, $6a02e7a2d8ad057c$var$L = -1, $6a02e7a2d8ad057c$var$P = 5, $6a02e7a2d8ad057c$var$Q = -1;
function $6a02e7a2d8ad057c$var$M() {
    return $6a02e7a2d8ad057c$export$c4744153514ff05d() - $6a02e7a2d8ad057c$var$Q < $6a02e7a2d8ad057c$var$P ? !1 : !0;
}
function $6a02e7a2d8ad057c$var$R() {
    if (null !== $6a02e7a2d8ad057c$var$O) {
        var a = $6a02e7a2d8ad057c$export$c4744153514ff05d();
        $6a02e7a2d8ad057c$var$Q = a;
        var b = !0;
        try {
            b = $6a02e7a2d8ad057c$var$O(!0, a);
        } finally{
            b ? $6a02e7a2d8ad057c$var$S() : ($6a02e7a2d8ad057c$var$N = !1, $6a02e7a2d8ad057c$var$O = null);
        }
    } else $6a02e7a2d8ad057c$var$N = !1;
}
var $6a02e7a2d8ad057c$var$S;
if ("function" === typeof $6a02e7a2d8ad057c$var$F) $6a02e7a2d8ad057c$var$S = function S() {
    $6a02e7a2d8ad057c$var$F($6a02e7a2d8ad057c$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6a02e7a2d8ad057c$var$T = new MessageChannel, $6a02e7a2d8ad057c$var$U = $6a02e7a2d8ad057c$var$T.port2;
    $6a02e7a2d8ad057c$var$T.port1.onmessage = $6a02e7a2d8ad057c$var$R;
    $6a02e7a2d8ad057c$var$S = function S() {
        $6a02e7a2d8ad057c$var$U.postMessage(null);
    };
} else $6a02e7a2d8ad057c$var$S = function S() {
    $6a02e7a2d8ad057c$var$D($6a02e7a2d8ad057c$var$R, 0);
};
function $6a02e7a2d8ad057c$var$I(a) {
    $6a02e7a2d8ad057c$var$O = a;
    $6a02e7a2d8ad057c$var$N || ($6a02e7a2d8ad057c$var$N = !0, $6a02e7a2d8ad057c$var$S());
}
function $6a02e7a2d8ad057c$var$K(a, b) {
    $6a02e7a2d8ad057c$var$L = $6a02e7a2d8ad057c$var$D(function() {
        a($6a02e7a2d8ad057c$export$c4744153514ff05d());
    }, b);
}
$6a02e7a2d8ad057c$export$3e506c1ccc9cc1a7 = 5;
$6a02e7a2d8ad057c$export$e26fe2ed2fa76875 = 1;
$6a02e7a2d8ad057c$export$502329bbf4b505b1 = 4;
$6a02e7a2d8ad057c$export$6e3807111c4874c4 = 3;
$6a02e7a2d8ad057c$export$c27134553091fb3a = null;
$6a02e7a2d8ad057c$export$33ee1acdc04fd2a2 = 2;
$6a02e7a2d8ad057c$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6a02e7a2d8ad057c$export$8352ce38b91d0c62 = function() {
    $6a02e7a2d8ad057c$var$A || $6a02e7a2d8ad057c$var$z || ($6a02e7a2d8ad057c$var$A = !0, $6a02e7a2d8ad057c$var$I($6a02e7a2d8ad057c$var$J));
};
$6a02e7a2d8ad057c$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6a02e7a2d8ad057c$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6a02e7a2d8ad057c$export$d3dfb8e4810cb555 = function() {
    return $6a02e7a2d8ad057c$var$y;
};
$6a02e7a2d8ad057c$export$839f9183b0465a69 = function() {
    return $6a02e7a2d8ad057c$var$h($6a02e7a2d8ad057c$var$r);
};
$6a02e7a2d8ad057c$export$72fdf0e06517287b = function(a) {
    switch($6a02e7a2d8ad057c$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6a02e7a2d8ad057c$var$y;
    }
    var c = $6a02e7a2d8ad057c$var$y;
    $6a02e7a2d8ad057c$var$y = b;
    try {
        return a();
    } finally{
        $6a02e7a2d8ad057c$var$y = c;
    }
};
$6a02e7a2d8ad057c$export$4b844e58a3e414b4 = function() {};
$6a02e7a2d8ad057c$export$816d2913ae6b83b1 = function() {};
$6a02e7a2d8ad057c$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6a02e7a2d8ad057c$var$y;
    $6a02e7a2d8ad057c$var$y = a;
    try {
        return b();
    } finally{
        $6a02e7a2d8ad057c$var$y = c;
    }
};
$6a02e7a2d8ad057c$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6a02e7a2d8ad057c$export$c4744153514ff05d();
    "object" === (typeof c === "undefined" ? "undefined" : (0, $27SFb._)(c)) && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6a02e7a2d8ad057c$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6a02e7a2d8ad057c$var$f($6a02e7a2d8ad057c$var$t, a), null === $6a02e7a2d8ad057c$var$h($6a02e7a2d8ad057c$var$r) && a === $6a02e7a2d8ad057c$var$h($6a02e7a2d8ad057c$var$t) && ($6a02e7a2d8ad057c$var$B ? ($6a02e7a2d8ad057c$var$E($6a02e7a2d8ad057c$var$L), $6a02e7a2d8ad057c$var$L = -1) : $6a02e7a2d8ad057c$var$B = !0, $6a02e7a2d8ad057c$var$K($6a02e7a2d8ad057c$var$H, c - d))) : (a.sortIndex = e, $6a02e7a2d8ad057c$var$f($6a02e7a2d8ad057c$var$r, a), $6a02e7a2d8ad057c$var$A || $6a02e7a2d8ad057c$var$z || ($6a02e7a2d8ad057c$var$A = !0, $6a02e7a2d8ad057c$var$I($6a02e7a2d8ad057c$var$J)));
    return a;
};
$6a02e7a2d8ad057c$export$b5836b71941fa3ed = $6a02e7a2d8ad057c$var$M;
$6a02e7a2d8ad057c$export$cf845f2c119da08a = function(a) {
    var b = $6a02e7a2d8ad057c$var$y;
    return function() {
        var c = $6a02e7a2d8ad057c$var$y;
        $6a02e7a2d8ad057c$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6a02e7a2d8ad057c$var$y = c;
        }
    };
};

});



var $5653a780cfe29e3e$exports = {};
'use strict';

$5653a780cfe29e3e$exports = (parcelRequire("cliSa"));


parcelRequire("e7uJ5");
var $75511b671e3d5c31$exports = {};

$parcel$export($75511b671e3d5c31$exports, "createRoot", function () { return $75511b671e3d5c31$export$882461b6382ed46c; }, function (v) { return $75511b671e3d5c31$export$882461b6382ed46c = v; });
$parcel$export($75511b671e3d5c31$exports, "hydrateRoot", function () { return $75511b671e3d5c31$export$757ceba2d55c277e; }, function (v) { return $75511b671e3d5c31$export$757ceba2d55c277e = v; });
var $75511b671e3d5c31$export$882461b6382ed46c;
var $75511b671e3d5c31$export$757ceba2d55c277e;
'use strict';
var $a432a49917d0710b$exports = {};
'use strict';
function $a432a49917d0710b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a432a49917d0710b$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a432a49917d0710b$var$checkDCE();

$a432a49917d0710b$exports = (parcelRequire("aDicf"));


var $75511b671e3d5c31$var$i;
$75511b671e3d5c31$export$882461b6382ed46c = $a432a49917d0710b$exports.createRoot;
$75511b671e3d5c31$export$757ceba2d55c277e = $a432a49917d0710b$exports.hydrateRoot;



function $b150e58c0d13a504$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $3726bb8d3c17940f$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $b150e58c0d13a504$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $ddab6414934dc4e5$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $f072c5daae1e17b2$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $dbd2489c02db6887$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $f95367494854931d$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $6e17484dd95b832d$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $f95367494854931d$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $f95367494854931d$export$71511d61b312f219)(o, minLen);
}


function $9f3f58c235e31b6d$export$71511d61b312f219(arr, i) {
    return (0, $ddab6414934dc4e5$export$71511d61b312f219)(arr) || (0, $f072c5daae1e17b2$export$71511d61b312f219)(arr, i) || (0, $6e17484dd95b832d$export$71511d61b312f219)(arr, i) || (0, $dbd2489c02db6887$export$71511d61b312f219)();
}


function $aa21808cecea3360$export$71511d61b312f219(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}




var $e7uJ5 = parcelRequire("e7uJ5");

var $27SFb = parcelRequire("27SFb");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $27SFb = parcelRequire("27SFb");
var $c9b1471f73a231b2$var$extendStatics = function extendStatics1(d, b) {
    $c9b1471f73a231b2$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $c9b1471f73a231b2$var$extendStatics(d, b);
};
function $c9b1471f73a231b2$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $c9b1471f73a231b2$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c9b1471f73a231b2$export$18ce0697a983be9b = function __assign1() {
    $c9b1471f73a231b2$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c9b1471f73a231b2$export$18ce0697a983be9b.apply(this, arguments);
};
function $c9b1471f73a231b2$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c9b1471f73a231b2$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $27SFb._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c9b1471f73a231b2$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c9b1471f73a231b2$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $27SFb._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $c9b1471f73a231b2$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $c9b1471f73a231b2$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $27SFb._)(x)) === "symbol" ? x : "".concat(x);
}
function $c9b1471f73a231b2$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $27SFb._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $c9b1471f73a231b2$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $27SFb._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c9b1471f73a231b2$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c9b1471f73a231b2$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $c9b1471f73a231b2$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $c9b1471f73a231b2$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $c9b1471f73a231b2$export$45d3717a4c69092e(o, m, p);
}
function $c9b1471f73a231b2$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c9b1471f73a231b2$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c9b1471f73a231b2$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c9b1471f73a231b2$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c9b1471f73a231b2$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c9b1471f73a231b2$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $c9b1471f73a231b2$export$10c90e4f7922046c(v) {
    return this instanceof $c9b1471f73a231b2$export$10c90e4f7922046c ? (this.v = v, this) : new $c9b1471f73a231b2$export$10c90e4f7922046c(v);
}
function $c9b1471f73a231b2$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c9b1471f73a231b2$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c9b1471f73a231b2$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c9b1471f73a231b2$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $c9b1471f73a231b2$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c9b1471f73a231b2$export$19a8beecd37a4c45 === "function" ? $c9b1471f73a231b2$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c9b1471f73a231b2$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $c9b1471f73a231b2$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $c9b1471f73a231b2$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c9b1471f73a231b2$export$45d3717a4c69092e(result, mod, k);
    }
    $c9b1471f73a231b2$var$__setModuleDefault(result, mod);
    return result;
}
function $c9b1471f73a231b2$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c9b1471f73a231b2$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $c9b1471f73a231b2$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $c9b1471f73a231b2$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $27SFb._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $c9b1471f73a231b2$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $27SFb._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $c9b1471f73a231b2$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $c9b1471f73a231b2$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $c9b1471f73a231b2$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $c9b1471f73a231b2$export$2e2bcd8739ae039 = {
    __extends: $c9b1471f73a231b2$export$a8ba968b8961cb8a,
    __assign: $c9b1471f73a231b2$export$18ce0697a983be9b,
    __rest: $c9b1471f73a231b2$export$3c9a16f847548506,
    __decorate: $c9b1471f73a231b2$export$29e00dfd3077644b,
    __param: $c9b1471f73a231b2$export$d5ad3fd78186038f,
    __metadata: $c9b1471f73a231b2$export$f1db080c865becb9,
    __awaiter: $c9b1471f73a231b2$export$1050f835b63b671e,
    __generator: $c9b1471f73a231b2$export$67ebef60e6f28a6,
    __createBinding: $c9b1471f73a231b2$export$45d3717a4c69092e,
    __exportStar: $c9b1471f73a231b2$export$f33643c0debef087,
    __values: $c9b1471f73a231b2$export$19a8beecd37a4c45,
    __read: $c9b1471f73a231b2$export$8d051b38c9118094,
    __spread: $c9b1471f73a231b2$export$afc72e2116322959,
    __spreadArrays: $c9b1471f73a231b2$export$6388937ca91ccae8,
    __spreadArray: $c9b1471f73a231b2$export$1216008129fb82ed,
    __await: $c9b1471f73a231b2$export$10c90e4f7922046c,
    __asyncGenerator: $c9b1471f73a231b2$export$e427f37a30a4de9b,
    __asyncDelegator: $c9b1471f73a231b2$export$bbd80228419bb833,
    __asyncValues: $c9b1471f73a231b2$export$e3b29a3d6162315f,
    __makeTemplateObject: $c9b1471f73a231b2$export$4fb47efe1390b86f,
    __importStar: $c9b1471f73a231b2$export$c21735bcef00d192,
    __importDefault: $c9b1471f73a231b2$export$da59b14a69baef04,
    __classPrivateFieldGet: $c9b1471f73a231b2$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $c9b1471f73a231b2$export$d40a35129aaff81f,
    __classPrivateFieldIn: $c9b1471f73a231b2$export$81fdc39f203e4e04,
    __addDisposableResource: $c9b1471f73a231b2$export$88ac25d8e944e405,
    __disposeResources: $c9b1471f73a231b2$export$8f076105dc360e92
};


function $6621e04373d4b2a8$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $87a4cd95f1c755e1$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $87a4cd95f1c755e1$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6621e04373d4b2a8$export$2e2bcd8739ae039)(function(prop) {
    return $87a4cd95f1c755e1$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $e7uJ5 = parcelRequire("e7uJ5");
var $08f454a428c9ca39$exports = {};
//

var $27SFb = parcelRequire("27SFb");
$08f454a428c9ca39$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if ((typeof objA === "undefined" ? "undefined" : (0, $27SFb._)(objA)) !== "object" || !objA || (typeof objB === "undefined" ? "undefined" : (0, $27SFb._)(objB)) !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $c4aec195e4e78606$export$71ad59f2e432cfe8 = "-ms-";
var $c4aec195e4e78606$export$2c0f367103c8d01c = "-moz-";
var $c4aec195e4e78606$export$39dfd62a25e0fe93 = "-webkit-";
var $c4aec195e4e78606$export$a29989082612d0d9 = "comm";
var $c4aec195e4e78606$export$aa3a2e812ca8570d = "rule";
var $c4aec195e4e78606$export$527d108ccf083c2b = "decl";
var $c4aec195e4e78606$export$d3d35020fa5b54f0 = "@page";
var $c4aec195e4e78606$export$500415a86c544f73 = "@media";
var $c4aec195e4e78606$export$a763edbf796b780a = "@import";
var $c4aec195e4e78606$export$2790aeb8b4e5c826 = "@charset";
var $c4aec195e4e78606$export$1cc683e23b84b133 = "@viewport";
var $c4aec195e4e78606$export$9447a5efea57e862 = "@supports";
var $c4aec195e4e78606$export$ef011b4e114b1fba = "@document";
var $c4aec195e4e78606$export$6aad947bda0f3f46 = "@namespace";
var $c4aec195e4e78606$export$b44a8529a35fcb60 = "@keyframes";
var $c4aec195e4e78606$export$2c16de31893252e6 = "@font-face";
var $c4aec195e4e78606$export$3d846dd52e150c6f = "@counter-style";
var $c4aec195e4e78606$export$22314bfbb57653fe = "@font-feature-values";
var $c4aec195e4e78606$export$d773506282b3cfe6 = "@layer";
var $c4aec195e4e78606$export$1c5a554c78c0cd12 = "@scope";
var $c4aec195e4e78606$export$2335f513bbd82c6d = Math.abs;
var $c4aec195e4e78606$export$6788812c4e6611e6 = String.fromCharCode;
var $c4aec195e4e78606$export$e6e34fd1f2686227 = Object.assign;
function $c4aec195e4e78606$export$d6af199866bfb566(e, r) {
    return $c4aec195e4e78606$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $c4aec195e4e78606$export$a9db5e087081082d(e, 0)) << 2 ^ $c4aec195e4e78606$export$a9db5e087081082d(e, 1)) << 2 ^ $c4aec195e4e78606$export$a9db5e087081082d(e, 2)) << 2 ^ $c4aec195e4e78606$export$a9db5e087081082d(e, 3) : 0;
}
function $c4aec195e4e78606$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $c4aec195e4e78606$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $c4aec195e4e78606$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $c4aec195e4e78606$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $c4aec195e4e78606$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $c4aec195e4e78606$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $c4aec195e4e78606$export$36776f635604f274(e) {
    return e.length;
}
function $c4aec195e4e78606$export$f9084667e487ed46(e) {
    return e.length;
}
function $c4aec195e4e78606$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $c4aec195e4e78606$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $c4aec195e4e78606$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$c4aec195e4e78606$export$4659b591c19bdf3d(e, r);
    });
}
var $c4aec195e4e78606$export$53f1d5ea8de3d7c = 1;
var $c4aec195e4e78606$export$4e0c71f277ca26b3 = 1;
var $c4aec195e4e78606$export$f24224f1c91d8156 = 0;
var $c4aec195e4e78606$export$5880b8b5730aff45 = 0;
var $c4aec195e4e78606$export$c0306caf338ac095 = 0;
var $c4aec195e4e78606$export$30a86d91af8ff6e6 = "";
function $c4aec195e4e78606$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $c4aec195e4e78606$export$53f1d5ea8de3d7c,
        column: $c4aec195e4e78606$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $c4aec195e4e78606$export$784d13d8ee351f07(e, r) {
    return $c4aec195e4e78606$export$e6e34fd1f2686227($c4aec195e4e78606$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $c4aec195e4e78606$export$590e8b2c435046d9(e) {
    while(e.root)e = $c4aec195e4e78606$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $c4aec195e4e78606$export$10d8903dec122b9d(e, e.siblings);
}
function $c4aec195e4e78606$export$eba6f6f03b0a92e7() {
    return $c4aec195e4e78606$export$c0306caf338ac095;
}
function $c4aec195e4e78606$export$232faf9add678146() {
    $c4aec195e4e78606$export$c0306caf338ac095 = $c4aec195e4e78606$export$5880b8b5730aff45 > 0 ? $c4aec195e4e78606$export$a9db5e087081082d($c4aec195e4e78606$export$30a86d91af8ff6e6, --$c4aec195e4e78606$export$5880b8b5730aff45) : 0;
    if ($c4aec195e4e78606$export$4e0c71f277ca26b3--, $c4aec195e4e78606$export$c0306caf338ac095 === 10) $c4aec195e4e78606$export$4e0c71f277ca26b3 = 1, $c4aec195e4e78606$export$53f1d5ea8de3d7c--;
    return $c4aec195e4e78606$export$c0306caf338ac095;
}
function $c4aec195e4e78606$export$48cfd1e771a65c4f() {
    $c4aec195e4e78606$export$c0306caf338ac095 = $c4aec195e4e78606$export$5880b8b5730aff45 < $c4aec195e4e78606$export$f24224f1c91d8156 ? $c4aec195e4e78606$export$a9db5e087081082d($c4aec195e4e78606$export$30a86d91af8ff6e6, $c4aec195e4e78606$export$5880b8b5730aff45++) : 0;
    if ($c4aec195e4e78606$export$4e0c71f277ca26b3++, $c4aec195e4e78606$export$c0306caf338ac095 === 10) $c4aec195e4e78606$export$4e0c71f277ca26b3 = 1, $c4aec195e4e78606$export$53f1d5ea8de3d7c++;
    return $c4aec195e4e78606$export$c0306caf338ac095;
}
function $c4aec195e4e78606$export$4d3fb11e950abb9e() {
    return $c4aec195e4e78606$export$a9db5e087081082d($c4aec195e4e78606$export$30a86d91af8ff6e6, $c4aec195e4e78606$export$5880b8b5730aff45);
}
function $c4aec195e4e78606$export$e88cb2efb12ae807() {
    return $c4aec195e4e78606$export$5880b8b5730aff45;
}
function $c4aec195e4e78606$export$58adb3bec8346d0f(e, r) {
    return $c4aec195e4e78606$export$2f35ab04d2335697($c4aec195e4e78606$export$30a86d91af8ff6e6, e, r);
}
function $c4aec195e4e78606$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $c4aec195e4e78606$export$2de70f21292aac9e(e) {
    return $c4aec195e4e78606$export$53f1d5ea8de3d7c = $c4aec195e4e78606$export$4e0c71f277ca26b3 = 1, $c4aec195e4e78606$export$f24224f1c91d8156 = $c4aec195e4e78606$export$36776f635604f274($c4aec195e4e78606$export$30a86d91af8ff6e6 = e), $c4aec195e4e78606$export$5880b8b5730aff45 = 0, [];
}
function $c4aec195e4e78606$export$45918ac1574455b1(e) {
    return $c4aec195e4e78606$export$30a86d91af8ff6e6 = "", e;
}
function $c4aec195e4e78606$export$410ac95b9ec204b8(e) {
    return $c4aec195e4e78606$export$87c2784dc9fc4ab($c4aec195e4e78606$export$58adb3bec8346d0f($c4aec195e4e78606$export$5880b8b5730aff45 - 1, $c4aec195e4e78606$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $c4aec195e4e78606$export$660b2ee2d4fb4eff(e) {
    return $c4aec195e4e78606$export$45918ac1574455b1($c4aec195e4e78606$export$5f8c09e3ae6f64e1($c4aec195e4e78606$export$2de70f21292aac9e(e)));
}
function $c4aec195e4e78606$export$7af1228ff777d175(e) {
    while($c4aec195e4e78606$export$c0306caf338ac095 = $c4aec195e4e78606$export$4d3fb11e950abb9e())if ($c4aec195e4e78606$export$c0306caf338ac095 < 33) $c4aec195e4e78606$export$48cfd1e771a65c4f();
    else break;
    return $c4aec195e4e78606$export$9e1725a4cfeada27(e) > 2 || $c4aec195e4e78606$export$9e1725a4cfeada27($c4aec195e4e78606$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $c4aec195e4e78606$export$5f8c09e3ae6f64e1(e) {
    while($c4aec195e4e78606$export$48cfd1e771a65c4f())switch($c4aec195e4e78606$export$9e1725a4cfeada27($c4aec195e4e78606$export$c0306caf338ac095)){
        case 0:
            $c4aec195e4e78606$export$10d8903dec122b9d($c4aec195e4e78606$export$c2ab62c7bf24634($c4aec195e4e78606$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $c4aec195e4e78606$export$10d8903dec122b9d($c4aec195e4e78606$export$410ac95b9ec204b8($c4aec195e4e78606$export$c0306caf338ac095), e);
            break;
        default:
            $c4aec195e4e78606$export$10d8903dec122b9d($c4aec195e4e78606$export$6788812c4e6611e6($c4aec195e4e78606$export$c0306caf338ac095), e);
    }
    return e;
}
function $c4aec195e4e78606$export$955ba06d119e085e(e, r) {
    while(--r && $c4aec195e4e78606$export$48cfd1e771a65c4f())if ($c4aec195e4e78606$export$c0306caf338ac095 < 48 || $c4aec195e4e78606$export$c0306caf338ac095 > 102 || $c4aec195e4e78606$export$c0306caf338ac095 > 57 && $c4aec195e4e78606$export$c0306caf338ac095 < 65 || $c4aec195e4e78606$export$c0306caf338ac095 > 70 && $c4aec195e4e78606$export$c0306caf338ac095 < 97) break;
    return $c4aec195e4e78606$export$58adb3bec8346d0f(e, $c4aec195e4e78606$export$e88cb2efb12ae807() + (r < 6 && $c4aec195e4e78606$export$4d3fb11e950abb9e() == 32 && $c4aec195e4e78606$export$48cfd1e771a65c4f() == 32));
}
function $c4aec195e4e78606$export$c889f2fcc19dbf12(e) {
    while($c4aec195e4e78606$export$48cfd1e771a65c4f())switch($c4aec195e4e78606$export$c0306caf338ac095){
        case e:
            return $c4aec195e4e78606$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $c4aec195e4e78606$export$c889f2fcc19dbf12($c4aec195e4e78606$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $c4aec195e4e78606$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $c4aec195e4e78606$export$48cfd1e771a65c4f();
            break;
    }
    return $c4aec195e4e78606$export$5880b8b5730aff45;
}
function $c4aec195e4e78606$export$4254d4e2b3745c4c(e, r) {
    while($c4aec195e4e78606$export$48cfd1e771a65c4f())if (e + $c4aec195e4e78606$export$c0306caf338ac095 === 57) break;
    else if (e + $c4aec195e4e78606$export$c0306caf338ac095 === 84 && $c4aec195e4e78606$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $c4aec195e4e78606$export$58adb3bec8346d0f(r, $c4aec195e4e78606$export$5880b8b5730aff45 - 1) + "*" + $c4aec195e4e78606$export$6788812c4e6611e6(e === 47 ? e : $c4aec195e4e78606$export$48cfd1e771a65c4f());
}
function $c4aec195e4e78606$export$c2ab62c7bf24634(e) {
    while(!$c4aec195e4e78606$export$9e1725a4cfeada27($c4aec195e4e78606$export$4d3fb11e950abb9e()))$c4aec195e4e78606$export$48cfd1e771a65c4f();
    return $c4aec195e4e78606$export$58adb3bec8346d0f(e, $c4aec195e4e78606$export$5880b8b5730aff45);
}
function $c4aec195e4e78606$export$ef7acd7185315e22(e) {
    return $c4aec195e4e78606$export$45918ac1574455b1($c4aec195e4e78606$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $c4aec195e4e78606$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $c4aec195e4e78606$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $c4aec195e4e78606$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $c4aec195e4e78606$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($c4aec195e4e78606$export$f8e21b1e77979a08(z += $c4aec195e4e78606$export$77ad94ebf1c2b9ed($c4aec195e4e78606$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $c4aec195e4e78606$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $c4aec195e4e78606$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $c4aec195e4e78606$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $c4aec195e4e78606$export$955ba06d119e085e($c4aec195e4e78606$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($c4aec195e4e78606$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $c4aec195e4e78606$export$10d8903dec122b9d($c4aec195e4e78606$export$4a34f930e789283c($c4aec195e4e78606$export$4254d4e2b3745c4c($c4aec195e4e78606$export$48cfd1e771a65c4f(), $c4aec195e4e78606$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $c4aec195e4e78606$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $c4aec195e4e78606$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $c4aec195e4e78606$export$36776f635604f274(z) - l) $c4aec195e4e78606$export$10d8903dec122b9d(p > 32 ? $c4aec195e4e78606$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $c4aec195e4e78606$export$f8483753829ec8f3($c4aec195e4e78606$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $c4aec195e4e78606$export$10d8903dec122b9d(j = $c4aec195e4e78606$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $c4aec195e4e78606$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $c4aec195e4e78606$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $c4aec195e4e78606$export$98e6a39c04603d36(e, j, j, n && $c4aec195e4e78606$export$10d8903dec122b9d($c4aec195e4e78606$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $c4aec195e4e78606$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $c4aec195e4e78606$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $c4aec195e4e78606$export$232faf9add678146() == 125) continue;
            }
            switch(z += $c4aec195e4e78606$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($c4aec195e4e78606$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($c4aec195e4e78606$export$4d3fb11e950abb9e() === 45) z += $c4aec195e4e78606$export$410ac95b9ec204b8($c4aec195e4e78606$export$48cfd1e771a65c4f());
                    v = $c4aec195e4e78606$export$4d3fb11e950abb9e(), o = l = $c4aec195e4e78606$export$36776f635604f274(k = z += $c4aec195e4e78606$export$c2ab62c7bf24634($c4aec195e4e78606$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $c4aec195e4e78606$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $c4aec195e4e78606$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $c4aec195e4e78606$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $c4aec195e4e78606$export$2f35ab04d2335697(e, p + 1, p = $c4aec195e4e78606$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $c4aec195e4e78606$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $c4aec195e4e78606$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $c4aec195e4e78606$export$35059013cd4a06db(e, r, a, s === 0 ? $c4aec195e4e78606$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $c4aec195e4e78606$export$4a34f930e789283c(e, r, a, c) {
    return $c4aec195e4e78606$export$35059013cd4a06db(e, r, a, $c4aec195e4e78606$export$a29989082612d0d9, $c4aec195e4e78606$export$6788812c4e6611e6($c4aec195e4e78606$export$eba6f6f03b0a92e7()), $c4aec195e4e78606$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $c4aec195e4e78606$export$f8483753829ec8f3(e, r, a, n, c) {
    return $c4aec195e4e78606$export$35059013cd4a06db(e, r, a, $c4aec195e4e78606$export$527d108ccf083c2b, $c4aec195e4e78606$export$2f35ab04d2335697(e, 0, n), $c4aec195e4e78606$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $c4aec195e4e78606$export$82e9f45cca5ba907(n, c, s) {
    switch($c4aec195e4e78606$export$d6af199866bfb566(n, c)){
        case 5103:
            return $c4aec195e4e78606$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $c4aec195e4e78606$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $c4aec195e4e78606$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $c4aec195e4e78606$export$39dfd62a25e0fe93 + n + $c4aec195e4e78606$export$2c0f367103c8d01c + n + $c4aec195e4e78606$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($c4aec195e4e78606$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $c4aec195e4e78606$export$39dfd62a25e0fe93 + n + $c4aec195e4e78606$export$71ad59f2e432cfe8 + $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $c4aec195e4e78606$export$39dfd62a25e0fe93 + n + $c4aec195e4e78606$export$71ad59f2e432cfe8 + $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $c4aec195e4e78606$export$39dfd62a25e0fe93 + n + $c4aec195e4e78606$export$71ad59f2e432cfe8 + $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $c4aec195e4e78606$export$39dfd62a25e0fe93 + n + $c4aec195e4e78606$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $c4aec195e4e78606$export$39dfd62a25e0fe93 + n + $c4aec195e4e78606$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $c4aec195e4e78606$export$39dfd62a25e0fe93 + n + $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $c4aec195e4e78606$export$39dfd62a25e0fe93 + "box-$1$2" + $c4aec195e4e78606$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $c4aec195e4e78606$export$39dfd62a25e0fe93 + n + $c4aec195e4e78606$export$71ad59f2e432cfe8 + "flex-item-" + $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$c4aec195e4e78606$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $c4aec195e4e78606$export$71ad59f2e432cfe8 + "grid-row-" + $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $c4aec195e4e78606$export$39dfd62a25e0fe93 + n + $c4aec195e4e78606$export$71ad59f2e432cfe8 + "flex-line-pack" + $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $c4aec195e4e78606$export$39dfd62a25e0fe93 + n + $c4aec195e4e78606$export$71ad59f2e432cfe8 + $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $c4aec195e4e78606$export$39dfd62a25e0fe93 + n + $c4aec195e4e78606$export$71ad59f2e432cfe8 + $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $c4aec195e4e78606$export$39dfd62a25e0fe93 + "box-" + $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, "-grow", "") + $c4aec195e4e78606$export$39dfd62a25e0fe93 + n + $c4aec195e4e78606$export$71ad59f2e432cfe8 + $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $c4aec195e4e78606$export$39dfd62a25e0fe93 + $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $c4aec195e4e78606$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $c4aec195e4e78606$export$77ad94ebf1c2b9ed($c4aec195e4e78606$export$77ad94ebf1c2b9ed($c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $c4aec195e4e78606$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $c4aec195e4e78606$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $c4aec195e4e78606$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $c4aec195e4e78606$export$77ad94ebf1c2b9ed($c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $c4aec195e4e78606$export$39dfd62a25e0fe93 + "box-pack:$3" + $c4aec195e4e78606$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $c4aec195e4e78606$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$c4aec195e4e78606$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $c4aec195e4e78606$export$71ad59f2e432cfe8 + "grid-column-align" + $c4aec195e4e78606$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $c4aec195e4e78606$export$71ad59f2e432cfe8 + $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $c4aec195e4e78606$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$c4aec195e4e78606$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $c4aec195e4e78606$export$71ad59f2e432cfe8 + $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $c4aec195e4e78606$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$c4aec195e4e78606$export$f8e21b1e77979a08(s, "span", 0) ? $c4aec195e4e78606$export$4659b591c19bdf3d(s, /\d+/) : +$c4aec195e4e78606$export$4659b591c19bdf3d(s, /\d+/) - +$c4aec195e4e78606$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $c4aec195e4e78606$export$71ad59f2e432cfe8 + $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $c4aec195e4e78606$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $c4aec195e4e78606$export$71ad59f2e432cfe8 + $c4aec195e4e78606$export$77ad94ebf1c2b9ed($c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $c4aec195e4e78606$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($c4aec195e4e78606$export$36776f635604f274(n) - 1 - c > 6) switch($c4aec195e4e78606$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($c4aec195e4e78606$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $c4aec195e4e78606$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $c4aec195e4e78606$export$2c0f367103c8d01c + ($c4aec195e4e78606$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$c4aec195e4e78606$export$f8e21b1e77979a08(n, "stretch", 0) ? $c4aec195e4e78606$export$82e9f45cca5ba907($c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $c4aec195e4e78606$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $c4aec195e4e78606$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($c4aec195e4e78606$export$a9db5e087081082d(n, c + 6) === 121) return $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, ":", ":" + $c4aec195e4e78606$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($c4aec195e4e78606$export$a9db5e087081082d(n, $c4aec195e4e78606$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $c4aec195e4e78606$export$39dfd62a25e0fe93 + ($c4aec195e4e78606$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $c4aec195e4e78606$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $c4aec195e4e78606$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, ":", ":" + $c4aec195e4e78606$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $c4aec195e4e78606$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $c4aec195e4e78606$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $c4aec195e4e78606$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $c4aec195e4e78606$export$a763edbf796b780a:
        case $c4aec195e4e78606$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $c4aec195e4e78606$export$a29989082612d0d9:
            return "";
        case $c4aec195e4e78606$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $c4aec195e4e78606$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $c4aec195e4e78606$export$aa3a2e812ca8570d:
            if (!$c4aec195e4e78606$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $c4aec195e4e78606$export$36776f635604f274(a = $c4aec195e4e78606$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $c4aec195e4e78606$export$5a7767152ae0305f(e) {
    var r = $c4aec195e4e78606$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $c4aec195e4e78606$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $c4aec195e4e78606$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $c4aec195e4e78606$export$527d108ccf083c2b:
                n.return = $c4aec195e4e78606$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $c4aec195e4e78606$export$b44a8529a35fcb60:
                return $c4aec195e4e78606$export$dfdc1655ccc5b9cb([
                    $c4aec195e4e78606$export$784d13d8ee351f07(n, {
                        value: $c4aec195e4e78606$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $c4aec195e4e78606$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $c4aec195e4e78606$export$aa3a2e812ca8570d:
                if (n.length) return $c4aec195e4e78606$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($c4aec195e4e78606$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $c4aec195e4e78606$export$590e8b2c435046d9($c4aec195e4e78606$export$784d13d8ee351f07(n, {
                                props: [
                                    $c4aec195e4e78606$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $c4aec195e4e78606$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $c4aec195e4e78606$export$590e8b2c435046d9($c4aec195e4e78606$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $c4aec195e4e78606$export$e6e34fd1f2686227(n, {
                                props: $c4aec195e4e78606$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $c4aec195e4e78606$export$590e8b2c435046d9($c4aec195e4e78606$export$784d13d8ee351f07(n, {
                                props: [
                                    $c4aec195e4e78606$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $c4aec195e4e78606$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $c4aec195e4e78606$export$590e8b2c435046d9($c4aec195e4e78606$export$784d13d8ee351f07(n, {
                                props: [
                                    $c4aec195e4e78606$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $c4aec195e4e78606$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $c4aec195e4e78606$export$590e8b2c435046d9($c4aec195e4e78606$export$784d13d8ee351f07(n, {
                                props: [
                                    $c4aec195e4e78606$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $c4aec195e4e78606$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $c4aec195e4e78606$export$590e8b2c435046d9($c4aec195e4e78606$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $c4aec195e4e78606$export$e6e34fd1f2686227(n, {
                                props: $c4aec195e4e78606$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $c4aec195e4e78606$export$76a88f7de6507443(e) {
    switch(e.type){
        case $c4aec195e4e78606$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $c4aec195e4e78606$export$1be1fc439b849fdf($c4aec195e4e78606$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($c4aec195e4e78606$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $c4aec195e4e78606$export$2f35ab04d2335697(r, 1, $c4aec195e4e78606$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $c4aec195e4e78606$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $c4aec195e4e78606$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $c4aec195e4e78606$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $7f66e85e02307542$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $ad8be9eb1eeade5d$exports = {};
// shim for using process in browser
var $ad8be9eb1eeade5d$var$process = $ad8be9eb1eeade5d$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $ad8be9eb1eeade5d$var$cachedSetTimeout;
var $ad8be9eb1eeade5d$var$cachedClearTimeout;
function $ad8be9eb1eeade5d$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $ad8be9eb1eeade5d$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $ad8be9eb1eeade5d$var$cachedSetTimeout = setTimeout;
        else $ad8be9eb1eeade5d$var$cachedSetTimeout = $ad8be9eb1eeade5d$var$defaultSetTimout;
    } catch (e) {
        $ad8be9eb1eeade5d$var$cachedSetTimeout = $ad8be9eb1eeade5d$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $ad8be9eb1eeade5d$var$cachedClearTimeout = clearTimeout;
        else $ad8be9eb1eeade5d$var$cachedClearTimeout = $ad8be9eb1eeade5d$var$defaultClearTimeout;
    } catch (e) {
        $ad8be9eb1eeade5d$var$cachedClearTimeout = $ad8be9eb1eeade5d$var$defaultClearTimeout;
    }
})();
function $ad8be9eb1eeade5d$var$runTimeout(fun) {
    if ($ad8be9eb1eeade5d$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($ad8be9eb1eeade5d$var$cachedSetTimeout === $ad8be9eb1eeade5d$var$defaultSetTimout || !$ad8be9eb1eeade5d$var$cachedSetTimeout) && setTimeout) {
        $ad8be9eb1eeade5d$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ad8be9eb1eeade5d$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $ad8be9eb1eeade5d$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $ad8be9eb1eeade5d$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $ad8be9eb1eeade5d$var$runClearTimeout(marker) {
    if ($ad8be9eb1eeade5d$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($ad8be9eb1eeade5d$var$cachedClearTimeout === $ad8be9eb1eeade5d$var$defaultClearTimeout || !$ad8be9eb1eeade5d$var$cachedClearTimeout) && clearTimeout) {
        $ad8be9eb1eeade5d$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ad8be9eb1eeade5d$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $ad8be9eb1eeade5d$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $ad8be9eb1eeade5d$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $ad8be9eb1eeade5d$var$queue = [];
var $ad8be9eb1eeade5d$var$draining = false;
var $ad8be9eb1eeade5d$var$currentQueue;
var $ad8be9eb1eeade5d$var$queueIndex = -1;
function $ad8be9eb1eeade5d$var$cleanUpNextTick() {
    if (!$ad8be9eb1eeade5d$var$draining || !$ad8be9eb1eeade5d$var$currentQueue) return;
    $ad8be9eb1eeade5d$var$draining = false;
    if ($ad8be9eb1eeade5d$var$currentQueue.length) $ad8be9eb1eeade5d$var$queue = $ad8be9eb1eeade5d$var$currentQueue.concat($ad8be9eb1eeade5d$var$queue);
    else $ad8be9eb1eeade5d$var$queueIndex = -1;
    if ($ad8be9eb1eeade5d$var$queue.length) $ad8be9eb1eeade5d$var$drainQueue();
}
function $ad8be9eb1eeade5d$var$drainQueue() {
    if ($ad8be9eb1eeade5d$var$draining) return;
    var timeout = $ad8be9eb1eeade5d$var$runTimeout($ad8be9eb1eeade5d$var$cleanUpNextTick);
    $ad8be9eb1eeade5d$var$draining = true;
    var len = $ad8be9eb1eeade5d$var$queue.length;
    while(len){
        $ad8be9eb1eeade5d$var$currentQueue = $ad8be9eb1eeade5d$var$queue;
        $ad8be9eb1eeade5d$var$queue = [];
        while(++$ad8be9eb1eeade5d$var$queueIndex < len)if ($ad8be9eb1eeade5d$var$currentQueue) $ad8be9eb1eeade5d$var$currentQueue[$ad8be9eb1eeade5d$var$queueIndex].run();
        $ad8be9eb1eeade5d$var$queueIndex = -1;
        len = $ad8be9eb1eeade5d$var$queue.length;
    }
    $ad8be9eb1eeade5d$var$currentQueue = null;
    $ad8be9eb1eeade5d$var$draining = false;
    $ad8be9eb1eeade5d$var$runClearTimeout(timeout);
}
$ad8be9eb1eeade5d$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $ad8be9eb1eeade5d$var$queue.push(new $ad8be9eb1eeade5d$var$Item(fun, args));
    if ($ad8be9eb1eeade5d$var$queue.length === 1 && !$ad8be9eb1eeade5d$var$draining) $ad8be9eb1eeade5d$var$runTimeout($ad8be9eb1eeade5d$var$drainQueue);
};
// v8 likes predictible objects
function $ad8be9eb1eeade5d$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$ad8be9eb1eeade5d$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$ad8be9eb1eeade5d$var$process.title = 'browser';
$ad8be9eb1eeade5d$var$process.browser = true;
$ad8be9eb1eeade5d$var$process.env = {};
$ad8be9eb1eeade5d$var$process.argv = [];
$ad8be9eb1eeade5d$var$process.version = ''; // empty string to avoid regexp issues
$ad8be9eb1eeade5d$var$process.versions = {};
function $ad8be9eb1eeade5d$var$noop() {}
$ad8be9eb1eeade5d$var$process.on = $ad8be9eb1eeade5d$var$noop;
$ad8be9eb1eeade5d$var$process.addListener = $ad8be9eb1eeade5d$var$noop;
$ad8be9eb1eeade5d$var$process.once = $ad8be9eb1eeade5d$var$noop;
$ad8be9eb1eeade5d$var$process.off = $ad8be9eb1eeade5d$var$noop;
$ad8be9eb1eeade5d$var$process.removeListener = $ad8be9eb1eeade5d$var$noop;
$ad8be9eb1eeade5d$var$process.removeAllListeners = $ad8be9eb1eeade5d$var$noop;
$ad8be9eb1eeade5d$var$process.emit = $ad8be9eb1eeade5d$var$noop;
$ad8be9eb1eeade5d$var$process.prependListener = $ad8be9eb1eeade5d$var$noop;
$ad8be9eb1eeade5d$var$process.prependOnceListener = $ad8be9eb1eeade5d$var$noop;
$ad8be9eb1eeade5d$var$process.listeners = function(name) {
    return [];
};
$ad8be9eb1eeade5d$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$ad8be9eb1eeade5d$var$process.cwd = function() {
    return '/';
};
$ad8be9eb1eeade5d$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$ad8be9eb1eeade5d$var$process.umask = function() {
    return 0;
};


var $6a8d69d2aa3d57e7$var$f = ("undefined" != typeof $ad8be9eb1eeade5d$exports && void 0 !== $ad8be9eb1eeade5d$exports.env && undefined, "data-styled"), $6a8d69d2aa3d57e7$var$m = "active", $6a8d69d2aa3d57e7$var$y = "data-styled-version", $6a8d69d2aa3d57e7$export$83d89fbfd8236492 = "6.1.13", $6a8d69d2aa3d57e7$var$g = "/*!sc*/\n", $6a8d69d2aa3d57e7$var$S = "undefined" != typeof window && "HTMLElement" in window, $6a8d69d2aa3d57e7$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $ad8be9eb1eeade5d$exports && $ad8be9eb1eeade5d$exports.env, "undefined" != typeof $ad8be9eb1eeade5d$exports && $ad8be9eb1eeade5d$exports.env, false)), $6a8d69d2aa3d57e7$var$b = {}, $6a8d69d2aa3d57e7$var$E = /invalid hook call/i, $6a8d69d2aa3d57e7$var$N = new Set, $6a8d69d2aa3d57e7$var$P = function P(t, n) {
    var _$o, s, i, a, e;
}, $6a8d69d2aa3d57e7$var$_ = Object.freeze([]), $6a8d69d2aa3d57e7$var$C = Object.freeze({});
function $6a8d69d2aa3d57e7$var$I(e, t, n) {
    return void 0 === n && (n = $6a8d69d2aa3d57e7$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $6a8d69d2aa3d57e7$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $6a8d69d2aa3d57e7$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $6a8d69d2aa3d57e7$var$D = /(^-|-$)/g;
function $6a8d69d2aa3d57e7$var$R(e) {
    return e.replace($6a8d69d2aa3d57e7$var$O, "-").replace($6a8d69d2aa3d57e7$var$D, "");
}
var $6a8d69d2aa3d57e7$var$T = /(a)(d)/gi, $6a8d69d2aa3d57e7$var$k = 52, $6a8d69d2aa3d57e7$var$j = function j(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $6a8d69d2aa3d57e7$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $6a8d69d2aa3d57e7$var$k; t = t / $6a8d69d2aa3d57e7$var$k | 0)n = $6a8d69d2aa3d57e7$var$j(t % $6a8d69d2aa3d57e7$var$k) + n;
    return ($6a8d69d2aa3d57e7$var$j(t % $6a8d69d2aa3d57e7$var$k) + n).replace($6a8d69d2aa3d57e7$var$T, "$1-$2");
}
var $6a8d69d2aa3d57e7$var$V, $6a8d69d2aa3d57e7$var$F = 5381, $6a8d69d2aa3d57e7$var$M = function M(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $6a8d69d2aa3d57e7$var$z = function z(e) {
    return $6a8d69d2aa3d57e7$var$M($6a8d69d2aa3d57e7$var$F, e);
};
function $6a8d69d2aa3d57e7$var$$(e) {
    return $6a8d69d2aa3d57e7$var$x($6a8d69d2aa3d57e7$var$z(e) >>> 0);
}
function $6a8d69d2aa3d57e7$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $6a8d69d2aa3d57e7$var$L(e) {
    return "string" == typeof e && true;
}
var $6a8d69d2aa3d57e7$var$G = "function" == typeof Symbol && Symbol.for, $6a8d69d2aa3d57e7$var$Y = $6a8d69d2aa3d57e7$var$G ? Symbol.for("react.memo") : 60115, $6a8d69d2aa3d57e7$var$W = $6a8d69d2aa3d57e7$var$G ? Symbol.for("react.forward_ref") : 60112, $6a8d69d2aa3d57e7$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $6a8d69d2aa3d57e7$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $6a8d69d2aa3d57e7$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $6a8d69d2aa3d57e7$var$J = (($6a8d69d2aa3d57e7$var$V = {})[$6a8d69d2aa3d57e7$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $6a8d69d2aa3d57e7$var$V[$6a8d69d2aa3d57e7$var$Y] = $6a8d69d2aa3d57e7$var$U, $6a8d69d2aa3d57e7$var$V);
function $6a8d69d2aa3d57e7$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $6a8d69d2aa3d57e7$var$Y ? $6a8d69d2aa3d57e7$var$U : "$$typeof" in e ? $6a8d69d2aa3d57e7$var$J[e.$$typeof] : $6a8d69d2aa3d57e7$var$q;
}
var $6a8d69d2aa3d57e7$var$Z = Object.defineProperty, $6a8d69d2aa3d57e7$var$K = Object.getOwnPropertyNames, $6a8d69d2aa3d57e7$var$Q = Object.getOwnPropertySymbols, $6a8d69d2aa3d57e7$var$ee = Object.getOwnPropertyDescriptor, $6a8d69d2aa3d57e7$var$te = Object.getPrototypeOf, $6a8d69d2aa3d57e7$var$ne = Object.prototype;
function $6a8d69d2aa3d57e7$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($6a8d69d2aa3d57e7$var$ne) {
            var _$o = $6a8d69d2aa3d57e7$var$te(t);
            _$o && _$o !== $6a8d69d2aa3d57e7$var$ne && $6a8d69d2aa3d57e7$var$oe(e, _$o, n);
        }
        var r = $6a8d69d2aa3d57e7$var$K(t);
        $6a8d69d2aa3d57e7$var$Q && (r = r.concat($6a8d69d2aa3d57e7$var$Q(t)));
        for(var s = $6a8d69d2aa3d57e7$var$X(e), i = $6a8d69d2aa3d57e7$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $6a8d69d2aa3d57e7$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $6a8d69d2aa3d57e7$var$ee(t, c);
                try {
                    $6a8d69d2aa3d57e7$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $6a8d69d2aa3d57e7$var$re(e) {
    return "function" == typeof e;
}
function $6a8d69d2aa3d57e7$export$7ba318d8d2f06c76(e) {
    return "object" == (typeof e === "undefined" ? "undefined" : (0, $27SFb._)(e)) && "styledComponentId" in e;
}
function $6a8d69d2aa3d57e7$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $6a8d69d2aa3d57e7$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], _$o = 1; _$o < e.length; _$o++)n += t ? t + e[_$o] : e[_$o];
    return n;
}
function $6a8d69d2aa3d57e7$var$ce(e) {
    return null !== e && "object" == (typeof e === "undefined" ? "undefined" : (0, $27SFb._)(e)) && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $6a8d69d2aa3d57e7$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$6a8d69d2aa3d57e7$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var _$o = 0; _$o < t.length; _$o++)e[_$o] = $6a8d69d2aa3d57e7$var$le(e[_$o], t[_$o]);
    else if ($6a8d69d2aa3d57e7$var$ce(t)) for(var _$o in t)e[_$o] = $6a8d69d2aa3d57e7$var$le(e[_$o], t[_$o]);
    return e;
}
function $6a8d69d2aa3d57e7$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $6a8d69d2aa3d57e7$var$pe = {};
function $6a8d69d2aa3d57e7$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], _$o = [], r = 1, s = e.length; r < s; r += 1)_$o.push(e[r]);
    return _$o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $6a8d69d2aa3d57e7$var$he(t) {
    for(var n = [], _$o = 1; _$o < arguments.length; _$o++)n[_$o - 1] = arguments[_$o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $6a8d69d2aa3d57e7$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, _$o = n.length, r = _$o; e >= r;)if ((r <<= 1) < 0) throw $6a8d69d2aa3d57e7$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = _$o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), _$o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < _$o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], _$o = this.indexOfGroup(e), r = _$o + n, s = _$o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($6a8d69d2aa3d57e7$var$g);
        return t;
    }, e;
}(), $6a8d69d2aa3d57e7$var$me = 1073741824, $6a8d69d2aa3d57e7$var$ye = new Map, $6a8d69d2aa3d57e7$var$ve = new Map, $6a8d69d2aa3d57e7$var$ge = 1, $6a8d69d2aa3d57e7$var$Se = function Se(e) {
    if ($6a8d69d2aa3d57e7$var$ye.has(e)) return $6a8d69d2aa3d57e7$var$ye.get(e);
    for(; $6a8d69d2aa3d57e7$var$ve.has($6a8d69d2aa3d57e7$var$ge);)$6a8d69d2aa3d57e7$var$ge++;
    var t = $6a8d69d2aa3d57e7$var$ge++;
    return $6a8d69d2aa3d57e7$var$ye.set(e, t), $6a8d69d2aa3d57e7$var$ve.set(t, e), t;
}, $6a8d69d2aa3d57e7$var$we = function we(e, t) {
    $6a8d69d2aa3d57e7$var$ge = t + 1, $6a8d69d2aa3d57e7$var$ye.set(e, t), $6a8d69d2aa3d57e7$var$ve.set(t, e);
}, $6a8d69d2aa3d57e7$var$be = "style[".concat($6a8d69d2aa3d57e7$var$f, "][").concat($6a8d69d2aa3d57e7$var$y, '="').concat($6a8d69d2aa3d57e7$export$83d89fbfd8236492, '"]'), $6a8d69d2aa3d57e7$var$Ee = new RegExp("^".concat($6a8d69d2aa3d57e7$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $6a8d69d2aa3d57e7$var$Ne = function Ne(e, t, n) {
    for(var _$o, r = n.split(","), s = 0, i = r.length; s < i; s++)(_$o = r[s]) && e.registerName(t, _$o);
}, $6a8d69d2aa3d57e7$var$Pe = function Pe(e, t) {
    for(var n, _$o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($6a8d69d2aa3d57e7$var$g), r = [], s = 0, i = _$o.length; s < i; s++){
        var a = _$o[s].trim();
        if (a) {
            var c = a.match($6a8d69d2aa3d57e7$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($6a8d69d2aa3d57e7$var$we(u, l), $6a8d69d2aa3d57e7$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $6a8d69d2aa3d57e7$var$_e = function _e(e) {
    for(var t = document.querySelectorAll($6a8d69d2aa3d57e7$var$be), n = 0, _$o = t.length; n < _$o; n++){
        var r = t[n];
        r && r.getAttribute($6a8d69d2aa3d57e7$var$f) !== $6a8d69d2aa3d57e7$var$m && ($6a8d69d2aa3d57e7$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $6a8d69d2aa3d57e7$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $6a8d69d2aa3d57e7$var$Ie = function Ie(e) {
    var t = document.head, n = e || t, _$o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($6a8d69d2aa3d57e7$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    _$o.setAttribute($6a8d69d2aa3d57e7$var$f, $6a8d69d2aa3d57e7$var$m), _$o.setAttribute($6a8d69d2aa3d57e7$var$y, $6a8d69d2aa3d57e7$export$83d89fbfd8236492);
    var i = $6a8d69d2aa3d57e7$var$Ce();
    return i && _$o.setAttribute("nonce", i), n.insertBefore(_$o, s), _$o;
}, $6a8d69d2aa3d57e7$var$Ae = function() {
    function e(e) {
        this.element = $6a8d69d2aa3d57e7$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, _$o = t.length; n < _$o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $6a8d69d2aa3d57e7$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $6a8d69d2aa3d57e7$var$Oe = function() {
    function e(e) {
        this.element = $6a8d69d2aa3d57e7$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $6a8d69d2aa3d57e7$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $6a8d69d2aa3d57e7$var$Re = $6a8d69d2aa3d57e7$var$S, $6a8d69d2aa3d57e7$var$Te = {
    isServer: !$6a8d69d2aa3d57e7$var$S,
    useCSSOMInjection: !$6a8d69d2aa3d57e7$var$w
}, $6a8d69d2aa3d57e7$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $6a8d69d2aa3d57e7$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $c9b1471f73a231b2$export$18ce0697a983be9b)((0, $c9b1471f73a231b2$export$18ce0697a983be9b)({}, $6a8d69d2aa3d57e7$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $6a8d69d2aa3d57e7$var$S && $6a8d69d2aa3d57e7$var$Re && ($6a8d69d2aa3d57e7$var$Re = !1, $6a8d69d2aa3d57e7$var$_e(this)), $6a8d69d2aa3d57e7$var$ue(this, function() {
            return function(e) {
                for(var _$t = e.getTag(), _$n = _$t.length, _$o = "", r = function r(n) {
                    var r = function(e) {
                        return $6a8d69d2aa3d57e7$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = _$t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($6a8d69d2aa3d57e7$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), _$o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($6a8d69d2aa3d57e7$var$g);
                }, s = 0; s < _$n; s++)r(s);
                return _$o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $6a8d69d2aa3d57e7$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $6a8d69d2aa3d57e7$var$S && $6a8d69d2aa3d57e7$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $c9b1471f73a231b2$export$18ce0697a983be9b)((0, $c9b1471f73a231b2$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var _$e;
        return this.tag || (this.tag = (_$e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $6a8d69d2aa3d57e7$var$De(n) : t ? new $6a8d69d2aa3d57e7$var$Ae(n) : new $6a8d69d2aa3d57e7$var$Oe(n);
        }(this.options), new $6a8d69d2aa3d57e7$var$fe(_$e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($6a8d69d2aa3d57e7$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($6a8d69d2aa3d57e7$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($6a8d69d2aa3d57e7$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $6a8d69d2aa3d57e7$var$je = /&/g, $6a8d69d2aa3d57e7$var$xe = /^\s*\/\/.*$/gm;
function $6a8d69d2aa3d57e7$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $6a8d69d2aa3d57e7$var$Ve(e.children, t)), e;
    });
}
function $6a8d69d2aa3d57e7$var$Fe(e) {
    var t, n, _$o, r = void 0 === e ? $6a8d69d2aa3d57e7$var$C : e, s = r.options, i = void 0 === s ? $6a8d69d2aa3d57e7$var$C : s, a = r.plugins, c = void 0 === a ? $6a8d69d2aa3d57e7$var$_ : a, l = function l(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $c4aec195e4e78606$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($6a8d69d2aa3d57e7$var$je, n).replace(_$o, l));
    }), i.prefix && u.push($c4aec195e4e78606$export$e08c7d021b829b7a), u.push($c4aec195e4e78606$export$fac44ee5b035f737);
    var p = function p(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, _$o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($6a8d69d2aa3d57e7$var$xe, ""), l = $c4aec195e4e78606$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $6a8d69d2aa3d57e7$var$Ve(l, i.namespace));
        var p = [];
        return $c4aec195e4e78606$export$dfdc1655ccc5b9cb(l, $c4aec195e4e78606$export$5a7767152ae0305f(u.concat($c4aec195e4e78606$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $6a8d69d2aa3d57e7$var$he(15), $6a8d69d2aa3d57e7$var$M(e, t.name);
    }, $6a8d69d2aa3d57e7$var$F).toString() : "", p;
}
var $6a8d69d2aa3d57e7$var$Me = new $6a8d69d2aa3d57e7$var$ke, $6a8d69d2aa3d57e7$var$ze = $6a8d69d2aa3d57e7$var$Fe(), $6a8d69d2aa3d57e7$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $6a8d69d2aa3d57e7$var$Me,
    stylis: $6a8d69d2aa3d57e7$var$ze
}), $6a8d69d2aa3d57e7$export$91317688fc694efa = $6a8d69d2aa3d57e7$export$8c190ef828af4c86.Consumer, $6a8d69d2aa3d57e7$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).createContext(void 0);
function $6a8d69d2aa3d57e7$var$Ge() {
    return (0, $e7uJ5.useContext)($6a8d69d2aa3d57e7$export$8c190ef828af4c86);
}
function $6a8d69d2aa3d57e7$export$a473771da2f0ff7c(e) {
    var t = (0, $e7uJ5.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $6a8d69d2aa3d57e7$var$Ge().styleSheet, l = (0, $e7uJ5.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $e7uJ5.useMemo)(function() {
        return $6a8d69d2aa3d57e7$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $e7uJ5.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($08f454a428c9ca39$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $e7uJ5.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).createElement($6a8d69d2aa3d57e7$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).createElement($6a8d69d2aa3d57e7$var$Le.Provider, {
        value: u
    }, e.children));
}
var $6a8d69d2aa3d57e7$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $6a8d69d2aa3d57e7$var$ze);
            var _$o = n.name + t.hash;
            e.hasNameForId(n.id, _$o) || e.insertRules(n.id, _$o, t(n.rules, _$o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $6a8d69d2aa3d57e7$var$ue(this, function() {
            throw $6a8d69d2aa3d57e7$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $6a8d69d2aa3d57e7$var$ze), this.name + e.hash;
    }, e;
}(), $6a8d69d2aa3d57e7$var$qe = function qe(e) {
    return e >= "A" && e <= "Z";
};
function $6a8d69d2aa3d57e7$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var _$o = e[n];
        if (1 === n && "-" === _$o && "-" === e[0]) return e;
        $6a8d69d2aa3d57e7$var$qe(_$o) ? t += "-" + _$o.toLowerCase() : t += _$o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $6a8d69d2aa3d57e7$var$Ue = function Ue(e) {
    return null == e || !1 === e || "" === e;
}, $6a8d69d2aa3d57e7$var$Je = function Je1(t) {
    var n, _$o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$6a8d69d2aa3d57e7$var$Ue(i) && (Array.isArray(i) && i.isCss || $6a8d69d2aa3d57e7$var$re(i) ? r.push("".concat($6a8d69d2aa3d57e7$var$He(s), ":"), i, ";") : $6a8d69d2aa3d57e7$var$ce(i) ? r.push.apply(r, (0, $c9b1471f73a231b2$export$1216008129fb82ed)((0, $c9b1471f73a231b2$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $6a8d69d2aa3d57e7$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($6a8d69d2aa3d57e7$var$He(s), ": ").concat((n = s, null == (_$o = i) || "boolean" == typeof _$o || "" === _$o ? "" : "number" != typeof _$o || 0 === _$o || n in (0, $7f66e85e02307542$export$2e2bcd8739ae039) || n.startsWith("--") ? String(_$o).trim() : "".concat(_$o, "px")), ";")));
    }
    return r;
};
function $6a8d69d2aa3d57e7$var$Xe(e, t, n, o) {
    if ($6a8d69d2aa3d57e7$var$Ue(e)) return [];
    if ($6a8d69d2aa3d57e7$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($6a8d69d2aa3d57e7$var$re(e)) {
        if (!$6a8d69d2aa3d57e7$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $6a8d69d2aa3d57e7$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $6a8d69d2aa3d57e7$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $6a8d69d2aa3d57e7$var$ce(e) ? $6a8d69d2aa3d57e7$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($6a8d69d2aa3d57e7$var$_, e.map(function(e) {
        return $6a8d69d2aa3d57e7$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $6a8d69d2aa3d57e7$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($6a8d69d2aa3d57e7$var$re(n) && !$6a8d69d2aa3d57e7$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $6a8d69d2aa3d57e7$var$Ke = $6a8d69d2aa3d57e7$var$z($6a8d69d2aa3d57e7$export$83d89fbfd8236492), $6a8d69d2aa3d57e7$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $6a8d69d2aa3d57e7$var$Ze(e), this.componentId = t, this.baseHash = $6a8d69d2aa3d57e7$var$M($6a8d69d2aa3d57e7$var$Ke, t), this.baseStyle = n, $6a8d69d2aa3d57e7$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var _$o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) _$o = $6a8d69d2aa3d57e7$var$ie(_$o, this.staticRulesId);
            else {
                var r = $6a8d69d2aa3d57e7$var$ae($6a8d69d2aa3d57e7$var$Xe(this.rules, e, t, n)), s = $6a8d69d2aa3d57e7$var$x($6a8d69d2aa3d57e7$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                _$o = $6a8d69d2aa3d57e7$var$ie(_$o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $6a8d69d2aa3d57e7$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $6a8d69d2aa3d57e7$var$ae($6a8d69d2aa3d57e7$var$Xe(u, e, t, n));
                    a = $6a8d69d2aa3d57e7$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $6a8d69d2aa3d57e7$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), _$o = $6a8d69d2aa3d57e7$var$ie(_$o, d);
            }
        }
        return _$o;
    }, e;
}(), $6a8d69d2aa3d57e7$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).createContext(void 0), $6a8d69d2aa3d57e7$export$b631efc24e9d5e2f = $6a8d69d2aa3d57e7$export$2c657da244d00bd6.Consumer;
function $6a8d69d2aa3d57e7$export$93d4e7f90805808f() {
    var e = (0, $e7uJ5.useContext)($6a8d69d2aa3d57e7$export$2c657da244d00bd6);
    if (!e) throw $6a8d69d2aa3d57e7$var$he(18);
    return e;
}
function $6a8d69d2aa3d57e7$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useContext($6a8d69d2aa3d57e7$export$2c657da244d00bd6), r = (0, $e7uJ5.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $6a8d69d2aa3d57e7$var$he(14);
            if ($6a8d69d2aa3d57e7$var$re(e)) {
                var _$o = e(n);
                return _$o;
            }
            if (Array.isArray(e) || "object" != (typeof e === "undefined" ? "undefined" : (0, $27SFb._)(e))) throw $6a8d69d2aa3d57e7$var$he(8);
            return n ? (0, $c9b1471f73a231b2$export$18ce0697a983be9b)((0, $c9b1471f73a231b2$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).createElement($6a8d69d2aa3d57e7$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $6a8d69d2aa3d57e7$var$rt = {}, $6a8d69d2aa3d57e7$var$st = new Set;
function $6a8d69d2aa3d57e7$var$it(e, r, s) {
    var i = $6a8d69d2aa3d57e7$export$7ba318d8d2f06c76(e), a = e, c = !$6a8d69d2aa3d57e7$var$L(e), p = r.attrs, d = void 0 === p ? $6a8d69d2aa3d57e7$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $6a8d69d2aa3d57e7$var$R(e);
        $6a8d69d2aa3d57e7$var$rt[n] = ($6a8d69d2aa3d57e7$var$rt[n] || 0) + 1;
        var _$o = "".concat(n, "-").concat($6a8d69d2aa3d57e7$var$$($6a8d69d2aa3d57e7$export$83d89fbfd8236492 + n + $6a8d69d2aa3d57e7$var$rt[n]));
        return t ? "".concat(t, "-").concat(_$o) : _$o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $6a8d69d2aa3d57e7$var$L(e) ? "styled.".concat(e) : "Styled(".concat($6a8d69d2aa3d57e7$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($6a8d69d2aa3d57e7$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function w(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $6a8d69d2aa3d57e7$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useContext($6a8d69d2aa3d57e7$export$2c657da244d00bd6), m = $6a8d69d2aa3d57e7$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $6a8d69d2aa3d57e7$var$I(r, f, c) || $6a8d69d2aa3d57e7$var$C, g = function(e, n, o) {
                for(var _$r, _$s = (0, $c9b1471f73a231b2$export$18ce0697a983be9b)((0, $c9b1471f73a231b2$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $6a8d69d2aa3d57e7$var$re(_$r = e[i]) ? _$r(_$s) : _$r;
                    for(var c in a)_$s[c] = "className" === c ? $6a8d69d2aa3d57e7$var$ie(_$s[c], a[c]) : "style" === c ? (0, $c9b1471f73a231b2$export$18ce0697a983be9b)((0, $c9b1471f73a231b2$export$18ce0697a983be9b)({}, _$s[c]), a[c]) : a[c];
                }
                return n.className && (_$s.className = $6a8d69d2aa3d57e7$var$ie(_$s.className, n.className)), _$s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $6a8d69d2aa3d57e7$var$Ge(), _$o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return _$o;
            }(a, g);
            var N = $6a8d69d2aa3d57e7$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$6a8d69d2aa3d57e7$var$L(S) && !$6a8d69d2aa3d57e7$var$A.has(S) ? "class" : "className"] = N, w.ref = s, (0, $e7uJ5.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $6a8d69d2aa3d57e7$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function get() {
            return this._foldedDefaultProps;
        },
        set: function set(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var _$o = 0, _$r = t; _$o < _$r.length; _$o++)$6a8d69d2aa3d57e7$var$le(e, _$r[_$o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $6a8d69d2aa3d57e7$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $6a8d69d2aa3d57e7$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $6a8d69d2aa3d57e7$var$at(e, t) {
    for(var n = [
        e[0]
    ], _$o = 0, r = t.length; _$o < r; _$o += 1)n.push(t[_$o], e[_$o + 1]);
    return n;
}
var $6a8d69d2aa3d57e7$var$ct = function ct(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $6a8d69d2aa3d57e7$export$dbf350e5966cf602(t) {
    for(var n = [], _$o = 1; _$o < arguments.length; _$o++)n[_$o - 1] = arguments[_$o];
    if ($6a8d69d2aa3d57e7$var$re(t) || $6a8d69d2aa3d57e7$var$ce(t)) return $6a8d69d2aa3d57e7$var$ct($6a8d69d2aa3d57e7$var$Xe($6a8d69d2aa3d57e7$var$at($6a8d69d2aa3d57e7$var$_, (0, $c9b1471f73a231b2$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $6a8d69d2aa3d57e7$var$Xe(r) : $6a8d69d2aa3d57e7$var$ct($6a8d69d2aa3d57e7$var$Xe($6a8d69d2aa3d57e7$var$at(r, n)));
}
function $6a8d69d2aa3d57e7$var$ut(n, o, r) {
    if (void 0 === r && (r = $6a8d69d2aa3d57e7$var$C), !o) throw $6a8d69d2aa3d57e7$var$he(1, o);
    var s = function s(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $6a8d69d2aa3d57e7$export$dbf350e5966cf602.apply(void 0, (0, $c9b1471f73a231b2$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $6a8d69d2aa3d57e7$var$ut(n, o, (0, $c9b1471f73a231b2$export$18ce0697a983be9b)((0, $c9b1471f73a231b2$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $6a8d69d2aa3d57e7$var$ut(n, o, (0, $c9b1471f73a231b2$export$18ce0697a983be9b)((0, $c9b1471f73a231b2$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $6a8d69d2aa3d57e7$var$pt = function pt(e) {
    return $6a8d69d2aa3d57e7$var$ut($6a8d69d2aa3d57e7$var$it, e);
}, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039 = $6a8d69d2aa3d57e7$var$pt;
$6a8d69d2aa3d57e7$var$A.forEach(function(e) {
    $6a8d69d2aa3d57e7$export$2e2bcd8739ae039[e] = $6a8d69d2aa3d57e7$var$pt(e);
});
var $6a8d69d2aa3d57e7$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $6a8d69d2aa3d57e7$var$Ze(e), $6a8d69d2aa3d57e7$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($6a8d69d2aa3d57e7$var$ae($6a8d69d2aa3d57e7$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $6a8d69d2aa3d57e7$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $6a8d69d2aa3d57e7$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $6a8d69d2aa3d57e7$export$dbf350e5966cf602.apply(void 0, (0, $c9b1471f73a231b2$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($6a8d69d2aa3d57e7$var$$(JSON.stringify(i))), c = new $6a8d69d2aa3d57e7$var$ht(i, a);
    var l = function l(e) {
        var t = $6a8d69d2aa3d57e7$var$Ge(), _$n = (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useContext($6a8d69d2aa3d57e7$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, _$n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, _$n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            _$n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $6a8d69d2aa3d57e7$var$b, o, s);
        else {
            var i = (0, $c9b1471f73a231b2$export$18ce0697a983be9b)((0, $c9b1471f73a231b2$export$18ce0697a983be9b)({}, n), {
                theme: $6a8d69d2aa3d57e7$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).memo(l);
}
function $6a8d69d2aa3d57e7$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], _$o = 1; _$o < arguments.length; _$o++)n[_$o - 1] = arguments[_$o];
    var r = $6a8d69d2aa3d57e7$var$ae($6a8d69d2aa3d57e7$export$dbf350e5966cf602.apply(void 0, (0, $c9b1471f73a231b2$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $6a8d69d2aa3d57e7$var$$(r);
    return new $6a8d69d2aa3d57e7$var$We(s, r);
}
function $6a8d69d2aa3d57e7$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).forwardRef(function(n, r) {
        var s = $6a8d69d2aa3d57e7$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useContext($6a8d69d2aa3d57e7$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).createElement(e, (0, $c9b1471f73a231b2$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($6a8d69d2aa3d57e7$var$B(e), ")"), $6a8d69d2aa3d57e7$var$oe(n, e);
}
var $6a8d69d2aa3d57e7$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var _$e = this;
        this._emitSheetCSS = function() {
            var t = _$e.instance.toString();
            if (!t) return "";
            var n = $6a8d69d2aa3d57e7$var$Ce(), _$o = $6a8d69d2aa3d57e7$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($6a8d69d2aa3d57e7$var$f, '="true"'),
                "".concat($6a8d69d2aa3d57e7$var$y, '="').concat($6a8d69d2aa3d57e7$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(_$o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (_$e.sealed) throw $6a8d69d2aa3d57e7$var$he(2);
            return _$e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (_$e.sealed) throw $6a8d69d2aa3d57e7$var$he(2);
            var r = _$e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$6a8d69d2aa3d57e7$var$f] = "", n[$6a8d69d2aa3d57e7$var$y] = $6a8d69d2aa3d57e7$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $6a8d69d2aa3d57e7$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).createElement("style", (0, $c9b1471f73a231b2$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            _$e.sealed = !0;
        }, this.instance = new $6a8d69d2aa3d57e7$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $6a8d69d2aa3d57e7$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).createElement($6a8d69d2aa3d57e7$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $6a8d69d2aa3d57e7$var$he(3);
    }, e;
}(), $6a8d69d2aa3d57e7$export$5c87cfe6c475f500 = {
    StyleSheet: $6a8d69d2aa3d57e7$var$ke,
    mainSheet: $6a8d69d2aa3d57e7$var$Me
};
var $6a8d69d2aa3d57e7$var$St = "__sc-".concat($6a8d69d2aa3d57e7$var$f, "__");




parcelRequire("e7uJ5");

var $25a868dbea23500b$export$9a6bb2acef5e644a = 15;
var $25a868dbea23500b$export$cba6217a006ba569 = 25;
var $25a868dbea23500b$export$83e664a9d119a376 = 600;
var $25a868dbea23500b$export$3d5e80817e1f8611 = "(max-width: ".concat($25a868dbea23500b$export$83e664a9d119a376, "px)");
var $25a868dbea23500b$export$57b55975112d979e = "(max-width: 400px)";



parcelRequire("e7uJ5");

function $b8b947fdcf551f8e$var$WrappedIcon(param) {
    var style = param.style, svg = param.svg;
    return /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("div", {
        style: style,
        children: svg
    });
}
function $b8b947fdcf551f8e$export$9b80ee7d1e129684(param) {
    var style = param.style, _param_fill = param.fill, fill = _param_fill === void 0 ? "none" : _param_fill;
    var icon = /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("path", {
            d: "m18 15-6-6-6 6"
        })
    });
    return /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($b8b947fdcf551f8e$var$WrappedIcon, {
        style: style,
        svg: icon
    });
}
function $b8b947fdcf551f8e$export$4e3778eb35f54199(param) {
    var style = param.style, _param_fill = param.fill, fill = _param_fill === void 0 ? "none" : _param_fill;
    var icon = /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("path", {
            d: "m6 9 6 6 6-6"
        })
    });
    return /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($b8b947fdcf551f8e$var$WrappedIcon, {
        style: style,
        svg: icon
    });
}
function $b8b947fdcf551f8e$export$ea3b71af1761ff40(param) {
    var style = param.style, _param_fill = param.fill, fill = _param_fill === void 0 ? "none" : _param_fill;
    var icon = /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("rect", {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1",
                ry: "1"
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("path", {
                d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("path", {
                d: "M16 4h2a2 2 0 0 1 2 2v4"
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("path", {
                d: "M21 14H11"
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("path", {
                d: "m15 10-4 4 4 4"
            })
        ]
    });
    return /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($b8b947fdcf551f8e$var$WrappedIcon, {
        style: style,
        svg: icon
    });
}
function $b8b947fdcf551f8e$export$1644ba17714857f1(param) {
    var style = param.style, _param_fill = param.fill, fill = _param_fill === void 0 ? "none" : _param_fill;
    var icon = /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("path", {
            d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
        })
    });
    return /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($b8b947fdcf551f8e$var$WrappedIcon, {
        style: style,
        svg: icon
    });
}
function $b8b947fdcf551f8e$export$128fdd60f6c96030(param) {
    var style = param.style;
    var icon = /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 600 530",
        fill: "currentColor",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("path", {
            d: "m135.72 44.03c66.496 49.921 138.02 151.14 164.28 205.46 26.262-54.316 97.782-155.54 164.28-205.46 47.98-36.021 125.72-63.892 125.72 24.795 0 17.712-10.155 148.79-16.111 170.07-20.703 73.984-96.144 92.854-163.25 81.433 117.3 19.964 147.14 86.092 82.697 152.22-122.39 125.59-175.91-31.511-189.63-71.766-2.514-7.3797-3.6904-10.832-3.7077-7.8964-0.0174-2.9357-1.1937 0.51669-3.7077 7.8964-13.714 40.255-67.233 197.36-189.63 71.766-64.444-66.128-34.605-132.26 82.697-152.22-67.108 11.421-142.55-7.4491-163.25-81.433-5.9562-21.282-16.111-152.36-16.111-170.07 0-88.687 77.742-60.816 125.72-24.795z"
        })
    });
    return /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($b8b947fdcf551f8e$var$WrappedIcon, {
        style: style,
        svg: icon
    });
}
var $b8b947fdcf551f8e$export$9e389cdad32a5b7a = function(param) {
    var style = param.style;
    var icon = /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 23",
        width: "100%",
        height: "100%",
        style: style,
        children: /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("path", {
            d: "M 24 4.300781 C 23.101563 4.699219 22.199219 5 21.199219 5.101563 C 22.199219 4.5 23 3.5 23.398438 2.398438 C 22.398438 3 21.398438 3.398438 20.300781 3.601563 C 19.300781 2.601563 18 2 16.601563 2 C 13.898438 2 11.699219 4.199219 11.699219 6.898438 C 11.699219 7.300781 11.699219 7.699219 11.800781 8 C 7.699219 7.800781 4.101563 5.898438 1.699219 2.898438 C 1.199219 3.601563 1 4.5 1 5.398438 C 1 7.101563 1.898438 8.601563 3.199219 9.5 C 2.398438 9.398438 1.601563 9.199219 1 8.898438 C 1 8.898438 1 8.898438 1 9 C 1 11.398438 2.699219 13.398438 4.898438 13.800781 C 4.5 13.898438 4.101563 14 3.601563 14 C 3.300781 14 3 14 2.699219 13.898438 C 3.300781 15.898438 5.101563 17.300781 7.300781 17.300781 C 5.601563 18.601563 3.5 19.398438 1.199219 19.398438 C 0.800781 19.398438 0.398438 19.398438 0 19.300781 C 2.199219 20.699219 4.800781 21.5 7.5 21.5 C 16.601563 21.5 21.5 14 21.5 7.5 C 21.5 7.300781 21.5 7.101563 21.5 6.898438 C 22.5 6.199219 23.300781 5.300781 24 4.300781"
        })
    });
    return /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($b8b947fdcf551f8e$var$WrappedIcon, {
        style: style,
        svg: icon
    });
};
var $b8b947fdcf551f8e$export$52f0f02147b12c03 = function(param) {
    var style = param.style, _param_fill = param.fill, fill = _param_fill === void 0 ? "none" : _param_fill;
    var icon = /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("polyline", {
                points: "16 18 22 12 16 6"
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("polyline", {
                points: "8 6 2 12 8 18"
            })
        ]
    });
    return /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($b8b947fdcf551f8e$var$WrappedIcon, {
        style: style,
        svg: icon
    });
};
var $b8b947fdcf551f8e$export$1be7516c0280bee8 = function(param) {
    var style = param.style, _param_fill = param.fill, fill = _param_fill === void 0 ? "none" : _param_fill;
    var icon = /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        style: style,
        children: [
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("path", {
                d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("path", {
                d: "M12 17h.01"
            })
        ]
    });
    return /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($b8b947fdcf551f8e$var$WrappedIcon, {
        style: style,
        svg: icon
    });
};
var $b8b947fdcf551f8e$export$78acf4525d8a74c4 = function(param) {
    var style = param.style, _param_fill = param.fill, fill = _param_fill === void 0 ? "none" : _param_fill;
    var icon = /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("path", {
                d: "M18 6 6 18"
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("path", {
                d: "m6 6 12 12"
            })
        ]
    });
    return /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($b8b947fdcf551f8e$var$WrappedIcon, {
        style: style,
        svg: icon
    });
};
var $b8b947fdcf551f8e$export$60f7169f5ee875bc = function(param) {
    var style = param.style, _param_fill = param.fill, fill = _param_fill === void 0 ? "none" : _param_fill;
    var icon = /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("path", {
                d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("rect", {
                x: "2",
                y: "9",
                width: "4",
                height: "12"
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)("circle", {
                cx: "4",
                cy: "4",
                r: "2"
            })
        ]
    });
    return /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($b8b947fdcf551f8e$var$WrappedIcon, {
        style: style,
        svg: icon
    });
};


var $44e92e235e4eaad6$export$51fe096c4db50bc8 = [
    {
        "type": "OTC",
        "mpid": "AALC",
        "clearingBroker": "0226",
        "brokerName": "THRIVENT INVESTMENT MANAGEMENT, INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "ABAI",
        "clearingBroker": "0279",
        "brokerName": "ABACUS INVESTMENTS, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "ABBA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ABBK",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ABDA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ABDW",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ABEA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ABHE",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ABIG",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ABLE",
        "clearingBroker": "0031",
        "brokerName": "NATIXIS SECURITIES AMERICAS LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "ABNA",
        "clearingBroker": "0349",
        "brokerName": "ABN AMRO SECURITIES (USA) LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "ABPR",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ABRM",
        "clearingBroker": "0534",
        "brokerName": "ABRAHAM & CO., INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "ABRP",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ABST",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ACAD",
        "clearingBroker": "0443",
        "brokerName": "ACADEMY SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "ACAP",
        "clearingBroker": "0235",
        "brokerName": "ALAMO CAPITAL                                                         "
    },
    {
        "type": "OTC",
        "mpid": "ACCI",
        "clearingBroker": "0226",
        "brokerName": "WORTH FINANCIAL GROUP INC                                             "
    },
    {
        "type": "OTC",
        "mpid": "ACCP",
        "clearingBroker": "0158",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "ACCU",
        "clearingBroker": "0052",
        "brokerName": "ATB CAPITAL MARKETS USA INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "ACII",
        "clearingBroker": "0158",
        "brokerName": "ARCA CAPITAL INVESTMENTS, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "ACLP",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER CAPITAL, L.P.                                               "
    },
    {
        "type": "OTC",
        "mpid": "ACLV",
        "clearingBroker": "0294",
        "brokerName": "ALEXANDER CAPITAL, L.P.                                               "
    },
    {
        "type": "OTC",
        "mpid": "ACPL",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN CAPITAL PARTNERS                                             "
    },
    {
        "type": "OTC",
        "mpid": "ACPS",
        "clearingBroker": "0534",
        "brokerName": "ACP SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "ACRA",
        "clearingBroker": "0436",
        "brokerName": "ARCHIPELAGO SECURITIES, L.L.C.                                        "
    },
    {
        "type": "OTC",
        "mpid": "ACRN",
        "clearingBroker": "0235",
        "brokerName": "ACORNS SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "ACSS",
        "clearingBroker": "3450",
        "brokerName": "AC SUNSHINE SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "ADAM",
        "clearingBroker": "0161",
        "brokerName": "CANACCORD GENUITY INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "ADSB",
        "clearingBroker": "1476",
        "brokerName": "ADELPHI STOCK BROKERS                                                 "
    },
    {
        "type": "OTC",
        "mpid": "ADSO",
        "clearingBroker": "0141",
        "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "AEFA",
        "clearingBroker": "0756",
        "brokerName": "AMERIPRISE FINANCIAL SERVICES, LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "AETL",
        "clearingBroker": "0158",
        "brokerName": "AET INVESTMENT SERVICES, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "AEXG",
        "clearingBroker": "0158",
        "brokerName": "ALTERNATIVE EXECUTION GROUP                                           "
    },
    {
        "type": "OTC",
        "mpid": "AFBS",
        "clearingBroker": "0158",
        "brokerName": "APEX FINTECH BROKERAGE SERVICES LLC                                   "
    },
    {
        "type": "OTC",
        "mpid": "AFCO",
        "clearingBroker": "0284",
        "brokerName": "TD PRIME SERVICES LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "AFSS",
        "clearingBroker": "0750",
        "brokerName": "FOUR POINTS CAPITAL PARTNERS LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "AGCO",
        "clearingBroker": "0052",
        "brokerName": "AUERBACH GRAYSON & COMPANY LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "AGCP",
        "clearingBroker": "0052",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "AGES",
        "clearingBroker": "0750",
        "brokerName": "ADVISORY GROUP EQUITY SERVICES LTD.                                   "
    },
    {
        "type": "OTC",
        "mpid": "AGFA",
        "clearingBroker": "0226",
        "brokerName": "VALIC FINANCIAL ADVISORS, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "AGIS",
        "clearingBroker": "0235",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "AGPM",
        "clearingBroker": "1043",
        "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
    },
    {
        "type": "OTC",
        "mpid": "AGTS",
        "clearingBroker": "0158",
        "brokerName": "AVANT-GARDE TRADING SECURITIES                                        "
    },
    {
        "type": "OTC",
        "mpid": "AHSI",
        "clearingBroker": "0141",
        "brokerName": "AMERICAN HERITAGE SECURITIES, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "AIRS",
        "clearingBroker": "0279",
        "brokerName": "HAND SECURITIES, INC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "AISG",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN INDEPENDENT SECURITIES GROUP, LLC                            "
    },
    {
        "type": "OTC",
        "mpid": "AJCO",
        "clearingBroker": "0443",
        "brokerName": "IDB CAPITAL CORP.                                                     "
    },
    {
        "type": "OTC",
        "mpid": "AKUN",
        "clearingBroker": "0695",
        "brokerName": "AKUNA SECURITIES LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "ALBS",
        "clearingBroker": "0158",
        "brokerName": "ALBERT SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "ALCG",
        "clearingBroker": "0235",
        "brokerName": "ALTITUDE CAPITAL GROUP LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "ALDN",
        "clearingBroker": "0052",
        "brokerName": "J. ALDEN ASSOCIATES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "ALEG",
        "clearingBroker": "0534",
        "brokerName": "ALLEGRO SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "ALFA",
        "clearingBroker": "0352",
        "brokerName": "ALPHA TRADING L.P.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "ALGP",
        "clearingBroker": "0235",
        "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
    },
    {
        "type": "OTC",
        "mpid": "ALGR",
        "clearingBroker": "0158",
        "brokerName": "ALGER (FRED) & CO INC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "ALIS",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER INVESTMENT SERVICES CO.                                     "
    },
    {
        "type": "OTC",
        "mpid": "ALLC",
        "clearingBroker": "0436",
        "brokerName": "ARCHIPELAGO SECURITIES L.L.C.                                         "
    },
    {
        "type": "OTC",
        "mpid": "ALLN",
        "clearingBroker": "0443",
        "brokerName": "ALLEN & COMPANY LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "ALNC",
        "clearingBroker": "0226",
        "brokerName": "A.G.P./ALLIANCE GLOBAL PARTNERS                                       "
    },
    {
        "type": "OTC",
        "mpid": "ALPS",
        "clearingBroker": "8072",
        "brokerName": "ALPINE SECURITIES CORPORATION                                         "
    },
    {
        "type": "OTC",
        "mpid": "ALPX",
        "clearingBroker": "0067",
        "brokerName": "TSX ALPHA U.S., INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "ALTR",
        "clearingBroker": "3164",
        "brokerName": "ALTRUIST FINANCIAL LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "ALTS",
        "clearingBroker": "0052",
        "brokerName": "LODAS SECURITIES LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "AMBB",
        "clearingBroker": "0141",
        "brokerName": "ALLEN, MOONEY & BARNES BROKERAGE SERVICES, LLC                        "
    },
    {
        "type": "OTC",
        "mpid": "AMER",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "OTC",
        "mpid": "AMIC",
        "clearingBroker": "0226",
        "brokerName": "AMERICAN INVESTORS COMPANY                                            "
    },
    {
        "type": "OTC",
        "mpid": "AMLU",
        "clearingBroker": "3652",
        "brokerName": "LUCID CAPITAL MARKETS, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "AMMS",
        "clearingBroker": "0141",
        "brokerName": "AMUNI FINANCIAL, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "AMRI",
        "clearingBroker": "8199",
        "brokerName": "AMERICAS EXECUTIONS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "ANDG",
        "clearingBroker": "0235",
        "brokerName": "GARRETT (ANDREW), INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "ANOS",
        "clearingBroker": "0235",
        "brokerName": "ABEL NOSER, LLC.                                                      "
    },
    {
        "type": "OTC",
        "mpid": "ANOV",
        "clearingBroker": "0750",
        "brokerName": "ANOVEST FINANCIAL SERVICES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "AORP",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "AOSD",
        "clearingBroker": "0158",
        "brokerName": "TRADING BLOCK                                                         "
    },
    {
        "type": "OTC",
        "mpid": "APBD",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "APBO",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "APCA",
        "clearingBroker": "3021",
        "brokerName": "ALPACA SECURITIES LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "APCC",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "APOG",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "APRO",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "APRT",
        "clearingBroker": "0226",
        "brokerName": "PARTNERS                                                              "
    },
    {
        "type": "OTC",
        "mpid": "APTO",
        "clearingBroker": "0103",
        "brokerName": "APTO PARTNERS, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "APXO",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "APXS",
        "clearingBroker": "0052",
        "brokerName": "APEXUS CAPITAL LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "AQUA",
        "clearingBroker": "0197",
        "brokerName": "AQUA SECURITIES L.P.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "AQUB",
        "clearingBroker": "0197",
        "brokerName": "AQUA SECURITIES L.P.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "ARBC",
        "clearingBroker": "0235",
        "brokerName": "ARKADIOS CAPITAL                                                      "
    },
    {
        "type": "OTC",
        "mpid": "ARCA",
        "clearingBroker": "0436",
        "brokerName": "ARCHIPELAGO TRADING SERVICES, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "ARCD",
        "clearingBroker": "0443",
        "brokerName": "ARCADIA SECURITIES, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "ARCT",
        "clearingBroker": "4305",
        "brokerName": "ARCHITECT SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "ARKI",
        "clearingBroker": "0226",
        "brokerName": "ARKADIOS CAPITAL                                                      "
    },
    {
        "type": "OTC",
        "mpid": "ARMS",
        "clearingBroker": "0534",
        "brokerName": "ARMSTRONG SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "ARRB",
        "clearingBroker": "0436",
        "brokerName": "ARCHIPELAGO SECURITIES L.L.C.                                         "
    },
    {
        "type": "OTC",
        "mpid": "ARSC",
        "clearingBroker": "1043",
        "brokerName": "ARCTIC SECURITIES LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "ARVS",
        "clearingBroker": "0443",
        "brokerName": "ARVEST WEALTH MANAGEMENT                                              "
    },
    {
        "type": "OTC",
        "mpid": "ASCM",
        "clearingBroker": "0052",
        "brokerName": "ASCENDIANT CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "ASEL",
        "clearingBroker": "0370",
        "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
    },
    {
        "type": "OTC",
        "mpid": "ASII",
        "clearingBroker": "0226",
        "brokerName": "AURORA SECURITIES                                                     "
    },
    {
        "type": "OTC",
        "mpid": "ASLB",
        "clearingBroker": "0370",
        "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
    },
    {
        "type": "OTC",
        "mpid": "ASLT",
        "clearingBroker": "1043",
        "brokerName": "ASL CAPITAL MARKETS INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "ASOI",
        "clearingBroker": "0226",
        "brokerName": "ASSOCIATED INVESTMENT SERVICES, INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "ASPI",
        "clearingBroker": "0534",
        "brokerName": "ASIA PACIFIC FINANCIAL MANAGEMENT GROUP, INC.                         "
    },
    {
        "type": "OTC",
        "mpid": "ASSO",
        "clearingBroker": "0075",
        "brokerName": "ASSOCIATED SECURITIES CORP.                                           "
    },
    {
        "type": "OTC",
        "mpid": "ASTW",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "ATIS",
        "clearingBroker": "0052",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "OTC",
        "mpid": "ATMC",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "ATVT",
        "clearingBroker": "0443",
        "brokerName": "ATOMIC BROKERAGE LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "AUTO",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "AVEN",
        "clearingBroker": "0226",
        "brokerName": "AVENTURA SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "AVEW",
        "clearingBroker": "8199",
        "brokerName": "AVENTURA SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "AVIL",
        "clearingBroker": "0158",
        "brokerName": "AVANZA CAPITAL MARKETS INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "AVML",
        "clearingBroker": "0443",
        "brokerName": "AVM, L.P.                                                             "
    },
    {
        "type": "OTC",
        "mpid": "AVNU",
        "clearingBroker": "0158",
        "brokerName": "AVENUE SECURITIES LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "AVSC",
        "clearingBroker": "0294",
        "brokerName": "AVENUE SECURITIES LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "AVSI",
        "clearingBroker": "0443",
        "brokerName": "AMERIVET SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "AVST",
        "clearingBroker": "0235",
        "brokerName": "ATOMIC BROKERAGE LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "AVTR",
        "clearingBroker": "8199",
        "brokerName": "AVATAR SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "AXCL",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "AXCS",
        "clearingBroker": "0443",
        "brokerName": "ACCESS SECURITIES INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "AXGP",
        "clearingBroker": "0443",
        "brokerName": "ACCESS SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "AXIO",
        "clearingBroker": "0279",
        "brokerName": "AXIOM CAPITAL MANAGEMENT, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "AXOS",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "AXXX",
        "clearingBroker": "8601",
        "brokerName": "DTC/NSCC FTS TEST ACCOUNT 1                                           "
    },
    {
        "type": "OTC",
        "mpid": "BALA",
        "clearingBroker": "0005",
        "brokerName": "G1 EXECUTION SERVICES, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "BALE",
        "clearingBroker": "0443",
        "brokerName": "M&T SECURITIES, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "BALS",
        "clearingBroker": "0750",
        "brokerName": "BRUCE A. LEFAVI SECURITIES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "BANK",
        "clearingBroker": "0701",
        "brokerName": "CETERA INVESTMENT SERVICES LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "BARD",
        "clearingBroker": "0547",
        "brokerName": "ROBERT W. BAIRD & CO. INCORPORATED                                    "
    },
    {
        "type": "OTC",
        "mpid": "BARR",
        "clearingBroker": "0226",
        "brokerName": "BARRETT & COMPANY                                                     "
    },
    {
        "type": "OTC",
        "mpid": "BATM",
        "clearingBroker": "0050",
        "brokerName": "BATS TRADING, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BATS",
        "clearingBroker": "8199",
        "brokerName": "BATS TRADING, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BAYC",
        "clearingBroker": "0161",
        "brokerName": "BAY CREST PARTNERS,  LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "BAYP",
        "clearingBroker": "0161",
        "brokerName": "BAY CREST PARTNERS, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "BAYT",
        "clearingBroker": "0005",
        "brokerName": "BTIG, LLC                                                             "
    },
    {
        "type": "OTC",
        "mpid": "BBAR",
        "clearingBroker": "0595",
        "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "BBGC",
        "clearingBroker": "0235",
        "brokerName": "GRAHAM (B.B.) & COMPANY                                               "
    },
    {
        "type": "OTC",
        "mpid": "BBHC",
        "clearingBroker": "0010",
        "brokerName": "BROWN BROTHERS HARRIMAN & CO.                                         "
    },
    {
        "type": "OTC",
        "mpid": "BBOK",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "BCDX",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "BCEP",
        "clearingBroker": "0551",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "BCEX",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "BCMX",
        "clearingBroker": "0443",
        "brokerName": "BERENBERG CAPITAL MARKETS LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "BCPI",
        "clearingBroker": "0279",
        "brokerName": "GVC CAPITAL LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "BCPL",
        "clearingBroker": "0750",
        "brokerName": "STOCKKINGS CAPITAL LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "BCRK",
        "clearingBroker": "0279",
        "brokerName": "BEAR CREEK SECURITIES, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "BCSA",
        "clearingBroker": "0443",
        "brokerName": "BCS AMERICAS, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BCSG",
        "clearingBroker": "0294",
        "brokerName": "BCS GLOBAL MARKETS                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BCWM",
        "clearingBroker": "4077",
        "brokerName": "BETA CAPITAL SECURITIES LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "BCZC",
        "clearingBroker": "0443",
        "brokerName": "ZIEGLER (B.C.) & COMPANY                                              "
    },
    {
        "type": "OTC",
        "mpid": "BDCO",
        "clearingBroker": "0534",
        "brokerName": "BARDI CO. LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "BEAF",
        "clearingBroker": "0235",
        "brokerName": "BEACONSFIELD FINANCIAL SERV.                                          "
    },
    {
        "type": "OTC",
        "mpid": "BEAR",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "BELZ",
        "clearingBroker": "0627",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BERN",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BERS",
        "clearingBroker": "0235",
        "brokerName": "BESTEX RESEARCH SECURITIES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BEST",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "BESX",
        "clearingBroker": "8199",
        "brokerName": "BESTEX RESEARCH SECURITIES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BFAB",
        "clearingBroker": "0695",
        "brokerName": "BLUEFIN CAPITAL MANAGEMENT, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BFEC",
        "clearingBroker": "0443",
        "brokerName": "BENJAMIN F. EDWARDS & COMPANY                                         "
    },
    {
        "type": "OTC",
        "mpid": "BFFI",
        "clearingBroker": "0226",
        "brokerName": "BERTHEL, FISHER & COMPANY FINANCIAL SERVICES, INC.                    "
    },
    {
        "type": "OTC",
        "mpid": "BFSL",
        "clearingBroker": "0235",
        "brokerName": "BRIGGS-FICKS SECURITIES, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "BGCE",
        "clearingBroker": "0161",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BGCF",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL, L.P.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "BGHT",
        "clearingBroker": "0141",
        "brokerName": "BRIGHTON SECURITIES CORP.                                             "
    },
    {
        "type": "OTC",
        "mpid": "BGIS",
        "clearingBroker": "0443",
        "brokerName": "BLACKROCK EXECUTION SERVICES                                          "
    },
    {
        "type": "OTC",
        "mpid": "BGMI",
        "clearingBroker": "0158",
        "brokerName": "BRICKELL GLOBAL MARKETS, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "BGSG",
        "clearingBroker": "0226",
        "brokerName": "CBIZ FINANCIAL SOLUTIONS, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "BHKS",
        "clearingBroker": "0141",
        "brokerName": "BHK SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "BIDS",
        "clearingBroker": "0161",
        "brokerName": "BIDS TRADING L.P.                                                     "
    },
    {
        "type": "OTC",
        "mpid": "BIGG",
        "clearingBroker": "0005",
        "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "BIGP",
        "clearingBroker": "0443",
        "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "BIGZ",
        "clearingBroker": "0443",
        "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "BIMI",
        "clearingBroker": "0136",
        "brokerName": "INTESA SANPAOLO IMI SECURITIES CORP.                                  "
    },
    {
        "type": "OTC",
        "mpid": "BIRM",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BISB",
        "clearingBroker": "0286",
        "brokerName": "BERNSTEIN INSTITUTIONAL SERVICES LLC                                  "
    },
    {
        "type": "OTC",
        "mpid": "BISE",
        "clearingBroker": "0286",
        "brokerName": "BERNSTEIN INSTITUTIONAL SERVICES LLC                                  "
    },
    {
        "type": "OTC",
        "mpid": "BISG",
        "clearingBroker": "0286",
        "brokerName": "BERNSTEIN INSTITUTIONAL SERVICES LLC                                  "
    },
    {
        "type": "OTC",
        "mpid": "BISH",
        "clearingBroker": "0286",
        "brokerName": "BERNSTEIN INSTITUTIONAL SERVICES LLC                                  "
    },
    {
        "type": "OTC",
        "mpid": "BISI",
        "clearingBroker": "0443",
        "brokerName": "BANORTE SECURITIES INTERNATIONAL, LTD.                                "
    },
    {
        "type": "OTC",
        "mpid": "BISO",
        "clearingBroker": "0286",
        "brokerName": "BERNSTEIN INSTITUTIONAL SERVICES LLC                                  "
    },
    {
        "type": "OTC",
        "mpid": "BIVO",
        "clearingBroker": "0534",
        "brokerName": "BIVO FINANCIAL LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BJCM",
        "clearingBroker": "0235",
        "brokerName": "ESSEX SECURITIES LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "BJRC",
        "clearingBroker": "0235",
        "brokerName": "CASCADE INVESTMENT GROUP, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "BKCM",
        "clearingBroker": "0443",
        "brokerName": "BNY CAPITAL MARKETS INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "BKES",
        "clearingBroker": "0443",
        "brokerName": "BNY MELLON CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BKRT",
        "clearingBroker": "0235",
        "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "BLAV",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BLCK",
        "clearingBroker": "0534",
        "brokerName": "JAMES I. BLACK & COMPANY                                              "
    },
    {
        "type": "OTC",
        "mpid": "BLKX",
        "clearingBroker": "0067",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "BLNI",
        "clearingBroker": "0226",
        "brokerName": "AMERITAS INVESTMENT COMPANY, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "BLOC",
        "clearingBroker": "0158",
        "brokerName": "TRADING BLOCK                                                         "
    },
    {
        "type": "OTC",
        "mpid": "BLOX",
        "clearingBroker": "0443",
        "brokerName": "JONESTRADING                                                          "
    },
    {
        "type": "OTC",
        "mpid": "BLTK",
        "clearingBroker": "0443",
        "brokerName": "BULLTICK, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "BLTN",
        "clearingBroker": "0534",
        "brokerName": "BOLTON SECURITIES CORPORATION                                         "
    },
    {
        "type": "OTC",
        "mpid": "BLUE",
        "clearingBroker": "4305",
        "brokerName": "BLUE OCEAN ATS, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "BMOC",
        "clearingBroker": "0045",
        "brokerName": "BMO CAPITAL MARKETS CORP.                                             "
    },
    {
        "type": "OTC",
        "mpid": "BMSI",
        "clearingBroker": "0750",
        "brokerName": "BULL MARKET SECURITIES, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "BMSX",
        "clearingBroker": "4305",
        "brokerName": "BULL MARKET SECURITIES, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "BMSY",
        "clearingBroker": "0294",
        "brokerName": "BULL MARKET SECURITIES, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "BMUR",
        "clearingBroker": "0443",
        "brokerName": "BREAN CAPITAL, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BNBB",
        "clearingBroker": "0750",
        "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "BNCH",
        "clearingBroker": "0235",
        "brokerName": "THE BENCHMARK COMPANY, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "BNJM",
        "clearingBroker": "0235",
        "brokerName": "BENJAMIN SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "BNPS",
        "clearingBroker": "2154",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "OTC",
        "mpid": "BNPX",
        "clearingBroker": "2154",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "OTC",
        "mpid": "BNTE",
        "clearingBroker": "0158",
        "brokerName": "BANORTE-IXE SECURITIES INTERNATIONAL, LTD.                            "
    },
    {
        "type": "OTC",
        "mpid": "BNYN",
        "clearingBroker": "0226",
        "brokerName": "BANYAN SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "BOBS",
        "clearingBroker": "0534",
        "brokerName": "BULLISH BOB BAGLEY SECURITIES, INC.                                   "
    },
    {
        "type": "OTC",
        "mpid": "BOKI",
        "clearingBroker": "0443",
        "brokerName": "BOSC, INC.                                                            "
    },
    {
        "type": "OTC",
        "mpid": "BOLL",
        "clearingBroker": "0279",
        "brokerName": "BODELL OVERCASH ANDERSON & CO.                                        "
    },
    {
        "type": "OTC",
        "mpid": "BOSS",
        "clearingBroker": "0158",
        "brokerName": "ALL TIME ATS                                                          "
    },
    {
        "type": "OTC",
        "mpid": "BPWP",
        "clearingBroker": "0226",
        "brokerName": "BUTTONWOOD PARTNERS, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "BRBR",
        "clearingBroker": "0279",
        "brokerName": "BROWN AND BROWN SECURITIES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "BRCY",
        "clearingBroker": "0443",
        "brokerName": "BCP SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "BRGE",
        "clearingBroker": "0052",
        "brokerName": "NEWBRIDGE SECURITIES CORPORATION                                      "
    },
    {
        "type": "OTC",
        "mpid": "BRLI",
        "clearingBroker": "0226",
        "brokerName": "BROWN, LISLE/CUMMINGS, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "BRLY",
        "clearingBroker": "0158",
        "brokerName": "B. RILEY WEALTH MANAGEMENT, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "BRNK",
        "clearingBroker": "0226",
        "brokerName": "BRINKER CAPITAL SECURITIES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BROC",
        "clearingBroker": "0443",
        "brokerName": "PAVILION GLOBAL MARKETS LTD                                           "
    },
    {
        "type": "OTC",
        "mpid": "BRPR",
        "clearingBroker": "0534",
        "brokerName": "BRASIL PLURAL SECURITIES LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "BRRR",
        "clearingBroker": "8199",
        "brokerName": "BARRINGTON RESEARCH ASSOCIATES, INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "BRSA",
        "clearingBroker": "0103",
        "brokerName": "BOURSA INVESTMENTS                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BRSE",
        "clearingBroker": "0226",
        "brokerName": "BRADESCO SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "BRUT",
        "clearingBroker": "0568",
        "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "BRVL",
        "clearingBroker": "0443",
        "brokerName": "BLAYLOCK BEAL VAN, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "BRWM",
        "clearingBroker": "0226",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "OTC",
        "mpid": "BSCM",
        "clearingBroker": "0052",
        "brokerName": "BROAD STREET CAPITAL MARKETS, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "BSPI",
        "clearingBroker": "0235",
        "brokerName": "BALANCED SECURITY PLANNING, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "BSSC",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "BSTX",
        "clearingBroker": "4305",
        "brokerName": "BESTEX RESEARCH SECURITIES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BTBS",
        "clearingBroker": "0695",
        "brokerName": "BELVEDERE TRADING LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "BTCK",
        "clearingBroker": "0158",
        "brokerName": "BULLTICK, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "BTDG",
        "clearingBroker": "0161",
        "brokerName": "BIDS TRADING LP                                                       "
    },
    {
        "type": "OTC",
        "mpid": "BTGP",
        "clearingBroker": "2402",
        "brokerName": "BTG PACTUAL US CAPITAL, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "BTIG",
        "clearingBroker": "0005",
        "brokerName": "BTIG, LLC                                                             "
    },
    {
        "type": "OTC",
        "mpid": "BTIM",
        "clearingBroker": "1043",
        "brokerName": "BTIG, LLC                                                             "
    },
    {
        "type": "OTC",
        "mpid": "BTIS",
        "clearingBroker": "0443",
        "brokerName": "BTIG, LLC                                                             "
    },
    {
        "type": "OTC",
        "mpid": "BTSI",
        "clearingBroker": "0158",
        "brokerName": "LIGHT HORSE MARKET SOLUTIONS INC                                      "
    },
    {
        "type": "OTC",
        "mpid": "BTSS",
        "clearingBroker": "0279",
        "brokerName": "HILLTOP SECURITIES INDEPENDENT NETWORK INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "BULL",
        "clearingBroker": "0158",
        "brokerName": "WEBULL FINANCIAL LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "BUMP",
        "clearingBroker": "0158",
        "brokerName": "BUMPED FINANCIAL LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "BUNT",
        "clearingBroker": "5017",
        "brokerName": "UBS SECURITIES CANADA INC./CDS                                        "
    },
    {
        "type": "OTC",
        "mpid": "BWNA",
        "clearingBroker": "0235",
        "brokerName": "BROWN ASSOCIATES INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "BXXX",
        "clearingBroker": "8602",
        "brokerName": "ANONYMOUS BROKER ACCOUNT                                              "
    },
    {
        "type": "OTC",
        "mpid": "BYXM",
        "clearingBroker": "0050",
        "brokerName": "BATS TRADING, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BYXX",
        "clearingBroker": "8199",
        "brokerName": "BATS TRADING, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BZTN",
        "clearingBroker": "0141",
        "brokerName": "ALLIANT SECURITIES, INC. TURNER, NORD, KIENBAUM                       "
    },
    {
        "type": "OTC",
        "mpid": "BZWV",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "BZYD",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "BZYF",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "BZYJ",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "CAAA",
        "clearingBroker": "0750",
        "brokerName": "AKAR CAPITAL MANAGEMENT, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CABR",
        "clearingBroker": "0161",
        "brokerName": "CABRERA CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CADG",
        "clearingBroker": "0005",
        "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "CADZ",
        "clearingBroker": "0279",
        "brokerName": "CADZ SECURITIES INC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "CAES",
        "clearingBroker": "0734",
        "brokerName": "THE NASDAQ STOCK MARKET LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "CAFS",
        "clearingBroker": "0158",
        "brokerName": "COMMUNITYAMERICA FINANCIAL SOLUTIONS, LLC                             "
    },
    {
        "type": "OTC",
        "mpid": "CAGI",
        "clearingBroker": "0279",
        "brokerName": "CRESCENT SECURITIES GROUP, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "CAIX",
        "clearingBroker": "0235",
        "brokerName": "CAIS CAPITAL LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "CALD",
        "clearingBroker": "0103",
        "brokerName": "CALDWELL SUTTER CAPITAL, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CALT",
        "clearingBroker": "0279",
        "brokerName": "CALTON & ASSOCIATES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "CANA",
        "clearingBroker": "0443",
        "brokerName": "CANACCORD GENUITY INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "CANR",
        "clearingBroker": "0388",
        "brokerName": "CANTONE RESEARCH INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "CANT",
        "clearingBroker": "0696",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "OTC",
        "mpid": "CAPC",
        "clearingBroker": "0235",
        "brokerName": "CAPITAL CITY SECURITIES, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "CAPE",
        "clearingBroker": "0279",
        "brokerName": "CAPE SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "CARY",
        "clearingBroker": "0141",
        "brokerName": "CARY STREET PARTNERS                                                  "
    },
    {
        "type": "OTC",
        "mpid": "CASH",
        "clearingBroker": "0158",
        "brokerName": "PLANNER SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CATE",
        "clearingBroker": "0235",
        "brokerName": "CARTER, TERRY & COMPANY, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CATH",
        "clearingBroker": "0534",
        "brokerName": "CATHAY SECURITIES, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "CATS",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CBLC",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CBOL",
        "clearingBroker": "0226",
        "brokerName": "MUTUAL SECURITIES, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "CBRA",
        "clearingBroker": "0103",
        "brokerName": "COBRA TRADING, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "CBRC",
        "clearingBroker": "3450",
        "brokerName": "COBRA TRADING, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "CBRV",
        "clearingBroker": "8199",
        "brokerName": "COBRA TRADING, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "CBTD",
        "clearingBroker": "0226",
        "brokerName": "SYNOVOUS SECURITIES INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "CBUZ",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "CCAI",
        "clearingBroker": "5046",
        "brokerName": "CANACCORD CAPITAL CORPORATION/CDS                                     "
    },
    {
        "type": "OTC",
        "mpid": "CCAT",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CCCO",
        "clearingBroker": "0226",
        "brokerName": "CARNES CAPITAL CORPORATION                                            "
    },
    {
        "type": "OTC",
        "mpid": "CCIG",
        "clearingBroker": "0235",
        "brokerName": "CINCAP INVESTMENT GROUP, INC                                          "
    },
    {
        "type": "OTC",
        "mpid": "CCMB",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "CCMI",
        "clearingBroker": "0443",
        "brokerName": "JMP SECURITIES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "CCMM",
        "clearingBroker": "0235",
        "brokerName": "CRAFT CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "CCMX",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CCPM",
        "clearingBroker": "0595",
        "brokerName": "CAMBRIA CAPITAL, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "CDEA",
        "clearingBroker": "0438",
        "brokerName": "CIBC WORLD MARKETS CORP.                                              "
    },
    {
        "type": "OTC",
        "mpid": "CDED",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CDEL",
        "clearingBroker": "0161",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CDFS",
        "clearingBroker": "0052",
        "brokerName": "NAVIAN CAPITAL SECURITIES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "CDGO",
        "clearingBroker": "0551",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CDLC",
        "clearingBroker": "0395",
        "brokerName": "CITADEL CLEARING LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "CDMA",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CDMI",
        "clearingBroker": "0005",
        "brokerName": "CITIGROUP DERIVATIVES MARKETS INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "CDON",
        "clearingBroker": "0534",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "CDRG",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CDSO",
        "clearingBroker": "4305",
        "brokerName": "CDS1 SECURITIES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "CECL",
        "clearingBroker": "0158",
        "brokerName": "CARVER EDISON CAPITAL, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "CEDL",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CEMM",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CERS",
        "clearingBroker": "0226",
        "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "CFCD",
        "clearingBroker": "0005",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "OTC",
        "mpid": "CFCO",
        "clearingBroker": "7311",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "OTC",
        "mpid": "CFCS",
        "clearingBroker": "0005",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "OTC",
        "mpid": "CFDI",
        "clearingBroker": "0226",
        "brokerName": "CFD INVESTMENTS, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "CFGM",
        "clearingBroker": "0235",
        "brokerName": "TRUSTMONT FINANCIAL GROUP, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "CFGT",
        "clearingBroker": "0235",
        "brokerName": "CF GLOBAL TRADING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CFII",
        "clearingBroker": "0235",
        "brokerName": "CONSOLIDATED FINANCIAL INVESTMENTS, INC.                              "
    },
    {
        "type": "OTC",
        "mpid": "CFIN",
        "clearingBroker": "0279",
        "brokerName": "CHELSEA FINANCIAL SERVICES                                            "
    },
    {
        "type": "OTC",
        "mpid": "CFPT",
        "clearingBroker": "0197",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "OTC",
        "mpid": "CFRC",
        "clearingBroker": "3259",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "OTC",
        "mpid": "CFSI",
        "clearingBroker": "0052",
        "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "CFSX",
        "clearingBroker": "0794",
        "brokerName": "CF SECURED, LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "CGQT",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CGWM",
        "clearingBroker": "0443",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CGXS",
        "clearingBroker": "0067",
        "brokerName": "ONECHRONOS                                                            "
    },
    {
        "type": "OTC",
        "mpid": "CHAS",
        "clearingBroker": "0164",
        "brokerName": "CHARLES SCHWAB & CO., INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "CHBC",
        "clearingBroker": "0235",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CHCH",
        "clearingBroker": "0226",
        "brokerName": "CHURCHILL FINANCIAL, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CHCK",
        "clearingBroker": "0226",
        "brokerName": "CHICKASAW SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "CHDA",
        "clearingBroker": "0141",
        "brokerName": "CHAPIN, DAVIS                                                         "
    },
    {
        "type": "OTC",
        "mpid": "CHDN",
        "clearingBroker": "8199",
        "brokerName": "CHARDAN CAPITAL MARKETS LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "CHLC",
        "clearingBroker": "0443",
        "brokerName": "CHURCHILL CAPITAL USA, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "CHLM",
        "clearingBroker": "0226",
        "brokerName": "CRAIG-HALLUM CAPITAL GROUP LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "CHMR",
        "clearingBroker": "0294",
        "brokerName": "CHIMERA SECURITIES, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "CHPP",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "CHRD",
        "clearingBroker": "0158",
        "brokerName": "CHERRY TRADING                                                        "
    },
    {
        "type": "OTC",
        "mpid": "CHRS",
        "clearingBroker": "0750",
        "brokerName": "ROYAL TREASURE SECURITIES LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "CHUB",
        "clearingBroker": "0226",
        "brokerName": "OSAIC FS, INC.                                                        "
    },
    {
        "type": "OTC",
        "mpid": "CIBP",
        "clearingBroker": "0438",
        "brokerName": "CIBC WORLD MARKETS CORP.                                              "
    },
    {
        "type": "OTC",
        "mpid": "CICC",
        "clearingBroker": "0443",
        "brokerName": "CICC US SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "CICF",
        "clearingBroker": "5046",
        "brokerName": "CANACCORD GENUITY CORP./CDS                                           "
    },
    {
        "type": "OTC",
        "mpid": "CIIV",
        "clearingBroker": "0052",
        "brokerName": "CORPORATE INVESTMENTS GROUP, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "CIMB",
        "clearingBroker": "0005",
        "brokerName": "CIMB SECURITIES (USA), INC                                            "
    },
    {
        "type": "OTC",
        "mpid": "CIOI",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CIRI",
        "clearingBroker": "0443",
        "brokerName": "CAMBRIDGE INVESTMENT RESEARCH, INC.                                   "
    },
    {
        "type": "OTC",
        "mpid": "CISI",
        "clearingBroker": "0352",
        "brokerName": "CHASE INVESTMENT SERVICES CORP.                                       "
    },
    {
        "type": "OTC",
        "mpid": "CIST",
        "clearingBroker": "0161",
        "brokerName": "CAPITAL INSTITUTIONAL SERVICES, INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "CISV",
        "clearingBroker": "0226",
        "brokerName": "CITIZENS SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "CITO",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CJSC",
        "clearingBroker": "0443",
        "brokerName": "CJS SECURITIES, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "CLCU",
        "clearingBroker": "9132",
        "brokerName": "CLSA AMERICAS, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "CLDN",
        "clearingBroker": "0235",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "CLHT",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "CLIC",
        "clearingBroker": "0158",
        "brokerName": "CLICK IPO SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "CLRK",
        "clearingBroker": "0235",
        "brokerName": "CLARK DODGE & CO, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "CLSA",
        "clearingBroker": "0161",
        "brokerName": "CLSA AMERICAS, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "CLSC",
        "clearingBroker": "0235",
        "brokerName": "CABOT LODGE SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "CLST",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "CLTN",
        "clearingBroker": "0226",
        "brokerName": "CALTON & ASSOCIATES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "CMBA",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "CMBB",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "CMBC",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "CMBD",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "CMCE",
        "clearingBroker": "0226",
        "brokerName": "COMMERCE BROKERAGE SERVICES                                           "
    },
    {
        "type": "OTC",
        "mpid": "CMMW",
        "clearingBroker": "0226",
        "brokerName": "COMMONWEALTH FINANCIAL NETWORK                                        "
    },
    {
        "type": "OTC",
        "mpid": "CMPR",
        "clearingBroker": "0158",
        "brokerName": "COMPOSER SECURITIES LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "CMPT",
        "clearingBroker": "0750",
        "brokerName": "COMPASS POINT RESEARCH & TRADING, LLC                                 "
    },
    {
        "type": "OTC",
        "mpid": "CMRA",
        "clearingBroker": "9132",
        "brokerName": "CHIMERA SECURITIES, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "CMSI",
        "clearingBroker": "0279",
        "brokerName": "CAPITAL MANAGEMENT SECURITIES, INC.                                   "
    },
    {
        "type": "OTC",
        "mpid": "CNAB",
        "clearingBroker": "1186",
        "brokerName": "COR CLEARING LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "CNCD",
        "clearingBroker": "0235",
        "brokerName": "CONCORDE INVESTMENT SERVICES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "CNFR",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "CNSI",
        "clearingBroker": "0226",
        "brokerName": "CITY NATIONAL SECURITIES, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "CNTR",
        "clearingBroker": "0103",
        "brokerName": "PRECISION SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "COAK",
        "clearingBroker": "0443",
        "brokerName": "CASTLE OAK SECURITIES, L.P.                                           "
    },
    {
        "type": "OTC",
        "mpid": "CODA",
        "clearingBroker": "0161",
        "brokerName": "CODA MARKETS, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "COEI",
        "clearingBroker": "0052",
        "brokerName": "COASTAL EQUITIES, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "COEX",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "COFS",
        "clearingBroker": "0279",
        "brokerName": "COLORADO FINANCIAL SERVICE CORPORATION                                "
    },
    {
        "type": "OTC",
        "mpid": "COHN",
        "clearingBroker": "0235",
        "brokerName": "COHEN BROS. & COMPANY                                                 "
    },
    {
        "type": "OTC",
        "mpid": "COHR",
        "clearingBroker": "9132",
        "brokerName": "COMHAR CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "COKE",
        "clearingBroker": "0235",
        "brokerName": "COKER & PALMER, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "COMP",
        "clearingBroker": "0595",
        "brokerName": "COMPASS POINT RESEARCH & TRADING, LLC                                 "
    },
    {
        "type": "OTC",
        "mpid": "CONI",
        "clearingBroker": "0235",
        "brokerName": "CONTINENTAL INVESTORS SERVICES, INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "CONR",
        "clearingBroker": "0235",
        "brokerName": "CONNERS & CO., INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "COOR",
        "clearingBroker": "0141",
        "brokerName": "COORDINATED CAPITAL SECURITIES, INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "COWN",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "COWP",
        "clearingBroker": "0226",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "COWR",
        "clearingBroker": "0443",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "COWX",
        "clearingBroker": "0161",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "COWZ",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "COYL",
        "clearingBroker": "0235",
        "brokerName": "COYLE SECURITIES LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "CPEM",
        "clearingBroker": "0161",
        "brokerName": "CLEARPOOL EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "CPLC",
        "clearingBroker": "0595",
        "brokerName": "COVA CAPITAL PARTNERS LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "CPNT",
        "clearingBroker": "8199",
        "brokerName": "PRECISION SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "CPRC",
        "clearingBroker": "0235",
        "brokerName": "CORINTHIAN PARTNERS, L.L.C.                                           "
    },
    {
        "type": "OTC",
        "mpid": "CPRM",
        "clearingBroker": "8199",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "CPST",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "CRAG",
        "clearingBroker": "0443",
        "brokerName": "KEPLER CAPITAL MARKETS, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "CRCM",
        "clearingBroker": "0235",
        "brokerName": "COHNREZNICK CAPITAL                                                   "
    },
    {
        "type": "OTC",
        "mpid": "CRDL",
        "clearingBroker": "0235",
        "brokerName": "CARDINAL INVESTMENTS, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "CRED",
        "clearingBroker": "0443",
        "brokerName": "CREDICORP CAPITAL LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "CRFN",
        "clearingBroker": "6769",
        "brokerName": "ROBINHOOD FINANCIAL, LLC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "CRIT",
        "clearingBroker": "0294",
        "brokerName": "CRITO CAPITAL LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "CRNJ",
        "clearingBroker": "0103",
        "brokerName": "CANTONE RESEARCH INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "CRPT",
        "clearingBroker": "0235",
        "brokerName": "CROSS POINT CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "CRUS",
        "clearingBroker": "0005",
        "brokerName": "CHINA RENAISSANCE SECURITIES (US) INC.                                "
    },
    {
        "type": "OTC",
        "mpid": "CRWE",
        "clearingBroker": "0534",
        "brokerName": "CREWE CAPITAL                                                         "
    },
    {
        "type": "OTC",
        "mpid": "CRYN",
        "clearingBroker": "0235",
        "brokerName": "BRENDAN E. CRYAN AND COMPANY, L.L.C.                                  "
    },
    {
        "type": "OTC",
        "mpid": "CSAI",
        "clearingBroker": "0793",
        "brokerName": "STIFEL INDEPENDENT ADVISORS, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "CSAP",
        "clearingBroker": "0141",
        "brokerName": "CRESAP, INC.                                                          "
    },
    {
        "type": "OTC",
        "mpid": "CSCM",
        "clearingBroker": "0279",
        "brokerName": "CENTRAL STATES CAPITAL MARKETS, LLC                                   "
    },
    {
        "type": "OTC",
        "mpid": "CSEC",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CSGI",
        "clearingBroker": "7587",
        "brokerName": "CHARLES SCHWAB & CO., INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "CSIN",
        "clearingBroker": "0161",
        "brokerName": "CITADEL SECURITIES INSTITUTIONAL LLC                                  "
    },
    {
        "type": "OTC",
        "mpid": "CSMI",
        "clearingBroker": "0534",
        "brokerName": "CAPITOL SECURITIES MANAGEMENT, INC.                                   "
    },
    {
        "type": "OTC",
        "mpid": "CSMM",
        "clearingBroker": "9132",
        "brokerName": "SUMMIT SECURITIES GROUP, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "CSOT",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "CSPD",
        "clearingBroker": "0197",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "OTC",
        "mpid": "CSPI",
        "clearingBroker": "0235",
        "brokerName": "CAPITAL SYNERGY PARTNERS                                              "
    },
    {
        "type": "OTC",
        "mpid": "CSSA",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "CSSB",
        "clearingBroker": "0551",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "CSTI",
        "clearingBroker": "0161",
        "brokerName": "CANACCORD GENUITY INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "CTAS",
        "clearingBroker": "0443",
        "brokerName": "OSAIC INSTITUTIONS, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "CTCA",
        "clearingBroker": "0551",
        "brokerName": "CTC, LLC                                                              "
    },
    {
        "type": "OTC",
        "mpid": "CTCB",
        "clearingBroker": "0005",
        "brokerName": "CTC, LLC                                                              "
    },
    {
        "type": "OTC",
        "mpid": "CTCO",
        "clearingBroker": "0534",
        "brokerName": "CITCO SECURITIES, INC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "CTDL",
        "clearingBroker": "0551",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CTDN",
        "clearingBroker": "0352",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CTLA",
        "clearingBroker": "0443",
        "brokerName": "CANTELLA & CO, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "CTNL",
        "clearingBroker": "0235",
        "brokerName": "CENTENNIAL SECURITIES COMPANY LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "CTRD",
        "clearingBroker": "3856",
        "brokerName": "CHOICETRADE                                                           "
    },
    {
        "type": "OTC",
        "mpid": "CUAL",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CUAN",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CUAX",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CUFT",
        "clearingBroker": "0226",
        "brokerName": "FROST BROKERAGE SERVICES, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "CUGS",
        "clearingBroker": "8199",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "CURG",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CURI",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "CURM",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "CURO",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CURT",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CURV",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "CUTW",
        "clearingBroker": "0235",
        "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "CUWB",
        "clearingBroker": "0103",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "CVCG",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVCN",
        "clearingBroker": "0158",
        "brokerName": "CV BROKERAGE, INC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "CVDC",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "CVFM",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVHE",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "CVKD",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVKX",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVMS",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVRB",
        "clearingBroker": "0005",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CVRJ",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVSB",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVSH",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVSX",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVVG",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVWS",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CWMC",
        "clearingBroker": "0438",
        "brokerName": "CIBC WORLD MARKETS CORP.                                              "
    },
    {
        "type": "OTC",
        "mpid": "CWMK",
        "clearingBroker": "0438",
        "brokerName": "CIBC WORLD MARKETS CORP.                                              "
    },
    {
        "type": "OTC",
        "mpid": "CXCX",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CXPS",
        "clearingBroker": "0534",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "CXXX",
        "clearingBroker": "8603",
        "brokerName": "DTC/NSCC FTS TEST ACCOUNT #3                                          "
    },
    {
        "type": "OTC",
        "mpid": "CYND",
        "clearingBroker": "0443",
        "brokerName": "TIGRESS FINANCIAL PARTNERS LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "DABS",
        "clearingBroker": "0534",
        "brokerName": "DABBAH SECURITIES CORP.                                               "
    },
    {
        "type": "OTC",
        "mpid": "DADA",
        "clearingBroker": "0361",
        "brokerName": "D. A. DAVIDSON & CO.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DAIN",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "DAIS",
        "clearingBroker": "0052",
        "brokerName": "DAI SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "DARA",
        "clearingBroker": "0235",
        "brokerName": "DARWOOD ASSOCIATES, INC                                               "
    },
    {
        "type": "OTC",
        "mpid": "DARQ",
        "clearingBroker": "0568",
        "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "DART",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DASH",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "DAVA",
        "clearingBroker": "0443",
        "brokerName": "DAVENPORT & COMPANY LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "DAVS",
        "clearingBroker": "0534",
        "brokerName": "DAVIS SECURITIES LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DAWA",
        "clearingBroker": "0647",
        "brokerName": "DAIWA CAPITAL MARKETS AMERICA INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "DBAB",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBAE",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBAT",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBAX",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBCC",
        "clearingBroker": "0235",
        "brokerName": "D. BORAL CAPITAL                                                      "
    },
    {
        "type": "OTC",
        "mpid": "DBCH",
        "clearingBroker": "0052",
        "brokerName": "D. BORAL CAPITAL                                                      "
    },
    {
        "type": "OTC",
        "mpid": "DBIB",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBLV",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBMS",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBPC",
        "clearingBroker": "0443",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBPR",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBPT",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBQT",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBRC",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBRT",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBST",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBUL",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DCMI",
        "clearingBroker": "0226",
        "brokerName": "DAVINCI CAPITAL MANAGEMENT, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "DCSD",
        "clearingBroker": "0235",
        "brokerName": "DAIN CORRESPONDENT SERVICES                                           "
    },
    {
        "type": "OTC",
        "mpid": "DCVL",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DEAN",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "DEDT",
        "clearingBroker": "0695",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DEFA",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "DEGS",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DEIF",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DEMA",
        "clearingBroker": "0534",
        "brokerName": "DEMATTEO MONNESS LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DENI",
        "clearingBroker": "0279",
        "brokerName": "H.C. DENISON CO.                                                      "
    },
    {
        "type": "OTC",
        "mpid": "DESJ",
        "clearingBroker": "5028",
        "brokerName": "DESJARDINS SECURITIES INC./CDS                                        "
    },
    {
        "type": "OTC",
        "mpid": "DETF",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DEXP",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DFIN",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "DFPG",
        "clearingBroker": "0235",
        "brokerName": "DFPG INVESTMENTS, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "DFTA",
        "clearingBroker": "0695",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "DFTR",
        "clearingBroker": "9132",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "DGLE",
        "clearingBroker": "0695",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DIBS",
        "clearingBroker": "0226",
        "brokerName": "DIGITAL BROKERAGE SERVICES LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "DIGG",
        "clearingBroker": "0595",
        "brokerName": "BOUSTEAD SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "DINO",
        "clearingBroker": "8199",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "OTC",
        "mpid": "DJMA",
        "clearingBroker": "0158",
        "brokerName": "DOJIMA SERVICES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "DJSA",
        "clearingBroker": "0750",
        "brokerName": "DAWSON JAMES SECURITIES, INC                                          "
    },
    {
        "type": "OTC",
        "mpid": "DLAI",
        "clearingBroker": "0235",
        "brokerName": "DAVID LERNER ASSOCIATES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DLPS",
        "clearingBroker": "0595",
        "brokerName": "DLP SECURITIES,.LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "DLSI",
        "clearingBroker": "0226",
        "brokerName": "DEMPSEY LORD SMITH, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "DLTA",
        "clearingBroker": "8445",
        "brokerName": "DEALERWEB INC.                                                        "
    },
    {
        "type": "OTC",
        "mpid": "DMCD",
        "clearingBroker": "0279",
        "brokerName": "MCDERMOTT INVESTMENT SERVICES, LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "DMER",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DMFE",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DMKC",
        "clearingBroker": "0141",
        "brokerName": "D.M. KELLY & COMPANY                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DNOR",
        "clearingBroker": "0005",
        "brokerName": "DNB MARKETS, INC.                                                     "
    },
    {
        "type": "OTC",
        "mpid": "DNSR",
        "clearingBroker": "0158",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "OTC",
        "mpid": "DNWL",
        "clearingBroker": "0443",
        "brokerName": "DUNCAN & WILLIAMS, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "DOFI",
        "clearingBroker": "4305",
        "brokerName": "DOO FINANCIAL US, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "DOFT",
        "clearingBroker": "0443",
        "brokerName": "DOFT & CO., INC.                                                      "
    },
    {
        "type": "OTC",
        "mpid": "DOMI",
        "clearingBroker": "0279",
        "brokerName": "DOMINION INVESTOR SERVICES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "DOMS",
        "clearingBroker": "0235",
        "brokerName": "DOMINARI SECURITIES LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "DOPE",
        "clearingBroker": "0158",
        "brokerName": "DOUGH LLC                                                             "
    },
    {
        "type": "OTC",
        "mpid": "DORN",
        "clearingBroker": "0235",
        "brokerName": "DORN & CO., INC.                                                      "
    },
    {
        "type": "OTC",
        "mpid": "DOTC",
        "clearingBroker": "0226",
        "brokerName": "COLLIERS SECURITIES LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "DOVE",
        "clearingBroker": "0226",
        "brokerName": "SECURITIES EQUITY GROUP                                               "
    },
    {
        "type": "OTC",
        "mpid": "DOWL",
        "clearingBroker": "0443",
        "brokerName": "DOWLING & PARTNERS SECURITIES LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "DQNY",
        "clearingBroker": "0551",
        "brokerName": "DRW SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "DRAT",
        "clearingBroker": "0571",
        "brokerName": "DRATEL GROUP (THE)                                                    "
    },
    {
        "type": "OTC",
        "mpid": "DREX",
        "clearingBroker": "0443",
        "brokerName": "DREXEL HAMILTON, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DRIV",
        "clearingBroker": "2402",
        "brokerName": "DRIVEWEALTH, LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "DRSC",
        "clearingBroker": "0443",
        "brokerName": "BNY MELLON SECURITIES CORPORATION                                     "
    },
    {
        "type": "OTC",
        "mpid": "DRTG",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DRTR",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DRVW",
        "clearingBroker": "0235",
        "brokerName": "DRIVEWEALTH, LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "DRWC",
        "clearingBroker": "0005",
        "brokerName": "DRW SECURITIES, L.L.C.                                                "
    },
    {
        "type": "OTC",
        "mpid": "DRWJ",
        "clearingBroker": "0551",
        "brokerName": "DRW SECURITIES, L.L.C.                                                "
    },
    {
        "type": "OTC",
        "mpid": "DRWK",
        "clearingBroker": "0695",
        "brokerName": "DRW SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "DRWM",
        "clearingBroker": "0005",
        "brokerName": "DRW SECURITIES, L.L.C.                                                "
    },
    {
        "type": "OTC",
        "mpid": "DRWP",
        "clearingBroker": "0695",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DRWS",
        "clearingBroker": "0005",
        "brokerName": "DRW SECURITIES, L.L.C.                                                "
    },
    {
        "type": "OTC",
        "mpid": "DRWW",
        "clearingBroker": "8199",
        "brokerName": "DRIVEWEALTH, LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "DRXL",
        "clearingBroker": "0443",
        "brokerName": "DREXEL HAMILTON, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DSEC",
        "clearingBroker": "8199",
        "brokerName": "DOMINARI SECURITIES LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "DSGG",
        "clearingBroker": "0226",
        "brokerName": "DMG SECURITIES, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DSIO",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DSNG",
        "clearingBroker": "0695",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DTEX",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
    },
    {
        "type": "OTC",
        "mpid": "DTTX",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "DUST",
        "clearingBroker": "0161",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "DVEQ",
        "clearingBroker": "0695",
        "brokerName": "DV EQUITIES                                                           "
    },
    {
        "type": "OTC",
        "mpid": "DVES",
        "clearingBroker": "0005",
        "brokerName": "DV EQUITIES                                                           "
    },
    {
        "type": "OTC",
        "mpid": "DWEL",
        "clearingBroker": "3856",
        "brokerName": "DRIVEWEALTH, LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "DWEQ",
        "clearingBroker": "0695",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DWIZ",
        "clearingBroker": "0235",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "DWLY",
        "clearingBroker": "2402",
        "brokerName": "DRIVELOYALTY                                                          "
    },
    {
        "type": "OTC",
        "mpid": "DXXX",
        "clearingBroker": "8604",
        "brokerName": "DTC/NSCC FTS TEST ACCOUNT #4                                          "
    },
    {
        "type": "OTC",
        "mpid": "EAMC",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
    },
    {
        "type": "OTC",
        "mpid": "EAMG",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
    },
    {
        "type": "OTC",
        "mpid": "EBKR",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "EBRD",
        "clearingBroker": "0103",
        "brokerName": "EARLYBIRD CAPITAL, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "EBXL",
        "clearingBroker": "0067",
        "brokerName": "KEZAR TRADING, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "ECFI",
        "clearingBroker": "0158",
        "brokerName": "DASTA FINANCIAL, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "ECUT",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "EDDI",
        "clearingBroker": "0294",
        "brokerName": "EDDID SECURITIES USA INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "EDDY",
        "clearingBroker": "0294",
        "brokerName": "BOUSTEAD SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "EDFC",
        "clearingBroker": "0443",
        "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "EDFI",
        "clearingBroker": "8873",
        "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "EDFO",
        "clearingBroker": "0158",
        "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "EDFP",
        "clearingBroker": "8873",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "EDJC",
        "clearingBroker": "5012",
        "brokerName": "EDWARD JONES/CDS                                                      "
    },
    {
        "type": "OTC",
        "mpid": "EDJO",
        "clearingBroker": "0057",
        "brokerName": "EDWARD D. JONES & CO.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "EGAM",
        "clearingBroker": "0050",
        "brokerName": "BATS TRADING, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "EGAW",
        "clearingBroker": "8199",
        "brokerName": "BATS TRADING, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "EGLE",
        "clearingBroker": "1043",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "OTC",
        "mpid": "EGXM",
        "clearingBroker": "0050",
        "brokerName": "BATS TRADING, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "EGXW",
        "clearingBroker": "8199",
        "brokerName": "BATS TRADING, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "ELEQ",
        "clearingBroker": "0551",
        "brokerName": "ELEQUIN SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "ELET",
        "clearingBroker": "0388",
        "brokerName": "ELECTRONIFIE SECURITIES LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "ELEV",
        "clearingBroker": "0235",
        "brokerName": "ELEVATION, LLC                                                        "
    },
    {
        "type": "OTC",
        "mpid": "EMOC",
        "clearingBroker": "0750",
        "brokerName": "E. MAGNUS OPPENHIEM & CO. INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "ENTR",
        "clearingBroker": "0235",
        "brokerName": "ENTRUSTODY FINANCIAL, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "EQHA",
        "clearingBroker": "0075",
        "brokerName": "EQUITABLE ADVISORS, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "EQSV",
        "clearingBroker": "0226",
        "brokerName": "EQUITY SERVICES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "EROP",
        "clearingBroker": "0158",
        "brokerName": "EROOM SECURITIES L.L.C.                                               "
    },
    {
        "type": "OTC",
        "mpid": "ESBD",
        "clearingBroker": "0235",
        "brokerName": "EASTDIL SECURED ADVISORS LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "ESGT",
        "clearingBroker": "0294",
        "brokerName": "EASTGATE SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "ESPD",
        "clearingBroker": "0696",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "OTC",
        "mpid": "ETBE",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "ETCB",
        "clearingBroker": "3505",
        "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "ETCL",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "ETDX",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "ETEJ",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "ETFU",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "ETMM",
        "clearingBroker": "0005",
        "brokerName": "G1 EXECUTION SERVICES, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "ETOR",
        "clearingBroker": "0158",
        "brokerName": "ETORO USA SECURITIES INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "ETRF",
        "clearingBroker": "0161",
        "brokerName": "G1 EXECUTION SERVICES, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "ETRS",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "EWMX",
        "clearingBroker": "0279",
        "brokerName": "EAST WEST MARKETS, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "EXTF",
        "clearingBroker": "0534",
        "brokerName": "WYNSTON HILL CAPITAL, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "EZOP",
        "clearingBroker": "0158",
        "brokerName": "OPTIONSHOUSE, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "FALC",
        "clearingBroker": "0103",
        "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "FARA",
        "clearingBroker": "8199",
        "brokerName": "FARINA & ASSOCIATES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "FATS",
        "clearingBroker": "0443",
        "brokerName": "FIRST BROKERS SECURITIES LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "FBLM",
        "clearingBroker": "0235",
        "brokerName": "FBL MARKETING SERVICES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "FBLT",
        "clearingBroker": "8199",
        "brokerName": "FIRST BALLANTYNE, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FBNS",
        "clearingBroker": "0235",
        "brokerName": "FBN SECURITIES, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "FBPC",
        "clearingBroker": "0443",
        "brokerName": "CREDIT SUISSE SECURITIES (USA) LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "FBSB",
        "clearingBroker": "0280",
        "brokerName": "U.S. BANCORP INVESTMENTS, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "FCCP",
        "clearingBroker": "0141",
        "brokerName": "WELLS FARGO CLEARING SERVICES, LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "FCML",
        "clearingBroker": "0279",
        "brokerName": "FNBB CAPITAL MARKETS, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "FCMP",
        "clearingBroker": "0595",
        "brokerName": "PRIME EXECUTIONS, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "FCST",
        "clearingBroker": "0443",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FDMI",
        "clearingBroker": "0571",
        "brokerName": "FREEDOM INVESTMENTS, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "FDSC",
        "clearingBroker": "0158",
        "brokerName": "1ST DISCOUNT BROKERAGE INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "FDSI",
        "clearingBroker": "0141",
        "brokerName": "FIRST DALLAS SECURITIES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "FEDR",
        "clearingBroker": "0235",
        "brokerName": "FEDERATED SECURITIES INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "FENV",
        "clearingBroker": "0294",
        "brokerName": "FENIX SECURITIES, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FENX",
        "clearingBroker": "0595",
        "brokerName": "FENIX SECURITIES, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FFCM",
        "clearingBroker": "0235",
        "brokerName": "FOREFRONT CAPITAL MARKETS LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "FFGI",
        "clearingBroker": "0235",
        "brokerName": "FELDSTEIN FINANCIAL GROUP, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "FFSI",
        "clearingBroker": "0158",
        "brokerName": "FIRSTRADE SECURITIES INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "FGIC",
        "clearingBroker": "0534",
        "brokerName": "FINANCORP GROUP INTERNATIONAL CORPORATION                             "
    },
    {
        "type": "OTC",
        "mpid": "FGOE",
        "clearingBroker": "0226",
        "brokerName": "FIRST GEORGETOWN SECURITIES, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "FHON",
        "clearingBroker": "0235",
        "brokerName": "FIRST HONOLULU SECURITIES INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "FIBS",
        "clearingBroker": "0226",
        "brokerName": "FIDELITY BROKERAGE SERVICES LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "FIDT",
        "clearingBroker": "5040",
        "brokerName": "FIDELITY CLEARING CANADA ULC/CDS                                      "
    },
    {
        "type": "OTC",
        "mpid": "FISA",
        "clearingBroker": "0443",
        "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "FISH",
        "clearingBroker": "0235",
        "brokerName": "L.B. FISHER & COMPANY                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FJRF",
        "clearingBroker": "0052",
        "brokerName": "PARITER SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "FKSC",
        "clearingBroker": "0235",
        "brokerName": "FIRST KENTUCKY SECURITIES CORP.                                       "
    },
    {
        "type": "OTC",
        "mpid": "FLAT",
        "clearingBroker": "0226",
        "brokerName": "FLORIDA ATLANTIC SECURITIES CORP.                                     "
    },
    {
        "type": "OTC",
        "mpid": "FLEX",
        "clearingBroker": "0158",
        "brokerName": "GWM GROUP, INC.                                                       "
    },
    {
        "type": "OTC",
        "mpid": "FLIB",
        "clearingBroker": "0235",
        "brokerName": "FIRST LIBERTIES FINANCIAL                                             "
    },
    {
        "type": "OTC",
        "mpid": "FLIO",
        "clearingBroker": "0158",
        "brokerName": "SANTOS CAPITAL GROUP, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "FLTG",
        "clearingBroker": "0005",
        "brokerName": "FLOW TRADERS U.S. LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FLTL",
        "clearingBroker": "0235",
        "brokerName": "FELTL & COMPANY                                                       "
    },
    {
        "type": "OTC",
        "mpid": "FLTU",
        "clearingBroker": "0551",
        "brokerName": "FLOW TRADERS U.S. LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FLWT",
        "clearingBroker": "0161",
        "brokerName": "FLOW TRADERS U.S. INSTITUTIONAL TRADING LLC                           "
    },
    {
        "type": "OTC",
        "mpid": "FMAF",
        "clearingBroker": "5008",
        "brokerName": "NBCN INC./CDS                                                         "
    },
    {
        "type": "OTC",
        "mpid": "FMAT",
        "clearingBroker": "0608",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "FMCO",
        "clearingBroker": "0443",
        "brokerName": "FIRST MANHATTAN CO.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "FMEX",
        "clearingBroker": "0750",
        "brokerName": "FINAMEX INTERNATIONAL, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "FMGF",
        "clearingBroker": "0695",
        "brokerName": "ABN AMRO CLEARING CHICAGO LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "FMNC",
        "clearingBroker": "0226",
        "brokerName": "FMN CAPITAL CORPORATION                                               "
    },
    {
        "type": "OTC",
        "mpid": "FNBR",
        "clearingBroker": "0728",
        "brokerName": "FOLIOFN INVESTMENTS, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "FNET",
        "clearingBroker": "0141",
        "brokerName": "WACHOVIA SECURITIES FINANCIAL NETWORK, LLC                            "
    },
    {
        "type": "OTC",
        "mpid": "FNFD",
        "clearingBroker": "0443",
        "brokerName": "FOLGER NOLAN FLEMING DOUGLAS INCORPORATED                             "
    },
    {
        "type": "OTC",
        "mpid": "FNIC",
        "clearingBroker": "0443",
        "brokerName": "FINANCIAL NETWORK INVESTMENT CORP.                                    "
    },
    {
        "type": "OTC",
        "mpid": "FNNL",
        "clearingBroker": "0158",
        "brokerName": "FENNEL                                                                "
    },
    {
        "type": "OTC",
        "mpid": "FNSJ",
        "clearingBroker": "0443",
        "brokerName": "FINANCIAL NORTHEASTERN SECURITIES, INC.                               "
    },
    {
        "type": "OTC",
        "mpid": "FNTN",
        "clearingBroker": "0158",
        "brokerName": "FINTRON INVEST                                                        "
    },
    {
        "type": "OTC",
        "mpid": "FNXE",
        "clearingBroker": "0158",
        "brokerName": "FENIX SECURITIES, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FNXS",
        "clearingBroker": "0750",
        "brokerName": "FENIX SECURITIES, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FOGS",
        "clearingBroker": "0235",
        "brokerName": "FOG EQUITIES LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "FORI",
        "clearingBroker": "0750",
        "brokerName": "FORTREND SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "FORS",
        "clearingBroker": "0158",
        "brokerName": "FORIS CAPITAL US LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "FRAC",
        "clearingBroker": "4305",
        "brokerName": "ATOMIC VAULTS SECURITIES, LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "FRCE",
        "clearingBroker": "2402",
        "brokerName": "FIN2                                                                  "
    },
    {
        "type": "OTC",
        "mpid": "FREC",
        "clearingBroker": "0158",
        "brokerName": "FREC SECURITIES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "FRKS",
        "clearingBroker": "0294",
        "brokerName": "FARKAS CAPITAL                                                        "
    },
    {
        "type": "OTC",
        "mpid": "FRSO",
        "clearingBroker": "0534",
        "brokerName": "FIRST OMEGA, LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "FRTN",
        "clearingBroker": "0103",
        "brokerName": "FORTUNE SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "FRTS",
        "clearingBroker": "0534",
        "brokerName": "FORTRESS PRIVATE LEDGER, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "FSRP",
        "clearingBroker": "0443",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "FTBR",
        "clearingBroker": "0728",
        "brokerName": "FOLIO INVESTMENTS, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "FTEN",
        "clearingBroker": "0226",
        "brokerName": "FTB ADVISORS, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "FTIT",
        "clearingBroker": "0005",
        "brokerName": "FLOW TRADERS U.S. INSTITUTIONAL TRADING LLC                           "
    },
    {
        "type": "OTC",
        "mpid": "FTLP",
        "clearingBroker": "8244",
        "brokerName": "FIRST TRUST PORTFOLIOS, L.P.                                          "
    },
    {
        "type": "OTC",
        "mpid": "FTRD",
        "clearingBroker": "0161",
        "brokerName": "FLOW TRADERS U.S. LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FTSC",
        "clearingBroker": "0202",
        "brokerName": "FHN FINANCIAL SECURITIES CORP.                                        "
    },
    {
        "type": "OTC",
        "mpid": "FTSR",
        "clearingBroker": "0226",
        "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "FUTA",
        "clearingBroker": "4272",
        "brokerName": "FUTU CLEARING INC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "FUTC",
        "clearingBroker": "4272",
        "brokerName": "FUTU CLEARING INC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "FUTG",
        "clearingBroker": "4272",
        "brokerName": "FUTU CLEARING INC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "FUTI",
        "clearingBroker": "4272",
        "brokerName": "FUTU INC                                                              "
    },
    {
        "type": "OTC",
        "mpid": "FUTJ",
        "clearingBroker": "4272",
        "brokerName": "FUTU CLEARING INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "FUTM",
        "clearingBroker": "4272",
        "brokerName": "FUTU CLEARING INC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "FUTU",
        "clearingBroker": "0534",
        "brokerName": "FUTU INC                                                              "
    },
    {
        "type": "OTC",
        "mpid": "FWSI",
        "clearingBroker": "0141",
        "brokerName": "FIRST WESTERN SECURITIES, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "GABE",
        "clearingBroker": "0534",
        "brokerName": "G. RESEARCH, INC.                                                     "
    },
    {
        "type": "OTC",
        "mpid": "GAFI",
        "clearingBroker": "0235",
        "brokerName": "GARDNER FINANCIAL SERVICES INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "GAGN",
        "clearingBroker": "0226",
        "brokerName": "GAGNON SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "GALX",
        "clearingBroker": "0534",
        "brokerName": "GALAXY SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "GARB",
        "clearingBroker": "0148",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
    },
    {
        "type": "OTC",
        "mpid": "GARC",
        "clearingBroker": "0161",
        "brokerName": "ICAP CORPORATES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "GARR",
        "clearingBroker": "0226",
        "brokerName": "GARRETT NAGLE & CO., INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "GARW",
        "clearingBroker": "0595",
        "brokerName": "GAR WOOD SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "GATE",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "GBMT",
        "clearingBroker": "0443",
        "brokerName": "GBM INTERNATIONAL, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "GBTS",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "GDOC",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "GEBB",
        "clearingBroker": "0551",
        "brokerName": "GLOBAL EXECUTION BROKERS, LP                                          "
    },
    {
        "type": "OTC",
        "mpid": "GELB",
        "clearingBroker": "0005",
        "brokerName": "GELBER SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "GELP",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "GENS",
        "clearingBroker": "0279",
        "brokerName": "GENERAL SECURITIES CORP                                               "
    },
    {
        "type": "OTC",
        "mpid": "GENW",
        "clearingBroker": "0226",
        "brokerName": "GENEOS WEALTH MANAGEMENT, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "GETS",
        "clearingBroker": "0295",
        "brokerName": "GETCO SECURITIES, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "GFIG",
        "clearingBroker": "0537",
        "brokerName": "GFI SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "GFIS",
        "clearingBroker": "0005",
        "brokerName": "GFI SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "GFLO",
        "clearingBroker": "0443",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "GFRY",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "GFYC",
        "clearingBroker": "0438",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "GHCC",
        "clearingBroker": "0226",
        "brokerName": "GORDON, HASKETT CAPITAL CORPORATION                                   "
    },
    {
        "type": "OTC",
        "mpid": "GILG",
        "clearingBroker": "0226",
        "brokerName": "GILDER GAGNON HOWE & CO. LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "GJSS",
        "clearingBroker": "0235",
        "brokerName": "SCHWARTZ, GREGORY J & CO. INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "GLED",
        "clearingBroker": "0283",
        "brokerName": "GLENDALE SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "GLII",
        "clearingBroker": "5005",
        "brokerName": "TD SECURITIES INC./CDS                                                "
    },
    {
        "type": "OTC",
        "mpid": "GLIP",
        "clearingBroker": "5062",
        "brokerName": "TD SECURITIES INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "GLIR",
        "clearingBroker": "5021",
        "brokerName": "TD WATERHOUSE CANADA INC. #5/CDS                                      "
    },
    {
        "type": "OTC",
        "mpid": "GLIS",
        "clearingBroker": "5036",
        "brokerName": "TD WATERHOUSE CANADA INC./CDS                                         "
    },
    {
        "type": "OTC",
        "mpid": "GLLL",
        "clearingBroker": "0279",
        "brokerName": "GILL CAPITAL PARTNERS                                                 "
    },
    {
        "type": "OTC",
        "mpid": "GLPX",
        "clearingBroker": "9132",
        "brokerName": "ACS EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "GLTV",
        "clearingBroker": "0294",
        "brokerName": "GTS SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "GMSE",
        "clearingBroker": "0750",
        "brokerName": "GAMMA SECURITIES, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "GMSG",
        "clearingBroker": "0443",
        "brokerName": "GMS GROUP (THE), L.L.C.                                               "
    },
    {
        "type": "OTC",
        "mpid": "GONE",
        "clearingBroker": "0551",
        "brokerName": "GROUP ONE TRADING, L.P.                                               "
    },
    {
        "type": "OTC",
        "mpid": "GPCA",
        "clearingBroker": "0235",
        "brokerName": "GREAT POINT CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GPCE",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "GPCW",
        "clearingBroker": "8199",
        "brokerName": "GREAT POINT CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GPSA",
        "clearingBroker": "0294",
        "brokerName": "GLOBAL PACIFIC SECURITIES US, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "GPSS",
        "clearingBroker": "0443",
        "brokerName": "GREAT PACIFIC SECURITIES                                              "
    },
    {
        "type": "OTC",
        "mpid": "GPTG",
        "clearingBroker": "0534",
        "brokerName": "SMITH CAPITAL MARKETS, LLC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "GRAD",
        "clearingBroker": "0235",
        "brokerName": "GRADIENT SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "GRBD",
        "clearingBroker": "0052",
        "brokerName": "GREENBIRD CAPITAL LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "GRFN",
        "clearingBroker": "0103",
        "brokerName": "GRIFFIN FINANCIAL GROUP, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "GRIL",
        "clearingBroker": "0235",
        "brokerName": "GLOBAL RESOURCE INVESTMENTS, LTD.                                     "
    },
    {
        "type": "OTC",
        "mpid": "GROD",
        "clearingBroker": "0226",
        "brokerName": "GRODSKY ASSOCIATES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "GRPS",
        "clearingBroker": "0226",
        "brokerName": "MML INVESTORS SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "GRWD",
        "clearingBroker": "0052",
        "brokerName": "GAR WOOD SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "GSBI",
        "clearingBroker": "0279",
        "brokerName": "GLOBAL BROKERAGE SERVICES, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "GSCO",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSCS",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSFS",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "GSIB",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSLM",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSLT",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSLZ",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSMM",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSQQ",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSSC",
        "clearingBroker": "0161",
        "brokerName": "GEORGESON SHAREHOLDER SECURITIES CORP.                                "
    },
    {
        "type": "OTC",
        "mpid": "GSSI",
        "clearingBroker": "0052",
        "brokerName": "GARDEN STATE SECURITIES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "GSUU",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSVV",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSWW",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSXX",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSYY",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSZZ",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GTBY",
        "clearingBroker": "0158",
        "brokerName": "GATSBY SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "GTEX",
        "clearingBroker": "0005",
        "brokerName": "GTS EXECUTION SERVICES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "GTNA",
        "clearingBroker": "0294",
        "brokerName": "GTN AMERICAS FINANCIAL SERVICES INC                                   "
    },
    {
        "type": "OTC",
        "mpid": "GTNB",
        "clearingBroker": "0595",
        "brokerName": "GTN AMERICAS FINANCIAL SERVICES, INC.                                 "
    },
    {
        "type": "OTC",
        "mpid": "GTNC",
        "clearingBroker": "9132",
        "brokerName": "GTN AMERICAS FINANCIAL SERVICES INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "GTSB",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "GTSM",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "GTSW",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "GTSY",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "GTSZ",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "GTTX",
        "clearingBroker": "0695",
        "brokerName": "ABN AMRO CLEARING CHICAGO LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "GUGI",
        "clearingBroker": "0526",
        "brokerName": "GUGGENHEIM FUNDS DISTRIBUTORS, LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "GUGS",
        "clearingBroker": "0443",
        "brokerName": "GUGGENHEIM SECURITIES, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "GWDS",
        "clearingBroker": "0534",
        "brokerName": "GAR WOOD SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "GWNS",
        "clearingBroker": "0226",
        "brokerName": "GWN SECURITIES INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "GZML",
        "clearingBroker": "0161",
        "brokerName": "GUZMAN & COMPANY                                                      "
    },
    {
        "type": "OTC",
        "mpid": "HACA",
        "clearingBroker": "0701",
        "brokerName": "HARVEST CAPITAL LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "HAFS",
        "clearingBroker": "0279",
        "brokerName": "HANTZ FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "HALA",
        "clearingBroker": "0534",
        "brokerName": "HALIFAX AMERICA LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "HALO",
        "clearingBroker": "0235",
        "brokerName": "HALO SECURITIES, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "HAPI",
        "clearingBroker": "0158",
        "brokerName": "HAPI                                                                  "
    },
    {
        "type": "OTC",
        "mpid": "HAPX",
        "clearingBroker": "0551",
        "brokerName": "HAP TRADING, LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "HARC",
        "clearingBroker": "0235",
        "brokerName": "HARLEY CAPITAL LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "HARS",
        "clearingBroker": "8199",
        "brokerName": "HARVESTONS SECURITIES, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "HASF",
        "clearingBroker": "5058",
        "brokerName": "HAYWOOD SECURITIES INC./ CDS                                          "
    },
    {
        "type": "OTC",
        "mpid": "HAVK",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE STATE FINANCIAL, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "HAZL",
        "clearingBroker": "0226",
        "brokerName": "HAZLETT, BURT AND WATSON, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "HBCA",
        "clearingBroker": "0430",
        "brokerName": "HOLD BROTHERS CAPITAL LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "HBCL",
        "clearingBroker": "0430",
        "brokerName": "HOLD BROTHERS CAPITAL LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "HBIF",
        "clearingBroker": "0695",
        "brokerName": "DRW SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "HBIW",
        "clearingBroker": "0695",
        "brokerName": "DRW SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "HCGC",
        "clearingBroker": "0103",
        "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "HCMX",
        "clearingBroker": "0235",
        "brokerName": "HOOPOE CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "HCTA",
        "clearingBroker": "0005",
        "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "HCWW",
        "clearingBroker": "0235",
        "brokerName": "H.C.WAINWRIGHT & CO., LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "HDVS",
        "clearingBroker": "0226",
        "brokerName": "AVANTAX INVESTMENT SERVICES, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "HEAD",
        "clearingBroker": "0443",
        "brokerName": "TD SECURITIES AUTOMATED TRADING LLC                                   "
    },
    {
        "type": "OTC",
        "mpid": "HEDG",
        "clearingBroker": "0158",
        "brokerName": "HEDGE PRO LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "HENN",
        "clearingBroker": "0235",
        "brokerName": "CARL M. HENNIG, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "HENY",
        "clearingBroker": "0443",
        "brokerName": "HENLEY & COMPANY LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "HFLD",
        "clearingBroker": "0279",
        "brokerName": "HARTFIELD, TITUS & DONNELLY, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "HIGG",
        "clearingBroker": "0235",
        "brokerName": "HIGGINS CAPITAL MANAGEMENT, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "HNTR",
        "clearingBroker": "0443",
        "brokerName": "HUNTER ASSOCIATES, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "HOLD",
        "clearingBroker": "0430",
        "brokerName": "HOLD BROTHERS CAPITAL LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "HONR",
        "clearingBroker": "0235",
        "brokerName": "ROBERTS & RYAN INVESTMENTS INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "HOOD",
        "clearingBroker": "6769",
        "brokerName": "ROBINHOOD SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "HOPK",
        "clearingBroker": "0750",
        "brokerName": "SILVER OAK SECURITIES, INCORPORATED                                   "
    },
    {
        "type": "OTC",
        "mpid": "HORW",
        "clearingBroker": "0534",
        "brokerName": "INSIGHT SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "HOVD",
        "clearingBroker": "0103",
        "brokerName": "HOVDE GROUP, LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "HPOM",
        "clearingBroker": "0235",
        "brokerName": "HERNDON PLANT OAKLEY, LTD.                                            "
    },
    {
        "type": "OTC",
        "mpid": "HPSR",
        "clearingBroker": "0534",
        "brokerName": "HEWLETT POINT SECURITIES, LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "HRBF",
        "clearingBroker": "0756",
        "brokerName": "AMERICAN ENTERPRISE INVESTMENT SERVICES INC.                          "
    },
    {
        "type": "OTC",
        "mpid": "HRGR",
        "clearingBroker": "0235",
        "brokerName": "HARGER AND COMPANY, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "HRTB",
        "clearingBroker": "0551",
        "brokerName": "HRT FINANCIAL LP                                                      "
    },
    {
        "type": "OTC",
        "mpid": "HRTF",
        "clearingBroker": "0369",
        "brokerName": "HRT FINANCIAL LP                                                      "
    },
    {
        "type": "OTC",
        "mpid": "HRTW",
        "clearingBroker": "0369",
        "brokerName": "HRT FINANCIAL LP                                                      "
    },
    {
        "type": "OTC",
        "mpid": "HRTX",
        "clearingBroker": "0369",
        "brokerName": "HRT EXECUTION SERVICES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "HSAC",
        "clearingBroker": "0158",
        "brokerName": "KBFG SECURITIES AMERICA INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "HSAI",
        "clearingBroker": "0443",
        "brokerName": "INDEPENDENT FINANCIAL GROUP, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "HSBC",
        "clearingBroker": "0816",
        "brokerName": "HSBC SECURITIES (USA), INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "HSBK",
        "clearingBroker": "0816",
        "brokerName": "HSBC SECURITIES (USA) INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "HTCM",
        "clearingBroker": "0235",
        "brokerName": "HOWDEN TIGER CAPITAL MARKETS & ADVISOF LLC                            "
    },
    {
        "type": "OTC",
        "mpid": "HTIS",
        "clearingBroker": "0443",
        "brokerName": "HAITONG INTERNATIONAL SECURITIES (USA) INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "HTSC",
        "clearingBroker": "0750",
        "brokerName": "HUATAI SECURITIES (USA), INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "HTWR",
        "clearingBroker": "0226",
        "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "HUCO",
        "clearingBroker": "0226",
        "brokerName": "HUNTINGTON INVESTMENT COMPANY                                         "
    },
    {
        "type": "OTC",
        "mpid": "HUNT",
        "clearingBroker": "0141",
        "brokerName": "HUNTLEIGH SECURITIES CORPORATION                                      "
    },
    {
        "type": "OTC",
        "mpid": "HWJC",
        "clearingBroker": "0052",
        "brokerName": "HWJ CAPITAL PARTNERS II, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "HWLS",
        "clearingBroker": "0443",
        "brokerName": "M.S. HOWELLS & CO.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "HYSI",
        "clearingBroker": "0226",
        "brokerName": "HEIM, YOUNG & ASSOCIATES, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "IAAK",
        "clearingBroker": "0279",
        "brokerName": "ISAAK BOND INVESTMENT, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "IAEA",
        "clearingBroker": "0294",
        "brokerName": "SRT SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "IAEW",
        "clearingBroker": "0595",
        "brokerName": "SRT SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "IAEX",
        "clearingBroker": "0235",
        "brokerName": "SRT SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "IATS",
        "clearingBroker": "0017",
        "brokerName": "INTERACTIVE BROKERS LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "IBCO",
        "clearingBroker": "0534",
        "brokerName": "INTERACTIVE BROKERS CORP.                                             "
    },
    {
        "type": "OTC",
        "mpid": "IBFS",
        "clearingBroker": "0824",
        "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL SERVICES LLC        "
    },
    {
        "type": "OTC",
        "mpid": "IBKR",
        "clearingBroker": "0534",
        "brokerName": "INTERACTIVE BROKERS LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "IBND",
        "clearingBroker": "0103",
        "brokerName": "INSTITUTIONAL BOND NETWORK, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "IBPR",
        "clearingBroker": "0052",
        "brokerName": "IB CAPITAL LLC                                                        "
    },
    {
        "type": "OTC",
        "mpid": "IBSH",
        "clearingBroker": "0595",
        "brokerName": "INTEGRITY BROKERAGE SERVICES, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "IBSJ",
        "clearingBroker": "0052",
        "brokerName": "INTEGRITY BROKERAGE SERVICES, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "ICAN",
        "clearingBroker": "0226",
        "brokerName": "CETERA ADVISOR NETWORKS LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "ICBC",
        "clearingBroker": "0824",
        "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL                     "
    },
    {
        "type": "OTC",
        "mpid": "ICBK",
        "clearingBroker": "0388",
        "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL SERVICES LLC        "
    },
    {
        "type": "OTC",
        "mpid": "ICBX",
        "clearingBroker": "0067",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "ICCP",
        "clearingBroker": "0443",
        "brokerName": "INVESTORS CAPITAL CORPORATION                                         "
    },
    {
        "type": "OTC",
        "mpid": "ICDS",
        "clearingBroker": "0750",
        "brokerName": "ICD SECURITIES                                                        "
    },
    {
        "type": "OTC",
        "mpid": "ICFS",
        "clearingBroker": "0534",
        "brokerName": "INTERCAROLINA FINANCIAL SERVICES, INC.                                "
    },
    {
        "type": "OTC",
        "mpid": "ICMH",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL CAPITAL MANAGEMENT, INC.                                "
    },
    {
        "type": "OTC",
        "mpid": "ICON",
        "clearingBroker": "0595",
        "brokerName": "ICON CAPITAL GROUP, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "ICRD",
        "clearingBroker": "0551",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "ICVT",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "IDAY",
        "clearingBroker": "0103",
        "brokerName": "BROKERAGESELECT                                                       "
    },
    {
        "type": "OTC",
        "mpid": "IELP",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "IEOS",
        "clearingBroker": "0534",
        "brokerName": "INTERACTIVE BROKERS LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "IEQY",
        "clearingBroker": "0551",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "IESI",
        "clearingBroker": "0443",
        "brokerName": "ITAU EUROPA SECURITIES INC                                            "
    },
    {
        "type": "OTC",
        "mpid": "IEXG",
        "clearingBroker": "0161",
        "brokerName": "IEX SERVICES, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "IFCS",
        "clearingBroker": "0161",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "ILND",
        "clearingBroker": "0520",
        "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "ILNK",
        "clearingBroker": "0750",
        "brokerName": "INVESTORLINK CAPITAL MARKETS, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "IMAB",
        "clearingBroker": "0695",
        "brokerName": "IMC-CHICAGO, LLC, IMC FINANCIAL MARKETS                               "
    },
    {
        "type": "OTC",
        "mpid": "IMCC",
        "clearingBroker": "0005",
        "brokerName": "IMC FINANCIAL MARKETS                                                 "
    },
    {
        "type": "OTC",
        "mpid": "IMCS",
        "clearingBroker": "0005",
        "brokerName": "IMC FINANCIAL MARKETS                                                 "
    },
    {
        "type": "OTC",
        "mpid": "IMCX",
        "clearingBroker": "0005",
        "brokerName": "IMC EXECUTION SERVICES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "IMMG",
        "clearingBroker": "0226",
        "brokerName": "INTERNATIONAL MONEY MANAGEMENT GROUP, INC.                            "
    },
    {
        "type": "OTC",
        "mpid": "IMPC",
        "clearingBroker": "0443",
        "brokerName": "IMPERIAL CAPITAL, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "IMSE",
        "clearingBroker": "0695",
        "brokerName": "IMC SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "INAB",
        "clearingBroker": "0695",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INAM",
        "clearingBroker": "0695",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INCA",
        "clearingBroker": "0067",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INCE",
        "clearingBroker": "0067",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INCR",
        "clearingBroker": "0067",
        "brokerName": "INTELLIGENT CROSS LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "INCV",
        "clearingBroker": "0294",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INCW",
        "clearingBroker": "0294",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INCX",
        "clearingBroker": "9132",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INCY",
        "clearingBroker": "9132",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INDB",
        "clearingBroker": "0067",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INDX",
        "clearingBroker": "0158",
        "brokerName": "LINDEN THOMAS AND COMPANY SECURITIES, LLC                             "
    },
    {
        "type": "OTC",
        "mpid": "INDY",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "INET",
        "clearingBroker": "0568",
        "brokerName": "NADAQ EXECUTION SERVICES, LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "INFI",
        "clearingBroker": "0279",
        "brokerName": "INTEGRAL FINANCIAL, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "INFX",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "INGF",
        "clearingBroker": "0270",
        "brokerName": "ING FINANCIAL MARKETS LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "INGS",
        "clearingBroker": "0124",
        "brokerName": "INGALLS & SNYDER, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "INJX",
        "clearingBroker": "0536",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INNO",
        "clearingBroker": "0052",
        "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "INPI",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT PLANNERS INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "INPS",
        "clearingBroker": "0235",
        "brokerName": "INDEPENDENCE POINT SECURITIES LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "INSR",
        "clearingBroker": "0067",
        "brokerName": "INTELLIGENT CROSS LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "INTB",
        "clearingBroker": "0158",
        "brokerName": "INTER&CO SECURITIES LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "INTL",
        "clearingBroker": "0161",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "INTW",
        "clearingBroker": "0067",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INTX",
        "clearingBroker": "0235",
        "brokerName": "INTERNATIONAL ASSETS ADVISORY, LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "ISCN",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
    },
    {
        "type": "OTC",
        "mpid": "ISEY",
        "clearingBroker": "0520",
        "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "ISIG",
        "clearingBroker": "0226",
        "brokerName": "EVERCORE GROUP L.L.C.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "ISLL",
        "clearingBroker": "0052",
        "brokerName": "INLET SECURITIES LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "ISSI",
        "clearingBroker": "0052",
        "brokerName": "INSIGHT SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "ITAU",
        "clearingBroker": "0443",
        "brokerName": "ITAU BBA USA SECURITIES INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "ITCC",
        "clearingBroker": "0750",
        "brokerName": "STERNE AGEE FINANCIAL SERVICES, INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "ITGI",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "ITGP",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "IURS",
        "clearingBroker": "0534",
        "brokerName": "IUR SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "IVNT",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT NETWORK, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "IVOL",
        "clearingBroker": "0235",
        "brokerName": "UNION CAPITAL COMPANY                                                 "
    },
    {
        "type": "OTC",
        "mpid": "JANE",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET MARKETS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "JANS",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET MARKETS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "JANY",
        "clearingBroker": "0374",
        "brokerName": "JANNEY MONTGOMERY SCOTT LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "JBDX",
        "clearingBroker": "0294",
        "brokerName": "JB DRAX HONORE INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "JBLK",
        "clearingBroker": "0019",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "JDRB",
        "clearingBroker": "0595",
        "brokerName": "J.H. DARBIE & CO., INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "JEFF",
        "clearingBroker": "0019",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "JEFM",
        "clearingBroker": "0235",
        "brokerName": "JEFFREY MATTHEWS FINANCIAL GROUP, L.L.C.                              "
    },
    {
        "type": "OTC",
        "mpid": "JEFX",
        "clearingBroker": "0536",
        "brokerName": "JEFFERIES EXECUTION SERVICES, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "JEVO",
        "clearingBroker": "0235",
        "brokerName": "ATIS, INC                                                             "
    },
    {
        "type": "OTC",
        "mpid": "JEXF",
        "clearingBroker": "0536",
        "brokerName": "ABN AMRO CLEARING CHICAGO LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "JGRC",
        "clearingBroker": "0103",
        "brokerName": "JOSEPH GRACE                                                          "
    },
    {
        "type": "OTC",
        "mpid": "JGUN",
        "clearingBroker": "0235",
        "brokerName": "JOSEPH GUNNAR & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "JHDR",
        "clearingBroker": "0052",
        "brokerName": "JH DARBIE & CO. INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "JHYT",
        "clearingBroker": "0019",
        "brokerName": "JEFFERIES PARTNER OPPORTUNITY FUND II, LLC                            "
    },
    {
        "type": "OTC",
        "mpid": "JKFS",
        "clearingBroker": "0279",
        "brokerName": "J.K. FINANCIAL SERVICES INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "JLEQ",
        "clearingBroker": "0161",
        "brokerName": "JUMP EXECUTION, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "JMLS",
        "clearingBroker": "0235",
        "brokerName": "J.M LUMMIS SECURITIES, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "JMPT",
        "clearingBroker": "0551",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "JMSI",
        "clearingBroker": "0374",
        "brokerName": "JANNEY MONTGOMERY SCOTT LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "JNST",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "JOHN",
        "clearingBroker": "8072",
        "brokerName": "SCOTTSDALE CAPITAL ADVISORS                                           "
    },
    {
        "type": "OTC",
        "mpid": "JONE",
        "clearingBroker": "0161",
        "brokerName": "JONESTRADING                                                          "
    },
    {
        "type": "OTC",
        "mpid": "JPBX",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "JPII",
        "clearingBroker": "0534",
        "brokerName": "JAYPEE INTERNATIONAL, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "JPME",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "JPMG",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "JPMP",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "JPMS",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "JPMT",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "JPMX",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "JPPB",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "JRCO",
        "clearingBroker": "0226",
        "brokerName": "JOHNSON RICE & COMPANY L.L.C.                                         "
    },
    {
        "type": "OTC",
        "mpid": "JSAP",
        "clearingBroker": "8497",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "JSBA",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "JSCA",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "JSCL",
        "clearingBroker": "0052",
        "brokerName": "JOSEPH STONE CAPITAL L.L.C.                                           "
    },
    {
        "type": "OTC",
        "mpid": "JSCO",
        "clearingBroker": "3856",
        "brokerName": "J. STREICHER & CO. L.L.C.                                             "
    },
    {
        "type": "OTC",
        "mpid": "JSCT",
        "clearingBroker": "0005",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "JSEB",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
    },
    {
        "type": "OTC",
        "mpid": "JSEG",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
    },
    {
        "type": "OTC",
        "mpid": "JSJX",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "JSML",
        "clearingBroker": "0551",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "JSOL",
        "clearingBroker": "0551",
        "brokerName": "JANE STREET OPTIONS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "JSPT",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET MARKETS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "JSSC",
        "clearingBroker": "3492",
        "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
    },
    {
        "type": "OTC",
        "mpid": "JSSF",
        "clearingBroker": "0226",
        "brokerName": "JMP SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "JTOT",
        "clearingBroker": "0005",
        "brokerName": "JONES TRADING                                                         "
    },
    {
        "type": "OTC",
        "mpid": "JUSX",
        "clearingBroker": "3856",
        "brokerName": "JUST2TRADE, INC.                                                      "
    },
    {
        "type": "OTC",
        "mpid": "JVBF",
        "clearingBroker": "0235",
        "brokerName": "JACK V. BUTTERFIELD INVESTMENT COMPANY                                "
    },
    {
        "type": "OTC",
        "mpid": "JVBG",
        "clearingBroker": "0443",
        "brokerName": "J.V.B. FINANCIAL GROUP LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "JVDA",
        "clearingBroker": "0294",
        "brokerName": "CHAINCE SECURITIES, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "JWCF",
        "clearingBroker": "0226",
        "brokerName": "J. W. COLE FINANCIAL, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "JWTT",
        "clearingBroker": "0158",
        "brokerName": "JWTT INC.                                                             "
    },
    {
        "type": "OTC",
        "mpid": "JXLI",
        "clearingBroker": "0536",
        "brokerName": "LIME BROKERAGE LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "KALA",
        "clearingBroker": "0226",
        "brokerName": "KA ASSOCIATES, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "KALS",
        "clearingBroker": "0235",
        "brokerName": "KALOS CAPITAL, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "KAPG",
        "clearingBroker": "0158",
        "brokerName": "KAPITALL GENERATION, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "KART",
        "clearingBroker": "0750",
        "brokerName": "REVERE SECURITIES CORP.                                               "
    },
    {
        "type": "OTC",
        "mpid": "KBWI",
        "clearingBroker": "0793",
        "brokerName": "KEEFE, BRUYETTE & WOODS, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "KCAM",
        "clearingBroker": "0052",
        "brokerName": "K2 CAPITAL ASSET MANAGEMENT, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "KCGM",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "KCIM",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT MANAGEMENT CORPORATION                                     "
    },
    {
        "type": "OTC",
        "mpid": "KCIX",
        "clearingBroker": "0279",
        "brokerName": "KILEY PARTNERS, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "KCMP",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "KCRD",
        "clearingBroker": "0052",
        "brokerName": "PHX FINANCIAL, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "KEEN",
        "clearingBroker": "0279",
        "brokerName": "ST. BERNARD FINANCIAL SERVICES, INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "KELG",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "KELL",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "KENS",
        "clearingBroker": "0279",
        "brokerName": "KENSINGTON CAPITAL CORP.                                              "
    },
    {
        "type": "OTC",
        "mpid": "KEYB",
        "clearingBroker": "0443",
        "brokerName": "KEYBANC CAPITAL MARKETS INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "KEYS",
        "clearingBroker": "2402",
        "brokerName": "ARETE WEALTH MANAGEMENT, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "KIML",
        "clearingBroker": "0226",
        "brokerName": "KIMELMAN & BAIRD, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "KING",
        "clearingBroker": "0235",
        "brokerName": "C. L. KING & ASSOCIATES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "KISA",
        "clearingBroker": "0294",
        "brokerName": "KOREA INVESTMENT & SECURITIES AMERICA, INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "KLFX",
        "clearingBroker": "9132",
        "brokerName": "KLEON FINANCIAL, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "KNGS",
        "clearingBroker": "0235",
        "brokerName": "KINGSWOOD CAPITAL PARTNERS, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "KNGW",
        "clearingBroker": "0158",
        "brokerName": "KINGSWOOD CAPITAL PARTNERS, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "KOVS",
        "clearingBroker": "0226",
        "brokerName": "KOVACK SECURITIES INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "KRCO",
        "clearingBroker": "0235",
        "brokerName": "KR SECURITIES, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "KRMQ",
        "clearingBroker": "0158",
        "brokerName": "KARMEQ, LLC                                                           "
    },
    {
        "type": "OTC",
        "mpid": "KRSH",
        "clearingBroker": "0005",
        "brokerName": "KERSHNER SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "KRTH",
        "clearingBroker": "0235",
        "brokerName": "J.W. KORTH & COMPANY                                                  "
    },
    {
        "type": "OTC",
        "mpid": "KUYK",
        "clearingBroker": "0279",
        "brokerName": "KUYKENDALL & SCHNEIDER, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "KWSC",
        "clearingBroker": "0294",
        "brokerName": "KW SECURITIES CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "KYAN",
        "clearingBroker": "0103",
        "brokerName": "KAYAN SECURITIES, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "KYCS",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "LAFB",
        "clearingBroker": "0235",
        "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "LAFC",
        "clearingBroker": "0443",
        "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "LAFF",
        "clearingBroker": "0443",
        "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "LAFI",
        "clearingBroker": "0750",
        "brokerName": "LAFISE SECURITIES CORPORATION                                         "
    },
    {
        "type": "OTC",
        "mpid": "LAGI",
        "clearingBroker": "0226",
        "brokerName": "ALLSTATE FINANCIAL SERVICES, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "LAMA",
        "clearingBroker": "0141",
        "brokerName": "XML SECURITIES                                                        "
    },
    {
        "type": "OTC",
        "mpid": "LAMP",
        "clearingBroker": "4305",
        "brokerName": "LAMPOST CAPITAL, L.C.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "LANE",
        "clearingBroker": "0235",
        "brokerName": "MARC J. LANE & COMPANY                                                "
    },
    {
        "type": "OTC",
        "mpid": "LASI",
        "clearingBroker": "0141",
        "brokerName": "LIEBLONG & ASSOCIATES, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "LASS",
        "clearingBroker": "0226",
        "brokerName": "LASALLE ST. SECURITIES, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "LATG",
        "clearingBroker": "0537",
        "brokerName": "GFI SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "LATM",
        "clearingBroker": "0537",
        "brokerName": "GFI SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "LATN",
        "clearingBroker": "0443",
        "brokerName": "HEROLD & LANTERN INVESTMENTS, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "LATS",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "LBKI",
        "clearingBroker": "0235",
        "brokerName": "LIBUCKI & CO., LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "LDGA",
        "clearingBroker": "0052",
        "brokerName": "DOUGALL & ASSOCIATES                                                  "
    },
    {
        "type": "OTC",
        "mpid": "LDIL",
        "clearingBroker": "0226",
        "brokerName": "LINCOLN DOUGLAS INVESTMENTS, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "LDLW",
        "clearingBroker": "0750",
        "brokerName": "LAIDLAW & COMPANY (UK) LTD.                                           "
    },
    {
        "type": "OTC",
        "mpid": "LDOT",
        "clearingBroker": "0235",
        "brokerName": "LANDOLT SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "LEAD",
        "clearingBroker": "0226",
        "brokerName": "THE LEADERS GROUP, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "LEBO",
        "clearingBroker": "0226",
        "brokerName": "LEIGH BALDWIN & CO., LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "LEDE",
        "clearingBroker": "5071",
        "brokerName": "LEEDE JONES GABLE INC./CDS                                            "
    },
    {
        "type": "OTC",
        "mpid": "LEER",
        "clearingBroker": "0443",
        "brokerName": "LEERINK SWANN & COMPANY                                               "
    },
    {
        "type": "OTC",
        "mpid": "LEHB",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "LEHM",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "LEHP",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "LEIM",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "LESW",
        "clearingBroker": "0443",
        "brokerName": "LEERINK SWANN & COMPANY                                               "
    },
    {
        "type": "OTC",
        "mpid": "LETS",
        "clearingBroker": "3450",
        "brokerName": "CHOICETRADE                                                           "
    },
    {
        "type": "OTC",
        "mpid": "LEXM",
        "clearingBroker": "0158",
        "brokerName": "LEX MARKETS LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "LEYA",
        "clearingBroker": "0235",
        "brokerName": "LEMLEY, YARLING & CO.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "LFAC",
        "clearingBroker": "0226",
        "brokerName": "OSAIC FA, INC.                                                        "
    },
    {
        "type": "OTC",
        "mpid": "LFRO",
        "clearingBroker": "0235",
        "brokerName": "LF ROTHSCHILD, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "LGLL",
        "clearingBroker": "0534",
        "brokerName": "MM GLOBAL SECURITIES, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "LGNT",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "LGSA",
        "clearingBroker": "0158",
        "brokerName": "WOORI INVESTMENT AND SECURITIES AMERICA, INC.                         "
    },
    {
        "type": "OTC",
        "mpid": "LHMA",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "LHMB",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "LHSB",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "LIFG",
        "clearingBroker": "0279",
        "brokerName": "LONG ISLAND FINANCIAL GROUP, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "LIME",
        "clearingBroker": "8199",
        "brokerName": "SCORE PRIORITY CORP.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "LINC",
        "clearingBroker": "0158",
        "brokerName": "LIBERUM                                                               "
    },
    {
        "type": "OTC",
        "mpid": "LIVC",
        "clearingBroker": "0294",
        "brokerName": "LIME TRADING CORP                                                     "
    },
    {
        "type": "OTC",
        "mpid": "LIWM",
        "clearingBroker": "0695",
        "brokerName": "SCORE PRIORITY CORP.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "LIWO",
        "clearingBroker": "0695",
        "brokerName": "SCORE PRIORITY CORP.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "LMAR",
        "clearingBroker": "0226",
        "brokerName": "LIFEMARK SECURITIES CORP.                                             "
    },
    {
        "type": "OTC",
        "mpid": "LMGP",
        "clearingBroker": "8199",
        "brokerName": "SCORE PRIORITY CORP.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "LMKO",
        "clearingBroker": "0235",
        "brokerName": "KOHN (L.M.) & COMPANY                                                 "
    },
    {
        "type": "OTC",
        "mpid": "LMNX",
        "clearingBroker": "0226",
        "brokerName": "LUMINEX TRADING & ANALYTICS LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "LMPC",
        "clearingBroker": "0695",
        "brokerName": "SCORE PRIORITY CORP.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "LMPT",
        "clearingBroker": "0695",
        "brokerName": "SCORE PRIORITY CORP.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "LNCL",
        "clearingBroker": "0443",
        "brokerName": "LINCOLN INVESTMENT                                                    "
    },
    {
        "type": "OTC",
        "mpid": "LOMB",
        "clearingBroker": "0141",
        "brokerName": "LOMBARD SECURITIES INCORPORATED                                       "
    },
    {
        "type": "OTC",
        "mpid": "LOOP",
        "clearingBroker": "0443",
        "brokerName": "LOOP CAPITAL MARKETS LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "LOTC",
        "clearingBroker": "0226",
        "brokerName": "L.O. THOMAS & CO. INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "LOUE",
        "clearingBroker": "0161",
        "brokerName": "ICAP CORPORATES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "LOUI",
        "clearingBroker": "0005",
        "brokerName": "LOUIS CAPITAL MARKETS, LP                                             "
    },
    {
        "type": "OTC",
        "mpid": "LPCA",
        "clearingBroker": "3856",
        "brokerName": "ALPACA SECURITIES LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "LPCM",
        "clearingBroker": "0103",
        "brokerName": "LAMPERT CAPITAL MARKETS INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "LPFS",
        "clearingBroker": "0235",
        "brokerName": "LIBERTY PARTNERS FINANCIAL SERVICES, INC.                             "
    },
    {
        "type": "OTC",
        "mpid": "LPLE",
        "clearingBroker": "0075",
        "brokerName": "LPL ENTERPRISE, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "LPSP",
        "clearingBroker": "1043",
        "brokerName": "LPS CAPITAL LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "LQFI",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "LQNA",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "OTC",
        "mpid": "LQNB",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "OTC",
        "mpid": "LQNF",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "OTC",
        "mpid": "LQNT",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "OTC",
        "mpid": "LQPT",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "LRBC",
        "clearingBroker": "0235",
        "brokerName": "LIBERTY ASSOCIATES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "LRCM",
        "clearingBroker": "0279",
        "brokerName": "LOCKTON RE CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "LSAH",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "LSCM",
        "clearingBroker": "0235",
        "brokerName": "LAKE STREET CAPITAL MARKETS, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "LSCP",
        "clearingBroker": "8199",
        "brokerName": "LIFESCI CAPITAL, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "LSKO",
        "clearingBroker": "0226",
        "brokerName": "LESKO SECURITIES INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "LSPS",
        "clearingBroker": "8199",
        "brokerName": "LIGHTSPEED FINANCIAL SERVICES GROUP LLC                               "
    },
    {
        "type": "OTC",
        "mpid": "LSSI",
        "clearingBroker": "0750",
        "brokerName": "EJ STERLING INC.                                                      "
    },
    {
        "type": "OTC",
        "mpid": "LSUS",
        "clearingBroker": "0443",
        "brokerName": "LATIN SECURITIES INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "LTAA",
        "clearingBroker": "0226",
        "brokerName": "LUMINEX TRADING & ANALYTICS LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "LTCO",
        "clearingBroker": "0226",
        "brokerName": "LADENBURG, THALMANN & CO., INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "LTCS",
        "clearingBroker": "0141",
        "brokerName": "LINDEN THOMAS AND COMPANY SECURITIES, LLC                             "
    },
    {
        "type": "OTC",
        "mpid": "LVAR",
        "clearingBroker": "0443",
        "brokerName": "LARRAINVIAL SECURITIES US LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "LVMR",
        "clearingBroker": "0235",
        "brokerName": "LIVERMORE TRADING GROUP, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "MACC",
        "clearingBroker": "0226",
        "brokerName": "NEWEDGE SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "MACQ",
        "clearingBroker": "0114",
        "brokerName": "MACQUARIE CAPITAL (USA) INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "MADV",
        "clearingBroker": "0443",
        "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MATD",
        "clearingBroker": "3856",
        "brokerName": "MM GLOBAL SECURITIES, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "MATI",
        "clearingBroker": "9132",
        "brokerName": "MATRIX EXECUTIONS, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "MAVB",
        "clearingBroker": "0103",
        "brokerName": "GREAT POINT CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "MAXC",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "MAXM",
        "clearingBroker": "0443",
        "brokerName": "MAXIM GROUP LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "MAXN",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "MBSE",
        "clearingBroker": "0052",
        "brokerName": "MBS SOURCE ETRADING, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "MBTS",
        "clearingBroker": "0158",
        "brokerName": "MB TRADING                                                            "
    },
    {
        "type": "OTC",
        "mpid": "MBUS",
        "clearingBroker": "0052",
        "brokerName": "MEDIOBANCA SECURITIES USA LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "MCAP",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "OTC",
        "mpid": "MCBT",
        "clearingBroker": "0235",
        "brokerName": "MOORS & CABOT, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "MCMF",
        "clearingBroker": "5076",
        "brokerName": "RAYMOND JAMES LTD./CDS                                                "
    },
    {
        "type": "OTC",
        "mpid": "MCMG",
        "clearingBroker": "0279",
        "brokerName": "MUNICIPAL CAPITAL MARKETS GROUP, INC.                                 "
    },
    {
        "type": "OTC",
        "mpid": "MDBC",
        "clearingBroker": "0534",
        "brokerName": "MDB CAPITAL GROUP LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MDGP",
        "clearingBroker": "0235",
        "brokerName": "MD GLOBAL PARTNERS, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "MEAL",
        "clearingBroker": "0226",
        "brokerName": "M. E. ALLISON & CO., INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "MEMX",
        "clearingBroker": "0161",
        "brokerName": "MEMX EXECUTION SERVICES LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "MERP",
        "clearingBroker": "0235",
        "brokerName": "MERIDIAN EQUITY PARTNERS, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "MESF",
        "clearingBroker": "0443",
        "brokerName": "MESIROW FINANCIAL, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "MEXD",
        "clearingBroker": "0551",
        "brokerName": "DYNAMEX TRADING, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "MFGX",
        "clearingBroker": "0443",
        "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "MGIS",
        "clearingBroker": "5008",
        "brokerName": "INDUSTRIAL ALLIANCE SECURITIES INC.                                   "
    },
    {
        "type": "OTC",
        "mpid": "MGPC",
        "clearingBroker": "0534",
        "brokerName": "MADISON GLOBAL PARTNERS LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "MGTX",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "MHFI",
        "clearingBroker": "0226",
        "brokerName": "M HOLDINGS SECURITIES, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "MIAM",
        "clearingBroker": "0141",
        "brokerName": "FMSBONDS, INC.                                                        "
    },
    {
        "type": "OTC",
        "mpid": "MIDL",
        "clearingBroker": "0226",
        "brokerName": "MIDDLEGATE SECURITIES LTD.                                            "
    },
    {
        "type": "OTC",
        "mpid": "MILE",
        "clearingBroker": "0052",
        "brokerName": "I-BANKERS SECURITIES INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "MINP",
        "clearingBroker": "0235",
        "brokerName": "MINISTRY PARTNERS SECURITIES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "MINT",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "MINV",
        "clearingBroker": "0235",
        "brokerName": "MACK INVESTMENTS SECURITIES, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "MIRA",
        "clearingBroker": "1043",
        "brokerName": "MIRAE ASSET SECURITIES (USA) INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "MISL",
        "clearingBroker": "0161",
        "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "MITR",
        "clearingBroker": "0443",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MJWH",
        "clearingBroker": "0235",
        "brokerName": "ETICO PARTNERS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "MKRT",
        "clearingBroker": "0235",
        "brokerName": "MARKET SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "MKTI",
        "clearingBroker": "0226",
        "brokerName": "U.S. BANCORP ADVISORS, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "MKTX",
        "clearingBroker": "4265",
        "brokerName": "MARKETAXESS CORPORATION                                               "
    },
    {
        "type": "OTC",
        "mpid": "MKTY",
        "clearingBroker": "4265",
        "brokerName": "MARKETAXESS CORPORATION                                               "
    },
    {
        "type": "OTC",
        "mpid": "MLBC",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLCA",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLCB",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLCC",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLCD",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLCG",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLCO",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLCP",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLCQ",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLCS",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLCX",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLEL",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLEX",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLIX",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLMA",
        "clearingBroker": "0671",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLPK",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLPL",
        "clearingBroker": "0075",
        "brokerName": "MUTUAL SERVICE CORPORATION                                            "
    },
    {
        "type": "OTC",
        "mpid": "MLRM",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLRO",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLSE",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLSK",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLSL",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLTA",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTB",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTC",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTE",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLTF",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTG",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTH",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTI",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLTJ",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTK",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLTL",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTO",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTP",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTQ",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTR",
        "clearingBroker": "0158",
        "brokerName": "MONEYLION SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "MLTT",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTU",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTW",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTX",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTY",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLUA",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLUB",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLUC",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLUD",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLVX",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLWM",
        "clearingBroker": "0671",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLZB",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZC",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZD",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZE",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZF",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZI",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZJ",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZL",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZM",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZN",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZO",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZP",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZQ",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZR",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZS",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZT",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZU",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZV",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZW",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MMNT",
        "clearingBroker": "0158",
        "brokerName": "MOMENT MARKETS, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "MNCO",
        "clearingBroker": "0279",
        "brokerName": "NELSON (MARTIN) & CO., INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "MNDC",
        "clearingBroker": "4305",
        "brokerName": "MONDEUM CAPITAL, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "MNDX",
        "clearingBroker": "9132",
        "brokerName": "TJM INVESTMENTS, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "MOCM",
        "clearingBroker": "0235",
        "brokerName": "MORETON CAPITAL MARKETS, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "MOFI",
        "clearingBroker": "0158",
        "brokerName": "M1 FINANCE LLC                                                        "
    },
    {
        "type": "OTC",
        "mpid": "MOFO",
        "clearingBroker": "1497",
        "brokerName": "M1 FINANCE LLC                                                        "
    },
    {
        "type": "OTC",
        "mpid": "MOLO",
        "clearingBroker": "0235",
        "brokerName": "MOLONEY SECURITIES                                                    "
    },
    {
        "type": "OTC",
        "mpid": "MONR",
        "clearingBroker": "0226",
        "brokerName": "MONROE FINANCIAL PARTNERS, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "MOON",
        "clearingBroker": "0158",
        "brokerName": "OTC LINK LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "MORE",
        "clearingBroker": "0361",
        "brokerName": "MITCHELL SECURITIES CORPORATION OF OREGON                             "
    },
    {
        "type": "OTC",
        "mpid": "MPLA",
        "clearingBroker": "0158",
        "brokerName": "EMPALA SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "MPLW",
        "clearingBroker": "0226",
        "brokerName": "MAPLEWOOD INVESTMENT ADVISORS, INC.                                   "
    },
    {
        "type": "OTC",
        "mpid": "MPSG",
        "clearingBroker": "0161",
        "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "MRAD",
        "clearingBroker": "0052",
        "brokerName": "MACRO RISK ADVISORS LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "MRBA",
        "clearingBroker": "0052",
        "brokerName": "IBN FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "MRCY",
        "clearingBroker": "0520",
        "brokerName": "NASDAQ EXECUTION SERVICES, LLC/OPTIONS                                "
    },
    {
        "type": "OTC",
        "mpid": "MREC",
        "clearingBroker": "5029",
        "brokerName": "MACKIE RESERCH CAPITAL CORPORATION/CDS                                "
    },
    {
        "type": "OTC",
        "mpid": "MRNA",
        "clearingBroker": "0161",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MRSC",
        "clearingBroker": "0287",
        "brokerName": "TRADEUP SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSBT",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "MSCB",
        "clearingBroker": "0279",
        "brokerName": "MAINE SECURITIES CORPORATION                                          "
    },
    {
        "type": "OTC",
        "mpid": "MSCO",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSEC",
        "clearingBroker": "0235",
        "brokerName": "MSEC, LLC                                                             "
    },
    {
        "type": "OTC",
        "mpid": "MSED",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSEM",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSET",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSFP",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSLC",
        "clearingBroker": "0534",
        "brokerName": "MCDONNAUGH SECURITIES LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "MSML",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSMP",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSNY",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSPL",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSPW",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "MSRO",
        "clearingBroker": "0226",
        "brokerName": "MESIROW FINANCIAL, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "MSRP",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSTC",
        "clearingBroker": "0226",
        "brokerName": "MIDWESTERN SECURITIES TRADING COMPANY, LLC                            "
    },
    {
        "type": "OTC",
        "mpid": "MSTI",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSTW",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSTX",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MTDB",
        "clearingBroker": "0443",
        "brokerName": "M&T SECURITIES, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "MTGO",
        "clearingBroker": "0158",
        "brokerName": "MTG, LLC                                                              "
    },
    {
        "type": "OTC",
        "mpid": "MTHN",
        "clearingBroker": "0005",
        "brokerName": "MARATHON TRADING GROUP LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "MTLE",
        "clearingBroker": "0235",
        "brokerName": "MTL EQUITY PRODUCTS, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "MTSL",
        "clearingBroker": "0226",
        "brokerName": "MSEC, LLC                                                             "
    },
    {
        "type": "OTC",
        "mpid": "MUFG",
        "clearingBroker": "0076",
        "brokerName": "MUFG SECURITIES AMERICAS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "MULA",
        "clearingBroker": "0534",
        "brokerName": "MUNDIAL FINANCIAL GROUP, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "MULL",
        "clearingBroker": "8199",
        "brokerName": "MARK J. MULLER EQUITIES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "MURJ",
        "clearingBroker": "0750",
        "brokerName": "COMMERCE ONE FINANCIAL INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "MVMP",
        "clearingBroker": "0534",
        "brokerName": "MICROVENTURE MARKETPLACE INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "MWCC",
        "clearingBroker": "0235",
        "brokerName": "MONNESS CRESPI HARDT & CO., INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "MWIL",
        "clearingBroker": "0235",
        "brokerName": "MORGAN WILSHIRE SECURITIES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "MYSS",
        "clearingBroker": "0158",
        "brokerName": "M.Y. SAFRA SECURITIES, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "MZHO",
        "clearingBroker": "0892",
        "brokerName": "MIZUHO SECURITIES USA LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "NACM",
        "clearingBroker": "0161",
        "brokerName": "NABSECURITIES, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "NADL",
        "clearingBroker": "0235",
        "brokerName": "WARREN D. NADEL & COMPANY                                             "
    },
    {
        "type": "OTC",
        "mpid": "NAPK",
        "clearingBroker": "0052",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "OTC",
        "mpid": "NASC",
        "clearingBroker": "0235",
        "brokerName": "NATALLIANCE SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "NASJ",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET MARKETS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "NATI",
        "clearingBroker": "4305",
        "brokerName": "NATISA SECURITIES LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "NAVC",
        "clearingBroker": "0235",
        "brokerName": "NAVIAN CAPITAL SECURITIES LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "NBAR",
        "clearingBroker": "0226",
        "brokerName": "NANCY BARRON & ASSOCIATES, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "NBCS",
        "clearingBroker": "0235",
        "brokerName": "NBC SECURITIES, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "NBFI",
        "clearingBroker": "5008",
        "brokerName": "NBF SECURITIES (USA) CORP.                                            "
    },
    {
        "type": "OTC",
        "mpid": "NBKT",
        "clearingBroker": "8353",
        "brokerName": "NATIONAL BANK OF CANADA FINANCIAL INC.                                "
    },
    {
        "type": "OTC",
        "mpid": "NBLB",
        "clearingBroker": "0226",
        "brokerName": "NEUBERGER BERMAN BD LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "NBSL",
        "clearingBroker": "0226",
        "brokerName": "BMO NESBITT BURNS SECURITIES LTD.                                     "
    },
    {
        "type": "OTC",
        "mpid": "NEED",
        "clearingBroker": "0443",
        "brokerName": "NEEDHAM & COMPANY, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "NEFO",
        "clearingBroker": "0608",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "NENB",
        "clearingBroker": "0608",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "NEST",
        "clearingBroker": "0235",
        "brokerName": "NEST INVESTMENTS BD LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "NEUS",
        "clearingBroker": "0750",
        "brokerName": "NINTH ETERNITY SECURITIES LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "NFBS",
        "clearingBroker": "2402",
        "brokerName": "NAVY FEDERAL INVESTMENT SERVICES, LLC                                 "
    },
    {
        "type": "OTC",
        "mpid": "NFGR",
        "clearingBroker": "0141",
        "brokerName": "NATIONS FINANCIAL GROUP, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "NFSC",
        "clearingBroker": "0226",
        "brokerName": "NATIONAL FINANCIAL SERVICES LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "NFTY",
        "clearingBroker": "0235",
        "brokerName": "INFINITY FINANCIAL SERVICES                                           "
    },
    {
        "type": "OTC",
        "mpid": "NHFS",
        "clearingBroker": "0158",
        "brokerName": "ALIGHT FINANCIAL SOLUTIONS, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "NHWI",
        "clearingBroker": "0141",
        "brokerName": "HENNION & WALSH, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "NIAD",
        "clearingBroker": "0052",
        "brokerName": "NI ADVISORS                                                           "
    },
    {
        "type": "OTC",
        "mpid": "NICK",
        "clearingBroker": "0161",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "NITC",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "NITD",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "NITE",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "NITP",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "NITX",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "NLOV",
        "clearingBroker": "0534",
        "brokerName": "NORTLOV SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "NMRA",
        "clearingBroker": "0180",
        "brokerName": "NOMURA SECURITIES INTERNATIONAL, INC./FIXED INCOME                    "
    },
    {
        "type": "OTC",
        "mpid": "NMRB",
        "clearingBroker": "0180",
        "brokerName": "NOMURA SECURITIES INTERNATIONAL, INC                                  "
    },
    {
        "type": "OTC",
        "mpid": "NOBL",
        "clearingBroker": "0750",
        "brokerName": "NOBLE FINANCIAL CAPITAL MARKETS                                       "
    },
    {
        "type": "OTC",
        "mpid": "NORC",
        "clearingBroker": "0235",
        "brokerName": "NORTHERN CAPITAL SEC. CORP.                                           "
    },
    {
        "type": "OTC",
        "mpid": "NORT",
        "clearingBroker": "0443",
        "brokerName": "NORTHLAND SECURITIES, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "NORW",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO BROKERAGE SERVICES, LLC                                   "
    },
    {
        "type": "OTC",
        "mpid": "NOSO",
        "clearingBroker": "0443",
        "brokerName": "NORTH SOUTH CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "NPNT",
        "clearingBroker": "0005",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "NPTP",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "NQBX",
        "clearingBroker": "0163",
        "brokerName": "NASDAQ BX, INC.                                                       "
    },
    {
        "type": "OTC",
        "mpid": "NQOP",
        "clearingBroker": "0520",
        "brokerName": "NASDAQ EXECUTION SERVICES, LLC/OPTIONS                                "
    },
    {
        "type": "OTC",
        "mpid": "NQPX",
        "clearingBroker": "0237",
        "brokerName": "NASDAQ PHLX LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "NQRB",
        "clearingBroker": "0568",
        "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "NSDQ",
        "clearingBroker": "0759",
        "brokerName": "NASDAQ STOCK MARKET LLC/OMNIBUS ACCOUNT                               "
    },
    {
        "type": "OTC",
        "mpid": "NSFP",
        "clearingBroker": "0235",
        "brokerName": "NORTHSTAR FINANCIAL PARTNERS, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "NSIF",
        "clearingBroker": "5061",
        "brokerName": "TD WATERHOUSE - NORSTAR SECURITIES/CDS                                "
    },
    {
        "type": "OTC",
        "mpid": "NSRD",
        "clearingBroker": "0235",
        "brokerName": "NESTLERODE & CO., INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "NTBF",
        "clearingBroker": "5043",
        "brokerName": "BMO NESBITT BURNS INC./CDS                                            "
    },
    {
        "type": "OTC",
        "mpid": "NTFN",
        "clearingBroker": "0052",
        "brokerName": "NETWORK 1 FINANCIAL SECURITIES INC.                                   "
    },
    {
        "type": "OTC",
        "mpid": "NTRC",
        "clearingBroker": "0226",
        "brokerName": "NORTHERN TRUST SECURITIES, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "NVEN",
        "clearingBroker": "0448",
        "brokerName": "NUVEEN SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "NVGT",
        "clearingBroker": "0388",
        "brokerName": "NAVIGATE ADVISORS LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "NVSR",
        "clearingBroker": "0158",
        "brokerName": "NVSTR FINANCIAL LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "NWCM",
        "clearingBroker": "0235",
        "brokerName": "NW CAPITAL MARKETS INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "NWIA",
        "clearingBroker": "0750",
        "brokerName": "NORTHWEST INVESTMENT ADVISORS, INC.                                   "
    },
    {
        "type": "OTC",
        "mpid": "NYFX",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "NYLS",
        "clearingBroker": "0226",
        "brokerName": "NYLIFE SECURITIES INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "OAIF",
        "clearingBroker": "0158",
        "brokerName": "OPTIONS AI FINANCIAL, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "OAKR",
        "clearingBroker": "0235",
        "brokerName": "THE OAK RIDGE FINANCIAL SERVICES GROUP, INC.                          "
    },
    {
        "type": "OTC",
        "mpid": "OBEX",
        "clearingBroker": "0534",
        "brokerName": "OBEX SECURITIES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "OBWS",
        "clearingBroker": "0226",
        "brokerName": "OBERWEIS SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "OCAC",
        "clearingBroker": "0235",
        "brokerName": "OLSON, CROSS & ALAMO LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "OCEA",
        "clearingBroker": "0052",
        "brokerName": "OCEAN FINANCIAL SERVICES, LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "OCEE",
        "clearingBroker": "4305",
        "brokerName": "OCEANUS SECURITIES, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "OCEN",
        "clearingBroker": "0568",
        "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "OCTG",
        "clearingBroker": "0295",
        "brokerName": "OCTEG, LLC                                                            "
    },
    {
        "type": "OTC",
        "mpid": "ODNC",
        "clearingBroker": "0235",
        "brokerName": "ODEON CAPITAL GROUP LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "OFGF",
        "clearingBroker": "0235",
        "brokerName": "OFG FINANCIAL SERVICES INC                                            "
    },
    {
        "type": "OTC",
        "mpid": "OFMC",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "OGRU",
        "clearingBroker": "0161",
        "brokerName": "OSCAR GRUSS & SON, INCORPORATED                                       "
    },
    {
        "type": "OTC",
        "mpid": "OGTL",
        "clearingBroker": "0005",
        "brokerName": "OUTSET GLOBAL TRADING LIMITED                                         "
    },
    {
        "type": "OTC",
        "mpid": "OHIO",
        "clearingBroker": "0443",
        "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "OHOS",
        "clearingBroker": "0551",
        "brokerName": "TWO SIGMA SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "OLDM",
        "clearingBroker": "0005",
        "brokerName": "OLD MISSION CAPITAL, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "OLMN",
        "clearingBroker": "0005",
        "brokerName": "OLD MISSION MARKETS LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "OLNE",
        "clearingBroker": "0279",
        "brokerName": "OLDEN LANE SECURITIES, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "OMMA",
        "clearingBroker": "0005",
        "brokerName": "OLD MISSION MARKETS LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "ONEC",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "ONEL",
        "clearingBroker": "0161",
        "brokerName": "O'NEIL (WILLIAM) & CO                                                 "
    },
    {
        "type": "OTC",
        "mpid": "OPAL",
        "clearingBroker": "8199",
        "brokerName": "OPAL SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "OPCO",
        "clearingBroker": "0571",
        "brokerName": "OPPENHEIMER & CO. INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "OPDL",
        "clearingBroker": "0158",
        "brokerName": "OPENDEAL BROKER LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "OPTE",
        "clearingBroker": "0695",
        "brokerName": "OPTIVER US LLC                                                        "
    },
    {
        "type": "OTC",
        "mpid": "OPTF",
        "clearingBroker": "0005",
        "brokerName": "OPTIVER US LLC                                                        "
    },
    {
        "type": "OTC",
        "mpid": "OPTG",
        "clearingBroker": "0005",
        "brokerName": "OPTIVER US, LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "OPTU",
        "clearingBroker": "0695",
        "brokerName": "OPTIVER US, LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "OPTY",
        "clearingBroker": "0158",
        "brokerName": "OPTIONALITY SECURITIES                                                "
    },
    {
        "type": "OTC",
        "mpid": "OSFI",
        "clearingBroker": "0534",
        "brokerName": "ONESOURCE FI LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "OSIC",
        "clearingBroker": "0226",
        "brokerName": "OSAIC INSTITUTIONS, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "OTAA",
        "clearingBroker": "0551",
        "brokerName": "OTA LIMITED PARTNERSHIP                                               "
    },
    {
        "type": "OTC",
        "mpid": "OTCN",
        "clearingBroker": "0158",
        "brokerName": "OTC LINK LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "OTCO",
        "clearingBroker": "0158",
        "brokerName": "OTC LINK LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "OTCX",
        "clearingBroker": "0158",
        "brokerName": "OTC LINK LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "OTSB",
        "clearingBroker": "0103",
        "brokerName": "OAK TREE SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "OYLD",
        "clearingBroker": "0235",
        "brokerName": "OPENYIELD TRADING LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "PACT",
        "clearingBroker": "0443",
        "brokerName": "BTG PACTUAL US CAPITAL LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "PAPP",
        "clearingBroker": "0534",
        "brokerName": "EUROPEAN FAMILY OFFICE INSTITUTE LLC.                                 "
    },
    {
        "type": "OTC",
        "mpid": "PARK",
        "clearingBroker": "0750",
        "brokerName": "PARK WALK CAPITAL MARKETS, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "PARX",
        "clearingBroker": "0695",
        "brokerName": "PARX TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "PASF",
        "clearingBroker": "2402",
        "brokerName": "PASSFOLIO SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "PASL",
        "clearingBroker": "0443",
        "brokerName": "PERSHING ADVISOR SOLUTIONS, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "PATR",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "PAUL",
        "clearingBroker": "0595",
        "brokerName": "PAULSON INVESTMENT COMPANY, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "PAVE",
        "clearingBroker": "0534",
        "brokerName": "PAVE SECURITIES, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "PBON",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "PCAP",
        "clearingBroker": "0608",
        "brokerName": "SG AMERICAS SECURITIES, LLC/SUB 608                                   "
    },
    {
        "type": "OTC",
        "mpid": "PCCA",
        "clearingBroker": "0279",
        "brokerName": "PEACHCAP SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "PCFF",
        "clearingBroker": "5075",
        "brokerName": "PI FINANCIAL CORP./CDS                                                "
    },
    {
        "type": "OTC",
        "mpid": "PCIS",
        "clearingBroker": "0226",
        "brokerName": "BANKOH INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "PCPT",
        "clearingBroker": "8460",
        "brokerName": "PHILLIP CAPITAL INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "PCSG",
        "clearingBroker": "0158",
        "brokerName": "PACIFIC CENTURY SECURITIES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "PCSS",
        "clearingBroker": "0294",
        "brokerName": "PACIFIC CENTURY SECURITIES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "PECA",
        "clearingBroker": "0388",
        "brokerName": "PERAZA CAPITAL AND INVESTMENT, LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "PERC",
        "clearingBroker": "0279",
        "brokerName": "PERCIVAL FINANCIAL PARTNERS, LTD.                                     "
    },
    {
        "type": "OTC",
        "mpid": "PERO",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "PERS",
        "clearingBroker": "0443",
        "brokerName": "PERSHING LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "PERX",
        "clearingBroker": "0443",
        "brokerName": "PERSHING LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "PFCG",
        "clearingBroker": "0279",
        "brokerName": "PREFERRED CLIENT GROUP, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "PFCL",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "PFCM",
        "clearingBroker": "0158",
        "brokerName": "PENSON FINANCIAL SERVICES, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "PFDC",
        "clearingBroker": "0235",
        "brokerName": "PREFERRED CAPITAL SECURITIES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "PFPI",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "PFRA",
        "clearingBroker": "0443",
        "brokerName": "PERSHING LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "PHBP",
        "clearingBroker": "0052",
        "brokerName": "PENNHAVEN BROKERAGE PARTNERS, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "PHLY",
        "clearingBroker": "0520",
        "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "PHRS",
        "clearingBroker": "0279",
        "brokerName": "NAVAID FINANCIAL SERVICES, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "PICF",
        "clearingBroker": "5027",
        "brokerName": "PICTET CANADA L.P./CDS                                                "
    },
    {
        "type": "OTC",
        "mpid": "PICI",
        "clearingBroker": "0279",
        "brokerName": "POLAR INVESTMENT COUNSEL, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "PICL",
        "clearingBroker": "0052",
        "brokerName": "PAULSON INVESTMENT COMPANY LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "PICT",
        "clearingBroker": "5027",
        "brokerName": "PICTET OVERSEAS, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "PIER",
        "clearingBroker": "3018",
        "brokerName": "GREEN PIER FINTECH LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "PINA",
        "clearingBroker": "0141",
        "brokerName": "PINNACLE INVESTMENTS, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "PIPR",
        "clearingBroker": "0443",
        "brokerName": "PIPER SANDLER & CO.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "PISC",
        "clearingBroker": "0750",
        "brokerName": "PACIFIC INVESTMENT SECURITIES CORP.                                   "
    },
    {
        "type": "OTC",
        "mpid": "PIUS",
        "clearingBroker": "5075",
        "brokerName": "PI FINANCIAL (US) CORP.                                               "
    },
    {
        "type": "OTC",
        "mpid": "PJCX",
        "clearingBroker": "0443",
        "brokerName": "PIPER SANDLER & CO.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "PJEF",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "PKAX",
        "clearingBroker": "0158",
        "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "PKCM",
        "clearingBroker": "0005",
        "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "PKSD",
        "clearingBroker": "8460",
        "brokerName": "PARKSIDE SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "PLAT",
        "clearingBroker": "0443",
        "brokerName": "CLARKSONS PLATOU SECURITIES, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "PLHT",
        "clearingBroker": "0750",
        "brokerName": "PEEL HUNT INC.                                                        "
    },
    {
        "type": "OTC",
        "mpid": "PLTF",
        "clearingBroker": "0534",
        "brokerName": "PLACE TRADE FINANCIAL, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "PNCC",
        "clearingBroker": "0226",
        "brokerName": "PNC INVESTMENTS                                                       "
    },
    {
        "type": "OTC",
        "mpid": "PNCS",
        "clearingBroker": "3856",
        "brokerName": "PRIME NUMBER CAPITAL, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "PNFP",
        "clearingBroker": "0279",
        "brokerName": "PNFP CAPITAL MARKETS, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "PNSA",
        "clearingBroker": "0235",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "PNSR",
        "clearingBroker": "0161",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "PODE",
        "clearingBroker": "0235",
        "brokerName": "PODESTA & CO.                                                         "
    },
    {
        "type": "OTC",
        "mpid": "POPS",
        "clearingBroker": "0226",
        "brokerName": "POPULAR SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "PPNY",
        "clearingBroker": "3450",
        "brokerName": "PRIME NUMBER CAPITAL LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "PPPP",
        "clearingBroker": "0122",
        "brokerName": "PPPP CLEARING 0122 TEST                                               "
    },
    {
        "type": "OTC",
        "mpid": "PPSI",
        "clearingBroker": "0235",
        "brokerName": "PENSION PLANNERS SECURITIES, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "PPSL",
        "clearingBroker": "0443",
        "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "PRAG",
        "clearingBroker": "0067",
        "brokerName": "PRAGMA LLC                                                            "
    },
    {
        "type": "OTC",
        "mpid": "PRDG",
        "clearingBroker": "0551",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "PREB",
        "clearingBroker": "0005",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "PRFA",
        "clearingBroker": "0235",
        "brokerName": "PROOF SERVICES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "PRFT",
        "clearingBroker": "0158",
        "brokerName": "PROOF SERVICES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "PRJX",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "PRST",
        "clearingBroker": "0551",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "PRXX",
        "clearingBroker": "2793",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "PSFL",
        "clearingBroker": "0534",
        "brokerName": "PUENTE SERVICIOS FINANCIEROS LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "PSII",
        "clearingBroker": "0226",
        "brokerName": "KESTRA INVESTMENT SERVICES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "PSIM",
        "clearingBroker": "0226",
        "brokerName": "PRINCIPAL SECURITIES, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "PSRI",
        "clearingBroker": "0103",
        "brokerName": "GLOBALINK SECURITIES, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "PSUT",
        "clearingBroker": "0235",
        "brokerName": "INNOVATION PARTNERS LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "PTFI",
        "clearingBroker": "0221",
        "brokerName": "UBS FINANCIAL SERVICES INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "PTIS",
        "clearingBroker": "0235",
        "brokerName": "PTI SECURITIES & FUTURES L.P.                                         "
    },
    {
        "type": "OTC",
        "mpid": "PTIX",
        "clearingBroker": "0534",
        "brokerName": "PTI SECURITIES & FUTURES L.P.                                         "
    },
    {
        "type": "OTC",
        "mpid": "PTLV",
        "clearingBroker": "8353",
        "brokerName": "NATIONAL BANK OF CANADA FINANCIAL INC.                                "
    },
    {
        "type": "OTC",
        "mpid": "PTSB",
        "clearingBroker": "0534",
        "brokerName": "PTS BROKERAGE, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "PUBV",
        "clearingBroker": "3341",
        "brokerName": "MDB CAPITAL                                                           "
    },
    {
        "type": "OTC",
        "mpid": "PULX",
        "clearingBroker": "0067",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "PUMA",
        "clearingBroker": "8199",
        "brokerName": "PUMA CAPITAL, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "PUMX",
        "clearingBroker": "8199",
        "brokerName": "PUMA CAPITAL, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "PUND",
        "clearingBroker": "0551",
        "brokerName": "PUNDION LLC                                                           "
    },
    {
        "type": "OTC",
        "mpid": "PUPL",
        "clearingBroker": "0226",
        "brokerName": "PUPLAVA SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "PURE",
        "clearingBroker": "0067",
        "brokerName": "PURESTREAM, LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "PURP",
        "clearingBroker": "0279",
        "brokerName": "LIBERTY CAPITAL INVESTMENT CORPORATION                                "
    },
    {
        "type": "OTC",
        "mpid": "PWCP",
        "clearingBroker": "0534",
        "brokerName": "PICKWICK CAPITAL PARTNERS, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "PWJC",
        "clearingBroker": "0221",
        "brokerName": "UBS FINANCIAL SERVICES INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "PWJX",
        "clearingBroker": "0221",
        "brokerName": "UBS FINANCIAL SERVICES INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "PXCJ",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "PXGA",
        "clearingBroker": "0551",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "PXGG",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING                                                          "
    },
    {
        "type": "OTC",
        "mpid": "PXGJ",
        "clearingBroker": "0352",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "QAMM",
        "clearingBroker": "0294",
        "brokerName": "QUANTEX CLEARING, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "QBND",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "OTC",
        "mpid": "QBSI",
        "clearingBroker": "0226",
        "brokerName": "GLEN EAGLE WEALTH, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "QCAP",
        "clearingBroker": "0235",
        "brokerName": "QUINT CAPITAL CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "QCAS",
        "clearingBroker": "0226",
        "brokerName": "QUINCY CASS ASSOCIATES, INCORPORATED                                  "
    },
    {
        "type": "OTC",
        "mpid": "QGSB",
        "clearingBroker": "0158",
        "brokerName": "QUAESTOR GLOBAL SECURITIES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "QLBR",
        "clearingBroker": "0695",
        "brokerName": "QUANTLAB BROKERAGE, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "QMSR",
        "clearingBroker": "0235",
        "brokerName": "QUATTRO M SECURITIES INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "QMSX",
        "clearingBroker": "0294",
        "brokerName": "QUATTRO M SECURITIES INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "QNTX",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "QRQR",
        "clearingBroker": "0534",
        "brokerName": "QUANTRIVER FINANCIAL, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "QUES",
        "clearingBroker": "5084",
        "brokerName": "QUESTRADE INC./CDS                                                    "
    },
    {
        "type": "OTC",
        "mpid": "QUOI",
        "clearingBroker": "0279",
        "brokerName": "QUOIN CAPITAL LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "QWIK",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "OTC",
        "mpid": "RAAA",
        "clearingBroker": "0052",
        "brokerName": "RICHARD JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "RAAI",
        "clearingBroker": "0226",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "RABO",
        "clearingBroker": "0443",
        "brokerName": "RABO SECURITIES USA, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "RACO",
        "clearingBroker": "0158",
        "brokerName": "SHEARMAN, RALSTON, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "RAJA",
        "clearingBroker": "0725",
        "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "RAYG",
        "clearingBroker": "0443",
        "brokerName": "BOLTON GLOBAL CAPITAL                                                 "
    },
    {
        "type": "OTC",
        "mpid": "RBAC",
        "clearingBroker": "0235",
        "brokerName": "ROBERT B. AUSDAL & CO. INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "RBCD",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "OTC",
        "mpid": "RBCF",
        "clearingBroker": "5002",
        "brokerName": "RBC DOMINION SECURITIES INC./CDS                                      "
    },
    {
        "type": "OTC",
        "mpid": "RBCM",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "OTC",
        "mpid": "RBCX",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "OTC",
        "mpid": "RBDG",
        "clearingBroker": "0158",
        "brokerName": "REDBRIDGE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "RCKF",
        "clearingBroker": "0534",
        "brokerName": "ROCKFLEET FINANCIAL SERVICES, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "RCMA",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS ARBITRAGE, S.A.                                   "
    },
    {
        "type": "OTC",
        "mpid": "RCMI",
        "clearingBroker": "0608",
        "brokerName": "DEALERWEB INC.                                                        "
    },
    {
        "type": "OTC",
        "mpid": "RDBN",
        "clearingBroker": "0443",
        "brokerName": "REDBURN PARTNERS (USA) LP                                             "
    },
    {
        "type": "OTC",
        "mpid": "RECA",
        "clearingBroker": "5029",
        "brokerName": "RESEARCH CAPITAL USA INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "REGN",
        "clearingBroker": "0443",
        "brokerName": "REGIONS SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "REGR",
        "clearingBroker": "0141",
        "brokerName": "REGISTER & AKERS INVESTMENTS, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "REPP",
        "clearingBroker": "0226",
        "brokerName": "G. A. REPPLE & COMPANY                                                "
    },
    {
        "type": "OTC",
        "mpid": "REVE",
        "clearingBroker": "3450",
        "brokerName": "REVERE SECURITIES CORP.                                               "
    },
    {
        "type": "OTC",
        "mpid": "REVO",
        "clearingBroker": "2402",
        "brokerName": "REVOLUT SECURITIES INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "RFRC",
        "clearingBroker": "0279",
        "brokerName": "THE ROCKWELL FINANCIAL GROUP, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "RGLD",
        "clearingBroker": "0279",
        "brokerName": "REGAL SECURITIES, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "RGLS",
        "clearingBroker": "0235",
        "brokerName": "REGAL SECURITIES, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "RHCO",
        "clearingBroker": "0226",
        "brokerName": "TRUIST SECURITIES, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "RHDS",
        "clearingBroker": "0141",
        "brokerName": "RHODES SECURITIES, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "RHOX",
        "clearingBroker": "0005",
        "brokerName": "XR SECURITIES LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "RIAN",
        "clearingBroker": "0226",
        "brokerName": "OSAIC SERVICES, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "RICD",
        "clearingBroker": "4305",
        "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
    },
    {
        "type": "OTC",
        "mpid": "RICJ",
        "clearingBroker": "0235",
        "brokerName": "RICE SECURITIES, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "RICM",
        "clearingBroker": "0595",
        "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
    },
    {
        "type": "OTC",
        "mpid": "RIED",
        "clearingBroker": "0235",
        "brokerName": "RIEDL, FIRST SECURITIES COMPANY OF KANSAS                             "
    },
    {
        "type": "OTC",
        "mpid": "RILY",
        "clearingBroker": "0226",
        "brokerName": "B. RILEY FBR, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "RJFI",
        "clearingBroker": "0390",
        "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "RKWS",
        "clearingBroker": "0235",
        "brokerName": "ROCKWELL SECURITIES LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "RLIN",
        "clearingBroker": "0005",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "RMAC",
        "clearingBroker": "0235",
        "brokerName": "RENAISSANCE MACRO SECURITIES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "RMPI",
        "clearingBroker": "0141",
        "brokerName": "RICHARDS, MERRILL & PETERSON, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "RNYB",
        "clearingBroker": "3350",
        "brokerName": "ROYAL BANK OF CANADA, WFC BRANCH                                      "
    },
    {
        "type": "OTC",
        "mpid": "ROBT",
        "clearingBroker": "0443",
        "brokerName": "ROBOTTI & COMPANY, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "ROCK",
        "clearingBroker": "0226",
        "brokerName": "ROCKEFELLER FINANCIAL LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "ROCM",
        "clearingBroker": "0443",
        "brokerName": "RIM SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "RODM",
        "clearingBroker": "1043",
        "brokerName": "RODMAN & RENSHAW, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "ROMO",
        "clearingBroker": "0141",
        "brokerName": "ROMANO BROTHERS AND COMPANY                                           "
    },
    {
        "type": "OTC",
        "mpid": "RONI",
        "clearingBroker": "0005",
        "brokerName": "RONIN CAPITAL, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "ROSN",
        "clearingBroker": "0443",
        "brokerName": "ROSENBLATT SECURITIES INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "ROTB",
        "clearingBroker": "0235",
        "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "ROTH",
        "clearingBroker": "0161",
        "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "RPTR",
        "clearingBroker": "0235",
        "brokerName": "DINOSAUR SECURITIES, L.L.C.                                           "
    },
    {
        "type": "OTC",
        "mpid": "RQDR",
        "clearingBroker": "0235",
        "brokerName": "RQD* CLEARING LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "RREZ",
        "clearingBroker": "0443",
        "brokerName": "SAMUEL A RAMIREZ & CO., INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "RRUD",
        "clearingBroker": "0235",
        "brokerName": "REID & RUDIGER, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "RSCM",
        "clearingBroker": "0235",
        "brokerName": "ROBERTSON STEPHENS CAPITAL MARKETS, LLC                               "
    },
    {
        "type": "OTC",
        "mpid": "RSKY",
        "clearingBroker": "0695",
        "brokerName": "ITG DERIVATIVES, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "RSSE",
        "clearingBroker": "0443",
        "brokerName": "RUSSELL IMPLEMENTATION SERVICES INC. PART OF RUSSE                    "
    },
    {
        "type": "OTC",
        "mpid": "RTHS",
        "clearingBroker": "0443",
        "brokerName": "ROTHSCHILD INVESTMENT CORPORATION                                     "
    },
    {
        "type": "OTC",
        "mpid": "RWPS",
        "clearingBroker": "0443",
        "brokerName": "R.W. PRESSPRICH & CO.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "RWSM",
        "clearingBroker": "0279",
        "brokerName": "R.W. SMITH & ASSOCIATES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "RYDS",
        "clearingBroker": "0235",
        "brokerName": "RBC DOMINION SECURITIES CORPORATION                                   "
    },
    {
        "type": "OTC",
        "mpid": "SAFS",
        "clearingBroker": "0750",
        "brokerName": "STERNE AGEE FINANCIAL SERVICES, INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "SAFX",
        "clearingBroker": "0235",
        "brokerName": "SAF FINANCIAL SECURITIES LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "SAGE",
        "clearingBroker": "0141",
        "brokerName": "SAGE, RUTTY & CO., INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "SAGL",
        "clearingBroker": "9132",
        "brokerName": "SAGETRADER LLC                                                        "
    },
    {
        "type": "OTC",
        "mpid": "SAGP",
        "clearingBroker": "8199",
        "brokerName": "SAGETRADER, LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "SAGR",
        "clearingBroker": "4305",
        "brokerName": "SAGETRADER, LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "SAGT",
        "clearingBroker": "3856",
        "brokerName": "SAGETRADER, LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "SAKL",
        "clearingBroker": "0279",
        "brokerName": "DMK ADVISORS GROUP, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "SALI",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "SALL",
        "clearingBroker": "0534",
        "brokerName": "SUPREME ALLIANCE LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "SAMI",
        "clearingBroker": "0226",
        "brokerName": "SAMI BROKERAGE LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "SANC",
        "clearingBroker": "3499",
        "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "SANT",
        "clearingBroker": "0443",
        "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "SARG",
        "clearingBroker": "0226",
        "brokerName": "PURSHE KAPLAN STERLING INVESTMENTS, INC.                              "
    },
    {
        "type": "OTC",
        "mpid": "SBER",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "SBLS",
        "clearingBroker": "0235",
        "brokerName": "SAN BLAS SECURITIES LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "SBLT",
        "clearingBroker": "0226",
        "brokerName": "SUNBELT SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "SBRO",
        "clearingBroker": "0443",
        "brokerName": "STERN BROTHERS & CO.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "SBRT",
        "clearingBroker": "0226",
        "brokerName": "SIEBERT(MURIEL) & CO.,INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "SBRX",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "SBSC",
        "clearingBroker": "0226",
        "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
    },
    {
        "type": "OTC",
        "mpid": "SBSH",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "SBSI",
        "clearingBroker": "0103",
        "brokerName": "SUN'S BROTHERS SECURITIES INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "SBSL",
        "clearingBroker": "1043",
        "brokerName": "STOCKBLOCK SECURITIES LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "SCAP",
        "clearingBroker": "0595",
        "brokerName": "STRONG CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "SCBO",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "SCBT",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "SCIL",
        "clearingBroker": "0052",
        "brokerName": "STRATEGIC CAPITAL INVESTMENTS, LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "SCMC",
        "clearingBroker": "0096",
        "brokerName": "SCOTIA CAPITAL MARKETS (USA) INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "SCMF",
        "clearingBroker": "5011",
        "brokerName": "SCOTIA CAPITAL INC./CDS                                               "
    },
    {
        "type": "OTC",
        "mpid": "SCSI",
        "clearingBroker": "0370",
        "brokerName": "STANDARD CREDIT SECURITIES INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "SCSS",
        "clearingBroker": "0750",
        "brokerName": "STONECASTLE SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "SDIC",
        "clearingBroker": "0235",
        "brokerName": "SAUER DAZEY INVESTMENT CO.                                            "
    },
    {
        "type": "OTC",
        "mpid": "SEAP",
        "clearingBroker": "0226",
        "brokerName": "SEAPORT SECURITIES CORP.                                              "
    },
    {
        "type": "OTC",
        "mpid": "SEBR",
        "clearingBroker": "0158",
        "brokerName": "SENTINEL BROKERS COMPANY, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "SEEL",
        "clearingBroker": "0443",
        "brokerName": "R. SEELAUS & CO., INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "SEFB",
        "clearingBroker": "0052",
        "brokerName": "SOUTHEAST INVESTMENTS, N.C., INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "SEIB",
        "clearingBroker": "0158",
        "brokerName": "SEIBERT (J.D.) & COMPANY INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "SEIC",
        "clearingBroker": "0295",
        "brokerName": "SEI INVESTMENTS DISTRIBUTION CO.                                      "
    },
    {
        "type": "OTC",
        "mpid": "SEID",
        "clearingBroker": "0388",
        "brokerName": "SEIDEL & SHAW LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "SEIF",
        "clearingBroker": "0696",
        "brokerName": "SEI INVESTMENTS DISTRIBUTION CO.                                      "
    },
    {
        "type": "OTC",
        "mpid": "SEMT",
        "clearingBroker": "7311",
        "brokerName": "MINT BROKERS                                                          "
    },
    {
        "type": "OTC",
        "mpid": "SERL",
        "clearingBroker": "0443",
        "brokerName": "SEARLE & CO.                                                          "
    },
    {
        "type": "OTC",
        "mpid": "SETX",
        "clearingBroker": "0695",
        "brokerName": "ABN AMRO CLEARING USA LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "SFGB",
        "clearingBroker": "0161",
        "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLP                                      "
    },
    {
        "type": "OTC",
        "mpid": "SFSI",
        "clearingBroker": "0235",
        "brokerName": "SUPERIOR FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "SGAL",
        "clearingBroker": "0534",
        "brokerName": "S. GOLDMAN ADVISORS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "SGAS",
        "clearingBroker": "0286",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "SGBI",
        "clearingBroker": "0226",
        "brokerName": "SMITH, BROWN & GROOVER, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "SGFC",
        "clearingBroker": "0226",
        "brokerName": "SIGMA FINANCIAL CORPORATION                                           "
    },
    {
        "type": "OTC",
        "mpid": "SGLC",
        "clearingBroker": "0235",
        "brokerName": "S.G. LONG & COMPANY                                                   "
    },
    {
        "type": "OTC",
        "mpid": "SGMA",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS EXECUTION & CLEARING, L.P.                              "
    },
    {
        "type": "OTC",
        "mpid": "SGMT",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "SGNL",
        "clearingBroker": "0279",
        "brokerName": "SIGNAL SECURITIES, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "SGOV",
        "clearingBroker": "0286",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "SGSM",
        "clearingBroker": "1043",
        "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "SHMR",
        "clearingBroker": "0695",
        "brokerName": "ABN AMRO CLEARING USA LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "SHOT",
        "clearingBroker": "0005",
        "brokerName": "SCHOTTENFELD GROUP LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "SHYR",
        "clearingBroker": "0158",
        "brokerName": "STERLINGSHIRE INVESTMENTS                                             "
    },
    {
        "type": "OTC",
        "mpid": "SIBO",
        "clearingBroker": "8199",
        "brokerName": "PRIME EXECUTIONS, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "SILC",
        "clearingBroker": "0158",
        "brokerName": "SOCIAL INVSTR                                                         "
    },
    {
        "type": "OTC",
        "mpid": "SILK",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS EXECUTION & CLEARING, L.P.                              "
    },
    {
        "type": "OTC",
        "mpid": "SIMP",
        "clearingBroker": "0551",
        "brokerName": "SIMPLEX TRADING, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "SKTR",
        "clearingBroker": "0279",
        "brokerName": "STOCK TRADERS                                                         "
    },
    {
        "type": "OTC",
        "mpid": "SLRD",
        "clearingBroker": "0226",
        "brokerName": "S.L. REED & COMPANY                                                   "
    },
    {
        "type": "OTC",
        "mpid": "SMCO",
        "clearingBroker": "0235",
        "brokerName": "SMITH, MOORE & CO.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "SMHI",
        "clearingBroker": "0443",
        "brokerName": "SANDERS MORRIS HARRIS INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "SMNS",
        "clearingBroker": "0226",
        "brokerName": "PARKLAND SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "SMPX",
        "clearingBroker": "0695",
        "brokerName": "SIMPLEX TRADING, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "SMRD",
        "clearingBroker": "0443",
        "brokerName": "SUMRIDGE PARTNERS, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "SMRI",
        "clearingBroker": "0226",
        "brokerName": "SECURITIES MANAGEMENT & RESEARCH, INC.                                "
    },
    {
        "type": "OTC",
        "mpid": "SNCC",
        "clearingBroker": "0534",
        "brokerName": "SNC CAPITAL MANAGEMENT CORP.                                          "
    },
    {
        "type": "OTC",
        "mpid": "SNEX",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "SOCO",
        "clearingBroker": "0443",
        "brokerName": "CAPITAL ONE SECURITIES, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "SOFI",
        "clearingBroker": "0158",
        "brokerName": "SOFI SECURITIES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "SOGO",
        "clearingBroker": "0158",
        "brokerName": "WANG INVESTMENT ASSOCIATES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "SOHO",
        "clearingBroker": "0161",
        "brokerName": "TWO SIGMA SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "SORS",
        "clearingBroker": "0235",
        "brokerName": "SORSBY FINANCIAL CORP.                                                "
    },
    {
        "type": "OTC",
        "mpid": "SOVG",
        "clearingBroker": "8199",
        "brokerName": "SOVEREIGN GLOBAL ADVISORS, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "SPAC",
        "clearingBroker": "0793",
        "brokerName": "SIERRA PACIFIC SECURITIES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "SPBR",
        "clearingBroker": "3856",
        "brokerName": "SPRINKLEBROKERAGE, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "SPCS",
        "clearingBroker": "0052",
        "brokerName": "SPARTAN CAPITAL SECURITIES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "SPCX",
        "clearingBroker": "8199",
        "brokerName": "SCORE PRIORITY CORP.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "SPEX",
        "clearingBroker": "0235",
        "brokerName": "INSPEREX LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "SPFI",
        "clearingBroker": "2402",
        "brokerName": "NORTHBOUND SECURITIES LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "SPGS",
        "clearingBroker": "0443",
        "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "SPHN",
        "clearingBroker": "0443",
        "brokerName": "STEPHENS INC.                                                         "
    },
    {
        "type": "OTC",
        "mpid": "SPLC",
        "clearingBroker": "0226",
        "brokerName": "SPIRE SECURITIES, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "SPLN",
        "clearingBroker": "8199",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "SPLX",
        "clearingBroker": "0695",
        "brokerName": "SIMPLEX TRADING, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "SPNN",
        "clearingBroker": "0052",
        "brokerName": "SPARTAN CAPITAL SECURITIES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "SPOT",
        "clearingBroker": "0005",
        "brokerName": "SPOT TRADING                                                          "
    },
    {
        "type": "OTC",
        "mpid": "SPTD",
        "clearingBroker": "0052",
        "brokerName": "MINT GLOBAL MARKETS, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "SPTS",
        "clearingBroker": "0158",
        "brokerName": "SEVEN POINTS CAPITAL, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "SRBC",
        "clearingBroker": "0235",
        "brokerName": "SPIDERROCK EXS, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "SRPT",
        "clearingBroker": "9132",
        "brokerName": "SPEEDROUTE LLC                                                        "
    },
    {
        "type": "OTC",
        "mpid": "SSBS",
        "clearingBroker": "0189",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "SSCO",
        "clearingBroker": "8457",
        "brokerName": "SAFRA SECURITIES LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "SSEI",
        "clearingBroker": "0824",
        "brokerName": "SEI INVESTMENTS DISTRIBUTION CO.                                      "
    },
    {
        "type": "OTC",
        "mpid": "SSGC",
        "clearingBroker": "0226",
        "brokerName": "SIGNATURE SECURITIES                                                  "
    },
    {
        "type": "OTC",
        "mpid": "SSGM",
        "clearingBroker": "0226",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "SSGR",
        "clearingBroker": "0443",
        "brokerName": "SHAREHOLDERS SERVICES GROUP INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "SSIN",
        "clearingBroker": "0226",
        "brokerName": "TRUIST INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "SSLC",
        "clearingBroker": "0279",
        "brokerName": "SANDERLIN SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "SSLL",
        "clearingBroker": "0189",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "SSNE",
        "clearingBroker": "0226",
        "brokerName": "SANTANDER SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "SSUS",
        "clearingBroker": "0551",
        "brokerName": "SUSQUEHANNA SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "STEP",
        "clearingBroker": "0235",
        "brokerName": "FERRETTI GROUP, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "STFC",
        "clearingBroker": "0443",
        "brokerName": "STUART FRANKEL & CO., INCORPORATED                                    "
    },
    {
        "type": "OTC",
        "mpid": "STFL",
        "clearingBroker": "0793",
        "brokerName": "STIFEL, NICOLAUS & COMPANY, INCORPORATED                              "
    },
    {
        "type": "OTC",
        "mpid": "STFX",
        "clearingBroker": "0793",
        "brokerName": "STIFEL, NICOLAUS & COMPANY, INCORPORATED                              "
    },
    {
        "type": "OTC",
        "mpid": "STGC",
        "clearingBroker": "0279",
        "brokerName": "STERLING GRACE MUNICIPAL SECURITIES CO                                "
    },
    {
        "type": "OTC",
        "mpid": "STHR",
        "clearingBroker": "0388",
        "brokerName": "STORMHARBOUR SECURITIES LP                                            "
    },
    {
        "type": "OTC",
        "mpid": "STKP",
        "clearingBroker": "0158",
        "brokerName": "STOCKPILE INVESTMENTS, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "STNH",
        "clearingBroker": "0534",
        "brokerName": "STONEHAVEN, LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "STOX",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "STRM",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "OTC",
        "mpid": "STRS",
        "clearingBroker": "0161",
        "brokerName": "STRATEGAS RESEARCH PARTNERS, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "STSB",
        "clearingBroker": "3856",
        "brokerName": "SOUTHERN TRUST SECURITIES, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "STSH",
        "clearingBroker": "0158",
        "brokerName": "STASH CAPITAL LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "STSV",
        "clearingBroker": "3856",
        "brokerName": "SOUTHERN TRUST SECURITIES, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "STTT",
        "clearingBroker": "0052",
        "brokerName": "STATETRUST INVESTMENTS INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "STUR",
        "clearingBroker": "0158",
        "brokerName": "STURDIVANT & CO., INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "STXG",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "SUFI",
        "clearingBroker": "0551",
        "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLP                                      "
    },
    {
        "type": "OTC",
        "mpid": "SUMI",
        "clearingBroker": "0443",
        "brokerName": "SMBC NIKKO SECURITIES AMERICA, INC.                                   "
    },
    {
        "type": "OTC",
        "mpid": "SUNX",
        "clearingBroker": "0695",
        "brokerName": "ABN AMRO CLEARING CHICAGO LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "SUSQ",
        "clearingBroker": "0551",
        "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLP                                      "
    },
    {
        "type": "OTC",
        "mpid": "SUST",
        "clearingBroker": "0235",
        "brokerName": "SUNSTREET SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "SVBS",
        "clearingBroker": "0443",
        "brokerName": "SVB SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "SWSS",
        "clearingBroker": "0443",
        "brokerName": "SANCTUARY SECURITIES, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "SWST",
        "clearingBroker": "0279",
        "brokerName": "HILLTOP SECURITIES INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "TAGB",
        "clearingBroker": "0052",
        "brokerName": "TAGLICH BROTHERS, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "TAGC",
        "clearingBroker": "1043",
        "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "TAGD",
        "clearingBroker": "1043",
        "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "TAIQ",
        "clearingBroker": "8199",
        "brokerName": "THINK ALPHA SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "TAPP",
        "clearingBroker": "0294",
        "brokerName": "TAPP ENGINE SECURITIES                                                "
    },
    {
        "type": "OTC",
        "mpid": "TAPR",
        "clearingBroker": "4305",
        "brokerName": "TAPP ENGINE SECURITIES                                                "
    },
    {
        "type": "OTC",
        "mpid": "TBCL",
        "clearingBroker": "0750",
        "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "TBCR",
        "clearingBroker": "0235",
        "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "TBGO",
        "clearingBroker": "4305",
        "brokerName": "TRADINGBLOCK                                                          "
    },
    {
        "type": "OTC",
        "mpid": "TBIA",
        "clearingBroker": "0158",
        "brokerName": "TRADIER BROKERAGE, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "TBIS",
        "clearingBroker": "0158",
        "brokerName": "TRADIER BROKERAGE, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "TBLK",
        "clearingBroker": "4305",
        "brokerName": "TRADINGBLOCK                                                          "
    },
    {
        "type": "OTC",
        "mpid": "TBRD",
        "clearingBroker": "0226",
        "brokerName": "THOROUGHBRED FINANCIAL SERVICES, LLC                                  "
    },
    {
        "type": "OTC",
        "mpid": "TBRO",
        "clearingBroker": "8199",
        "brokerName": "TUOHY BROTHERS INVESTMENT RESEARCH, INC.                              "
    },
    {
        "type": "OTC",
        "mpid": "TCBI",
        "clearingBroker": "0443",
        "brokerName": "TCBI SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "TDCO",
        "clearingBroker": "0235",
        "brokerName": "THOMPSON DAVIS & CO., INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "TDED",
        "clearingBroker": "0284",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "TDFS",
        "clearingBroker": "0052",
        "brokerName": "TRADERFIELD SECURITIES INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "TDFV",
        "clearingBroker": "0294",
        "brokerName": "TRADERFIELD SECURITIES INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "TDNF",
        "clearingBroker": "2568",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "TDSI",
        "clearingBroker": "0226",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "TFAI",
        "clearingBroker": "0226",
        "brokerName": "TRANSAMERICA FINANCIAL ADVISORS, INC.                                 "
    },
    {
        "type": "OTC",
        "mpid": "TFAS",
        "clearingBroker": "0443",
        "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
    },
    {
        "type": "OTC",
        "mpid": "TFSL",
        "clearingBroker": "0235",
        "brokerName": "TECKMEYER FINANCIAL SERVICES                                          "
    },
    {
        "type": "OTC",
        "mpid": "THEM",
        "clearingBroker": "0235",
        "brokerName": "THEMIS TRADING LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "THNK",
        "clearingBroker": "0052",
        "brokerName": "THINKEQUITY, LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "TIAD",
        "clearingBroker": "8199",
        "brokerName": "TRIAD SECURITIES CORP                                                 "
    },
    {
        "type": "OTC",
        "mpid": "TIAN",
        "clearingBroker": "0226",
        "brokerName": "TRIAD SECURITIES CORP                                                 "
    },
    {
        "type": "OTC",
        "mpid": "TIGC",
        "clearingBroker": "0235",
        "brokerName": "NELSONREID, INC.                                                      "
    },
    {
        "type": "OTC",
        "mpid": "TIGE",
        "clearingBroker": "1043",
        "brokerName": "US TIGER SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "TIRE",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING                                                          "
    },
    {
        "type": "OTC",
        "mpid": "TJMI",
        "clearingBroker": "9132",
        "brokerName": "TJM INVESTMENTS, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "TKEQ",
        "clearingBroker": "1186",
        "brokerName": "FORDHAM FINANCIAL MANAGEMENT, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "TKNG",
        "clearingBroker": "0158",
        "brokerName": "TRADEKING LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "TLSA",
        "clearingBroker": "4230",
        "brokerName": "TRADELINK SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "TMAS",
        "clearingBroker": "0235",
        "brokerName": "TRADEMAS INC.                                                         "
    },
    {
        "type": "OTC",
        "mpid": "TMBI",
        "clearingBroker": "0141",
        "brokerName": "THURSTON SPRINGER FINANCIAL                                           "
    },
    {
        "type": "OTC",
        "mpid": "TMBR",
        "clearingBroker": "0534",
        "brokerName": "IBKR SECURITIES SERVICES LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "TMCD",
        "clearingBroker": "0235",
        "brokerName": "MCDONALD PARTNERS LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "TMIN",
        "clearingBroker": "0443",
        "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
    },
    {
        "type": "OTC",
        "mpid": "TOCQ",
        "clearingBroker": "0443",
        "brokerName": "TOCQUEVILLE SECURITIES L.P.                                           "
    },
    {
        "type": "OTC",
        "mpid": "TONE",
        "clearingBroker": "8199",
        "brokerName": "2021 CAPITAL                                                          "
    },
    {
        "type": "OTC",
        "mpid": "TORB",
        "clearingBroker": "0294",
        "brokerName": "TOR BROKERAGE LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "TORM",
        "clearingBroker": "0294",
        "brokerName": "TOR BROKERAGE LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "TOUR",
        "clearingBroker": "0005",
        "brokerName": "TOURMALINE PARTNERS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "TPIS",
        "clearingBroker": "0161",
        "brokerName": "TULLETT PREBON FINANCIAL SERVICES, LLC                                "
    },
    {
        "type": "OTC",
        "mpid": "TPMG",
        "clearingBroker": "0005",
        "brokerName": "TOWER PRINCIPAL MARKETS LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "TPMR",
        "clearingBroker": "0141",
        "brokerName": "TRADE-PMR INC.                                                        "
    },
    {
        "type": "OTC",
        "mpid": "TPMX",
        "clearingBroker": "0695",
        "brokerName": "TOWER PRINCIPAL MARKETS LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "TPRO",
        "clearingBroker": "4305",
        "brokerName": "TRADEPRO SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "TPTG",
        "clearingBroker": "2402",
        "brokerName": "CASH APP INVESTING LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "TPVC",
        "clearingBroker": "0294",
        "brokerName": "TRADEPRO SECURITIES,INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "TRAD",
        "clearingBroker": "0271",
        "brokerName": "TRADESTATION SECURITIES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "TRBT",
        "clearingBroker": "0083",
        "brokerName": "TRADEBOT SYSTEMS, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "TRCG",
        "clearingBroker": "0005",
        "brokerName": "TRC MARKETS LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "TRCJ",
        "clearingBroker": "0352",
        "brokerName": "TRC MARKETS LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "TRCM",
        "clearingBroker": "0695",
        "brokerName": "TRC MARKETS LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "TRCS",
        "clearingBroker": "0388",
        "brokerName": "TIGERRISK CAPITAL MARKETS & ADVISORY                                  "
    },
    {
        "type": "OTC",
        "mpid": "TRCX",
        "clearingBroker": "0695",
        "brokerName": "TRC MARKETS LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "TREX",
        "clearingBroker": "1043",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "OTC",
        "mpid": "TRIB",
        "clearingBroker": "0235",
        "brokerName": "TRIBAL CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "TRIM",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "TRIP",
        "clearingBroker": "0235",
        "brokerName": "TRIDENT PARTNERS LTD                                                  "
    },
    {
        "type": "OTC",
        "mpid": "TRLN",
        "clearingBroker": "4230",
        "brokerName": "TRADELINK SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "TRMZ",
        "clearingBroker": "0161",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "TRSH",
        "clearingBroker": "0279",
        "brokerName": "THRASHER & CHAMBERS, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "TRSQ",
        "clearingBroker": "0443",
        "brokerName": "TOWER SQUARE SECURITIES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "TRUB",
        "clearingBroker": "0141",
        "brokerName": "TRUBEE, COLLINS & CO., INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "TRWN",
        "clearingBroker": "0443",
        "brokerName": "T.R. WINSTON & COMPANY, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "TRYC",
        "clearingBroker": "0158",
        "brokerName": "SIXTEEN SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "TRYN",
        "clearingBroker": "0279",
        "brokerName": "FIRST TRYON SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "TSCD",
        "clearingBroker": "0235",
        "brokerName": "STURGES COMPANY (THE)                                                 "
    },
    {
        "type": "OTC",
        "mpid": "TSER",
        "clearingBroker": "0161",
        "brokerName": "TWO SIGMA EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "TSSM",
        "clearingBroker": "0161",
        "brokerName": "TWO SIGMA SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "TTCS",
        "clearingBroker": "9132",
        "brokerName": "T3 TRADING GROUP, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "TTSC",
        "clearingBroker": "0052",
        "brokerName": "TREND TRADE SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "TTSI",
        "clearingBroker": "0158",
        "brokerName": "T3 SECURITIES, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "TTTG",
        "clearingBroker": "0294",
        "brokerName": "T3 TRADING GROUP, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "TTTS",
        "clearingBroker": "0158",
        "brokerName": "T3 SECURITIES, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "TWDP",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "TWTT",
        "clearingBroker": "0158",
        "brokerName": "TASTYWORKS, INC.                                                      "
    },
    {
        "type": "OTC",
        "mpid": "TWXS",
        "clearingBroker": "0161",
        "brokerName": "TRADEWORX SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "TYLO",
        "clearingBroker": "1186",
        "brokerName": "DOUGALL & ASSOCIATES                                                  "
    },
    {
        "type": "OTC",
        "mpid": "TZCL",
        "clearingBroker": "0712",
        "brokerName": "TZ CLEAR LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "UBII",
        "clearingBroker": "0221",
        "brokerName": "UBS INTERNATIONAL, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "UBSA",
        "clearingBroker": "0642",
        "brokerName": "UBS SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "UBSB",
        "clearingBroker": "0642",
        "brokerName": "UBS SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "UBSI",
        "clearingBroker": "0141",
        "brokerName": "UNITED BROKERAGE SERVICES, INC                                        "
    },
    {
        "type": "OTC",
        "mpid": "UBSS",
        "clearingBroker": "0642",
        "brokerName": "UBS SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "UBSW",
        "clearingBroker": "0642",
        "brokerName": "UBS SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "UBSX",
        "clearingBroker": "0642",
        "brokerName": "UBS SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "UCAP",
        "clearingBroker": "0750",
        "brokerName": "UCAP SECURITIES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "UCCM",
        "clearingBroker": "0279",
        "brokerName": "CU INVESTMENT SOLUTIONS, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "UCML",
        "clearingBroker": "0052",
        "brokerName": "UNITED CAPITAL MARKETS, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "UFPF",
        "clearingBroker": "0226",
        "brokerName": "UNITED FIRST PARTNERS, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "UHLM",
        "clearingBroker": "0235",
        "brokerName": "UHLMANN PRICE SECURITIES, LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "UMBF",
        "clearingBroker": "0226",
        "brokerName": "UMB FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "UNIS",
        "clearingBroker": "3450",
        "brokerName": "UNIVEST SECURITIES, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "UNIV",
        "clearingBroker": "3856",
        "brokerName": "UNIVEST SECURITIES, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "UPLN",
        "clearingBroker": "0443",
        "brokerName": "UNITED PLANNERS FINANCIAL SERVICES OF AMERICA                         "
    },
    {
        "type": "OTC",
        "mpid": "USCA",
        "clearingBroker": "0226",
        "brokerName": "USCA SECURITIES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "USDB",
        "clearingBroker": "0279",
        "brokerName": "U.S. BROKERAGE, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "USEC",
        "clearingBroker": "3450",
        "brokerName": "UNIVEST SECURITIES, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "USFB",
        "clearingBroker": "0595",
        "brokerName": "U.S. FINANCIAL INVESTMENTS, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "USIC",
        "clearingBroker": "0226",
        "brokerName": "U.S. SECURITIES, INTL. CORP.                                          "
    },
    {
        "type": "OTC",
        "mpid": "USLF",
        "clearingBroker": "5075",
        "brokerName": "PI FINANCIAL CORP.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "USSI",
        "clearingBroker": "0279",
        "brokerName": "U.S. STERLING SECURITIES, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "USTZ",
        "clearingBroker": "0595",
        "brokerName": "TRADEZERO AMERINCA, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "UVUV",
        "clearingBroker": "0161",
        "brokerName": "ULTRAVIOLET SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "VALA",
        "clearingBroker": "0294",
        "brokerName": "VALUABLE CAPITAL SECURITIES                                           "
    },
    {
        "type": "OTC",
        "mpid": "VALD",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VALI",
        "clearingBroker": "0226",
        "brokerName": "VALLEY NATIONAL INVESTMENTS, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "VALR",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VALU",
        "clearingBroker": "0294",
        "brokerName": "VALUABLE CAPITAL SECURITIES                                           "
    },
    {
        "type": "OTC",
        "mpid": "VALX",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VBLT",
        "clearingBroker": "0226",
        "brokerName": "VANDERBILT SECURITIES, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "VBSL",
        "clearingBroker": "0595",
        "brokerName": "VISION BROKERAGE SERVICES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "VCAB",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCAX",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCBB",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCBR",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CAPITAL, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "VCBY",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCCA",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCEC",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCEL",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCEX",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCFL",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCFN",
        "clearingBroker": "0235",
        "brokerName": "VAN CLEMENS & CO. INCORPORATED                                        "
    },
    {
        "type": "OTC",
        "mpid": "VCFS",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCGD",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCGL",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCGO",
        "clearingBroker": "0005",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCGP",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCGS",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCGT",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCIM",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCIN",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCIT",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCKW",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCLT",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCMA",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCPR",
        "clearingBroker": "4424",
        "brokerName": "VELOCITY CAPITAL, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "VCPS",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCRB",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCSG",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCSH",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCSK",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCSM",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCSO",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCSS",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCST",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCSV",
        "clearingBroker": "0052",
        "brokerName": "PRIMARY CAPITAL, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "VCTC",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCTH",
        "clearingBroker": "6019",
        "brokerName": "VELOCITY CAPITAL LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "VCTP",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCTS",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCTY",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCUG",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCUH",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCUS",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCVL",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCVS",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCVT",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCVU",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCVV",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCVW",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCWC",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCWP",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCWS",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VEAA",
        "clearingBroker": "3856",
        "brokerName": "VELOX CLEARING LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VEAB",
        "clearingBroker": "3856",
        "brokerName": "VELOX CLEARING LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VEAD",
        "clearingBroker": "3856",
        "brokerName": "VELOX CLEARING LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VEAE",
        "clearingBroker": "3856",
        "brokerName": "VELOX CLEARING LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VEAF",
        "clearingBroker": "3856",
        "brokerName": "VELOX CLEARING LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VELC",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CAPITAL, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "VERF",
        "clearingBroker": "0235",
        "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "VERT",
        "clearingBroker": "8199",
        "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "VESB",
        "clearingBroker": "0158",
        "brokerName": "VESTFI INC.                                                           "
    },
    {
        "type": "OTC",
        "mpid": "VEST",
        "clearingBroker": "0750",
        "brokerName": "VESTECH SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "VETS",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN VETERANS GROUP, PBC                                          "
    },
    {
        "type": "OTC",
        "mpid": "VFSI",
        "clearingBroker": "2402",
        "brokerName": "VF SECURITIES                                                         "
    },
    {
        "type": "OTC",
        "mpid": "VGRD",
        "clearingBroker": "0062",
        "brokerName": "VANGUARD MARKETING CORPORATION                                        "
    },
    {
        "type": "OTC",
        "mpid": "VHTO",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VIEW",
        "clearingBroker": "9132",
        "brokerName": "VIEWTRADE SECURITIES, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "VIRT",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VKMI",
        "clearingBroker": "0692",
        "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "VLCT",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VLEO",
        "clearingBroker": "0158",
        "brokerName": "VOLEO USA, INC                                                        "
    },
    {
        "type": "OTC",
        "mpid": "VLET",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VLFX",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VLMM",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VLNT",
        "clearingBroker": "4305",
        "brokerName": "VOLANT SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VLOX",
        "clearingBroker": "3856",
        "brokerName": "VELOX CLEARING LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VMDI",
        "clearingBroker": "0443",
        "brokerName": "DESJARDINS SECURITIES INTERNATIONAL INC.                              "
    },
    {
        "type": "OTC",
        "mpid": "VNDM",
        "clearingBroker": "0443",
        "brokerName": "VANDHAM SECURITIES CORP.                                              "
    },
    {
        "type": "OTC",
        "mpid": "VNMS",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VPEW",
        "clearingBroker": "0158",
        "brokerName": "VPE WERTPAPIERHANDELSBANK AG                                          "
    },
    {
        "type": "OTC",
        "mpid": "VRTG",
        "clearingBroker": "0695",
        "brokerName": "ABN AMRO CLEARING CHICAGO LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "VSIN",
        "clearingBroker": "0595",
        "brokerName": "VISION FINANCIAL MARKETS LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "VTDT",
        "clearingBroker": "0158",
        "brokerName": "VIEWTRADE SECURITIES, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "VTRN",
        "clearingBroker": "0443",
        "brokerName": "BANCROFT CAPITAL, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "WABR",
        "clearingBroker": "0443",
        "brokerName": "WALL STREET ACCESS                                                    "
    },
    {
        "type": "OTC",
        "mpid": "WACC",
        "clearingBroker": "0279",
        "brokerName": "MIDLAND SECURITIES, LTD                                               "
    },
    {
        "type": "OTC",
        "mpid": "WACL",
        "clearingBroker": "0709",
        "brokerName": "WACHTEL & CO., INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "WAIN",
        "clearingBroker": "1043",
        "brokerName": "H.C. WAINWRIGHT & CO., INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "WBAX",
        "clearingBroker": "0052",
        "brokerName": "WALLACHBETH CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "WBBC",
        "clearingBroker": "0226",
        "brokerName": "WBB SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "WBET",
        "clearingBroker": "0161",
        "brokerName": "WALLACHBETH CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "WBLR",
        "clearingBroker": "0771",
        "brokerName": "WILLIAM BLAIR & COMPANY, L.L.C.                                       "
    },
    {
        "type": "OTC",
        "mpid": "WBNF",
        "clearingBroker": "0226",
        "brokerName": "WILLIAM BLAIR & COMPANY L.L.C.                                        "
    },
    {
        "type": "OTC",
        "mpid": "WBPA",
        "clearingBroker": "0161",
        "brokerName": "CLEAR STREET MARKETS LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "WBPX",
        "clearingBroker": "0551",
        "brokerName": "SUMMIT SECURITIES GROUP, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "WBSI",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "WBUL",
        "clearingBroker": "0158",
        "brokerName": "WEBULL FINANCIAL LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "WCHV",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "WCIG",
        "clearingBroker": "0750",
        "brokerName": "WILLOW COVE INVESTMENT GROUP, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "WCSC",
        "clearingBroker": "0235",
        "brokerName": "WILMINGTON CAPITAL SECURITIES, LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "WCSF",
        "clearingBroker": "0235",
        "brokerName": "WORLD CHOICE SECURITIES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "WDCO",
        "clearingBroker": "0283",
        "brokerName": "WILSON-DAVIS & CO., INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "WDLF",
        "clearingBroker": "5078",
        "brokerName": "W.D. LATIMER CO LTD./CDS                                              "
    },
    {
        "type": "OTC",
        "mpid": "WDLP",
        "clearingBroker": "0005",
        "brokerName": "WOLVERINE TRADING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "WDOG",
        "clearingBroker": "0158",
        "brokerName": "WATCHDOG CAPITAL, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "WDSB",
        "clearingBroker": "0536",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "WEBL",
        "clearingBroker": "0158",
        "brokerName": "WEBULL FINANCIAL LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "WEBS",
        "clearingBroker": "0226",
        "brokerName": "WEALTH ENHANCEMENT BROKERAGE SERVICES, LLC                            "
    },
    {
        "type": "OTC",
        "mpid": "WEDB",
        "clearingBroker": "0103",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "WEDP",
        "clearingBroker": "0103",
        "brokerName": "WEDBUSH MORGAN SECURITIES INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "WEGI",
        "clearingBroker": "0235",
        "brokerName": "WORLD EQUITY GROUP INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "WEGP",
        "clearingBroker": "0235",
        "brokerName": "WESTERN EQUITY GROUP, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "WELX",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "WEMM",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "WESC",
        "clearingBroker": "0443",
        "brokerName": "WELLINGTON SHIELDS & CO., LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "WEXC",
        "clearingBroker": "7350",
        "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "WEXM",
        "clearingBroker": "0161",
        "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "WEXR",
        "clearingBroker": "0235",
        "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "WEXS",
        "clearingBroker": "9132",
        "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "WEXX",
        "clearingBroker": "0005",
        "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "WEYE",
        "clearingBroker": "0005",
        "brokerName": "WALLEYE TRADING LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "WFES",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "WFGP",
        "clearingBroker": "0075",
        "brokerName": "WATERSTONE FINANCIAL GROUP, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "WFPB",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "WGIF",
        "clearingBroker": "5030",
        "brokerName": "CIBC WORLD MARKETS INC./CDS                                           "
    },
    {
        "type": "OTC",
        "mpid": "WHBB",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "WHOT",
        "clearingBroker": "0595",
        "brokerName": "JUST2TRADE, INC.                                                      "
    },
    {
        "type": "OTC",
        "mpid": "WIDS",
        "clearingBroker": "0279",
        "brokerName": "WISCONSIN DISCOUNT SECURITIES CORP.                                   "
    },
    {
        "type": "OTC",
        "mpid": "WINO",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "WINR",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING                                                          "
    },
    {
        "type": "OTC",
        "mpid": "WINZ",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "WISC",
        "clearingBroker": "0235",
        "brokerName": "WINDSOR, SHEFFIELD & CO., INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "WISE",
        "clearingBroker": "0052",
        "brokerName": "AXOS INVEST LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "WISP",
        "clearingBroker": "0443",
        "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
    },
    {
        "type": "OTC",
        "mpid": "WLMS",
        "clearingBroker": "0443",
        "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
    },
    {
        "type": "OTC",
        "mpid": "WLTH",
        "clearingBroker": "0235",
        "brokerName": "WEALTHFRONT BROKERAGE CORPORATION                                     "
    },
    {
        "type": "OTC",
        "mpid": "WMCL",
        "clearingBroker": "0279",
        "brokerName": "WHITE MOUNTAIN CAPITAL, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "WMFS",
        "clearingBroker": "0226",
        "brokerName": "WESTMINSTER FINANCIAL SECURITIES, INC.                                "
    },
    {
        "type": "OTC",
        "mpid": "WMLL",
        "clearingBroker": "0235",
        "brokerName": "WATERMILL INSTITUTIONAL TRADING LLC                                   "
    },
    {
        "type": "OTC",
        "mpid": "WNUT",
        "clearingBroker": "0443",
        "brokerName": "WALNUT STREET SECURITIES, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "WPCC",
        "clearingBroker": "0052",
        "brokerName": "WESTPARK CAPITAL, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "WPCI",
        "clearingBroker": "0595",
        "brokerName": "WESTPARK CAPITAL, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "WPRM",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "WPSG",
        "clearingBroker": "0005",
        "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "WPSX",
        "clearingBroker": "0445",
        "brokerName": "RISE FINANCIAL SERVICES, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "WRDN",
        "clearingBroker": "0534",
        "brokerName": "WORDENTRADE, INC.                                                     "
    },
    {
        "type": "OTC",
        "mpid": "WRET",
        "clearingBroker": "0141",
        "brokerName": "WELLS FARGO CLEARING SERVICES, LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "WRIS",
        "clearingBroker": "0141",
        "brokerName": "SMH CAPITAL INVESTMENTS LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "WSAG",
        "clearingBroker": "0443",
        "brokerName": "WALL STREET ACCESS                                                    "
    },
    {
        "type": "OTC",
        "mpid": "WSAT",
        "clearingBroker": "0443",
        "brokerName": "WALL STREET ACCESS                                                    "
    },
    {
        "type": "OTC",
        "mpid": "WSCC",
        "clearingBroker": "0235",
        "brokerName": "WASHINGTON SECURITIES CORPORATION                                     "
    },
    {
        "type": "OTC",
        "mpid": "WSCX",
        "clearingBroker": "0235",
        "brokerName": "WORKMAN SECURITIES CORP                                               "
    },
    {
        "type": "OTC",
        "mpid": "WSGD",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC./P3                                            "
    },
    {
        "type": "OTC",
        "mpid": "WSIW",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "WSRP",
        "clearingBroker": "0052",
        "brokerName": "WESTROCK CAPITAL MANAGEMENT, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "WSTI",
        "clearingBroker": "0226",
        "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
    },
    {
        "type": "OTC",
        "mpid": "WTCO",
        "clearingBroker": "0005",
        "brokerName": "WILLIAMS TRADING LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "WTFS",
        "clearingBroker": "0052",
        "brokerName": "LIME TRADING CORP                                                     "
    },
    {
        "type": "OTC",
        "mpid": "WTLP",
        "clearingBroker": "0005",
        "brokerName": "WOLVERINE TRADING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "WTRI",
        "clearingBroker": "0235",
        "brokerName": "WATERFORD INVESTORS SERVICES, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "WUND",
        "clearingBroker": "0141",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "OTC",
        "mpid": "WVBD",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "WWLD",
        "clearingBroker": "0647",
        "brokerName": "WHITEWELD TRADING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "XCNC",
        "clearingBroker": "0005",
        "brokerName": "C&C TRADING L.L.C.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "XDOZ",
        "clearingBroker": "0438",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "XGWD",
        "clearingBroker": "0695",
        "brokerName": "LATOUR TRADING LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "XIST",
        "clearingBroker": "0067",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "XPQR",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING                                                          "
    },
    {
        "type": "OTC",
        "mpid": "XPSE",
        "clearingBroker": "0158",
        "brokerName": "XP INVESTMENTS US, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "XPUS",
        "clearingBroker": "0443",
        "brokerName": "XP SECURITIES, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "XRVR",
        "clearingBroker": "0279",
        "brokerName": "CRB SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "XSTM",
        "clearingBroker": "0226",
        "brokerName": "NATIONAL FINANCIAL SERVICES LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "XTLS",
        "clearingBroker": "0052",
        "brokerName": "XTELLUS CAPITAL PARTNERS, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "XTLW",
        "clearingBroker": "0052",
        "brokerName": "XTELLUS CAPITAL PARTNERS, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "XTXE",
        "clearingBroker": "0161",
        "brokerName": "XTX EXECUTION SERVICES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "XTXM",
        "clearingBroker": "0551",
        "brokerName": "XTX MARKETS LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "XXXX",
        "clearingBroker": "0123",
        "brokerName": "XXXX CLEARING 0123 TEST                                               "
    },
    {
        "type": "OTC",
        "mpid": "YLPL",
        "clearingBroker": "0075",
        "brokerName": "LPL FINANCIAL LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "YOSE",
        "clearingBroker": "0052",
        "brokerName": "YORK SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "YSBI",
        "clearingBroker": "0534",
        "brokerName": "YORK STOCKBROKERS, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "YYYY",
        "clearingBroker": "0122",
        "brokerName": "TEST ACCOUNT FORWARD TO P & S DEPT                                    "
    },
    {
        "type": "OTC",
        "mpid": "ZACK",
        "clearingBroker": "0534",
        "brokerName": "LBMZ SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "ZBAH",
        "clearingBroker": "0712",
        "brokerName": "TZ CLEAR LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "ZCAN",
        "clearingBroker": "0712",
        "brokerName": "TZ CLEAR LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "ZEDB",
        "clearingBroker": "0161",
        "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "ZEDD",
        "clearingBroker": "0295",
        "brokerName": "VAN KAMPEN FUNDS, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "ZERO",
        "clearingBroker": "0158",
        "brokerName": "TRADEZERO AMERICA, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "ZEUS",
        "clearingBroker": "0443",
        "brokerName": "ZEUS FINANCIAL, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "ZIPD",
        "clearingBroker": "3450",
        "brokerName": "SPEEDTRADER, INC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "ZIVI",
        "clearingBroker": "8082",
        "brokerName": "ZIV INVESTMENT COMPANY                                                "
    },
    {
        "type": "OTC",
        "mpid": "ZNTH",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "ZOES",
        "clearingBroker": "0158",
        "brokerName": "ZOE SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "ZOUL",
        "clearingBroker": "0235",
        "brokerName": "N.B. ZOULLAS SECURITIES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "ZPFD",
        "clearingBroker": "0443",
        "brokerName": "B. C. ZIEGLER AND COMPANY                                             "
    },
    {
        "type": "OTC",
        "mpid": "ZZZZ",
        "clearingBroker": "0123",
        "brokerName": "TEST ACCOUNT - FORWARD TO P&S DEPARTMENT                              "
    },
    {
        "type": "CORP",
        "mpid": "AALC",
        "clearingBroker": "0226",
        "brokerName": "THRIVENT INVESTMENT MANAGEMENT, INC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "ABAI",
        "clearingBroker": "0279",
        "brokerName": "ABACUS INVESTMENTS, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "ABBA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABBK",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABDA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABDW",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABEA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABEN",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABHE",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABIG",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABPR",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABRP",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABST",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ACAD",
        "clearingBroker": "0443",
        "brokerName": "ACADEMY SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "ACAM",
        "clearingBroker": "0388",
        "brokerName": "ACADEMY SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "ACAP",
        "clearingBroker": "0235",
        "brokerName": "ALAMO CAPITAL                                                         "
    },
    {
        "type": "CORP",
        "mpid": "ACCP",
        "clearingBroker": "0158",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "ACCU",
        "clearingBroker": "0052",
        "brokerName": "ATB CAPITAL MARKETS USA INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "ACII",
        "clearingBroker": "0158",
        "brokerName": "ARCA CAPITAL INVESTMENTS, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "ACLP",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER CAPITAL, L.P.                                               "
    },
    {
        "type": "CORP",
        "mpid": "ACPL",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN CAPITAL PARTNERS                                             "
    },
    {
        "type": "CORP",
        "mpid": "ACPS",
        "clearingBroker": "0443",
        "brokerName": "ACP SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "ACRN",
        "clearingBroker": "0235",
        "brokerName": "ACORNS SECURITIES, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "ACTI",
        "clearingBroker": "0443",
        "brokerName": "ACTIVNER SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "ADAM",
        "clearingBroker": "0161",
        "brokerName": "CANACCORD GENUITY INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "ADSD",
        "clearingBroker": "0725",
        "brokerName": "ROGAN & ASSOCIATES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "ADSO",
        "clearingBroker": "0141",
        "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "AEFS",
        "clearingBroker": "0226",
        "brokerName": "AE FINANCIAL SERVICES, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "AETL",
        "clearingBroker": "0158",
        "brokerName": "AET INVESTMENT SERVICES, LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "AEXG",
        "clearingBroker": "0158",
        "brokerName": "ALTERNATIVE EXECUTION GROUP                                           "
    },
    {
        "type": "CORP",
        "mpid": "AFBS",
        "clearingBroker": "0158",
        "brokerName": "APEX FINTECH BROKERAGE SERVICES LLC                                   "
    },
    {
        "type": "CORP",
        "mpid": "AFGI",
        "clearingBroker": "0725",
        "brokerName": "ACCESS FINANCIAL GROUP, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "AFGT",
        "clearingBroker": "0052",
        "brokerName": "J. ALDEN ASSOCIATES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "AFSL",
        "clearingBroker": "0443",
        "brokerName": "SORRENTO PACIFIC FINANCIAL                                            "
    },
    {
        "type": "CORP",
        "mpid": "AFSS",
        "clearingBroker": "0750",
        "brokerName": "FOUR POINTS CAPITAL PARTNERS LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "AGCO",
        "clearingBroker": "0052",
        "brokerName": "AUERBACH GRAYSON & COMPANY LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "AGCP",
        "clearingBroker": "0052",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "AGES",
        "clearingBroker": "0750",
        "brokerName": "ADVISORY GROUP EQUITY SERVICES LTD.                                   "
    },
    {
        "type": "CORP",
        "mpid": "AGFA",
        "clearingBroker": "0226",
        "brokerName": "VALIC FINANCIAL ADVISORS, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "AGIS",
        "clearingBroker": "0235",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "AGPM",
        "clearingBroker": "1043",
        "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
    },
    {
        "type": "CORP",
        "mpid": "AGSS",
        "clearingBroker": "0443",
        "brokerName": "GREAT AMERICAN ADVISORS, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "AHSI",
        "clearingBroker": "0141",
        "brokerName": "AMERICAN HERITAGE SECURITIES, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "AIGF",
        "clearingBroker": "0443",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "AIGN",
        "clearingBroker": "0226",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "AIRS",
        "clearingBroker": "0279",
        "brokerName": "HAND SECURITIES, INC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "AISG",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN INDEPENDENT SECURITIES GROUP, LLC                            "
    },
    {
        "type": "CORP",
        "mpid": "AJCO",
        "clearingBroker": "0443",
        "brokerName": "IDB CAPITAL CORP.                                                     "
    },
    {
        "type": "CORP",
        "mpid": "ALCG",
        "clearingBroker": "0235",
        "brokerName": "ALTITUDE CAPITAL GROUP LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "ALCM",
        "clearingBroker": "0279",
        "brokerName": "ALPHALEDGER MARKETS, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "ALDN",
        "clearingBroker": "0052",
        "brokerName": "J. ALDEN ASSOCIATES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "ALGP",
        "clearingBroker": "0235",
        "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
    },
    {
        "type": "CORP",
        "mpid": "ALGR",
        "clearingBroker": "0158",
        "brokerName": "ALGER (FRED) & CO INC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "ALIS",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER INVESTMENT SERVICES CO.                                     "
    },
    {
        "type": "CORP",
        "mpid": "ALLN",
        "clearingBroker": "0443",
        "brokerName": "ALLEN & COMPANY LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "ALNC",
        "clearingBroker": "0226",
        "brokerName": "A.G.P./ALLIANCE GLOBAL PARTNERS                                       "
    },
    {
        "type": "CORP",
        "mpid": "ALTR",
        "clearingBroker": "3164",
        "brokerName": "ALTRUIST FINANCIAL LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "AMBB",
        "clearingBroker": "0141",
        "brokerName": "ALLEN, MOONEY & BARNES BROKERAGE SERVICES, LLC                        "
    },
    {
        "type": "CORP",
        "mpid": "AMER",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "CORP",
        "mpid": "AMIC",
        "clearingBroker": "0226",
        "brokerName": "AMERICAN INVESTORS COMPANY                                            "
    },
    {
        "type": "CORP",
        "mpid": "AMLU",
        "clearingBroker": "3652",
        "brokerName": "LUCID CAPITAL MARKETS, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "AMMS",
        "clearingBroker": "0141",
        "brokerName": "AMUNI FINANCIAL, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "AMRG",
        "clearingBroker": "0443",
        "brokerName": "WORLD CAPITAL BROKERAGE, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "ANDB",
        "clearingBroker": "0443",
        "brokerName": "ANDBANC BROKERAGE, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "ANDG",
        "clearingBroker": "0235",
        "brokerName": "GARRETT (ANDREW), INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "ANOS",
        "clearingBroker": "0235",
        "brokerName": "ABEL NOSER, LLC.                                                      "
    },
    {
        "type": "CORP",
        "mpid": "ANOV",
        "clearingBroker": "0750",
        "brokerName": "ANOVEST FINANCIAL SERVICES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "AOCS",
        "clearingBroker": "0388",
        "brokerName": "AOC SECURITIES                                                        "
    },
    {
        "type": "CORP",
        "mpid": "AONC",
        "clearingBroker": "0443",
        "brokerName": "AON BENFIELD SECURITIES                                               "
    },
    {
        "type": "CORP",
        "mpid": "AORP",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "AOSD",
        "clearingBroker": "0158",
        "brokerName": "TRADING BLOCK                                                         "
    },
    {
        "type": "CORP",
        "mpid": "APBD",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "APBO",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "APFS",
        "clearingBroker": "0443",
        "brokerName": "AMERICA'S PORTFOLIO'S                                                 "
    },
    {
        "type": "CORP",
        "mpid": "APRT",
        "clearingBroker": "0226",
        "brokerName": "PARTNERS                                                              "
    },
    {
        "type": "CORP",
        "mpid": "APXO",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "APXS",
        "clearingBroker": "0052",
        "brokerName": "APEXUS CAPITAL LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "ARBC",
        "clearingBroker": "0235",
        "brokerName": "ARKADIOS CAPITAL                                                      "
    },
    {
        "type": "CORP",
        "mpid": "ARCD",
        "clearingBroker": "0443",
        "brokerName": "ARCADIA SECURITIES, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "ARKA",
        "clearingBroker": "0443",
        "brokerName": "ARKA SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "ARKI",
        "clearingBroker": "0226",
        "brokerName": "ARKADIOS CAPITAL                                                      "
    },
    {
        "type": "CORP",
        "mpid": "ARSC",
        "clearingBroker": "1043",
        "brokerName": "ARCTIC SECURITIES LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "ARTI",
        "clearingBroker": "1043",
        "brokerName": "ARBOR RESEARCH & TRADING, LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "ARVS",
        "clearingBroker": "0443",
        "brokerName": "ARVEST WEALTH MANAGEMENT                                              "
    },
    {
        "type": "CORP",
        "mpid": "ASCM",
        "clearingBroker": "0052",
        "brokerName": "ASCENDIANT CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "ASCP",
        "clearingBroker": "0443",
        "brokerName": "BOK FINANCIAL SECURITIES                                              "
    },
    {
        "type": "CORP",
        "mpid": "ASII",
        "clearingBroker": "0226",
        "brokerName": "AURORA SECURITIES                                                     "
    },
    {
        "type": "CORP",
        "mpid": "ASLB",
        "clearingBroker": "0370",
        "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
    },
    {
        "type": "CORP",
        "mpid": "ASOI",
        "clearingBroker": "0226",
        "brokerName": "ASSOCIATED INVESTMENT SERVICES, INC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "ASPI",
        "clearingBroker": "0725",
        "brokerName": "ASIA PACIFIC FINANCIAL MANAGEMENT GROUP, INC.                         "
    },
    {
        "type": "CORP",
        "mpid": "ATIS",
        "clearingBroker": "0052",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "CORP",
        "mpid": "ATLS",
        "clearingBroker": "0443",
        "brokerName": "APOLLO GLOBAL SECURITIES, LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "ATMC",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "ATVT",
        "clearingBroker": "0443",
        "brokerName": "ATOMIC BROKERAGE LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "AULC",
        "clearingBroker": "0443",
        "brokerName": "ONEAMERICA SECURITIES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "AVEN",
        "clearingBroker": "0226",
        "brokerName": "AVENTURA SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "AVEW",
        "clearingBroker": "8199",
        "brokerName": "AVENTURA SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "AVIL",
        "clearingBroker": "0158",
        "brokerName": "AVANZA CAPITAL MARKETS INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "AVML",
        "clearingBroker": "0443",
        "brokerName": "AVM, L.P.                                                             "
    },
    {
        "type": "CORP",
        "mpid": "AVON",
        "clearingBroker": "0226",
        "brokerName": "AVONDALE PARTNERS, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "AVSI",
        "clearingBroker": "0443",
        "brokerName": "AMERIVET SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "AVST",
        "clearingBroker": "0235",
        "brokerName": "ATOMIC BROKERAGE LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "AWMI",
        "clearingBroker": "0725",
        "brokerName": "AMERICAN WEALTH MANAGEMENT INC                                        "
    },
    {
        "type": "CORP",
        "mpid": "AXAA",
        "clearingBroker": "0075",
        "brokerName": "AXA ADVISORS LLC                                                      "
    },
    {
        "type": "CORP",
        "mpid": "AXCB",
        "clearingBroker": "0443",
        "brokerName": "ACCESS SECURITIES                                                     "
    },
    {
        "type": "CORP",
        "mpid": "AXCL",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "AXCS",
        "clearingBroker": "0443",
        "brokerName": "ACCESS SECURITIES INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "AXGP",
        "clearingBroker": "0443",
        "brokerName": "ACCESS SECURITIES, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "AXIO",
        "clearingBroker": "0279",
        "brokerName": "AXIOM CAPITAL MANAGEMENT, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "AXOS",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "AXTN",
        "clearingBroker": "0052",
        "brokerName": "AX TRADING, LLC                                                       "
    },
    {
        "type": "CORP",
        "mpid": "BAKR",
        "clearingBroker": "0443",
        "brokerName": "JAMES BAKER & ASSOCIATES, L.P.                                        "
    },
    {
        "type": "CORP",
        "mpid": "BALE",
        "clearingBroker": "0443",
        "brokerName": "M&T SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "BALS",
        "clearingBroker": "0750",
        "brokerName": "BRUCE A. LEFAVI SECURITIES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "BANK",
        "clearingBroker": "0701",
        "brokerName": "CETERA INVESTMENT SERVICES LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "BARC",
        "clearingBroker": "0388",
        "brokerName": "BARCLAY                                                               "
    },
    {
        "type": "CORP",
        "mpid": "BARD",
        "clearingBroker": "0547",
        "brokerName": "ROBERT W. BAIRD & CO. INCORPORATED                                    "
    },
    {
        "type": "CORP",
        "mpid": "BARR",
        "clearingBroker": "0226",
        "brokerName": "BARRETT & COMPANY                                                     "
    },
    {
        "type": "CORP",
        "mpid": "BAYC",
        "clearingBroker": "0161",
        "brokerName": "BAY CREST PARTNERS,  LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "BAYP",
        "clearingBroker": "0161",
        "brokerName": "BAY CREST PARTNERS, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "BBAR",
        "clearingBroker": "0595",
        "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "BBGC",
        "clearingBroker": "0235",
        "brokerName": "GRAHAM (B.B.) & COMPANY                                               "
    },
    {
        "type": "CORP",
        "mpid": "BBNI",
        "clearingBroker": "0443",
        "brokerName": "PERFORMANCE TRUST CAPITAL PARTNERS, INC.                              "
    },
    {
        "type": "CORP",
        "mpid": "BCAP",
        "clearingBroker": "7256",
        "brokerName": "BARCLAYS CAPITAL, INC./FIXED INCOME                                   "
    },
    {
        "type": "CORP",
        "mpid": "BCCS",
        "clearingBroker": "0443",
        "brokerName": "BAC FLORIDA INVESTMENTS CORP.                                         "
    },
    {
        "type": "CORP",
        "mpid": "BCEX",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "BCGS",
        "clearingBroker": "0443",
        "brokerName": "BCG SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "BCIB",
        "clearingBroker": "0443",
        "brokerName": "BCI SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "BCKL",
        "clearingBroker": "0443",
        "brokerName": "BANCOLOMBIA CAPITAL LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "BCLE",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "CORP",
        "mpid": "BCPI",
        "clearingBroker": "0279",
        "brokerName": "GVC CAPITAL LLC                                                       "
    },
    {
        "type": "CORP",
        "mpid": "BCRK",
        "clearingBroker": "0279",
        "brokerName": "BEAR CREEK SECURITIES, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "BCSA",
        "clearingBroker": "0443",
        "brokerName": "BCS AMERICAS, INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "BCWM",
        "clearingBroker": "4077",
        "brokerName": "BETA CAPITAL SECURITIES LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "BCZC",
        "clearingBroker": "0443",
        "brokerName": "ZIEGLER (B.C.) & COMPANY                                              "
    },
    {
        "type": "CORP",
        "mpid": "BDBS",
        "clearingBroker": "0443",
        "brokerName": "BANCO DO BRASIL SECURITIES                                            "
    },
    {
        "type": "CORP",
        "mpid": "BDDK",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "BDIR",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "CORP",
        "mpid": "BDTR",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "BEAF",
        "clearingBroker": "0235",
        "brokerName": "BEACONSFIELD FINANCIAL SERV.                                          "
    },
    {
        "type": "CORP",
        "mpid": "BECM",
        "clearingBroker": "0725",
        "brokerName": "BETA CAPITAL SECURITIES LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "BELS",
        "clearingBroker": "0443",
        "brokerName": "BEL AIR SECURITIES LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "BERN",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "BERS",
        "clearingBroker": "0235",
        "brokerName": "BESTEX RESEARCH SECURITIES, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "BEST",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "BFEC",
        "clearingBroker": "0443",
        "brokerName": "BENJAMIN F. EDWARDS & COMPANY                                         "
    },
    {
        "type": "CORP",
        "mpid": "BFEW",
        "clearingBroker": "0443",
        "brokerName": "BILL FEW ASSOCIATES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "BFFI",
        "clearingBroker": "0226",
        "brokerName": "BERTHEL, FISHER & COMPANY FINANCIAL SERVICES, INC.                    "
    },
    {
        "type": "CORP",
        "mpid": "BFSL",
        "clearingBroker": "0235",
        "brokerName": "BRIGGS-FICKS SECURITIES, LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "BGCE",
        "clearingBroker": "0161",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "BGCF",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL, L.P.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "BGCX",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "BGHT",
        "clearingBroker": "0141",
        "brokerName": "BRIGHTON SECURITIES CORP.                                             "
    },
    {
        "type": "CORP",
        "mpid": "BGIS",
        "clearingBroker": "0443",
        "brokerName": "BLACKROCK EXECUTION SERVICES                                          "
    },
    {
        "type": "CORP",
        "mpid": "BGMI",
        "clearingBroker": "0158",
        "brokerName": "BRICKELL GLOBAL MARKETS, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "BGSG",
        "clearingBroker": "0226",
        "brokerName": "CBIZ FINANCIAL SOLUTIONS, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "BGVS",
        "clearingBroker": "0443",
        "brokerName": "BGV SECURITIES                                                        "
    },
    {
        "type": "CORP",
        "mpid": "BHII",
        "clearingBroker": "0443",
        "brokerName": "BELLE HAVEN INVESTMENTS, LP                                           "
    },
    {
        "type": "CORP",
        "mpid": "BHKS",
        "clearingBroker": "0141",
        "brokerName": "BHK SECURITIES, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "BIFS",
        "clearingBroker": "0443",
        "brokerName": "BROKERS INTERNATIONAL FINANCIAL SERVICES, LLC                         "
    },
    {
        "type": "CORP",
        "mpid": "BIGG",
        "clearingBroker": "0005",
        "brokerName": "BROWNSTONE INVESTMENT GROUP                                           "
    },
    {
        "type": "CORP",
        "mpid": "BIGP",
        "clearingBroker": "0443",
        "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "BIMI",
        "clearingBroker": "0136",
        "brokerName": "INTESA SANPAOLO IMI SECURITIES CORP.                                  "
    },
    {
        "type": "CORP",
        "mpid": "BISI",
        "clearingBroker": "0443",
        "brokerName": "BANORTE SECURITIES INTERNATIONAL, LTD.                                "
    },
    {
        "type": "CORP",
        "mpid": "BJCM",
        "clearingBroker": "0235",
        "brokerName": "ESSEX SECURITIES LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "BJRC",
        "clearingBroker": "0235",
        "brokerName": "CASCADE INVESTMENT GROUP, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "BKCM",
        "clearingBroker": "0443",
        "brokerName": "BNY CAPITAL MARKETS INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "BKES",
        "clearingBroker": "0443",
        "brokerName": "BNY MELLON CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "BKRT",
        "clearingBroker": "0235",
        "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "BLEY",
        "clearingBroker": "0443",
        "brokerName": "BLEY INVESTMENT GROUP, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "BLNI",
        "clearingBroker": "0226",
        "brokerName": "AMERITAS INVESTMENT COMPANY, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "BLOC",
        "clearingBroker": "0158",
        "brokerName": "TRADING BLOCK                                                         "
    },
    {
        "type": "CORP",
        "mpid": "BLTK",
        "clearingBroker": "0443",
        "brokerName": "BULLTICK, LLC                                                         "
    },
    {
        "type": "CORP",
        "mpid": "BMKS",
        "clearingBroker": "0443",
        "brokerName": "BENCHMARK SECURITIES, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "BMSA",
        "clearingBroker": "0443",
        "brokerName": "MARIVA CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "BMSI",
        "clearingBroker": "0750",
        "brokerName": "BULL MARKET SECURITIES, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "BMUR",
        "clearingBroker": "0443",
        "brokerName": "BREAN CAPITAL, LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "BNBB",
        "clearingBroker": "0750",
        "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "BNCH",
        "clearingBroker": "0235",
        "brokerName": "THE BENCHMARK COMPANY, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "BNDI",
        "clearingBroker": "0443",
        "brokerName": "BERNARDI SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "BNDS",
        "clearingBroker": "0226",
        "brokerName": "MTS MARKETS INTERNATIONAL, INC                                        "
    },
    {
        "type": "CORP",
        "mpid": "BNJM",
        "clearingBroker": "0235",
        "brokerName": "BENJAMIN SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "BNPS",
        "clearingBroker": "2154",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "CORP",
        "mpid": "BNPX",
        "clearingBroker": "2154",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "CORP",
        "mpid": "BNTE",
        "clearingBroker": "0158",
        "brokerName": "BANORTE-IXE SECURITIES INTERNATIONAL, LTD.                            "
    },
    {
        "type": "CORP",
        "mpid": "BNYM",
        "clearingBroker": "8355",
        "brokerName": "BNYM/UIT NSCC CNS CLEARANCE                                           "
    },
    {
        "type": "CORP",
        "mpid": "BNYN",
        "clearingBroker": "0226",
        "brokerName": "BANYAN SECURITIES, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "BOFA",
        "clearingBroker": "0773",
        "brokerName": "BOFA SECURITIES, INC./FIXED INCOME                                    "
    },
    {
        "type": "CORP",
        "mpid": "BOKI",
        "clearingBroker": "0443",
        "brokerName": "BOSC, INC.                                                            "
    },
    {
        "type": "CORP",
        "mpid": "BOLL",
        "clearingBroker": "0279",
        "brokerName": "BODELL OVERCASH ANDERSON & CO.                                        "
    },
    {
        "type": "CORP",
        "mpid": "BOSE",
        "clearingBroker": "0443",
        "brokerName": "BOE SECURITIES INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "BOSS",
        "clearingBroker": "0158",
        "brokerName": "ALL TIME ATS                                                          "
    },
    {
        "type": "CORP",
        "mpid": "BOTS",
        "clearingBroker": "0052",
        "brokerName": "C A BOTZUM & CO                                                       "
    },
    {
        "type": "CORP",
        "mpid": "BPWP",
        "clearingBroker": "0226",
        "brokerName": "BUTTONWOOD PARTNERS, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "BRAD",
        "clearingBroker": "0443",
        "brokerName": "BERNARD HEROLD & CO                                                   "
    },
    {
        "type": "CORP",
        "mpid": "BRAZ",
        "clearingBroker": "0279",
        "brokerName": "BRAZOS SECURITIES INC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "BRBR",
        "clearingBroker": "0279",
        "brokerName": "BROWN AND BROWN SECURITIES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "BRCY",
        "clearingBroker": "0443",
        "brokerName": "BCP SECURITIES, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "BRGE",
        "clearingBroker": "0052",
        "brokerName": "NEWBRIDGE SECURITIES CORPORATION                                      "
    },
    {
        "type": "CORP",
        "mpid": "BRLI",
        "clearingBroker": "0226",
        "brokerName": "BROWN, LISLE/CUMMINGS, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "BRNK",
        "clearingBroker": "0226",
        "brokerName": "BRINKER CAPITAL SECURITIES, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "BROC",
        "clearingBroker": "0443",
        "brokerName": "PAVILION GLOBAL MARKETS LTD                                           "
    },
    {
        "type": "CORP",
        "mpid": "BRRR",
        "clearingBroker": "8199",
        "brokerName": "BARRINGTON RESEARCH ASSOCIATES, INC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "BRSA",
        "clearingBroker": "0103",
        "brokerName": "BOURSA INVESTMENT                                                     "
    },
    {
        "type": "CORP",
        "mpid": "BRSE",
        "clearingBroker": "0226",
        "brokerName": "BRADESCO SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "BRVL",
        "clearingBroker": "0443",
        "brokerName": "BLAYLOCK BEAL VAN, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "BRWM",
        "clearingBroker": "0226",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "CORP",
        "mpid": "BSCM",
        "clearingBroker": "0052",
        "brokerName": "BROAD STREET CAPITAL MARKETS, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "BSPI",
        "clearingBroker": "0235",
        "brokerName": "BALANCED SECURITY PLANNING, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "BTCK",
        "clearingBroker": "0158",
        "brokerName": "BULLTICK, LLC                                                         "
    },
    {
        "type": "CORP",
        "mpid": "BTDG",
        "clearingBroker": "0161",
        "brokerName": "BIDS TRADING LP                                                       "
    },
    {
        "type": "CORP",
        "mpid": "BTIM",
        "clearingBroker": "1043",
        "brokerName": "BTIG, LLC                                                             "
    },
    {
        "type": "CORP",
        "mpid": "BTIS",
        "clearingBroker": "0443",
        "brokerName": "BTIG, LLC                                                             "
    },
    {
        "type": "CORP",
        "mpid": "BTSS",
        "clearingBroker": "0279",
        "brokerName": "HILLTOP SECURITIES INDEPENDENT NETWORK INC.                           "
    },
    {
        "type": "CORP",
        "mpid": "BURK",
        "clearingBroker": "0141",
        "brokerName": "BURKE, LAWTON, BREWER & BURKE                                         "
    },
    {
        "type": "CORP",
        "mpid": "BURT",
        "clearingBroker": "0725",
        "brokerName": "HARBOR FINANCIAL SERVICES, L.L.C.                                     "
    },
    {
        "type": "CORP",
        "mpid": "BWNA",
        "clearingBroker": "0235",
        "brokerName": "BROWN ASSOCIATES INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "BYAI",
        "clearingBroker": "0226",
        "brokerName": "BRECEK & YOUNG                                                        "
    },
    {
        "type": "CORP",
        "mpid": "BZCP",
        "clearingBroker": "0443",
        "brokerName": "BALANZ CAPITAL USA LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "BZTN",
        "clearingBroker": "0141",
        "brokerName": "ALLIANT SECURITIES, INC. TURNER, NORD, KIENBAUM                       "
    },
    {
        "type": "CORP",
        "mpid": "BZWV",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "BZYD",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "BZYF",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "CABA",
        "clearingBroker": "0443",
        "brokerName": "CABRERA CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "CABR",
        "clearingBroker": "0161",
        "brokerName": "CABRERA CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "CADG",
        "clearingBroker": "0005",
        "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "CADZ",
        "clearingBroker": "0279",
        "brokerName": "CADZ SECURITIES INC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CAFS",
        "clearingBroker": "0158",
        "brokerName": "COMMUNITYAMERICA FINANCIAL SOLUTIONS, LLC                             "
    },
    {
        "type": "CORP",
        "mpid": "CAGI",
        "clearingBroker": "0279",
        "brokerName": "CRESCENT SECURITIES GROUP, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "CAIX",
        "clearingBroker": "0235",
        "brokerName": "CAIS CAPITAL LLC                                                      "
    },
    {
        "type": "CORP",
        "mpid": "CALD",
        "clearingBroker": "0103",
        "brokerName": "CALDWELL SUTTER CAPITAL, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "CALT",
        "clearingBroker": "0279",
        "brokerName": "CALTON & ASSOCIATES                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CAMS",
        "clearingBroker": "0443",
        "brokerName": "COMPREHENSIVE ASSET MANAGEMENT AND SERVICING, INC.                    "
    },
    {
        "type": "CORP",
        "mpid": "CANA",
        "clearingBroker": "0443",
        "brokerName": "CANACCORD GENUITY INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "CANT",
        "clearingBroker": "0696",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "CORP",
        "mpid": "CAPC",
        "clearingBroker": "0235",
        "brokerName": "CAPITAL CITY SECURITIES, LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "CAPE",
        "clearingBroker": "0279",
        "brokerName": "CAPE SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "CAPF",
        "clearingBroker": "0443",
        "brokerName": "CAPITAL FINANCIAL SERVICES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "CAPP",
        "clearingBroker": "0443",
        "brokerName": "CAPTRUST FINANCIAL ADVISORS                                           "
    },
    {
        "type": "CORP",
        "mpid": "CARG",
        "clearingBroker": "0141",
        "brokerName": "CARTHAGE GROUP INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CART",
        "clearingBroker": "0443",
        "brokerName": "CARTY & COMPANY, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "CARY",
        "clearingBroker": "0141",
        "brokerName": "CARY STREET PARTNERS                                                  "
    },
    {
        "type": "CORP",
        "mpid": "CASH",
        "clearingBroker": "0158",
        "brokerName": "PLANNER SECURITIES LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "CATE",
        "clearingBroker": "0235",
        "brokerName": "CARTER, TERRY & COMPANY, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "CAVU",
        "clearingBroker": "0443",
        "brokerName": "CAVU SECURITIES LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CBEV",
        "clearingBroker": "0226",
        "brokerName": "CITY NATIONAL BANK, BEVERLY HILLS, CALIFORNIA                         "
    },
    {
        "type": "CORP",
        "mpid": "CBII",
        "clearingBroker": "0443",
        "brokerName": "WESBANCO SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "CBIN",
        "clearingBroker": "0443",
        "brokerName": "COMPASS BROKERAGE, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "CBOL",
        "clearingBroker": "0226",
        "brokerName": "MUTUAL SECURITIES, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "CBSE",
        "clearingBroker": "1043",
        "brokerName": "CAMBRIDGE INTERNATIONAL SECURITIES, LLC                               "
    },
    {
        "type": "CORP",
        "mpid": "CBTD",
        "clearingBroker": "0226",
        "brokerName": "SYNOVOUS SECURITIES INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "CCCO",
        "clearingBroker": "0226",
        "brokerName": "CARNES CAPITAL CORPORATION                                            "
    },
    {
        "type": "CORP",
        "mpid": "CCIG",
        "clearingBroker": "0235",
        "brokerName": "CINCAP INVESTMENT GROUP, INC                                          "
    },
    {
        "type": "CORP",
        "mpid": "CCMB",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "CCMC",
        "clearingBroker": "0443",
        "brokerName": "COMMERZEBANK CAPITAL CORP.                                            "
    },
    {
        "type": "CORP",
        "mpid": "CCMI",
        "clearingBroker": "0443",
        "brokerName": "JMP SECURITIES LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CCMM",
        "clearingBroker": "0235",
        "brokerName": "CRAFT CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "CCPM",
        "clearingBroker": "0595",
        "brokerName": "CAMBRIA CAPITAL, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "CCRD",
        "clearingBroker": "0443",
        "brokerName": "CONCORDE INVESTMENT SERVICES, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "CCSS",
        "clearingBroker": "0443",
        "brokerName": "CROWN CAPITAL SECURITIES, L.P.                                        "
    },
    {
        "type": "CORP",
        "mpid": "CDFS",
        "clearingBroker": "0052",
        "brokerName": "NAVIAN CAPITAL SECURITIES, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "CDGO",
        "clearingBroker": "0551",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "CERS",
        "clearingBroker": "0226",
        "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "CFCO",
        "clearingBroker": "7311",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "CORP",
        "mpid": "CFCS",
        "clearingBroker": "0005",
        "brokerName": "CANTOR FITZGERALD & CO                                                "
    },
    {
        "type": "CORP",
        "mpid": "CFGM",
        "clearingBroker": "0235",
        "brokerName": "TRUSTMONT FINANCIAL GROUP, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "CFGT",
        "clearingBroker": "0235",
        "brokerName": "CF GLOBAL TRADING, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "CFII",
        "clearingBroker": "0235",
        "brokerName": "CONSOLIDATED FINANCIAL INVESTMENTS, INC.                              "
    },
    {
        "type": "CORP",
        "mpid": "CFIN",
        "clearingBroker": "0279",
        "brokerName": "CHELSEA FINANCIAL SERVICES                                            "
    },
    {
        "type": "CORP",
        "mpid": "CFSC",
        "clearingBroker": "0443",
        "brokerName": "INSIGNEO SECURITIES LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "CFSI",
        "clearingBroker": "0052",
        "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "CFSX",
        "clearingBroker": "0794",
        "brokerName": "CF SECURED, LLC                                                       "
    },
    {
        "type": "CORP",
        "mpid": "CGAM",
        "clearingBroker": "0443",
        "brokerName": "CGIS SECURITIES LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CGAT",
        "clearingBroker": "0443",
        "brokerName": "CADARET, GRANT & CO., INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "CGCO",
        "clearingBroker": "0443",
        "brokerName": "CG COMPASS (USA) LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "CGLN",
        "clearingBroker": "0103",
        "brokerName": "COUGHLIN & CO                                                         "
    },
    {
        "type": "CORP",
        "mpid": "CGMI",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "CGWM",
        "clearingBroker": "0443",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "CHAS",
        "clearingBroker": "0164",
        "brokerName": "CHARLES SCHWAB & CO., INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "CHBC",
        "clearingBroker": "0235",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "CHCH",
        "clearingBroker": "0226",
        "brokerName": "CHURCHILL FINANCIAL, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "CHCK",
        "clearingBroker": "0226",
        "brokerName": "CHICKASAW SECURITIES, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "CHDA",
        "clearingBroker": "0141",
        "brokerName": "CHAPIN, DAVIS                                                         "
    },
    {
        "type": "CORP",
        "mpid": "CHHS",
        "clearingBroker": "0141",
        "brokerName": "CHESTER HARRIS & CO., INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "CHLC",
        "clearingBroker": "0443",
        "brokerName": "CHURCHILL CAPITAL USA, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "CHPP",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "CHRS",
        "clearingBroker": "0750",
        "brokerName": "ROYAL TREASURE SECURITIES LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "CHSI",
        "clearingBroker": "0187",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "CHUB",
        "clearingBroker": "0226",
        "brokerName": "OSAIC FS, INC.                                                        "
    },
    {
        "type": "CORP",
        "mpid": "CICC",
        "clearingBroker": "0443",
        "brokerName": "CICC US SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "CICI",
        "clearingBroker": "0443",
        "brokerName": "COMMERCE BANK INVESTMENT SERVICES, INC.                               "
    },
    {
        "type": "CORP",
        "mpid": "CICL",
        "clearingBroker": "0141",
        "brokerName": "CAROLINAS INVESTMENT CONSULTING                                       "
    },
    {
        "type": "CORP",
        "mpid": "CIIV",
        "clearingBroker": "0052",
        "brokerName": "CORPORATE INVESTMENTS GROUP, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "CIMB",
        "clearingBroker": "0005",
        "brokerName": "CIMB SECURITIES (USA), INC                                            "
    },
    {
        "type": "CORP",
        "mpid": "CIRI",
        "clearingBroker": "0443",
        "brokerName": "CAMBRIDGE INVESTMENT RESEARCH, INC.                                   "
    },
    {
        "type": "CORP",
        "mpid": "CIST",
        "clearingBroker": "0161",
        "brokerName": "CAPITAL INSTITUTIONAL SERVICES, INC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "CISV",
        "clearingBroker": "0226",
        "brokerName": "CITIZENS SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "CJSC",
        "clearingBroker": "0443",
        "brokerName": "CJS SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "CLDN",
        "clearingBroker": "0235",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "CLRK",
        "clearingBroker": "0235",
        "brokerName": "CLARK DODGE & CO, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "CLRT",
        "clearingBroker": "1043",
        "brokerName": "ARBOR RESEARCH & TRADING, LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "CLSA",
        "clearingBroker": "0161",
        "brokerName": "CLSA AMERICAS, LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "CLSC",
        "clearingBroker": "0235",
        "brokerName": "CABOT LODGE SECURITIES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "CLSS",
        "clearingBroker": "0235",
        "brokerName": "CABOT LODGE SECURITIES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "CLTN",
        "clearingBroker": "0226",
        "brokerName": "CALTON & ASSOCIATES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "CMCE",
        "clearingBroker": "0226",
        "brokerName": "COMMERCE BROKERAGE SERVICES                                           "
    },
    {
        "type": "CORP",
        "mpid": "CMCX",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
    },
    {
        "type": "CORP",
        "mpid": "CMFS",
        "clearingBroker": "0443",
        "brokerName": "BNY MELLON CAP MKTS                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CMGF",
        "clearingBroker": "0443",
        "brokerName": "CMG SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "CMMW",
        "clearingBroker": "0226",
        "brokerName": "COMMONWEALTH FINANCIAL NETWORK                                        "
    },
    {
        "type": "CORP",
        "mpid": "CMPT",
        "clearingBroker": "0750",
        "brokerName": "COMPASS POINT RESEARCH & TRADING, LLC                                 "
    },
    {
        "type": "CORP",
        "mpid": "CMSI",
        "clearingBroker": "0279",
        "brokerName": "CAPITAL MANAGEMENT SECURITIES, INC.                                   "
    },
    {
        "type": "CORP",
        "mpid": "CNCD",
        "clearingBroker": "0235",
        "brokerName": "CONCORDE INVESTMENT SERVICES, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "CNFI",
        "clearingBroker": "0443",
        "brokerName": "CENTAURUS FINANCIAL INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "CNFR",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "CNSI",
        "clearingBroker": "0226",
        "brokerName": "CITY NATIONAL SECURITIES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "CNTR",
        "clearingBroker": "0103",
        "brokerName": "PRECISION SECURITIES                                                  "
    },
    {
        "type": "CORP",
        "mpid": "COAK",
        "clearingBroker": "0443",
        "brokerName": "CASTLE OAK SECURITIES, L.P.                                           "
    },
    {
        "type": "CORP",
        "mpid": "COAS",
        "clearingBroker": "0443",
        "brokerName": "REALTA EQUITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "CODA",
        "clearingBroker": "0161",
        "brokerName": "CODA MARKETS, INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "COEI",
        "clearingBroker": "0052",
        "brokerName": "COASTAL EQUITIES, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "COEX",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "COFS",
        "clearingBroker": "0279",
        "brokerName": "COLORADO FINANCIAL SERVICE CORPORATION                                "
    },
    {
        "type": "CORP",
        "mpid": "COHN",
        "clearingBroker": "0235",
        "brokerName": "COHEN BROS. & COMPANY                                                 "
    },
    {
        "type": "CORP",
        "mpid": "COKE",
        "clearingBroker": "0235",
        "brokerName": "COKER & PALMER, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "COLS",
        "clearingBroker": "0279",
        "brokerName": "COLONIAL SECURITIES INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "COMP",
        "clearingBroker": "0595",
        "brokerName": "COMPASS POINT RESEARCH & TRADING, LLC                                 "
    },
    {
        "type": "CORP",
        "mpid": "CONI",
        "clearingBroker": "0235",
        "brokerName": "CONTINENTAL INVESTORS SERVICES, INC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "CONR",
        "clearingBroker": "0235",
        "brokerName": "CONNERS & CO., INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CONS",
        "clearingBroker": "0141",
        "brokerName": "CONSULTIVA SECURITIES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "COOR",
        "clearingBroker": "0141",
        "brokerName": "COORDINATED CAPITAL SECURITIES, INC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "COSL",
        "clearingBroker": "0443",
        "brokerName": "CLIENT ONE SECURITIES, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "COWN",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "COWP",
        "clearingBroker": "0226",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "COWR",
        "clearingBroker": "0443",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "COWX",
        "clearingBroker": "0161",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "COYL",
        "clearingBroker": "0235",
        "brokerName": "COYLE SECURITIES LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "CPGL",
        "clearingBroker": "0226",
        "brokerName": "CONTINUITY PARTNERS GROUP, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "CPLC",
        "clearingBroker": "0595",
        "brokerName": "COVA CAPITAL PARTNERS LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "CPRC",
        "clearingBroker": "0235",
        "brokerName": "CORINTHIAN PARTNERS, L.L.C.                                           "
    },
    {
        "type": "CORP",
        "mpid": "CPRM",
        "clearingBroker": "8199",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "CRCM",
        "clearingBroker": "0235",
        "brokerName": "COHNREZNICK CAPITAL                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CRDL",
        "clearingBroker": "0235",
        "brokerName": "CARDINAL INVESTMENTS, INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "CRED",
        "clearingBroker": "0443",
        "brokerName": "CREDICORP CAPITAL LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "CREF",
        "clearingBroker": "0443",
        "brokerName": "TIAA-CREF INDIVIDUAL AND INSTITUTIONAL SERVICES, LLC                  "
    },
    {
        "type": "CORP",
        "mpid": "CREW",
        "clearingBroker": "0443",
        "brokerName": "CREWS & ASSOCIATES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "CRFN",
        "clearingBroker": "6769",
        "brokerName": "ROBINHOOD FINANCIAL, LLC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "CRII",
        "clearingBroker": "0443",
        "brokerName": "CRI SECURITIES INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CRNJ",
        "clearingBroker": "0103",
        "brokerName": "CANTONE RESEARCH                                                      "
    },
    {
        "type": "CORP",
        "mpid": "CRON",
        "clearingBroker": "0443",
        "brokerName": "CRONIN & CO., INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "CRPT",
        "clearingBroker": "0235",
        "brokerName": "CROSS POINT CAPITAL LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "CRTH",
        "clearingBroker": "0443",
        "brokerName": "CORINTHIAN PARTNERS, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "CRYN",
        "clearingBroker": "0235",
        "brokerName": "BRENDAN E. CRYAN AND COMPANY, L.L.C.                                  "
    },
    {
        "type": "CORP",
        "mpid": "CSAI",
        "clearingBroker": "0793",
        "brokerName": "STIFEL INDEPENDENT ADVISORS, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "CSAP",
        "clearingBroker": "0141",
        "brokerName": "CRESAP, INC.                                                          "
    },
    {
        "type": "CORP",
        "mpid": "CSCA",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "CORP",
        "mpid": "CSCM",
        "clearingBroker": "0279",
        "brokerName": "CENTRAL STATES CAPITAL MARKETS, LLC                                   "
    },
    {
        "type": "CORP",
        "mpid": "CSPA",
        "clearingBroker": "0226",
        "brokerName": "CREDIT SUISSE PRIVATE ADVISORS                                        "
    },
    {
        "type": "CORP",
        "mpid": "CSPD",
        "clearingBroker": "0197",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "CORP",
        "mpid": "CSPI",
        "clearingBroker": "0235",
        "brokerName": "CAPITAL SYNERGY PARTNERS                                              "
    },
    {
        "type": "CORP",
        "mpid": "CSTI",
        "clearingBroker": "0161",
        "brokerName": "CANACCORD GENUITY INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "CTAS",
        "clearingBroker": "0443",
        "brokerName": "OSAIC INSTITUTIONS, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "CTBK",
        "clearingBroker": "4270",
        "brokerName": "CENTRAL TRUST BANK                                                    "
    },
    {
        "type": "CORP",
        "mpid": "CTDL",
        "clearingBroker": "0551",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "CTDN",
        "clearingBroker": "0352",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "CTNL",
        "clearingBroker": "0235",
        "brokerName": "CENTENNIAL SECURITIES COMPANY LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "CTSC",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "CORP",
        "mpid": "CUFT",
        "clearingBroker": "0226",
        "brokerName": "FROST BROKERAGE SERVICES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "CUGS",
        "clearingBroker": "8199",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "CULL",
        "clearingBroker": "0725",
        "brokerName": "CULLEN INVESTMENT GROUP, LTD.                                         "
    },
    {
        "type": "CORP",
        "mpid": "CUSO",
        "clearingBroker": "0443",
        "brokerName": "CUSO FINANCIAL SERVICES, L.P.                                         "
    },
    {
        "type": "CORP",
        "mpid": "CUTW",
        "clearingBroker": "0235",
        "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "CUWB",
        "clearingBroker": "0103",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "CVGP",
        "clearingBroker": "0443",
        "brokerName": "COWEN AND COMPANY LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "CWEI",
        "clearingBroker": "0443",
        "brokerName": "BEECH HILL SECURITIES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "CWMK",
        "clearingBroker": "0438",
        "brokerName": "CIBC WORLD MARKETS CORP.                                              "
    },
    {
        "type": "CORP",
        "mpid": "CYND",
        "clearingBroker": "0443",
        "brokerName": "TIGRESS FINANCIAL PARTNERS LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "DADA",
        "clearingBroker": "0361",
        "brokerName": "D. A. DAVIDSON & CO.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DAII",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER (DON) INVESTMENTS, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "DAIN",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "DAIS",
        "clearingBroker": "0052",
        "brokerName": "DAI SECURITIES, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "DARA",
        "clearingBroker": "0235",
        "brokerName": "DARWOOD ASSOCIATES, INC                                               "
    },
    {
        "type": "CORP",
        "mpid": "DART",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DASH",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "DAVA",
        "clearingBroker": "0443",
        "brokerName": "DAVENPORT & COMPANY LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "DAWA",
        "clearingBroker": "0647",
        "brokerName": "DAIWA CAPITAL MARKETS AMERICA INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "DBCC",
        "clearingBroker": "0235",
        "brokerName": "D. BORAL CAPITAL                                                      "
    },
    {
        "type": "CORP",
        "mpid": "DBCH",
        "clearingBroker": "0052",
        "brokerName": "D. BORAL CAPITAL                                                      "
    },
    {
        "type": "CORP",
        "mpid": "DBKS",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "DBPC",
        "clearingBroker": "0443",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "DCAN",
        "clearingBroker": "0279",
        "brokerName": "R. M. DUNCAN SECURITIES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "DCSD",
        "clearingBroker": "0235",
        "brokerName": "DAIN CORRESPONDENT SERVICES                                           "
    },
    {
        "type": "CORP",
        "mpid": "DCVL",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DEAN",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "DEGS",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DENI",
        "clearingBroker": "0279",
        "brokerName": "H.C. DENISON CO.                                                      "
    },
    {
        "type": "CORP",
        "mpid": "DETF",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DFIN",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "DFPG",
        "clearingBroker": "0235",
        "brokerName": "DFPG INVESTMENTS, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "DIGG",
        "clearingBroker": "0595",
        "brokerName": "BOUSTEAD SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "DINO",
        "clearingBroker": "0103",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "CORP",
        "mpid": "DJSA",
        "clearingBroker": "0750",
        "brokerName": "DAWSON JAMES SECURITIES, INC                                          "
    },
    {
        "type": "CORP",
        "mpid": "DLAI",
        "clearingBroker": "0235",
        "brokerName": "DAVID LERNER ASSOCIATES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "DLPS",
        "clearingBroker": "0595",
        "brokerName": "DLP SECURITIES,.LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "DLSI",
        "clearingBroker": "0226",
        "brokerName": "DEMPSEY LORD SMITH, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "DMCD",
        "clearingBroker": "0279",
        "brokerName": "MCDERMOTT INVESTMENT SERVICES, LLC                                    "
    },
    {
        "type": "CORP",
        "mpid": "DMKC",
        "clearingBroker": "0141",
        "brokerName": "D.M. KELLY & COMPANY                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DNOR",
        "clearingBroker": "0005",
        "brokerName": "DNB MARKETS, INC.                                                     "
    },
    {
        "type": "CORP",
        "mpid": "DNSR",
        "clearingBroker": "0158",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "CORP",
        "mpid": "DNWL",
        "clearingBroker": "0443",
        "brokerName": "DUNCAN & WILLIAMS, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "DOFT",
        "clearingBroker": "0443",
        "brokerName": "DOFT & CO., INC.                                                      "
    },
    {
        "type": "CORP",
        "mpid": "DOMI",
        "clearingBroker": "0279",
        "brokerName": "DOMINION INVESTOR SERVICES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "DOMS",
        "clearingBroker": "0235",
        "brokerName": "DOMINARI SECURITIES LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "DORN",
        "clearingBroker": "0235",
        "brokerName": "DORN & CO., INC.                                                      "
    },
    {
        "type": "CORP",
        "mpid": "DOTC",
        "clearingBroker": "0226",
        "brokerName": "COLLIERS SECURITIES LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "DOVE",
        "clearingBroker": "0226",
        "brokerName": "SECURITIES EQUITY GROUP                                               "
    },
    {
        "type": "CORP",
        "mpid": "DOWL",
        "clearingBroker": "0443",
        "brokerName": "DOWLING & PARTNERS SECURITIES LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "DREX",
        "clearingBroker": "0443",
        "brokerName": "DREXEL HAMILTON, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DRSC",
        "clearingBroker": "0443",
        "brokerName": "BNY MELLON SECURITIES CORPORATION                                     "
    },
    {
        "type": "CORP",
        "mpid": "DRTG",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DRTR",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DRVW",
        "clearingBroker": "0235",
        "brokerName": "DRIVEWEALTH, LLC                                                      "
    },
    {
        "type": "CORP",
        "mpid": "DRWM",
        "clearingBroker": "0005",
        "brokerName": "DRW SECURITIES, L.L.C.                                                "
    },
    {
        "type": "CORP",
        "mpid": "DSAI",
        "clearingBroker": "0443",
        "brokerName": "DAEWOO SECURITIES (AMERICA) INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "DSGG",
        "clearingBroker": "0226",
        "brokerName": "DMG SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DTEX",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
    },
    {
        "type": "CORP",
        "mpid": "DUST",
        "clearingBroker": "0161",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "DVES",
        "clearingBroker": "0005",
        "brokerName": "DV EQUITIES                                                           "
    },
    {
        "type": "CORP",
        "mpid": "DWIZ",
        "clearingBroker": "0235",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "EAMC",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
    },
    {
        "type": "CORP",
        "mpid": "EAMG",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
    },
    {
        "type": "CORP",
        "mpid": "EBKD",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL, L.P.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "EBKR",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "EBRD",
        "clearingBroker": "0103",
        "brokerName": "EARLYBIRD CAPITAL, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "ECCC",
        "clearingBroker": "0226",
        "brokerName": "EAGLES COAST CAPITAL, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "EDFC",
        "clearingBroker": "0443",
        "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "EDFO",
        "clearingBroker": "0158",
        "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "EDIR",
        "clearingBroker": "0235",
        "brokerName": "EDI FINANCIAL, INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "EDJO",
        "clearingBroker": "0057",
        "brokerName": "EDWARD D. JONES & CO.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "EFGC",
        "clearingBroker": "0443",
        "brokerName": "EFG CAPITAL INTERNATIONAL                                             "
    },
    {
        "type": "CORP",
        "mpid": "EFSP",
        "clearingBroker": "0443",
        "brokerName": "ESSEX FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "EGLE",
        "clearingBroker": "1043",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "CORP",
        "mpid": "EGMT",
        "clearingBroker": "0005",
        "brokerName": "EG MARKET TECHNOLOGIES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "ELEQ",
        "clearingBroker": "0551",
        "brokerName": "ELEQUIN SECURITIES LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "ELET",
        "clearingBroker": "0388",
        "brokerName": "ELECTRONIFIE SECURITIES LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "ELEV",
        "clearingBroker": "0235",
        "brokerName": "ELEVATION, LLC                                                        "
    },
    {
        "type": "CORP",
        "mpid": "ELQN",
        "clearingBroker": "0443",
        "brokerName": "ELEQUIN SECURITIES LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "EMER",
        "clearingBroker": "0443",
        "brokerName": "EMERSON EQUITY LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "EMOC",
        "clearingBroker": "0750",
        "brokerName": "E. MAGNUS OPPENHIEM & CO. INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "EMPR",
        "clearingBroker": "0279",
        "brokerName": "SELKIRK INVESTMENTS, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "EMRP",
        "clearingBroker": "0161",
        "brokerName": "EMPIRICAL RESEARCH PARTNERS LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "ENTR",
        "clearingBroker": "0235",
        "brokerName": "ENTRUSTODY FINANCIAL, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "EPIC",
        "clearingBroker": "0443",
        "brokerName": "EPIC CAPITAL SECURITIES                                               "
    },
    {
        "type": "CORP",
        "mpid": "EQHA",
        "clearingBroker": "0075",
        "brokerName": "EQUITABLE ADVISORS, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "EQSV",
        "clearingBroker": "0226",
        "brokerName": "EQUITY SERVICES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "EROP",
        "clearingBroker": "0158",
        "brokerName": "EROOM SECURITIES LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "ESBD",
        "clearingBroker": "0235",
        "brokerName": "EASTDIL SECURED ADVISORS LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "ESHC",
        "clearingBroker": "0443",
        "brokerName": "FIRST SOUTHERN, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "ETCB",
        "clearingBroker": "3505",
        "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "ETCL",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "ETRF",
        "clearingBroker": "0161",
        "brokerName": "G1 EXECUTION SERVICES, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "ETRS",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "EUBR",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "EVOL",
        "clearingBroker": "0226",
        "brokerName": "EVOLVE SECURITIES, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "EWMX",
        "clearingBroker": "0279",
        "brokerName": "EAST WEST MARKETS, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "EXCS",
        "clearingBroker": "0443",
        "brokerName": "EXCEL SECURITIES AND ASSOCIATES, INC.                                 "
    },
    {
        "type": "CORP",
        "mpid": "FAFI",
        "clearingBroker": "0279",
        "brokerName": "FIRST ASSET FINANCIAL                                                 "
    },
    {
        "type": "CORP",
        "mpid": "FALC",
        "clearingBroker": "0103",
        "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "FALL",
        "clearingBroker": "0725",
        "brokerName": "FALLLINE SECURITIES LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "FANC",
        "clearingBroker": "0235",
        "brokerName": "FINANCE 500, INC.                                                     "
    },
    {
        "type": "CORP",
        "mpid": "FARA",
        "clearingBroker": "8199",
        "brokerName": "FARINA & ASSOCIATES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "FATS",
        "clearingBroker": "0443",
        "brokerName": "FIRST BROKERS SECURITIES LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "FBLM",
        "clearingBroker": "0235",
        "brokerName": "FBL MARKETING SERVICES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "FBLT",
        "clearingBroker": "8199",
        "brokerName": "FIRST BALLANTYNE, LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "FBNS",
        "clearingBroker": "0235",
        "brokerName": "FBN SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "FBPC",
        "clearingBroker": "0443",
        "brokerName": "CREDIT SUISSE SECURITIES (USA) LLC                                    "
    },
    {
        "type": "CORP",
        "mpid": "FBSB",
        "clearingBroker": "0280",
        "brokerName": "U.S. BANCORP INVESTMENTS, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "FCFP",
        "clearingBroker": "0141",
        "brokerName": "FIRST CITIZENS FINANCIAL PLUS, INC.                                   "
    },
    {
        "type": "CORP",
        "mpid": "FCFS",
        "clearingBroker": "0443",
        "brokerName": "FIRST COMMAND FINANCIAL PLANNING, INC.                                "
    },
    {
        "type": "CORP",
        "mpid": "FCGB",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL, L.P.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "FCIT",
        "clearingBroker": "0443",
        "brokerName": "FIRST CITIZENS INVESTOR SERVICES, INC.                                "
    },
    {
        "type": "CORP",
        "mpid": "FCML",
        "clearingBroker": "0279",
        "brokerName": "FNBB CAPITAL MARKETS, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "FCMP",
        "clearingBroker": "0595",
        "brokerName": "PRIME EXECUTIONS, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "FCST",
        "clearingBroker": "0443",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "FDSC",
        "clearingBroker": "0158",
        "brokerName": "1ST DISCOUNT BROKERAGE INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "FDSI",
        "clearingBroker": "0141",
        "brokerName": "FIRST DALLAS SECURITIES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "FEDR",
        "clearingBroker": "0235",
        "brokerName": "FEDERATED SECURITIES INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "FENX",
        "clearingBroker": "0595",
        "brokerName": "FENIX SECURITIES, LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "FERN",
        "clearingBroker": "0443",
        "brokerName": "FEARNLEY SECURITIES                                                   "
    },
    {
        "type": "CORP",
        "mpid": "FFCM",
        "clearingBroker": "0235",
        "brokerName": "FOREFRONT CAPITAL MARKETS LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "FFGI",
        "clearingBroker": "0235",
        "brokerName": "FELDSTEIN FINANCIAL GROUP, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "FFSI",
        "clearingBroker": "0158",
        "brokerName": "FIRSTRADE SECURITIES INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "FHCI",
        "clearingBroker": "0443",
        "brokerName": "FIRST HEARTLAND CAPITAL, INC                                          "
    },
    {
        "type": "CORP",
        "mpid": "FHON",
        "clearingBroker": "0235",
        "brokerName": "FIRST HONOLULU SECURITIES INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "FIBS",
        "clearingBroker": "0226",
        "brokerName": "FIDELITY BROKERAGE SERVICES LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "FISA",
        "clearingBroker": "0443",
        "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "FISB",
        "clearingBroker": "0226",
        "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "FISH",
        "clearingBroker": "0235",
        "brokerName": "L.B. FISHER & COMPANY                                                 "
    },
    {
        "type": "CORP",
        "mpid": "FJRF",
        "clearingBroker": "0052",
        "brokerName": "PARITER SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "FKSC",
        "clearingBroker": "0235",
        "brokerName": "FIRST KENTUCKY SECURITIES CORP.                                       "
    },
    {
        "type": "CORP",
        "mpid": "FLAT",
        "clearingBroker": "0226",
        "brokerName": "FLORIDA ATLANTIC SECURITIES CORP.                                     "
    },
    {
        "type": "CORP",
        "mpid": "FLCO",
        "clearingBroker": "0750",
        "brokerName": "THE FRAZER LANIER COMPANY, INCORPORATED                               "
    },
    {
        "type": "CORP",
        "mpid": "FLEX",
        "clearingBroker": "0158",
        "brokerName": "GWM GROUP, INC.                                                       "
    },
    {
        "type": "CORP",
        "mpid": "FLIB",
        "clearingBroker": "0235",
        "brokerName": "FIRST LIBERTIES FINANCIAL                                             "
    },
    {
        "type": "CORP",
        "mpid": "FLIO",
        "clearingBroker": "0750",
        "brokerName": "SANTOS CAPITAL GROUP, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "FLOU",
        "clearingBroker": "0443",
        "brokerName": "FIRST ST. LOUIS SECURITIES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "FLTG",
        "clearingBroker": "0005",
        "brokerName": "FLOW TRADERS U.S. LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "FLTL",
        "clearingBroker": "0235",
        "brokerName": "FELTL & COMPANY                                                       "
    },
    {
        "type": "CORP",
        "mpid": "FLTU",
        "clearingBroker": "0551",
        "brokerName": "FLOW TRADERS US LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "FLWT",
        "clearingBroker": "0161",
        "brokerName": "FLOW TRADERS U.S. INSTITUTIONAL TRADING LLC                           "
    },
    {
        "type": "CORP",
        "mpid": "FMAT",
        "clearingBroker": "0608",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "FMCO",
        "clearingBroker": "0443",
        "brokerName": "FIRST MANHATTAN CO.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "FMEX",
        "clearingBroker": "0750",
        "brokerName": "FINAMEX INTERNATIONAL, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "FMFS",
        "clearingBroker": "0226",
        "brokerName": "FISRT MERIT FINANCIAL SERVICES, INC                                   "
    },
    {
        "type": "CORP",
        "mpid": "FMGT",
        "clearingBroker": "0443",
        "brokerName": "FAMILY MANAGEMENT SECURITIES, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "FNFD",
        "clearingBroker": "0443",
        "brokerName": "FOLGER NOLAN FLEMING DOUGLAS INCORPORATED                             "
    },
    {
        "type": "CORP",
        "mpid": "FNIC",
        "clearingBroker": "0443",
        "brokerName": "FINANCIAL NETWORK INVESTMENT CORP.                                    "
    },
    {
        "type": "CORP",
        "mpid": "FNPN",
        "clearingBroker": "0443",
        "brokerName": "UNIVEST INVESTMENTS                                                   "
    },
    {
        "type": "CORP",
        "mpid": "FNSJ",
        "clearingBroker": "0443",
        "brokerName": "FINANCIAL NORTHEASTERN SECURITIES, INC.                               "
    },
    {
        "type": "CORP",
        "mpid": "FNXB",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL, L.P.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "FNXS",
        "clearingBroker": "0750",
        "brokerName": "FENIX SECURITIES, LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "FOGS",
        "clearingBroker": "0235",
        "brokerName": "FOG EQUITIES LLC                                                      "
    },
    {
        "type": "CORP",
        "mpid": "FORI",
        "clearingBroker": "0750",
        "brokerName": "FORTREND SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "FOXC",
        "clearingBroker": "0443",
        "brokerName": "FOX CHASE CAPITAL PARTNERS, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "FRLZ",
        "clearingBroker": "0103",
        "brokerName": "FRIEDMAN LUZZATTO & CO                                                "
    },
    {
        "type": "CORP",
        "mpid": "FRTN",
        "clearingBroker": "0103",
        "brokerName": "FORTUNE SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "FSCS",
        "clearingBroker": "0443",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "FSIX",
        "clearingBroker": "0725",
        "brokerName": "FSIC                                                                  "
    },
    {
        "type": "CORP",
        "mpid": "FSRP",
        "clearingBroker": "0443",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "FTEN",
        "clearingBroker": "0226",
        "brokerName": "FTB ADVISORS, INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "FTLP",
        "clearingBroker": "8244",
        "brokerName": "FIRST TRUST PORTFOLIOS, L.P.                                          "
    },
    {
        "type": "CORP",
        "mpid": "FTSC",
        "clearingBroker": "0202",
        "brokerName": "FHN FINANCIAL SECURITIES CORP.                                        "
    },
    {
        "type": "CORP",
        "mpid": "FTSR",
        "clearingBroker": "0226",
        "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "FUBO",
        "clearingBroker": "0443",
        "brokerName": "GRIFFINEST ASIA SECURITIES, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "FWSI",
        "clearingBroker": "0141",
        "brokerName": "FIRST WESTERN SECURITIES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "GABE",
        "clearingBroker": "0141",
        "brokerName": "G. RESEARCH, INC.                                                     "
    },
    {
        "type": "CORP",
        "mpid": "GAFI",
        "clearingBroker": "0235",
        "brokerName": "GARDNER FINANCIAL SERVICES INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "GAGN",
        "clearingBroker": "0226",
        "brokerName": "GAGNON SECURITIES, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "GAII",
        "clearingBroker": "0279",
        "brokerName": "GREAT AMERICAN INVESTORS, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "GARB",
        "clearingBroker": "0148",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
    },
    {
        "type": "CORP",
        "mpid": "GARC",
        "clearingBroker": "0161",
        "brokerName": "ICAP CORPORATES LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "GARE",
        "clearingBroker": "0148",
        "brokerName": "GARE                                                                  "
    },
    {
        "type": "CORP",
        "mpid": "GARR",
        "clearingBroker": "0226",
        "brokerName": "GARRETT NAGLE & CO., INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "GARW",
        "clearingBroker": "0595",
        "brokerName": "GAR WOOD SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "GBMS",
        "clearingBroker": "0158",
        "brokerName": "GBM INTERNATIONAL, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "GBMT",
        "clearingBroker": "0443",
        "brokerName": "GBM INTERNATIONAL, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "GBTS",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "GCMC",
        "clearingBroker": "0443",
        "brokerName": "GLADOWSKY CAPITAL MANAGEMENT CORP.                                    "
    },
    {
        "type": "CORP",
        "mpid": "GDCO",
        "clearingBroker": "0443",
        "brokerName": "GILBERT, DONIGER CO., INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "GELP",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "GENS",
        "clearingBroker": "0279",
        "brokerName": "GENERAL SECURITIES CORP                                               "
    },
    {
        "type": "CORP",
        "mpid": "GENW",
        "clearingBroker": "0443",
        "brokerName": "GENEOS WEALTH MANAGEMENT, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "GFIG",
        "clearingBroker": "0537",
        "brokerName": "GFI SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "GFSI",
        "clearingBroker": "0725",
        "brokerName": "GLOBAL FINANCIAL SERVICES, L.L.C.                                     "
    },
    {
        "type": "CORP",
        "mpid": "GGWI",
        "clearingBroker": "0141",
        "brokerName": "GAGE-WILEY & COMPANY INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "GHCC",
        "clearingBroker": "0226",
        "brokerName": "GORDON, HASKETT CAPITAL CORPORATION                                   "
    },
    {
        "type": "CORP",
        "mpid": "GILG",
        "clearingBroker": "0226",
        "brokerName": "GILDER GAGNON HOWE & CO. LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "GJSS",
        "clearingBroker": "0235",
        "brokerName": "SCHWARTZ, GREGORY J & CO. INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "GLCM",
        "clearingBroker": "0443",
        "brokerName": "GREENSLEDGE CAPITAL MARKETS                                           "
    },
    {
        "type": "CORP",
        "mpid": "GLLL",
        "clearingBroker": "0279",
        "brokerName": "GILL CAPITAL PARTNERS                                                 "
    },
    {
        "type": "CORP",
        "mpid": "GLYN",
        "clearingBroker": "0443",
        "brokerName": "GLYNN (J.A.) & CO.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "GMSE",
        "clearingBroker": "0750",
        "brokerName": "GAMMA SECURITIES, LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "GMSG",
        "clearingBroker": "0443",
        "brokerName": "GMS GROUP (THE), L.L.C.                                               "
    },
    {
        "type": "CORP",
        "mpid": "GPCA",
        "clearingBroker": "0158",
        "brokerName": "GREAT POINT CAPITAL LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "GPCG",
        "clearingBroker": "0443",
        "brokerName": "GREENMAN, PARKER, CONNALLY, GREENMAN, INC.                            "
    },
    {
        "type": "CORP",
        "mpid": "GPSS",
        "clearingBroker": "0443",
        "brokerName": "GREAT PACIFIC SECURITIES                                              "
    },
    {
        "type": "CORP",
        "mpid": "GRAD",
        "clearingBroker": "0235",
        "brokerName": "GRADIENT SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "GRBD",
        "clearingBroker": "0052",
        "brokerName": "GREENBIRD CAPITAL LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "GRIL",
        "clearingBroker": "0235",
        "brokerName": "GLOBAL RESOURCE INVESTMENTS, LTD.                                     "
    },
    {
        "type": "CORP",
        "mpid": "GROD",
        "clearingBroker": "0226",
        "brokerName": "GRODSKY ASSOCIATES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "GRPS",
        "clearingBroker": "0226",
        "brokerName": "MML INVESTORS SERVICES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "GRWD",
        "clearingBroker": "0052",
        "brokerName": "GAR WOOD SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "GRYG",
        "clearingBroker": "0226",
        "brokerName": "GOLDBERG (GARY) & CO., INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "GSBI",
        "clearingBroker": "0279",
        "brokerName": "GLOBAL BROKERAGE SERVICES, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "GSCO",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "GSIL",
        "clearingBroker": "0158",
        "brokerName": "GLOBAL STRATEGIC INVESTMENTS, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "GSMM",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "GSQQ",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "GSSC",
        "clearingBroker": "0161",
        "brokerName": "GEORGESON SHAREHOLDER SECURITIES CORP.                                "
    },
    {
        "type": "CORP",
        "mpid": "GSSI",
        "clearingBroker": "0052",
        "brokerName": "GARDEN STATE SECURITIES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "GSUU",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "GSVV",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "GTNB",
        "clearingBroker": "0595",
        "brokerName": "GTN AMERICAS FINANCIAL SERVICES, INC.                                 "
    },
    {
        "type": "CORP",
        "mpid": "GTSM",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "GWFS",
        "clearingBroker": "0443",
        "brokerName": "GWFS EQUITIES, INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "GWNS",
        "clearingBroker": "0443",
        "brokerName": "GWN SECURITIES INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "GZML",
        "clearingBroker": "0161",
        "brokerName": "GUZMAN & COMPANY                                                      "
    },
    {
        "type": "CORP",
        "mpid": "HAFS",
        "clearingBroker": "0279",
        "brokerName": "HANTZ FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "HALO",
        "clearingBroker": "0235",
        "brokerName": "HALO SECURITIES, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "HARB",
        "clearingBroker": "0443",
        "brokerName": "HARBOUR INVESTMENTS INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "HARC",
        "clearingBroker": "0235",
        "brokerName": "HARLEY CAPITAL LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "HARS",
        "clearingBroker": "8199",
        "brokerName": "HARVESTONS SECURITIES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "HAVK",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE STATE FINANCIAL, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "HAZL",
        "clearingBroker": "0226",
        "brokerName": "HAZLETT, BURT AND WATSON, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "HBCO",
        "clearingBroker": "0443",
        "brokerName": "GLOBAL INVESTOR SERVICES, L.C.                                        "
    },
    {
        "type": "CORP",
        "mpid": "HBUS",
        "clearingBroker": "0443",
        "brokerName": "HOLISTIC BROKERAGE, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "HCGC",
        "clearingBroker": "0103",
        "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "HCMX",
        "clearingBroker": "0235",
        "brokerName": "HOOPOE CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "HCTA",
        "clearingBroker": "0005",
        "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "HCWW",
        "clearingBroker": "0235",
        "brokerName": "H.C.WAINWRIGHT & CO., LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "HDVS",
        "clearingBroker": "0226",
        "brokerName": "AVANTAX INVESTMENT SERVICES, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "HEAD",
        "clearingBroker": "0443",
        "brokerName": "TD SECURITIES AUTOMATED TRADING LLC                                   "
    },
    {
        "type": "CORP",
        "mpid": "HEGS",
        "clearingBroker": "1043",
        "brokerName": "HEG SECURITIES, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "HENN",
        "clearingBroker": "0235",
        "brokerName": "CARL M. HENNIG, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "HENY",
        "clearingBroker": "0443",
        "brokerName": "HENLEY & COMPANY LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "HFLD",
        "clearingBroker": "0279",
        "brokerName": "HARTFIELD, TITUS & DONNELLY, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "HIAL",
        "clearingBroker": "0443",
        "brokerName": "HARBOR INVESTMENT ADVISORY, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "HIGG",
        "clearingBroker": "0235",
        "brokerName": "HIGGINS CAPITAL MANAGEMENT, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "HINO",
        "clearingBroker": "0235",
        "brokerName": "TRB CAPITAL MARKETS,LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "HITS",
        "clearingBroker": "0443",
        "brokerName": "HEIGHT SECURITIES, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "HJSC",
        "clearingBroker": "0443",
        "brokerName": "SIMS (HERBERT J.) & CO., INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "HNTR",
        "clearingBroker": "0443",
        "brokerName": "HUNTER ASSOCIATES, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "HONR",
        "clearingBroker": "0235",
        "brokerName": "ROBERTS & RYAN INVESTMENTS INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "HOOD",
        "clearingBroker": "6769",
        "brokerName": "ROBINHOOD SECURITIES, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "HOPK",
        "clearingBroker": "0750",
        "brokerName": "SILVER OAK SECURITIES, INCORPORATED                                   "
    },
    {
        "type": "CORP",
        "mpid": "HOTO",
        "clearingBroker": "0443",
        "brokerName": "HORNOR, TOWNSEND & KENT, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "HPOM",
        "clearingBroker": "0235",
        "brokerName": "HERNDON PLANT OAKLEY, LTD.                                            "
    },
    {
        "type": "CORP",
        "mpid": "HPWD",
        "clearingBroker": "0443",
        "brokerName": "PIPER SANDLER & CO.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "HRBF",
        "clearingBroker": "0756",
        "brokerName": "AMERICAN ENTERPRISE INVESTMENT SERVICES INC.                          "
    },
    {
        "type": "CORP",
        "mpid": "HRCO",
        "clearingBroker": "0103",
        "brokerName": "H RIVKIN & COMPANY                                                    "
    },
    {
        "type": "CORP",
        "mpid": "HRCS",
        "clearingBroker": "0443",
        "brokerName": "HRC INVESTMENT SERVICES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "HRGR",
        "clearingBroker": "0235",
        "brokerName": "HARGER AND COMPANY, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "HRRS",
        "clearingBroker": "0443",
        "brokerName": "HARRIS INVESTORS SERVICES, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "HSAI",
        "clearingBroker": "0443",
        "brokerName": "INDEPENDENT FINANCIAL GROUP, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "HSBK",
        "clearingBroker": "0443",
        "brokerName": "HSBC SECURITIES (USA) INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "HSBM",
        "clearingBroker": "0486",
        "brokerName": "HSBC SECURITIES (USA), INC/ FIXED INCOME SECS                         "
    },
    {
        "type": "CORP",
        "mpid": "HTCM",
        "clearingBroker": "0235",
        "brokerName": "HOWDEN TIGER CAPITAL MARKETS & ADVISOF LLC                            "
    },
    {
        "type": "CORP",
        "mpid": "HTDX",
        "clearingBroker": "0279",
        "brokerName": "HARTFIELD, TITUS & DONNELLY, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "HTIS",
        "clearingBroker": "0443",
        "brokerName": "HAITONG INTERNATIONAL SECURITIES (USA) INC.                           "
    },
    {
        "type": "CORP",
        "mpid": "HTPS",
        "clearingBroker": "0443",
        "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "HTWR",
        "clearingBroker": "0226",
        "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "HUCO",
        "clearingBroker": "0226",
        "brokerName": "HUNTINGTON INVESTMENT COMPANY                                         "
    },
    {
        "type": "CORP",
        "mpid": "HUFS",
        "clearingBroker": "0443",
        "brokerName": "HUNT FINANCIAL SECURITIES, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "HUNT",
        "clearingBroker": "0141",
        "brokerName": "HUNTLEIGH SECURITIES CORPORATION                                      "
    },
    {
        "type": "CORP",
        "mpid": "HUTC",
        "clearingBroker": "0443",
        "brokerName": "HUNTINGTON SECURITIES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "HWJC",
        "clearingBroker": "0052",
        "brokerName": "HWJ CAPITAL PARTNERS II, LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "HWLS",
        "clearingBroker": "0443",
        "brokerName": "M.S. HOWELLS & CO.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "IAAK",
        "clearingBroker": "0279",
        "brokerName": "ISAAK BOND INVESTMENT, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "IAEW",
        "clearingBroker": "0595",
        "brokerName": "SRT SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "IAEX",
        "clearingBroker": "0235",
        "brokerName": "SRT SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "IBKR",
        "clearingBroker": "0017",
        "brokerName": "INTERACTIVE BROKERS LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "IBND",
        "clearingBroker": "0103",
        "brokerName": "INSTITUTIONAL BOND NETWORK, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "IBOT",
        "clearingBroker": "0279",
        "brokerName": "INVESTORS BROKERAGE OF TEXAS, INC                                     "
    },
    {
        "type": "CORP",
        "mpid": "IBPR",
        "clearingBroker": "0052",
        "brokerName": "IB CAPITAL LLC                                                        "
    },
    {
        "type": "CORP",
        "mpid": "IBSJ",
        "clearingBroker": "0052",
        "brokerName": "INTEGRITY BROKERAGE                                                   "
    },
    {
        "type": "CORP",
        "mpid": "ICAN",
        "clearingBroker": "0226",
        "brokerName": "CETERA ADVISOR NETWORKS LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "ICBK",
        "clearingBroker": "0388",
        "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL SERVICES LLC        "
    },
    {
        "type": "CORP",
        "mpid": "ICCI",
        "clearingBroker": "0279",
        "brokerName": "INDEPENDENCE CAPITAL CO.                                              "
    },
    {
        "type": "CORP",
        "mpid": "ICDS",
        "clearingBroker": "0750",
        "brokerName": "ICD SECURITIES                                                        "
    },
    {
        "type": "CORP",
        "mpid": "ICEX",
        "clearingBroker": "4264",
        "brokerName": "ICE SECURITIES EXECUTION & CLEARING, LLC                              "
    },
    {
        "type": "CORP",
        "mpid": "ICMB",
        "clearingBroker": "1043",
        "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "ICMH",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL CAPITAL MANAGEMENT, INC.                                "
    },
    {
        "type": "CORP",
        "mpid": "ICMI",
        "clearingBroker": "0279",
        "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "ICON",
        "clearingBroker": "0595",
        "brokerName": "ICON CAPITAL GROUP, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "ICRL",
        "clearingBroker": "0443",
        "brokerName": "RIDEAU (I.C.) LYONS AND CO.                                           "
    },
    {
        "type": "CORP",
        "mpid": "ICTI",
        "clearingBroker": "0158",
        "brokerName": "INTERNATIONAL CORRESPONDENT TRADING, INC.                             "
    },
    {
        "type": "CORP",
        "mpid": "IDAY",
        "clearingBroker": "0103",
        "brokerName": "BROKERAGESELECT                                                       "
    },
    {
        "type": "CORP",
        "mpid": "IESI",
        "clearingBroker": "0443",
        "brokerName": "ITAU EUROPA SECURITIES INC                                            "
    },
    {
        "type": "CORP",
        "mpid": "IFCS",
        "clearingBroker": "0161",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "IMCC",
        "clearingBroker": "0005",
        "brokerName": "IMC FINANCIAL MARKETS                                                 "
    },
    {
        "type": "CORP",
        "mpid": "IMPC",
        "clearingBroker": "0443",
        "brokerName": "IMPERIAL CAPITAL, LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "INCC",
        "clearingBroker": "0443",
        "brokerName": "SATURNA BROKERAGE SERVICES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "INFI",
        "clearingBroker": "0279",
        "brokerName": "INTEGRAL FINANCIAL, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "INGF",
        "clearingBroker": "0270",
        "brokerName": "ING FINANCIAL MARKETS LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "INGS",
        "clearingBroker": "0124",
        "brokerName": "INGALLS & SNYDER, LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "INNO",
        "clearingBroker": "0052",
        "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "INPI",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT PLANNERS INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "INPS",
        "clearingBroker": "0235",
        "brokerName": "INDEPENDENCE POINT SECURITIES LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "INTL",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "INTX",
        "clearingBroker": "0235",
        "brokerName": "INTERNATIONAL ASSETS ADVISORY, LLC                                    "
    },
    {
        "type": "CORP",
        "mpid": "IPGR",
        "clearingBroker": "0443",
        "brokerName": "INVESTMENT PLACEMENT GROUP                                            "
    },
    {
        "type": "CORP",
        "mpid": "IRMD",
        "clearingBroker": "0443",
        "brokerName": "PLANMEMBER SECURITIES CORP                                            "
    },
    {
        "type": "CORP",
        "mpid": "ISCN",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
    },
    {
        "type": "CORP",
        "mpid": "ISIG",
        "clearingBroker": "0226",
        "brokerName": "EVERCORE GROUP L.L.C.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "ISLL",
        "clearingBroker": "0052",
        "brokerName": "INLET SECURITIES LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "ISSI",
        "clearingBroker": "0052",
        "brokerName": "INSIGHT SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "ITAU",
        "clearingBroker": "0443",
        "brokerName": "ITAU BBA USA SECURITIES INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "ITCC",
        "clearingBroker": "0750",
        "brokerName": "STERNE AGEE FINANCIAL SERVICES, INC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "ITCM",
        "clearingBroker": "0443",
        "brokerName": "INTERCAM SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "ITFS",
        "clearingBroker": "0226",
        "brokerName": "KEEL POINT CAPITAL, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "IVEX",
        "clearingBroker": "0443",
        "brokerName": "INVEX, INC.                                                           "
    },
    {
        "type": "CORP",
        "mpid": "IVNT",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT NETWORK, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "IVOL",
        "clearingBroker": "0235",
        "brokerName": "UNION CAPITAL COMPANY                                                 "
    },
    {
        "type": "CORP",
        "mpid": "IVST",
        "clearingBroker": "0443",
        "brokerName": "INTERVEST INTERNATIONAL EQUITIES CORPORATION                          "
    },
    {
        "type": "CORP",
        "mpid": "JADN",
        "clearingBroker": "0725",
        "brokerName": "J ALDEN ASSOCIATES                                                    "
    },
    {
        "type": "CORP",
        "mpid": "JANY",
        "clearingBroker": "0374",
        "brokerName": "JANNEY MONTGOMERY SCOTT LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "JBLW",
        "clearingBroker": "0443",
        "brokerName": "OHANESIAN / LECOURS, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "JDLS",
        "clearingBroker": "0103",
        "brokerName": "JDL SECURITIES                                                        "
    },
    {
        "type": "CORP",
        "mpid": "JDRB",
        "clearingBroker": "0595",
        "brokerName": "J.H. DARBIE & CO., INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "JEFF",
        "clearingBroker": "0019",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "CORP",
        "mpid": "JEFM",
        "clearingBroker": "0235",
        "brokerName": "JEFFREY MATTHEWS FINANCIAL GROUP, L.L.C.                              "
    },
    {
        "type": "CORP",
        "mpid": "JEVO",
        "clearingBroker": "0235",
        "brokerName": "ATIS, INC                                                             "
    },
    {
        "type": "CORP",
        "mpid": "JGUN",
        "clearingBroker": "0235",
        "brokerName": "JOSEPH GUNNAR & CO. LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "JHDR",
        "clearingBroker": "0052",
        "brokerName": "JH DARBIE & CO. INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "JJKE",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "JKFS",
        "clearingBroker": "0279",
        "brokerName": "J.K. FINANCIAL SERVICES INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "JKRC",
        "clearingBroker": "0443",
        "brokerName": "J.K.R. & CO., INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "JLEQ",
        "clearingBroker": "0161",
        "brokerName": "JUMP EXECUTION, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "JMLS",
        "clearingBroker": "0235",
        "brokerName": "J.M LUMMIS SECURITIES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "JNSN",
        "clearingBroker": "0443",
        "brokerName": "D A DAVIDSON                                                          "
    },
    {
        "type": "CORP",
        "mpid": "JNST",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "JONE",
        "clearingBroker": "0161",
        "brokerName": "JONESTRADING                                                          "
    },
    {
        "type": "CORP",
        "mpid": "JPMS",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "JPPB",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "CORP",
        "mpid": "JQII",
        "clearingBroker": "0443",
        "brokerName": "THE GARBACZ GROUP                                                     "
    },
    {
        "type": "CORP",
        "mpid": "JRCO",
        "clearingBroker": "0226",
        "brokerName": "JOHNSON RICE & COMPANY L.L.C.                                         "
    },
    {
        "type": "CORP",
        "mpid": "JSAP",
        "clearingBroker": "8497",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "JSBA",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "JSCL",
        "clearingBroker": "0052",
        "brokerName": "JOSEPH STONE CAPITAL L.L.C.                                           "
    },
    {
        "type": "CORP",
        "mpid": "JSCT",
        "clearingBroker": "0005",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "JSEB",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
    },
    {
        "type": "CORP",
        "mpid": "JSEG",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
    },
    {
        "type": "CORP",
        "mpid": "JSSF",
        "clearingBroker": "0226",
        "brokerName": "JMP SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "JVBF",
        "clearingBroker": "0235",
        "brokerName": "JACK V. BUTTERFIELD INVESTMENT COMPANY                                "
    },
    {
        "type": "CORP",
        "mpid": "JVBG",
        "clearingBroker": "0443",
        "brokerName": "J.V.B. FINANCIAL GROUP LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "JWCF",
        "clearingBroker": "0226",
        "brokerName": "J. W. COLE FINANCIAL, INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "JWML",
        "clearingBroker": "0235",
        "brokerName": "MILLEGAN (J.W.), INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "KALS",
        "clearingBroker": "0235",
        "brokerName": "KALOS CAPITAL, INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "KAPG",
        "clearingBroker": "0158",
        "brokerName": "KAPITALL GENERATION, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "KART",
        "clearingBroker": "0750",
        "brokerName": "REVERE SECURITIES CORP.                                               "
    },
    {
        "type": "CORP",
        "mpid": "KAWM",
        "clearingBroker": "0443",
        "brokerName": "ARETE WEALTH MANAGEMENT, LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "KBCO",
        "clearingBroker": "0443",
        "brokerName": "KAHN BROTHERS LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "KCAM",
        "clearingBroker": "0052",
        "brokerName": "K2 CAPITAL ASSET MANAGEMENT, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "KCIM",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT MANAGEMENT CORPORATION                                     "
    },
    {
        "type": "CORP",
        "mpid": "KCIX",
        "clearingBroker": "0279",
        "brokerName": "KILEY PARTNERS, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "KCRD",
        "clearingBroker": "0052",
        "brokerName": "PHX FINANCIAL, INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "KEEN",
        "clearingBroker": "0279",
        "brokerName": "ST. BERNARD FINANCIAL SERVICES, INC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "KENS",
        "clearingBroker": "0279",
        "brokerName": "KENSINGTON CAPITAL CORP.                                              "
    },
    {
        "type": "CORP",
        "mpid": "KERC",
        "clearingBroker": "0443",
        "brokerName": "KERCHEVILLE & COMPANY                                                 "
    },
    {
        "type": "CORP",
        "mpid": "KEYB",
        "clearingBroker": "0443",
        "brokerName": "KEYBANC CAPITAL MARKETS INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "KIML",
        "clearingBroker": "0226",
        "brokerName": "KIMELMAN & BAIRD, LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "KING",
        "clearingBroker": "0235",
        "brokerName": "C. L. KING & ASSOCIATES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "KISL",
        "clearingBroker": "0443",
        "brokerName": "KEY INVESTMENT SERVICES LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "KJCO",
        "clearingBroker": "0725",
        "brokerName": "KIPLING JONES & CO., LTD.                                             "
    },
    {
        "type": "CORP",
        "mpid": "KMSF",
        "clearingBroker": "0443",
        "brokerName": "KMS FINANCIAL SERVICES                                                "
    },
    {
        "type": "CORP",
        "mpid": "KNGS",
        "clearingBroker": "0235",
        "brokerName": "KINGSWOOD CAPITAL PARTNERS, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "KOTK",
        "clearingBroker": "1043",
        "brokerName": "KOTAK MAHINDRA, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "KOVP",
        "clearingBroker": "0443",
        "brokerName": "KOVACK SECURITIES INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "KOVS",
        "clearingBroker": "0226",
        "brokerName": "KOVACK SECURITIES, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "KRCO",
        "clearingBroker": "0235",
        "brokerName": "KR SECURITIES, LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "KRSH",
        "clearingBroker": "0005",
        "brokerName": "KERSHNER SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "KRTH",
        "clearingBroker": "0235",
        "brokerName": "J.W. KORTH & COMPANY                                                  "
    },
    {
        "type": "CORP",
        "mpid": "KUYK",
        "clearingBroker": "0279",
        "brokerName": "KUYKENDALL & SCHNEIDER, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "LADY",
        "clearingBroker": "0443",
        "brokerName": "TRUSTFIRST, INC.                                                      "
    },
    {
        "type": "CORP",
        "mpid": "LAFB",
        "clearingBroker": "0235",
        "brokerName": "LAFFERTY (R.F.) & CO., INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "LAFC",
        "clearingBroker": "0443",
        "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "LAFF",
        "clearingBroker": "0443",
        "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "LAFI",
        "clearingBroker": "0750",
        "brokerName": "LAFISE SECURITIES CORPORATION                                         "
    },
    {
        "type": "CORP",
        "mpid": "LAGI",
        "clearingBroker": "0226",
        "brokerName": "ALLSTATE FINANCIAL SERVICES, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "LANE",
        "clearingBroker": "0235",
        "brokerName": "MARC J. LANE & COMPANY                                                "
    },
    {
        "type": "CORP",
        "mpid": "LARC",
        "clearingBroker": "0235",
        "brokerName": "LARIMER CAPITAL CORPORATION                                           "
    },
    {
        "type": "CORP",
        "mpid": "LASI",
        "clearingBroker": "0141",
        "brokerName": "LIEBLONG & ASSOCIATES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "LASS",
        "clearingBroker": "0226",
        "brokerName": "LASALLE ST. SECURITIES, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "LATG",
        "clearingBroker": "0537",
        "brokerName": "GFI SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "LATM",
        "clearingBroker": "0537",
        "brokerName": "GFI SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "LATN",
        "clearingBroker": "0443",
        "brokerName": "HEROLD & LANTERN INVESTMENTS, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "LBKI",
        "clearingBroker": "0235",
        "brokerName": "LIBUCKI & CO., LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "LDAS",
        "clearingBroker": "0443",
        "brokerName": "LANDAAS & CO.                                                         "
    },
    {
        "type": "CORP",
        "mpid": "LDIL",
        "clearingBroker": "0226",
        "brokerName": "LINCOLN DOUGLAS INVESTMENTS, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "LDLW",
        "clearingBroker": "0750",
        "brokerName": "LAIDLAW & COMPANY (UK) LTD.                                           "
    },
    {
        "type": "CORP",
        "mpid": "LDOT",
        "clearingBroker": "0235",
        "brokerName": "LANDOLT SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "LEAD",
        "clearingBroker": "0226",
        "brokerName": "THE LEADERS GROUP, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "LEBO",
        "clearingBroker": "0226",
        "brokerName": "LEIGH BALDWIN & CO., LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "LEER",
        "clearingBroker": "0443",
        "brokerName": "LEERINK SWANN & COMPANY                                               "
    },
    {
        "type": "CORP",
        "mpid": "LENX",
        "clearingBroker": "0279",
        "brokerName": "LENOX FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "LEXI",
        "clearingBroker": "0226",
        "brokerName": "LEXINGTON INVESTMENT COMPANY, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "LEYA",
        "clearingBroker": "0235",
        "brokerName": "LEMLEY, YARLING & CO.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "LFAC",
        "clearingBroker": "0226",
        "brokerName": "OSAIC FA, INC.                                                        "
    },
    {
        "type": "CORP",
        "mpid": "LFRO",
        "clearingBroker": "0235",
        "brokerName": "LF ROTHSCHILD, LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "LGNT",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "LGSA",
        "clearingBroker": "0158",
        "brokerName": "WOORI INVESTMENT AND SECURITIES AMERICA, INC.                         "
    },
    {
        "type": "CORP",
        "mpid": "LIFG",
        "clearingBroker": "0279",
        "brokerName": "LONG ISLAND FINANCIAL GROUP, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "LIIS",
        "clearingBroker": "0226",
        "brokerName": "USAA FINANCIAL ADVISORS, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "LINC",
        "clearingBroker": "0158",
        "brokerName": "LIBERUM                                                               "
    },
    {
        "type": "CORP",
        "mpid": "LISI",
        "clearingBroker": "0443",
        "brokerName": "LEUMI INVESTMENT SERVICES, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "LMAR",
        "clearingBroker": "0226",
        "brokerName": "LIFEMARK SECURITIES CORP.                                             "
    },
    {
        "type": "CORP",
        "mpid": "LMBD",
        "clearingBroker": "0443",
        "brokerName": "LAZARD ASSET MANAGEMENT SECURITIES LLC                                "
    },
    {
        "type": "CORP",
        "mpid": "LMKO",
        "clearingBroker": "0235",
        "brokerName": "KOHN (L.M.) & COMPANY                                                 "
    },
    {
        "type": "CORP",
        "mpid": "LMNX",
        "clearingBroker": "0226",
        "brokerName": "LUMINEX TRADING & ANALYTICS LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "LNCL",
        "clearingBroker": "0443",
        "brokerName": "LINCOLN INVESTMENT                                                    "
    },
    {
        "type": "CORP",
        "mpid": "LNKS",
        "clearingBroker": "0443",
        "brokerName": "GUGGENHEIM SECURITIES, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "LOMB",
        "clearingBroker": "0141",
        "brokerName": "LOMBARD SECURITIES INCORPORATED                                       "
    },
    {
        "type": "CORP",
        "mpid": "LOOP",
        "clearingBroker": "0443",
        "brokerName": "LOOP CAPITAL MARKETS, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "LOUE",
        "clearingBroker": "0161",
        "brokerName": "ICAP CORPORATES LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "LOUI",
        "clearingBroker": "0005",
        "brokerName": "LOUIS CAPITAL MARKETS, LP                                             "
    },
    {
        "type": "CORP",
        "mpid": "LPCM",
        "clearingBroker": "0103",
        "brokerName": "LAMPERT CAPITAL MARKETS INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "LPFS",
        "clearingBroker": "0235",
        "brokerName": "LIBERTY PARTNERS FINANCIAL SERVICES, INC.                             "
    },
    {
        "type": "CORP",
        "mpid": "LPLE",
        "clearingBroker": "0075",
        "brokerName": "LPL ENTERPRISE, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "LPSP",
        "clearingBroker": "1043",
        "brokerName": "LPS CAPITAL LLC                                                       "
    },
    {
        "type": "CORP",
        "mpid": "LQNA",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "CORP",
        "mpid": "LQNB",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "CORP",
        "mpid": "LQNF",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "CORP",
        "mpid": "LQNT",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "CORP",
        "mpid": "LQPT",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "LRBC",
        "clearingBroker": "0235",
        "brokerName": "LIBERTY ASSOCIATES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "LRCM",
        "clearingBroker": "0279",
        "brokerName": "LOCKTON RE CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "LSCM",
        "clearingBroker": "0235",
        "brokerName": "LAKE STREET CAPITAL MARKETS, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "LSFB",
        "clearingBroker": "0443",
        "brokerName": "LION STREET FINANCIAL, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "LSKO",
        "clearingBroker": "0226",
        "brokerName": "LESKO SECURITIES INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "LSPI",
        "clearingBroker": "0141",
        "brokerName": "LAFAYETTE INVESTMENTS                                                 "
    },
    {
        "type": "CORP",
        "mpid": "LSSI",
        "clearingBroker": "0750",
        "brokerName": "EJ STERLING INC.                                                      "
    },
    {
        "type": "CORP",
        "mpid": "LSUS",
        "clearingBroker": "0443",
        "brokerName": "LATIN SECURITIES INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "LTAA",
        "clearingBroker": "0226",
        "brokerName": "LUMINEX TRADING & ANALYTICS LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "LTCO",
        "clearingBroker": "0226",
        "brokerName": "LADENBURG, THALMANN & CO., INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "LTIN",
        "clearingBroker": "2786",
        "brokerName": "BBVA SECURITIES INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "LVAR",
        "clearingBroker": "0443",
        "brokerName": "LARRAINVIAL SECURITIES US LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "LVMR",
        "clearingBroker": "0235",
        "brokerName": "LIVERMORE TRADING GROUP, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "LWFL",
        "clearingBroker": "0443",
        "brokerName": "LAWSON FINANCIAL CORPORATION                                          "
    },
    {
        "type": "CORP",
        "mpid": "LYON",
        "clearingBroker": "0651",
        "brokerName": "CREDIT AGRICOLE SECURITIES (USA) INC.                                 "
    },
    {
        "type": "CORP",
        "mpid": "LYSI",
        "clearingBroker": "0443",
        "brokerName": "LLOYDS SECURITIES INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "MACC",
        "clearingBroker": "0226",
        "brokerName": "NEWEDGE SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "MADV",
        "clearingBroker": "0443",
        "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "MAMA",
        "clearingBroker": "0443",
        "brokerName": "SECUREVEST FINANCIAL GROUP                                            "
    },
    {
        "type": "CORP",
        "mpid": "MAPA",
        "clearingBroker": "0279",
        "brokerName": "MADISON PAIGE SECURITIES LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "MASE",
        "clearingBroker": "0141",
        "brokerName": "MANAGED ACCOUNT SERVICES, LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "MAVS",
        "clearingBroker": "0443",
        "brokerName": "MADISON AVENUE SECURITIES                                             "
    },
    {
        "type": "CORP",
        "mpid": "MAXM",
        "clearingBroker": "0443",
        "brokerName": "MAXIM GROUP LLC                                                       "
    },
    {
        "type": "CORP",
        "mpid": "MBBS",
        "clearingBroker": "0443",
        "brokerName": "INFINEX INVESTMENTS                                                   "
    },
    {
        "type": "CORP",
        "mpid": "MBSA",
        "clearingBroker": "0052",
        "brokerName": "MBS SOURCE ETRADING, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "MBSE",
        "clearingBroker": "0052",
        "brokerName": "MBS SOURCE ETRADING, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "MBSL",
        "clearingBroker": "0443",
        "brokerName": "MBS CAPITAL MARKETS, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "MBUS",
        "clearingBroker": "0052",
        "brokerName": "MEDIOBANCA SECURITIES USA LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "MCAP",
        "clearingBroker": "1043",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "CORP",
        "mpid": "MCBT",
        "clearingBroker": "0235",
        "brokerName": "MOORS & CABOT, INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "MCCL",
        "clearingBroker": "0443",
        "brokerName": "MCCLURG CAPITAL CORPORATION                                           "
    },
    {
        "type": "CORP",
        "mpid": "MCMG",
        "clearingBroker": "0279",
        "brokerName": "MUNICIPAL CAPITAL MARKETS GROUP, INC.                                 "
    },
    {
        "type": "CORP",
        "mpid": "MCNA",
        "clearingBroker": "0443",
        "brokerName": "MCNALLY FINANCIAL SERVICES CORPORATION                                "
    },
    {
        "type": "CORP",
        "mpid": "MDGP",
        "clearingBroker": "0235",
        "brokerName": "MD GLOBAL PARTNERS, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "MEAL",
        "clearingBroker": "0226",
        "brokerName": "M. E. ALLISON & CO., INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "MERP",
        "clearingBroker": "0235",
        "brokerName": "MERIDIAN EQUITY PARTNERS, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "MERQ",
        "clearingBroker": "0052",
        "brokerName": "MERCATOR ASSOCIATES LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "MESF",
        "clearingBroker": "0443",
        "brokerName": "MESIROW FINANCIAL, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "MFGX",
        "clearingBroker": "0443",
        "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "MFRS",
        "clearingBroker": "0443",
        "brokerName": "MFR SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "MHFI",
        "clearingBroker": "0226",
        "brokerName": "M HOLDINGS SECURITIES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "MHSI",
        "clearingBroker": "0443",
        "brokerName": "M HOLDINGS SECURITIES                                                 "
    },
    {
        "type": "CORP",
        "mpid": "MIAM",
        "clearingBroker": "0141",
        "brokerName": "FMSBONDS, INC.                                                        "
    },
    {
        "type": "CORP",
        "mpid": "MIBS",
        "clearingBroker": "0443",
        "brokerName": "BMO HARRIS FINANCIAL ADVISORS                                         "
    },
    {
        "type": "CORP",
        "mpid": "MIDA",
        "clearingBroker": "0725",
        "brokerName": "MID-ATLANTIC SECURITIES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "MIDL",
        "clearingBroker": "0226",
        "brokerName": "MIDDLEGATE SECURITIES LTD.                                            "
    },
    {
        "type": "CORP",
        "mpid": "MIFI",
        "clearingBroker": "0226",
        "brokerName": "MILKIE FERGUSON INVESTMENTS, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "MILE",
        "clearingBroker": "0052",
        "brokerName": "I-BANKERS SECURITIES INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "MILN",
        "clearingBroker": "1767",
        "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "MINP",
        "clearingBroker": "0235",
        "brokerName": "MINISTRY PARTNERS SECURITIES, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "MINV",
        "clearingBroker": "0235",
        "brokerName": "MACK INVESTMENTS SECURITIES, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "MIRA",
        "clearingBroker": "1043",
        "brokerName": "MIRAE ASSET SECURITIES (USA) INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "MISL",
        "clearingBroker": "0161",
        "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "MITR",
        "clearingBroker": "0443",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "MJDW",
        "clearingBroker": "0279",
        "brokerName": "MURRAY SECURITIES                                                     "
    },
    {
        "type": "CORP",
        "mpid": "MJWH",
        "clearingBroker": "0235",
        "brokerName": "ETICO PARTNERS LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "MKMP",
        "clearingBroker": "0161",
        "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "MKRT",
        "clearingBroker": "0235",
        "brokerName": "MARKET SECURITIES, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "MKTI",
        "clearingBroker": "0226",
        "brokerName": "U.S. BANCORP ADVISORS, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "MKTX",
        "clearingBroker": "4265",
        "brokerName": "MARKETAXESS CORPORATION                                               "
    },
    {
        "type": "CORP",
        "mpid": "MKTY",
        "clearingBroker": "4265",
        "brokerName": "MARKETAXESS CORPORATION                                               "
    },
    {
        "type": "CORP",
        "mpid": "MLCO",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "MLEX",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "MLMA",
        "clearingBroker": "0671",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "CORP",
        "mpid": "MLMS",
        "clearingBroker": "0279",
        "brokerName": "MAINLINE WEST MUNICIPAL SECURITIES, LLC                               "
    },
    {
        "type": "CORP",
        "mpid": "MLTX",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "MLWM",
        "clearingBroker": "0671",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "CORP",
        "mpid": "MMCS",
        "clearingBroker": "0443",
        "brokerName": "MMC SECURITIES CORP.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "MMNT",
        "clearingBroker": "0158",
        "brokerName": "MOMENT MARKETS, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "MNCC",
        "clearingBroker": "0443",
        "brokerName": "MONEY CONCEPTS CAPITAL CORP.                                          "
    },
    {
        "type": "CORP",
        "mpid": "MNCO",
        "clearingBroker": "0279",
        "brokerName": "NELSON (MARTIN) & CO., INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "MNRC",
        "clearingBroker": "0443",
        "brokerName": "MONARCH CAPITAL GROUP LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "MNXS",
        "clearingBroker": "0443",
        "brokerName": "MUNIAXIS LEBENTHAL LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "MOCM",
        "clearingBroker": "0235",
        "brokerName": "MORETON CAPITAL MARKETS, LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "MOFI",
        "clearingBroker": "0158",
        "brokerName": "M1 FINANCE LLC                                                        "
    },
    {
        "type": "CORP",
        "mpid": "MOIS",
        "clearingBroker": "0443",
        "brokerName": "MUTUAL OF OMAHA INVESTOR SERVICES INC.                                "
    },
    {
        "type": "CORP",
        "mpid": "MOLO",
        "clearingBroker": "0235",
        "brokerName": "MOLONEY SECURITIES                                                    "
    },
    {
        "type": "CORP",
        "mpid": "MOMS",
        "clearingBroker": "0750",
        "brokerName": "MOMENTUS SECURITIES LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "MONE",
        "clearingBroker": "0443",
        "brokerName": "MONERE INVESTMENTS, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "MONR",
        "clearingBroker": "0226",
        "brokerName": "MONROE FINANCIAL PARTNERS, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "MONX",
        "clearingBroker": "0443",
        "brokerName": "MONEX SECURITIES INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "MORA",
        "clearingBroker": "0443",
        "brokerName": "MORA WM SECURITIES                                                    "
    },
    {
        "type": "CORP",
        "mpid": "MPLA",
        "clearingBroker": "0158",
        "brokerName": "EMPALA SECURITIES, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "MPLW",
        "clearingBroker": "0226",
        "brokerName": "MAPLEWOOD INVESTMENT ADVISORS, INC.                                   "
    },
    {
        "type": "CORP",
        "mpid": "MPSG",
        "clearingBroker": "0161",
        "brokerName": "ED & F MAN CAPITAL MARKETS INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "MRBA",
        "clearingBroker": "0052",
        "brokerName": "IBN FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "MRIS",
        "clearingBroker": "0443",
        "brokerName": "BMO HARRIS FINANCIAL ADVISORS                                         "
    },
    {
        "type": "CORP",
        "mpid": "MRKS",
        "clearingBroker": "0443",
        "brokerName": "M. RAMSEY KING                                                        "
    },
    {
        "type": "CORP",
        "mpid": "MRNA",
        "clearingBroker": "0161",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "MRPH",
        "clearingBroker": "0226",
        "brokerName": "WM FINANCIAL SERVICES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "MRSC",
        "clearingBroker": "0287",
        "brokerName": "TRADEUP SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "MSCB",
        "clearingBroker": "0279",
        "brokerName": "MAINE SECURITIES CORPORATION                                          "
    },
    {
        "type": "CORP",
        "mpid": "MSCO",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "MSEC",
        "clearingBroker": "0235",
        "brokerName": "MSEC, LLC                                                             "
    },
    {
        "type": "CORP",
        "mpid": "MSII",
        "clearingBroker": "0226",
        "brokerName": "MSI FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "MSRO",
        "clearingBroker": "0226",
        "brokerName": "MESIROW FINANCIAL, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "MSTC",
        "clearingBroker": "0226",
        "brokerName": "MIDWESTERN SECURITIES TRADING COMPANY, LLC                            "
    },
    {
        "type": "CORP",
        "mpid": "MTBK",
        "clearingBroker": "0443",
        "brokerName": "MULTI-BANK SECURITIES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "MTDB",
        "clearingBroker": "0443",
        "brokerName": "M&T SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "MTGO",
        "clearingBroker": "0158",
        "brokerName": "MTG, LLC                                                              "
    },
    {
        "type": "CORP",
        "mpid": "MTHN",
        "clearingBroker": "0005",
        "brokerName": "MARATHON TRADING GROUP LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "MTLE",
        "clearingBroker": "0235",
        "brokerName": "MTL EQUITY PRODUCTS, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "MTSL",
        "clearingBroker": "0226",
        "brokerName": "MSEC, LLC                                                             "
    },
    {
        "type": "CORP",
        "mpid": "MUFG",
        "clearingBroker": "0076",
        "brokerName": "MUFG SECURITIES AMERICAS INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "MULT",
        "clearingBroker": "0443",
        "brokerName": "MULTI-FINANCIAL SECURITIES GROUP                                      "
    },
    {
        "type": "CORP",
        "mpid": "MURJ",
        "clearingBroker": "0750",
        "brokerName": "COMMERCE ONE FINANCIAL INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "MWAF",
        "clearingBroker": "0443",
        "brokerName": "MWA FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "MWCC",
        "clearingBroker": "0235",
        "brokerName": "MONNESS CRESPI HARDT & CO., INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "MWIL",
        "clearingBroker": "0235",
        "brokerName": "MORGAN WILSHIRE SECURITIES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "MWMS",
        "clearingBroker": "0443",
        "brokerName": "MUREX CAPITAL LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "MYSS",
        "clearingBroker": "0158",
        "brokerName": "M.Y. SAFRA SECURITIES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "MZHO",
        "clearingBroker": "0892",
        "brokerName": "MIZUHO SECURITIES USA LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "MZHO",
        "clearingBroker": "2396",
        "brokerName": "MIZUHO SECURITIES USA LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "NACM",
        "clearingBroker": "0161",
        "brokerName": "NABSECURITIES, LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "NADL",
        "clearingBroker": "0235",
        "brokerName": "WARREN D. NADEL & COMPANY                                             "
    },
    {
        "type": "CORP",
        "mpid": "NAPK",
        "clearingBroker": "0052",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "CORP",
        "mpid": "NASC",
        "clearingBroker": "0235",
        "brokerName": "NATALLIANCE SECURITIES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "NAVC",
        "clearingBroker": "0235",
        "brokerName": "NAVIAN CAPITAL SECURITIES LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "NBAR",
        "clearingBroker": "0226",
        "brokerName": "NANCY BARRON & ASSOCIATES, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "NBCS",
        "clearingBroker": "0235",
        "brokerName": "NBC SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "NBLB",
        "clearingBroker": "0226",
        "brokerName": "NEUBERGER BERMAN BD LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "NBSL",
        "clearingBroker": "0226",
        "brokerName": "BMO NESBITT BURNS SECURITIES LTD.                                     "
    },
    {
        "type": "CORP",
        "mpid": "NEED",
        "clearingBroker": "0443",
        "brokerName": "NEEDHAM & COMPANY, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "NEPP",
        "clearingBroker": "0226",
        "brokerName": "N.E. PRIVATE CLIENT ADVISORS, LTD.                                    "
    },
    {
        "type": "CORP",
        "mpid": "NEST",
        "clearingBroker": "0235",
        "brokerName": "NEST INVESTMENTS BD LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "NEXT",
        "clearingBroker": "0443",
        "brokerName": "NEXT FINANCIAL GROUP, INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "NFGR",
        "clearingBroker": "0141",
        "brokerName": "NATIONS FINANCIAL GROUP, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "NFSC",
        "clearingBroker": "0226",
        "brokerName": "NATIONAL FINANCIAL SERVICES LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "NFTY",
        "clearingBroker": "0235",
        "brokerName": "INFINITY FINANCIAL SERVICES                                           "
    },
    {
        "type": "CORP",
        "mpid": "NHFS",
        "clearingBroker": "0443",
        "brokerName": "ALIGHT FINANCIAL SOLUTIONS, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "NHWI",
        "clearingBroker": "0141",
        "brokerName": "HENNION & WALSH, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "NIAD",
        "clearingBroker": "0052",
        "brokerName": "NI ADVISORS                                                           "
    },
    {
        "type": "CORP",
        "mpid": "NILL",
        "clearingBroker": "0725",
        "brokerName": "NIAGARA INTERNATIONAL CAPITAL LIMITED                                 "
    },
    {
        "type": "CORP",
        "mpid": "NITE",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "NLOV",
        "clearingBroker": "0279",
        "brokerName": "NORTLOV SECURITIES LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "NMRA",
        "clearingBroker": "0180",
        "brokerName": "NOMURA SECURITIES INTERNATIONAL, INC./FIXED INCOME                    "
    },
    {
        "type": "CORP",
        "mpid": "NMRA",
        "clearingBroker": "5222",
        "brokerName": "NOMURA SECURITIES INTERNATIONAL, INC./FIXED INCOME                    "
    },
    {
        "type": "CORP",
        "mpid": "NOBL",
        "clearingBroker": "0750",
        "brokerName": "NOBLE FINANCIAL CAPITAL MARKETS                                       "
    },
    {
        "type": "CORP",
        "mpid": "NORC",
        "clearingBroker": "0235",
        "brokerName": "NORTHERN CAPITAL SEC. CORP.                                           "
    },
    {
        "type": "CORP",
        "mpid": "NORP",
        "clearingBroker": "0443",
        "brokerName": "PARETO SECURITIES INC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "NORT",
        "clearingBroker": "0443",
        "brokerName": "NORTHLAND SECURITIES, INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "NOSO",
        "clearingBroker": "0443",
        "brokerName": "NORTH SOUTH CAPITAL LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "NPAI",
        "clearingBroker": "0443",
        "brokerName": "NATIONWIDE PLANNING ASSOCIATES                                        "
    },
    {
        "type": "CORP",
        "mpid": "NPBF",
        "clearingBroker": "0443",
        "brokerName": "NPB FINANCIAL GROUP, LLC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "NPNT",
        "clearingBroker": "0005",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "NPTP",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "NRAM",
        "clearingBroker": "0443",
        "brokerName": "CANACCORD WEALTH MANAGEMENT (USA) INC.                                "
    },
    {
        "type": "CORP",
        "mpid": "NSFP",
        "clearingBroker": "0235",
        "brokerName": "NORTHSTAR FINANCIAL PARTNERS, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "NSRD",
        "clearingBroker": "0235",
        "brokerName": "NESTLERODE & CO., INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "NTFN",
        "clearingBroker": "0052",
        "brokerName": "NETWORK 1 FINANCIAL SECURITIES INC.                                   "
    },
    {
        "type": "CORP",
        "mpid": "NTRC",
        "clearingBroker": "0226",
        "brokerName": "NORTHERN TRUST SECURITIES, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "NTSI",
        "clearingBroker": "0443",
        "brokerName": "NESBITT THOMSON SECURITIES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "NVEN",
        "clearingBroker": "0448",
        "brokerName": "NUVEEN SECURITIES, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "NWCM",
        "clearingBroker": "0235",
        "brokerName": "NW CAPITAL MARKETS INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "NWIA",
        "clearingBroker": "0750",
        "brokerName": "NORTHWEST INVESTMENT ADVISORS, INC.                                   "
    },
    {
        "type": "CORP",
        "mpid": "NWML",
        "clearingBroker": "0443",
        "brokerName": "NORTHWESTERN MUTUAL INVESTMENT SERVICES, LLC                          "
    },
    {
        "type": "CORP",
        "mpid": "NYLS",
        "clearingBroker": "0226",
        "brokerName": "NYLIFE SECURITIES INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "OAKR",
        "clearingBroker": "0235",
        "brokerName": "THE OAK RIDGE FINANCIAL SERVICES GROUP, INC.                          "
    },
    {
        "type": "CORP",
        "mpid": "OBWS",
        "clearingBroker": "0226",
        "brokerName": "OBERWEIS SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "OCAC",
        "clearingBroker": "0235",
        "brokerName": "OLSON, CROSS & ALAMO LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "OCEA",
        "clearingBroker": "0052",
        "brokerName": "OCEAN FINANCIAL SERVICES, LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "OCON",
        "clearingBroker": "0103",
        "brokerName": "O'CONNOR & CO SECURITIES                                              "
    },
    {
        "type": "CORP",
        "mpid": "ODEO",
        "clearingBroker": "0388",
        "brokerName": "ODEON CAP                                                             "
    },
    {
        "type": "CORP",
        "mpid": "ODNC",
        "clearingBroker": "0235",
        "brokerName": "ODEON CAPITAL GROUP LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "OFGF",
        "clearingBroker": "0235",
        "brokerName": "OFG FINANCIAL SERVICES INC                                            "
    },
    {
        "type": "CORP",
        "mpid": "OGTL",
        "clearingBroker": "0005",
        "brokerName": "OUTSET GLOBAL TRADING LIMITED                                         "
    },
    {
        "type": "CORP",
        "mpid": "OHIO",
        "clearingBroker": "0443",
        "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "OLDM",
        "clearingBroker": "0005",
        "brokerName": "OLD MISSION CAPITAL, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "OLNE",
        "clearingBroker": "0279",
        "brokerName": "OLDEN LANE SECURITIES, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "OMSL",
        "clearingBroker": "0158",
        "brokerName": "OM SECURITIES, LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "ONEL",
        "clearingBroker": "0161",
        "brokerName": "O'NEIL (WILLIAM) & CO                                                 "
    },
    {
        "type": "CORP",
        "mpid": "ONES",
        "clearingBroker": "0443",
        "brokerName": "O N EQUITY SALES CO.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "OPCO",
        "clearingBroker": "0571",
        "brokerName": "OPPENHEIMER & CO. INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "OPTF",
        "clearingBroker": "0005",
        "brokerName": "OPTIVER US LLC                                                        "
    },
    {
        "type": "CORP",
        "mpid": "ORTL",
        "clearingBroker": "0443",
        "brokerName": "ORIENTAL FINANCIAL SERVICES                                           "
    },
    {
        "type": "CORP",
        "mpid": "OSIC",
        "clearingBroker": "0226",
        "brokerName": "OSAIC INSTITUTIONS, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "OTCN",
        "clearingBroker": "0158",
        "brokerName": "OTC LINK LLC                                                          "
    },
    {
        "type": "CORP",
        "mpid": "OYLD",
        "clearingBroker": "0235",
        "brokerName": "OPENYIELD TRADING LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "PACK",
        "clearingBroker": "0279",
        "brokerName": "PACKERLAND BROKERAGE SERVICES                                         "
    },
    {
        "type": "CORP",
        "mpid": "PACT",
        "clearingBroker": "0443",
        "brokerName": "BTG PACTUAL US CAPITAL LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "PAMC",
        "clearingBroker": "0226",
        "brokerName": "PROGRESSIVE ASSET MANAGEMENT                                          "
    },
    {
        "type": "CORP",
        "mpid": "PAPA",
        "clearingBroker": "0443",
        "brokerName": "PAPAMARKOU WELLNER & CO., INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "PARI",
        "clearingBroker": "0630",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "CORP",
        "mpid": "PARK",
        "clearingBroker": "0750",
        "brokerName": "PARK WALK CAPITAL MARKETS, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "PARV",
        "clearingBroker": "0443",
        "brokerName": "PAR5 CAPITAL & CO LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "PASC",
        "clearingBroker": "0443",
        "brokerName": "PARK AVENUE SECURITIES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "PASL",
        "clearingBroker": "0443",
        "brokerName": "PERSHING ADVISOR SOLUTIONS, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "PATR",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "PAUL",
        "clearingBroker": "0595",
        "brokerName": "PAULSON INVESTMENT COMPANY, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "PBON",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "PBSL",
        "clearingBroker": "0725",
        "brokerName": "PEAK BROKERAGE SERVICES, LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "PCCA",
        "clearingBroker": "0279",
        "brokerName": "PEACHCAP SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "PCIS",
        "clearingBroker": "0226",
        "brokerName": "BANKOH INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "PCSB",
        "clearingBroker": "0443",
        "brokerName": "PRIVATE CLIENT SERVICES, LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "PEER",
        "clearingBroker": "0226",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "CORP",
        "mpid": "PENG",
        "clearingBroker": "0443",
        "brokerName": "PENNSYLVANIA GROUP INCORPORATED (THE)                                 "
    },
    {
        "type": "CORP",
        "mpid": "PERC",
        "clearingBroker": "0279",
        "brokerName": "PERCIVAL FINANCIAL PARTNERS, LTD.                                     "
    },
    {
        "type": "CORP",
        "mpid": "PERS",
        "clearingBroker": "0443",
        "brokerName": "PERSHING LLC                                                          "
    },
    {
        "type": "CORP",
        "mpid": "PFCG",
        "clearingBroker": "0279",
        "brokerName": "PREFERRED CLIENT GROUP, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "PFCL",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "PFDC",
        "clearingBroker": "0235",
        "brokerName": "PREFERRED CAPITAL SECURITIES, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "PFPI",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
    },
    {
        "type": "CORP",
        "mpid": "PHBP",
        "clearingBroker": "0052",
        "brokerName": "PENNHAVEN BROKERAGE PARTNERS, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "PHIN",
        "clearingBroker": "0443",
        "brokerName": "PHILADELPHIA INVESTORS, LTD.                                          "
    },
    {
        "type": "CORP",
        "mpid": "PHRS",
        "clearingBroker": "0279",
        "brokerName": "NAVAID FINANCIAL SERVICES, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "PICE",
        "clearingBroker": "0443",
        "brokerName": "T ROWE PRICE INVESTMENT SERV                                          "
    },
    {
        "type": "CORP",
        "mpid": "PICI",
        "clearingBroker": "0279",
        "brokerName": "POLAR INVESTMENT COUNSEL, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "PICL",
        "clearingBroker": "0052",
        "brokerName": "PAULSON INVESTMENT COMPANY LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "PIMS",
        "clearingBroker": "0226",
        "brokerName": "PRUDENTIAL INVESTMENT MANAGEMENT SERVICES, LLC                        "
    },
    {
        "type": "CORP",
        "mpid": "PINA",
        "clearingBroker": "0141",
        "brokerName": "PINNACLE INVESTMENTS, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "PIPR",
        "clearingBroker": "0443",
        "brokerName": "PIPER SANDLER & CO.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "PIRR",
        "clearingBroker": "0443",
        "brokerName": "PIRRONE & CO., INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "PISC",
        "clearingBroker": "0750",
        "brokerName": "PACIFIC INVESTMENT SECURITIES CORP.                                   "
    },
    {
        "type": "CORP",
        "mpid": "PJEF",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "CORP",
        "mpid": "PKAX",
        "clearingBroker": "0158",
        "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "PLAT",
        "clearingBroker": "0443",
        "brokerName": "CLARKSONS PLATOU SECURITIES, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "PMAS",
        "clearingBroker": "0443",
        "brokerName": "PMA SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "PNCC",
        "clearingBroker": "0226",
        "brokerName": "PNC INVESTMENTS                                                       "
    },
    {
        "type": "CORP",
        "mpid": "PNCM",
        "clearingBroker": "2835",
        "brokerName": "PNC CAPITAL MARKETS LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "PNFP",
        "clearingBroker": "0279",
        "brokerName": "PNFP CAPITAL MARKETS, INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "PNSA",
        "clearingBroker": "0235",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "PNSR",
        "clearingBroker": "0161",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "PODE",
        "clearingBroker": "0235",
        "brokerName": "PODESTA & CO.                                                         "
    },
    {
        "type": "CORP",
        "mpid": "POOH",
        "clearingBroker": "0443",
        "brokerName": "QUESTAR CAPITAL CORPORATION                                           "
    },
    {
        "type": "CORP",
        "mpid": "POPS",
        "clearingBroker": "0226",
        "brokerName": "POPULAR SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "POWL",
        "clearingBroker": "0443",
        "brokerName": "POWELL (ELMER E.) COMPANY                                             "
    },
    {
        "type": "CORP",
        "mpid": "PPSI",
        "clearingBroker": "0235",
        "brokerName": "PENSION PLANNERS SECURITIES, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "PPSL",
        "clearingBroker": "0413",
        "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "PREB",
        "clearingBroker": "0005",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "PRFA",
        "clearingBroker": "0235",
        "brokerName": "PROOF SERVICES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "PRGI",
        "clearingBroker": "0443",
        "brokerName": "PORTFOLIO RESOURCES GROUP, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "PROE",
        "clearingBroker": "0443",
        "brokerName": "PROEQUITIES, INC.                                                     "
    },
    {
        "type": "CORP",
        "mpid": "PRPO",
        "clearingBroker": "0443",
        "brokerName": "PRIVATE PORTFOLIO, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "PRSB",
        "clearingBroker": "0141",
        "brokerName": "PRESIDENTIAL BROKERAGE, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "PRSI",
        "clearingBroker": "0103",
        "brokerName": "GLOBALINK SECURITIES                                                  "
    },
    {
        "type": "CORP",
        "mpid": "PRST",
        "clearingBroker": "0551",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "PSII",
        "clearingBroker": "0226",
        "brokerName": "KESTRA INVESTMENT SERVICES, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "PSIM",
        "clearingBroker": "0226",
        "brokerName": "PRINCIPAL SECURITIES, INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "PSIN",
        "clearingBroker": "0443",
        "brokerName": "LUMENT SECURITIES, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "PSUT",
        "clearingBroker": "0235",
        "brokerName": "INNOVATION PARTNERS LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "PTCM",
        "clearingBroker": "0443",
        "brokerName": "CAVU SECURITIES LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "PTIS",
        "clearingBroker": "0235",
        "brokerName": "PTI SECURITIES & FUTURES L.P.                                         "
    },
    {
        "type": "CORP",
        "mpid": "PUPL",
        "clearingBroker": "0226",
        "brokerName": "PUPLAVA SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "PURP",
        "clearingBroker": "0279",
        "brokerName": "LIBERTY CAPITAL INVESTMENT CORPORATION                                "
    },
    {
        "type": "CORP",
        "mpid": "PWAS",
        "clearingBroker": "0443",
        "brokerName": "PWA SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "PWJC",
        "clearingBroker": "0221",
        "brokerName": "UBS FINANCIAL SERVICES INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "PXGJ",
        "clearingBroker": "0352",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "QBND",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "CORP",
        "mpid": "QBSI",
        "clearingBroker": "0226",
        "brokerName": "GLEN EAGLE WEALTH, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "QCAP",
        "clearingBroker": "0235",
        "brokerName": "QUINT CAPITAL CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "QCAS",
        "clearingBroker": "0226",
        "brokerName": "QUINCY CASS ASSOCIATES, INCORPORATED                                  "
    },
    {
        "type": "CORP",
        "mpid": "QMSR",
        "clearingBroker": "0235",
        "brokerName": "QUATTRO M SECURITIES INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "QUOI",
        "clearingBroker": "0279",
        "brokerName": "QUOIN CAPITAL LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "QWIK",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "CORP",
        "mpid": "RAAA",
        "clearingBroker": "0052",
        "brokerName": "RICHARD JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "RAAI",
        "clearingBroker": "0226",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "RABO",
        "clearingBroker": "0443",
        "brokerName": "RABO SECURITIES USA, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "RACO",
        "clearingBroker": "0158",
        "brokerName": "SHEARMAN, RALSTON, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "RAJA",
        "clearingBroker": "0725",
        "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "RAJC",
        "clearingBroker": "0443",
        "brokerName": "RAYMOND JAMES USA                                                     "
    },
    {
        "type": "CORP",
        "mpid": "RAYG",
        "clearingBroker": "0443",
        "brokerName": "BOLTON GLOBAL CAPITAL                                                 "
    },
    {
        "type": "CORP",
        "mpid": "RBAC",
        "clearingBroker": "0443",
        "brokerName": "ROBERT B. AUSDAL & CO. INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "RBCD",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "CORP",
        "mpid": "RBCM",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "CORP",
        "mpid": "RBCX",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "CORP",
        "mpid": "RBII",
        "clearingBroker": "0279",
        "brokerName": "REGIONAL BROKERS, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "RCMA",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS ARBITRAGE, S.A.                                   "
    },
    {
        "type": "CORP",
        "mpid": "RCRS",
        "clearingBroker": "0226",
        "brokerName": "ROOSEVELT & CROSS, INCORPORATED                                       "
    },
    {
        "type": "CORP",
        "mpid": "RDSS",
        "clearingBroker": "0141",
        "brokerName": "RDSC, LLC                                                             "
    },
    {
        "type": "CORP",
        "mpid": "REGN",
        "clearingBroker": "0443",
        "brokerName": "REGIONS SECURITIES LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "REGR",
        "clearingBroker": "0141",
        "brokerName": "REGISTER & AKERS INVESTMENTS, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "REVL",
        "clearingBroker": "0750",
        "brokerName": "REVL SECURITIES, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "RFAI",
        "clearingBroker": "0725",
        "brokerName": "RYAN FINANCIAL, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "RFRC",
        "clearingBroker": "0279",
        "brokerName": "THE ROCKWELL FINANCIAL GROUP, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "RGLD",
        "clearingBroker": "0279",
        "brokerName": "REGAL SECURITIES, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "RGLS",
        "clearingBroker": "0235",
        "brokerName": "REGAL SECURITIES, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "RHDS",
        "clearingBroker": "0141",
        "brokerName": "RHODES SECURITIES, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "RHOX",
        "clearingBroker": "0005",
        "brokerName": "XR SECURITIES LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "RIAP",
        "clearingBroker": "0443",
        "brokerName": "OSAIC SERVICES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "RICE",
        "clearingBroker": "0235",
        "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
    },
    {
        "type": "CORP",
        "mpid": "RICJ",
        "clearingBroker": "0235",
        "brokerName": "RICE SECURITIES, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "RICM",
        "clearingBroker": "0595",
        "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
    },
    {
        "type": "CORP",
        "mpid": "RIED",
        "clearingBroker": "0235",
        "brokerName": "RIEDL, FIRST SECURITIES COMPANY OF KANSAS                             "
    },
    {
        "type": "CORP",
        "mpid": "RILY",
        "clearingBroker": "0226",
        "brokerName": "B. RILEY FBR, INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "RJFI",
        "clearingBroker": "0390",
        "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "RJFS",
        "clearingBroker": "0725",
        "brokerName": "RAYMOND JAMES FINANCIAL SVCS. INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "RKWS",
        "clearingBroker": "0235",
        "brokerName": "ROCKWELL SECURITIES LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "RLIN",
        "clearingBroker": "0005",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "RMAC",
        "clearingBroker": "0235",
        "brokerName": "RENAISSANCE MACRO SECURITIES, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "RMPI",
        "clearingBroker": "0141",
        "brokerName": "RICHARDS, MERRILL & PETERSON, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "RMST",
        "clearingBroker": "0443",
        "brokerName": "R.M. STARK & CO., INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "ROAR",
        "clearingBroker": "0103",
        "brokerName": "DINOSAUR SECURITIES                                                   "
    },
    {
        "type": "CORP",
        "mpid": "ROBT",
        "clearingBroker": "0443",
        "brokerName": "ROBOTTI & COMPANY, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "ROCK",
        "clearingBroker": "0226",
        "brokerName": "ROCKEFELLER FINANCIAL LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "ROCM",
        "clearingBroker": "0443",
        "brokerName": "RIM SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "ROMO",
        "clearingBroker": "0141",
        "brokerName": "ROMANO BROTHERS AND COMPANY                                           "
    },
    {
        "type": "CORP",
        "mpid": "RONI",
        "clearingBroker": "0005",
        "brokerName": "RONIN CAPITAL, LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "ROTB",
        "clearingBroker": "0235",
        "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "ROTH",
        "clearingBroker": "0161",
        "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "ROYL",
        "clearingBroker": "0443",
        "brokerName": "ROYAL ALLIANCE ASSOCIATES, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "RPTR",
        "clearingBroker": "0235",
        "brokerName": "DINOSAUR SECURITIES, L.L.C.                                           "
    },
    {
        "type": "CORP",
        "mpid": "RQDR",
        "clearingBroker": "0235",
        "brokerName": "RQD* CLEARING LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "RREZ",
        "clearingBroker": "0443",
        "brokerName": "SAMUEL A RAMIREZ & CO., INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "RRII",
        "clearingBroker": "0388",
        "brokerName": "ROBERTS & RYAN INVESTMENTS, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "RRUD",
        "clearingBroker": "0235",
        "brokerName": "REID & RUDIGER, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "RSCM",
        "clearingBroker": "0235",
        "brokerName": "ROBERTSON STEPHENS CAPITAL MARKETS, LLC                               "
    },
    {
        "type": "CORP",
        "mpid": "RSSE",
        "clearingBroker": "0443",
        "brokerName": "RUSSELL IMPLEMENTATION SERVICES INC. PART OF RUSSE                    "
    },
    {
        "type": "CORP",
        "mpid": "RTHS",
        "clearingBroker": "0443",
        "brokerName": "ROTHSCHILD INVESTMENT CORPORATION                                     "
    },
    {
        "type": "CORP",
        "mpid": "RWSM",
        "clearingBroker": "0279",
        "brokerName": "R.W. SMITH & ASSOCIATES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "RYDS",
        "clearingBroker": "0235",
        "brokerName": "RBC DOMINION SECURITIES CORPORATION                                   "
    },
    {
        "type": "CORP",
        "mpid": "SABS",
        "clearingBroker": "0443",
        "brokerName": "SABADELL SECURITIES USA, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "SAFX",
        "clearingBroker": "0235",
        "brokerName": "SAF FINANCIAL SECURITIES LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "SAGE",
        "clearingBroker": "0141",
        "brokerName": "SAGE, RUTTY & CO., INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "SALB",
        "clearingBroker": "0274",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC./SALOMON BROTHERS                        "
    },
    {
        "type": "CORP",
        "mpid": "SALI",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "SAMI",
        "clearingBroker": "0226",
        "brokerName": "SAMI BROKERAGE LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "SANT",
        "clearingBroker": "0443",
        "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "SAPA",
        "clearingBroker": "0141",
        "brokerName": "SAPERSTON ASSET MANAGEMENT INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "SARG",
        "clearingBroker": "0226",
        "brokerName": "PURSHE KAPLAN STERLING INVESTMENTS, INC.                              "
    },
    {
        "type": "CORP",
        "mpid": "SAXO",
        "clearingBroker": "0443",
        "brokerName": "SAXONY SECURITIES                                                     "
    },
    {
        "type": "CORP",
        "mpid": "SBAM",
        "clearingBroker": "0443",
        "brokerName": "INVESTMENT PROFESSIONALS, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "SBLS",
        "clearingBroker": "0235",
        "brokerName": "SAN BLAS SECURITIES LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "SBLT",
        "clearingBroker": "0226",
        "brokerName": "SUNBELT SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "SBRO",
        "clearingBroker": "0443",
        "brokerName": "STERN BROTHERS & CO.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "SBRT",
        "clearingBroker": "0226",
        "brokerName": "SIEBERT(MURIEL) & CO.,INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "SBRX",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "SBSC",
        "clearingBroker": "0226",
        "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
    },
    {
        "type": "CORP",
        "mpid": "SBSI",
        "clearingBroker": "0103",
        "brokerName": "SUN'S BROTHERS SECURITIES INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "SBSL",
        "clearingBroker": "1043",
        "brokerName": "STOCKBLOCK SECURITIES LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "SCAP",
        "clearingBroker": "0595",
        "brokerName": "STRONG CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "SCIL",
        "clearingBroker": "0052",
        "brokerName": "STRATEGIC CAPITAL INVESTMENTS, LLC                                    "
    },
    {
        "type": "CORP",
        "mpid": "SCMC",
        "clearingBroker": "0096",
        "brokerName": "SCOTIA CAPITAL MARKETS (USA) INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "SCSS",
        "clearingBroker": "0750",
        "brokerName": "STONECASTLE SECURITIES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "SCTI",
        "clearingBroker": "0443",
        "brokerName": "SECURITY CAPITAL BROKERAGE, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "SCTL",
        "clearingBroker": "0443",
        "brokerName": "SENTINEL SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "SDDC",
        "clearingBroker": "0443",
        "brokerName": "SDDCO BROKERAGE AQDVISORS                                             "
    },
    {
        "type": "CORP",
        "mpid": "SDIC",
        "clearingBroker": "0235",
        "brokerName": "SAUER DAZEY INVESTMENT CO.                                            "
    },
    {
        "type": "CORP",
        "mpid": "SEAP",
        "clearingBroker": "0226",
        "brokerName": "SEAPORT SECURITIES CORP.                                              "
    },
    {
        "type": "CORP",
        "mpid": "SEBS",
        "clearingBroker": "0443",
        "brokerName": "SECU BROKERAGE SERVICES                                               "
    },
    {
        "type": "CORP",
        "mpid": "SEEL",
        "clearingBroker": "0443",
        "brokerName": "R. SEELAUS & CO., INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "SEFB",
        "clearingBroker": "0052",
        "brokerName": "SOUTHEAST INVESTMENTS, N.C., INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "SEIB",
        "clearingBroker": "0158",
        "brokerName": "SEIBERT (J.D.) & COMPANY INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "SEMI",
        "clearingBroker": "0443",
        "brokerName": "SEMINARIO SECURITIES                                                  "
    },
    {
        "type": "CORP",
        "mpid": "SEMT",
        "clearingBroker": "7311",
        "brokerName": "MINT BROKERS                                                          "
    },
    {
        "type": "CORP",
        "mpid": "SEND",
        "clearingBroker": "0443",
        "brokerName": "SENDERO SECURITIES                                                    "
    },
    {
        "type": "CORP",
        "mpid": "SERL",
        "clearingBroker": "0443",
        "brokerName": "SEARLE & CO.                                                          "
    },
    {
        "type": "CORP",
        "mpid": "SEVN",
        "clearingBroker": "0443",
        "brokerName": "NATIONWIDE SECURITIES                                                 "
    },
    {
        "type": "CORP",
        "mpid": "SFGB",
        "clearingBroker": "0161",
        "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLP                                      "
    },
    {
        "type": "CORP",
        "mpid": "SFPS",
        "clearingBroker": "0443",
        "brokerName": "SF INVESTMENTS, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "SFSI",
        "clearingBroker": "0235",
        "brokerName": "SUPERIOR FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "SGAS",
        "clearingBroker": "0286",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "SGBI",
        "clearingBroker": "0226",
        "brokerName": "SMITH, BROWN & GROOVER, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "SGFC",
        "clearingBroker": "0226",
        "brokerName": "SIGMA FINANCIAL CORPORATION                                           "
    },
    {
        "type": "CORP",
        "mpid": "SGLC",
        "clearingBroker": "0235",
        "brokerName": "S.G. LONG & COMPANY                                                   "
    },
    {
        "type": "CORP",
        "mpid": "SGNL",
        "clearingBroker": "0279",
        "brokerName": "SIGNAL SECURITIES, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "SGSM",
        "clearingBroker": "1043",
        "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "SHMR",
        "clearingBroker": "0443",
        "brokerName": "ABN AMRO CLEARING USA LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "SHOT",
        "clearingBroker": "0005",
        "brokerName": "SCHOTTENFELD GROUP LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "SIAN",
        "clearingBroker": "0443",
        "brokerName": "SECURIAN FINANCIAL SERVICES                                           "
    },
    {
        "type": "CORP",
        "mpid": "SJGM",
        "clearingBroker": "0443",
        "brokerName": "SCOTT JAMES GROUP, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "SKTR",
        "clearingBroker": "0279",
        "brokerName": "STOCK TRADERS                                                         "
    },
    {
        "type": "CORP",
        "mpid": "SLRD",
        "clearingBroker": "0226",
        "brokerName": "S.L. REED & COMPANY                                                   "
    },
    {
        "type": "CORP",
        "mpid": "SMCO",
        "clearingBroker": "0235",
        "brokerName": "SMITH, MOORE & CO.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "SMHI",
        "clearingBroker": "0443",
        "brokerName": "SANDERS MORRIS HARRIS INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "SMNS",
        "clearingBroker": "0226",
        "brokerName": "PARKLAND SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "SMPR",
        "clearingBroker": "0443",
        "brokerName": "SUMMIT BROKERAGE SERVICES, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "SMRD",
        "clearingBroker": "0443",
        "brokerName": "SUMRIDGE PARTNERS, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "SMRI",
        "clearingBroker": "0226",
        "brokerName": "SECURITIES MANAGEMENT & RESEARCH, INC.                                "
    },
    {
        "type": "CORP",
        "mpid": "SNEX",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "SNWS",
        "clearingBroker": "0443",
        "brokerName": "SNOWDEN ACCOUNT SERVICES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "SOCO",
        "clearingBroker": "0443",
        "brokerName": "CAPITAL ONE SECURITIES, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "SOFI",
        "clearingBroker": "0158",
        "brokerName": "SOFI SECURITIES LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "SOGO",
        "clearingBroker": "0158",
        "brokerName": "WANG INVESTMENT ASSOCIATES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "SORS",
        "clearingBroker": "0235",
        "brokerName": "SORSBY FINANCIAL CORP.                                                "
    },
    {
        "type": "CORP",
        "mpid": "SOVG",
        "clearingBroker": "8199",
        "brokerName": "SOVEREIGN GLOBAL ADVISORS, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "SPAC",
        "clearingBroker": "0793",
        "brokerName": "SIERRA PACIFIC SECURITIES, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "SPCS",
        "clearingBroker": "0052",
        "brokerName": "SPARTAN CAPITAL SECURITIES, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "SPEX",
        "clearingBroker": "0235",
        "brokerName": "INSPEREX LLC                                                          "
    },
    {
        "type": "CORP",
        "mpid": "SPGS",
        "clearingBroker": "0443",
        "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "SPHN",
        "clearingBroker": "0443",
        "brokerName": "STEPHENS INC.                                                         "
    },
    {
        "type": "CORP",
        "mpid": "SPLC",
        "clearingBroker": "0226",
        "brokerName": "SPIRE SECURITIES, LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "SPLD",
        "clearingBroker": "0443",
        "brokerName": "SPIRE SECURITIES, LLC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "SPLN",
        "clearingBroker": "8199",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "SPOT",
        "clearingBroker": "0005",
        "brokerName": "SPOT TRADING                                                          "
    },
    {
        "type": "CORP",
        "mpid": "SPTD",
        "clearingBroker": "0052",
        "brokerName": "MINT GLOBAL MARKETS, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "SPTS",
        "clearingBroker": "0158",
        "brokerName": "SEVEN POINTS CAPITAL, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "SRAM",
        "clearingBroker": "0443",
        "brokerName": "SAMCO CAPITAL MARKETS, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "SRBC",
        "clearingBroker": "0235",
        "brokerName": "SPIDERROCK EXS, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "SSBS",
        "clearingBroker": "0443",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "SSCO",
        "clearingBroker": "8457",
        "brokerName": "SAFRA SECURITIES LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "SSGC",
        "clearingBroker": "0226",
        "brokerName": "SIGNATURE SECURITIES                                                  "
    },
    {
        "type": "CORP",
        "mpid": "SSGM",
        "clearingBroker": "0226",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "SSGR",
        "clearingBroker": "0443",
        "brokerName": "SHAREHOLDERS SERVICES GROUP INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "SSIN",
        "clearingBroker": "0226",
        "brokerName": "TRUIST INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "SSLC",
        "clearingBroker": "0279",
        "brokerName": "SANDERLIN SECURITIES, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "SSLL",
        "clearingBroker": "0189",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "SSNE",
        "clearingBroker": "0226",
        "brokerName": "SANTANDER SECURITIES LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "SSNG",
        "clearingBroker": "0443",
        "brokerName": "SISUNG SECURITIES CORPORATION                                         "
    },
    {
        "type": "CORP",
        "mpid": "STCM",
        "clearingBroker": "2095",
        "brokerName": "TRUIST SECURITIES, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "STEP",
        "clearingBroker": "0235",
        "brokerName": "FERRETTI GROUP, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "STFC",
        "clearingBroker": "0443",
        "brokerName": "STUART FRANKEL & CO., INCORPORATED                                    "
    },
    {
        "type": "CORP",
        "mpid": "STFG",
        "clearingBroker": "0443",
        "brokerName": "STANFORD GROUP COMPANY                                                "
    },
    {
        "type": "CORP",
        "mpid": "STFL",
        "clearingBroker": "0793",
        "brokerName": "STIFEL, NICOLAUS & COMPANY, INCORPORATED                              "
    },
    {
        "type": "CORP",
        "mpid": "STGC",
        "clearingBroker": "0279",
        "brokerName": "STERLING GRACE MUNICIPAL SECURITIES CO                                "
    },
    {
        "type": "CORP",
        "mpid": "STKP",
        "clearingBroker": "0158",
        "brokerName": "STOCKPILE INVESTMENTS, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "STOX",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "STRM",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "CORP",
        "mpid": "STRS",
        "clearingBroker": "0161",
        "brokerName": "STRATEGAS RESEARCH PARTNERS, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "STSM",
        "clearingBroker": "0443",
        "brokerName": "STERLING SMITH CORPORATION                                            "
    },
    {
        "type": "CORP",
        "mpid": "STTT",
        "clearingBroker": "0052",
        "brokerName": "STATETRUST INVESTMENTS INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "STUR",
        "clearingBroker": "0158",
        "brokerName": "STURDIVANT & CO., INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "STXG",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "STXW",
        "clearingBroker": "0443",
        "brokerName": "SA STONE WEALTH MANAGEMENT INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "SUFI",
        "clearingBroker": "0551",
        "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "SUMI",
        "clearingBroker": "0443",
        "brokerName": "SMBC NIKKO SECURITIES AMERICA, INC.                                   "
    },
    {
        "type": "CORP",
        "mpid": "SUSQ",
        "clearingBroker": "0551",
        "brokerName": "SUSQUEHANNA CAPITAL GROUP                                             "
    },
    {
        "type": "CORP",
        "mpid": "SUST",
        "clearingBroker": "0235",
        "brokerName": "SUNSTREET SECURITIES, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "SVSI",
        "clearingBroker": "0725",
        "brokerName": "SILICON VALLEY SECURITIES, INC                                        "
    },
    {
        "type": "CORP",
        "mpid": "SWBC",
        "clearingBroker": "0443",
        "brokerName": "SWBC INVESTMENT SERVICES, LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "SWSS",
        "clearingBroker": "0443",
        "brokerName": "SANCTUARY SECURITIES, INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "SWST",
        "clearingBroker": "0279",
        "brokerName": "HILLTOP SECURITIES INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "SYCA",
        "clearingBroker": "0443",
        "brokerName": "SYNDICATED CAPITAL, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "TAFI",
        "clearingBroker": "0443",
        "brokerName": "NATHAN HALE CAPITAL, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "TAGB",
        "clearingBroker": "0052",
        "brokerName": "TAGLICH BROTHERS, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "TAGC",
        "clearingBroker": "1043",
        "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "TAGD",
        "clearingBroker": "1043",
        "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "TALR",
        "clearingBroker": "0725",
        "brokerName": "TAYLOR SECURITIES, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "TBCL",
        "clearingBroker": "0750",
        "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "TBCR",
        "clearingBroker": "0235",
        "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "TBIA",
        "clearingBroker": "0158",
        "brokerName": "TRADIER BROKERAGE, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "TBIS",
        "clearingBroker": "0158",
        "brokerName": "TRADIER BROKERAGE, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "TBRD",
        "clearingBroker": "0226",
        "brokerName": "THOROUGHBRED FINANCIAL SERVICES, LLC                                  "
    },
    {
        "type": "CORP",
        "mpid": "TCBI",
        "clearingBroker": "0443",
        "brokerName": "TCBI SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "TDCO",
        "clearingBroker": "0235",
        "brokerName": "THOMPSON DAVIS & CO., INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "TDFS",
        "clearingBroker": "0052",
        "brokerName": "TRADERFIELD SECURITIES INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "TDNF",
        "clearingBroker": "2568",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "TDPA",
        "clearingBroker": "0226",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "TDPW",
        "clearingBroker": "0443",
        "brokerName": "TD PRIVATE CLIENT WEALTH, LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "TDSI",
        "clearingBroker": "2568",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "TEDP",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "TERA",
        "clearingBroker": "0443",
        "brokerName": "CETERA FINANCIAL SPECIALISTS                                          "
    },
    {
        "type": "CORP",
        "mpid": "TFAI",
        "clearingBroker": "0226",
        "brokerName": "TRANSAMERICA FINANCIAL ADVISORS, INC.                                 "
    },
    {
        "type": "CORP",
        "mpid": "TFAS",
        "clearingBroker": "0443",
        "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
    },
    {
        "type": "CORP",
        "mpid": "TFSL",
        "clearingBroker": "0235",
        "brokerName": "TECKMEYER FINANCIAL SERVICES                                          "
    },
    {
        "type": "CORP",
        "mpid": "TFSS",
        "clearingBroker": "0443",
        "brokerName": "TFS SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "TGHS",
        "clearingBroker": "0443",
        "brokerName": "TGH SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "THEM",
        "clearingBroker": "0235",
        "brokerName": "THEMIS TRADING LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "THNK",
        "clearingBroker": "0052",
        "brokerName": "THINKEQUITY, LLC                                                      "
    },
    {
        "type": "CORP",
        "mpid": "TIAD",
        "clearingBroker": "8199",
        "brokerName": "TRIAD SECURITIES                                                      "
    },
    {
        "type": "CORP",
        "mpid": "TIAN",
        "clearingBroker": "0226",
        "brokerName": "TRIAD SECURITIES CORP                                                 "
    },
    {
        "type": "CORP",
        "mpid": "TIGC",
        "clearingBroker": "0235",
        "brokerName": "NELSONREID, INC.                                                      "
    },
    {
        "type": "CORP",
        "mpid": "TIGE",
        "clearingBroker": "1043",
        "brokerName": "US TIGER SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "TJMB",
        "clearingBroker": "1043",
        "brokerName": "TJM INVESTMENTS, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "TKNG",
        "clearingBroker": "0158",
        "brokerName": "TRADEKING LLC                                                         "
    },
    {
        "type": "CORP",
        "mpid": "TMAS",
        "clearingBroker": "0235",
        "brokerName": "TRADEMAS INC.                                                         "
    },
    {
        "type": "CORP",
        "mpid": "TMCC",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "CORP",
        "mpid": "TMCD",
        "clearingBroker": "0235",
        "brokerName": "MCDONALD PARTNERS LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "TOCQ",
        "clearingBroker": "0443",
        "brokerName": "TOCQUEVILLE SECURITIES L.P.                                           "
    },
    {
        "type": "CORP",
        "mpid": "TONE",
        "clearingBroker": "8199",
        "brokerName": "2021 CAPITAL                                                          "
    },
    {
        "type": "CORP",
        "mpid": "TORO",
        "clearingBroker": "0279",
        "brokerName": "VALDES & MORENO, INC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "TOUR",
        "clearingBroker": "0005",
        "brokerName": "TOURMALINE PARTNERS, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "TOYS",
        "clearingBroker": "0443",
        "brokerName": "TOYOTA FINANCIAL SERVICES SECURITIES USA CORPORATION                  "
    },
    {
        "type": "CORP",
        "mpid": "TPCD",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "TPIS",
        "clearingBroker": "0161",
        "brokerName": "TULLETT PREBON FINANCIAL SERVICES, LLC                                "
    },
    {
        "type": "CORP",
        "mpid": "TPMG",
        "clearingBroker": "0005",
        "brokerName": "TOWER PRINCIPAL MARKETS LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "TPMR",
        "clearingBroker": "0141",
        "brokerName": "TRADE-PMR INC.                                                        "
    },
    {
        "type": "CORP",
        "mpid": "TRAD",
        "clearingBroker": "0271",
        "brokerName": "TRADESTATION SECURITIES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "TRCG",
        "clearingBroker": "0005",
        "brokerName": "TRC MARKETS LLC                                                       "
    },
    {
        "type": "CORP",
        "mpid": "TRCS",
        "clearingBroker": "0388",
        "brokerName": "TIGERRISK CAPITAL MARKETS & ADVISORY                                  "
    },
    {
        "type": "CORP",
        "mpid": "TREX",
        "clearingBroker": "1043",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "CORP",
        "mpid": "TRIB",
        "clearingBroker": "0235",
        "brokerName": "TRIBAL CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "TRIP",
        "clearingBroker": "0235",
        "brokerName": "TRIDENT PARTNERS LTD                                                  "
    },
    {
        "type": "CORP",
        "mpid": "TRSH",
        "clearingBroker": "0279",
        "brokerName": "THRASHER & CHAMBERS, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "TRUB",
        "clearingBroker": "0141",
        "brokerName": "TRUBEE, COLLINS & CO., INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "TRWN",
        "clearingBroker": "0443",
        "brokerName": "T.R. WINSTON & COMPANY, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "TRYC",
        "clearingBroker": "0158",
        "brokerName": "SIXTEEN SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "TRYN",
        "clearingBroker": "0279",
        "brokerName": "FIRST TRYON SECURITIES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "TSCD",
        "clearingBroker": "0235",
        "brokerName": "STURGES COMPANY (THE)                                                 "
    },
    {
        "type": "CORP",
        "mpid": "TSER",
        "clearingBroker": "0161",
        "brokerName": "TWO SIGMA EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "TSFA",
        "clearingBroker": "0443",
        "brokerName": "STRATEGIC FINANCIAL ALLIANCE (THE)                                    "
    },
    {
        "type": "CORP",
        "mpid": "TSSM",
        "clearingBroker": "0161",
        "brokerName": "TWO SIGMA SECURITIES, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "TTSC",
        "clearingBroker": "0052",
        "brokerName": "TREND TRADE SECURITIES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "TTSI",
        "clearingBroker": "0158",
        "brokerName": "T3 SECURITIES, INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "TWCM",
        "clearingBroker": "0443",
        "brokerName": "TOWERS WATSON CAPITAL MARKETS                                         "
    },
    {
        "type": "CORP",
        "mpid": "TWDI",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "TWDL",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "TWDP",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "TWDR",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "TWDS",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "TWTT",
        "clearingBroker": "0158",
        "brokerName": "TASTYWORKS, INC.                                                      "
    },
    {
        "type": "CORP",
        "mpid": "UBSI",
        "clearingBroker": "0141",
        "brokerName": "UNITED BROKERAGE SERVICES, INC                                        "
    },
    {
        "type": "CORP",
        "mpid": "UBSW",
        "clearingBroker": "0642",
        "brokerName": "UBS SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "UCAP",
        "clearingBroker": "0750",
        "brokerName": "UCAP SECURITIES LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "UCCM",
        "clearingBroker": "0279",
        "brokerName": "CU INVESTMENT SOLUTIONS, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "UCML",
        "clearingBroker": "0052",
        "brokerName": "UNITED CAPITAL MARKETS, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "UFPF",
        "clearingBroker": "0226",
        "brokerName": "UNITED FIRST PARTNERS, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "UHLM",
        "clearingBroker": "0235",
        "brokerName": "UHLMANN PRICE SECURITIES, LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "UMBF",
        "clearingBroker": "0226",
        "brokerName": "UMB FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "UNIB",
        "clearingBroker": "0443",
        "brokerName": "UNIBANCO SECURITIES INC                                               "
    },
    {
        "type": "CORP",
        "mpid": "UNIV",
        "clearingBroker": "0595",
        "brokerName": "UNIVEST SECURITIES, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "UNTD",
        "clearingBroker": "0443",
        "brokerName": "WADDELL & REED, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "UPLN",
        "clearingBroker": "0443",
        "brokerName": "UNITED PLANNERS FINANCIAL SERVICES OF AMERICA                         "
    },
    {
        "type": "CORP",
        "mpid": "USAF",
        "clearingBroker": "0443",
        "brokerName": "USA FINANCIAL SECURITIES CORP.                                        "
    },
    {
        "type": "CORP",
        "mpid": "USCA",
        "clearingBroker": "0226",
        "brokerName": "USCA SECURITIES LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "USDB",
        "clearingBroker": "0279",
        "brokerName": "U.S. BROKERAGE, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "USIC",
        "clearingBroker": "0226",
        "brokerName": "U.S. SECURITIES, INTL. CORP.                                          "
    },
    {
        "type": "CORP",
        "mpid": "USSI",
        "clearingBroker": "0279",
        "brokerName": "U.S. STERLING SECURITIES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "USTZ",
        "clearingBroker": "0595",
        "brokerName": "TRADEZERO AMERINCA, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "UVST",
        "clearingBroker": "0443",
        "brokerName": "UVEST FINANCIAL SERVICES GROUP, INC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "VABD",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "CORP",
        "mpid": "VALI",
        "clearingBroker": "0226",
        "brokerName": "VALLEY NATIONAL INVESTMENTS, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "VALM",
        "clearingBroker": "0443",
        "brokerName": "VALMARK SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "VBCS",
        "clearingBroker": "0279",
        "brokerName": "VBC SECURITIES                                                        "
    },
    {
        "type": "CORP",
        "mpid": "VBLT",
        "clearingBroker": "0226",
        "brokerName": "VANDERBILT SECURITIES, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "VBSL",
        "clearingBroker": "0595",
        "brokerName": "VISION BROKERAGE SERVICES, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "VCAP",
        "clearingBroker": "0443",
        "brokerName": "VANGUARD CAPITAL                                                      "
    },
    {
        "type": "CORP",
        "mpid": "VCAS",
        "clearingBroker": "0443",
        "brokerName": "VCA SECURITIES, LP                                                    "
    },
    {
        "type": "CORP",
        "mpid": "VCFN",
        "clearingBroker": "0235",
        "brokerName": "VAN CLEMENS & CO. INCORPORATED                                        "
    },
    {
        "type": "CORP",
        "mpid": "VCPL",
        "clearingBroker": "0443",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "VCSV",
        "clearingBroker": "0052",
        "brokerName": "PRIMARY CAPITAL, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "VENE",
        "clearingBroker": "0443",
        "brokerName": "VENECREDIT SECURITIES                                                 "
    },
    {
        "type": "CORP",
        "mpid": "VERF",
        "clearingBroker": "0235",
        "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "VERT",
        "clearingBroker": "8199",
        "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "VEST",
        "clearingBroker": "0750",
        "brokerName": "VESTECH SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "VETS",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN VETERANS GROUP, PBC                                          "
    },
    {
        "type": "CORP",
        "mpid": "VFSL",
        "clearingBroker": "0443",
        "brokerName": "VALOR FINANCIAL SECURITIES LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "VGRD",
        "clearingBroker": "0062",
        "brokerName": "VANGUARD MARKETING CORPORATION                                        "
    },
    {
        "type": "CORP",
        "mpid": "VISI",
        "clearingBroker": "0443",
        "brokerName": "VISION INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "VKMI",
        "clearingBroker": "0692",
        "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "VLEO",
        "clearingBroker": "0158",
        "brokerName": "VOLEO USA, INC                                                        "
    },
    {
        "type": "CORP",
        "mpid": "VMDI",
        "clearingBroker": "0443",
        "brokerName": "DESJARDINS SECURITIES INTERNATIONAL INC.                              "
    },
    {
        "type": "CORP",
        "mpid": "VMEX",
        "clearingBroker": "0443",
        "brokerName": "VECTORGLOBAL WMG                                                      "
    },
    {
        "type": "CORP",
        "mpid": "VPEW",
        "clearingBroker": "0158",
        "brokerName": "VPE WERTPAPIERHANDELSBANK AG                                          "
    },
    {
        "type": "CORP",
        "mpid": "VSIN",
        "clearingBroker": "0595",
        "brokerName": "VISION FINANCIAL MARKETS LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "VSRF",
        "clearingBroker": "0141",
        "brokerName": "VSR FINANCIAL SERVICES                                                "
    },
    {
        "type": "CORP",
        "mpid": "VTDT",
        "clearingBroker": "0158",
        "brokerName": "VIEWTRADE SECURITIES, INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "VTRN",
        "clearingBroker": "0443",
        "brokerName": "BANCROFT CAPITAL, LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "WABR",
        "clearingBroker": "0443",
        "brokerName": "WALL STREET ACCESS                                                    "
    },
    {
        "type": "CORP",
        "mpid": "WACC",
        "clearingBroker": "0279",
        "brokerName": "MIDLAND SECURITIES, LTD                                               "
    },
    {
        "type": "CORP",
        "mpid": "WACL",
        "clearingBroker": "0709",
        "brokerName": "WACHTEL & CO., INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "WAIN",
        "clearingBroker": "0443",
        "brokerName": "H.C. WAINWRIGHT & CO., INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "WBAX",
        "clearingBroker": "0052",
        "brokerName": "WALLACHBETH CAPITAL LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "WBBC",
        "clearingBroker": "0226",
        "brokerName": "WBB SECURITIES, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "WBET",
        "clearingBroker": "0161",
        "brokerName": "WALLACHBETH CAPITAL LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "WBFS",
        "clearingBroker": "0443",
        "brokerName": "WOODBURY FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "WBLR",
        "clearingBroker": "0771",
        "brokerName": "WILLIAM BLAIR & COMPANY, L.L.C.                                       "
    },
    {
        "type": "CORP",
        "mpid": "WBNA",
        "clearingBroker": "2072",
        "brokerName": "WELLS FARGO BANK, N.A./SIG                                            "
    },
    {
        "type": "CORP",
        "mpid": "WBNF",
        "clearingBroker": "0226",
        "brokerName": "WILLIAM BLAIR & COMPANY L.L.C.                                        "
    },
    {
        "type": "CORP",
        "mpid": "WBRO",
        "clearingBroker": "0443",
        "brokerName": "WILEY BROS.-AINTREE CAPITAL, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "WBUL",
        "clearingBroker": "0158",
        "brokerName": "WEBULL FINANCIAL LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "WCHV",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "WCIG",
        "clearingBroker": "0750",
        "brokerName": "WILLOW COVE INVESTMENT GROUP, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "WCSC",
        "clearingBroker": "0235",
        "brokerName": "WILMINGTON CAPITAL SECURITIES, LLC                                    "
    },
    {
        "type": "CORP",
        "mpid": "WCSF",
        "clearingBroker": "0235",
        "brokerName": "WORLD CHOICE SECURITIES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "WEBS",
        "clearingBroker": "0226",
        "brokerName": "WEALTH ENHANCEMENT BROKERAGE SERVICES, LLC                            "
    },
    {
        "type": "CORP",
        "mpid": "WEDB",
        "clearingBroker": "0103",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "WEGE",
        "clearingBroker": "0443",
        "brokerName": "WORLD EQUITY GROUP, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "WEGI",
        "clearingBroker": "0235",
        "brokerName": "WORLD EQUITY GROUP INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "WEGP",
        "clearingBroker": "0235",
        "brokerName": "WESTERN EQUITY GROUP, INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "WESC",
        "clearingBroker": "0443",
        "brokerName": "WELLINGTON SHIELDS & CO., LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "WEST",
        "clearingBroker": "0443",
        "brokerName": "WESTERN GROWERS FINANCIAL SERVICES, INC.                              "
    },
    {
        "type": "CORP",
        "mpid": "WEXM",
        "clearingBroker": "0161",
        "brokerName": "W OLVERINE EXECUTION SERVICES LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "WEXR",
        "clearingBroker": "0235",
        "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "WEXX",
        "clearingBroker": "0005",
        "brokerName": "WOLVERINE EXECUTION SERVICES                                          "
    },
    {
        "type": "CORP",
        "mpid": "WHAE",
        "clearingBroker": "0443",
        "brokerName": "WHARTON EQUITY CORPORATION                                            "
    },
    {
        "type": "CORP",
        "mpid": "WHCG",
        "clearingBroker": "0388",
        "brokerName": "WHITAKER                                                              "
    },
    {
        "type": "CORP",
        "mpid": "WHOT",
        "clearingBroker": "0595",
        "brokerName": "JUST2TRADE, INC.                                                      "
    },
    {
        "type": "CORP",
        "mpid": "WIDS",
        "clearingBroker": "0279",
        "brokerName": "WISCONSIN DISCOUNT SECURITIES CORP.                                   "
    },
    {
        "type": "CORP",
        "mpid": "WING",
        "clearingBroker": "0443",
        "brokerName": "ING FINANCIAL PARTNERS, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "WISC",
        "clearingBroker": "0235",
        "brokerName": "WINDSOR, SHEFFIELD & CO., INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "WISE",
        "clearingBroker": "0052",
        "brokerName": "AXOS INVEST LLC                                                       "
    },
    {
        "type": "CORP",
        "mpid": "WISP",
        "clearingBroker": "0443",
        "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
    },
    {
        "type": "CORP",
        "mpid": "WJBI",
        "clearingBroker": "0443",
        "brokerName": "WJB CAPITAL GROUP                                                     "
    },
    {
        "type": "CORP",
        "mpid": "WLMS",
        "clearingBroker": "0443",
        "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
    },
    {
        "type": "CORP",
        "mpid": "WLTH",
        "clearingBroker": "0235",
        "brokerName": "WEALTHFRONT BROKERAGE CORPORATION                                     "
    },
    {
        "type": "CORP",
        "mpid": "WMCL",
        "clearingBroker": "0279",
        "brokerName": "WHITE MOUNTAIN CAPITAL, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "WMFS",
        "clearingBroker": "0226",
        "brokerName": "WESTMINSTER FINANCIAL SECURITIES, INC.                                "
    },
    {
        "type": "CORP",
        "mpid": "WMLL",
        "clearingBroker": "0005",
        "brokerName": "WATERMILL INSTITUTIONAL TRADING LLC                                   "
    },
    {
        "type": "CORP",
        "mpid": "WOOD",
        "clearingBroker": "0725",
        "brokerName": "ARTHUR W WOOD COMPANY                                                 "
    },
    {
        "type": "CORP",
        "mpid": "WPCC",
        "clearingBroker": "0052",
        "brokerName": "WESTPARK CAPITAL, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "WPCI",
        "clearingBroker": "0595",
        "brokerName": "WESTPARK CAPITAL, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "WPSG",
        "clearingBroker": "0005",
        "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "WPSX",
        "clearingBroker": "0445",
        "brokerName": "RISE FINANCIAL SERVICES, LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "WRET",
        "clearingBroker": "0141",
        "brokerName": "WELLS FARGO CLEARING SERVICES, LLC                                    "
    },
    {
        "type": "CORP",
        "mpid": "WSBI",
        "clearingBroker": "0443",
        "brokerName": "W&S BROKERAGE SVCS                                                    "
    },
    {
        "type": "CORP",
        "mpid": "WSCC",
        "clearingBroker": "0235",
        "brokerName": "WASHINGTON SECURITIES CORPORATION                                     "
    },
    {
        "type": "CORP",
        "mpid": "WSCX",
        "clearingBroker": "0235",
        "brokerName": "WORKMAN SECURITIES CORP                                               "
    },
    {
        "type": "CORP",
        "mpid": "WSEC",
        "clearingBroker": "0443",
        "brokerName": "WILLIS SECURITIES, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "WSGD",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC./P3                                            "
    },
    {
        "type": "CORP",
        "mpid": "WSIW",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "WSRP",
        "clearingBroker": "0052",
        "brokerName": "WESTROCK CAPITAL MANAGEMENT, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "WSTI",
        "clearingBroker": "0226",
        "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
    },
    {
        "type": "CORP",
        "mpid": "WTCO",
        "clearingBroker": "0005",
        "brokerName": "WILLIAMS TRADING LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "WTFS",
        "clearingBroker": "0052",
        "brokerName": "LIME TRADING CORP                                                     "
    },
    {
        "type": "CORP",
        "mpid": "WTKR",
        "clearingBroker": "0388",
        "brokerName": "WHITAKER                                                              "
    },
    {
        "type": "CORP",
        "mpid": "WTLP",
        "clearingBroker": "0388",
        "brokerName": "WOLVERINE TRADING, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "WTRI",
        "clearingBroker": "0235",
        "brokerName": "WATERFORD INVESTORS SERVICES, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "WUND",
        "clearingBroker": "0141",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "CORP",
        "mpid": "WVBD",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "WZVB",
        "clearingBroker": "0725",
        "brokerName": "IMPACTIVE ADVISORS, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "XCNC",
        "clearingBroker": "0005",
        "brokerName": "C&C TRADING L.L.C.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "XPUS",
        "clearingBroker": "0443",
        "brokerName": "XP SECURITIES, LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "XRVR",
        "clearingBroker": "0279",
        "brokerName": "CRB SECURITIES, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "XTLS",
        "clearingBroker": "0052",
        "brokerName": "XTELLUS CAPITAL PARTNERS, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "XTLW",
        "clearingBroker": "0052",
        "brokerName": "XTELLUS CAPITAL PARTNERS, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "XTXE",
        "clearingBroker": "0161",
        "brokerName": "XTX EXECUTION SERVICES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "YLPL",
        "clearingBroker": "0075",
        "brokerName": "LPL FINANCIAL LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "YOSE",
        "clearingBroker": "0052",
        "brokerName": "YORK SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "ZAHK",
        "clearingBroker": "0443",
        "brokerName": "TRANSAMERICA FINANCIAL ADVISORS                                       "
    },
    {
        "type": "CORP",
        "mpid": "ZAND",
        "clearingBroker": "0443",
        "brokerName": "MCLAUGHLIN RYDER INVESTMENTS                                          "
    },
    {
        "type": "CORP",
        "mpid": "ZEDB",
        "clearingBroker": "0161",
        "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "ZERO",
        "clearingBroker": "0158",
        "brokerName": "TRADEZERO AMERICA, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "ZEUS",
        "clearingBroker": "0443",
        "brokerName": "ZEUS FINANCIAL, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "ZION",
        "clearingBroker": "0065",
        "brokerName": "ZIONS DIRECT, INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "ZIVI",
        "clearingBroker": "0235",
        "brokerName": "ZIV INVESTMENT COMPANY                                                "
    },
    {
        "type": "CORP",
        "mpid": "ZOUL",
        "clearingBroker": "0235",
        "brokerName": "N.B. ZOULLAS SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "AALC",
        "clearingBroker": "0226",
        "brokerName": "THRIVENT INVESTMENT MANAGEMENT, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "ABAI",
        "clearingBroker": "0279",
        "brokerName": "ABACUS INVESTMENTS, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "ABBA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABBK",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABDA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABDW",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABEA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABEN",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABHE",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABIG",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABLE",
        "clearingBroker": "0031",
        "brokerName": "NATIXIS SECURITIES AMERICAS LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "ABPI",
        "clearingBroker": "0235",
        "brokerName": "ALLIED BEACON PARTNERS, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "ABPR",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABRP",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABST",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ACAD",
        "clearingBroker": "0443",
        "brokerName": "ACADEMY SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "ACAP",
        "clearingBroker": "0235",
        "brokerName": "ALAMO CAPITAL                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "ACCP",
        "clearingBroker": "0158",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "ACLP",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER CAPITAL, L.P.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "ACTI",
        "clearingBroker": "0443",
        "brokerName": "ACTIVNER SECURITIES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ADAM",
        "clearingBroker": "0161",
        "brokerName": "CANACCORD GENUITY INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "ADSO",
        "clearingBroker": "0141",
        "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "AEFS",
        "clearingBroker": "0226",
        "brokerName": "AE FINANCIAL SERVICES, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "AETL",
        "clearingBroker": "0158",
        "brokerName": "AET INVESTMENT SERVICES, LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "AFBS",
        "clearingBroker": "0158",
        "brokerName": "APEX FINTECH BROKERAGE SERVICES LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "AFCO",
        "clearingBroker": "0284",
        "brokerName": "TD PRIME SERVICES LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "AFGT",
        "clearingBroker": "0052",
        "brokerName": "J. ALDEN ASSOCIATES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "AGCO",
        "clearingBroker": "0052",
        "brokerName": "AUERBACH GRAYSON & COMPANY LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "AGCP",
        "clearingBroker": "0052",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "AGES",
        "clearingBroker": "0750",
        "brokerName": "ADVISORY GROUP EQUITY SERVICES LTD.                                   "
    },
    {
        "type": "MUNI",
        "mpid": "AGFA",
        "clearingBroker": "0226",
        "brokerName": "VALIC FINANCIAL ADVISORS, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "AGIS",
        "clearingBroker": "0235",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "AGPM",
        "clearingBroker": "1043",
        "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
    },
    {
        "type": "MUNI",
        "mpid": "AGSS",
        "clearingBroker": "0443",
        "brokerName": "GREAT AMERICAN ADVISORS, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "AHSI",
        "clearingBroker": "0141",
        "brokerName": "AMERICAN HERITAGE SECURITIES, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "AIGF",
        "clearingBroker": "0443",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "AIGN",
        "clearingBroker": "0226",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "AIRS",
        "clearingBroker": "0279",
        "brokerName": "HAND SECURITIES, INC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "AISG",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN INDEPENDENT SECURITIES GROUP, LLC                            "
    },
    {
        "type": "MUNI",
        "mpid": "AJCO",
        "clearingBroker": "0443",
        "brokerName": "IDB CAPITAL CORP.                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "ALAD",
        "clearingBroker": "0235",
        "brokerName": "ALLIANCE ADVISORY & SECURITIES, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "ALCG",
        "clearingBroker": "0235",
        "brokerName": "ALTITUDE CAPITAL GROUP LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "ALCM",
        "clearingBroker": "0279",
        "brokerName": "ALPHALEDGER MARKETS, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ALDN",
        "clearingBroker": "0052",
        "brokerName": "J. ALDEN ASSOCIATES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ALGP",
        "clearingBroker": "0235",
        "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
    },
    {
        "type": "MUNI",
        "mpid": "ALIS",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER INVESTMENT SERVICES CO.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "ALLS",
        "clearingBroker": "0443",
        "brokerName": "ALLARIA SECURITIES, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "ALNC",
        "clearingBroker": "0226",
        "brokerName": "A.G.P./ALLIANCE GLOBAL PARTNERS                                       "
    },
    {
        "type": "MUNI",
        "mpid": "ALTR",
        "clearingBroker": "3164",
        "brokerName": "ALTRUIST FINANCIAL LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "AMBB",
        "clearingBroker": "0141",
        "brokerName": "ALLEN, MOONEY & BARNES BROKERAGE SERVICES, LLC                        "
    },
    {
        "type": "MUNI",
        "mpid": "AMER",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "MUNI",
        "mpid": "AMGN",
        "clearingBroker": "0443",
        "brokerName": "AMERICAN GENERAL SECURITIES INCORPORATED                              "
    },
    {
        "type": "MUNI",
        "mpid": "AMIC",
        "clearingBroker": "0226",
        "brokerName": "AMERICAN INVESTORS COMPANY                                            "
    },
    {
        "type": "MUNI",
        "mpid": "AMLU",
        "clearingBroker": "3652",
        "brokerName": "LUCID CAPITAL MARKETS, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "AMMI",
        "clearingBroker": "0443",
        "brokerName": "AM&M INVESTMENT BROKERS, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "AMMS",
        "clearingBroker": "0141",
        "brokerName": "AMUNI FINANCIAL, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "ANDB",
        "clearingBroker": "0443",
        "brokerName": "ANDBANC BROKERAGE, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "ANDG",
        "clearingBroker": "0235",
        "brokerName": "GARRETT (ANDREW), INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "ANOS",
        "clearingBroker": "0235",
        "brokerName": "ABEL NOSER, LLC.                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "ANOV",
        "clearingBroker": "0750",
        "brokerName": "ANOVEST FINANCIAL SERVICES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "ANSR",
        "clearingBroker": "0443",
        "brokerName": "ANDERSON & STRUDWICK, INCORPORATED                                    "
    },
    {
        "type": "MUNI",
        "mpid": "AORP",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "APBD",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "APBO",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "APFS",
        "clearingBroker": "0443",
        "brokerName": "AMERICA'S PORTFOLIO'S                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "APRT",
        "clearingBroker": "0226",
        "brokerName": "PARTNERS                                                              "
    },
    {
        "type": "MUNI",
        "mpid": "APTO",
        "clearingBroker": "0103",
        "brokerName": "APTO PARTNERS, LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "APXO",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "APXS",
        "clearingBroker": "0052",
        "brokerName": "APEXUS CAPITAL LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "AQUB",
        "clearingBroker": "0197",
        "brokerName": "AQUA SECURITIES L.P.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "ARBC",
        "clearingBroker": "0235",
        "brokerName": "ARKADIOS CAPITAL                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "ARBR",
        "clearingBroker": "6783",
        "brokerName": "ARBOR RESEARCH & TRADING, LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "ARGA",
        "clearingBroker": "0443",
        "brokerName": "AURIGA USA, INC.                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "ARKA",
        "clearingBroker": "0443",
        "brokerName": "ARKA SECURITIES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "ARKI",
        "clearingBroker": "0226",
        "brokerName": "ARKADIOS CAPITAL                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "ARTI",
        "clearingBroker": "1043",
        "brokerName": "ARBOR RESEARCH & TRADING, LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "ARVS",
        "clearingBroker": "0443",
        "brokerName": "ARVEST WEALTH MANAGEMENT                                              "
    },
    {
        "type": "MUNI",
        "mpid": "ASCM",
        "clearingBroker": "0052",
        "brokerName": "ASCENDIANT CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "ASEL",
        "clearingBroker": "0370",
        "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
    },
    {
        "type": "MUNI",
        "mpid": "ASII",
        "clearingBroker": "0226",
        "brokerName": "AURORA SECURITIES                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "ASKR",
        "clearingBroker": "0141",
        "brokerName": "ASKAR CORP.                                                           "
    },
    {
        "type": "MUNI",
        "mpid": "ASOI",
        "clearingBroker": "0226",
        "brokerName": "ASSOCIATED INVESTMENT SERVICES, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "ATIS",
        "clearingBroker": "0052",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "MUNI",
        "mpid": "ATMC",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "ATVT",
        "clearingBroker": "0443",
        "brokerName": "ATOMIC BROKERAGE LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "AVEN",
        "clearingBroker": "0226",
        "brokerName": "AVENTURA SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "AVEW",
        "clearingBroker": "8199",
        "brokerName": "AVENTURA SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "AVIA",
        "clearingBroker": "0443",
        "brokerName": "AVIAN SECURITIES, L.L.C.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "AVIL",
        "clearingBroker": "0158",
        "brokerName": "AVANZA CAPITAL MARKETS INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "AVSI",
        "clearingBroker": "0443",
        "brokerName": "AMERIVET SECURITIES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "AVST",
        "clearingBroker": "0235",
        "brokerName": "ATOMIC BROKERAGE LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "AXAA",
        "clearingBroker": "0075",
        "brokerName": "AXA ADVISORS LLC                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "AXCL",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "AXIO",
        "clearingBroker": "0279",
        "brokerName": "AXIOM CAPITAL MANAGEMENT, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "AXOS",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "BAKR",
        "clearingBroker": "6069",
        "brokerName": "JAMES BAKER & ASSOCIATES, L.P.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "BALS",
        "clearingBroker": "0750",
        "brokerName": "BRUCE A. LEFAVI SECURITIES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "BANK",
        "clearingBroker": "0701",
        "brokerName": "CETERA INVESTMENT SERVICES LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "BARD",
        "clearingBroker": "0547",
        "brokerName": "ROBERT W. BAIRD & CO. INCORPORATED                                    "
    },
    {
        "type": "MUNI",
        "mpid": "BARR",
        "clearingBroker": "0226",
        "brokerName": "BARRETT & COMPANY                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "BAYC",
        "clearingBroker": "0161",
        "brokerName": "BAY CREST PARTNERS,  LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "BAYP",
        "clearingBroker": "0161",
        "brokerName": "BAY CREST PARTNERS, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "BBAR",
        "clearingBroker": "0595",
        "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "BBBI",
        "clearingBroker": "0443",
        "brokerName": "BLUEBID BROKERAGE, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "BBCM",
        "clearingBroker": "1608",
        "brokerName": "BRYANT BANK                                                           "
    },
    {
        "type": "MUNI",
        "mpid": "BBGC",
        "clearingBroker": "0235",
        "brokerName": "GRAHAM (B.B.) & COMPANY                                               "
    },
    {
        "type": "MUNI",
        "mpid": "BBID",
        "clearingBroker": "2557",
        "brokerName": "BANKERS' BANK                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "BBNI",
        "clearingBroker": "0443",
        "brokerName": "PERFORMANCE TRUST CAPITAL PARTNERS, INC.                              "
    },
    {
        "type": "MUNI",
        "mpid": "BCAP",
        "clearingBroker": "7256",
        "brokerName": "BARCLAYS CAPITAL, INC./FIXED INCOME                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BCCS",
        "clearingBroker": "0443",
        "brokerName": "BAC FLORIDA INVESTMENTS CORP.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "BCIB",
        "clearingBroker": "0443",
        "brokerName": "BCI SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "BCLE",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "MUNI",
        "mpid": "BCPI",
        "clearingBroker": "0279",
        "brokerName": "GVC CAPITAL LLC                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "BCRK",
        "clearingBroker": "0279",
        "brokerName": "BEAR CREEK SECURITIES, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "BCWM",
        "clearingBroker": "4077",
        "brokerName": "BETA CAPITAL SECURITIES LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "BCZC",
        "clearingBroker": "0443",
        "brokerName": "ZIEGLER (B.C.) & COMPANY                                              "
    },
    {
        "type": "MUNI",
        "mpid": "BDDK",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BDTR",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BEAF",
        "clearingBroker": "0235",
        "brokerName": "BEACONSFIELD FINANCIAL SERV.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "BEAL",
        "clearingBroker": "0443",
        "brokerName": "M.R. BEAL & COMPANY                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BEAR",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "BECS",
        "clearingBroker": "0443",
        "brokerName": "BECKER & SUFFERN LTD.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "BELS",
        "clearingBroker": "0443",
        "brokerName": "BEL AIR SECURITIES LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "BERM",
        "clearingBroker": "0443",
        "brokerName": "BERMUDA INVESTMENT ADVISORY SERVICES                                  "
    },
    {
        "type": "MUNI",
        "mpid": "BERN",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "BERS",
        "clearingBroker": "0235",
        "brokerName": "BESTEX RESEARCH SECURITIES, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "BEST",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "BFCM",
        "clearingBroker": "1043",
        "brokerName": "BLUEFIN CAPITAL MANAGEMENT, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "BFEW",
        "clearingBroker": "0443",
        "brokerName": "BILL FEW ASSOCIATES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "BFFI",
        "clearingBroker": "0226",
        "brokerName": "BERTHEL, FISHER & COMPANY FINANCIAL SERVICES, INC.                    "
    },
    {
        "type": "MUNI",
        "mpid": "BFMA",
        "clearingBroker": "1043",
        "brokerName": "BLUEFIN CAPITAL MANAGEMENT, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "BFSL",
        "clearingBroker": "0235",
        "brokerName": "BRIGGS-FICKS SECURITIES, LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "BGCF",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL, L.P.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BGHT",
        "clearingBroker": "0141",
        "brokerName": "BRIGHTON SECURITIES CORP.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "BGMI",
        "clearingBroker": "0158",
        "brokerName": "BRICKELL GLOBAL MARKETS, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "BGSG",
        "clearingBroker": "0226",
        "brokerName": "CBIZ FINANCIAL SOLUTIONS, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "BGVS",
        "clearingBroker": "0443",
        "brokerName": "BGV SECURITIES                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "BHII",
        "clearingBroker": "0443",
        "brokerName": "BELLE HAVEN INVESTMENTS, LP                                           "
    },
    {
        "type": "MUNI",
        "mpid": "BHKS",
        "clearingBroker": "0141",
        "brokerName": "BHK SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BICA",
        "clearingBroker": "0443",
        "brokerName": "BEACON INVESTMENT COMPANY                                             "
    },
    {
        "type": "MUNI",
        "mpid": "BIDS",
        "clearingBroker": "0161",
        "brokerName": "BIDS TRADING L.P.                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "BIGP",
        "clearingBroker": "0443",
        "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "BIGZ",
        "clearingBroker": "0443",
        "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "BIMI",
        "clearingBroker": "0136",
        "brokerName": "INTESA SANPAOLO IMI SECURITIES CORP.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "BISI",
        "clearingBroker": "0443",
        "brokerName": "BANORTE SECURITIES INTERNATIONAL, LTD.                                "
    },
    {
        "type": "MUNI",
        "mpid": "BJCM",
        "clearingBroker": "0235",
        "brokerName": "ESSEX SECURITIES LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "BJRC",
        "clearingBroker": "0235",
        "brokerName": "CASCADE INVESTMENT GROUP, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "BKCM",
        "clearingBroker": "0443",
        "brokerName": "BNY CAPITAL MARKETS INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "BKES",
        "clearingBroker": "0443",
        "brokerName": "BNY MELLON CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "BKRT",
        "clearingBroker": "0235",
        "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "BLEY",
        "clearingBroker": "0443",
        "brokerName": "BLEY INVESTMENT GROUP, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "BLKB",
        "clearingBroker": "0642",
        "brokerName": "BLACKBURN & COMPANY                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BLNI",
        "clearingBroker": "0226",
        "brokerName": "AMERITAS INVESTMENT COMPANY, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "BMCB",
        "clearingBroker": "0103",
        "brokerName": "BACKSTROM MCCARLEY BERRY & CO., LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BMKS",
        "clearingBroker": "0443",
        "brokerName": "BENCHMARK SECURITIES, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "BMSA",
        "clearingBroker": "0443",
        "brokerName": "MARIVA CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "BMUR",
        "clearingBroker": "0443",
        "brokerName": "BREAN CAPITAL, LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "BNBB",
        "clearingBroker": "0443",
        "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "BNCH",
        "clearingBroker": "0235",
        "brokerName": "THE BENCHMARK COMPANY, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "BNDI",
        "clearingBroker": "0443",
        "brokerName": "BERNARDI SECURITIES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "BNDS",
        "clearingBroker": "0226",
        "brokerName": "MTS MARKETS INTERNATIONAL, INC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "BNTE",
        "clearingBroker": "0158",
        "brokerName": "BANORTE-IXE SECURITIES INTERNATIONAL, LTD.                            "
    },
    {
        "type": "MUNI",
        "mpid": "BNYI",
        "clearingBroker": "0443",
        "brokerName": "BNY INVESTMENT CENTERS, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "BNYM",
        "clearingBroker": "8355",
        "brokerName": "BNYM/UIT NSCC CNS CLEARANCE                                           "
    },
    {
        "type": "MUNI",
        "mpid": "BNYN",
        "clearingBroker": "0226",
        "brokerName": "BANYAN SECURITIES, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "BOFA",
        "clearingBroker": "0773",
        "brokerName": "BOFA SECURITIES, INC./FIXED INCOME                                    "
    },
    {
        "type": "MUNI",
        "mpid": "BOKI",
        "clearingBroker": "0443",
        "brokerName": "BOSC, INC.                                                            "
    },
    {
        "type": "MUNI",
        "mpid": "BOKL",
        "clearingBroker": "6752",
        "brokerName": "BANK OF OKLAHOMA                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "BOSS",
        "clearingBroker": "0158",
        "brokerName": "ALL TIME ATS                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "BOYR",
        "clearingBroker": "0443",
        "brokerName": "MARK BOYAR & CO., INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "BPNS",
        "clearingBroker": "2154",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "BPSG",
        "clearingBroker": "0443",
        "brokerName": "GLEACHER & COMPANY SECURITIES, INC.                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BPWP",
        "clearingBroker": "0226",
        "brokerName": "BUTTONWOOD PARTNERS, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "BRBR",
        "clearingBroker": "0279",
        "brokerName": "BROWN AND BROWN SECURITIES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "BRCY",
        "clearingBroker": "0443",
        "brokerName": "BCP SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BRGE",
        "clearingBroker": "0052",
        "brokerName": "NEWBRIDGE SECURITIES CORPORATION                                      "
    },
    {
        "type": "MUNI",
        "mpid": "BRKE",
        "clearingBroker": "0443",
        "brokerName": "BIRKELBACH INVESTMENT SECURITIES, INC.                                "
    },
    {
        "type": "MUNI",
        "mpid": "BRLI",
        "clearingBroker": "0226",
        "brokerName": "BROWN, LISLE/CUMMINGS, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "BRNK",
        "clearingBroker": "0226",
        "brokerName": "BRINKER CAPITAL SECURITIES, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "BRNT",
        "clearingBroker": "0235",
        "brokerName": "H.D. BRENT & COMPANY, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "BRRR",
        "clearingBroker": "8199",
        "brokerName": "BARRINGTON RESEARCH ASSOCIATES, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "BRSA",
        "clearingBroker": "0103",
        "brokerName": "BOURSA INVESTMENT                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "BRSE",
        "clearingBroker": "0226",
        "brokerName": "BRADESCO SECURITIES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "BRVL",
        "clearingBroker": "0443",
        "brokerName": "BLAYLOCK BEAL VAN, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "BRWM",
        "clearingBroker": "0226",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "MUNI",
        "mpid": "BSAZ",
        "clearingBroker": "0103",
        "brokerName": "BERRY SHINO SECURITIES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "BSCM",
        "clearingBroker": "0052",
        "brokerName": "BROAD STREET CAPITAL MARKETS, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "BSIS",
        "clearingBroker": "0443",
        "brokerName": "BANCORPSOUTH INVESTMENT SERVICES, INC.                                "
    },
    {
        "type": "MUNI",
        "mpid": "BSPI",
        "clearingBroker": "0235",
        "brokerName": "BALANCED SECURITY PLANNING, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "BSSC",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "BSTO",
        "clearingBroker": "0443",
        "brokerName": "BANESTO SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "BTDG",
        "clearingBroker": "0161",
        "brokerName": "BIDS TRADING LP                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "BTIM",
        "clearingBroker": "1043",
        "brokerName": "BTIG, LLC                                                             "
    },
    {
        "type": "MUNI",
        "mpid": "BTSS",
        "clearingBroker": "0279",
        "brokerName": "HILLTOP SECURITIES INDEPENDENT NETWORK INC.                           "
    },
    {
        "type": "MUNI",
        "mpid": "BURK",
        "clearingBroker": "0141",
        "brokerName": "BURKE, LAWTON, BREWER & BURKE                                         "
    },
    {
        "type": "MUNI",
        "mpid": "BUZZ",
        "clearingBroker": "0141",
        "brokerName": "HEIDTKE & COMPANY, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "BWNA",
        "clearingBroker": "0235",
        "brokerName": "BROWN ASSOCIATES INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "BYAI",
        "clearingBroker": "0226",
        "brokerName": "BRECEK & YOUNG                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "BZCP",
        "clearingBroker": "0443",
        "brokerName": "BALANZ CAPITAL USA LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "BZTN",
        "clearingBroker": "0141",
        "brokerName": "ALLIANT SECURITIES, INC. TURNER, NORD, KIENBAUM                       "
    },
    {
        "type": "MUNI",
        "mpid": "BZWV",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "BZYD",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "BZYF",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "CABA",
        "clearingBroker": "0443",
        "brokerName": "CABRERA CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CABR",
        "clearingBroker": "0161",
        "brokerName": "CABRERA CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CADG",
        "clearingBroker": "0005",
        "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "CADZ",
        "clearingBroker": "0279",
        "brokerName": "CADZ SECURITIES INC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CAFS",
        "clearingBroker": "0158",
        "brokerName": "COMMUNITYAMERICA FINANCIAL SOLUTIONS, LLC                             "
    },
    {
        "type": "MUNI",
        "mpid": "CAGI",
        "clearingBroker": "0279",
        "brokerName": "CRESCENT SECURITIES GROUP, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "CAIX",
        "clearingBroker": "0235",
        "brokerName": "CAIS CAPITAL LLC                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "CALD",
        "clearingBroker": "0103",
        "brokerName": "CALDWELL SUTTER CAPITAL, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CALT",
        "clearingBroker": "0279",
        "brokerName": "CALTON & ASSOCIATES                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CAMS",
        "clearingBroker": "0443",
        "brokerName": "COMPREHENSIVE ASSET MANAGEMENT AND SERVICING, INC.                    "
    },
    {
        "type": "MUNI",
        "mpid": "CANR",
        "clearingBroker": "0388",
        "brokerName": "CANTONE RESEARCH INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CANT",
        "clearingBroker": "0696",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "CAPC",
        "clearingBroker": "0235",
        "brokerName": "CAPITAL CITY SECURITIES, LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "CAPE",
        "clearingBroker": "0279",
        "brokerName": "CAPE SECURITIES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CAPI",
        "clearingBroker": "0443",
        "brokerName": "CAPITAL ANALYSTS INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CARL",
        "clearingBroker": "0443",
        "brokerName": "BASE SECURITIES LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CART",
        "clearingBroker": "0443",
        "brokerName": "CARTY & COMPANY, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CARY",
        "clearingBroker": "0141",
        "brokerName": "CARY STREET PARTNERS                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CATC",
        "clearingBroker": "0443",
        "brokerName": "CHICAGO ANALYTIC TRADING COMPANY, LLC                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CATE",
        "clearingBroker": "0235",
        "brokerName": "CARTER, TERRY & COMPANY, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CAVU",
        "clearingBroker": "0443",
        "brokerName": "CAVU SECURITIES LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CBAL",
        "clearingBroker": "0443",
        "brokerName": "ACCESS SECURITIES, INC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "CBEV",
        "clearingBroker": "0226",
        "brokerName": "CITY NATIONAL BANK, BEVERLY HILLS, CALIFORNIA                         "
    },
    {
        "type": "MUNI",
        "mpid": "CBII",
        "clearingBroker": "0443",
        "brokerName": "WESBANCO SECURITIES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "CBIN",
        "clearingBroker": "0443",
        "brokerName": "COMPASS BROKERAGE, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "CBKC",
        "clearingBroker": "2170",
        "brokerName": "COMMERCE BANK                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CBNA",
        "clearingBroker": "0950",
        "brokerName": "CITIBANK N.A./DEALER                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CBOL",
        "clearingBroker": "0226",
        "brokerName": "MUTUAL SECURITIES, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "CBSE",
        "clearingBroker": "1043",
        "brokerName": "CAMBRIDGE INTERNATIONAL SECURITIES, LLC                               "
    },
    {
        "type": "MUNI",
        "mpid": "CBTD",
        "clearingBroker": "0226",
        "brokerName": "SYNOVOUS SECURITIES INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "CCBI",
        "clearingBroker": "6744",
        "brokerName": "COUNTRY CLUB BANK, KANSAS, KANSAS CITY, MO.                           "
    },
    {
        "type": "MUNI",
        "mpid": "CCCO",
        "clearingBroker": "0226",
        "brokerName": "CARNES CAPITAL CORPORATION                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CCIG",
        "clearingBroker": "0235",
        "brokerName": "CINCAP INVESTMENT GROUP, INC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "CCMC",
        "clearingBroker": "0443",
        "brokerName": "COMMERZEBANK CAPITAL CORP.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CCPM",
        "clearingBroker": "0595",
        "brokerName": "CAMBRIA CAPITAL, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CCSS",
        "clearingBroker": "0443",
        "brokerName": "CROWN CAPITAL SECURITIES, L.P.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CERS",
        "clearingBroker": "0226",
        "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CESI",
        "clearingBroker": "0235",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CFCO",
        "clearingBroker": "7311",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "CFGM",
        "clearingBroker": "0235",
        "brokerName": "TRUSTMONT FINANCIAL GROUP, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "CFGO",
        "clearingBroker": "0161",
        "brokerName": "CF GLOBAL TRADING, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "CFGT",
        "clearingBroker": "0235",
        "brokerName": "CF GLOBAL TRADING, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "CFII",
        "clearingBroker": "0235",
        "brokerName": "CONSOLIDATED FINANCIAL INVESTMENTS, INC.                              "
    },
    {
        "type": "MUNI",
        "mpid": "CFIN",
        "clearingBroker": "0279",
        "brokerName": "CHELSEA FINANCIAL SERVICES                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CFSI",
        "clearingBroker": "0052",
        "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CFSX",
        "clearingBroker": "0794",
        "brokerName": "CF SECURED, LLC                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "CGAT",
        "clearingBroker": "0443",
        "brokerName": "CADARET, GRANT & CO., INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CGCO",
        "clearingBroker": "0443",
        "brokerName": "CG COMPASS (USA) LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CGLN",
        "clearingBroker": "0103",
        "brokerName": "COUGHLIN & CO                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CGMI",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CHAS",
        "clearingBroker": "0164",
        "brokerName": "CHARLES SCHWAB & CO., INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CHBC",
        "clearingBroker": "0235",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "CHCH",
        "clearingBroker": "0226",
        "brokerName": "CHURCHILL FINANCIAL, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "CHCK",
        "clearingBroker": "0226",
        "brokerName": "CHICKASAW SECURITIES, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "CHDA",
        "clearingBroker": "0141",
        "brokerName": "CHAPIN, DAVIS                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CHPP",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CHSI",
        "clearingBroker": "0187",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CHUB",
        "clearingBroker": "0226",
        "brokerName": "OSAIC FS, INC.                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CICI",
        "clearingBroker": "0443",
        "brokerName": "COMMERCE BANK INVESTMENT SERVICES, INC.                               "
    },
    {
        "type": "MUNI",
        "mpid": "CICL",
        "clearingBroker": "0141",
        "brokerName": "CAROLINAS INVESTMENT CONSULTING                                       "
    },
    {
        "type": "MUNI",
        "mpid": "CIIV",
        "clearingBroker": "0052",
        "brokerName": "CORPORATE INVESTMENTS GROUP, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "CIMB",
        "clearingBroker": "0005",
        "brokerName": "CIMB SECURITIES (USA), INC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CINV",
        "clearingBroker": "0158",
        "brokerName": "CORPORATE INVESTMENTS GROUP, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "CIRI",
        "clearingBroker": "0443",
        "brokerName": "CAMBRIDGE INVESTMENT RESEARCH, INC.                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CISI",
        "clearingBroker": "0352",
        "brokerName": "CHASE INVESTMENT SERVICES CORP.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "CIST",
        "clearingBroker": "0161",
        "brokerName": "CAPITAL INSTITUTIONAL SERVICES, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CISV",
        "clearingBroker": "0226",
        "brokerName": "CITIZENS SECURITIES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "CLDN",
        "clearingBroker": "0235",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "CLRK",
        "clearingBroker": "0235",
        "brokerName": "CLARK DODGE & CO, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "CLRT",
        "clearingBroker": "1043",
        "brokerName": "ARBOR RESEARCH & TRADING, LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CLSA",
        "clearingBroker": "0161",
        "brokerName": "CLSA AMERICAS, LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "CLSS",
        "clearingBroker": "0443",
        "brokerName": "CABOT LODGE SECURITIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CLTN",
        "clearingBroker": "0226",
        "brokerName": "CALTON & ASSOCIATES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "CLYN",
        "clearingBroker": "0443",
        "brokerName": "CARLIN EQUITIES, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CMCE",
        "clearingBroker": "0226",
        "brokerName": "COMMERCE BROKERAGE SERVICES                                           "
    },
    {
        "type": "MUNI",
        "mpid": "CMCX",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CMGF",
        "clearingBroker": "0443",
        "brokerName": "CMG SECURITIES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "CMMB",
        "clearingBroker": "2781",
        "brokerName": "U.S. BANK N.A./U.S. BANK MUNICIPAL SECURITIES GROUP                   "
    },
    {
        "type": "MUNI",
        "mpid": "CMMW",
        "clearingBroker": "0226",
        "brokerName": "COMMONWEALTH FINANCIAL NETWORK                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CNCD",
        "clearingBroker": "0235",
        "brokerName": "CONCORDE INVESTMENT SERVICES, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "CNFI",
        "clearingBroker": "0443",
        "brokerName": "CENTAURUS FINANCIAL INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "CNFR",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CNSI",
        "clearingBroker": "0226",
        "brokerName": "CITY NATIONAL SECURITIES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "COAK",
        "clearingBroker": "0443",
        "brokerName": "CASTLE OAK SECURITIES, L.P.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "COAS",
        "clearingBroker": "0443",
        "brokerName": "REALTA EQUITIES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CODA",
        "clearingBroker": "0161",
        "brokerName": "CODA MARKETS, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "COEI",
        "clearingBroker": "0052",
        "brokerName": "COASTAL EQUITIES, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "COEX",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "COFS",
        "clearingBroker": "0279",
        "brokerName": "COLORADO FINANCIAL SERVICE CORPORATION                                "
    },
    {
        "type": "MUNI",
        "mpid": "COHN",
        "clearingBroker": "0235",
        "brokerName": "COHEN BROS. & COMPANY                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "COLS",
        "clearingBroker": "0279",
        "brokerName": "COLONIAL SECURITIES INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "COMP",
        "clearingBroker": "0595",
        "brokerName": "COMPASS POINT RESEARCH & TRADING, LLC                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CONI",
        "clearingBroker": "0235",
        "brokerName": "CONTINENTAL INVESTORS SERVICES, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CONS",
        "clearingBroker": "0141",
        "brokerName": "CONSULTIVA SECURITIES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "COOR",
        "clearingBroker": "0141",
        "brokerName": "COORDINATED CAPITAL SECURITIES, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "COWN",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "COWP",
        "clearingBroker": "0226",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "COWX",
        "clearingBroker": "0161",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "COYL",
        "clearingBroker": "0235",
        "brokerName": "COYLE SECURITIES LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CPAM",
        "clearingBroker": "0141",
        "brokerName": "CAPITAL SECURITIES OF AMERICA, INC.                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CPEM",
        "clearingBroker": "0161",
        "brokerName": "CLEARPOOL EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "CPGL",
        "clearingBroker": "0226",
        "brokerName": "CONTINUITY PARTNERS GROUP, LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CPLC",
        "clearingBroker": "0595",
        "brokerName": "COVA CAPITAL PARTNERS LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "CPPM",
        "clearingBroker": "0443",
        "brokerName": "COKER & PALMER                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CPRC",
        "clearingBroker": "0235",
        "brokerName": "CORINTHIAN PARTNERS, L.L.C.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "CPRM",
        "clearingBroker": "8199",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "CQSI",
        "clearingBroker": "0443",
        "brokerName": "CAPITALQUEST SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CRCM",
        "clearingBroker": "0235",
        "brokerName": "COHNREZNICK CAPITAL                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CRDL",
        "clearingBroker": "0235",
        "brokerName": "CARDINAL INVESTMENTS, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CRED",
        "clearingBroker": "0443",
        "brokerName": "CREDICORP CAPITAL LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CREF",
        "clearingBroker": "0443",
        "brokerName": "TIAA-CREF INDIVIDUAL AND INSTITUTIONAL SERVICES, LLC                  "
    },
    {
        "type": "MUNI",
        "mpid": "CREW",
        "clearingBroker": "0443",
        "brokerName": "CREWS & ASSOCIATES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "CRII",
        "clearingBroker": "0443",
        "brokerName": "CRI SECURITIES INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CRIS",
        "clearingBroker": "0443",
        "brokerName": "CARIS & COMPANY, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CRNJ",
        "clearingBroker": "0103",
        "brokerName": "CANTONE RESEARCH                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "CRON",
        "clearingBroker": "0443",
        "brokerName": "CRONIN & CO., INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "CRPT",
        "clearingBroker": "0235",
        "brokerName": "CROSS POINT CAPITAL LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "CRRT",
        "clearingBroker": "0443",
        "brokerName": "BREAN MURRAY, CARRET & CO., LLC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "CRTH",
        "clearingBroker": "0443",
        "brokerName": "CORINTHIAN PARTNERS, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "CRYN",
        "clearingBroker": "0235",
        "brokerName": "BRENDAN E. CRYAN AND COMPANY, L.L.C.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CSAI",
        "clearingBroker": "0793",
        "brokerName": "STIFEL INDEPENDENT ADVISORS, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "CSCA",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "MUNI",
        "mpid": "CSCB",
        "clearingBroker": "0161",
        "brokerName": "COMPUTERSHARE SECURITIES, CORP.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "CSCM",
        "clearingBroker": "0279",
        "brokerName": "CENTRAL STATES CAPITAL MARKETS, LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CSFL",
        "clearingBroker": "6770",
        "brokerName": "SOUTH STATE BANK, NATIONAL ASSOCIATION                                "
    },
    {
        "type": "MUNI",
        "mpid": "CSIB",
        "clearingBroker": "0443",
        "brokerName": "RBC CENTURA SECURITIES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "CSII",
        "clearingBroker": "0443",
        "brokerName": "COMMONWEALTH SECURITIES AND INVESTMENTS, INC.                         "
    },
    {
        "type": "MUNI",
        "mpid": "CSIN",
        "clearingBroker": "0161",
        "brokerName": "CITADEL SECURITIES INSTITUTIONAL LLC                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CSOA",
        "clearingBroker": "0443",
        "brokerName": "CLEARING SERVICES OF AMERICA                                          "
    },
    {
        "type": "MUNI",
        "mpid": "CSPA",
        "clearingBroker": "0226",
        "brokerName": "CREDIT SUISSE PRIVATE ADVISORS                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CSPD",
        "clearingBroker": "0197",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "CSPI",
        "clearingBroker": "0235",
        "brokerName": "CAPITAL SYNERGY PARTNERS                                              "
    },
    {
        "type": "MUNI",
        "mpid": "CSTI",
        "clearingBroker": "0161",
        "brokerName": "CANACCORD GENUITY INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "CTBK",
        "clearingBroker": "4270",
        "brokerName": "CENTRAL TRUST BANK                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "CTNL",
        "clearingBroker": "0235",
        "brokerName": "CENTENNIAL SECURITIES COMPANY LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "CTSC",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "MUNI",
        "mpid": "CUEF",
        "clearingBroker": "0443",
        "brokerName": "CUE FINANCIAL GROUP, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "CUFT",
        "clearingBroker": "0226",
        "brokerName": "FROST BROKERAGE SERVICES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CUSO",
        "clearingBroker": "0443",
        "brokerName": "CUSO FINANCIAL SERVICES, L.P.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CUTW",
        "clearingBroker": "0235",
        "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "CUWB",
        "clearingBroker": "0103",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL, LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CWEI",
        "clearingBroker": "0443",
        "brokerName": "BEECH HILL SECURITIES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "CWMK",
        "clearingBroker": "0438",
        "brokerName": "CIBC WORLD MARKETS CORP.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "DADA",
        "clearingBroker": "0361",
        "brokerName": "D. A. DAVIDSON & CO.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DAGH",
        "clearingBroker": "0443",
        "brokerName": "DAUGHERTY COLE, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DAIS",
        "clearingBroker": "0052",
        "brokerName": "DAI SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "DARA",
        "clearingBroker": "0235",
        "brokerName": "DARWOOD ASSOCIATES, INC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "DART",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DASH",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "DAVA",
        "clearingBroker": "0443",
        "brokerName": "DAVENPORT & COMPANY LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "DAWA",
        "clearingBroker": "0647",
        "brokerName": "DAIWA CAPITAL MARKETS AMERICA INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "DBAB",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "DBCC",
        "clearingBroker": "0235",
        "brokerName": "D. BORAL CAPITAL                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "DBCH",
        "clearingBroker": "0052",
        "brokerName": "D. BORAL CAPITAL                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "DBIB",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "DBKS",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "DBMC",
        "clearingBroker": "0725",
        "brokerName": "D.B. MCKENNA & CO., INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "DBPC",
        "clearingBroker": "0443",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "DCAN",
        "clearingBroker": "0279",
        "brokerName": "R. M. DUNCAN SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "DCSD",
        "clearingBroker": "0235",
        "brokerName": "DAIN CORRESPONDENT SERVICES                                           "
    },
    {
        "type": "MUNI",
        "mpid": "DCVL",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DEAN",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "DEFA",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "DEGS",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DELA",
        "clearingBroker": "0443",
        "brokerName": "DELAFIELD & HAMBRECHT, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "DEMF",
        "clearingBroker": "0443",
        "brokerName": "DEMPSEY FINANCIAL NETWORK                                             "
    },
    {
        "type": "MUNI",
        "mpid": "DENI",
        "clearingBroker": "0279",
        "brokerName": "H.C. DENISON CO.                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "DETF",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DIDI",
        "clearingBroker": "0443",
        "brokerName": "DWS INVESTMENT DISTRIBUTORS INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "DIGG",
        "clearingBroker": "0595",
        "brokerName": "BOUSTEAD SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "DINO",
        "clearingBroker": "0103",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "MUNI",
        "mpid": "DKEI",
        "clearingBroker": "0141",
        "brokerName": "DALE K. EHRHART, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "DLAI",
        "clearingBroker": "0235",
        "brokerName": "DAVID LERNER ASSOCIATES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "DLPS",
        "clearingBroker": "0595",
        "brokerName": "DLP SECURITIES,.LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "DLSI",
        "clearingBroker": "0226",
        "brokerName": "DEMPSEY LORD SMITH, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "DLTA",
        "clearingBroker": "0161",
        "brokerName": "DEALERWEB INC.                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "DMCD",
        "clearingBroker": "0279",
        "brokerName": "MCDERMOTT INVESTMENT SERVICES, LLC                                    "
    },
    {
        "type": "MUNI",
        "mpid": "DMKC",
        "clearingBroker": "0141",
        "brokerName": "D.M. KELLY & COMPANY                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DNOR",
        "clearingBroker": "0005",
        "brokerName": "DNB MARKETS, INC.                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "DNSR",
        "clearingBroker": "0158",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "MUNI",
        "mpid": "DNWL",
        "clearingBroker": "0443",
        "brokerName": "DUNCAN & WILLIAMS, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "DOFT",
        "clearingBroker": "0443",
        "brokerName": "DOFT & CO., INC.                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "DOMI",
        "clearingBroker": "0279",
        "brokerName": "DOMINION INVESTOR SERVICES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "DOMK",
        "clearingBroker": "0443",
        "brokerName": "DOMINICK & DOMINICK LLC/CDS                                           "
    },
    {
        "type": "MUNI",
        "mpid": "DOMS",
        "clearingBroker": "0235",
        "brokerName": "DOMINARI SECURITIES LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "DOTC",
        "clearingBroker": "0226",
        "brokerName": "COLLIERS SECURITIES LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "DOVE",
        "clearingBroker": "0226",
        "brokerName": "SECURITIES EQUITY GROUP                                               "
    },
    {
        "type": "MUNI",
        "mpid": "DOWD",
        "clearingBroker": "0161",
        "brokerName": "WALTER J. DOWD, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DRAT",
        "clearingBroker": "0571",
        "brokerName": "DRATEL GROUP (THE)                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "DREX",
        "clearingBroker": "0443",
        "brokerName": "DREXEL HAMILTON, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DRTG",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DRTR",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DRVW",
        "clearingBroker": "0235",
        "brokerName": "DRIVEWEALTH, LLC                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "DRWM",
        "clearingBroker": "0005",
        "brokerName": "DRW SECURITIES, L.L.C.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "DSGG",
        "clearingBroker": "0226",
        "brokerName": "DMG SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DSTR",
        "clearingBroker": "0443",
        "brokerName": "DESTRA CAPITAL INVESTMENTS LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "DTAP",
        "clearingBroker": "0161",
        "brokerName": "DIRECT TRADING INSTITUTIONAL L.P.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "DTEX",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DUST",
        "clearingBroker": "0161",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "DVES",
        "clearingBroker": "0005",
        "brokerName": "DV EQUITIES                                                           "
    },
    {
        "type": "MUNI",
        "mpid": "DWFN",
        "clearingBroker": "0443",
        "brokerName": "DEWAY FINANCIAL NETWORK, LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "DWIZ",
        "clearingBroker": "0235",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "EAMC",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
    },
    {
        "type": "MUNI",
        "mpid": "EAMG",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
    },
    {
        "type": "MUNI",
        "mpid": "EAST",
        "clearingBroker": "6742",
        "brokerName": "EASTERN BANK CAPITAL MARKETS                                          "
    },
    {
        "type": "MUNI",
        "mpid": "EBRD",
        "clearingBroker": "0103",
        "brokerName": "EARLYBIRD CAPITAL, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "ECCC",
        "clearingBroker": "0226",
        "brokerName": "EAGLES COAST CAPITAL, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ECUT",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "EDFC",
        "clearingBroker": "0443",
        "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "EDJO",
        "clearingBroker": "0057",
        "brokerName": "EDWARD D. JONES & CO.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "EDLR",
        "clearingBroker": "0103",
        "brokerName": "DE LA ROSA (E.J.) & CO., INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "EGLE",
        "clearingBroker": "1043",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "MUNI",
        "mpid": "EGMT",
        "clearingBroker": "0005",
        "brokerName": "EG MARKET TECHNOLOGIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "ELEQ",
        "clearingBroker": "0551",
        "brokerName": "ELEQUIN SECURITIES LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "ELEV",
        "clearingBroker": "0235",
        "brokerName": "ELEVATION, LLC                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "ELQN",
        "clearingBroker": "0443",
        "brokerName": "ELEQUIN SECURITIES LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "EMOC",
        "clearingBroker": "0750",
        "brokerName": "E. MAGNUS OPPENHIEM & CO. INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "EMPR",
        "clearingBroker": "0279",
        "brokerName": "SELKIRK INVESTMENTS, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ENTR",
        "clearingBroker": "0235",
        "brokerName": "ENTRUSTODY FINANCIAL, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "EPIC",
        "clearingBroker": "0443",
        "brokerName": "EPIC CAPITAL SECURITIES                                               "
    },
    {
        "type": "MUNI",
        "mpid": "EQHA",
        "clearingBroker": "0075",
        "brokerName": "EQUITABLE ADVISORS, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "EQSV",
        "clearingBroker": "0226",
        "brokerName": "EQUITY SERVICES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "EQUA",
        "clearingBroker": "0443",
        "brokerName": "EQUITAS AMERICA, L.L.C.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "ESBD",
        "clearingBroker": "0235",
        "brokerName": "EASTDIL SECURED ADVISORS LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "ESHC",
        "clearingBroker": "0443",
        "brokerName": "FIRST SOUTHERN, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "ESUS",
        "clearingBroker": "0443",
        "brokerName": "EVOLUTION SECURITIES US INC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "ETCB",
        "clearingBroker": "3505",
        "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "ETCL",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "ETRF",
        "clearingBroker": "0161",
        "brokerName": "G1 EXECUTION SERVICES, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "ETRS",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "EVOL",
        "clearingBroker": "0226",
        "brokerName": "EVOLVE SECURITIES, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "EWMX",
        "clearingBroker": "0279",
        "brokerName": "EAST WEST MARKETS, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "EXCS",
        "clearingBroker": "0443",
        "brokerName": "EXCEL SECURITIES AND ASSOCIATES, INC.                                 "
    },
    {
        "type": "MUNI",
        "mpid": "EXCU",
        "clearingBroker": "0443",
        "brokerName": "XCU CAPITAL CORPORATION, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "FACA",
        "clearingBroker": "0443",
        "brokerName": "FINANCIAL ASSETS CORPORATION                                          "
    },
    {
        "type": "MUNI",
        "mpid": "FAFT",
        "clearingBroker": "0161",
        "brokerName": "FACTFET SYSTEMS, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "FALC",
        "clearingBroker": "0103",
        "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "FAMI",
        "clearingBroker": "0235",
        "brokerName": "FIRST AMERICAN MUNICIPALS, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "FARA",
        "clearingBroker": "8199",
        "brokerName": "FARINA & ASSOCIATES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "FATS",
        "clearingBroker": "0443",
        "brokerName": "FIRST BROKERS SECURITIES LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "FBLM",
        "clearingBroker": "0235",
        "brokerName": "FBL MARKETING SERVICES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "FBLT",
        "clearingBroker": "8199",
        "brokerName": "FIRST BALLANTYNE, LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "FBNS",
        "clearingBroker": "0235",
        "brokerName": "FBN SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "FBPC",
        "clearingBroker": "0443",
        "brokerName": "CREDIT SUISSE SECURITIES (USA) LLC                                    "
    },
    {
        "type": "MUNI",
        "mpid": "FBSB",
        "clearingBroker": "0280",
        "brokerName": "U.S. BANCORP INVESTMENTS, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "FCCP",
        "clearingBroker": "0141",
        "brokerName": "WELLS FARGO CLEARING SERVICES, LLC                                    "
    },
    {
        "type": "MUNI",
        "mpid": "FCIT",
        "clearingBroker": "0443",
        "brokerName": "FIRST CITIZENS INVESTOR SERVICES, INC.                                "
    },
    {
        "type": "MUNI",
        "mpid": "FCML",
        "clearingBroker": "0279",
        "brokerName": "FNBB CAPITAL MARKETS, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "FCMP",
        "clearingBroker": "0595",
        "brokerName": "PRIME EXECUTIONS, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "FDMI",
        "clearingBroker": "0571",
        "brokerName": "FREEDOM INVESTMENTS, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "FDSC",
        "clearingBroker": "0158",
        "brokerName": "1ST DISCOUNT BROKERAGE INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "FDSI",
        "clearingBroker": "0141",
        "brokerName": "FIRST DALLAS SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "FENX",
        "clearingBroker": "0595",
        "brokerName": "FENIX SECURITIES, LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "FFCI",
        "clearingBroker": "0443",
        "brokerName": "FRONTIER FINANCIAL CONSULTANTS, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "FFCM",
        "clearingBroker": "0235",
        "brokerName": "FOREFRONT CAPITAL MARKETS LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "FFGI",
        "clearingBroker": "0235",
        "brokerName": "FELDSTEIN FINANCIAL GROUP, LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "FFPS",
        "clearingBroker": "0443",
        "brokerName": "FFP SECURITIES                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "FGOE",
        "clearingBroker": "0226",
        "brokerName": "FIRST GEORGETOWN SECURITIES, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "FHCI",
        "clearingBroker": "0443",
        "brokerName": "FIRST HEARTLAND CAPITAL, INC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "FHON",
        "clearingBroker": "0235",
        "brokerName": "FIRST HONOLULU SECURITIES INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "FIAF",
        "clearingBroker": "0443",
        "brokerName": "FLORIDA INVESTMENT ADVISERS                                           "
    },
    {
        "type": "MUNI",
        "mpid": "FIBS",
        "clearingBroker": "0226",
        "brokerName": "FIDELITY BROKERAGE SERVICES LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "FINC",
        "clearingBroker": "0443",
        "brokerName": "AWM SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "FISA",
        "clearingBroker": "0443",
        "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "FISB",
        "clearingBroker": "0226",
        "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "FISH",
        "clearingBroker": "0235",
        "brokerName": "L.B. FISHER & COMPANY                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "FITE",
        "clearingBroker": "0443",
        "brokerName": "FORESIGHT INVESTMENTS, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "FJRF",
        "clearingBroker": "0052",
        "brokerName": "PARITER SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "FKSC",
        "clearingBroker": "0235",
        "brokerName": "FIRST KENTUCKY SECURITIES CORP.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "FLAT",
        "clearingBroker": "0226",
        "brokerName": "FLORIDA ATLANTIC SECURITIES CORP.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "FLEX",
        "clearingBroker": "0158",
        "brokerName": "GWM GROUP, INC.                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "FLIB",
        "clearingBroker": "0235",
        "brokerName": "FIRST LIBERTIES FINANCIAL                                             "
    },
    {
        "type": "MUNI",
        "mpid": "FLOU",
        "clearingBroker": "0443",
        "brokerName": "FIRST ST. LOUIS SECURITIES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "FLTL",
        "clearingBroker": "0235",
        "brokerName": "FELTL & COMPANY                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "FLTU",
        "clearingBroker": "0551",
        "brokerName": "FLOW TRADERS US LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "FLWT",
        "clearingBroker": "0161",
        "brokerName": "FLOW TRADERS U.S. INSTITUTIONAL TRADING LLC                           "
    },
    {
        "type": "MUNI",
        "mpid": "FMAT",
        "clearingBroker": "0608",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "FMCO",
        "clearingBroker": "0443",
        "brokerName": "FIRST MANHATTAN CO.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "FMFS",
        "clearingBroker": "0226",
        "brokerName": "FISRT MERIT FINANCIAL SERVICES, INC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "FMGT",
        "clearingBroker": "0443",
        "brokerName": "FAMILY MANAGEMENT SECURITIES, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "FNBB",
        "clearingBroker": "6753",
        "brokerName": "FIRST NATIONAL BANKERS BANK                                           "
    },
    {
        "type": "MUNI",
        "mpid": "FNET",
        "clearingBroker": "0141",
        "brokerName": "WACHOVIA SECURITIES FINANCIAL NETWORK, LLC                            "
    },
    {
        "type": "MUNI",
        "mpid": "FNFD",
        "clearingBroker": "0443",
        "brokerName": "FOLGER NOLAN FLEMING DOUGLAS INCORPORATED                             "
    },
    {
        "type": "MUNI",
        "mpid": "FNIC",
        "clearingBroker": "0443",
        "brokerName": "FINANCIAL NETWORK INVESTMENT CORP.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "FNSJ",
        "clearingBroker": "0443",
        "brokerName": "FINANCIAL NORTHEASTERN SECURITIES, INC.                               "
    },
    {
        "type": "MUNI",
        "mpid": "FOGS",
        "clearingBroker": "0235",
        "brokerName": "FOG EQUITIES LLC                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "FORD",
        "clearingBroker": "0052",
        "brokerName": "THINKEQUITY, LLC                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "FORT",
        "clearingBroker": "0443",
        "brokerName": "FORTE SECURITIES LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "FRLZ",
        "clearingBroker": "0103",
        "brokerName": "FRIEDMAN LUZZATTO & CO                                                "
    },
    {
        "type": "MUNI",
        "mpid": "FROS",
        "clearingBroker": "6751",
        "brokerName": "FROST BANK                                                            "
    },
    {
        "type": "MUNI",
        "mpid": "FRSE",
        "clearingBroker": "0443",
        "brokerName": "FRANKLIN SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "FSCN",
        "clearingBroker": "0226",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "FSCS",
        "clearingBroker": "0443",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "FSEC",
        "clearingBroker": "0161",
        "brokerName": "FRS SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "FSFA",
        "clearingBroker": "0443",
        "brokerName": "FIRST SECURITY FINANCIAL ADVISORS, INC.                               "
    },
    {
        "type": "MUNI",
        "mpid": "FSRP",
        "clearingBroker": "0443",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "FSST",
        "clearingBroker": "0443",
        "brokerName": "FRANKLIN STREET SECURITIES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "FTCM",
        "clearingBroker": "2445",
        "brokerName": "FHN FINANCIAL CAPITAL MARKETS A DIVISION OF FIRST HORIZON BANK-DTC 244"
    },
    {
        "type": "MUNI",
        "mpid": "FTEN",
        "clearingBroker": "0226",
        "brokerName": "FTB ADVISORS, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "FTLP",
        "clearingBroker": "8244",
        "brokerName": "FIRST TRUST PORTFOLIOS, L.P.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "FTSC",
        "clearingBroker": "0202",
        "brokerName": "FHN FINANCIAL SECURITIES CORP.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "FTSR",
        "clearingBroker": "0226",
        "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "FUJI",
        "clearingBroker": "0443",
        "brokerName": "MIZUHO SECURITIES USA INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "FWCO",
        "clearingBroker": "0443",
        "brokerName": "FIRST WASHINGTON CORPORATION                                          "
    },
    {
        "type": "MUNI",
        "mpid": "FWSI",
        "clearingBroker": "0141",
        "brokerName": "FIRST WESTERN SECURITIES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "GABE",
        "clearingBroker": "0141",
        "brokerName": "G. RESEARCH, INC.                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "GAFI",
        "clearingBroker": "0235",
        "brokerName": "GARDNER FINANCIAL SERVICES INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "GARB",
        "clearingBroker": "0148",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "GARC",
        "clearingBroker": "0161",
        "brokerName": "ICAP CORPORATES LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "GARQ",
        "clearingBroker": "0161",
        "brokerName": "ICAP CORPORATES, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "GARR",
        "clearingBroker": "0226",
        "brokerName": "GARRETT NAGLE & CO., INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "GARW",
        "clearingBroker": "0595",
        "brokerName": "GAR WOOD SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "GBMT",
        "clearingBroker": "0443",
        "brokerName": "GBM INTERNATIONAL, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "GBSI",
        "clearingBroker": "0443",
        "brokerName": "GREENTREE BROKERAGE SERVICES, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "GBTS",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "GCMC",
        "clearingBroker": "0443",
        "brokerName": "GLADOWSKY CAPITAL MANAGEMENT CORP.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "GCMT",
        "clearingBroker": "0443",
        "brokerName": "GOLD CAPITAL MANAGEMENT, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "GDCO",
        "clearingBroker": "0443",
        "brokerName": "GILBERT, DONIGER CO., INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "GFBD",
        "clearingBroker": "0226",
        "brokerName": "G. F. INVESTMENT SERVICES, LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "GFIG",
        "clearingBroker": "0537",
        "brokerName": "GFI SECURITIES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "GFSI",
        "clearingBroker": "0443",
        "brokerName": "GLOBAL FINANCIAL SERVICES, L.L.C.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "GGWI",
        "clearingBroker": "0141",
        "brokerName": "GAGE-WILEY & COMPANY INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "GHCC",
        "clearingBroker": "0226",
        "brokerName": "GORDON, HASKETT CAPITAL CORPORATION                                   "
    },
    {
        "type": "MUNI",
        "mpid": "GILG",
        "clearingBroker": "0226",
        "brokerName": "GILDER GAGNON HOWE & CO. LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "GJSS",
        "clearingBroker": "0235",
        "brokerName": "SCHWARTZ, GREGORY J & CO. INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "GLBZ",
        "clearingBroker": "0443",
        "brokerName": "ONLINE BROKERAGE SERVICES                                             "
    },
    {
        "type": "MUNI",
        "mpid": "GLII",
        "clearingBroker": "5005",
        "brokerName": "TD SECURITIES INC./CDS                                                "
    },
    {
        "type": "MUNI",
        "mpid": "GLIR",
        "clearingBroker": "5021",
        "brokerName": "TD WATERHOUSE CANADA INC. #5/CDS                                      "
    },
    {
        "type": "MUNI",
        "mpid": "GLLL",
        "clearingBroker": "0279",
        "brokerName": "GILL CAPITAL PARTNERS                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "GLYN",
        "clearingBroker": "0443",
        "brokerName": "GLYNN (J.A.) & CO.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "GMSG",
        "clearingBroker": "0443",
        "brokerName": "GMS GROUP (THE), L.L.C.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "GPCA",
        "clearingBroker": "0158",
        "brokerName": "GREAT POINT CAPITAL LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "GPCG",
        "clearingBroker": "0443",
        "brokerName": "GREENMAN, PARKER, CONNALLY, GREENMAN, INC.                            "
    },
    {
        "type": "MUNI",
        "mpid": "GPSS",
        "clearingBroker": "0443",
        "brokerName": "GREAT PACIFIC SECURITIES                                              "
    },
    {
        "type": "MUNI",
        "mpid": "GRBD",
        "clearingBroker": "0052",
        "brokerName": "GREENBIRD CAPITAL LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "GRCF",
        "clearingBroker": "0443",
        "brokerName": "GREATER COMMUNITY FINANCIAL L.L.C.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "GRIN",
        "clearingBroker": "0443",
        "brokerName": "SANDGRAIN SECURITIES, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "GROD",
        "clearingBroker": "0226",
        "brokerName": "GRODSKY ASSOCIATES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "GRPS",
        "clearingBroker": "0226",
        "brokerName": "MML INVESTORS SERVICES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "GRWC",
        "clearingBroker": "0443",
        "brokerName": "GRW CAPITAL CORPORATION                                               "
    },
    {
        "type": "MUNI",
        "mpid": "GRWD",
        "clearingBroker": "0052",
        "brokerName": "GAR WOOD SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "GRYG",
        "clearingBroker": "0226",
        "brokerName": "GOLDBERG (GARY) & CO., INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "GSAD",
        "clearingBroker": "0235",
        "brokerName": "GATTEN SADOWSKI INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "GSBI",
        "clearingBroker": "0279",
        "brokerName": "GLOBAL BROKERAGE SERVICES, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "GSCO",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "GSIL",
        "clearingBroker": "0158",
        "brokerName": "GLOBAL STRATEGIC INVESTMENTS, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "GSMM",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "GSQQ",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "GSRI",
        "clearingBroker": "0443",
        "brokerName": "GLOBAL STRATEGIC INVESTMENTS, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "GSSC",
        "clearingBroker": "0161",
        "brokerName": "GEORGESON SHAREHOLDER SECURITIES CORP.                                "
    },
    {
        "type": "MUNI",
        "mpid": "GSSI",
        "clearingBroker": "0052",
        "brokerName": "GARDEN STATE SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "GSUU",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "GSVV",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "GTNB",
        "clearingBroker": "0595",
        "brokerName": "GTN AMERICAS FINANCIAL SERVICES, INC.                                 "
    },
    {
        "type": "MUNI",
        "mpid": "GTSM",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "GUGI",
        "clearingBroker": "0526",
        "brokerName": "GUGGENHEIM FUNDS DISTRIBUTORS, LLC                                    "
    },
    {
        "type": "MUNI",
        "mpid": "GWFS",
        "clearingBroker": "0443",
        "brokerName": "GWFS EQUITIES, INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "GWNS",
        "clearingBroker": "0226",
        "brokerName": "GWN SECURITIES INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "GZML",
        "clearingBroker": "0161",
        "brokerName": "GUZMAN & COMPANY                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "HACA",
        "clearingBroker": "0701",
        "brokerName": "HARVEST CAPITAL LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "HALO",
        "clearingBroker": "0235",
        "brokerName": "HALO SECURITIES, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "HARB",
        "clearingBroker": "0443",
        "brokerName": "HARBOUR INVESTMENTS INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "HARC",
        "clearingBroker": "0235",
        "brokerName": "HARLEY CAPITAL LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "HARS",
        "clearingBroker": "8199",
        "brokerName": "HARVESTONS SECURITIES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "HAVK",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE STATE FINANCIAL, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "HAZL",
        "clearingBroker": "0226",
        "brokerName": "HAZLETT, BURT AND WATSON, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "HBCO",
        "clearingBroker": "0443",
        "brokerName": "GLOBAL INVESTOR SERVICES, L.C.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "HBKI",
        "clearingBroker": "0352",
        "brokerName": "HBK FINANCE, LP                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "HBUS",
        "clearingBroker": "0443",
        "brokerName": "HOLISTIC BROKERAGE, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "HCGC",
        "clearingBroker": "0103",
        "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "HCMX",
        "clearingBroker": "0235",
        "brokerName": "HOOPOE CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "HCTA",
        "clearingBroker": "0005",
        "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "HCWW",
        "clearingBroker": "0235",
        "brokerName": "H.C.WAINWRIGHT & CO., LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "HDVS",
        "clearingBroker": "0226",
        "brokerName": "AVANTAX INVESTMENT SERVICES, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "HEAD",
        "clearingBroker": "0443",
        "brokerName": "TD SECURITIES AUTOMATED TRADING LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "HEGS",
        "clearingBroker": "1043",
        "brokerName": "HEG SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "HENN",
        "clearingBroker": "0235",
        "brokerName": "CARL M. HENNIG, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "HENY",
        "clearingBroker": "0443",
        "brokerName": "HENLEY & COMPANY LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "HFIS",
        "clearingBroker": "0141",
        "brokerName": "HFI SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "HFLD",
        "clearingBroker": "0279",
        "brokerName": "HARTFIELD, TITUS & DONNELLY, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "HIGG",
        "clearingBroker": "0235",
        "brokerName": "HIGGINS CAPITAL MANAGEMENT, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "HIGH",
        "clearingBroker": "0443",
        "brokerName": "HIGHLANDER CAPITAL GROUP, INC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "HILF",
        "clearingBroker": "0443",
        "brokerName": "HILL THOMPSON MAGID & CO INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "HINO",
        "clearingBroker": "0235",
        "brokerName": "TRB CAPITAL MARKETS,LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "HJSC",
        "clearingBroker": "0443",
        "brokerName": "SIMS (HERBERT J.) & CO., INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "HMRB",
        "clearingBroker": "0235",
        "brokerName": "W.R. HAMBRECHT + CO., LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "HNTR",
        "clearingBroker": "0443",
        "brokerName": "HUNTER ASSOCIATES, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "HONR",
        "clearingBroker": "0235",
        "brokerName": "ROBERTS & RYAN INVESTMENTS INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "HOPK",
        "clearingBroker": "0750",
        "brokerName": "SILVER OAK SECURITIES, INCORPORATED                                   "
    },
    {
        "type": "MUNI",
        "mpid": "HOTO",
        "clearingBroker": "0443",
        "brokerName": "HORNOR, TOWNSEND & KENT, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "HPOM",
        "clearingBroker": "0235",
        "brokerName": "HERNDON PLANT OAKLEY, LTD.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "HPWD",
        "clearingBroker": "0443",
        "brokerName": "PIPER SANDLER & CO.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "HRBF",
        "clearingBroker": "0756",
        "brokerName": "AMERICAN ENTERPRISE INVESTMENT SERVICES INC.                          "
    },
    {
        "type": "MUNI",
        "mpid": "HRCS",
        "clearingBroker": "0443",
        "brokerName": "HRC INVESTMENT SERVICES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "HRGR",
        "clearingBroker": "0235",
        "brokerName": "HARGER AND COMPANY, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "HRRS",
        "clearingBroker": "0443",
        "brokerName": "HARRIS INVESTORS SERVICES, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "HSBM",
        "clearingBroker": "0486",
        "brokerName": "HSBC SECURITIES (USA), INC/ FIXED INCOME SECS                         "
    },
    {
        "type": "MUNI",
        "mpid": "HTCM",
        "clearingBroker": "0235",
        "brokerName": "HOWDEN TIGER CAPITAL MARKETS & ADVISOF LLC                            "
    },
    {
        "type": "MUNI",
        "mpid": "HTIS",
        "clearingBroker": "0443",
        "brokerName": "HAITONG INTERNATIONAL SECURITIES (USA) INC.                           "
    },
    {
        "type": "MUNI",
        "mpid": "HTPS",
        "clearingBroker": "0443",
        "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "HTWR",
        "clearingBroker": "0226",
        "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "HUCO",
        "clearingBroker": "0226",
        "brokerName": "HUNTINGTON INVESTMENT COMPANY                                         "
    },
    {
        "type": "MUNI",
        "mpid": "HUTC",
        "clearingBroker": "0443",
        "brokerName": "HUNTINGTON SECURITIES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "HWLS",
        "clearingBroker": "0443",
        "brokerName": "M.S. HOWELLS & CO.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "HXGN",
        "clearingBroker": "0443",
        "brokerName": "HEXAGON SECURITIES, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "IAAK",
        "clearingBroker": "0279",
        "brokerName": "ISAAK BOND INVESTMENT, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "IAEW",
        "clearingBroker": "0595",
        "brokerName": "SRT SECURITIES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "IAEX",
        "clearingBroker": "0235",
        "brokerName": "SRT SECURITIES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "IBCO",
        "clearingBroker": "0534",
        "brokerName": "INTERACTIVE BROKERS CORP.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "IBFS",
        "clearingBroker": "0824",
        "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL SERVICES LLC        "
    },
    {
        "type": "MUNI",
        "mpid": "IBKR",
        "clearingBroker": "0534",
        "brokerName": "INTERACTIVE BROKERS LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "IBND",
        "clearingBroker": "0103",
        "brokerName": "INSTITUTIONAL BOND NETWORK, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "IBPR",
        "clearingBroker": "0052",
        "brokerName": "IB CAPITAL LLC                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "IBSH",
        "clearingBroker": "0595",
        "brokerName": "INTEGRITY BROKERAGE SERVICES, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "IBSJ",
        "clearingBroker": "0052",
        "brokerName": "INTEGRITY BROKERAGE                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "ICAN",
        "clearingBroker": "0226",
        "brokerName": "CETERA ADVISOR NETWORKS LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "ICBK",
        "clearingBroker": "0388",
        "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL SERVICES LLC        "
    },
    {
        "type": "MUNI",
        "mpid": "ICCP",
        "clearingBroker": "0443",
        "brokerName": "INVESTORS CAPITAL CORPORATION                                         "
    },
    {
        "type": "MUNI",
        "mpid": "ICEX",
        "clearingBroker": "4264",
        "brokerName": "ICE SECURITIES EXECUTION & CLEARING, LLC                              "
    },
    {
        "type": "MUNI",
        "mpid": "ICMH",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL CAPITAL MANAGEMENT, INC.                                "
    },
    {
        "type": "MUNI",
        "mpid": "ICMI",
        "clearingBroker": "0279",
        "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "ICON",
        "clearingBroker": "0595",
        "brokerName": "ICON CAPITAL GROUP, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "ICPX",
        "clearingBroker": "0443",
        "brokerName": "ICP SECURITIES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "ICRL",
        "clearingBroker": "0443",
        "brokerName": "RIDEAU (I.C.) LYONS AND CO.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "ICTI",
        "clearingBroker": "0158",
        "brokerName": "INTERNATIONAL CORRESPONDENT TRADING, INC.                             "
    },
    {
        "type": "MUNI",
        "mpid": "IESI",
        "clearingBroker": "0443",
        "brokerName": "ITAU EUROPA SECURITIES INC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "IFCS",
        "clearingBroker": "0161",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "IMCC",
        "clearingBroker": "0005",
        "brokerName": "IMC FINANCIAL MARKETS                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "IMPC",
        "clearingBroker": "0443",
        "brokerName": "IMPERIAL CAPITAL, LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "INGS",
        "clearingBroker": "0124",
        "brokerName": "INGALLS & SNYDER, LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "INGW",
        "clearingBroker": "0443",
        "brokerName": "ING PRIVATE WEALTH MANAGEMENT LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "INNO",
        "clearingBroker": "0052",
        "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "INPI",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT PLANNERS INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "INPS",
        "clearingBroker": "0235",
        "brokerName": "INDEPENDENCE POINT SECURITIES LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "INTL",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "INTX",
        "clearingBroker": "0235",
        "brokerName": "INTERNATIONAL ASSETS ADVISORY, LLC                                    "
    },
    {
        "type": "MUNI",
        "mpid": "IPGR",
        "clearingBroker": "0443",
        "brokerName": "INVESTMENT PLACEMENT GROUP                                            "
    },
    {
        "type": "MUNI",
        "mpid": "IRIS",
        "clearingBroker": "0279",
        "brokerName": "IRIS TRADING, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "ISCN",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
    },
    {
        "type": "MUNI",
        "mpid": "ISIG",
        "clearingBroker": "0226",
        "brokerName": "EVERCORE GROUP L.L.C.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "ISLL",
        "clearingBroker": "0052",
        "brokerName": "INLET SECURITIES LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "ISSB",
        "clearingBroker": "0443",
        "brokerName": "IRONSTONE SECURITIES INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ISSC",
        "clearingBroker": "0443",
        "brokerName": "INVESTORS SECURITIES SERVICES, LLC                                    "
    },
    {
        "type": "MUNI",
        "mpid": "ISSI",
        "clearingBroker": "0052",
        "brokerName": "INSIGHT SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "ITCC",
        "clearingBroker": "0750",
        "brokerName": "STERNE AGEE FINANCIAL SERVICES, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "ITFS",
        "clearingBroker": "0226",
        "brokerName": "KEEL POINT CAPITAL, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "IVEX",
        "clearingBroker": "0443",
        "brokerName": "INVEX, INC.                                                           "
    },
    {
        "type": "MUNI",
        "mpid": "IVNT",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT NETWORK, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "IVOL",
        "clearingBroker": "0235",
        "brokerName": "UNION CAPITAL COMPANY                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "IVST",
        "clearingBroker": "0443",
        "brokerName": "INTERVEST INTERNATIONAL EQUITIES CORPORATION                          "
    },
    {
        "type": "MUNI",
        "mpid": "JACK",
        "clearingBroker": "0443",
        "brokerName": "JACKSON SECURITIES LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "JANC",
        "clearingBroker": "0443",
        "brokerName": "JANCO PARTNERS INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "JANE",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET MARKETS, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "JANY",
        "clearingBroker": "0374",
        "brokerName": "JANNEY MONTGOMERY SCOTT LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "JASC",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "JDAA",
        "clearingBroker": "0443",
        "brokerName": "DARDIS (JACK) & ASSOCIATES                                            "
    },
    {
        "type": "MUNI",
        "mpid": "JDRB",
        "clearingBroker": "0595",
        "brokerName": "J.H. DARBIE & CO., INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "JEFF",
        "clearingBroker": "0019",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "JEFM",
        "clearingBroker": "0235",
        "brokerName": "JEFFREY MATTHEWS FINANCIAL GROUP, L.L.C.                              "
    },
    {
        "type": "MUNI",
        "mpid": "JEVO",
        "clearingBroker": "0235",
        "brokerName": "ATIS, INC                                                             "
    },
    {
        "type": "MUNI",
        "mpid": "JGUN",
        "clearingBroker": "0235",
        "brokerName": "JOSEPH GUNNAR & CO. LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "JHDR",
        "clearingBroker": "0052",
        "brokerName": "JH DARBIE & CO. INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "JHYT",
        "clearingBroker": "0019",
        "brokerName": "JEFFERIES PARTNER OPPORTUNITY FUND II, LLC                            "
    },
    {
        "type": "MUNI",
        "mpid": "JJKE",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "JKCA",
        "clearingBroker": "0103",
        "brokerName": "J.K. CHILTON & ASSOCIATES, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "JKFS",
        "clearingBroker": "0279",
        "brokerName": "J.K. FINANCIAL SERVICES INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "JKRC",
        "clearingBroker": "0443",
        "brokerName": "J.K.R. & CO., INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "JLEQ",
        "clearingBroker": "0161",
        "brokerName": "JUMP EXECUTION, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "JMFL",
        "clearingBroker": "0235",
        "brokerName": "THE JEFFREY MATTHEWS FINANCIAL GROUP, L.L.C.                          "
    },
    {
        "type": "MUNI",
        "mpid": "JMLS",
        "clearingBroker": "0235",
        "brokerName": "J.M LUMMIS SECURITIES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "JNST",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "JNWS",
        "clearingBroker": "0443",
        "brokerName": "WHIPPLE (J.N.) INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "JONE",
        "clearingBroker": "0161",
        "brokerName": "JONESTRADING                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "JPMC",
        "clearingBroker": "0443",
        "brokerName": "MCGOWAN (J.P.) & COMPANY, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "JPMT",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "JPPB",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "JRCO",
        "clearingBroker": "0226",
        "brokerName": "JOHNSON RICE & COMPANY L.L.C.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "JSAP",
        "clearingBroker": "8497",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "JSBA",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "JSCT",
        "clearingBroker": "0005",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "JSEB",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "JSEG",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "JSSF",
        "clearingBroker": "0226",
        "brokerName": "JMP SECURITIES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "JVBF",
        "clearingBroker": "0235",
        "brokerName": "JACK V. BUTTERFIELD INVESTMENT COMPANY                                "
    },
    {
        "type": "MUNI",
        "mpid": "JVBG",
        "clearingBroker": "0443",
        "brokerName": "J.V.B. FINANCIAL GROUP LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "JWCF",
        "clearingBroker": "0226",
        "brokerName": "J. W. COLE FINANCIAL, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "KALA",
        "clearingBroker": "0226",
        "brokerName": "KA ASSOCIATES, INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "KALS",
        "clearingBroker": "0235",
        "brokerName": "KALOS CAPITAL, INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "KART",
        "clearingBroker": "0750",
        "brokerName": "REVERE SECURITIES CORP.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "KAWM",
        "clearingBroker": "0443",
        "brokerName": "ARETE WEALTH MANAGEMENT, LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "KBWI",
        "clearingBroker": "0793",
        "brokerName": "KEEFE, BRUYETTE & WOODS, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "KCAM",
        "clearingBroker": "0052",
        "brokerName": "K2 CAPITAL ASSET MANAGEMENT, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "KCIM",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT MANAGEMENT CORPORATION                                     "
    },
    {
        "type": "MUNI",
        "mpid": "KCIX",
        "clearingBroker": "0279",
        "brokerName": "KILEY PARTNERS, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "KCRD",
        "clearingBroker": "0052",
        "brokerName": "PHX FINANCIAL, INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "KENY",
        "clearingBroker": "0443",
        "brokerName": "KENNY SECURITIES CORP.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "KEYB",
        "clearingBroker": "0443",
        "brokerName": "KEYBANC CAPITAL MARKETS INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "KILD",
        "clearingBroker": "0103",
        "brokerName": "KILDARE CAPITAL, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "KIML",
        "clearingBroker": "0226",
        "brokerName": "KIMELMAN & BAIRD, LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "KING",
        "clearingBroker": "0235",
        "brokerName": "C. L. KING & ASSOCIATES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "KISL",
        "clearingBroker": "0443",
        "brokerName": "KEY INVESTMENT SERVICES LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "KMSF",
        "clearingBroker": "0443",
        "brokerName": "KMS FINANCIAL SERVICES                                                "
    },
    {
        "type": "MUNI",
        "mpid": "KNGS",
        "clearingBroker": "0235",
        "brokerName": "KINGSWOOD CAPITAL PARTNERS, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "KOVP",
        "clearingBroker": "0443",
        "brokerName": "KOVACK SECURITIES INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "KOVS",
        "clearingBroker": "0226",
        "brokerName": "KOVACK SECURITIES, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "KRAM",
        "clearingBroker": "0141",
        "brokerName": "KRAMER SECURITIES CORP.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "KRCO",
        "clearingBroker": "0235",
        "brokerName": "KR SECURITIES, LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "KRSH",
        "clearingBroker": "0005",
        "brokerName": "KERSHNER SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "KRTH",
        "clearingBroker": "0235",
        "brokerName": "J.W. KORTH & COMPANY                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "KRUG",
        "clearingBroker": "0235",
        "brokerName": "KRUEGER BROKERAGE, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "KUYK",
        "clearingBroker": "0279",
        "brokerName": "KUYKENDALL & SCHNEIDER, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "LAFB",
        "clearingBroker": "0235",
        "brokerName": "LAFFERTY (R.F.) & CO., INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "LAFC",
        "clearingBroker": "0443",
        "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "LAFF",
        "clearingBroker": "0443",
        "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "LAGI",
        "clearingBroker": "0226",
        "brokerName": "ALLSTATE FINANCIAL SERVICES, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "LAMA",
        "clearingBroker": "0141",
        "brokerName": "XML SECURITIES                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "LANE",
        "clearingBroker": "0235",
        "brokerName": "MARC J. LANE & COMPANY                                                "
    },
    {
        "type": "MUNI",
        "mpid": "LARC",
        "clearingBroker": "0235",
        "brokerName": "LARIMER CAPITAL CORPORATION                                           "
    },
    {
        "type": "MUNI",
        "mpid": "LASE",
        "clearingBroker": "0235",
        "brokerName": "LEGACY ASSET SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "LASI",
        "clearingBroker": "0141",
        "brokerName": "LIEBLONG & ASSOCIATES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "LASS",
        "clearingBroker": "0226",
        "brokerName": "LASALLE ST. SECURITIES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "LATG",
        "clearingBroker": "0537",
        "brokerName": "GFI SECURITIES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "LATN",
        "clearingBroker": "0443",
        "brokerName": "HEROLD & LANTERN INVESTMENTS, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "LBKI",
        "clearingBroker": "0235",
        "brokerName": "LIBUCKI & CO., LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "LDIL",
        "clearingBroker": "0226",
        "brokerName": "LINCOLN DOUGLAS INVESTMENTS, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "LDLW",
        "clearingBroker": "0750",
        "brokerName": "LAIDLAW & COMPANY (UK) LTD.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "LDOT",
        "clearingBroker": "0235",
        "brokerName": "LANDOLT SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "LEAD",
        "clearingBroker": "0226",
        "brokerName": "THE LEADERS GROUP, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "LEBO",
        "clearingBroker": "0226",
        "brokerName": "LEIGH BALDWIN & CO., LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "LEDG",
        "clearingBroker": "0443",
        "brokerName": "LEDGEWOOD CAPITAL MANAGEMENT, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "LEER",
        "clearingBroker": "0443",
        "brokerName": "LEERINK SWANN & COMPANY                                               "
    },
    {
        "type": "MUNI",
        "mpid": "LENX",
        "clearingBroker": "0279",
        "brokerName": "LENOX FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "LEON",
        "clearingBroker": "0235",
        "brokerName": "LEONARD SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "LESW",
        "clearingBroker": "0443",
        "brokerName": "LEERINK SWANN & COMPANY                                               "
    },
    {
        "type": "MUNI",
        "mpid": "LEXI",
        "clearingBroker": "0226",
        "brokerName": "LEXINGTON INVESTMENT COMPANY, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "LEYA",
        "clearingBroker": "0235",
        "brokerName": "LEMLEY, YARLING & CO.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "LFAC",
        "clearingBroker": "0226",
        "brokerName": "OSAIC FA, INC.                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "LFIN",
        "clearingBroker": "0161",
        "brokerName": "LIGHTHOUSE FINANCIAL GROUP, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LFRO",
        "clearingBroker": "0235",
        "brokerName": "LF ROTHSCHILD, LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "LGLL",
        "clearingBroker": "0141",
        "brokerName": "MM GLOBAL SECURITIES, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "LGNT",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "LGSA",
        "clearingBroker": "0443",
        "brokerName": "WOORI INVESTMENT AND SECURITIES AMERICA, INC.                         "
    },
    {
        "type": "MUNI",
        "mpid": "LIBE",
        "clearingBroker": "0443",
        "brokerName": "KCG AMERICAS LLC                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "LIFG",
        "clearingBroker": "0279",
        "brokerName": "LONG ISLAND FINANCIAL GROUP, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "LIIS",
        "clearingBroker": "0226",
        "brokerName": "USAA FINANCIAL ADVISORS, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "LINQ",
        "clearingBroker": "0443",
        "brokerName": "LINKBROKERS DERIVATIVES CORPORATION                                   "
    },
    {
        "type": "MUNI",
        "mpid": "LISI",
        "clearingBroker": "0443",
        "brokerName": "LEUMI INVESTMENT SERVICES, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LMAR",
        "clearingBroker": "0226",
        "brokerName": "LIFEMARK SECURITIES CORP.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "LMKO",
        "clearingBroker": "0235",
        "brokerName": "KOHN (L.M.) & COMPANY                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "LMSC",
        "clearingBroker": "0235",
        "brokerName": "BAY COLONY SECURITIES CO., INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LNKS",
        "clearingBroker": "0443",
        "brokerName": "GUGGENHEIM SECURITIES, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "LOMB",
        "clearingBroker": "0141",
        "brokerName": "LOMBARD SECURITIES INCORPORATED                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LOOP",
        "clearingBroker": "0443",
        "brokerName": "LOOP CAPITAL MARKETS, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "LOUE",
        "clearingBroker": "0161",
        "brokerName": "ICAP CORPORATES LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "LOUI",
        "clearingBroker": "0005",
        "brokerName": "LOUIS CAPITAL MARKETS, LP                                             "
    },
    {
        "type": "MUNI",
        "mpid": "LPCM",
        "clearingBroker": "0103",
        "brokerName": "LAMPERT CAPITAL MARKETS INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "LPFS",
        "clearingBroker": "0235",
        "brokerName": "LIBERTY PARTNERS FINANCIAL SERVICES, INC.                             "
    },
    {
        "type": "MUNI",
        "mpid": "LPLE",
        "clearingBroker": "0075",
        "brokerName": "LPL ENTERPRISE, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "LPSP",
        "clearingBroker": "1043",
        "brokerName": "LPS CAPITAL LLC                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LQNA",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LQNB",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LQNF",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LQNT",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LQPT",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LRBC",
        "clearingBroker": "0235",
        "brokerName": "LIBERTY ASSOCIATES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "LRCM",
        "clearingBroker": "0279",
        "brokerName": "LOCKTON RE CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LSCM",
        "clearingBroker": "0235",
        "brokerName": "LAKE STREET CAPITAL MARKETS, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "LSKO",
        "clearingBroker": "0226",
        "brokerName": "LESKO SECURITIES INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "LSPI",
        "clearingBroker": "0141",
        "brokerName": "LAFAYETTE INVESTMENTS                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "LSSM",
        "clearingBroker": "0443",
        "brokerName": "LOCUST STREET SECURITIES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "LSUS",
        "clearingBroker": "0443",
        "brokerName": "LATIN SECURITIES INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "LTCO",
        "clearingBroker": "0226",
        "brokerName": "LADENBURG, THALMANN & CO., INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LTCS",
        "clearingBroker": "0141",
        "brokerName": "LINDEN THOMAS AND COMPANY SECURITIES, LLC                             "
    },
    {
        "type": "MUNI",
        "mpid": "LTIN",
        "clearingBroker": "2786",
        "brokerName": "BBVA SECURITIES INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "LTLI",
        "clearingBroker": "0141",
        "brokerName": "L.P. LITTLEWOOD & ASSOCIATES, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "LVMR",
        "clearingBroker": "0235",
        "brokerName": "LIVERMORE TRADING GROUP, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "LYON",
        "clearingBroker": "0651",
        "brokerName": "CREDIT AGRICOLE SECURITIES (USA) INC.                                 "
    },
    {
        "type": "MUNI",
        "mpid": "LYSI",
        "clearingBroker": "0443",
        "brokerName": "LLOYDS SECURITIES INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "MACC",
        "clearingBroker": "0226",
        "brokerName": "NEWEDGE SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "MACP",
        "clearingBroker": "0443",
        "brokerName": "GRIFFON MAY, INC.                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "MADV",
        "clearingBroker": "0443",
        "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "MAMA",
        "clearingBroker": "0443",
        "brokerName": "SECUREVEST FINANCIAL GROUP                                            "
    },
    {
        "type": "MUNI",
        "mpid": "MASE",
        "clearingBroker": "0141",
        "brokerName": "MANAGED ACCOUNT SERVICES, LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "MAVS",
        "clearingBroker": "0443",
        "brokerName": "MADISON AVENUE SECURITIES                                             "
    },
    {
        "type": "MUNI",
        "mpid": "MAXM",
        "clearingBroker": "0443",
        "brokerName": "MAXIM GROUP LLC                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "MBSA",
        "clearingBroker": "0052",
        "brokerName": "MBS SOURCE ETRADING, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "MBSE",
        "clearingBroker": "0052",
        "brokerName": "MBS SOURCE ETRADING, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "MBSL",
        "clearingBroker": "0443",
        "brokerName": "MBS CAPITAL MARKETS, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "MBTS",
        "clearingBroker": "0158",
        "brokerName": "MB TRADING                                                            "
    },
    {
        "type": "MUNI",
        "mpid": "MBUS",
        "clearingBroker": "0052",
        "brokerName": "MEDIOBANCA SECURITIES USA LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "MCAP",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "MUNI",
        "mpid": "MCBT",
        "clearingBroker": "0235",
        "brokerName": "MOORS & CABOT, INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "MCCL",
        "clearingBroker": "0443",
        "brokerName": "MCCLURG CAPITAL CORPORATION                                           "
    },
    {
        "type": "MUNI",
        "mpid": "MCMG",
        "clearingBroker": "0279",
        "brokerName": "MUNICIPAL CAPITAL MARKETS GROUP, INC.                                 "
    },
    {
        "type": "MUNI",
        "mpid": "MDGP",
        "clearingBroker": "0235",
        "brokerName": "MD GLOBAL PARTNERS, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "MDGS",
        "clearingBroker": "0103",
        "brokerName": "MIDDLEGATE SECURITIES LTD.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "MDTH",
        "clearingBroker": "0443",
        "brokerName": "MEREDITH (ROBERT R.) & CO.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "MEAL",
        "clearingBroker": "0226",
        "brokerName": "M. E. ALLISON & CO., INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "MERP",
        "clearingBroker": "0235",
        "brokerName": "MERIDIAN EQUITY PARTNERS, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "MERQ",
        "clearingBroker": "0161",
        "brokerName": "MERCATOR ASSOCIATES LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "MESF",
        "clearingBroker": "0443",
        "brokerName": "MESIROW FINANCIAL, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "MFCA",
        "clearingBroker": "0141",
        "brokerName": "MONARCH FINANCIAL CORPORATION OF AMERICA                              "
    },
    {
        "type": "MUNI",
        "mpid": "MFGX",
        "clearingBroker": "0443",
        "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "MFRS",
        "clearingBroker": "0443",
        "brokerName": "MFR SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "MHFI",
        "clearingBroker": "0226",
        "brokerName": "M HOLDINGS SECURITIES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "MIAM",
        "clearingBroker": "6440",
        "brokerName": "FMSBONDS, INC.                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "MICG",
        "clearingBroker": "0141",
        "brokerName": "MICG INVESTMENT MANAGEMENT                                            "
    },
    {
        "type": "MUNI",
        "mpid": "MIDL",
        "clearingBroker": "0226",
        "brokerName": "MIDDLEGATE SECURITIES LTD.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "MIFI",
        "clearingBroker": "0226",
        "brokerName": "MILKIE FERGUSON INVESTMENTS, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "MILN",
        "clearingBroker": "1767",
        "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "MINV",
        "clearingBroker": "0235",
        "brokerName": "MACK INVESTMENTS SECURITIES, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "MIRA",
        "clearingBroker": "1043",
        "brokerName": "MIRAE ASSET SECURITIES (USA) INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "MISL",
        "clearingBroker": "0161",
        "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "MISM",
        "clearingBroker": "0161",
        "brokerName": "MISMI, INC.                                                           "
    },
    {
        "type": "MUNI",
        "mpid": "MITR",
        "clearingBroker": "0443",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "MJWH",
        "clearingBroker": "0235",
        "brokerName": "ETICO PARTNERS LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "MKRT",
        "clearingBroker": "0235",
        "brokerName": "MARKET SECURITIES, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "MKTI",
        "clearingBroker": "0226",
        "brokerName": "U.S. BANCORP ADVISORS, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "MKTX",
        "clearingBroker": "4265",
        "brokerName": "MARKETAXESS CORPORATION                                               "
    },
    {
        "type": "MUNI",
        "mpid": "MKTY",
        "clearingBroker": "4265",
        "brokerName": "MARKETAXESS CORPORATION                                               "
    },
    {
        "type": "MUNI",
        "mpid": "MLCO",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "MLMA",
        "clearingBroker": "0671",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "MUNI",
        "mpid": "MLMS",
        "clearingBroker": "0279",
        "brokerName": "MAINLINE WEST MUNICIPAL SECURITIES, LLC                               "
    },
    {
        "type": "MUNI",
        "mpid": "MLWM",
        "clearingBroker": "0671",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "MUNI",
        "mpid": "MMAN",
        "clearingBroker": "0443",
        "brokerName": "MCMAHAN SECURITIES CO. L.P.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "MMNT",
        "clearingBroker": "0158",
        "brokerName": "MOMENT MARKETS, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "MNCO",
        "clearingBroker": "0279",
        "brokerName": "NELSON (MARTIN) & CO., INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "MNRC",
        "clearingBroker": "0443",
        "brokerName": "MONARCH CAPITAL GROUP LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "MNXS",
        "clearingBroker": "0443",
        "brokerName": "MUNIAXIS LEBENTHAL LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "MOCM",
        "clearingBroker": "0235",
        "brokerName": "MORETON CAPITAL MARKETS, LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "MOJO",
        "clearingBroker": "0103",
        "brokerName": "MONTAG & JOSELSON                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "MOLO",
        "clearingBroker": "0235",
        "brokerName": "MOLONEY SECURITIES                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "MOMS",
        "clearingBroker": "0750",
        "brokerName": "MOMENTUS SECURITIES LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "MONR",
        "clearingBroker": "0226",
        "brokerName": "MONROE FINANCIAL PARTNERS, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "MORA",
        "clearingBroker": "0443",
        "brokerName": "MORA WM SECURITIES                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "MPLA",
        "clearingBroker": "0158",
        "brokerName": "EMPALA SECURITIES, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "MPLM",
        "clearingBroker": "0651",
        "brokerName": "MOMENTUM TRADING PARTNERS, LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "MPLW",
        "clearingBroker": "0226",
        "brokerName": "MAPLEWOOD INVESTMENT ADVISORS, INC.                                   "
    },
    {
        "type": "MUNI",
        "mpid": "MPSG",
        "clearingBroker": "0161",
        "brokerName": "ED & F MAN CAPITAL MARKETS INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "MRBA",
        "clearingBroker": "0052",
        "brokerName": "IBN FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "MRNA",
        "clearingBroker": "0161",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "MRPH",
        "clearingBroker": "0226",
        "brokerName": "WM FINANCIAL SERVICES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "MRSC",
        "clearingBroker": "0287",
        "brokerName": "TRADEUP SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "MSCH",
        "clearingBroker": "0443",
        "brokerName": "MAGNA SECURITIES CORP.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "MSCO",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "MSEC",
        "clearingBroker": "0235",
        "brokerName": "MSEC, LLC                                                             "
    },
    {
        "type": "MUNI",
        "mpid": "MSII",
        "clearingBroker": "0226",
        "brokerName": "MSI FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "MSNY",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "MSPW",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "MSRO",
        "clearingBroker": "0226",
        "brokerName": "MESIROW FINANCIAL, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "MSSS",
        "clearingBroker": "0050",
        "brokerName": "MS SECURITIES SERVICES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "MSTC",
        "clearingBroker": "0226",
        "brokerName": "MIDWESTERN SECURITIES TRADING COMPANY, LLC                            "
    },
    {
        "type": "MUNI",
        "mpid": "MTBK",
        "clearingBroker": "0443",
        "brokerName": "MULTI-BANK SECURITIES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "MTCN",
        "clearingBroker": "0443",
        "brokerName": "MILLER TABAK & CO., LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "MTDB",
        "clearingBroker": "0443",
        "brokerName": "M&T SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "MTHN",
        "clearingBroker": "0005",
        "brokerName": "MARATHON TRADING GROUP LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "MTLE",
        "clearingBroker": "0235",
        "brokerName": "MTL EQUITY PRODUCTS, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "MTNS",
        "clearingBroker": "0443",
        "brokerName": "MOUNTAINSIDE SECURITIES LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "MTRN",
        "clearingBroker": "0443",
        "brokerName": "MULTITRADE SECURITIES LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "MTSL",
        "clearingBroker": "0226",
        "brokerName": "MSEC, LLC                                                             "
    },
    {
        "type": "MUNI",
        "mpid": "MUFG",
        "clearingBroker": "0076",
        "brokerName": "MUFG SECURITIES AMERICAS INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "MULT",
        "clearingBroker": "0443",
        "brokerName": "MULTI-FINANCIAL SECURITIES GROUP                                      "
    },
    {
        "type": "MUNI",
        "mpid": "MUNP",
        "clearingBroker": "0443",
        "brokerName": "MUNICIPAL PARTNERS                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "MURF",
        "clearingBroker": "0443",
        "brokerName": "MURPHY & DURIEU                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "MVII",
        "clearingBroker": "0235",
        "brokerName": "MINNESOTA VALLEY INVESTMENTS                                          "
    },
    {
        "type": "MUNI",
        "mpid": "MWCC",
        "clearingBroker": "0235",
        "brokerName": "MONNESS CRESPI HARDT & CO., INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "MWCO",
        "clearingBroker": "0443",
        "brokerName": "MADISON WILLIAMS AND COMPANY                                          "
    },
    {
        "type": "MUNI",
        "mpid": "MWIL",
        "clearingBroker": "0235",
        "brokerName": "MORGAN WILSHIRE SECURITIES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "MYMK",
        "clearingBroker": "0443",
        "brokerName": "MONEY MARKET 1 INSTITUTIONAL INVESTMENT DEALER                        "
    },
    {
        "type": "MUNI",
        "mpid": "MYSS",
        "clearingBroker": "0158",
        "brokerName": "M.Y. SAFRA SECURITIES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "MZHO",
        "clearingBroker": "2396",
        "brokerName": "MIZUHO SECURITIES USA LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "NACM",
        "clearingBroker": "0161",
        "brokerName": "NABSECURITIES, LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "NADL",
        "clearingBroker": "0235",
        "brokerName": "WARREN D. NADEL & COMPANY                                             "
    },
    {
        "type": "MUNI",
        "mpid": "NAIS",
        "clearingBroker": "0443",
        "brokerName": "NORTH AMERICAN CAPITAL MARKETS                                        "
    },
    {
        "type": "MUNI",
        "mpid": "NAPK",
        "clearingBroker": "0052",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "MUNI",
        "mpid": "NASC",
        "clearingBroker": "0235",
        "brokerName": "NATALLIANCE SECURITIES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "NAVC",
        "clearingBroker": "0235",
        "brokerName": "NAVIAN CAPITAL SECURITIES LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "NBAR",
        "clearingBroker": "0226",
        "brokerName": "NANCY BARRON & ASSOCIATES, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "NBCS",
        "clearingBroker": "0235",
        "brokerName": "NBC SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "NBLB",
        "clearingBroker": "0226",
        "brokerName": "NEUBERGER BERMAN BD LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "NBNA",
        "clearingBroker": "6737",
        "brokerName": "BANK OF AMERICA, N.A.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "NBSL",
        "clearingBroker": "0226",
        "brokerName": "BMO NESBITT BURNS SECURITIES LTD.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "NBST",
        "clearingBroker": "0103",
        "brokerName": "BRANDIS TALLMAN LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "NEPP",
        "clearingBroker": "0226",
        "brokerName": "N.E. PRIVATE CLIENT ADVISORS, LTD.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "NEST",
        "clearingBroker": "0235",
        "brokerName": "NEST INVESTMENTS BD LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "NEXT",
        "clearingBroker": "0443",
        "brokerName": "NEXT FINANCIAL GROUP, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "NFGR",
        "clearingBroker": "0141",
        "brokerName": "NATIONS FINANCIAL GROUP, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "NFSC",
        "clearingBroker": "0226",
        "brokerName": "NATIONAL FINANCIAL SERVICES LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "NFTY",
        "clearingBroker": "0235",
        "brokerName": "INFINITY FINANCIAL SERVICES                                           "
    },
    {
        "type": "MUNI",
        "mpid": "NHWI",
        "clearingBroker": "0141",
        "brokerName": "HENNION & WALSH, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "NIAD",
        "clearingBroker": "0052",
        "brokerName": "NI ADVISORS                                                           "
    },
    {
        "type": "MUNI",
        "mpid": "NITC",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "NLOV",
        "clearingBroker": "0279",
        "brokerName": "NORTLOV SECURITIES LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "NOBL",
        "clearingBroker": "0443",
        "brokerName": "NOBLE FINANCIAL CAPITAL MARKETS                                       "
    },
    {
        "type": "MUNI",
        "mpid": "NORC",
        "clearingBroker": "0235",
        "brokerName": "NORTHERN CAPITAL SEC. CORP.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "NORP",
        "clearingBroker": "0443",
        "brokerName": "PARETO SECURITIES INC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "NORT",
        "clearingBroker": "0443",
        "brokerName": "NORTHLAND SECURITIES, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "NORW",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO BROKERAGE SERVICES, LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "NQBX",
        "clearingBroker": "0163",
        "brokerName": "NASDAQ BX, INC.                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "NSFP",
        "clearingBroker": "0235",
        "brokerName": "NORTHSTAR FINANCIAL PARTNERS, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "NSRD",
        "clearingBroker": "0235",
        "brokerName": "NESTLERODE & CO., INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "NTFN",
        "clearingBroker": "0052",
        "brokerName": "NETWORK 1 FINANCIAL SECURITIES INC.                                   "
    },
    {
        "type": "MUNI",
        "mpid": "NTRC",
        "clearingBroker": "0226",
        "brokerName": "NORTHERN TRUST SECURITIES, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "NTSI",
        "clearingBroker": "0443",
        "brokerName": "NESBITT THOMSON SECURITIES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "NVEN",
        "clearingBroker": "0448",
        "brokerName": "NUVEEN SECURITIES, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "NVGT",
        "clearingBroker": "0388",
        "brokerName": "NAVIGATE ADVISORS LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "NWCM",
        "clearingBroker": "0235",
        "brokerName": "NW CAPITAL MARKETS INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "NWIA",
        "clearingBroker": "0750",
        "brokerName": "NORTHWEST INVESTMENT ADVISORS, INC.                                   "
    },
    {
        "type": "MUNI",
        "mpid": "NYLS",
        "clearingBroker": "0226",
        "brokerName": "NYLIFE SECURITIES INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "OAKR",
        "clearingBroker": "0235",
        "brokerName": "THE OAK RIDGE FINANCIAL SERVICES GROUP, INC.                          "
    },
    {
        "type": "MUNI",
        "mpid": "OBWS",
        "clearingBroker": "0226",
        "brokerName": "OBERWEIS SECURITIES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "OCAC",
        "clearingBroker": "0235",
        "brokerName": "OLSON, CROSS & ALAMO LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "OCON",
        "clearingBroker": "0103",
        "brokerName": "O'CONNOR & CO SECURITIES                                              "
    },
    {
        "type": "MUNI",
        "mpid": "ODEO",
        "clearingBroker": "0388",
        "brokerName": "ODEON CAP                                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ODNC",
        "clearingBroker": "0235",
        "brokerName": "ODEON CAPITAL GROUP LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "OFGF",
        "clearingBroker": "0235",
        "brokerName": "OFG FINANCIAL SERVICES INC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "OGRU",
        "clearingBroker": "0161",
        "brokerName": "OSCAR GRUSS & SON, INCORPORATED                                       "
    },
    {
        "type": "MUNI",
        "mpid": "OGTL",
        "clearingBroker": "0005",
        "brokerName": "OUTSET GLOBAL TRADING LIMITED                                         "
    },
    {
        "type": "MUNI",
        "mpid": "OHIO",
        "clearingBroker": "0443",
        "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "OLDM",
        "clearingBroker": "0005",
        "brokerName": "OLD MISSION CAPITAL, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "OLNE",
        "clearingBroker": "0279",
        "brokerName": "OLDEN LANE SECURITIES, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "OMMA",
        "clearingBroker": "0005",
        "brokerName": "OLD MISSION MARKETS LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "ONEL",
        "clearingBroker": "0161",
        "brokerName": "O'NEIL (WILLIAM) & CO                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "ONES",
        "clearingBroker": "0443",
        "brokerName": "O N EQUITY SALES CO.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "OPCO",
        "clearingBroker": "0571",
        "brokerName": "OPPENHEIMER & CO. INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "OPTF",
        "clearingBroker": "0005",
        "brokerName": "OPTIVER US LLC                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "ORTL",
        "clearingBroker": "0443",
        "brokerName": "ORIENTAL FINANCIAL SERVICES                                           "
    },
    {
        "type": "MUNI",
        "mpid": "OSIC",
        "clearingBroker": "0226",
        "brokerName": "OSAIC INSTITUTIONS, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "OTCN",
        "clearingBroker": "0158",
        "brokerName": "OTC LINK LLC                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "OTSC",
        "clearingBroker": "0443",
        "brokerName": "OGILVIE SECURITY ADVISORS CORPORATION                                 "
    },
    {
        "type": "MUNI",
        "mpid": "OYLD",
        "clearingBroker": "0235",
        "brokerName": "OPENYIELD TRADING LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "PAFA",
        "clearingBroker": "0443",
        "brokerName": "PAN-AMERICAN FINANCIAL ADVISORS                                       "
    },
    {
        "type": "MUNI",
        "mpid": "PAMC",
        "clearingBroker": "0226",
        "brokerName": "PROGRESSIVE ASSET MANAGEMENT                                          "
    },
    {
        "type": "MUNI",
        "mpid": "PAMI",
        "clearingBroker": "0141",
        "brokerName": "PROFESSIONAL ASSET MANAGEMENT, INC.                                   "
    },
    {
        "type": "MUNI",
        "mpid": "PAMS",
        "clearingBroker": "0443",
        "brokerName": "PACIFIC AMERICAN SECURITIES, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "PANA",
        "clearingBroker": "0443",
        "brokerName": "PANAMERICA CAPITAL GROUP INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "PAPA",
        "clearingBroker": "0443",
        "brokerName": "PAPAMARKOU WELLNER & CO., INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "PARI",
        "clearingBroker": "0630",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "PARK",
        "clearingBroker": "0443",
        "brokerName": "PARK WALK CAPITAL MARKETS, LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "PARV",
        "clearingBroker": "0443",
        "brokerName": "PAR5 CAPITAL & CO LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "PASC",
        "clearingBroker": "0443",
        "brokerName": "PARK AVENUE SECURITIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "PASL",
        "clearingBroker": "0443",
        "brokerName": "PERSHING ADVISOR SOLUTIONS, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "PASQ",
        "clearingBroker": "0443",
        "brokerName": "DUPASQUIER & CO., INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "PATR",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "PAUL",
        "clearingBroker": "0595",
        "brokerName": "PAULSON INVESTMENT COMPANY, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "PBON",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "PCAP",
        "clearingBroker": "0608",
        "brokerName": "SG AMERICAS SECURITIES, LLC/SUB 608                                   "
    },
    {
        "type": "MUNI",
        "mpid": "PCCA",
        "clearingBroker": "0279",
        "brokerName": "PEACHCAP SECURITIES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "PCCN",
        "clearingBroker": "0443",
        "brokerName": "PACTUAL CAPITAL CORPORATION                                           "
    },
    {
        "type": "MUNI",
        "mpid": "PCIS",
        "clearingBroker": "0226",
        "brokerName": "BANKOH INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "PEER",
        "clearingBroker": "0226",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "MUNI",
        "mpid": "PENG",
        "clearingBroker": "0443",
        "brokerName": "PENNSYLVANIA GROUP INCORPORATED (THE)                                 "
    },
    {
        "type": "MUNI",
        "mpid": "PERC",
        "clearingBroker": "0279",
        "brokerName": "PERCIVAL FINANCIAL PARTNERS, LTD.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "PERS",
        "clearingBroker": "0443",
        "brokerName": "PERSHING LLC                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "PFCG",
        "clearingBroker": "0279",
        "brokerName": "PREFERRED CLIENT GROUP, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "PFCL",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "PFDC",
        "clearingBroker": "0235",
        "brokerName": "PREFERRED CAPITAL SECURITIES, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "PFPI",
        "clearingBroker": "0443",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "PGRS",
        "clearingBroker": "0443",
        "brokerName": "PGR SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "PGSI",
        "clearingBroker": "0443",
        "brokerName": "PRIME GLOBAL SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "PHBP",
        "clearingBroker": "0052",
        "brokerName": "PENNHAVEN BROKERAGE PARTNERS, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "PHIN",
        "clearingBroker": "0443",
        "brokerName": "PHILADELPHIA INVESTORS, LTD.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "PHRS",
        "clearingBroker": "0279",
        "brokerName": "NAVAID FINANCIAL SERVICES, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "PICI",
        "clearingBroker": "0279",
        "brokerName": "POLAR INVESTMENT COUNSEL, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "PICL",
        "clearingBroker": "0052",
        "brokerName": "PAULSON INVESTMENT COMPANY LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "PIGS",
        "clearingBroker": "0443",
        "brokerName": "PENN INVESTMENT GROUP, INC. (THE)                                     "
    },
    {
        "type": "MUNI",
        "mpid": "PIMS",
        "clearingBroker": "0226",
        "brokerName": "PRUDENTIAL INVESTMENT MANAGEMENT SERVICES, LLC                        "
    },
    {
        "type": "MUNI",
        "mpid": "PINA",
        "clearingBroker": "0141",
        "brokerName": "PINNACLE INVESTMENTS, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "PIPR",
        "clearingBroker": "0443",
        "brokerName": "PIPER SANDLER & CO.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "PIRR",
        "clearingBroker": "0443",
        "brokerName": "PIRRONE & CO., INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "PJEF",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "PKAX",
        "clearingBroker": "0158",
        "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "PMAS",
        "clearingBroker": "0443",
        "brokerName": "PMA SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "PMKS",
        "clearingBroker": "0141",
        "brokerName": "PMK SECURITIES & RESEARCH, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "PNCC",
        "clearingBroker": "0226",
        "brokerName": "PNC INVESTMENTS                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "PNCM",
        "clearingBroker": "2835",
        "brokerName": "PNC CAPITAL MARKETS LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "PNFP",
        "clearingBroker": "0279",
        "brokerName": "PNFP CAPITAL MARKETS, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "PNSA",
        "clearingBroker": "0235",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "PNSR",
        "clearingBroker": "0161",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "PODE",
        "clearingBroker": "0235",
        "brokerName": "PODESTA & CO.                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "POND",
        "clearingBroker": "0141",
        "brokerName": "POND EQUITIES                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "POOH",
        "clearingBroker": "0443",
        "brokerName": "QUESTAR CAPITAL CORPORATION                                           "
    },
    {
        "type": "MUNI",
        "mpid": "POPS",
        "clearingBroker": "0226",
        "brokerName": "POPULAR SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "POWL",
        "clearingBroker": "0443",
        "brokerName": "POWELL (ELMER E.) COMPANY                                             "
    },
    {
        "type": "MUNI",
        "mpid": "PPSI",
        "clearingBroker": "0235",
        "brokerName": "PENSION PLANNERS SECURITIES, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "PPSL",
        "clearingBroker": "0413",
        "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "PREB",
        "clearingBroker": "0005",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "PRFA",
        "clearingBroker": "0235",
        "brokerName": "PROOF SERVICES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "PRGL",
        "clearingBroker": "0141",
        "brokerName": "PRUDENTIAL EQUITY GROUP, LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "PROE",
        "clearingBroker": "0443",
        "brokerName": "PROEQUITIES, INC.                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "PRPO",
        "clearingBroker": "0443",
        "brokerName": "PRIVATE PORTFOLIO, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "PRSB",
        "clearingBroker": "0141",
        "brokerName": "PRESIDENTIAL BROKERAGE, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "PRST",
        "clearingBroker": "0551",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "PSAE",
        "clearingBroker": "0141",
        "brokerName": "PSA EQUITIES, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "PSII",
        "clearingBroker": "0226",
        "brokerName": "KESTRA INVESTMENT SERVICES, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "PSIM",
        "clearingBroker": "0226",
        "brokerName": "PRINCIPAL SECURITIES, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "PSIN",
        "clearingBroker": "0443",
        "brokerName": "LUMENT SECURITIES, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "PSRI",
        "clearingBroker": "0103",
        "brokerName": "GLOBALINK SECURITIES, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "PSUT",
        "clearingBroker": "0235",
        "brokerName": "INNOVATION PARTNERS LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "PTCM",
        "clearingBroker": "0443",
        "brokerName": "CAVU SECURITIES LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "PTIS",
        "clearingBroker": "0235",
        "brokerName": "PTI SECURITIES & FUTURES L.P.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "PTRI",
        "clearingBroker": "0443",
        "brokerName": "PETRIE PARKMAN & CO.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "PULB",
        "clearingBroker": "0052",
        "brokerName": "PULASKI BANK                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "PUMP",
        "clearingBroker": "0141",
        "brokerName": "C.E. GAYE & SONS SECURITIES LTD.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "PUPL",
        "clearingBroker": "0226",
        "brokerName": "PUPLAVA SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "PURP",
        "clearingBroker": "0279",
        "brokerName": "LIBERTY CAPITAL INVESTMENT CORPORATION                                "
    },
    {
        "type": "MUNI",
        "mpid": "PWJC",
        "clearingBroker": "0221",
        "brokerName": "UBS FINANCIAL SERVICES INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "PWPR",
        "clearingBroker": "0221",
        "brokerName": "UBS FINANCIAL SERVICE INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "PXGJ",
        "clearingBroker": "0352",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "QBND",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "MUNI",
        "mpid": "QBSI",
        "clearingBroker": "0226",
        "brokerName": "GLEN EAGLE WEALTH, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "QCAP",
        "clearingBroker": "0235",
        "brokerName": "QUINT CAPITAL CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "QCAS",
        "clearingBroker": "0226",
        "brokerName": "QUINCY CASS ASSOCIATES, INCORPORATED                                  "
    },
    {
        "type": "MUNI",
        "mpid": "QMSR",
        "clearingBroker": "0235",
        "brokerName": "QUATTRO M SECURITIES INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "QUOI",
        "clearingBroker": "0279",
        "brokerName": "QUOIN CAPITAL LLC                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "QWIK",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "MUNI",
        "mpid": "RAAA",
        "clearingBroker": "0052",
        "brokerName": "RICHARD JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "RAAI",
        "clearingBroker": "0226",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "RACO",
        "clearingBroker": "0158",
        "brokerName": "SHEARMAN, RALSTON, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "RAIS",
        "clearingBroker": "0443",
        "brokerName": "ROYAL AMERICAN INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "MUNI",
        "mpid": "RAIT",
        "clearingBroker": "0161",
        "brokerName": "RAIT SECURITIES                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "RAJA",
        "clearingBroker": "0725",
        "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "RAYG",
        "clearingBroker": "0443",
        "brokerName": "BOLTON GLOBAL CAPITAL                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "RBAC",
        "clearingBroker": "0235",
        "brokerName": "ROBERT B. AUSDAL & CO. INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "RBCD",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "MUNI",
        "mpid": "RBCX",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "MUNI",
        "mpid": "RBII",
        "clearingBroker": "0279",
        "brokerName": "REGIONAL BROKERS, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "RBMU",
        "clearingBroker": "0279",
        "brokerName": "BLUM (ROBERT) MUNICIPALS INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "RCRS",
        "clearingBroker": "0226",
        "brokerName": "ROOSEVELT & CROSS, INCORPORATED                                       "
    },
    {
        "type": "MUNI",
        "mpid": "RCSK",
        "clearingBroker": "0642",
        "brokerName": "RUANE, CUNNIFF & GOLDBARB LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "RDSS",
        "clearingBroker": "0141",
        "brokerName": "RDSC, LLC                                                             "
    },
    {
        "type": "MUNI",
        "mpid": "REID",
        "clearingBroker": "0141",
        "brokerName": "REID AND ASSOCIATES LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "REPG",
        "clearingBroker": "0443",
        "brokerName": "FIRST REPUBLIC GROUP, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "REVL",
        "clearingBroker": "0750",
        "brokerName": "REVL SECURITIES, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "RFRC",
        "clearingBroker": "0279",
        "brokerName": "THE ROCKWELL FINANCIAL GROUP, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "RGIC",
        "clearingBroker": "0443",
        "brokerName": "R-G INVESTMENTS CORPORATION                                           "
    },
    {
        "type": "MUNI",
        "mpid": "RGLD",
        "clearingBroker": "0279",
        "brokerName": "REGAL SECURITIES, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "RGLS",
        "clearingBroker": "0235",
        "brokerName": "REGAL SECURITIES, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "RGWD",
        "clearingBroker": "0141",
        "brokerName": "RIDGEWOOD ASSOCIATES INC., NJ                                         "
    },
    {
        "type": "MUNI",
        "mpid": "RHCO",
        "clearingBroker": "0505",
        "brokerName": "TRUIST SECURITIES, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "RHDS",
        "clearingBroker": "0141",
        "brokerName": "RHODES SECURITIES, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "RHOX",
        "clearingBroker": "0005",
        "brokerName": "XR SECURITIES LLC                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "RIAP",
        "clearingBroker": "0443",
        "brokerName": "OSAIC SERVICES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "RICE",
        "clearingBroker": "0235",
        "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
    },
    {
        "type": "MUNI",
        "mpid": "RICJ",
        "clearingBroker": "0235",
        "brokerName": "RICE SECURITIES, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "RICM",
        "clearingBroker": "0595",
        "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
    },
    {
        "type": "MUNI",
        "mpid": "RIED",
        "clearingBroker": "0235",
        "brokerName": "RIEDL, FIRST SECURITIES COMPANY OF KANSAS                             "
    },
    {
        "type": "MUNI",
        "mpid": "RILY",
        "clearingBroker": "0226",
        "brokerName": "B. RILEY FBR, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "RINO",
        "clearingBroker": "0019",
        "brokerName": "RHINO TRADING PARTNERS, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "RJFI",
        "clearingBroker": "0390",
        "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "RKWS",
        "clearingBroker": "0235",
        "brokerName": "ROCKWELL SECURITIES LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "RMAC",
        "clearingBroker": "0235",
        "brokerName": "RENAISSANCE MACRO SECURITIES, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "RMPI",
        "clearingBroker": "0141",
        "brokerName": "RICHARDS, MERRILL & PETERSON, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "RMST",
        "clearingBroker": "0443",
        "brokerName": "R.M. STARK & CO., INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "ROAR",
        "clearingBroker": "0103",
        "brokerName": "DINOSAUR SECURITIES                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "ROBT",
        "clearingBroker": "0443",
        "brokerName": "ROBOTTI & COMPANY, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "ROCH",
        "clearingBroker": "0443",
        "brokerName": "ROCHDALE SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "ROCK",
        "clearingBroker": "0226",
        "brokerName": "ROCKEFELLER FINANCIAL LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "RODE",
        "clearingBroker": "0443",
        "brokerName": "RODECKER & COMPANY, INVESTMENT BROKERS, INC.                          "
    },
    {
        "type": "MUNI",
        "mpid": "ROMO",
        "clearingBroker": "0141",
        "brokerName": "ROMANO BROTHERS AND COMPANY                                           "
    },
    {
        "type": "MUNI",
        "mpid": "RONI",
        "clearingBroker": "0005",
        "brokerName": "RONIN CAPITAL, LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "ROPK",
        "clearingBroker": "0443",
        "brokerName": "REINOSO & COMPANY, INCORPORATED                                       "
    },
    {
        "type": "MUNI",
        "mpid": "ROTB",
        "clearingBroker": "0235",
        "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "ROTH",
        "clearingBroker": "0161",
        "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "ROYL",
        "clearingBroker": "0443",
        "brokerName": "ROYAL ALLIANCE ASSOCIATES, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "RQDR",
        "clearingBroker": "0235",
        "brokerName": "RQD* CLEARING LLC                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "RREZ",
        "clearingBroker": "0443",
        "brokerName": "SAMUEL A RAMIREZ & CO., INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "RRII",
        "clearingBroker": "0388",
        "brokerName": "ROBERTS & RYAN INVESTMENTS, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "RRPR",
        "clearingBroker": "0443",
        "brokerName": "SAMUEL A RAMIREZ, & CO., INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "RRUD",
        "clearingBroker": "0235",
        "brokerName": "REID & RUDIGER, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "RSCM",
        "clearingBroker": "0235",
        "brokerName": "ROBERTSON STEPHENS CAPITAL MARKETS, LLC                               "
    },
    {
        "type": "MUNI",
        "mpid": "RSCO",
        "clearingBroker": "0443",
        "brokerName": "RAMIUS SECURITIES, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "RSSE",
        "clearingBroker": "0443",
        "brokerName": "RUSSELL IMPLEMENTATION SERVICES INC. PART OF RUSSE                    "
    },
    {
        "type": "MUNI",
        "mpid": "RSWM",
        "clearingBroker": "0141",
        "brokerName": "RIVERSTONE WEALTH MANAGEMENT, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "RVSI",
        "clearingBroker": "0103",
        "brokerName": "ROBERT VAN SECURITIES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "RWPS",
        "clearingBroker": "0443",
        "brokerName": "R.W. PRESSPRICH & CO.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "RWSM",
        "clearingBroker": "0279",
        "brokerName": "R.W. SMITH & ASSOCIATES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "RYAN",
        "clearingBroker": "0443",
        "brokerName": "RYAN, BECK & CO.                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "SABF",
        "clearingBroker": "0161",
        "brokerName": "SAUDI AMERICAN BANK                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "SABS",
        "clearingBroker": "0443",
        "brokerName": "SABADELL SECURITIES USA, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "SAFS",
        "clearingBroker": "0750",
        "brokerName": "STERNE AGEE FINANCIAL SERVICES, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "SAFX",
        "clearingBroker": "0235",
        "brokerName": "SAF FINANCIAL SECURITIES LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SAGE",
        "clearingBroker": "0141",
        "brokerName": "SAGE, RUTTY & CO., INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "SALB",
        "clearingBroker": "0274",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC./SALOMON BROTHERS                        "
    },
    {
        "type": "MUNI",
        "mpid": "SALI",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "SAMI",
        "clearingBroker": "0226",
        "brokerName": "SAMI BROKERAGE LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "SAPA",
        "clearingBroker": "0141",
        "brokerName": "SAPERSTON ASSET MANAGEMENT INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "SARG",
        "clearingBroker": "0226",
        "brokerName": "PURSHE KAPLAN STERLING INVESTMENTS, INC.                              "
    },
    {
        "type": "MUNI",
        "mpid": "SAYB",
        "clearingBroker": "0103",
        "brokerName": "SAYBROOK CAPITAL CORPORATION                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SBAM",
        "clearingBroker": "0443",
        "brokerName": "INVESTMENT PROFESSIONALS, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "SBER",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "SBLS",
        "clearingBroker": "0235",
        "brokerName": "SAN BLAS SECURITIES LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "SBLT",
        "clearingBroker": "0226",
        "brokerName": "SUNBELT SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "SBRO",
        "clearingBroker": "0443",
        "brokerName": "STERN BROTHERS & CO.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "SBRT",
        "clearingBroker": "0226",
        "brokerName": "SIEBERT(MURIEL) & CO.,INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "SBRX",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "SBSC",
        "clearingBroker": "0226",
        "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "SBSL",
        "clearingBroker": "1043",
        "brokerName": "STOCKBLOCK SECURITIES LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "SCAP",
        "clearingBroker": "0595",
        "brokerName": "STRONG CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "SCFL",
        "clearingBroker": "0443",
        "brokerName": "STANCHART SECURITES INTL, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "SCHM",
        "clearingBroker": "0443",
        "brokerName": "A. R. SCHMEIDLER & CO., INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SCIL",
        "clearingBroker": "0052",
        "brokerName": "STRATEGIC CAPITAL INVESTMENTS, LLC                                    "
    },
    {
        "type": "MUNI",
        "mpid": "SCMC",
        "clearingBroker": "0096",
        "brokerName": "SCOTIA CAPITAL MARKETS (USA) INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "SCSI",
        "clearingBroker": "0370",
        "brokerName": "STANDARD CREDIT SECURITIES INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "SCSS",
        "clearingBroker": "0161",
        "brokerName": "STONECASTLE SECURITIES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "SCTI",
        "clearingBroker": "0443",
        "brokerName": "SECURITY CAPITAL BROKERAGE, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "SDIC",
        "clearingBroker": "0235",
        "brokerName": "SAUER DAZEY INVESTMENT CO.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "SEAP",
        "clearingBroker": "0226",
        "brokerName": "SEAPORT SECURITIES CORP.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "SEBR",
        "clearingBroker": "0158",
        "brokerName": "SENTINEL BROKERS COMPANY, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "SECS",
        "clearingBroker": "0161",
        "brokerName": "SECOND STREET SECURITIES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "SEEL",
        "clearingBroker": "0443",
        "brokerName": "R. SEELAUS & CO., INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "SEFB",
        "clearingBroker": "0052",
        "brokerName": "SOUTHEAST INVESTMENTS, N.C., INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "SEGE",
        "clearingBroker": "0443",
        "brokerName": "SEGERDAHL & CO.                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "SEIB",
        "clearingBroker": "0158",
        "brokerName": "SEIBERT (J.D.) & COMPANY INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "SEMT",
        "clearingBroker": "7311",
        "brokerName": "MINT BROKERS                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SEPN",
        "clearingBroker": "0161",
        "brokerName": "SEAPINE SECURITIES LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "SERL",
        "clearingBroker": "0443",
        "brokerName": "SEARLE & CO.                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SESL",
        "clearingBroker": "0158",
        "brokerName": "SESLIA SECURITIES                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "SFCO",
        "clearingBroker": "0443",
        "brokerName": "SYMETRA INVESTMENT SERVICES, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "SFGB",
        "clearingBroker": "0161",
        "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLP                                      "
    },
    {
        "type": "MUNI",
        "mpid": "SFPS",
        "clearingBroker": "0443",
        "brokerName": "SF INVESTMENTS, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "SFSI",
        "clearingBroker": "0235",
        "brokerName": "SUPERIOR FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "SGAS",
        "clearingBroker": "0286",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "SGBI",
        "clearingBroker": "0226",
        "brokerName": "SMITH, BROWN & GROOVER, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SGFC",
        "clearingBroker": "0226",
        "brokerName": "SIGMA FINANCIAL CORPORATION                                           "
    },
    {
        "type": "MUNI",
        "mpid": "SGLC",
        "clearingBroker": "0235",
        "brokerName": "S.G. LONG & COMPANY                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "SGNL",
        "clearingBroker": "0279",
        "brokerName": "SIGNAL SECURITIES, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "SGOV",
        "clearingBroker": "0286",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "SGSM",
        "clearingBroker": "1043",
        "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "SHOT",
        "clearingBroker": "0005",
        "brokerName": "SCHOTTENFELD GROUP LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "SHRR",
        "clearingBroker": "0443",
        "brokerName": "CARL P. SHERR AND CO., LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "SIBI",
        "clearingBroker": "0573",
        "brokerName": "SUNGARD INSITUTIONAL BROKERAGE, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "SILK",
        "clearingBroker": "0161",
        "brokerName": "GOLDMAN SACHS EXECUTION & CLEARING, L.P.                              "
    },
    {
        "type": "MUNI",
        "mpid": "SIMC",
        "clearingBroker": "0443",
        "brokerName": "SECURITIES INDUSTRY MANAGEMENT CORP.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "SKFS",
        "clearingBroker": "0443",
        "brokerName": "HEFREN-TILLOTSON/SHELBY, KERN, FREDERICK AND SHELB                    "
    },
    {
        "type": "MUNI",
        "mpid": "SKTR",
        "clearingBroker": "0279",
        "brokerName": "STOCK TRADERS                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "SLRD",
        "clearingBroker": "0226",
        "brokerName": "S.L. REED & COMPANY                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "SMCO",
        "clearingBroker": "0235",
        "brokerName": "SMITH, MOORE & CO.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "SMHI",
        "clearingBroker": "0443",
        "brokerName": "SANDERS MORRIS HARRIS INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "SMHJ",
        "clearingBroker": "0141",
        "brokerName": "SANDERS MORRIS HARRIS INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "SMNS",
        "clearingBroker": "0226",
        "brokerName": "PARKLAND SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "SMPR",
        "clearingBroker": "0443",
        "brokerName": "SUMMIT BROKERAGE SERVICES, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "SMRD",
        "clearingBroker": "0443",
        "brokerName": "SUMRIDGE PARTNERS, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "SMRI",
        "clearingBroker": "0226",
        "brokerName": "SECURITIES MANAGEMENT & RESEARCH, INC.                                "
    },
    {
        "type": "MUNI",
        "mpid": "SNEX",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "SNTE",
        "clearingBroker": "0279",
        "brokerName": "SENATE SECURITIES                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "SNWS",
        "clearingBroker": "0443",
        "brokerName": "SNOWDEN ACCOUNT SERVICES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "SOCO",
        "clearingBroker": "0443",
        "brokerName": "CAPITAL ONE SECURITIES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SORS",
        "clearingBroker": "0235",
        "brokerName": "SORSBY FINANCIAL CORP.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "SOVG",
        "clearingBroker": "8199",
        "brokerName": "SOVEREIGN GLOBAL ADVISORS, LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "SPAC",
        "clearingBroker": "0793",
        "brokerName": "SIERRA PACIFIC SECURITIES, LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "SPCS",
        "clearingBroker": "0052",
        "brokerName": "SPARTAN CAPITAL SECURITIES, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "SPEN",
        "clearingBroker": "0443",
        "brokerName": "SPENCER CLARKE LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "SPEX",
        "clearingBroker": "0235",
        "brokerName": "INSPEREX LLC                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SPGS",
        "clearingBroker": "0443",
        "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "SPHN",
        "clearingBroker": "0443",
        "brokerName": "STEPHENS INC.                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "SPLC",
        "clearingBroker": "0226",
        "brokerName": "SPIRE SECURITIES, LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "SPLN",
        "clearingBroker": "8199",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "SPOT",
        "clearingBroker": "0005",
        "brokerName": "SPOT TRADING                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SPSR",
        "clearingBroker": "0279",
        "brokerName": "STARK MUNICIPAL BROKERS                                               "
    },
    {
        "type": "MUNI",
        "mpid": "SPTD",
        "clearingBroker": "0052",
        "brokerName": "MINT GLOBAL MARKETS, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "SPTS",
        "clearingBroker": "0158",
        "brokerName": "SEVEN POINTS CAPITAL, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "SPWM",
        "clearingBroker": "0443",
        "brokerName": "STILLPOINT WEALTH MANAGEMENT, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "SRAM",
        "clearingBroker": "0443",
        "brokerName": "SAMCO CAPITAL MARKETS, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "SRBC",
        "clearingBroker": "0235",
        "brokerName": "SPIDERROCK EXS, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "SSBS",
        "clearingBroker": "0189",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "SSCO",
        "clearingBroker": "8457",
        "brokerName": "SAFRA SECURITIES LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "SSET",
        "clearingBroker": "0226",
        "brokerName": "SUNSET FINANCIAL SERVICES, INC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "SSGC",
        "clearingBroker": "0226",
        "brokerName": "SIGNATURE SECURITIES                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "SSGI",
        "clearingBroker": "0443",
        "brokerName": "SETON SECURITIES GROUP, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SSGM",
        "clearingBroker": "0226",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "SSGR",
        "clearingBroker": "0443",
        "brokerName": "SHAREHOLDERS SERVICES GROUP INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "SSIN",
        "clearingBroker": "0226",
        "brokerName": "TRUIST INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "SSLC",
        "clearingBroker": "0279",
        "brokerName": "SANDERLIN SECURITIES, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "SSLL",
        "clearingBroker": "0189",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "SSNE",
        "clearingBroker": "0226",
        "brokerName": "SANTANDER SECURITIES LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "SSNG",
        "clearingBroker": "0443",
        "brokerName": "SISUNG SECURITIES CORPORATION                                         "
    },
    {
        "type": "MUNI",
        "mpid": "STAD",
        "clearingBroker": "0141",
        "brokerName": "STEELE ADVISORS, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "STCM",
        "clearingBroker": "2095",
        "brokerName": "TRUIST SECURITIES, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "STEP",
        "clearingBroker": "0235",
        "brokerName": "FERRETTI GROUP, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "STFL",
        "clearingBroker": "0793",
        "brokerName": "STIFEL, NICOLAUS & COMPANY, INCORPORATED                              "
    },
    {
        "type": "MUNI",
        "mpid": "STGC",
        "clearingBroker": "0279",
        "brokerName": "STERLING GRACE MUNICIPAL SECURITIES CO                                "
    },
    {
        "type": "MUNI",
        "mpid": "STHR",
        "clearingBroker": "0388",
        "brokerName": "STORMHARBOUR SECURITIES LP                                            "
    },
    {
        "type": "MUNI",
        "mpid": "STND",
        "clearingBroker": "0279",
        "brokerName": "FIRST STANDARD FINANCIAL COMPANY LLC                                  "
    },
    {
        "type": "MUNI",
        "mpid": "STOX",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "STRM",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "STRS",
        "clearingBroker": "0161",
        "brokerName": "STRATEGAS RESEARCH PARTNERS, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "STRT",
        "clearingBroker": "0352",
        "brokerName": "OCTAVUS, LLC                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "STSI",
        "clearingBroker": "0235",
        "brokerName": "SPENCER TRASK VENTURES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "STTR",
        "clearingBroker": "0443",
        "brokerName": "STATE TRUST INVESTMENTS INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "STTT",
        "clearingBroker": "0052",
        "brokerName": "STATETRUST INVESTMENTS INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "STUR",
        "clearingBroker": "0158",
        "brokerName": "STURDIVANT & CO., INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "STXW",
        "clearingBroker": "0443",
        "brokerName": "SA STONE WEALTH MANAGEMENT INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "STYO",
        "clearingBroker": "0443",
        "brokerName": "STONE & YOUNGBERG L.L.C.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "SUFI",
        "clearingBroker": "0551",
        "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "SUSQ",
        "clearingBroker": "0551",
        "brokerName": "SUSQUEHANNA CAPITAL GROUP                                             "
    },
    {
        "type": "MUNI",
        "mpid": "SUST",
        "clearingBroker": "0235",
        "brokerName": "SUNSTREET SECURITIES, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "SWBC",
        "clearingBroker": "0443",
        "brokerName": "SWBC INVESTMENT SERVICES, LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "SWSS",
        "clearingBroker": "0443",
        "brokerName": "SANCTUARY SECURITIES, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "SWST",
        "clearingBroker": "0279",
        "brokerName": "HILLTOP SECURITIES INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "SWTX",
        "clearingBroker": "0443",
        "brokerName": "SWBT SECURITIES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "SYCA",
        "clearingBroker": "0443",
        "brokerName": "SYNDICATED CAPITAL, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "SZZI",
        "clearingBroker": "0141",
        "brokerName": "STOFAN, AGAZZI & COMPANY INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "TAFI",
        "clearingBroker": "0443",
        "brokerName": "NATHAN HALE CAPITAL, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "TAGB",
        "clearingBroker": "0052",
        "brokerName": "TAGLICH BROTHERS, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "TAGC",
        "clearingBroker": "1043",
        "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "TAGD",
        "clearingBroker": "1043",
        "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "TASE",
        "clearingBroker": "0443",
        "brokerName": "TRADITION ASIEL SECURITIES INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "TBCL",
        "clearingBroker": "0750",
        "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "TBCR",
        "clearingBroker": "0235",
        "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "TBIA",
        "clearingBroker": "0158",
        "brokerName": "TRADIER BROKERAGE, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "TBRD",
        "clearingBroker": "0226",
        "brokerName": "THOROUGHBRED FINANCIAL SERVICES, LLC                                  "
    },
    {
        "type": "MUNI",
        "mpid": "TCBI",
        "clearingBroker": "0443",
        "brokerName": "TCBI SECURITIES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "TCMU",
        "clearingBroker": "0443",
        "brokerName": "TCM CAPITAL, INC.                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "TCPX",
        "clearingBroker": "0443",
        "brokerName": "TOUSSAINT CAPITAL PARTNERS, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "TDCO",
        "clearingBroker": "0235",
        "brokerName": "THOMPSON DAVIS & CO., INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "TDNF",
        "clearingBroker": "2568",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "TDPA",
        "clearingBroker": "0226",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "TDSI",
        "clearingBroker": "2568",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "TFAI",
        "clearingBroker": "0226",
        "brokerName": "TRANSAMERICA FINANCIAL ADVISORS, INC.                                 "
    },
    {
        "type": "MUNI",
        "mpid": "TFAS",
        "clearingBroker": "0443",
        "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
    },
    {
        "type": "MUNI",
        "mpid": "TFSL",
        "clearingBroker": "0235",
        "brokerName": "TECKMEYER FINANCIAL SERVICES                                          "
    },
    {
        "type": "MUNI",
        "mpid": "TFSS",
        "clearingBroker": "0443",
        "brokerName": "TFS SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "TGHS",
        "clearingBroker": "0443",
        "brokerName": "TGH SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "THEM",
        "clearingBroker": "0235",
        "brokerName": "THEMIS TRADING LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "THIM",
        "clearingBroker": "0443",
        "brokerName": "LONGVIEW FINANCIAL GROUP INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "TIAN",
        "clearingBroker": "0226",
        "brokerName": "TRIAD SECURITIES CORP                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "TIBD",
        "clearingBroker": "6412",
        "brokerName": "TIB THE INDEPENDENT BANKERS BANK                                      "
    },
    {
        "type": "MUNI",
        "mpid": "TIBS",
        "clearingBroker": "0443",
        "brokerName": "TELEMUS INVESTMENT BROKERS, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "TIGC",
        "clearingBroker": "0235",
        "brokerName": "NELSONREID, INC.                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "TIGE",
        "clearingBroker": "1043",
        "brokerName": "US TIGER SECURITIES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "TLDX",
        "clearingBroker": "0226",
        "brokerName": "TULLETT LIBERTY SECURITIES, INC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "TMAS",
        "clearingBroker": "0235",
        "brokerName": "TRADEMAS INC.                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "TMBI",
        "clearingBroker": "0141",
        "brokerName": "THURSTON SPRINGER FINANCIAL                                           "
    },
    {
        "type": "MUNI",
        "mpid": "TMBR",
        "clearingBroker": "0534",
        "brokerName": "IBKR SECURITIES SERVICES LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "TMBS",
        "clearingBroker": "0443",
        "brokerName": "TRADITION ASIEL SECURITIES INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "TMCC",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "MUNI",
        "mpid": "TMCD",
        "clearingBroker": "0235",
        "brokerName": "MCDONALD PARTNERS LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "TOCQ",
        "clearingBroker": "0443",
        "brokerName": "TOCQUEVILLE SECURITIES L.P.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "TONE",
        "clearingBroker": "8199",
        "brokerName": "2021 CAPITAL                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "TONG",
        "clearingBroker": "0443",
        "brokerName": "TONGE (R.M.) & COMPANY                                                "
    },
    {
        "type": "MUNI",
        "mpid": "TORO",
        "clearingBroker": "0279",
        "brokerName": "VALDES & MORENO, INC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "TOUR",
        "clearingBroker": "0005",
        "brokerName": "TOURMALINE PARTNERS, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "TOVC",
        "clearingBroker": "0235",
        "brokerName": "TOV CAPITAL MARKETS, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "TPIS",
        "clearingBroker": "0161",
        "brokerName": "TULLETT PREBON FINANCIAL SERVICES, LLC                                "
    },
    {
        "type": "MUNI",
        "mpid": "TPMG",
        "clearingBroker": "0005",
        "brokerName": "TOWER PRINCIPAL MARKETS LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "TPMR",
        "clearingBroker": "0141",
        "brokerName": "TRADE-PMR INC.                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "TRAD",
        "clearingBroker": "0271",
        "brokerName": "TRADESTATION SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "TRCG",
        "clearingBroker": "0005",
        "brokerName": "TRC MARKETS LLC                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "TREX",
        "clearingBroker": "1043",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "MUNI",
        "mpid": "TRIB",
        "clearingBroker": "0235",
        "brokerName": "TRIBAL CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "TRIM",
        "clearingBroker": "0161",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "TRIN",
        "clearingBroker": "0141",
        "brokerName": "TRIANGLE SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "TRIP",
        "clearingBroker": "0235",
        "brokerName": "TRIDENT PARTNERS LTD                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "TRSH",
        "clearingBroker": "0279",
        "brokerName": "THRASHER & CHAMBERS, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "TRSQ",
        "clearingBroker": "0443",
        "brokerName": "TOWER SQUARE SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "TRUB",
        "clearingBroker": "0141",
        "brokerName": "TRUBEE, COLLINS & CO., INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "TRWN",
        "clearingBroker": "0443",
        "brokerName": "T.R. WINSTON & COMPANY, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "TRYN",
        "clearingBroker": "0279",
        "brokerName": "FIRST TRYON SECURITIES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "TSCD",
        "clearingBroker": "0235",
        "brokerName": "STURGES COMPANY (THE)                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "TSER",
        "clearingBroker": "0161",
        "brokerName": "TWO SIGMA EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "TSFA",
        "clearingBroker": "0443",
        "brokerName": "STRATEGIC FINANCIAL ALLIANCE (THE)                                    "
    },
    {
        "type": "MUNI",
        "mpid": "TSSM",
        "clearingBroker": "0161",
        "brokerName": "TWO SIGMA SECURITIES, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "TTSC",
        "clearingBroker": "0052",
        "brokerName": "TREND TRADE SECURITIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "TTSI",
        "clearingBroker": "0158",
        "brokerName": "T3 SECURITIES, INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "TWDI",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "TWDL",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "TWDP",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "TWDR",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "TWDS",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "TWPL",
        "clearingBroker": "0793",
        "brokerName": "STIFEL, NICOLAUS & COMPANY, INCORPORATED                              "
    },
    {
        "type": "MUNI",
        "mpid": "UBII",
        "clearingBroker": "0221",
        "brokerName": "UBS INTERNATIONAL, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "UBKR",
        "clearingBroker": "6732",
        "brokerName": "UNITED BANKERS' BANK                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "UBSI",
        "clearingBroker": "0141",
        "brokerName": "UNITED BROKERAGE SERVICES, INC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "UBSW",
        "clearingBroker": "0642",
        "brokerName": "UBS SECURITIES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "UMBF",
        "clearingBroker": "0226",
        "brokerName": "UMB FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "UMBI",
        "clearingBroker": "2451",
        "brokerName": "UMB BANK, NATIONAL ASSOCIATION                                        "
    },
    {
        "type": "MUNI",
        "mpid": "UNIB",
        "clearingBroker": "0443",
        "brokerName": "UNIBANCO SECURITIES INC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "UNIV",
        "clearingBroker": "0595",
        "brokerName": "UNIVEST SECURITIES, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "UPLN",
        "clearingBroker": "0443",
        "brokerName": "UNITED PLANNERS FINANCIAL SERVICES OF AMERICA                         "
    },
    {
        "type": "MUNI",
        "mpid": "USCA",
        "clearingBroker": "0226",
        "brokerName": "USCA SECURITIES LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "USDB",
        "clearingBroker": "0279",
        "brokerName": "U.S. BROKERAGE, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "USFB",
        "clearingBroker": "0595",
        "brokerName": "U.S. FINANCIAL INVESTMENTS, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "USIC",
        "clearingBroker": "0226",
        "brokerName": "U.S. SECURITIES, INTL. CORP.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "USSI",
        "clearingBroker": "0279",
        "brokerName": "U.S. STERLING SECURITIES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "USTZ",
        "clearingBroker": "0595",
        "brokerName": "TRADEZERO AMERINCA, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "UVST",
        "clearingBroker": "0443",
        "brokerName": "UVEST FINANCIAL SERVICES GROUP, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "VABD",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "MUNI",
        "mpid": "VALI",
        "clearingBroker": "0226",
        "brokerName": "VALLEY NATIONAL INVESTMENTS, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "VBCS",
        "clearingBroker": "0279",
        "brokerName": "VBC SECURITIES                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "VBLT",
        "clearingBroker": "0226",
        "brokerName": "VANDERBILT SECURITIES, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "VCAS",
        "clearingBroker": "0443",
        "brokerName": "VCA SECURITIES, LP                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "VCFN",
        "clearingBroker": "0235",
        "brokerName": "VAN CLEMENS & CO. INCORPORATED                                        "
    },
    {
        "type": "MUNI",
        "mpid": "VCMM",
        "clearingBroker": "0279",
        "brokerName": "VIRTUS CAPITAL MARKETS LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "VCMS",
        "clearingBroker": "0443",
        "brokerName": "VCM SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "VCSV",
        "clearingBroker": "0052",
        "brokerName": "PRIMARY CAPITAL, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "VERF",
        "clearingBroker": "0235",
        "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "VERT",
        "clearingBroker": "8199",
        "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "VEST",
        "clearingBroker": "0750",
        "brokerName": "VESTECH SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "VETS",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN VETERANS GROUP, PBC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "VGRD",
        "clearingBroker": "0062",
        "brokerName": "VANGUARD MARKETING CORPORATION                                        "
    },
    {
        "type": "MUNI",
        "mpid": "VISI",
        "clearingBroker": "0443",
        "brokerName": "VISION INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "VKMI",
        "clearingBroker": "0692",
        "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "VLYF",
        "clearingBroker": "0443",
        "brokerName": "VALLEY FORGE ASSET MANAGEMENT                                         "
    },
    {
        "type": "MUNI",
        "mpid": "VMEX",
        "clearingBroker": "0443",
        "brokerName": "VECTORGLOBAL WMG                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "VOLS",
        "clearingBroker": "2447",
        "brokerName": "HOME FINANCIAL SERVICES INC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "VPEW",
        "clearingBroker": "0158",
        "brokerName": "VPE WERTPAPIERHANDELSBANK AG                                          "
    },
    {
        "type": "MUNI",
        "mpid": "VSIN",
        "clearingBroker": "0595",
        "brokerName": "VISION FINANCIAL MARKETS LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "VSLP",
        "clearingBroker": "6043",
        "brokerName": "VINING-SPARKS IBG, L.P.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "VTDT",
        "clearingBroker": "0158",
        "brokerName": "VIEWTRADE SECURITIES, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "VTRN",
        "clearingBroker": "0443",
        "brokerName": "BANCROFT CAPITAL, LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "WABR",
        "clearingBroker": "0443",
        "brokerName": "WALL STREET ACCESS                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "WACC",
        "clearingBroker": "0279",
        "brokerName": "MIDLAND SECURITIES, LTD                                               "
    },
    {
        "type": "MUNI",
        "mpid": "WACL",
        "clearingBroker": "0709",
        "brokerName": "WACHTEL & CO., INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "WARF",
        "clearingBroker": "0235",
        "brokerName": "WARD'S FINANCIAL SERVICES, LTD.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "WBAX",
        "clearingBroker": "0052",
        "brokerName": "WALLACHBETH CAPITAL LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "WBBC",
        "clearingBroker": "0226",
        "brokerName": "WBB SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "WBFS",
        "clearingBroker": "0443",
        "brokerName": "WOODBURY FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "WBLR",
        "clearingBroker": "0771",
        "brokerName": "WILLIAM BLAIR & COMPANY, L.L.C.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "WBNA",
        "clearingBroker": "2072",
        "brokerName": "WELLS FARGO BANK, N.A./SIG                                            "
    },
    {
        "type": "MUNI",
        "mpid": "WBNF",
        "clearingBroker": "0226",
        "brokerName": "WILLIAM BLAIR & COMPANY L.L.C.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "WBRO",
        "clearingBroker": "0443",
        "brokerName": "WILEY BROS.-AINTREE CAPITAL, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "WCHV",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "WCIG",
        "clearingBroker": "0750",
        "brokerName": "WILLOW COVE INVESTMENT GROUP, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "WCIS",
        "clearingBroker": "0443",
        "brokerName": "WESCORP INVESTMENT SERVICES, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "WCSC",
        "clearingBroker": "0235",
        "brokerName": "WILMINGTON CAPITAL SECURITIES, LLC                                    "
    },
    {
        "type": "MUNI",
        "mpid": "WCSF",
        "clearingBroker": "0235",
        "brokerName": "WORLD CHOICE SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "WEBS",
        "clearingBroker": "0226",
        "brokerName": "WEALTH ENHANCEMENT BROKERAGE SERVICES, LLC                            "
    },
    {
        "type": "MUNI",
        "mpid": "WEDB",
        "clearingBroker": "0103",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "WEGE",
        "clearingBroker": "0443",
        "brokerName": "WORLD EQUITY GROUP, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "WEGI",
        "clearingBroker": "0235",
        "brokerName": "WORLD EQUITY GROUP INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "WEGP",
        "clearingBroker": "0235",
        "brokerName": "WESTERN EQUITY GROUP, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "WEIL",
        "clearingBroker": "0226",
        "brokerName": "THE WEIL COMPANY, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "WELD",
        "clearingBroker": "0443",
        "brokerName": "WHITE, WELD & CO. SECURITIES, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "WESC",
        "clearingBroker": "0443",
        "brokerName": "WELLINGTON SHIELDS & CO., LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "WEXR",
        "clearingBroker": "0235",
        "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "WEXX",
        "clearingBroker": "0005",
        "brokerName": "WOLVERINE EXECUTION SERVICES                                          "
    },
    {
        "type": "MUNI",
        "mpid": "WFPB",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "WGWD",
        "clearingBroker": "0158",
        "brokerName": "WEDGEWOOD PARTNERS, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "WHAE",
        "clearingBroker": "0158",
        "brokerName": "WHARTON EQUITY CORPORATION                                            "
    },
    {
        "type": "MUNI",
        "mpid": "WHBB",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "WHOT",
        "clearingBroker": "0595",
        "brokerName": "JUST2TRADE, INC.                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "WIDS",
        "clearingBroker": "0279",
        "brokerName": "WISCONSIN DISCOUNT SECURITIES CORP.                                   "
    },
    {
        "type": "MUNI",
        "mpid": "WING",
        "clearingBroker": "0443",
        "brokerName": "ING FINANCIAL PARTNERS, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "WISC",
        "clearingBroker": "0226",
        "brokerName": "WINDSOR, SHEFFIELD & CO., INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "WISE",
        "clearingBroker": "0052",
        "brokerName": "AXOS INVEST LLC                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "WISP",
        "clearingBroker": "0443",
        "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
    },
    {
        "type": "MUNI",
        "mpid": "WLTH",
        "clearingBroker": "0235",
        "brokerName": "WEALTHFRONT BROKERAGE CORPORATION                                     "
    },
    {
        "type": "MUNI",
        "mpid": "WMCL",
        "clearingBroker": "0279",
        "brokerName": "WHITE MOUNTAIN CAPITAL, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "WMFS",
        "clearingBroker": "0226",
        "brokerName": "WESTMINSTER FINANCIAL SECURITIES, INC.                                "
    },
    {
        "type": "MUNI",
        "mpid": "WMLL",
        "clearingBroker": "0005",
        "brokerName": "WATERMILL INSTITUTIONAL TRADING LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "WNUT",
        "clearingBroker": "0443",
        "brokerName": "WALNUT STREET SECURITIES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "WOHU",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL, L.P.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "WPCC",
        "clearingBroker": "0052",
        "brokerName": "WESTPARK CAPITAL, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "WPCI",
        "clearingBroker": "0595",
        "brokerName": "WESTPARK CAPITAL, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "WPSG",
        "clearingBroker": "0005",
        "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "WPST",
        "clearingBroker": "0443",
        "brokerName": "W.P. STEWART SECURITIES LIMITED                                       "
    },
    {
        "type": "MUNI",
        "mpid": "WPSX",
        "clearingBroker": "0445",
        "brokerName": "RISE FINANCIAL SERVICES, LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "WRET",
        "clearingBroker": "0141",
        "brokerName": "WELLS FARGO CLEARING SERVICES, LLC                                    "
    },
    {
        "type": "MUNI",
        "mpid": "WRIS",
        "clearingBroker": "0141",
        "brokerName": "SMH CAPITAL INVESTMENTS LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "WRLD",
        "clearingBroker": "0235",
        "brokerName": "HUNTER WORLD MARKETS, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "WSCC",
        "clearingBroker": "0235",
        "brokerName": "WASHINGTON SECURITIES CORPORATION                                     "
    },
    {
        "type": "MUNI",
        "mpid": "WSCX",
        "clearingBroker": "0235",
        "brokerName": "WORKMAN SECURITIES CORP                                               "
    },
    {
        "type": "MUNI",
        "mpid": "WSEC",
        "clearingBroker": "0443",
        "brokerName": "WILLIS SECURITIES, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "WSGD",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC./P3                                            "
    },
    {
        "type": "MUNI",
        "mpid": "WSIW",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "WSMC",
        "clearingBroker": "0443",
        "brokerName": "WALL STREET MANAGEMENT CORPORATION                                    "
    },
    {
        "type": "MUNI",
        "mpid": "WSRP",
        "clearingBroker": "0052",
        "brokerName": "WESTROCK CAPITAL MANAGEMENT, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "WSTI",
        "clearingBroker": "0226",
        "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
    },
    {
        "type": "MUNI",
        "mpid": "WSWW",
        "clearingBroker": "0443",
        "brokerName": "WESTMINSTER SECURITIES CORPORATION                                    "
    },
    {
        "type": "MUNI",
        "mpid": "WTCO",
        "clearingBroker": "0050",
        "brokerName": "WILLIAMS TRADING LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "WTFS",
        "clearingBroker": "0052",
        "brokerName": "LIME TRADING CORP                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "WTLP",
        "clearingBroker": "0388",
        "brokerName": "WOLVERINE TRADING, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "WTRI",
        "clearingBroker": "0235",
        "brokerName": "WATERFORD INVESTORS SERVICES, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "WUND",
        "clearingBroker": "0141",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "MUNI",
        "mpid": "WVBD",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "WVEX",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH PIERCE FENNER & SMITH INCORPOTATED                      "
    },
    {
        "type": "MUNI",
        "mpid": "XCNC",
        "clearingBroker": "0005",
        "brokerName": "C&C TRADING L.L.C.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "XRVR",
        "clearingBroker": "0279",
        "brokerName": "CRB SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "XTXE",
        "clearingBroker": "0161",
        "brokerName": "XTX EXECUTION SERVICES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "YLPL",
        "clearingBroker": "0075",
        "brokerName": "LPL FINANCIAL LLC                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "YOSE",
        "clearingBroker": "0052",
        "brokerName": "YORK SECURITIES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "ZEDB",
        "clearingBroker": "0161",
        "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "ZERO",
        "clearingBroker": "0158",
        "brokerName": "TRADEZERO AMERICA, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "ZEUS",
        "clearingBroker": "0443",
        "brokerName": "ZEUS FINANCIAL, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "ZFNB",
        "clearingBroker": "2104",
        "brokerName": "ZB, NATIONAL ASSOCIATION                                              "
    },
    {
        "type": "MUNI",
        "mpid": "ZION",
        "clearingBroker": "0065",
        "brokerName": "ZIONS DIRECT, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "ZIVI",
        "clearingBroker": "0235",
        "brokerName": "ZIV INVESTMENT COMPANY                                                "
    },
    {
        "type": "MUNI",
        "mpid": "ZOUL",
        "clearingBroker": "0235",
        "brokerName": "N.B. ZOULLAS SECURITIES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "AALC",
        "clearingBroker": "0226",
        "brokerName": "THRIVENT INVESTMENT MANAGEMENT, INC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "ABAI",
        "clearingBroker": "0279",
        "brokerName": "ABACUS INVESTMENTS, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "ABBA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABBK",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABDA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABDW",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABEA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABEN",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABHE",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABIG",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABPR",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABRP",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABST",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ACAP",
        "clearingBroker": "0235",
        "brokerName": "ALAMO CAPITAL                                                         "
    },
    {
        "type": "UIT",
        "mpid": "ACCP",
        "clearingBroker": "0158",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "ACCU",
        "clearingBroker": "0052",
        "brokerName": "ATB CAPITAL MARKETS USA INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "ACII",
        "clearingBroker": "0158",
        "brokerName": "ARCA CAPITAL INVESTMENTS, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "ACLP",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER CAPITAL, L.P.                                               "
    },
    {
        "type": "UIT",
        "mpid": "ACPL",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN CAPITAL PARTNERS                                             "
    },
    {
        "type": "UIT",
        "mpid": "ACPS",
        "clearingBroker": "0443",
        "brokerName": "ACP SECURITIES LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "ACRN",
        "clearingBroker": "0235",
        "brokerName": "ACORNS SECURITIES, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "ACTI",
        "clearingBroker": "0443",
        "brokerName": "ACTIVNER SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "ADSO",
        "clearingBroker": "0141",
        "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "AEFS",
        "clearingBroker": "0226",
        "brokerName": "AE FINANCIAL SERVICES, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "AEXG",
        "clearingBroker": "0158",
        "brokerName": "ALTERNATIVE EXECUTION GROUP                                           "
    },
    {
        "type": "UIT",
        "mpid": "AFBS",
        "clearingBroker": "0158",
        "brokerName": "APEX FINTECH BROKERAGE SERVICES LLC                                   "
    },
    {
        "type": "UIT",
        "mpid": "AFSL",
        "clearingBroker": "0443",
        "brokerName": "SORRENTO PACIFIC FINANCIAL                                            "
    },
    {
        "type": "UIT",
        "mpid": "AFSS",
        "clearingBroker": "0750",
        "brokerName": "FOUR POINTS CAPITAL PARTNERS LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "AGCO",
        "clearingBroker": "0052",
        "brokerName": "AUERBACH GRAYSON & COMPANY LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "AGCP",
        "clearingBroker": "0052",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "AGES",
        "clearingBroker": "0750",
        "brokerName": "ADVISORY GROUP EQUITY SERVICES LTD.                                   "
    },
    {
        "type": "UIT",
        "mpid": "AGIS",
        "clearingBroker": "0235",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "AGSS",
        "clearingBroker": "0443",
        "brokerName": "GREAT AMERICAN ADVISORS, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "AHSI",
        "clearingBroker": "0141",
        "brokerName": "AMERICAN HERITAGE SECURITIES, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "AIGF",
        "clearingBroker": "0443",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "AIGN",
        "clearingBroker": "0226",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "AISG",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN INDEPENDENT SECURITIES GROUP, LLC                            "
    },
    {
        "type": "UIT",
        "mpid": "AJCO",
        "clearingBroker": "0443",
        "brokerName": "IDB CAPITAL CORP.                                                     "
    },
    {
        "type": "UIT",
        "mpid": "ALCG",
        "clearingBroker": "0235",
        "brokerName": "ALTITUDE CAPITAL GROUP LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "ALCM",
        "clearingBroker": "0279",
        "brokerName": "ALPHALEDGER MARKETS, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "ALDN",
        "clearingBroker": "0052",
        "brokerName": "J. ALDEN ASSOCIATES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "ALGP",
        "clearingBroker": "0235",
        "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
    },
    {
        "type": "UIT",
        "mpid": "ALGR",
        "clearingBroker": "0158",
        "brokerName": "ALGER (FRED) & CO INC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "ALIS",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER INVESTMENT SERVICES CO.                                     "
    },
    {
        "type": "UIT",
        "mpid": "ALLN",
        "clearingBroker": "0443",
        "brokerName": "ALLEN & COMPANY LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "ALNC",
        "clearingBroker": "0226",
        "brokerName": "A.G.P./ALLIANCE GLOBAL PARTNERS                                       "
    },
    {
        "type": "UIT",
        "mpid": "ALTR",
        "clearingBroker": "3164",
        "brokerName": "ALTRUIST FINANCIAL LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "AMBB",
        "clearingBroker": "0141",
        "brokerName": "ALLEN, MOONEY & BARNES BROKERAGE SERVICES, LLC                        "
    },
    {
        "type": "UIT",
        "mpid": "AMER",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "UIT",
        "mpid": "AMIC",
        "clearingBroker": "0226",
        "brokerName": "AMERICAN INVESTORS COMPANY                                            "
    },
    {
        "type": "UIT",
        "mpid": "AMLU",
        "clearingBroker": "3652",
        "brokerName": "LUCID CAPITAL MARKETS, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "AMMS",
        "clearingBroker": "0141",
        "brokerName": "AMUNI FINANCIAL, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "AMRG",
        "clearingBroker": "0443",
        "brokerName": "WORLD CAPITAL BROKERAGE, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "ANDB",
        "clearingBroker": "0443",
        "brokerName": "ANDBANC BROKERAGE, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "ANDG",
        "clearingBroker": "0235",
        "brokerName": "GARRETT (ANDREW), INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "ANOS",
        "clearingBroker": "0235",
        "brokerName": "ABEL NOSER, LLC.                                                      "
    },
    {
        "type": "UIT",
        "mpid": "ANOV",
        "clearingBroker": "0750",
        "brokerName": "ANOVEST FINANCIAL SERVICES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "AOCS",
        "clearingBroker": "0388",
        "brokerName": "AOC SECURITIES                                                        "
    },
    {
        "type": "UIT",
        "mpid": "AONC",
        "clearingBroker": "0443",
        "brokerName": "AON BENFIELD SECURITIES                                               "
    },
    {
        "type": "UIT",
        "mpid": "AORP",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "AOSD",
        "clearingBroker": "0158",
        "brokerName": "TRADING BLOCK                                                         "
    },
    {
        "type": "UIT",
        "mpid": "APBD",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "APBO",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "APFS",
        "clearingBroker": "0443",
        "brokerName": "AMERICA'S PORTFOLIO'S                                                 "
    },
    {
        "type": "UIT",
        "mpid": "APRT",
        "clearingBroker": "0226",
        "brokerName": "PARTNERS                                                              "
    },
    {
        "type": "UIT",
        "mpid": "APXO",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "APXS",
        "clearingBroker": "0052",
        "brokerName": "APEXUS CAPITAL LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "ARBC",
        "clearingBroker": "0235",
        "brokerName": "ARKADIOS CAPITAL                                                      "
    },
    {
        "type": "UIT",
        "mpid": "ARCD",
        "clearingBroker": "0443",
        "brokerName": "ARCADIA SECURITIES, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "ARKA",
        "clearingBroker": "0443",
        "brokerName": "ARKA SECURITIES, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "ARKI",
        "clearingBroker": "0226",
        "brokerName": "ARKADIOS CAPITAL                                                      "
    },
    {
        "type": "UIT",
        "mpid": "ARUS",
        "clearingBroker": "0158",
        "brokerName": "AUTONOMOUS RESEARCH US LP                                             "
    },
    {
        "type": "UIT",
        "mpid": "ARVS",
        "clearingBroker": "0443",
        "brokerName": "ARVEST WEALTH MANAGEMENT                                              "
    },
    {
        "type": "UIT",
        "mpid": "ASCM",
        "clearingBroker": "0052",
        "brokerName": "ASCENDIANT CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "ASCP",
        "clearingBroker": "0443",
        "brokerName": "BOK FINANCIAL SECURITIES                                              "
    },
    {
        "type": "UIT",
        "mpid": "ASII",
        "clearingBroker": "0226",
        "brokerName": "AURORA SECURITIES                                                     "
    },
    {
        "type": "UIT",
        "mpid": "ASOI",
        "clearingBroker": "0226",
        "brokerName": "ASSOCIATED INVESTMENT SERVICES, INC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "ATIS",
        "clearingBroker": "0052",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "UIT",
        "mpid": "ATMC",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "ATRU",
        "clearingBroker": "0158",
        "brokerName": "ATREYU TRADING                                                        "
    },
    {
        "type": "UIT",
        "mpid": "ATVT",
        "clearingBroker": "0443",
        "brokerName": "ATOMIC BROKERAGE LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "AULC",
        "clearingBroker": "0443",
        "brokerName": "ONEAMERICA SECURITIES, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "AVEN",
        "clearingBroker": "0226",
        "brokerName": "AVENTURA SECURITIES, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "AVIL",
        "clearingBroker": "0158",
        "brokerName": "AVANZA CAPITAL MARKETS INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "AVML",
        "clearingBroker": "0443",
        "brokerName": "AVM, L.P.                                                             "
    },
    {
        "type": "UIT",
        "mpid": "AVST",
        "clearingBroker": "0235",
        "brokerName": "ATOMIC BROKERAGE LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "AXAA",
        "clearingBroker": "0075",
        "brokerName": "AXA ADVISORS LLC                                                      "
    },
    {
        "type": "UIT",
        "mpid": "AXCB",
        "clearingBroker": "0443",
        "brokerName": "ACCESS SECURITIES                                                     "
    },
    {
        "type": "UIT",
        "mpid": "AXCL",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "UIT",
        "mpid": "AXCS",
        "clearingBroker": "0443",
        "brokerName": "ACCESS SECURITIES INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "AXGP",
        "clearingBroker": "0443",
        "brokerName": "ACCESS SECURITIES, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "AXIO",
        "clearingBroker": "0279",
        "brokerName": "AXIOM CAPITAL MANAGEMENT, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "AXOS",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "UIT",
        "mpid": "AXTN",
        "clearingBroker": "0052",
        "brokerName": "AX TRADING, LLC                                                       "
    },
    {
        "type": "UIT",
        "mpid": "BAKR",
        "clearingBroker": "0443",
        "brokerName": "JAMES BAKER & ASSOCIATES, L.P.                                        "
    },
    {
        "type": "UIT",
        "mpid": "BALE",
        "clearingBroker": "0443",
        "brokerName": "M&T SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "BALS",
        "clearingBroker": "0750",
        "brokerName": "BRUCE A. LEFAVI SECURITIES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "BANK",
        "clearingBroker": "0701",
        "brokerName": "CETERA INVESTMENT SERVICES LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "BARC",
        "clearingBroker": "0388",
        "brokerName": "BARCLAY                                                               "
    },
    {
        "type": "UIT",
        "mpid": "BARD",
        "clearingBroker": "0547",
        "brokerName": "ROBERT W. BAIRD & CO. INCORPORATED                                    "
    },
    {
        "type": "UIT",
        "mpid": "BARR",
        "clearingBroker": "0226",
        "brokerName": "BARRETT & COMPANY                                                     "
    },
    {
        "type": "UIT",
        "mpid": "BAYP",
        "clearingBroker": "0161",
        "brokerName": "BAY CREST PARTNERS, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "BBAR",
        "clearingBroker": "0595",
        "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "BBGC",
        "clearingBroker": "0235",
        "brokerName": "GRAHAM (B.B.) & COMPANY                                               "
    },
    {
        "type": "UIT",
        "mpid": "BBNI",
        "clearingBroker": "0443",
        "brokerName": "PERFORMANCE TRUST CAPITAL PARTNERS, INC.                              "
    },
    {
        "type": "UIT",
        "mpid": "BCCS",
        "clearingBroker": "0443",
        "brokerName": "BAC FLORIDA INVESTMENTS CORP.                                         "
    },
    {
        "type": "UIT",
        "mpid": "BCGS",
        "clearingBroker": "0443",
        "brokerName": "BCG SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "BCIB",
        "clearingBroker": "0443",
        "brokerName": "BCI SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "BCSA",
        "clearingBroker": "0443",
        "brokerName": "BCS AMERICAS, INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "BCWM",
        "clearingBroker": "4077",
        "brokerName": "BETA CAPITAL SECURITIES LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "BCZC",
        "clearingBroker": "0443",
        "brokerName": "ZIEGLER (B.C.) & COMPANY                                              "
    },
    {
        "type": "UIT",
        "mpid": "BDBS",
        "clearingBroker": "0443",
        "brokerName": "BANCO DO BRASIL SECURITIES                                            "
    },
    {
        "type": "UIT",
        "mpid": "BDDK",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "BDIR",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "UIT",
        "mpid": "BDTR",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "BEAF",
        "clearingBroker": "0235",
        "brokerName": "BEACONSFIELD FINANCIAL SERV.                                          "
    },
    {
        "type": "UIT",
        "mpid": "BELS",
        "clearingBroker": "0443",
        "brokerName": "BEL AIR SECURITIES LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "BERN",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "BERS",
        "clearingBroker": "0235",
        "brokerName": "BESTEX RESEARCH SECURITIES, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "BEST",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "BFEC",
        "clearingBroker": "0443",
        "brokerName": "BENJAMIN F. EDWARDS & COMPANY                                         "
    },
    {
        "type": "UIT",
        "mpid": "BFEW",
        "clearingBroker": "0443",
        "brokerName": "BILL FEW ASSOCIATES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "BFFI",
        "clearingBroker": "0226",
        "brokerName": "BERTHEL, FISHER & COMPANY FINANCIAL SERVICES, INC.                    "
    },
    {
        "type": "UIT",
        "mpid": "BFSL",
        "clearingBroker": "0235",
        "brokerName": "BRIGGS-FICKS SECURITIES, LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "BGHT",
        "clearingBroker": "0141",
        "brokerName": "BRIGHTON SECURITIES CORP.                                             "
    },
    {
        "type": "UIT",
        "mpid": "BGIS",
        "clearingBroker": "0443",
        "brokerName": "BLACKROCK EXECUTION SERVICES                                          "
    },
    {
        "type": "UIT",
        "mpid": "BGSG",
        "clearingBroker": "0226",
        "brokerName": "CBIZ FINANCIAL SOLUTIONS, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "BGVS",
        "clearingBroker": "0443",
        "brokerName": "BGV SECURITIES                                                        "
    },
    {
        "type": "UIT",
        "mpid": "BHII",
        "clearingBroker": "0443",
        "brokerName": "BELLE HAVEN INVESTMENTS, LP                                           "
    },
    {
        "type": "UIT",
        "mpid": "BHKS",
        "clearingBroker": "0141",
        "brokerName": "BHK SECURITIES, LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "BIFS",
        "clearingBroker": "0443",
        "brokerName": "BROKERS INTERNATIONAL FINANCIAL SERVICES, LLC                         "
    },
    {
        "type": "UIT",
        "mpid": "BIGG",
        "clearingBroker": "0005",
        "brokerName": "BROWNSTONE INVESTMENT GROUP                                           "
    },
    {
        "type": "UIT",
        "mpid": "BIGP",
        "clearingBroker": "0443",
        "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "BISI",
        "clearingBroker": "0443",
        "brokerName": "BANORTE SECURITIES INTERNATIONAL, LTD.                                "
    },
    {
        "type": "UIT",
        "mpid": "BJCM",
        "clearingBroker": "0235",
        "brokerName": "ESSEX SECURITIES LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "BJRC",
        "clearingBroker": "0235",
        "brokerName": "CASCADE INVESTMENT GROUP, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "BKCM",
        "clearingBroker": "0443",
        "brokerName": "BNY CAPITAL MARKETS INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "BKES",
        "clearingBroker": "0443",
        "brokerName": "BNY MELLON CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "BKRT",
        "clearingBroker": "0235",
        "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "BLNI",
        "clearingBroker": "0226",
        "brokerName": "AMERITAS INVESTMENT COMPANY, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "BLOC",
        "clearingBroker": "0158",
        "brokerName": "TRADING BLOCK                                                         "
    },
    {
        "type": "UIT",
        "mpid": "BLTK",
        "clearingBroker": "0443",
        "brokerName": "BULLTICK, LLC                                                         "
    },
    {
        "type": "UIT",
        "mpid": "BMSA",
        "clearingBroker": "0443",
        "brokerName": "MARIVA CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "BMUR",
        "clearingBroker": "0443",
        "brokerName": "BREAN CAPITAL, LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "BNBB",
        "clearingBroker": "0750",
        "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "BNCH",
        "clearingBroker": "0235",
        "brokerName": "THE BENCHMARK COMPANY, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "BNDI",
        "clearingBroker": "0443",
        "brokerName": "BERNARDI SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "BNDS",
        "clearingBroker": "0226",
        "brokerName": "MTS MARKETS INTERNATIONAL, INC                                        "
    },
    {
        "type": "UIT",
        "mpid": "BNJM",
        "clearingBroker": "0235",
        "brokerName": "BENJAMIN SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "BNPS",
        "clearingBroker": "2154",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "UIT",
        "mpid": "BNPX",
        "clearingBroker": "2154",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "UIT",
        "mpid": "BNTE",
        "clearingBroker": "0158",
        "brokerName": "BANORTE-IXE SECURITIES INTERNATIONAL, LTD.                            "
    },
    {
        "type": "UIT",
        "mpid": "BNYM",
        "clearingBroker": "8355",
        "brokerName": "BNYM/UIT NSCC CNS CLEARANCE                                           "
    },
    {
        "type": "UIT",
        "mpid": "BNYN",
        "clearingBroker": "0226",
        "brokerName": "BANYAN SECURITIES, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "BOFA",
        "clearingBroker": "0773",
        "brokerName": "BOFA SECURITIES, INC./FIXED INCOME                                    "
    },
    {
        "type": "UIT",
        "mpid": "BOKI",
        "clearingBroker": "0443",
        "brokerName": "BOSC, INC.                                                            "
    },
    {
        "type": "UIT",
        "mpid": "BOSE",
        "clearingBroker": "0443",
        "brokerName": "BOE SECURITIES INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "BOSS",
        "clearingBroker": "0158",
        "brokerName": "ALL TIME ATS                                                          "
    },
    {
        "type": "UIT",
        "mpid": "BOTS",
        "clearingBroker": "0052",
        "brokerName": "C A BOTZUM & CO                                                       "
    },
    {
        "type": "UIT",
        "mpid": "BPWP",
        "clearingBroker": "0226",
        "brokerName": "BUTTONWOOD PARTNERS, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "BRAD",
        "clearingBroker": "0443",
        "brokerName": "BERNARD HEROLD & CO                                                   "
    },
    {
        "type": "UIT",
        "mpid": "BRBR",
        "clearingBroker": "0279",
        "brokerName": "BROWN AND BROWN SECURITIES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "BRCY",
        "clearingBroker": "0443",
        "brokerName": "BCP SECURITIES, LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "BRGE",
        "clearingBroker": "0052",
        "brokerName": "NEWBRIDGE SECURITIES CORPORATION                                      "
    },
    {
        "type": "UIT",
        "mpid": "BRLI",
        "clearingBroker": "0226",
        "brokerName": "BROWN, LISLE/CUMMINGS, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "BRNK",
        "clearingBroker": "0226",
        "brokerName": "BRINKER CAPITAL SECURITIES, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "BROC",
        "clearingBroker": "0443",
        "brokerName": "PAVILION GLOBAL MARKETS LTD                                           "
    },
    {
        "type": "UIT",
        "mpid": "BRRR",
        "clearingBroker": "8199",
        "brokerName": "BARRINGTON RESEARCH ASSOCIATES, INC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "BRSE",
        "clearingBroker": "0226",
        "brokerName": "BRADESCO SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "BRVL",
        "clearingBroker": "0443",
        "brokerName": "BLAYLOCK BEAL VAN, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "BRWM",
        "clearingBroker": "0226",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "UIT",
        "mpid": "BSCM",
        "clearingBroker": "0052",
        "brokerName": "BROAD STREET CAPITAL MARKETS, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "BSPI",
        "clearingBroker": "0235",
        "brokerName": "BALANCED SECURITY PLANNING, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "BTDG",
        "clearingBroker": "0161",
        "brokerName": "BIDS TRADING LP                                                       "
    },
    {
        "type": "UIT",
        "mpid": "BTIM",
        "clearingBroker": "1043",
        "brokerName": "BTIG, LLC                                                             "
    },
    {
        "type": "UIT",
        "mpid": "BTIS",
        "clearingBroker": "0443",
        "brokerName": "BTIG, LLC                                                             "
    },
    {
        "type": "UIT",
        "mpid": "BTSS",
        "clearingBroker": "0279",
        "brokerName": "HILLTOP SECURITIES INDEPENDENT NETWORK INC.                           "
    },
    {
        "type": "UIT",
        "mpid": "BURK",
        "clearingBroker": "0141",
        "brokerName": "BURKE, LAWTON, BREWER & BURKE                                         "
    },
    {
        "type": "UIT",
        "mpid": "BWNA",
        "clearingBroker": "0235",
        "brokerName": "BROWN ASSOCIATES INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "BYAI",
        "clearingBroker": "0226",
        "brokerName": "BRECEK & YOUNG                                                        "
    },
    {
        "type": "UIT",
        "mpid": "BZTN",
        "clearingBroker": "0141",
        "brokerName": "ALLIANT SECURITIES, INC. TURNER, NORD, KIENBAUM                       "
    },
    {
        "type": "UIT",
        "mpid": "BZWV",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "BZYD",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "BZYF",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "CADG",
        "clearingBroker": "0005",
        "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "CADZ",
        "clearingBroker": "0279",
        "brokerName": "CADZ SECURITIES INC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "CAGI",
        "clearingBroker": "0279",
        "brokerName": "CRESCENT SECURITIES GROUP, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "CAIX",
        "clearingBroker": "0235",
        "brokerName": "CAIS CAPITAL LLC                                                      "
    },
    {
        "type": "UIT",
        "mpid": "CALD",
        "clearingBroker": "0103",
        "brokerName": "CALDWELL SUTTER CAPITAL, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "CALT",
        "clearingBroker": "0279",
        "brokerName": "CALTON & ASSOCIATES                                                   "
    },
    {
        "type": "UIT",
        "mpid": "CAMS",
        "clearingBroker": "0443",
        "brokerName": "COMPREHENSIVE ASSET MANAGEMENT AND SERVICING, INC.                    "
    },
    {
        "type": "UIT",
        "mpid": "CANA",
        "clearingBroker": "0443",
        "brokerName": "CANACCORD GENUITY INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "CAPC",
        "clearingBroker": "0235",
        "brokerName": "CAPITAL CITY SECURITIES, LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "CAPE",
        "clearingBroker": "0279",
        "brokerName": "CAPE SECURITIES, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "CAPF",
        "clearingBroker": "0443",
        "brokerName": "CAPITAL FINANCIAL SERVICES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "CAPP",
        "clearingBroker": "0443",
        "brokerName": "CAPTRUST FINANCIAL ADVISORS                                           "
    },
    {
        "type": "UIT",
        "mpid": "CARG",
        "clearingBroker": "0141",
        "brokerName": "CARTHAGE GROUP INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "CART",
        "clearingBroker": "0443",
        "brokerName": "CARTY & COMPANY, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "CARY",
        "clearingBroker": "0141",
        "brokerName": "CARY STREET PARTNERS                                                  "
    },
    {
        "type": "UIT",
        "mpid": "CASH",
        "clearingBroker": "0158",
        "brokerName": "PLANNER SECURITIES LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "CATE",
        "clearingBroker": "0235",
        "brokerName": "CARTER, TERRY & COMPANY, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "CAVU",
        "clearingBroker": "0443",
        "brokerName": "CAVU SECURITIES LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "CBEV",
        "clearingBroker": "0226",
        "brokerName": "CITY NATIONAL BANK, BEVERLY HILLS, CALIFORNIA                         "
    },
    {
        "type": "UIT",
        "mpid": "CBII",
        "clearingBroker": "0443",
        "brokerName": "WESBANCO SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "CBIN",
        "clearingBroker": "0443",
        "brokerName": "COMPASS BROKERAGE, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "CBOL",
        "clearingBroker": "0226",
        "brokerName": "MUTUAL SECURITIES, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "CBTD",
        "clearingBroker": "0226",
        "brokerName": "SYNOVOUS SECURITIES INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "CCCO",
        "clearingBroker": "0226",
        "brokerName": "CARNES CAPITAL CORPORATION                                            "
    },
    {
        "type": "UIT",
        "mpid": "CCIG",
        "clearingBroker": "0235",
        "brokerName": "CINCAP INVESTMENT GROUP, INC                                          "
    },
    {
        "type": "UIT",
        "mpid": "CCMB",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "CCMC",
        "clearingBroker": "0443",
        "brokerName": "COMMERZEBANK CAPITAL CORP.                                            "
    },
    {
        "type": "UIT",
        "mpid": "CCMM",
        "clearingBroker": "0235",
        "brokerName": "CRAFT CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "CCPM",
        "clearingBroker": "0595",
        "brokerName": "CAMBRIA CAPITAL, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "CCRD",
        "clearingBroker": "0443",
        "brokerName": "CONCORDE INVESTMENT SERVICES, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "CCSS",
        "clearingBroker": "0443",
        "brokerName": "CROWN CAPITAL SECURITIES, L.P.                                        "
    },
    {
        "type": "UIT",
        "mpid": "CDFS",
        "clearingBroker": "0052",
        "brokerName": "NAVIAN CAPITAL SECURITIES, LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "CDMA",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "CERS",
        "clearingBroker": "0226",
        "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "CFCS",
        "clearingBroker": "0005",
        "brokerName": "CANTOR FITZGERALD & CO                                                "
    },
    {
        "type": "UIT",
        "mpid": "CFGM",
        "clearingBroker": "0235",
        "brokerName": "TRUSTMONT FINANCIAL GROUP, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "CFGT",
        "clearingBroker": "0235",
        "brokerName": "CF GLOBAL TRADING, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "CFII",
        "clearingBroker": "0235",
        "brokerName": "CONSOLIDATED FINANCIAL INVESTMENTS, INC.                              "
    },
    {
        "type": "UIT",
        "mpid": "CFIN",
        "clearingBroker": "0279",
        "brokerName": "CHELSEA FINANCIAL SERVICES                                            "
    },
    {
        "type": "UIT",
        "mpid": "CFSC",
        "clearingBroker": "0443",
        "brokerName": "INSIGNEO SECURITIES LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "CFSI",
        "clearingBroker": "0052",
        "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "CFSX",
        "clearingBroker": "0794",
        "brokerName": "CF SECURED, LLC                                                       "
    },
    {
        "type": "UIT",
        "mpid": "CGAM",
        "clearingBroker": "0443",
        "brokerName": "CGIS SECURITIES LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "CGAT",
        "clearingBroker": "0443",
        "brokerName": "CADARET, GRANT & CO., INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "CGCO",
        "clearingBroker": "0443",
        "brokerName": "CG COMPASS (USA) LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "CGLN",
        "clearingBroker": "0103",
        "brokerName": "COUGHLIN & CO                                                         "
    },
    {
        "type": "UIT",
        "mpid": "CGWM",
        "clearingBroker": "0443",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "CHAS",
        "clearingBroker": "0164",
        "brokerName": "CHARLES SCHWAB & CO., INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "CHBC",
        "clearingBroker": "0235",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "CHCH",
        "clearingBroker": "0226",
        "brokerName": "CHURCHILL FINANCIAL, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "CHCK",
        "clearingBroker": "0226",
        "brokerName": "CHICKASAW SECURITIES, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "CHDA",
        "clearingBroker": "0141",
        "brokerName": "CHAPIN, DAVIS                                                         "
    },
    {
        "type": "UIT",
        "mpid": "CHHS",
        "clearingBroker": "0141",
        "brokerName": "CHESTER HARRIS & CO., INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "CHLC",
        "clearingBroker": "0443",
        "brokerName": "CHURCHILL CAPITAL USA, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "CHPP",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "CICC",
        "clearingBroker": "0443",
        "brokerName": "CICC US SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "CICI",
        "clearingBroker": "0443",
        "brokerName": "COMMERCE BANK INVESTMENT SERVICES, INC.                               "
    },
    {
        "type": "UIT",
        "mpid": "CICL",
        "clearingBroker": "0141",
        "brokerName": "CAROLINAS INVESTMENT CONSULTING                                       "
    },
    {
        "type": "UIT",
        "mpid": "CIIV",
        "clearingBroker": "0052",
        "brokerName": "CORPORATE INVESTMENTS GROUP, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "CIMB",
        "clearingBroker": "0005",
        "brokerName": "CIMB SECURITIES (USA), INC                                            "
    },
    {
        "type": "UIT",
        "mpid": "CIRI",
        "clearingBroker": "0443",
        "brokerName": "CAMBRIDGE INVESTMENT RESEARCH, INC.                                   "
    },
    {
        "type": "UIT",
        "mpid": "CISV",
        "clearingBroker": "0226",
        "brokerName": "CITIZENS SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "CJSC",
        "clearingBroker": "0443",
        "brokerName": "CJS SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "CLDN",
        "clearingBroker": "0235",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "CLRK",
        "clearingBroker": "0235",
        "brokerName": "CLARK DODGE & CO, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "CLSC",
        "clearingBroker": "0235",
        "brokerName": "CABOT LODGE SECURITIES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "CLSS",
        "clearingBroker": "0235",
        "brokerName": "CABOT LODGE SECURITIES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "CLTN",
        "clearingBroker": "0226",
        "brokerName": "CALTON & ASSOCIATES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "CMCE",
        "clearingBroker": "0226",
        "brokerName": "COMMERCE BROKERAGE SERVICES                                           "
    },
    {
        "type": "UIT",
        "mpid": "CMFS",
        "clearingBroker": "0443",
        "brokerName": "BNY MELLON CAP MKTS                                                   "
    },
    {
        "type": "UIT",
        "mpid": "CMGF",
        "clearingBroker": "0443",
        "brokerName": "CMG SECURITIES LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "CMMW",
        "clearingBroker": "0226",
        "brokerName": "COMMONWEALTH FINANCIAL NETWORK                                        "
    },
    {
        "type": "UIT",
        "mpid": "CNCD",
        "clearingBroker": "0235",
        "brokerName": "CONCORDE INVESTMENT SERVICES, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "CNFI",
        "clearingBroker": "0443",
        "brokerName": "CENTAURUS FINANCIAL INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "CNFR",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "CNSI",
        "clearingBroker": "0226",
        "brokerName": "CITY NATIONAL SECURITIES, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "COAS",
        "clearingBroker": "0443",
        "brokerName": "REALTA EQUITIES, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "CODA",
        "clearingBroker": "0161",
        "brokerName": "CODA MARKETS, INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "COEI",
        "clearingBroker": "0052",
        "brokerName": "COASTAL EQUITIES, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "COEX",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "COFS",
        "clearingBroker": "0279",
        "brokerName": "COLORADO FINANCIAL SERVICE CORPORATION                                "
    },
    {
        "type": "UIT",
        "mpid": "COHN",
        "clearingBroker": "0235",
        "brokerName": "COHEN BROS. & COMPANY                                                 "
    },
    {
        "type": "UIT",
        "mpid": "COKE",
        "clearingBroker": "0235",
        "brokerName": "COKER & PALMER, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "COMP",
        "clearingBroker": "0595",
        "brokerName": "COMPASS POINT RESEARCH & TRADING, LLC                                 "
    },
    {
        "type": "UIT",
        "mpid": "CONI",
        "clearingBroker": "0235",
        "brokerName": "CONTINENTAL INVESTORS SERVICES, INC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "CONR",
        "clearingBroker": "0235",
        "brokerName": "CONNERS & CO., INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "CONS",
        "clearingBroker": "0141",
        "brokerName": "CONSULTIVA SECURITIES, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "COOR",
        "clearingBroker": "0141",
        "brokerName": "COORDINATED CAPITAL SECURITIES, INC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "COSL",
        "clearingBroker": "0443",
        "brokerName": "CLIENT ONE SECURITIES, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "COWN",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "COWP",
        "clearingBroker": "0226",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "COWR",
        "clearingBroker": "0443",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "COYL",
        "clearingBroker": "0235",
        "brokerName": "COYLE SECURITIES LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "CPGL",
        "clearingBroker": "0226",
        "brokerName": "CONTINUITY PARTNERS GROUP, LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "CPRC",
        "clearingBroker": "0235",
        "brokerName": "CORINTHIAN PARTNERS, L.L.C.                                           "
    },
    {
        "type": "UIT",
        "mpid": "CPRM",
        "clearingBroker": "8199",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "CRCM",
        "clearingBroker": "0235",
        "brokerName": "COHNREZNICK CAPITAL                                                   "
    },
    {
        "type": "UIT",
        "mpid": "CRDL",
        "clearingBroker": "0235",
        "brokerName": "CARDINAL INVESTMENTS, INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "CRED",
        "clearingBroker": "0443",
        "brokerName": "CREDICORP CAPITAL LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "CREF",
        "clearingBroker": "0443",
        "brokerName": "TIAA-CREF INDIVIDUAL AND INSTITUTIONAL SERVICES, LLC                  "
    },
    {
        "type": "UIT",
        "mpid": "CREW",
        "clearingBroker": "0443",
        "brokerName": "CREWS & ASSOCIATES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "CRFN",
        "clearingBroker": "6769",
        "brokerName": "ROBINHOOD FINANCIAL, LLC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "CRII",
        "clearingBroker": "0443",
        "brokerName": "CRI SECURITIES INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "CRNJ",
        "clearingBroker": "0103",
        "brokerName": "CANTONE RESEARCH                                                      "
    },
    {
        "type": "UIT",
        "mpid": "CRON",
        "clearingBroker": "0443",
        "brokerName": "CRONIN & CO., INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "CRPT",
        "clearingBroker": "0235",
        "brokerName": "CROSS POINT CAPITAL LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "CRTH",
        "clearingBroker": "0443",
        "brokerName": "CORINTHIAN PARTNERS, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "CRYN",
        "clearingBroker": "0235",
        "brokerName": "BRENDAN E. CRYAN AND COMPANY, L.L.C.                                  "
    },
    {
        "type": "UIT",
        "mpid": "CSAI",
        "clearingBroker": "0793",
        "brokerName": "STIFEL INDEPENDENT ADVISORS, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "CSAP",
        "clearingBroker": "0141",
        "brokerName": "CRESAP, INC.                                                          "
    },
    {
        "type": "UIT",
        "mpid": "CSCA",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "UIT",
        "mpid": "CSCM",
        "clearingBroker": "0279",
        "brokerName": "CENTRAL STATES CAPITAL MARKETS, LLC                                   "
    },
    {
        "type": "UIT",
        "mpid": "CSPA",
        "clearingBroker": "0226",
        "brokerName": "CREDIT SUISSE PRIVATE ADVISORS                                        "
    },
    {
        "type": "UIT",
        "mpid": "CSPI",
        "clearingBroker": "0235",
        "brokerName": "CAPITAL SYNERGY PARTNERS                                              "
    },
    {
        "type": "UIT",
        "mpid": "CTAS",
        "clearingBroker": "0443",
        "brokerName": "OSAIC INSTITUTIONS, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "CTBK",
        "clearingBroker": "4270",
        "brokerName": "CENTRAL TRUST BANK                                                    "
    },
    {
        "type": "UIT",
        "mpid": "CTNL",
        "clearingBroker": "0235",
        "brokerName": "CENTENNIAL SECURITIES COMPANY LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "CTSC",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "UIT",
        "mpid": "CUFT",
        "clearingBroker": "0226",
        "brokerName": "FROST BROKERAGE SERVICES, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "CUSO",
        "clearingBroker": "0443",
        "brokerName": "CUSO FINANCIAL SERVICES, L.P.                                         "
    },
    {
        "type": "UIT",
        "mpid": "CUTW",
        "clearingBroker": "0235",
        "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "CUWB",
        "clearingBroker": "0103",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL, LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "CVGP",
        "clearingBroker": "0443",
        "brokerName": "COWEN AND COMPANY LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "CWEI",
        "clearingBroker": "0443",
        "brokerName": "BEECH HILL SECURITIES, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "CWMK",
        "clearingBroker": "0438",
        "brokerName": "CIBC WORLD MARKETS CORP.                                              "
    },
    {
        "type": "UIT",
        "mpid": "CYND",
        "clearingBroker": "0443",
        "brokerName": "TIGRESS FINANCIAL PARTNERS LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "DADA",
        "clearingBroker": "0361",
        "brokerName": "D. A. DAVIDSON & CO.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DAII",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER (DON) INVESTMENTS, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "DAIN",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "DAIS",
        "clearingBroker": "0052",
        "brokerName": "DAI SECURITIES, LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "DARA",
        "clearingBroker": "0235",
        "brokerName": "DARWOOD ASSOCIATES, INC                                               "
    },
    {
        "type": "UIT",
        "mpid": "DART",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DASH",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "DAVA",
        "clearingBroker": "0443",
        "brokerName": "DAVENPORT & COMPANY LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "DAWA",
        "clearingBroker": "0647",
        "brokerName": "DAIWA CAPITAL MARKETS AMERICA INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "DBCC",
        "clearingBroker": "0235",
        "brokerName": "D. BORAL CAPITAL                                                      "
    },
    {
        "type": "UIT",
        "mpid": "DBCH",
        "clearingBroker": "0052",
        "brokerName": "D. BORAL CAPITAL                                                      "
    },
    {
        "type": "UIT",
        "mpid": "DBKS",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "DBPC",
        "clearingBroker": "0443",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "DCAN",
        "clearingBroker": "0279",
        "brokerName": "R. M. DUNCAN SECURITIES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "DCSD",
        "clearingBroker": "0235",
        "brokerName": "DAIN CORRESPONDENT SERVICES                                           "
    },
    {
        "type": "UIT",
        "mpid": "DCVL",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DEAN",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "DEGS",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DENI",
        "clearingBroker": "0279",
        "brokerName": "H.C. DENISON CO.                                                      "
    },
    {
        "type": "UIT",
        "mpid": "DETF",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DFPG",
        "clearingBroker": "0235",
        "brokerName": "DFPG INVESTMENTS, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "DIBS",
        "clearingBroker": "0226",
        "brokerName": "DIGITAL BROKERAGE SERVICES LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "DIGG",
        "clearingBroker": "0595",
        "brokerName": "BOUSTEAD SECURITIES, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "DINO",
        "clearingBroker": "0103",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "UIT",
        "mpid": "DJSA",
        "clearingBroker": "0750",
        "brokerName": "DAWSON JAMES SECURITIES, INC                                          "
    },
    {
        "type": "UIT",
        "mpid": "DLAI",
        "clearingBroker": "0235",
        "brokerName": "DAVID LERNER ASSOCIATES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "DLPS",
        "clearingBroker": "0595",
        "brokerName": "DLP SECURITIES,.LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "DLSI",
        "clearingBroker": "0226",
        "brokerName": "DEMPSEY LORD SMITH, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "DMCD",
        "clearingBroker": "0279",
        "brokerName": "MCDERMOTT INVESTMENT SERVICES, LLC                                    "
    },
    {
        "type": "UIT",
        "mpid": "DMKC",
        "clearingBroker": "0141",
        "brokerName": "D.M. KELLY & COMPANY                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DNOR",
        "clearingBroker": "0005",
        "brokerName": "DNB MARKETS, INC.                                                     "
    },
    {
        "type": "UIT",
        "mpid": "DNSR",
        "clearingBroker": "0158",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "UIT",
        "mpid": "DNWL",
        "clearingBroker": "0443",
        "brokerName": "DUNCAN & WILLIAMS, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "DOFT",
        "clearingBroker": "0443",
        "brokerName": "DOFT & CO., INC.                                                      "
    },
    {
        "type": "UIT",
        "mpid": "DOMI",
        "clearingBroker": "0279",
        "brokerName": "DOMINION INVESTOR SERVICES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "DOMS",
        "clearingBroker": "0235",
        "brokerName": "DOMINARI SECURITIES LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "DORN",
        "clearingBroker": "0235",
        "brokerName": "DORN & CO., INC.                                                      "
    },
    {
        "type": "UIT",
        "mpid": "DOTC",
        "clearingBroker": "0226",
        "brokerName": "COLLIERS SECURITIES LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "DOVE",
        "clearingBroker": "0226",
        "brokerName": "SECURITIES EQUITY GROUP                                               "
    },
    {
        "type": "UIT",
        "mpid": "DOWL",
        "clearingBroker": "0443",
        "brokerName": "DOWLING & PARTNERS SECURITIES LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "DREX",
        "clearingBroker": "0443",
        "brokerName": "DREXEL HAMILTON, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DRSC",
        "clearingBroker": "0443",
        "brokerName": "BNY MELLON SECURITIES CORPORATION                                     "
    },
    {
        "type": "UIT",
        "mpid": "DRTG",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DRTR",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DRVW",
        "clearingBroker": "0235",
        "brokerName": "DRIVEWEALTH, LLC                                                      "
    },
    {
        "type": "UIT",
        "mpid": "DSAI",
        "clearingBroker": "0443",
        "brokerName": "DAEWOO SECURITIES (AMERICA) INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "DSGG",
        "clearingBroker": "0226",
        "brokerName": "DMG SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DTEX",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
    },
    {
        "type": "UIT",
        "mpid": "DUST",
        "clearingBroker": "0161",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "UIT",
        "mpid": "DWIZ",
        "clearingBroker": "0235",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "EAMC",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
    },
    {
        "type": "UIT",
        "mpid": "EAMG",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
    },
    {
        "type": "UIT",
        "mpid": "ECCC",
        "clearingBroker": "0226",
        "brokerName": "EAGLES COAST CAPITAL, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "EDFC",
        "clearingBroker": "0443",
        "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "EDFO",
        "clearingBroker": "0158",
        "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "EDIR",
        "clearingBroker": "0235",
        "brokerName": "EDI FINANCIAL, INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "EDJO",
        "clearingBroker": "0057",
        "brokerName": "EDWARD D. JONES & CO.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "EFGC",
        "clearingBroker": "0443",
        "brokerName": "EFG CAPITAL INTERNATIONAL                                             "
    },
    {
        "type": "UIT",
        "mpid": "EFSP",
        "clearingBroker": "0443",
        "brokerName": "ESSEX FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "EGLE",
        "clearingBroker": "1043",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "UIT",
        "mpid": "EGMT",
        "clearingBroker": "0005",
        "brokerName": "EG MARKET TECHNOLOGIES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "ELET",
        "clearingBroker": "0388",
        "brokerName": "ELECTRONIFIE SECURITIES LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "ELEV",
        "clearingBroker": "0235",
        "brokerName": "ELEVATION, LLC                                                        "
    },
    {
        "type": "UIT",
        "mpid": "EMER",
        "clearingBroker": "0443",
        "brokerName": "EMERSON EQUITY LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "EMOC",
        "clearingBroker": "0750",
        "brokerName": "E. MAGNUS OPPENHIEM & CO. INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "EMPR",
        "clearingBroker": "0279",
        "brokerName": "SELKIRK INVESTMENTS, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "ENTR",
        "clearingBroker": "0235",
        "brokerName": "ENTRUSTODY FINANCIAL, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "EPIC",
        "clearingBroker": "0443",
        "brokerName": "EPIC CAPITAL SECURITIES                                               "
    },
    {
        "type": "UIT",
        "mpid": "EQHA",
        "clearingBroker": "0075",
        "brokerName": "EQUITABLE ADVISORS, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "EQSV",
        "clearingBroker": "0226",
        "brokerName": "EQUITY SERVICES, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "EROP",
        "clearingBroker": "0158",
        "brokerName": "EROOM SECURITIES LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "ESBD",
        "clearingBroker": "0235",
        "brokerName": "EASTDIL SECURED ADVISORS LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "ETCB",
        "clearingBroker": "3505",
        "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "ETCL",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "ETRS",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "EVOL",
        "clearingBroker": "0226",
        "brokerName": "EVOLVE SECURITIES, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "EXCS",
        "clearingBroker": "0443",
        "brokerName": "EXCEL SECURITIES AND ASSOCIATES, INC.                                 "
    },
    {
        "type": "UIT",
        "mpid": "FAFI",
        "clearingBroker": "0279",
        "brokerName": "FIRST ASSET FINANCIAL                                                 "
    },
    {
        "type": "UIT",
        "mpid": "FALC",
        "clearingBroker": "0103",
        "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "FANC",
        "clearingBroker": "0235",
        "brokerName": "FINANCE 500, INC.                                                     "
    },
    {
        "type": "UIT",
        "mpid": "FATS",
        "clearingBroker": "0443",
        "brokerName": "FIRST BROKERS SECURITIES LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "FBLM",
        "clearingBroker": "0235",
        "brokerName": "FBL MARKETING SERVICES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "FBLT",
        "clearingBroker": "8199",
        "brokerName": "FIRST BALLANTYNE, LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "FBNS",
        "clearingBroker": "0235",
        "brokerName": "FBN SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "FBPC",
        "clearingBroker": "0443",
        "brokerName": "CREDIT SUISSE SECURITIES (USA) LLC                                    "
    },
    {
        "type": "UIT",
        "mpid": "FBSB",
        "clearingBroker": "0280",
        "brokerName": "U.S. BANCORP INVESTMENTS, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "FCFP",
        "clearingBroker": "0141",
        "brokerName": "FIRST CITIZENS FINANCIAL PLUS, INC.                                   "
    },
    {
        "type": "UIT",
        "mpid": "FCFS",
        "clearingBroker": "0443",
        "brokerName": "FIRST COMMAND FINANCIAL PLANNING, INC.                                "
    },
    {
        "type": "UIT",
        "mpid": "FCIT",
        "clearingBroker": "0443",
        "brokerName": "FIRST CITIZENS INVESTOR SERVICES, INC.                                "
    },
    {
        "type": "UIT",
        "mpid": "FCML",
        "clearingBroker": "0279",
        "brokerName": "FNBB CAPITAL MARKETS, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "FCMP",
        "clearingBroker": "0595",
        "brokerName": "PRIME EXECUTIONS, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "FCST",
        "clearingBroker": "0443",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "FDSC",
        "clearingBroker": "0158",
        "brokerName": "1ST DISCOUNT BROKERAGE INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "FDSI",
        "clearingBroker": "0141",
        "brokerName": "FIRST DALLAS SECURITIES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "FEDR",
        "clearingBroker": "0235",
        "brokerName": "FEDERATED SECURITIES INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "FENX",
        "clearingBroker": "0595",
        "brokerName": "FENIX SECURITIES, LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "FERN",
        "clearingBroker": "0443",
        "brokerName": "FEARNLEY SECURITIES                                                   "
    },
    {
        "type": "UIT",
        "mpid": "FFCM",
        "clearingBroker": "0235",
        "brokerName": "FOREFRONT CAPITAL MARKETS LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "FFGI",
        "clearingBroker": "0235",
        "brokerName": "FELDSTEIN FINANCIAL GROUP, LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "FFSI",
        "clearingBroker": "0158",
        "brokerName": "FIRSTRADE SECURITIES INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "FHCI",
        "clearingBroker": "0443",
        "brokerName": "FIRST HEARTLAND CAPITAL, INC                                          "
    },
    {
        "type": "UIT",
        "mpid": "FHON",
        "clearingBroker": "0235",
        "brokerName": "FIRST HONOLULU SECURITIES INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "FIBS",
        "clearingBroker": "0226",
        "brokerName": "FIDELITY BROKERAGE SERVICES LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "FISA",
        "clearingBroker": "0443",
        "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "FISB",
        "clearingBroker": "0226",
        "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "FISH",
        "clearingBroker": "0235",
        "brokerName": "L.B. FISHER & COMPANY                                                 "
    },
    {
        "type": "UIT",
        "mpid": "FJRF",
        "clearingBroker": "0052",
        "brokerName": "PARITER SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "FKSC",
        "clearingBroker": "0235",
        "brokerName": "FIRST KENTUCKY SECURITIES CORP.                                       "
    },
    {
        "type": "UIT",
        "mpid": "FLAT",
        "clearingBroker": "0226",
        "brokerName": "FLORIDA ATLANTIC SECURITIES CORP.                                     "
    },
    {
        "type": "UIT",
        "mpid": "FLIB",
        "clearingBroker": "0235",
        "brokerName": "FIRST LIBERTIES FINANCIAL                                             "
    },
    {
        "type": "UIT",
        "mpid": "FLOU",
        "clearingBroker": "0443",
        "brokerName": "FIRST ST. LOUIS SECURITIES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "FLTG",
        "clearingBroker": "0005",
        "brokerName": "FLOW TRADERS U.S. LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "FLTL",
        "clearingBroker": "0235",
        "brokerName": "FELTL & COMPANY                                                       "
    },
    {
        "type": "UIT",
        "mpid": "FMAT",
        "clearingBroker": "0608",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "FMCO",
        "clearingBroker": "0443",
        "brokerName": "FIRST MANHATTAN CO.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "FMEX",
        "clearingBroker": "0750",
        "brokerName": "FINAMEX INTERNATIONAL, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "FMFS",
        "clearingBroker": "0226",
        "brokerName": "FISRT MERIT FINANCIAL SERVICES, INC                                   "
    },
    {
        "type": "UIT",
        "mpid": "FMGT",
        "clearingBroker": "0443",
        "brokerName": "FAMILY MANAGEMENT SECURITIES, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "FNFD",
        "clearingBroker": "0443",
        "brokerName": "FOLGER NOLAN FLEMING DOUGLAS INCORPORATED                             "
    },
    {
        "type": "UIT",
        "mpid": "FNIC",
        "clearingBroker": "0443",
        "brokerName": "FINANCIAL NETWORK INVESTMENT CORP.                                    "
    },
    {
        "type": "UIT",
        "mpid": "FNPN",
        "clearingBroker": "0443",
        "brokerName": "UNIVEST INVESTMENTS                                                   "
    },
    {
        "type": "UIT",
        "mpid": "FNSJ",
        "clearingBroker": "0443",
        "brokerName": "FINANCIAL NORTHEASTERN SECURITIES, INC.                               "
    },
    {
        "type": "UIT",
        "mpid": "FOGS",
        "clearingBroker": "0235",
        "brokerName": "FOG EQUITIES LLC                                                      "
    },
    {
        "type": "UIT",
        "mpid": "FOXC",
        "clearingBroker": "0443",
        "brokerName": "FOX CHASE CAPITAL PARTNERS, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "FSCS",
        "clearingBroker": "0443",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "FSRP",
        "clearingBroker": "0443",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "FTBR",
        "clearingBroker": "0728",
        "brokerName": "FOLIO INVESTMENTS, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "FTEN",
        "clearingBroker": "0226",
        "brokerName": "FTB ADVISORS, INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "FTLP",
        "clearingBroker": "8244",
        "brokerName": "FIRST TRUST PORTFOLIOS, L.P.                                          "
    },
    {
        "type": "UIT",
        "mpid": "FTSR",
        "clearingBroker": "0226",
        "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "FUBO",
        "clearingBroker": "0443",
        "brokerName": "GRIFFINEST ASIA SECURITIES, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "FWSI",
        "clearingBroker": "0141",
        "brokerName": "FIRST WESTERN SECURITIES, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "GABE",
        "clearingBroker": "0141",
        "brokerName": "G. RESEARCH, INC.                                                     "
    },
    {
        "type": "UIT",
        "mpid": "GAFI",
        "clearingBroker": "0235",
        "brokerName": "GARDNER FINANCIAL SERVICES INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "GAGN",
        "clearingBroker": "0226",
        "brokerName": "GAGNON SECURITIES, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "GAII",
        "clearingBroker": "0279",
        "brokerName": "GREAT AMERICAN INVESTORS, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "GARB",
        "clearingBroker": "0148",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
    },
    {
        "type": "UIT",
        "mpid": "GARC",
        "clearingBroker": "0161",
        "brokerName": "ICAP CORPORATES LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "GARE",
        "clearingBroker": "0148",
        "brokerName": "GARE                                                                  "
    },
    {
        "type": "UIT",
        "mpid": "GARR",
        "clearingBroker": "0226",
        "brokerName": "GARRETT NAGLE & CO., INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "GARW",
        "clearingBroker": "0595",
        "brokerName": "GAR WOOD SECURITIES, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "GBMS",
        "clearingBroker": "0158",
        "brokerName": "GBM INTERNATIONAL, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "GBMT",
        "clearingBroker": "0443",
        "brokerName": "GBM INTERNATIONAL, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "GCMC",
        "clearingBroker": "0443",
        "brokerName": "GLADOWSKY CAPITAL MANAGEMENT CORP.                                    "
    },
    {
        "type": "UIT",
        "mpid": "GDCO",
        "clearingBroker": "0443",
        "brokerName": "GILBERT, DONIGER CO., INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "GELP",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "GENS",
        "clearingBroker": "0279",
        "brokerName": "GENERAL SECURITIES CORP                                               "
    },
    {
        "type": "UIT",
        "mpid": "GENW",
        "clearingBroker": "0443",
        "brokerName": "GENEOS WEALTH MANAGEMENT, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "GFBD",
        "clearingBroker": "0226",
        "brokerName": "G. F. INVESTMENT SERVICES, LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "GFSI",
        "clearingBroker": "0443",
        "brokerName": "GLOBAL FINANCIAL SERVICES, L.L.C.                                     "
    },
    {
        "type": "UIT",
        "mpid": "GGWI",
        "clearingBroker": "0141",
        "brokerName": "GAGE-WILEY & COMPANY INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "GHCC",
        "clearingBroker": "0226",
        "brokerName": "GORDON, HASKETT CAPITAL CORPORATION                                   "
    },
    {
        "type": "UIT",
        "mpid": "GILG",
        "clearingBroker": "0226",
        "brokerName": "GILDER GAGNON HOWE & CO. LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "GJSS",
        "clearingBroker": "0235",
        "brokerName": "SCHWARTZ, GREGORY J & CO. INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "GLCM",
        "clearingBroker": "0443",
        "brokerName": "GREENSLEDGE CAPITAL MARKETS                                           "
    },
    {
        "type": "UIT",
        "mpid": "GLYN",
        "clearingBroker": "0443",
        "brokerName": "GLYNN (J.A.) & CO.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "GMSG",
        "clearingBroker": "0443",
        "brokerName": "GMS GROUP (THE), L.L.C.                                               "
    },
    {
        "type": "UIT",
        "mpid": "GPCA",
        "clearingBroker": "0235",
        "brokerName": "GREAT POINT CAPITAL LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "GPCG",
        "clearingBroker": "0443",
        "brokerName": "GREENMAN, PARKER, CONNALLY, GREENMAN, INC.                            "
    },
    {
        "type": "UIT",
        "mpid": "GRAD",
        "clearingBroker": "0235",
        "brokerName": "GRADIENT SECURITIES, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "GRBD",
        "clearingBroker": "0052",
        "brokerName": "GREENBIRD CAPITAL LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "GRIL",
        "clearingBroker": "0235",
        "brokerName": "GLOBAL RESOURCE INVESTMENTS, LTD.                                     "
    },
    {
        "type": "UIT",
        "mpid": "GROD",
        "clearingBroker": "0226",
        "brokerName": "GRODSKY ASSOCIATES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "GRPS",
        "clearingBroker": "0226",
        "brokerName": "MML INVESTORS SERVICES, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "GRWD",
        "clearingBroker": "0052",
        "brokerName": "GAR WOOD SECURITIES, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "GRYG",
        "clearingBroker": "0226",
        "brokerName": "GOLDBERG (GARY) & CO., INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "GSBI",
        "clearingBroker": "0279",
        "brokerName": "GLOBAL BROKERAGE SERVICES, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "GSCO",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "GSIL",
        "clearingBroker": "0158",
        "brokerName": "GLOBAL STRATEGIC INVESTMENTS, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "GSMM",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "GSQQ",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "GSSI",
        "clearingBroker": "0052",
        "brokerName": "GARDEN STATE SECURITIES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "GSUU",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "GSVV",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "GTNB",
        "clearingBroker": "0595",
        "brokerName": "GTN AMERICAS FINANCIAL SERVICES, INC.                                 "
    },
    {
        "type": "UIT",
        "mpid": "GUGI",
        "clearingBroker": "0526",
        "brokerName": "GUGGENHEIM FUNDS DISTRIBUTORS, LLC                                    "
    },
    {
        "type": "UIT",
        "mpid": "GWFS",
        "clearingBroker": "0443",
        "brokerName": "GWFS EQUITIES, INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "GWNS",
        "clearingBroker": "0443",
        "brokerName": "GWN SECURITIES INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "HAFS",
        "clearingBroker": "0279",
        "brokerName": "HANTZ FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "HALO",
        "clearingBroker": "0235",
        "brokerName": "HALO SECURITIES, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "HARB",
        "clearingBroker": "0443",
        "brokerName": "HARBOUR INVESTMENTS INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "HARC",
        "clearingBroker": "0235",
        "brokerName": "HARLEY CAPITAL LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "HAVK",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE STATE FINANCIAL, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "HAZL",
        "clearingBroker": "0226",
        "brokerName": "HAZLETT, BURT AND WATSON, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "HBCO",
        "clearingBroker": "0443",
        "brokerName": "GLOBAL INVESTOR SERVICES, L.C.                                        "
    },
    {
        "type": "UIT",
        "mpid": "HBUS",
        "clearingBroker": "0443",
        "brokerName": "HOLISTIC BROKERAGE, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "HCMX",
        "clearingBroker": "0235",
        "brokerName": "HOOPOE CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "HCTA",
        "clearingBroker": "0005",
        "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "HCWW",
        "clearingBroker": "0235",
        "brokerName": "H.C.WAINWRIGHT & CO., LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "HDVS",
        "clearingBroker": "0226",
        "brokerName": "AVANTAX INVESTMENT SERVICES, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "HEAD",
        "clearingBroker": "0443",
        "brokerName": "TD SECURITIES AUTOMATED TRADING LLC                                   "
    },
    {
        "type": "UIT",
        "mpid": "HENN",
        "clearingBroker": "0235",
        "brokerName": "CARL M. HENNIG, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "HENY",
        "clearingBroker": "0443",
        "brokerName": "HENLEY & COMPANY LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "HIAL",
        "clearingBroker": "0443",
        "brokerName": "HARBOR INVESTMENT ADVISORY, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "HIGG",
        "clearingBroker": "0235",
        "brokerName": "HIGGINS CAPITAL MANAGEMENT, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "HINO",
        "clearingBroker": "0235",
        "brokerName": "TRB CAPITAL MARKETS,LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "HITS",
        "clearingBroker": "0443",
        "brokerName": "HEIGHT SECURITIES, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "HJSC",
        "clearingBroker": "0443",
        "brokerName": "SIMS (HERBERT J.) & CO., INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "HNTR",
        "clearingBroker": "0443",
        "brokerName": "HUNTER ASSOCIATES, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "HONR",
        "clearingBroker": "0235",
        "brokerName": "ROBERTS & RYAN INVESTMENTS INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "HOOD",
        "clearingBroker": "6769",
        "brokerName": "ROBINHOOD SECURITIES, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "HOPK",
        "clearingBroker": "0750",
        "brokerName": "SILVER OAK SECURITIES, INCORPORATED                                   "
    },
    {
        "type": "UIT",
        "mpid": "HOTO",
        "clearingBroker": "0443",
        "brokerName": "HORNOR, TOWNSEND & KENT, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "HPOM",
        "clearingBroker": "0235",
        "brokerName": "HERNDON PLANT OAKLEY, LTD.                                            "
    },
    {
        "type": "UIT",
        "mpid": "HRBF",
        "clearingBroker": "0756",
        "brokerName": "AMERICAN ENTERPRISE INVESTMENT SERVICES INC.                          "
    },
    {
        "type": "UIT",
        "mpid": "HRCS",
        "clearingBroker": "0443",
        "brokerName": "HRC INVESTMENT SERVICES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "HRGR",
        "clearingBroker": "0235",
        "brokerName": "HARGER AND COMPANY, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "HRRS",
        "clearingBroker": "0443",
        "brokerName": "HARRIS INVESTORS SERVICES, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "HSAI",
        "clearingBroker": "0443",
        "brokerName": "INDEPENDENT FINANCIAL GROUP, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "HSBK",
        "clearingBroker": "0443",
        "brokerName": "HSBC SECURITIES (USA) INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "HSBM",
        "clearingBroker": "0486",
        "brokerName": "HSBC SECURITIES (USA), INC/ FIXED INCOME SECS                         "
    },
    {
        "type": "UIT",
        "mpid": "HTCM",
        "clearingBroker": "0235",
        "brokerName": "HOWDEN TIGER CAPITAL MARKETS & ADVISOF LLC                            "
    },
    {
        "type": "UIT",
        "mpid": "HTPS",
        "clearingBroker": "0443",
        "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "HTWR",
        "clearingBroker": "0226",
        "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "HUCO",
        "clearingBroker": "0226",
        "brokerName": "HUNTINGTON INVESTMENT COMPANY                                         "
    },
    {
        "type": "UIT",
        "mpid": "HUNT",
        "clearingBroker": "0141",
        "brokerName": "HUNTLEIGH SECURITIES CORPORATION                                      "
    },
    {
        "type": "UIT",
        "mpid": "HWJC",
        "clearingBroker": "0052",
        "brokerName": "HWJ CAPITAL PARTNERS II, LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "HWLS",
        "clearingBroker": "0443",
        "brokerName": "M.S. HOWELLS & CO.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "IAAK",
        "clearingBroker": "0279",
        "brokerName": "ISAAK BOND INVESTMENT, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "IAEW",
        "clearingBroker": "0595",
        "brokerName": "SRT SECURITIES LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "IAEX",
        "clearingBroker": "0235",
        "brokerName": "SRT SECURITIES LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "IBND",
        "clearingBroker": "0103",
        "brokerName": "INSTITUTIONAL BOND NETWORK, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "IBOT",
        "clearingBroker": "0279",
        "brokerName": "INVESTORS BROKERAGE OF TEXAS, INC                                     "
    },
    {
        "type": "UIT",
        "mpid": "IBPR",
        "clearingBroker": "0052",
        "brokerName": "IB CAPITAL LLC                                                        "
    },
    {
        "type": "UIT",
        "mpid": "IBSJ",
        "clearingBroker": "0052",
        "brokerName": "INTEGRITY BROKERAGE                                                   "
    },
    {
        "type": "UIT",
        "mpid": "ICAN",
        "clearingBroker": "0226",
        "brokerName": "CETERA ADVISOR NETWORKS LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "ICBK",
        "clearingBroker": "0388",
        "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL SERVICES LLC        "
    },
    {
        "type": "UIT",
        "mpid": "ICCI",
        "clearingBroker": "0279",
        "brokerName": "INDEPENDENCE CAPITAL CO.                                              "
    },
    {
        "type": "UIT",
        "mpid": "ICDS",
        "clearingBroker": "0750",
        "brokerName": "ICD SECURITIES                                                        "
    },
    {
        "type": "UIT",
        "mpid": "ICEX",
        "clearingBroker": "4264",
        "brokerName": "ICE SECURITIES EXECUTION & CLEARING, LLC                              "
    },
    {
        "type": "UIT",
        "mpid": "ICMH",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL CAPITAL MANAGEMENT, INC.                                "
    },
    {
        "type": "UIT",
        "mpid": "ICMI",
        "clearingBroker": "0279",
        "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "ICON",
        "clearingBroker": "0595",
        "brokerName": "ICON CAPITAL GROUP, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "ICRL",
        "clearingBroker": "0443",
        "brokerName": "RIDEAU (I.C.) LYONS AND CO.                                           "
    },
    {
        "type": "UIT",
        "mpid": "ICTI",
        "clearingBroker": "0158",
        "brokerName": "INTERNATIONAL CORRESPONDENT TRADING, INC.                             "
    },
    {
        "type": "UIT",
        "mpid": "IDAY",
        "clearingBroker": "0103",
        "brokerName": "BROKERAGESELECT                                                       "
    },
    {
        "type": "UIT",
        "mpid": "IESI",
        "clearingBroker": "0443",
        "brokerName": "ITAU EUROPA SECURITIES INC                                            "
    },
    {
        "type": "UIT",
        "mpid": "IFCS",
        "clearingBroker": "0161",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "IMCC",
        "clearingBroker": "0005",
        "brokerName": "IMC FINANCIAL MARKETS                                                 "
    },
    {
        "type": "UIT",
        "mpid": "IMPC",
        "clearingBroker": "0443",
        "brokerName": "IMPERIAL CAPITAL, LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "INCC",
        "clearingBroker": "0443",
        "brokerName": "SATURNA BROKERAGE SERVICES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "INFI",
        "clearingBroker": "0279",
        "brokerName": "INTEGRAL FINANCIAL, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "INGS",
        "clearingBroker": "0124",
        "brokerName": "INGALLS & SNYDER, LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "INNO",
        "clearingBroker": "0052",
        "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "INPI",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT PLANNERS INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "INPS",
        "clearingBroker": "0235",
        "brokerName": "INDEPENDENCE POINT SECURITIES LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "INTX",
        "clearingBroker": "0235",
        "brokerName": "INTERNATIONAL ASSETS ADVISORY, LLC                                    "
    },
    {
        "type": "UIT",
        "mpid": "IPGR",
        "clearingBroker": "0443",
        "brokerName": "INVESTMENT PLACEMENT GROUP                                            "
    },
    {
        "type": "UIT",
        "mpid": "IRMD",
        "clearingBroker": "0443",
        "brokerName": "PLANMEMBER SECURITIES CORP                                            "
    },
    {
        "type": "UIT",
        "mpid": "ISCN",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
    },
    {
        "type": "UIT",
        "mpid": "ISIG",
        "clearingBroker": "0226",
        "brokerName": "EVERCORE GROUP L.L.C.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "ISLL",
        "clearingBroker": "0052",
        "brokerName": "INLET SECURITIES LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "ISSI",
        "clearingBroker": "0052",
        "brokerName": "INSIGHT SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "ITAU",
        "clearingBroker": "0443",
        "brokerName": "ITAU BBA USA SECURITIES INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "ITCC",
        "clearingBroker": "0750",
        "brokerName": "STERNE AGEE FINANCIAL SERVICES, INC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "ITCM",
        "clearingBroker": "0443",
        "brokerName": "INTERCAM SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "ITFS",
        "clearingBroker": "0226",
        "brokerName": "KEEL POINT CAPITAL, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "IVEX",
        "clearingBroker": "0443",
        "brokerName": "INVEX, INC.                                                           "
    },
    {
        "type": "UIT",
        "mpid": "IVNT",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT NETWORK, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "IVOL",
        "clearingBroker": "0235",
        "brokerName": "UNION CAPITAL COMPANY                                                 "
    },
    {
        "type": "UIT",
        "mpid": "IVST",
        "clearingBroker": "0443",
        "brokerName": "INTERVEST INTERNATIONAL EQUITIES CORPORATION                          "
    },
    {
        "type": "UIT",
        "mpid": "JANY",
        "clearingBroker": "0374",
        "brokerName": "JANNEY MONTGOMERY SCOTT LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "JDRB",
        "clearingBroker": "0595",
        "brokerName": "J.H. DARBIE & CO., INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "JEFF",
        "clearingBroker": "0019",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "UIT",
        "mpid": "JEFM",
        "clearingBroker": "0235",
        "brokerName": "JEFFREY MATTHEWS FINANCIAL GROUP, L.L.C.                              "
    },
    {
        "type": "UIT",
        "mpid": "JEVO",
        "clearingBroker": "0235",
        "brokerName": "ATIS, INC                                                             "
    },
    {
        "type": "UIT",
        "mpid": "JGUN",
        "clearingBroker": "0235",
        "brokerName": "JOSEPH GUNNAR & CO. LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "JHDR",
        "clearingBroker": "0052",
        "brokerName": "JH DARBIE & CO. INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "JJKE",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "JKFS",
        "clearingBroker": "0279",
        "brokerName": "J.K. FINANCIAL SERVICES INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "JKRC",
        "clearingBroker": "0443",
        "brokerName": "J.K.R. & CO., INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "JLEQ",
        "clearingBroker": "0161",
        "brokerName": "JUMP EXECUTION, LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "JMLS",
        "clearingBroker": "0235",
        "brokerName": "J.M LUMMIS SECURITIES, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "JNSN",
        "clearingBroker": "0443",
        "brokerName": "D A DAVIDSON                                                          "
    },
    {
        "type": "UIT",
        "mpid": "JNST",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "JPMS",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "JPPB",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "UIT",
        "mpid": "JQII",
        "clearingBroker": "0443",
        "brokerName": "THE GARBACZ GROUP                                                     "
    },
    {
        "type": "UIT",
        "mpid": "JRCO",
        "clearingBroker": "0226",
        "brokerName": "JOHNSON RICE & COMPANY L.L.C.                                         "
    },
    {
        "type": "UIT",
        "mpid": "JSAP",
        "clearingBroker": "8497",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "JSBA",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "JSCL",
        "clearingBroker": "0052",
        "brokerName": "JOSEPH STONE CAPITAL L.L.C.                                           "
    },
    {
        "type": "UIT",
        "mpid": "JSCT",
        "clearingBroker": "0005",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "JSEG",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
    },
    {
        "type": "UIT",
        "mpid": "JSSF",
        "clearingBroker": "0226",
        "brokerName": "JMP SECURITIES LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "JVBF",
        "clearingBroker": "0235",
        "brokerName": "JACK V. BUTTERFIELD INVESTMENT COMPANY                                "
    },
    {
        "type": "UIT",
        "mpid": "JVBG",
        "clearingBroker": "0443",
        "brokerName": "J.V.B. FINANCIAL GROUP LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "JWCF",
        "clearingBroker": "0226",
        "brokerName": "J. W. COLE FINANCIAL, INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "JWML",
        "clearingBroker": "0235",
        "brokerName": "MILLEGAN (J.W.), INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "KALS",
        "clearingBroker": "0235",
        "brokerName": "KALOS CAPITAL, INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "KAPG",
        "clearingBroker": "0158",
        "brokerName": "KAPITALL GENERATION, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "KART",
        "clearingBroker": "0750",
        "brokerName": "REVERE SECURITIES CORP.                                               "
    },
    {
        "type": "UIT",
        "mpid": "KAWM",
        "clearingBroker": "0443",
        "brokerName": "ARETE WEALTH MANAGEMENT, LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "KBCO",
        "clearingBroker": "0443",
        "brokerName": "KAHN BROTHERS LLC                                                     "
    },
    {
        "type": "UIT",
        "mpid": "KCAM",
        "clearingBroker": "0052",
        "brokerName": "K2 CAPITAL ASSET MANAGEMENT, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "KCIM",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT MANAGEMENT CORPORATION                                     "
    },
    {
        "type": "UIT",
        "mpid": "KCIX",
        "clearingBroker": "0279",
        "brokerName": "KILEY PARTNERS, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "KCRD",
        "clearingBroker": "0052",
        "brokerName": "PHX FINANCIAL, INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "KEEN",
        "clearingBroker": "0279",
        "brokerName": "ST. BERNARD FINANCIAL SERVICES, INC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "KEYB",
        "clearingBroker": "0443",
        "brokerName": "KEYBANC CAPITAL MARKETS INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "KIML",
        "clearingBroker": "0226",
        "brokerName": "KIMELMAN & BAIRD, LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "KING",
        "clearingBroker": "0235",
        "brokerName": "C. L. KING & ASSOCIATES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "KISL",
        "clearingBroker": "0443",
        "brokerName": "KEY INVESTMENT SERVICES LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "KMSF",
        "clearingBroker": "0443",
        "brokerName": "KMS FINANCIAL SERVICES                                                "
    },
    {
        "type": "UIT",
        "mpid": "KNGS",
        "clearingBroker": "0235",
        "brokerName": "KINGSWOOD CAPITAL PARTNERS, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "KOVP",
        "clearingBroker": "0443",
        "brokerName": "KOVACK SECURITIES INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "KOVS",
        "clearingBroker": "0226",
        "brokerName": "KOVACK SECURITIES, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "KRCO",
        "clearingBroker": "0235",
        "brokerName": "KR SECURITIES, LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "KRSH",
        "clearingBroker": "0005",
        "brokerName": "KERSHNER SECURITIES, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "KRTH",
        "clearingBroker": "0235",
        "brokerName": "J.W. KORTH & COMPANY                                                  "
    },
    {
        "type": "UIT",
        "mpid": "LADY",
        "clearingBroker": "0443",
        "brokerName": "TRUSTFIRST, INC.                                                      "
    },
    {
        "type": "UIT",
        "mpid": "LAFB",
        "clearingBroker": "0235",
        "brokerName": "LAFFERTY (R.F.) & CO., INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "LAFC",
        "clearingBroker": "0443",
        "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "LAFF",
        "clearingBroker": "0443",
        "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "LAGI",
        "clearingBroker": "0226",
        "brokerName": "ALLSTATE FINANCIAL SERVICES, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "LANE",
        "clearingBroker": "0235",
        "brokerName": "MARC J. LANE & COMPANY                                                "
    },
    {
        "type": "UIT",
        "mpid": "LARC",
        "clearingBroker": "0235",
        "brokerName": "LARIMER CAPITAL CORPORATION                                           "
    },
    {
        "type": "UIT",
        "mpid": "LASI",
        "clearingBroker": "0141",
        "brokerName": "LIEBLONG & ASSOCIATES, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "LASS",
        "clearingBroker": "0226",
        "brokerName": "LASALLE ST. SECURITIES, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "LATN",
        "clearingBroker": "0443",
        "brokerName": "HEROLD & LANTERN INVESTMENTS, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "LBKI",
        "clearingBroker": "0235",
        "brokerName": "LIBUCKI & CO., LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "LDAS",
        "clearingBroker": "0443",
        "brokerName": "LANDAAS & CO.                                                         "
    },
    {
        "type": "UIT",
        "mpid": "LDIL",
        "clearingBroker": "0226",
        "brokerName": "LINCOLN DOUGLAS INVESTMENTS, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "LDLW",
        "clearingBroker": "0750",
        "brokerName": "LAIDLAW & COMPANY (UK) LTD.                                           "
    },
    {
        "type": "UIT",
        "mpid": "LDOT",
        "clearingBroker": "0235",
        "brokerName": "LANDOLT SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "LEAD",
        "clearingBroker": "0226",
        "brokerName": "THE LEADERS GROUP, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "LEBO",
        "clearingBroker": "0226",
        "brokerName": "LEIGH BALDWIN & CO., LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "LEER",
        "clearingBroker": "0443",
        "brokerName": "LEERINK SWANN & COMPANY                                               "
    },
    {
        "type": "UIT",
        "mpid": "LENX",
        "clearingBroker": "0279",
        "brokerName": "LENOX FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "LEXI",
        "clearingBroker": "0226",
        "brokerName": "LEXINGTON INVESTMENT COMPANY, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "LEYA",
        "clearingBroker": "0235",
        "brokerName": "LEMLEY, YARLING & CO.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "LFAC",
        "clearingBroker": "0226",
        "brokerName": "OSAIC FA, INC.                                                        "
    },
    {
        "type": "UIT",
        "mpid": "LFRO",
        "clearingBroker": "0235",
        "brokerName": "LF ROTHSCHILD, LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "LGNT",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "UIT",
        "mpid": "LGSA",
        "clearingBroker": "0158",
        "brokerName": "WOORI INVESTMENT AND SECURITIES AMERICA, INC.                         "
    },
    {
        "type": "UIT",
        "mpid": "LIIS",
        "clearingBroker": "0226",
        "brokerName": "USAA FINANCIAL ADVISORS, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "LINC",
        "clearingBroker": "0158",
        "brokerName": "LIBERUM                                                               "
    },
    {
        "type": "UIT",
        "mpid": "LISI",
        "clearingBroker": "0443",
        "brokerName": "LEUMI INVESTMENT SERVICES, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "LMAR",
        "clearingBroker": "0226",
        "brokerName": "LIFEMARK SECURITIES CORP.                                             "
    },
    {
        "type": "UIT",
        "mpid": "LMBD",
        "clearingBroker": "0443",
        "brokerName": "LAZARD ASSET MANAGEMENT SECURITIES LLC                                "
    },
    {
        "type": "UIT",
        "mpid": "LMKO",
        "clearingBroker": "0235",
        "brokerName": "KOHN (L.M.) & COMPANY                                                 "
    },
    {
        "type": "UIT",
        "mpid": "LMNX",
        "clearingBroker": "0226",
        "brokerName": "LUMINEX TRADING & ANALYTICS LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "LNCL",
        "clearingBroker": "0443",
        "brokerName": "LINCOLN INVESTMENT                                                    "
    },
    {
        "type": "UIT",
        "mpid": "LNKS",
        "clearingBroker": "0443",
        "brokerName": "GUGGENHEIM SECURITIES, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "LOMB",
        "clearingBroker": "0141",
        "brokerName": "LOMBARD SECURITIES INCORPORATED                                       "
    },
    {
        "type": "UIT",
        "mpid": "LOOP",
        "clearingBroker": "0443",
        "brokerName": "LOOP CAPITAL MARKETS, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "LOUE",
        "clearingBroker": "0161",
        "brokerName": "ICAP CORPORATES LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "LOUI",
        "clearingBroker": "0005",
        "brokerName": "LOUIS CAPITAL MARKETS, LP                                             "
    },
    {
        "type": "UIT",
        "mpid": "LPFS",
        "clearingBroker": "0235",
        "brokerName": "LIBERTY PARTNERS FINANCIAL SERVICES, INC.                             "
    },
    {
        "type": "UIT",
        "mpid": "LPLE",
        "clearingBroker": "0075",
        "brokerName": "LPL ENTERPRISE, LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "LQNA",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "UIT",
        "mpid": "LQNB",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "UIT",
        "mpid": "LQNF",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "UIT",
        "mpid": "LQNT",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "UIT",
        "mpid": "LQPT",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "LRBC",
        "clearingBroker": "0235",
        "brokerName": "LIBERTY ASSOCIATES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "LRCM",
        "clearingBroker": "0279",
        "brokerName": "LOCKTON RE CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "LSCM",
        "clearingBroker": "0235",
        "brokerName": "LAKE STREET CAPITAL MARKETS, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "LSFB",
        "clearingBroker": "0443",
        "brokerName": "LION STREET FINANCIAL, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "LSKO",
        "clearingBroker": "0226",
        "brokerName": "LESKO SECURITIES INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "LSPI",
        "clearingBroker": "0141",
        "brokerName": "LAFAYETTE INVESTMENTS                                                 "
    },
    {
        "type": "UIT",
        "mpid": "LSSI",
        "clearingBroker": "0750",
        "brokerName": "EJ STERLING INC.                                                      "
    },
    {
        "type": "UIT",
        "mpid": "LSUS",
        "clearingBroker": "0443",
        "brokerName": "LATIN SECURITIES INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "LTAA",
        "clearingBroker": "0226",
        "brokerName": "LUMINEX TRADING & ANALYTICS LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "LTCO",
        "clearingBroker": "0226",
        "brokerName": "LADENBURG, THALMANN & CO., INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "LVAR",
        "clearingBroker": "0443",
        "brokerName": "LARRAINVIAL SECURITIES US LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "LVMR",
        "clearingBroker": "0235",
        "brokerName": "LIVERMORE TRADING GROUP, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "LWFL",
        "clearingBroker": "0443",
        "brokerName": "LAWSON FINANCIAL CORPORATION                                          "
    },
    {
        "type": "UIT",
        "mpid": "LYSI",
        "clearingBroker": "0443",
        "brokerName": "LLOYDS SECURITIES INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "MACC",
        "clearingBroker": "0226",
        "brokerName": "NEWEDGE SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "MADV",
        "clearingBroker": "0443",
        "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "MAMA",
        "clearingBroker": "0443",
        "brokerName": "SECUREVEST FINANCIAL GROUP                                            "
    },
    {
        "type": "UIT",
        "mpid": "MAPA",
        "clearingBroker": "0279",
        "brokerName": "MADISON PAIGE SECURITIES LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "MASE",
        "clearingBroker": "0141",
        "brokerName": "MANAGED ACCOUNT SERVICES, LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "MAVS",
        "clearingBroker": "0443",
        "brokerName": "MADISON AVENUE SECURITIES                                             "
    },
    {
        "type": "UIT",
        "mpid": "MAXM",
        "clearingBroker": "0443",
        "brokerName": "MAXIM GROUP LLC                                                       "
    },
    {
        "type": "UIT",
        "mpid": "MBBS",
        "clearingBroker": "0443",
        "brokerName": "INFINEX INVESTMENTS                                                   "
    },
    {
        "type": "UIT",
        "mpid": "MBSE",
        "clearingBroker": "0052",
        "brokerName": "MBS SOURCE ETRADING, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "MBSL",
        "clearingBroker": "0443",
        "brokerName": "MBS CAPITAL MARKETS, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "MBUS",
        "clearingBroker": "0052",
        "brokerName": "MEDIOBANCA SECURITIES USA LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "MCAP",
        "clearingBroker": "1043",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "UIT",
        "mpid": "MCBT",
        "clearingBroker": "0235",
        "brokerName": "MOORS & CABOT, INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "MCCL",
        "clearingBroker": "0443",
        "brokerName": "MCCLURG CAPITAL CORPORATION                                           "
    },
    {
        "type": "UIT",
        "mpid": "MCNA",
        "clearingBroker": "0443",
        "brokerName": "MCNALLY FINANCIAL SERVICES CORPORATION                                "
    },
    {
        "type": "UIT",
        "mpid": "MDGP",
        "clearingBroker": "0235",
        "brokerName": "MD GLOBAL PARTNERS, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "MEAL",
        "clearingBroker": "0226",
        "brokerName": "M. E. ALLISON & CO., INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "MERP",
        "clearingBroker": "0235",
        "brokerName": "MERIDIAN EQUITY PARTNERS, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "MERQ",
        "clearingBroker": "0052",
        "brokerName": "MERCATOR ASSOCIATES LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "MESF",
        "clearingBroker": "0443",
        "brokerName": "MESIROW FINANCIAL, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "MFGX",
        "clearingBroker": "0443",
        "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "MFRS",
        "clearingBroker": "0443",
        "brokerName": "MFR SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "MHFI",
        "clearingBroker": "0226",
        "brokerName": "M HOLDINGS SECURITIES, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "MHSI",
        "clearingBroker": "0443",
        "brokerName": "M HOLDINGS SECURITIES                                                 "
    },
    {
        "type": "UIT",
        "mpid": "MIAM",
        "clearingBroker": "0141",
        "brokerName": "FMSBONDS, INC.                                                        "
    },
    {
        "type": "UIT",
        "mpid": "MIBS",
        "clearingBroker": "0443",
        "brokerName": "BMO HARRIS FINANCIAL ADVISORS                                         "
    },
    {
        "type": "UIT",
        "mpid": "MIFI",
        "clearingBroker": "0226",
        "brokerName": "MILKIE FERGUSON INVESTMENTS, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "MILE",
        "clearingBroker": "0052",
        "brokerName": "I-BANKERS SECURITIES INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "MILN",
        "clearingBroker": "1767",
        "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "MINP",
        "clearingBroker": "0235",
        "brokerName": "MINISTRY PARTNERS SECURITIES, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "MINV",
        "clearingBroker": "0235",
        "brokerName": "MACK INVESTMENTS SECURITIES, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "MIRA",
        "clearingBroker": "1043",
        "brokerName": "MIRAE ASSET SECURITIES (USA) INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "MITR",
        "clearingBroker": "0443",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "MJDW",
        "clearingBroker": "0279",
        "brokerName": "MURRAY SECURITIES                                                     "
    },
    {
        "type": "UIT",
        "mpid": "MJWH",
        "clearingBroker": "0235",
        "brokerName": "ETICO PARTNERS LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "MKRT",
        "clearingBroker": "0235",
        "brokerName": "MARKET SECURITIES, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "MKTI",
        "clearingBroker": "0226",
        "brokerName": "U.S. BANCORP ADVISORS, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "MKTX",
        "clearingBroker": "4265",
        "brokerName": "MARKETAXESS CORPORATION                                               "
    },
    {
        "type": "UIT",
        "mpid": "MKTY",
        "clearingBroker": "4265",
        "brokerName": "MARKETAXESS CORPORATION                                               "
    },
    {
        "type": "UIT",
        "mpid": "MLCO",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "MLMS",
        "clearingBroker": "0279",
        "brokerName": "MAINLINE WEST MUNICIPAL SECURITIES, LLC                               "
    },
    {
        "type": "UIT",
        "mpid": "MLWM",
        "clearingBroker": "0671",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "UIT",
        "mpid": "MMCS",
        "clearingBroker": "0443",
        "brokerName": "MMC SECURITIES CORP.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "MNCC",
        "clearingBroker": "0443",
        "brokerName": "MONEY CONCEPTS CAPITAL CORP.                                          "
    },
    {
        "type": "UIT",
        "mpid": "MNCO",
        "clearingBroker": "0279",
        "brokerName": "NELSON (MARTIN) & CO., INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "MNRC",
        "clearingBroker": "0443",
        "brokerName": "MONARCH CAPITAL GROUP LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "MNXS",
        "clearingBroker": "0443",
        "brokerName": "MUNIAXIS LEBENTHAL LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "MOCM",
        "clearingBroker": "0235",
        "brokerName": "MORETON CAPITAL MARKETS, LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "MOFI",
        "clearingBroker": "0158",
        "brokerName": "M1 FINANCE LLC                                                        "
    },
    {
        "type": "UIT",
        "mpid": "MOIS",
        "clearingBroker": "0443",
        "brokerName": "MUTUAL OF OMAHA INVESTOR SERVICES INC.                                "
    },
    {
        "type": "UIT",
        "mpid": "MOLO",
        "clearingBroker": "0235",
        "brokerName": "MOLONEY SECURITIES                                                    "
    },
    {
        "type": "UIT",
        "mpid": "MONE",
        "clearingBroker": "0443",
        "brokerName": "MONERE INVESTMENTS, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "MONR",
        "clearingBroker": "0226",
        "brokerName": "MONROE FINANCIAL PARTNERS, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "MONX",
        "clearingBroker": "0443",
        "brokerName": "MONEX SECURITIES INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "MORA",
        "clearingBroker": "0443",
        "brokerName": "MORA WM SECURITIES                                                    "
    },
    {
        "type": "UIT",
        "mpid": "MPLW",
        "clearingBroker": "0226",
        "brokerName": "MAPLEWOOD INVESTMENT ADVISORS, INC.                                   "
    },
    {
        "type": "UIT",
        "mpid": "MRAD",
        "clearingBroker": "0052",
        "brokerName": "MACRO RISK ADVISORS LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "MRBA",
        "clearingBroker": "0052",
        "brokerName": "IBN FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "MRIS",
        "clearingBroker": "0443",
        "brokerName": "BMO HARRIS FINANCIAL ADVISORS                                         "
    },
    {
        "type": "UIT",
        "mpid": "MRKS",
        "clearingBroker": "0443",
        "brokerName": "M. RAMSEY KING                                                        "
    },
    {
        "type": "UIT",
        "mpid": "MRNA",
        "clearingBroker": "0161",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "MRPH",
        "clearingBroker": "0226",
        "brokerName": "WM FINANCIAL SERVICES, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "MRSC",
        "clearingBroker": "0287",
        "brokerName": "TRADEUP SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "MSCB",
        "clearingBroker": "0279",
        "brokerName": "MAINE SECURITIES CORPORATION                                          "
    },
    {
        "type": "UIT",
        "mpid": "MSEC",
        "clearingBroker": "0235",
        "brokerName": "MSEC, LLC                                                             "
    },
    {
        "type": "UIT",
        "mpid": "MSII",
        "clearingBroker": "0226",
        "brokerName": "MSI FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "MSRO",
        "clearingBroker": "0226",
        "brokerName": "MESIROW FINANCIAL, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "MSTC",
        "clearingBroker": "0226",
        "brokerName": "MIDWESTERN SECURITIES TRADING COMPANY, LLC                            "
    },
    {
        "type": "UIT",
        "mpid": "MTBK",
        "clearingBroker": "0443",
        "brokerName": "MULTI-BANK SECURITIES, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "MTDB",
        "clearingBroker": "0443",
        "brokerName": "M&T SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "MTGO",
        "clearingBroker": "0158",
        "brokerName": "MTG, LLC                                                              "
    },
    {
        "type": "UIT",
        "mpid": "MTHN",
        "clearingBroker": "0005",
        "brokerName": "MARATHON TRADING GROUP LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "MTLE",
        "clearingBroker": "0235",
        "brokerName": "MTL EQUITY PRODUCTS, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "MTSL",
        "clearingBroker": "0226",
        "brokerName": "MSEC, LLC                                                             "
    },
    {
        "type": "UIT",
        "mpid": "MUFG",
        "clearingBroker": "0076",
        "brokerName": "MUFG SECURITIES AMERICAS INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "MULT",
        "clearingBroker": "0443",
        "brokerName": "MULTI-FINANCIAL SECURITIES GROUP                                      "
    },
    {
        "type": "UIT",
        "mpid": "MURJ",
        "clearingBroker": "0750",
        "brokerName": "COMMERCE ONE FINANCIAL INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "MWAF",
        "clearingBroker": "0443",
        "brokerName": "MWA FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "MWCC",
        "clearingBroker": "0235",
        "brokerName": "MONNESS CRESPI HARDT & CO., INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "MWIL",
        "clearingBroker": "0235",
        "brokerName": "MORGAN WILSHIRE SECURITIES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "MWMS",
        "clearingBroker": "0443",
        "brokerName": "MUREX CAPITAL LLC                                                     "
    },
    {
        "type": "UIT",
        "mpid": "MZHO",
        "clearingBroker": "2396",
        "brokerName": "MIZUHO SECURITIES USA LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "NACM",
        "clearingBroker": "0161",
        "brokerName": "NABSECURITIES, LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "NADL",
        "clearingBroker": "0235",
        "brokerName": "WARREN D. NADEL & COMPANY                                             "
    },
    {
        "type": "UIT",
        "mpid": "NAPK",
        "clearingBroker": "0052",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "UIT",
        "mpid": "NASC",
        "clearingBroker": "0235",
        "brokerName": "NATALLIANCE SECURITIES, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "NAVC",
        "clearingBroker": "0235",
        "brokerName": "NAVIAN CAPITAL SECURITIES LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "NBAR",
        "clearingBroker": "0226",
        "brokerName": "NANCY BARRON & ASSOCIATES, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "NBCS",
        "clearingBroker": "0235",
        "brokerName": "NBC SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "NBLB",
        "clearingBroker": "0226",
        "brokerName": "NEUBERGER BERMAN BD LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "NBSL",
        "clearingBroker": "0226",
        "brokerName": "BMO NESBITT BURNS SECURITIES LTD.                                     "
    },
    {
        "type": "UIT",
        "mpid": "NEED",
        "clearingBroker": "0443",
        "brokerName": "NEEDHAM & COMPANY, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "NEPP",
        "clearingBroker": "0226",
        "brokerName": "N.E. PRIVATE CLIENT ADVISORS, LTD.                                    "
    },
    {
        "type": "UIT",
        "mpid": "NEST",
        "clearingBroker": "0235",
        "brokerName": "NEST INVESTMENTS BD LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "NEXT",
        "clearingBroker": "0443",
        "brokerName": "NEXT FINANCIAL GROUP, INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "NFGR",
        "clearingBroker": "0141",
        "brokerName": "NATIONS FINANCIAL GROUP, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "NFSC",
        "clearingBroker": "0226",
        "brokerName": "NATIONAL FINANCIAL SERVICES LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "NFTY",
        "clearingBroker": "0235",
        "brokerName": "INFINITY FINANCIAL SERVICES                                           "
    },
    {
        "type": "UIT",
        "mpid": "NHFS",
        "clearingBroker": "0443",
        "brokerName": "ALIGHT FINANCIAL SOLUTIONS, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "NHWI",
        "clearingBroker": "0141",
        "brokerName": "HENNION & WALSH, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "NIAD",
        "clearingBroker": "0052",
        "brokerName": "NI ADVISORS                                                           "
    },
    {
        "type": "UIT",
        "mpid": "NITE",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "NLOV",
        "clearingBroker": "0279",
        "brokerName": "NORTLOV SECURITIES LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "NOBL",
        "clearingBroker": "0750",
        "brokerName": "NOBLE FINANCIAL CAPITAL MARKETS                                       "
    },
    {
        "type": "UIT",
        "mpid": "NORC",
        "clearingBroker": "0235",
        "brokerName": "NORTHERN CAPITAL SEC. CORP.                                           "
    },
    {
        "type": "UIT",
        "mpid": "NORP",
        "clearingBroker": "0443",
        "brokerName": "PARETO SECURITIES INC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "NORT",
        "clearingBroker": "0443",
        "brokerName": "NORTHLAND SECURITIES, INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "NOSO",
        "clearingBroker": "0443",
        "brokerName": "NORTH SOUTH CAPITAL LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "NPAI",
        "clearingBroker": "0443",
        "brokerName": "NATIONWIDE PLANNING ASSOCIATES                                        "
    },
    {
        "type": "UIT",
        "mpid": "NPBF",
        "clearingBroker": "0443",
        "brokerName": "NPB FINANCIAL GROUP, LLC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "NPNT",
        "clearingBroker": "0005",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "NPTP",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "NRAM",
        "clearingBroker": "0443",
        "brokerName": "CANACCORD WEALTH MANAGEMENT (USA) INC.                                "
    },
    {
        "type": "UIT",
        "mpid": "NSFP",
        "clearingBroker": "0235",
        "brokerName": "NORTHSTAR FINANCIAL PARTNERS, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "NSRD",
        "clearingBroker": "0235",
        "brokerName": "NESTLERODE & CO., INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "NTFN",
        "clearingBroker": "0052",
        "brokerName": "NETWORK 1 FINANCIAL SECURITIES INC.                                   "
    },
    {
        "type": "UIT",
        "mpid": "NTRC",
        "clearingBroker": "0226",
        "brokerName": "NORTHERN TRUST SECURITIES, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "NTSI",
        "clearingBroker": "0443",
        "brokerName": "NESBITT THOMSON SECURITIES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "NVEN",
        "clearingBroker": "0448",
        "brokerName": "NUVEEN SECURITIES, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "NWCM",
        "clearingBroker": "0235",
        "brokerName": "NW CAPITAL MARKETS INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "NWIA",
        "clearingBroker": "0750",
        "brokerName": "NORTHWEST INVESTMENT ADVISORS, INC.                                   "
    },
    {
        "type": "UIT",
        "mpid": "NWML",
        "clearingBroker": "0443",
        "brokerName": "NORTHWESTERN MUTUAL INVESTMENT SERVICES, LLC                          "
    },
    {
        "type": "UIT",
        "mpid": "NYLS",
        "clearingBroker": "0226",
        "brokerName": "NYLIFE SECURITIES INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "OAKR",
        "clearingBroker": "0235",
        "brokerName": "THE OAK RIDGE FINANCIAL SERVICES GROUP, INC.                          "
    },
    {
        "type": "UIT",
        "mpid": "OBWS",
        "clearingBroker": "0226",
        "brokerName": "OBERWEIS SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "OCAC",
        "clearingBroker": "0235",
        "brokerName": "OLSON, CROSS & ALAMO LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "OCEA",
        "clearingBroker": "0052",
        "brokerName": "OCEAN FINANCIAL SERVICES, LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "OCON",
        "clearingBroker": "0103",
        "brokerName": "O'CONNOR & CO SECURITIES                                              "
    },
    {
        "type": "UIT",
        "mpid": "ODEO",
        "clearingBroker": "0388",
        "brokerName": "ODEON CAP                                                             "
    },
    {
        "type": "UIT",
        "mpid": "ODNC",
        "clearingBroker": "0235",
        "brokerName": "ODEON CAPITAL GROUP LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "OFGF",
        "clearingBroker": "0235",
        "brokerName": "OFG FINANCIAL SERVICES INC                                            "
    },
    {
        "type": "UIT",
        "mpid": "OLNE",
        "clearingBroker": "0279",
        "brokerName": "OLDEN LANE SECURITIES, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "OMSL",
        "clearingBroker": "0158",
        "brokerName": "OM SECURITIES, LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "ONES",
        "clearingBroker": "0443",
        "brokerName": "O N EQUITY SALES CO.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "OPCO",
        "clearingBroker": "0571",
        "brokerName": "OPPENHEIMER & CO. INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "ORTL",
        "clearingBroker": "0443",
        "brokerName": "ORIENTAL FINANCIAL SERVICES                                           "
    },
    {
        "type": "UIT",
        "mpid": "OTCN",
        "clearingBroker": "0158",
        "brokerName": "OTC LINK LLC                                                          "
    },
    {
        "type": "UIT",
        "mpid": "OYLD",
        "clearingBroker": "0235",
        "brokerName": "OPENYIELD TRADING LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "PACK",
        "clearingBroker": "0279",
        "brokerName": "PACKERLAND BROKERAGE SERVICES                                         "
    },
    {
        "type": "UIT",
        "mpid": "PACT",
        "clearingBroker": "0443",
        "brokerName": "BTG PACTUAL US CAPITAL LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "PAMC",
        "clearingBroker": "0226",
        "brokerName": "PROGRESSIVE ASSET MANAGEMENT                                          "
    },
    {
        "type": "UIT",
        "mpid": "PAPA",
        "clearingBroker": "0443",
        "brokerName": "PAPAMARKOU WELLNER & CO., INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "PARI",
        "clearingBroker": "0630",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "UIT",
        "mpid": "PASC",
        "clearingBroker": "0443",
        "brokerName": "PARK AVENUE SECURITIES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "PASL",
        "clearingBroker": "0443",
        "brokerName": "PERSHING ADVISOR SOLUTIONS, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "PATR",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "PAUL",
        "clearingBroker": "0595",
        "brokerName": "PAULSON INVESTMENT COMPANY, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "PBON",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "PCCA",
        "clearingBroker": "0279",
        "brokerName": "PEACHCAP SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "PCIS",
        "clearingBroker": "0226",
        "brokerName": "BANKOH INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "PCSB",
        "clearingBroker": "0443",
        "brokerName": "PRIVATE CLIENT SERVICES, LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "PENG",
        "clearingBroker": "0443",
        "brokerName": "PENNSYLVANIA GROUP INCORPORATED (THE)                                 "
    },
    {
        "type": "UIT",
        "mpid": "PERC",
        "clearingBroker": "0279",
        "brokerName": "PERCIVAL FINANCIAL PARTNERS, LTD.                                     "
    },
    {
        "type": "UIT",
        "mpid": "PERS",
        "clearingBroker": "0443",
        "brokerName": "PERSHING LLC                                                          "
    },
    {
        "type": "UIT",
        "mpid": "PFCG",
        "clearingBroker": "0279",
        "brokerName": "PREFERRED CLIENT GROUP, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "PFDC",
        "clearingBroker": "0235",
        "brokerName": "PREFERRED CAPITAL SECURITIES, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "PHBP",
        "clearingBroker": "0052",
        "brokerName": "PENNHAVEN BROKERAGE PARTNERS, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "PHIN",
        "clearingBroker": "0443",
        "brokerName": "PHILADELPHIA INVESTORS, LTD.                                          "
    },
    {
        "type": "UIT",
        "mpid": "PICE",
        "clearingBroker": "0443",
        "brokerName": "T ROWE PRICE INVESTMENT SERV                                          "
    },
    {
        "type": "UIT",
        "mpid": "PICI",
        "clearingBroker": "0279",
        "brokerName": "POLAR INVESTMENT COUNSEL, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "PICL",
        "clearingBroker": "0052",
        "brokerName": "PAULSON INVESTMENT COMPANY LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "PIMS",
        "clearingBroker": "0226",
        "brokerName": "PRUDENTIAL INVESTMENT MANAGEMENT SERVICES, LLC                        "
    },
    {
        "type": "UIT",
        "mpid": "PINA",
        "clearingBroker": "0141",
        "brokerName": "PINNACLE INVESTMENTS, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "PIPR",
        "clearingBroker": "0443",
        "brokerName": "PIPER SANDLER & CO.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "PIRR",
        "clearingBroker": "0443",
        "brokerName": "PIRRONE & CO., INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "PISC",
        "clearingBroker": "0750",
        "brokerName": "PACIFIC INVESTMENT SECURITIES CORP.                                   "
    },
    {
        "type": "UIT",
        "mpid": "PJEF",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "UIT",
        "mpid": "PKAX",
        "clearingBroker": "0158",
        "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "PLAT",
        "clearingBroker": "0443",
        "brokerName": "CLARKSONS PLATOU SECURITIES, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "PMAS",
        "clearingBroker": "0443",
        "brokerName": "PMA SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "PNCC",
        "clearingBroker": "0226",
        "brokerName": "PNC INVESTMENTS                                                       "
    },
    {
        "type": "UIT",
        "mpid": "PNCM",
        "clearingBroker": "2835",
        "brokerName": "PNC CAPITAL MARKETS LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "PNFP",
        "clearingBroker": "0279",
        "brokerName": "PNFP CAPITAL MARKETS, INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "PNSA",
        "clearingBroker": "0235",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "PODE",
        "clearingBroker": "0235",
        "brokerName": "PODESTA & CO.                                                         "
    },
    {
        "type": "UIT",
        "mpid": "POOH",
        "clearingBroker": "0443",
        "brokerName": "QUESTAR CAPITAL CORPORATION                                           "
    },
    {
        "type": "UIT",
        "mpid": "POPS",
        "clearingBroker": "0226",
        "brokerName": "POPULAR SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "POWL",
        "clearingBroker": "0443",
        "brokerName": "POWELL (ELMER E.) COMPANY                                             "
    },
    {
        "type": "UIT",
        "mpid": "PPSI",
        "clearingBroker": "0235",
        "brokerName": "PENSION PLANNERS SECURITIES, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "PPSL",
        "clearingBroker": "0413",
        "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "PREB",
        "clearingBroker": "0005",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "PRFA",
        "clearingBroker": "0235",
        "brokerName": "PROOF SERVICES LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "PRGI",
        "clearingBroker": "0443",
        "brokerName": "PORTFOLIO RESOURCES GROUP, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "PROE",
        "clearingBroker": "0443",
        "brokerName": "PROEQUITIES, INC.                                                     "
    },
    {
        "type": "UIT",
        "mpid": "PRPO",
        "clearingBroker": "0443",
        "brokerName": "PRIVATE PORTFOLIO, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "PRSB",
        "clearingBroker": "0141",
        "brokerName": "PRESIDENTIAL BROKERAGE, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "PSII",
        "clearingBroker": "0226",
        "brokerName": "KESTRA INVESTMENT SERVICES, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "PSIM",
        "clearingBroker": "0226",
        "brokerName": "PRINCIPAL SECURITIES, INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "PSIN",
        "clearingBroker": "0443",
        "brokerName": "LUMENT SECURITIES, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "PSUT",
        "clearingBroker": "0235",
        "brokerName": "INNOVATION PARTNERS LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "PTCM",
        "clearingBroker": "0443",
        "brokerName": "CAVU SECURITIES LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "PTIS",
        "clearingBroker": "0235",
        "brokerName": "PTI SECURITIES & FUTURES L.P.                                         "
    },
    {
        "type": "UIT",
        "mpid": "PUPL",
        "clearingBroker": "0226",
        "brokerName": "PUPLAVA SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "PWAS",
        "clearingBroker": "0443",
        "brokerName": "PWA SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "PWJC",
        "clearingBroker": "0221",
        "brokerName": "UBS FINANCIAL SERVICES INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "QBND",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "UIT",
        "mpid": "QBSI",
        "clearingBroker": "0226",
        "brokerName": "GLEN EAGLE WEALTH, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "QCAP",
        "clearingBroker": "0235",
        "brokerName": "QUINT CAPITAL CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "QCAS",
        "clearingBroker": "0226",
        "brokerName": "QUINCY CASS ASSOCIATES, INCORPORATED                                  "
    },
    {
        "type": "UIT",
        "mpid": "QMSR",
        "clearingBroker": "0235",
        "brokerName": "QUATTRO M SECURITIES INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "QWIK",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "UIT",
        "mpid": "RAAA",
        "clearingBroker": "0052",
        "brokerName": "RICHARD JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "RAAI",
        "clearingBroker": "0226",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "RABO",
        "clearingBroker": "0443",
        "brokerName": "RABO SECURITIES USA, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "RACO",
        "clearingBroker": "0158",
        "brokerName": "SHEARMAN, RALSTON, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "RAJA",
        "clearingBroker": "0725",
        "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "RAJC",
        "clearingBroker": "0443",
        "brokerName": "RAYMOND JAMES USA                                                     "
    },
    {
        "type": "UIT",
        "mpid": "RAYG",
        "clearingBroker": "0443",
        "brokerName": "BOLTON GLOBAL CAPITAL                                                 "
    },
    {
        "type": "UIT",
        "mpid": "RBAC",
        "clearingBroker": "0443",
        "brokerName": "ROBERT B. AUSDAL & CO. INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "RBCD",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "UIT",
        "mpid": "RBCM",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "UIT",
        "mpid": "RBCX",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "UIT",
        "mpid": "RBII",
        "clearingBroker": "0279",
        "brokerName": "REGIONAL BROKERS, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "RCMA",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS ARBITRAGE, S.A.                                   "
    },
    {
        "type": "UIT",
        "mpid": "RCRS",
        "clearingBroker": "0226",
        "brokerName": "ROOSEVELT & CROSS, INCORPORATED                                       "
    },
    {
        "type": "UIT",
        "mpid": "RDSS",
        "clearingBroker": "0141",
        "brokerName": "RDSC, LLC                                                             "
    },
    {
        "type": "UIT",
        "mpid": "REGR",
        "clearingBroker": "0141",
        "brokerName": "REGISTER & AKERS INVESTMENTS, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "RGLD",
        "clearingBroker": "0279",
        "brokerName": "REGAL SECURITIES, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "RGLS",
        "clearingBroker": "0235",
        "brokerName": "REGAL SECURITIES, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "RHDS",
        "clearingBroker": "0141",
        "brokerName": "RHODES SECURITIES, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "RHOX",
        "clearingBroker": "0005",
        "brokerName": "XR SECURITIES LLC                                                     "
    },
    {
        "type": "UIT",
        "mpid": "RIAP",
        "clearingBroker": "0443",
        "brokerName": "OSAIC SERVICES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "RICE",
        "clearingBroker": "0235",
        "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
    },
    {
        "type": "UIT",
        "mpid": "RICJ",
        "clearingBroker": "0235",
        "brokerName": "RICE SECURITIES, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "RICM",
        "clearingBroker": "0595",
        "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
    },
    {
        "type": "UIT",
        "mpid": "RIED",
        "clearingBroker": "0235",
        "brokerName": "RIEDL, FIRST SECURITIES COMPANY OF KANSAS                             "
    },
    {
        "type": "UIT",
        "mpid": "RILY",
        "clearingBroker": "0226",
        "brokerName": "B. RILEY FBR, INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "RJFI",
        "clearingBroker": "0390",
        "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "RKWS",
        "clearingBroker": "0235",
        "brokerName": "ROCKWELL SECURITIES LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "RLIN",
        "clearingBroker": "0005",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "RMAC",
        "clearingBroker": "0235",
        "brokerName": "RENAISSANCE MACRO SECURITIES, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "RMPI",
        "clearingBroker": "0141",
        "brokerName": "RICHARDS, MERRILL & PETERSON, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "RMST",
        "clearingBroker": "0443",
        "brokerName": "R.M. STARK & CO., INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "ROAR",
        "clearingBroker": "0103",
        "brokerName": "DINOSAUR SECURITIES                                                   "
    },
    {
        "type": "UIT",
        "mpid": "ROBT",
        "clearingBroker": "0443",
        "brokerName": "ROBOTTI & COMPANY, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "ROCK",
        "clearingBroker": "0226",
        "brokerName": "ROCKEFELLER FINANCIAL LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "ROCM",
        "clearingBroker": "0443",
        "brokerName": "RIM SECURITIES LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "ROMO",
        "clearingBroker": "0141",
        "brokerName": "ROMANO BROTHERS AND COMPANY                                           "
    },
    {
        "type": "UIT",
        "mpid": "RONI",
        "clearingBroker": "0005",
        "brokerName": "RONIN CAPITAL, LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "ROTB",
        "clearingBroker": "0235",
        "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "ROYL",
        "clearingBroker": "0443",
        "brokerName": "ROYAL ALLIANCE ASSOCIATES, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "RPTR",
        "clearingBroker": "0235",
        "brokerName": "DINOSAUR SECURITIES, L.L.C.                                           "
    },
    {
        "type": "UIT",
        "mpid": "RQDR",
        "clearingBroker": "0235",
        "brokerName": "RQD* CLEARING LLC                                                     "
    },
    {
        "type": "UIT",
        "mpid": "RREZ",
        "clearingBroker": "0443",
        "brokerName": "SAMUEL A RAMIREZ & CO., INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "RRUD",
        "clearingBroker": "0235",
        "brokerName": "REID & RUDIGER, LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "RSCM",
        "clearingBroker": "0235",
        "brokerName": "ROBERTSON STEPHENS CAPITAL MARKETS, LLC                               "
    },
    {
        "type": "UIT",
        "mpid": "RSSE",
        "clearingBroker": "0443",
        "brokerName": "RUSSELL IMPLEMENTATION SERVICES INC. PART OF RUSSE                    "
    },
    {
        "type": "UIT",
        "mpid": "RTHS",
        "clearingBroker": "0443",
        "brokerName": "ROTHSCHILD INVESTMENT CORPORATION                                     "
    },
    {
        "type": "UIT",
        "mpid": "RWPC",
        "clearingBroker": "0443",
        "brokerName": "R.W. PRESSPRICH & CO.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "RWSM",
        "clearingBroker": "0279",
        "brokerName": "R.W. SMITH & ASSOCIATES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "RYDS",
        "clearingBroker": "0235",
        "brokerName": "RBC DOMINION SECURITIES CORPORATION                                   "
    },
    {
        "type": "UIT",
        "mpid": "SABS",
        "clearingBroker": "0443",
        "brokerName": "SABADELL SECURITIES USA, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "SAFX",
        "clearingBroker": "0235",
        "brokerName": "SAF FINANCIAL SECURITIES LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "SAGE",
        "clearingBroker": "0141",
        "brokerName": "SAGE, RUTTY & CO., INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "SALI",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "SAMI",
        "clearingBroker": "0226",
        "brokerName": "SAMI BROKERAGE LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "SANT",
        "clearingBroker": "0443",
        "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "SAPA",
        "clearingBroker": "0141",
        "brokerName": "SAPERSTON ASSET MANAGEMENT INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "SARG",
        "clearingBroker": "0226",
        "brokerName": "PURSHE KAPLAN STERLING INVESTMENTS, INC.                              "
    },
    {
        "type": "UIT",
        "mpid": "SAXO",
        "clearingBroker": "0443",
        "brokerName": "SAXONY SECURITIES                                                     "
    },
    {
        "type": "UIT",
        "mpid": "SBAM",
        "clearingBroker": "0443",
        "brokerName": "INVESTMENT PROFESSIONALS, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "SBLS",
        "clearingBroker": "0235",
        "brokerName": "SAN BLAS SECURITIES LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "SBLT",
        "clearingBroker": "0226",
        "brokerName": "SUNBELT SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "SBRO",
        "clearingBroker": "0443",
        "brokerName": "STERN BROTHERS & CO.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "SBRT",
        "clearingBroker": "0226",
        "brokerName": "SIEBERT(MURIEL) & CO.,INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "SBRX",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "SBSC",
        "clearingBroker": "0226",
        "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
    },
    {
        "type": "UIT",
        "mpid": "SCAP",
        "clearingBroker": "0595",
        "brokerName": "STRONG CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "SCIL",
        "clearingBroker": "0052",
        "brokerName": "STRATEGIC CAPITAL INVESTMENTS, LLC                                    "
    },
    {
        "type": "UIT",
        "mpid": "SCSS",
        "clearingBroker": "0750",
        "brokerName": "STONECASTLE SECURITIES, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "SCTI",
        "clearingBroker": "0443",
        "brokerName": "SECURITY CAPITAL BROKERAGE, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "SCTL",
        "clearingBroker": "0443",
        "brokerName": "SENTINEL SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "SDDC",
        "clearingBroker": "0443",
        "brokerName": "SDDCO BROKERAGE AQDVISORS                                             "
    },
    {
        "type": "UIT",
        "mpid": "SDIC",
        "clearingBroker": "0235",
        "brokerName": "SAUER DAZEY INVESTMENT CO.                                            "
    },
    {
        "type": "UIT",
        "mpid": "SEAP",
        "clearingBroker": "0226",
        "brokerName": "SEAPORT SECURITIES CORP.                                              "
    },
    {
        "type": "UIT",
        "mpid": "SEBS",
        "clearingBroker": "0443",
        "brokerName": "SECU BROKERAGE SERVICES                                               "
    },
    {
        "type": "UIT",
        "mpid": "SEEL",
        "clearingBroker": "0443",
        "brokerName": "R. SEELAUS & CO., INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "SEFB",
        "clearingBroker": "0052",
        "brokerName": "SOUTHEAST INVESTMENTS, N.C., INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "SEIB",
        "clearingBroker": "0158",
        "brokerName": "SEIBERT (J.D.) & COMPANY INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "SEIC",
        "clearingBroker": "0443",
        "brokerName": "SEI INVESTMENTS DISTRIBUTION CO.                                      "
    },
    {
        "type": "UIT",
        "mpid": "SEMI",
        "clearingBroker": "0443",
        "brokerName": "SEMINARIO SECURITIES                                                  "
    },
    {
        "type": "UIT",
        "mpid": "SEND",
        "clearingBroker": "0443",
        "brokerName": "SENDERO SECURITIES                                                    "
    },
    {
        "type": "UIT",
        "mpid": "SERL",
        "clearingBroker": "0443",
        "brokerName": "SEARLE & CO.                                                          "
    },
    {
        "type": "UIT",
        "mpid": "SEVN",
        "clearingBroker": "0443",
        "brokerName": "NATIONWIDE SECURITIES                                                 "
    },
    {
        "type": "UIT",
        "mpid": "SFPS",
        "clearingBroker": "0443",
        "brokerName": "SF INVESTMENTS, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "SFSI",
        "clearingBroker": "0235",
        "brokerName": "SUPERIOR FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "SGAS",
        "clearingBroker": "0286",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "SGBI",
        "clearingBroker": "0226",
        "brokerName": "SMITH, BROWN & GROOVER, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "SGFC",
        "clearingBroker": "0226",
        "brokerName": "SIGMA FINANCIAL CORPORATION                                           "
    },
    {
        "type": "UIT",
        "mpid": "SGLC",
        "clearingBroker": "0235",
        "brokerName": "S.G. LONG & COMPANY                                                   "
    },
    {
        "type": "UIT",
        "mpid": "SGNL",
        "clearingBroker": "0279",
        "brokerName": "SIGNAL SECURITIES, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "SGSM",
        "clearingBroker": "1043",
        "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "SHMR",
        "clearingBroker": "0443",
        "brokerName": "ABN AMRO CLEARING USA LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "SHOT",
        "clearingBroker": "0005",
        "brokerName": "SCHOTTENFELD GROUP LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "SIAN",
        "clearingBroker": "0443",
        "brokerName": "SECURIAN FINANCIAL SERVICES                                           "
    },
    {
        "type": "UIT",
        "mpid": "SJGM",
        "clearingBroker": "0443",
        "brokerName": "SCOTT JAMES GROUP, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "SKTR",
        "clearingBroker": "0279",
        "brokerName": "STOCK TRADERS                                                         "
    },
    {
        "type": "UIT",
        "mpid": "SLRD",
        "clearingBroker": "0226",
        "brokerName": "S.L. REED & COMPANY                                                   "
    },
    {
        "type": "UIT",
        "mpid": "SMCO",
        "clearingBroker": "0235",
        "brokerName": "SMITH, MOORE & CO.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "SMHI",
        "clearingBroker": "0443",
        "brokerName": "SANDERS MORRIS HARRIS INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "SMNS",
        "clearingBroker": "0226",
        "brokerName": "PARKLAND SECURITIES, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "SMPR",
        "clearingBroker": "0443",
        "brokerName": "SUMMIT BROKERAGE SERVICES, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "SMRD",
        "clearingBroker": "0443",
        "brokerName": "SUMRIDGE PARTNERS, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "SMRI",
        "clearingBroker": "0226",
        "brokerName": "SECURITIES MANAGEMENT & RESEARCH, INC.                                "
    },
    {
        "type": "UIT",
        "mpid": "SNEX",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "SNWS",
        "clearingBroker": "0443",
        "brokerName": "SNOWDEN ACCOUNT SERVICES, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "SOCO",
        "clearingBroker": "0443",
        "brokerName": "CAPITAL ONE SECURITIES, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "SOFI",
        "clearingBroker": "0158",
        "brokerName": "SOFI SECURITIES LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "SOGO",
        "clearingBroker": "0158",
        "brokerName": "WANG INVESTMENT ASSOCIATES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "SORS",
        "clearingBroker": "0235",
        "brokerName": "SORSBY FINANCIAL CORP.                                                "
    },
    {
        "type": "UIT",
        "mpid": "SOVG",
        "clearingBroker": "8199",
        "brokerName": "SOVEREIGN GLOBAL ADVISORS, LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "SPCS",
        "clearingBroker": "0052",
        "brokerName": "SPARTAN CAPITAL SECURITIES, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "SPEX",
        "clearingBroker": "0235",
        "brokerName": "INSPEREX LLC                                                          "
    },
    {
        "type": "UIT",
        "mpid": "SPGS",
        "clearingBroker": "0443",
        "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "SPHN",
        "clearingBroker": "0443",
        "brokerName": "STEPHENS INC.                                                         "
    },
    {
        "type": "UIT",
        "mpid": "SPLC",
        "clearingBroker": "0226",
        "brokerName": "SPIRE SECURITIES, LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "SPLD",
        "clearingBroker": "0443",
        "brokerName": "SPIRE SECURITIES, LLC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "SPLN",
        "clearingBroker": "8199",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "SPOT",
        "clearingBroker": "0005",
        "brokerName": "SPOT TRADING                                                          "
    },
    {
        "type": "UIT",
        "mpid": "SPTD",
        "clearingBroker": "0052",
        "brokerName": "MINT GLOBAL MARKETS, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "SPTS",
        "clearingBroker": "0158",
        "brokerName": "SEVEN POINTS CAPITAL, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "SRAM",
        "clearingBroker": "0443",
        "brokerName": "SAMCO CAPITAL MARKETS, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "SRBC",
        "clearingBroker": "0235",
        "brokerName": "SPIDERROCK EXS, LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "SSBS",
        "clearingBroker": "0443",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "SSCO",
        "clearingBroker": "8457",
        "brokerName": "SAFRA SECURITIES LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "SSGC",
        "clearingBroker": "0226",
        "brokerName": "SIGNATURE SECURITIES                                                  "
    },
    {
        "type": "UIT",
        "mpid": "SSGM",
        "clearingBroker": "0226",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "SSGR",
        "clearingBroker": "0443",
        "brokerName": "SHAREHOLDERS SERVICES GROUP INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "SSIN",
        "clearingBroker": "0226",
        "brokerName": "TRUIST INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "SSLL",
        "clearingBroker": "0189",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "SSNE",
        "clearingBroker": "0226",
        "brokerName": "SANTANDER SECURITIES LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "SSNG",
        "clearingBroker": "0443",
        "brokerName": "SISUNG SECURITIES CORPORATION                                         "
    },
    {
        "type": "UIT",
        "mpid": "STCM",
        "clearingBroker": "2095",
        "brokerName": "TRUIST SECURITIES, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "STEP",
        "clearingBroker": "0235",
        "brokerName": "FERRETTI GROUP, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "STFC",
        "clearingBroker": "0443",
        "brokerName": "STUART FRANKEL & CO., INCORPORATED                                    "
    },
    {
        "type": "UIT",
        "mpid": "STFG",
        "clearingBroker": "0443",
        "brokerName": "STANFORD GROUP COMPANY                                                "
    },
    {
        "type": "UIT",
        "mpid": "STFL",
        "clearingBroker": "0793",
        "brokerName": "STIFEL, NICOLAUS & COMPANY, INCORPORATED                              "
    },
    {
        "type": "UIT",
        "mpid": "STGC",
        "clearingBroker": "0279",
        "brokerName": "STERLING GRACE MUNICIPAL SECURITIES CO                                "
    },
    {
        "type": "UIT",
        "mpid": "STKP",
        "clearingBroker": "0158",
        "brokerName": "STOCKPILE INVESTMENTS, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "STND",
        "clearingBroker": "0279",
        "brokerName": "FIRST STANDARD FINANCIAL COMPANY LLC                                  "
    },
    {
        "type": "UIT",
        "mpid": "STOX",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "STRM",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "UIT",
        "mpid": "STSM",
        "clearingBroker": "0443",
        "brokerName": "STERLING SMITH CORPORATION                                            "
    },
    {
        "type": "UIT",
        "mpid": "STTT",
        "clearingBroker": "0052",
        "brokerName": "STATETRUST INVESTMENTS INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "STUR",
        "clearingBroker": "0158",
        "brokerName": "STURDIVANT & CO., INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "STXG",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "STXW",
        "clearingBroker": "0443",
        "brokerName": "SA STONE WEALTH MANAGEMENT INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "SUMI",
        "clearingBroker": "0443",
        "brokerName": "SMBC NIKKO SECURITIES AMERICA, INC.                                   "
    },
    {
        "type": "UIT",
        "mpid": "SUST",
        "clearingBroker": "0235",
        "brokerName": "SUNSTREET SECURITIES, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "SWBC",
        "clearingBroker": "0443",
        "brokerName": "SWBC INVESTMENT SERVICES, LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "SWSS",
        "clearingBroker": "0443",
        "brokerName": "SANCTUARY SECURITIES, INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "SWST",
        "clearingBroker": "0279",
        "brokerName": "HILLTOP SECURITIES INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "SYCA",
        "clearingBroker": "0443",
        "brokerName": "SYNDICATED CAPITAL, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "TAFI",
        "clearingBroker": "0443",
        "brokerName": "NATHAN HALE CAPITAL, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "TAGB",
        "clearingBroker": "0052",
        "brokerName": "TAGLICH BROTHERS, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "TAGC",
        "clearingBroker": "1043",
        "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "TAGD",
        "clearingBroker": "1043",
        "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "TBCL",
        "clearingBroker": "0750",
        "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "TBCR",
        "clearingBroker": "0235",
        "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "TBIA",
        "clearingBroker": "0158",
        "brokerName": "TRADIER BROKERAGE, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "TBIS",
        "clearingBroker": "0158",
        "brokerName": "TRADIER BROKERAGE, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "TBRD",
        "clearingBroker": "0226",
        "brokerName": "THOROUGHBRED FINANCIAL SERVICES, LLC                                  "
    },
    {
        "type": "UIT",
        "mpid": "TCBI",
        "clearingBroker": "0443",
        "brokerName": "TCBI SECURITIES, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "TDCO",
        "clearingBroker": "0235",
        "brokerName": "THOMPSON DAVIS & CO., INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "TDFS",
        "clearingBroker": "0052",
        "brokerName": "TRADERFIELD SECURITIES INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "TDNF",
        "clearingBroker": "2568",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "TDPA",
        "clearingBroker": "0226",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "TDPW",
        "clearingBroker": "0443",
        "brokerName": "TD PRIVATE CLIENT WEALTH, LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "TDSI",
        "clearingBroker": "2568",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "TERA",
        "clearingBroker": "0443",
        "brokerName": "CETERA FINANCIAL SPECIALISTS                                          "
    },
    {
        "type": "UIT",
        "mpid": "TFAI",
        "clearingBroker": "0226",
        "brokerName": "TRANSAMERICA FINANCIAL ADVISORS, INC.                                 "
    },
    {
        "type": "UIT",
        "mpid": "TFAS",
        "clearingBroker": "0443",
        "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
    },
    {
        "type": "UIT",
        "mpid": "TFSL",
        "clearingBroker": "0235",
        "brokerName": "TECKMEYER FINANCIAL SERVICES                                          "
    },
    {
        "type": "UIT",
        "mpid": "TFSS",
        "clearingBroker": "0443",
        "brokerName": "TFS SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "TGHS",
        "clearingBroker": "0443",
        "brokerName": "TGH SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "THEM",
        "clearingBroker": "0235",
        "brokerName": "THEMIS TRADING LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "THNK",
        "clearingBroker": "0052",
        "brokerName": "THINKEQUITY, LLC                                                      "
    },
    {
        "type": "UIT",
        "mpid": "TIAN",
        "clearingBroker": "0226",
        "brokerName": "TRIAD SECURITIES CORP                                                 "
    },
    {
        "type": "UIT",
        "mpid": "TIGC",
        "clearingBroker": "0235",
        "brokerName": "NELSONREID, INC.                                                      "
    },
    {
        "type": "UIT",
        "mpid": "TKGA",
        "clearingBroker": "0226",
        "brokerName": "KELT (THE) GROUP, LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "TKNG",
        "clearingBroker": "0158",
        "brokerName": "TRADEKING LLC                                                         "
    },
    {
        "type": "UIT",
        "mpid": "TMAS",
        "clearingBroker": "0235",
        "brokerName": "TRADEMAS INC.                                                         "
    },
    {
        "type": "UIT",
        "mpid": "TMCC",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "UIT",
        "mpid": "TMCD",
        "clearingBroker": "0235",
        "brokerName": "MCDONALD PARTNERS LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "TOCQ",
        "clearingBroker": "0443",
        "brokerName": "TOCQUEVILLE SECURITIES L.P.                                           "
    },
    {
        "type": "UIT",
        "mpid": "TOUR",
        "clearingBroker": "0005",
        "brokerName": "TOURMALINE PARTNERS, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "TOYS",
        "clearingBroker": "0443",
        "brokerName": "TOYOTA FINANCIAL SERVICES SECURITIES USA CORPORATION                  "
    },
    {
        "type": "UIT",
        "mpid": "TPIS",
        "clearingBroker": "0161",
        "brokerName": "TULLETT PREBON FINANCIAL SERVICES, LLC                                "
    },
    {
        "type": "UIT",
        "mpid": "TPMR",
        "clearingBroker": "0141",
        "brokerName": "TRADE-PMR INC.                                                        "
    },
    {
        "type": "UIT",
        "mpid": "TRAD",
        "clearingBroker": "0271",
        "brokerName": "TRADESTATION SECURITIES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "TRCG",
        "clearingBroker": "0005",
        "brokerName": "TRC MARKETS LLC                                                       "
    },
    {
        "type": "UIT",
        "mpid": "TRCS",
        "clearingBroker": "0388",
        "brokerName": "TIGERRISK CAPITAL MARKETS & ADVISORY                                  "
    },
    {
        "type": "UIT",
        "mpid": "TREX",
        "clearingBroker": "1043",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "UIT",
        "mpid": "TRIB",
        "clearingBroker": "0235",
        "brokerName": "TRIBAL CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "TRIP",
        "clearingBroker": "0235",
        "brokerName": "TRIDENT PARTNERS LTD                                                  "
    },
    {
        "type": "UIT",
        "mpid": "TRSH",
        "clearingBroker": "0279",
        "brokerName": "THRASHER & CHAMBERS, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "TRUB",
        "clearingBroker": "0141",
        "brokerName": "TRUBEE, COLLINS & CO., INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "TRWN",
        "clearingBroker": "0443",
        "brokerName": "T.R. WINSTON & COMPANY, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "TRYC",
        "clearingBroker": "0158",
        "brokerName": "SIXTEEN SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "TRYN",
        "clearingBroker": "0279",
        "brokerName": "FIRST TRYON SECURITIES, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "TSCD",
        "clearingBroker": "0235",
        "brokerName": "STURGES COMPANY (THE)                                                 "
    },
    {
        "type": "UIT",
        "mpid": "TSER",
        "clearingBroker": "0161",
        "brokerName": "TWO SIGMA EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "TSFA",
        "clearingBroker": "0443",
        "brokerName": "STRATEGIC FINANCIAL ALLIANCE (THE)                                    "
    },
    {
        "type": "UIT",
        "mpid": "TSSM",
        "clearingBroker": "0161",
        "brokerName": "TWO SIGMA SECURITIES, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "TTSC",
        "clearingBroker": "0052",
        "brokerName": "TREND TRADE SECURITIES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "TTSI",
        "clearingBroker": "0158",
        "brokerName": "T3 SECURITIES, INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "TWCM",
        "clearingBroker": "0443",
        "brokerName": "TOWERS WATSON CAPITAL MARKETS                                         "
    },
    {
        "type": "UIT",
        "mpid": "TWDI",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "TWDL",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "TWDP",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "TWDR",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "TWDS",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "TWTT",
        "clearingBroker": "0158",
        "brokerName": "TASTYWORKS, INC.                                                      "
    },
    {
        "type": "UIT",
        "mpid": "UBSI",
        "clearingBroker": "0141",
        "brokerName": "UNITED BROKERAGE SERVICES, INC                                        "
    },
    {
        "type": "UIT",
        "mpid": "UBSW",
        "clearingBroker": "0642",
        "brokerName": "UBS SECURITIES LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "UCAP",
        "clearingBroker": "0750",
        "brokerName": "UCAP SECURITIES LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "UCCM",
        "clearingBroker": "0279",
        "brokerName": "CU INVESTMENT SOLUTIONS, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "UCML",
        "clearingBroker": "0052",
        "brokerName": "UNITED CAPITAL MARKETS, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "UHLM",
        "clearingBroker": "0235",
        "brokerName": "UHLMANN PRICE SECURITIES, LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "UMBF",
        "clearingBroker": "0226",
        "brokerName": "UMB FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "UNIB",
        "clearingBroker": "0443",
        "brokerName": "UNIBANCO SECURITIES INC                                               "
    },
    {
        "type": "UIT",
        "mpid": "UNIV",
        "clearingBroker": "0595",
        "brokerName": "UNIVEST SECURITIES, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "UNTD",
        "clearingBroker": "0443",
        "brokerName": "WADDELL & REED, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "UPLN",
        "clearingBroker": "0443",
        "brokerName": "UNITED PLANNERS FINANCIAL SERVICES OF AMERICA                         "
    },
    {
        "type": "UIT",
        "mpid": "USAF",
        "clearingBroker": "0443",
        "brokerName": "USA FINANCIAL SECURITIES CORP.                                        "
    },
    {
        "type": "UIT",
        "mpid": "USCA",
        "clearingBroker": "0226",
        "brokerName": "USCA SECURITIES LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "USIC",
        "clearingBroker": "0226",
        "brokerName": "U.S. SECURITIES, INTL. CORP.                                          "
    },
    {
        "type": "UIT",
        "mpid": "USTZ",
        "clearingBroker": "0595",
        "brokerName": "TRADEZERO AMERINCA, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "UVST",
        "clearingBroker": "0443",
        "brokerName": "UVEST FINANCIAL SERVICES GROUP, INC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "VABD",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "UIT",
        "mpid": "VALI",
        "clearingBroker": "0226",
        "brokerName": "VALLEY NATIONAL INVESTMENTS, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "VALM",
        "clearingBroker": "0443",
        "brokerName": "VALMARK SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "VBCS",
        "clearingBroker": "0279",
        "brokerName": "VBC SECURITIES                                                        "
    },
    {
        "type": "UIT",
        "mpid": "VBLT",
        "clearingBroker": "0226",
        "brokerName": "VANDERBILT SECURITIES, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "VBSL",
        "clearingBroker": "0595",
        "brokerName": "VISION BROKERAGE SERVICES, LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "VCAP",
        "clearingBroker": "0443",
        "brokerName": "VANGUARD CAPITAL                                                      "
    },
    {
        "type": "UIT",
        "mpid": "VCAS",
        "clearingBroker": "0443",
        "brokerName": "VCA SECURITIES, LP                                                    "
    },
    {
        "type": "UIT",
        "mpid": "VCFN",
        "clearingBroker": "0235",
        "brokerName": "VAN CLEMENS & CO. INCORPORATED                                        "
    },
    {
        "type": "UIT",
        "mpid": "VCSV",
        "clearingBroker": "0052",
        "brokerName": "PRIMARY CAPITAL, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "VENE",
        "clearingBroker": "0443",
        "brokerName": "VENECREDIT SECURITIES                                                 "
    },
    {
        "type": "UIT",
        "mpid": "VERF",
        "clearingBroker": "0235",
        "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "VERT",
        "clearingBroker": "8199",
        "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "VEST",
        "clearingBroker": "0750",
        "brokerName": "VESTECH SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "VETS",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN VETERANS GROUP, PBC                                          "
    },
    {
        "type": "UIT",
        "mpid": "VFSL",
        "clearingBroker": "0443",
        "brokerName": "VALOR FINANCIAL SECURITIES LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "VGRD",
        "clearingBroker": "0062",
        "brokerName": "VANGUARD MARKETING CORPORATION                                        "
    },
    {
        "type": "UIT",
        "mpid": "VISI",
        "clearingBroker": "0443",
        "brokerName": "VISION INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "VKMI",
        "clearingBroker": "0692",
        "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "VLEO",
        "clearingBroker": "0158",
        "brokerName": "VOLEO USA, INC                                                        "
    },
    {
        "type": "UIT",
        "mpid": "VMDI",
        "clearingBroker": "0443",
        "brokerName": "DESJARDINS SECURITIES INTERNATIONAL INC.                              "
    },
    {
        "type": "UIT",
        "mpid": "VMEX",
        "clearingBroker": "0443",
        "brokerName": "VECTORGLOBAL WMG                                                      "
    },
    {
        "type": "UIT",
        "mpid": "VPEW",
        "clearingBroker": "0158",
        "brokerName": "VPE WERTPAPIERHANDELSBANK AG                                          "
    },
    {
        "type": "UIT",
        "mpid": "VSIN",
        "clearingBroker": "0595",
        "brokerName": "VISION FINANCIAL MARKETS LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "VSRF",
        "clearingBroker": "0141",
        "brokerName": "VSR FINANCIAL SERVICES                                                "
    },
    {
        "type": "UIT",
        "mpid": "VTDT",
        "clearingBroker": "0158",
        "brokerName": "VIEWTRADE SECURITIES, INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "WABR",
        "clearingBroker": "0443",
        "brokerName": "WALL STREET ACCESS                                                    "
    },
    {
        "type": "UIT",
        "mpid": "WACC",
        "clearingBroker": "0279",
        "brokerName": "MIDLAND SECURITIES, LTD                                               "
    },
    {
        "type": "UIT",
        "mpid": "WACL",
        "clearingBroker": "0709",
        "brokerName": "WACHTEL & CO., INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "WAIN",
        "clearingBroker": "0443",
        "brokerName": "H.C. WAINWRIGHT & CO., INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "WBAX",
        "clearingBroker": "0052",
        "brokerName": "WALLACHBETH CAPITAL LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "WBBC",
        "clearingBroker": "0226",
        "brokerName": "WBB SECURITIES, LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "WBFS",
        "clearingBroker": "0443",
        "brokerName": "WOODBURY FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "WBLR",
        "clearingBroker": "0771",
        "brokerName": "WILLIAM BLAIR & COMPANY, L.L.C.                                       "
    },
    {
        "type": "UIT",
        "mpid": "WBNF",
        "clearingBroker": "0226",
        "brokerName": "WILLIAM BLAIR & COMPANY L.L.C.                                        "
    },
    {
        "type": "UIT",
        "mpid": "WBRO",
        "clearingBroker": "0443",
        "brokerName": "WILEY BROS.-AINTREE CAPITAL, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "WCIG",
        "clearingBroker": "0750",
        "brokerName": "WILLOW COVE INVESTMENT GROUP, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "WCSC",
        "clearingBroker": "0235",
        "brokerName": "WILMINGTON CAPITAL SECURITIES, LLC                                    "
    },
    {
        "type": "UIT",
        "mpid": "WCSF",
        "clearingBroker": "0235",
        "brokerName": "WORLD CHOICE SECURITIES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "WEBS",
        "clearingBroker": "0226",
        "brokerName": "WEALTH ENHANCEMENT BROKERAGE SERVICES, LLC                            "
    },
    {
        "type": "UIT",
        "mpid": "WEDB",
        "clearingBroker": "0103",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "WEGE",
        "clearingBroker": "0443",
        "brokerName": "WORLD EQUITY GROUP, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "WEGI",
        "clearingBroker": "0235",
        "brokerName": "WORLD EQUITY GROUP INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "WEGP",
        "clearingBroker": "0235",
        "brokerName": "WESTERN EQUITY GROUP, INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "WESC",
        "clearingBroker": "0443",
        "brokerName": "WELLINGTON SHIELDS & CO., LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "WEST",
        "clearingBroker": "0443",
        "brokerName": "WESTERN GROWERS FINANCIAL SERVICES, INC.                              "
    },
    {
        "type": "UIT",
        "mpid": "WEXR",
        "clearingBroker": "0235",
        "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "WEXX",
        "clearingBroker": "0005",
        "brokerName": "WOLVERINE EXECUTION SERVICES                                          "
    },
    {
        "type": "UIT",
        "mpid": "WHAE",
        "clearingBroker": "0443",
        "brokerName": "WHARTON EQUITY CORPORATION                                            "
    },
    {
        "type": "UIT",
        "mpid": "WHCG",
        "clearingBroker": "0388",
        "brokerName": "WHITAKER                                                              "
    },
    {
        "type": "UIT",
        "mpid": "WHOT",
        "clearingBroker": "0595",
        "brokerName": "JUST2TRADE, INC.                                                      "
    },
    {
        "type": "UIT",
        "mpid": "WIDS",
        "clearingBroker": "0279",
        "brokerName": "WISCONSIN DISCOUNT SECURITIES CORP.                                   "
    },
    {
        "type": "UIT",
        "mpid": "WING",
        "clearingBroker": "0443",
        "brokerName": "ING FINANCIAL PARTNERS, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "WISC",
        "clearingBroker": "0235",
        "brokerName": "WINDSOR, SHEFFIELD & CO., INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "WISE",
        "clearingBroker": "0052",
        "brokerName": "AXOS INVEST LLC                                                       "
    },
    {
        "type": "UIT",
        "mpid": "WISP",
        "clearingBroker": "0443",
        "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
    },
    {
        "type": "UIT",
        "mpid": "WJBI",
        "clearingBroker": "0443",
        "brokerName": "WJB CAPITAL GROUP                                                     "
    },
    {
        "type": "UIT",
        "mpid": "WLMS",
        "clearingBroker": "0443",
        "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
    },
    {
        "type": "UIT",
        "mpid": "WLTH",
        "clearingBroker": "0235",
        "brokerName": "WEALTHFRONT BROKERAGE CORPORATION                                     "
    },
    {
        "type": "UIT",
        "mpid": "WMFS",
        "clearingBroker": "0226",
        "brokerName": "WESTMINSTER FINANCIAL SECURITIES, INC.                                "
    },
    {
        "type": "UIT",
        "mpid": "WMLL",
        "clearingBroker": "0005",
        "brokerName": "WATERMILL INSTITUTIONAL TRADING LLC                                   "
    },
    {
        "type": "UIT",
        "mpid": "WPCC",
        "clearingBroker": "0052",
        "brokerName": "WESTPARK CAPITAL, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "WPCI",
        "clearingBroker": "0595",
        "brokerName": "WESTPARK CAPITAL, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "WPSX",
        "clearingBroker": "0445",
        "brokerName": "RISE FINANCIAL SERVICES, LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "WRET",
        "clearingBroker": "0141",
        "brokerName": "WELLS FARGO CLEARING SERVICES, LLC                                    "
    },
    {
        "type": "UIT",
        "mpid": "WSBI",
        "clearingBroker": "0443",
        "brokerName": "W&S BROKERAGE SVCS                                                    "
    },
    {
        "type": "UIT",
        "mpid": "WSCC",
        "clearingBroker": "0235",
        "brokerName": "WASHINGTON SECURITIES CORPORATION                                     "
    },
    {
        "type": "UIT",
        "mpid": "WSCX",
        "clearingBroker": "0235",
        "brokerName": "WORKMAN SECURITIES CORP                                               "
    },
    {
        "type": "UIT",
        "mpid": "WSEC",
        "clearingBroker": "0443",
        "brokerName": "WILLIS SECURITIES, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "WSGD",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC./P3                                            "
    },
    {
        "type": "UIT",
        "mpid": "WSIW",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "WSRP",
        "clearingBroker": "0052",
        "brokerName": "WESTROCK CAPITAL MANAGEMENT, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "WSTI",
        "clearingBroker": "0226",
        "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
    },
    {
        "type": "UIT",
        "mpid": "WTCO",
        "clearingBroker": "0005",
        "brokerName": "WILLIAMS TRADING LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "WTFS",
        "clearingBroker": "0052",
        "brokerName": "LIME TRADING CORP                                                     "
    },
    {
        "type": "UIT",
        "mpid": "WTKR",
        "clearingBroker": "0388",
        "brokerName": "WHITAKER                                                              "
    },
    {
        "type": "UIT",
        "mpid": "WTLP",
        "clearingBroker": "0388",
        "brokerName": "WOLVERINE TRADING, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "WTRI",
        "clearingBroker": "0235",
        "brokerName": "WATERFORD INVESTORS SERVICES, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "WUND",
        "clearingBroker": "0141",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "UIT",
        "mpid": "XPUS",
        "clearingBroker": "0443",
        "brokerName": "XP SECURITIES, LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "XRVR",
        "clearingBroker": "0279",
        "brokerName": "CRB SECURITIES, LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "XTLS",
        "clearingBroker": "0052",
        "brokerName": "XTELLUS CAPITAL PARTNERS, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "XTLW",
        "clearingBroker": "0052",
        "brokerName": "XTELLUS CAPITAL PARTNERS, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "XTXE",
        "clearingBroker": "0161",
        "brokerName": "XTX EXECUTION SERVICES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "YLPL",
        "clearingBroker": "0075",
        "brokerName": "LPL FINANCIAL LLC                                                     "
    },
    {
        "type": "UIT",
        "mpid": "YOSE",
        "clearingBroker": "0052",
        "brokerName": "YORK SECURITIES, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "ZAHK",
        "clearingBroker": "0443",
        "brokerName": "TRANSAMERICA FINANCIAL ADVISORS                                       "
    },
    {
        "type": "UIT",
        "mpid": "ZAND",
        "clearingBroker": "0443",
        "brokerName": "MCLAUGHLIN RYDER INVESTMENTS                                          "
    },
    {
        "type": "UIT",
        "mpid": "ZEDB",
        "clearingBroker": "0161",
        "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "ZERO",
        "clearingBroker": "0158",
        "brokerName": "TRADEZERO AMERICA, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "ZION",
        "clearingBroker": "0065",
        "brokerName": "ZIONS DIRECT, INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "ZIVI",
        "clearingBroker": "0235",
        "brokerName": "ZIV INVESTMENT COMPANY                                                "
    },
    {
        "type": "UIT",
        "mpid": "ZOUL",
        "clearingBroker": "0235",
        "brokerName": "N.B. ZOULLAS SECURITIES, INC.                                         "
    }
];
var $44e92e235e4eaad6$export$4d75181863a19b8c = "2025-06-06T21:50:06.884Z";


function $905eccc5e8449d72$var$_templateObject() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  padding: 1rem 1rem 16px 24px;\n  line-height: 1;\n  border-bottom: 1px solid var(--border-color);\n  font-family: monospace;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n\n  @media ",
        " {\n    flex-direction: column;\n    gap: 1.5rem;\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n"
    ]);
    $905eccc5e8449d72$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $905eccc5e8449d72$var$_templateObject1() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  display: flex;\n  gap: 0.25rem;\n  flex-direction: column;\n\n  @media ",
        " {\n    align-items: center;\n  }\n"
    ]);
    $905eccc5e8449d72$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $905eccc5e8449d72$var$_templateObject2() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  font-size: 0.875rem;\n  opacity: 0.7;\n  transform: translateX(1px);\n"
    ]);
    $905eccc5e8449d72$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $905eccc5e8449d72$var$_templateObject3() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  font-size: 1.5rem;\n  margin: 0;\n"
    ]);
    $905eccc5e8449d72$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $905eccc5e8449d72$var$_templateObject4() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  color: inherit;\n  display: inline;\n  transition: color 0.1s ease-in-out;\n\n  @media (hover: hover) {\n    &:hover {\n      color: var(--neutral-500);\n    }\n  }\n"
    ]);
    $905eccc5e8449d72$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $905eccc5e8449d72$var$_templateObject5() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.5rem;\n\n  @media ",
        " {\n    flex-direction: row-reverse;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n  }\n"
    ]);
    $905eccc5e8449d72$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $905eccc5e8449d72$var$_templateObject6() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  text-decoration: none;\n  color: inherit;\n\n  @media (hover: hover) {\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    $905eccc5e8449d72$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $905eccc5e8449d72$var$_templateObject7() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  display: inline-flex;\n  align-items: center;\n  width: 1.5em;\n  height: 1.5em;\n  color: var(--slate-500);\n\n  transition: color 0.1s ease-in-out;\n  @media (hover: hover) {\n    &:hover {\n      color: var(--slate-700);\n    }\n  }\n"
    ]);
    $905eccc5e8449d72$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $905eccc5e8449d72$var$_templateObject8() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: 0.5rem;\n  justify-content: flex-end;\n  align-items: center;\n\n  @media (max-width: ",
        "px) {\n    transform: translateY(-1px);\n  }\n"
    ]);
    $905eccc5e8449d72$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
var $905eccc5e8449d72$var$Wrapper = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).header($905eccc5e8449d72$var$_templateObject(), (0, $25a868dbea23500b$export$3d5e80817e1f8611));
var $905eccc5e8449d72$var$TitleSubhead = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).div($905eccc5e8449d72$var$_templateObject1(), (0, $25a868dbea23500b$export$3d5e80817e1f8611));
var $905eccc5e8449d72$var$Subhead = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).div($905eccc5e8449d72$var$_templateObject2());
var $905eccc5e8449d72$var$Title = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).h1($905eccc5e8449d72$var$_templateObject3());
var $905eccc5e8449d72$var$Link = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).a($905eccc5e8449d72$var$_templateObject4());
var $905eccc5e8449d72$var$SelfPromotion = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).div($905eccc5e8449d72$var$_templateObject5(), (0, $25a868dbea23500b$export$3d5e80817e1f8611));
var $905eccc5e8449d72$var$TitleLink = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).a($905eccc5e8449d72$var$_templateObject6());
var $905eccc5e8449d72$var$SocialLink = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).a($905eccc5e8449d72$var$_templateObject7());
var $905eccc5e8449d72$var$Socials = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).div($905eccc5e8449d72$var$_templateObject8(), (0, $25a868dbea23500b$export$83e664a9d119a376));
function $905eccc5e8449d72$var$Header() {
    return /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)($905eccc5e8449d72$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)($905eccc5e8449d72$var$TitleSubhead, {
                children: [
                    /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($905eccc5e8449d72$var$TitleLink, {
                        href: "/",
                        children: /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($905eccc5e8449d72$var$Title, {
                            children: "MPID Tracker"
                        })
                    }),
                    /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($905eccc5e8449d72$var$Subhead, {
                        children: "An MPID is a Market Participant Identifier, used to identify firms in the stock market."
                    }),
                    /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)($905eccc5e8449d72$var$Subhead, {
                        children: [
                            "Data is sourced from the",
                            " ",
                            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($905eccc5e8449d72$var$Link, {
                                href: "https://www.dtcc.com",
                                children: "Depository Trust & Clearing Corporation (DTCC)"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)($905eccc5e8449d72$var$Subhead, {
                        children: [
                            "Data last refreshed: ",
                            new Date((0, $44e92e235e4eaad6$export$4d75181863a19b8c)).toLocaleString()
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)($905eccc5e8449d72$var$SelfPromotion, {
                children: [
                    /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)($905eccc5e8449d72$var$Socials, {
                        children: [
                            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($905eccc5e8449d72$var$SocialLink, {
                                href: "https://github.com/davidawad/mpid-base",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)((0, $b8b947fdcf551f8e$export$52f0f02147b12c03), {})
                            }),
                            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($905eccc5e8449d72$var$SocialLink, {
                                href: "https://twitter.com/realdavidawad",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)((0, $b8b947fdcf551f8e$export$9e389cdad32a5b7a), {})
                            }),
                            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($905eccc5e8449d72$var$SocialLink, {
                                href: "https://bsky.app/profile/davidawad.bsky.social",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)((0, $b8b947fdcf551f8e$export$128fdd60f6c96030), {})
                            }),
                            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($905eccc5e8449d72$var$SocialLink, {
                                href: "https://www.linkedin.com/in/davidaawad/",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)((0, $b8b947fdcf551f8e$export$60f7169f5ee875bc), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)("p", {
                        children: [
                            "A website by ",
                            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($905eccc5e8449d72$var$Link, {
                                href: "https://davidawad.com",
                                children: "davidawad"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $905eccc5e8449d72$export$2e2bcd8739ae039 = $905eccc5e8449d72$var$Header;


function $d5c179dd7fbb3606$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $d5c179dd7fbb3606$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $d5c179dd7fbb3606$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $d5c179dd7fbb3606$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $27SFb = parcelRequire("27SFb");
var $0f2075159701fb3b$var$extendStatics = function extendStatics1(d, b) {
    $0f2075159701fb3b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $0f2075159701fb3b$var$extendStatics(d, b);
};
function $0f2075159701fb3b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $0f2075159701fb3b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $0f2075159701fb3b$export$18ce0697a983be9b = function __assign1() {
    $0f2075159701fb3b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0f2075159701fb3b$export$18ce0697a983be9b.apply(this, arguments);
};
function $0f2075159701fb3b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $0f2075159701fb3b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $27SFb._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $0f2075159701fb3b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $0f2075159701fb3b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $27SFb._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $0f2075159701fb3b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $0f2075159701fb3b$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $27SFb._)(x)) === "symbol" ? x : "".concat(x);
}
function $0f2075159701fb3b$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $27SFb._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $0f2075159701fb3b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $27SFb._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $0f2075159701fb3b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $0f2075159701fb3b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $0f2075159701fb3b$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $0f2075159701fb3b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $0f2075159701fb3b$export$45d3717a4c69092e(o, m, p);
}
function $0f2075159701fb3b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $0f2075159701fb3b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $0f2075159701fb3b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($0f2075159701fb3b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $0f2075159701fb3b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $0f2075159701fb3b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $0f2075159701fb3b$export$10c90e4f7922046c(v) {
    return this instanceof $0f2075159701fb3b$export$10c90e4f7922046c ? (this.v = v, this) : new $0f2075159701fb3b$export$10c90e4f7922046c(v);
}
function $0f2075159701fb3b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $0f2075159701fb3b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $0f2075159701fb3b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $0f2075159701fb3b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $0f2075159701fb3b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $0f2075159701fb3b$export$19a8beecd37a4c45 === "function" ? $0f2075159701fb3b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $0f2075159701fb3b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $0f2075159701fb3b$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $0f2075159701fb3b$var$ownKeys = function ownKeys1(o) {
    $0f2075159701fb3b$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $0f2075159701fb3b$var$ownKeys(o);
};
function $0f2075159701fb3b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $0f2075159701fb3b$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $0f2075159701fb3b$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $0f2075159701fb3b$var$__setModuleDefault(result, mod);
    return result;
}
function $0f2075159701fb3b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $0f2075159701fb3b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $0f2075159701fb3b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $0f2075159701fb3b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $27SFb._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $0f2075159701fb3b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $27SFb._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $0f2075159701fb3b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $0f2075159701fb3b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $0f2075159701fb3b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $0f2075159701fb3b$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $0f2075159701fb3b$export$2e2bcd8739ae039 = {
    __extends: $0f2075159701fb3b$export$a8ba968b8961cb8a,
    __assign: $0f2075159701fb3b$export$18ce0697a983be9b,
    __rest: $0f2075159701fb3b$export$3c9a16f847548506,
    __decorate: $0f2075159701fb3b$export$29e00dfd3077644b,
    __param: $0f2075159701fb3b$export$d5ad3fd78186038f,
    __esDecorate: $0f2075159701fb3b$export$3a84e1ae4e97e9b0,
    __runInitializers: $0f2075159701fb3b$export$d831c04e792af3d,
    __propKey: $0f2075159701fb3b$export$6a2a36740a146cb8,
    __setFunctionName: $0f2075159701fb3b$export$d1a06452d3489bc7,
    __metadata: $0f2075159701fb3b$export$f1db080c865becb9,
    __awaiter: $0f2075159701fb3b$export$1050f835b63b671e,
    __generator: $0f2075159701fb3b$export$67ebef60e6f28a6,
    __createBinding: $0f2075159701fb3b$export$45d3717a4c69092e,
    __exportStar: $0f2075159701fb3b$export$f33643c0debef087,
    __values: $0f2075159701fb3b$export$19a8beecd37a4c45,
    __read: $0f2075159701fb3b$export$8d051b38c9118094,
    __spread: $0f2075159701fb3b$export$afc72e2116322959,
    __spreadArrays: $0f2075159701fb3b$export$6388937ca91ccae8,
    __spreadArray: $0f2075159701fb3b$export$1216008129fb82ed,
    __await: $0f2075159701fb3b$export$10c90e4f7922046c,
    __asyncGenerator: $0f2075159701fb3b$export$e427f37a30a4de9b,
    __asyncDelegator: $0f2075159701fb3b$export$bbd80228419bb833,
    __asyncValues: $0f2075159701fb3b$export$e3b29a3d6162315f,
    __makeTemplateObject: $0f2075159701fb3b$export$4fb47efe1390b86f,
    __importStar: $0f2075159701fb3b$export$c21735bcef00d192,
    __importDefault: $0f2075159701fb3b$export$da59b14a69baef04,
    __classPrivateFieldGet: $0f2075159701fb3b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $0f2075159701fb3b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $0f2075159701fb3b$export$81fdc39f203e4e04,
    __addDisposableResource: $0f2075159701fb3b$export$88ac25d8e944e405,
    __disposeResources: $0f2075159701fb3b$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $0f2075159701fb3b$export$889dfb5d17574b0b
};




var $e7uJ5 = parcelRequire("e7uJ5");



function $296bb10d3ede4de1$var$_templateObject() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  border: none;\n  background: none;\n  padding: 0;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    $296bb10d3ede4de1$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $296bb10d3ede4de1$var$UnstyledButton = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).button($296bb10d3ede4de1$var$_templateObject());
var $296bb10d3ede4de1$export$2e2bcd8739ae039 = $296bb10d3ede4de1$var$UnstyledButton;






function $f4ec3911665869dd$var$_templateObject() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  height: 100%;\n  aspect-ratio: 1;\n  cursor: pointer;\n  padding: 0;\n  transition:\n    transform 0.1s ease-in-out,\n    color 0.1s ease-in-out;\n\n  @media ",
        " {\n    height: 60%;\n  }\n\n  &:focus {\n    outline: none;\n    background-color: transparent;\n  }\n\n  &:selected {\n    background-color: transparent;\n  }\n\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -webkit-tap-highlight-color: transparent;\n"
    ]);
    $f4ec3911665869dd$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $f4ec3911665869dd$var$_templateObject1() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  grid-area: copy;\n\n  color: var(--slate-700);\n\n  @media (hover: hover) {\n    &:hover {\n      color: var(--slate-900);\n    }\n  }\n\n  transform: ",
        ";\n\n  &:active {\n    transform: scale(0.8);\n  }\n\n  @media ",
        " {\n    height: 1.5rem;\n  }\n"
    ]);
    $f4ec3911665869dd$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $f4ec3911665869dd$var$_templateObject2() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  0% {\n    transform: scale(1) rotate(0deg);\n  }\n\n  20% {\n    transform: scale(0.8) rotate(-40deg);\n  }\n\n\n  100% {\n    transform: scale(1) rotate(360deg);\n  }\n"
    ]);
    $f4ec3911665869dd$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $f4ec3911665869dd$var$_templateObject3() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  grid-area: favorite;\n\n  color: var(--yellow-700);\n\n  --fill-color: ",
        ';\n\n  &[data-just-faved="true"] {\n    animation: ',
        " 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) both;\n  }\n\n  @media (hover: hover) {\n    &:hover {\n      color: ",
        ";\n    }\n  }\n\n  @media ",
        " {\n    height: 1.5rem;\n  }\n"
    ]);
    $f4ec3911665869dd$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $f4ec3911665869dd$var$_templateObject4() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  flex: 1;\n  min-height: 0;\n  position: relative;\n  outline: none;\n  overflow-y: auto;\n  margin: 0 18rem;\n\n  --text-size: 0.875rem;\n\n  @media ",
        " {\n    margin: 0 1rem;\n  }\n\n  @media ",
        " {\n    --text-size: 0.75rem;\n  }\n"
    ]);
    $f4ec3911665869dd$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $f4ec3911665869dd$var$_templateObject5() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  height: 100%;\n  padding-bottom: 2rem;\n"
    ]);
    $f4ec3911665869dd$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $f4ec3911665869dd$var$_templateObject6() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        '\n  display: grid;\n  padding: 0.25rem 0;\n  grid-template-areas: "type mpid brokerName clearingBroker favorite copy";\n  grid-template-columns: 0.5fr 1fr 3fr 1fr 0.5fr 0.5fr;\n  gap: 0.25rem 0.5rem;\n  align-items: center;\n  font-family: monospace;\n  white-space: nowrap;\n  font-size: var(--text-size);\n  border-bottom: 1px solid var(--border-color);\n  height: ',
        "px;\n  position: sticky;\n  top: 0;\n  background: var(--slate-200);\n  z-index: 1;\n\n  @media ",
        ' {\n    grid-template-areas: "type mpid brokerName clearingBroker";\n    grid-template-columns: 1fr 1fr 2fr 1fr;\n\n    & > [style*="grid-area: favorite"],\n    & > [style*="grid-area: copy"] {\n      display: none;\n    }\n  }\n'
    ]);
    $f4ec3911665869dd$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $f4ec3911665869dd$var$_templateObject7() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        '\n  display: grid;\n  padding: 0.25rem 0;\n\n  grid-template-areas: "type mpid brokerName clearingBroker favorite copy copied";\n  grid-template-rows: 100%;\n  grid-template-columns: 0.5fr 1fr 3fr 1fr 0.5fr 0.5fr 0.5fr;\n  gap: 0.25rem 0.5rem;\n  align-items: center;\n\n  font-family: monospace;\n  white-space: nowrap;\n  font-size: var(--text-size);\n  border-bottom: 1px solid var(--border-color);\n  height: ',
        "px;\n\n  @media (hover: hover) {\n    &:hover {\n      background-color: var(--slate-400);\n    }\n  }\n\n  background-color: var(--row-background, transparent);\n  transition: background-color 0.1s ease-in-out;\n\n  @media ",
        ' {\n    grid-template-columns: 0.5fr 1fr 2fr 1fr;\n    grid-template-areas:\n      "type mpid brokerName clearingBroker"\n      "favorite copy . .";\n    grid-template-rows: auto auto;\n    height: auto;\n    justify-content: center;\n    gap: 0.25rem 0.5rem;\n    padding: 0.5rem 0;\n    margin-left: 0;\n    white-space: normal;\n  }\n'
    ]);
    $f4ec3911665869dd$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $f4ec3911665869dd$var$_templateObject8() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  0% {\n    opacity: 0;\n  }\n\n  15% {\n    opacity: 1;\n  }\n\n  40% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"
    ]);
    $f4ec3911665869dd$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $f4ec3911665869dd$var$_templateObject9() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  0% {\n    opacity: 0;\n    transform: translateX(0);\n  }\n\n  30% {\n    opacity: 1;\n    transform: translateX(-110%);\n  }\n\n  50% {\n    opacity: 1;\n    transform: translateX(-110%);\n  }\n\n  100% {\n    transform: translateX(0);\n  }\n"
    ]);
    $f4ec3911665869dd$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $f4ec3911665869dd$var$_templateObject10() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  grid-area: copied;\n  font-size: var(--text-size);\n  color: var(--green-900);\n  animation: ",
        " 0.6s ease-in both;\n  user-select: none;\n\n  @media ",
        " {\n    position: absolute;\n    backdrop-filter: blur(10px);\n    background-color: var(--slate-100);\n    border-radius: 0.5rem;\n    padding: 0.5rem;\n    left: 100%;\n    animation: ",
        " 1s ease-out both;\n  }\n"
    ]);
    $f4ec3911665869dd$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $f4ec3911665869dd$var$_templateObject11() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  display: block;\n  width: fit-content;\n"
    ]);
    $f4ec3911665869dd$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function $f4ec3911665869dd$var$_templateObject12() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  background-color: yellow;\n"
    ]);
    $f4ec3911665869dd$var$_templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
var $f4ec3911665869dd$var$BaseButton = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039)((0, $296bb10d3ede4de1$export$2e2bcd8739ae039))($f4ec3911665869dd$var$_templateObject(), (0, $25a868dbea23500b$export$3d5e80817e1f8611));
var $f4ec3911665869dd$var$CopyButton = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039)($f4ec3911665869dd$var$BaseButton)($f4ec3911665869dd$var$_templateObject1(), function(props) {
    return props.$rowMouseDown ? "scale(0.8)" : "none";
}, (0, $25a868dbea23500b$export$3d5e80817e1f8611));
var $f4ec3911665869dd$var$SpinStretch = (0, $6a8d69d2aa3d57e7$export$d25ddfdf17c3ad3e)($f4ec3911665869dd$var$_templateObject2());
var $f4ec3911665869dd$var$FavoriteButton = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039)($f4ec3911665869dd$var$BaseButton)($f4ec3911665869dd$var$_templateObject3(), function(props) {
    return props.$isFaved ? "var(--yellow-500)" : "transparent";
}, $f4ec3911665869dd$var$SpinStretch, function(props) {
    return props.$isFaved ? "var(--yellow-100)" : "var(--yellow-500)";
}, (0, $25a868dbea23500b$export$3d5e80817e1f8611));
var $f4ec3911665869dd$var$Wrapper = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).div($f4ec3911665869dd$var$_templateObject4(), (0, $25a868dbea23500b$export$3d5e80817e1f8611), (0, $25a868dbea23500b$export$57b55975112d979e));
var $f4ec3911665869dd$var$List = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).div($f4ec3911665869dd$var$_templateObject5());
var $f4ec3911665869dd$var$HeaderRow = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).div($f4ec3911665869dd$var$_templateObject6(), (0, $25a868dbea23500b$export$cba6217a006ba569), (0, $25a868dbea23500b$export$3d5e80817e1f8611));
var $f4ec3911665869dd$var$RowWrapper = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).div($f4ec3911665869dd$var$_templateObject7(), (0, $25a868dbea23500b$export$cba6217a006ba569), (0, $25a868dbea23500b$export$3d5e80817e1f8611));
var $f4ec3911665869dd$var$FadeOutDown = (0, $6a8d69d2aa3d57e7$export$d25ddfdf17c3ad3e)($f4ec3911665869dd$var$_templateObject8());
var $f4ec3911665869dd$var$FadeOutSide = (0, $6a8d69d2aa3d57e7$export$d25ddfdf17c3ad3e)($f4ec3911665869dd$var$_templateObject9());
var $f4ec3911665869dd$var$CopiedText = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).div($f4ec3911665869dd$var$_templateObject10(), $f4ec3911665869dd$var$FadeOutDown, (0, $25a868dbea23500b$export$3d5e80817e1f8611), $f4ec3911665869dd$var$FadeOutSide);
var $f4ec3911665869dd$var$Cell = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).span($f4ec3911665869dd$var$_templateObject11());
var $f4ec3911665869dd$var$Highlight = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).span($f4ec3911665869dd$var$_templateObject12());
function $f4ec3911665869dd$var$Row(param) {
    var mpid = param.mpid, isFaved = param.isFaved, toggleFavedMPID = param.toggleFavedMPID, search = param.search;
    var _React_useState = (0, $9f3f58c235e31b6d$export$71511d61b312f219)((0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useState(null), 2), justFaved = _React_useState[0], setJustFaved = _React_useState[1];
    var _React_useState1 = (0, $9f3f58c235e31b6d$export$71511d61b312f219)((0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useState(false), 2), mouseDown = _React_useState1[0], setMouseDown = _React_useState1[1];
    var _React_useState2 = (0, $9f3f58c235e31b6d$export$71511d61b312f219)((0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useState(0), 2), justCopied = _React_useState2[0], setJustCopied = _React_useState2[1];
    var timeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useRef(null);
    var handleCopy = (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useCallback(/*#__PURE__*/ (0, $d5c179dd7fbb3606$export$71511d61b312f219)(function() {
        return (0, $0f2075159701fb3b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    clearTimeout(timeoutRef.current);
                    return [
                        4,
                        navigator.clipboard.writeText(mpid.brokerName.trim()).catch(function(e) {
                            console.error("error copying to clipboard", e);
                            setJustCopied(0);
                        }).then(function() {
                            setJustCopied(function(prev) {
                                return prev + 1;
                            });
                            timeoutRef.current = setTimeout(function() {
                                setJustCopied(0);
                            }, 1000);
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        mpid.mpid
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useEffect(function() {
        if (justFaved && justFaved !== mpid.mpid) setJustFaved(null);
    }, [
        justFaved,
        mpid.mpid
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useEffect(function() {
        var handleMouseUp = function() {
            if (mouseDown) {
                setMouseDown(false);
                handleCopy();
            }
        };
        window.addEventListener("mouseup", handleMouseUp);
        return function() {
            window.removeEventListener("mouseup", handleMouseUp);
        };
    }, [
        mouseDown,
        handleCopy
    ]);
    var highlight = function(text) {
        if (!search || !text.toLowerCase().includes(search.toLowerCase())) return text;
        var start = text.toLowerCase().indexOf(search.toLowerCase());
        var end = start + search.length;
        return /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)((0, $5653a780cfe29e3e$exports.Fragment), {
            children: [
                text.slice(0, start),
                /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($f4ec3911665869dd$var$Highlight, {
                    children: text.slice(start, end)
                }),
                text.slice(end)
            ]
        });
    };
    return /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)($f4ec3911665869dd$var$RowWrapper, {
        onMouseDown: function(e) {
            if (e.target === e.currentTarget) setMouseDown(true);
        },
        style: {
            backgroundColor: mouseDown ? "var(--slate-500)" : null
        },
        children: [
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($f4ec3911665869dd$var$Cell, {
                style: {
                    gridArea: "type"
                },
                children: highlight(mpid.type)
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($f4ec3911665869dd$var$Cell, {
                style: {
                    gridArea: "mpid"
                },
                children: highlight(mpid.mpid)
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($f4ec3911665869dd$var$Cell, {
                style: {
                    gridArea: "brokerName"
                },
                children: highlight(mpid.brokerName)
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($f4ec3911665869dd$var$Cell, {
                style: {
                    gridArea: "clearingBroker"
                },
                children: highlight(mpid.clearingBroker)
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($f4ec3911665869dd$var$CopyButton, {
                onClick: handleCopy,
                $rowMouseDown: mouseDown,
                children: /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)((0, $b8b947fdcf551f8e$export$ea3b71af1761ff40), {
                    style: {
                        height: "100%",
                        aspectRatio: 1
                    }
                })
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($f4ec3911665869dd$var$FavoriteButton, {
                $isFaved: isFaved,
                "data-just-faved": isFaved && justFaved === mpid.mpid,
                onClick: function() {
                    if (!isFaved) setJustFaved(mpid.mpid);
                    toggleFavedMPID(mpid.mpid);
                },
                children: /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)((0, $b8b947fdcf551f8e$export$1644ba17714857f1), {
                    fill: "var(--fill-color)",
                    style: {
                        height: "100%",
                        aspectRatio: 1
                    }
                })
            }),
            justCopied !== 0 && /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($f4ec3911665869dd$var$CopiedText, {
                children: "copied!"
            }, justCopied)
        ]
    });
}
function $f4ec3911665869dd$var$MPIDDisplay(param) {
    var mpids = param.mpids, favedMPIDs = param.favedMPIDs, toggleFavedMPID = param.toggleFavedMPID, search = param.search;
    return /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)($f4ec3911665869dd$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)($f4ec3911665869dd$var$HeaderRow, {
                children: [
                    /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($f4ec3911665869dd$var$Cell, {
                        style: {
                            gridArea: "type"
                        },
                        children: "Type"
                    }),
                    /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($f4ec3911665869dd$var$Cell, {
                        style: {
                            gridArea: "mpid"
                        },
                        children: "MPID"
                    }),
                    /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($f4ec3911665869dd$var$Cell, {
                        style: {
                            gridArea: "brokerName"
                        },
                        children: "Broker Name"
                    }),
                    /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($f4ec3911665869dd$var$Cell, {
                        style: {
                            gridArea: "clearingBroker"
                        },
                        children: "Clearing Broker"
                    }),
                    /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($f4ec3911665869dd$var$Cell, {
                        style: {
                            gridArea: "favorite"
                        },
                        children: "Favorite"
                    }),
                    /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($f4ec3911665869dd$var$Cell, {
                        style: {
                            gridArea: "copy"
                        },
                        children: "Copy"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($f4ec3911665869dd$var$List, {
                children: mpids.map(function(mpid, index) {
                    return /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($f4ec3911665869dd$var$Row, {
                        mpid: mpid,
                        isFaved: favedMPIDs[mpid.mpid],
                        toggleFavedMPID: toggleFavedMPID,
                        search: search
                    }, "".concat(mpid.mpid, "-").concat(index));
                })
            })
        ]
    });
}
var $f4ec3911665869dd$export$2e2bcd8739ae039 = $f4ec3911665869dd$var$MPIDDisplay;






var $e7uJ5 = parcelRequire("e7uJ5");




function $8119ab029ea7139e$var$_templateObject() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  font-size: 0.875rem;\n  aspect-ratio: 1;\n  max-height: 80%;\n  padding: 4px;\n  color: var(--neutral-700);\n  flex-shrink: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  @media (hover: hover) {\n    &:hover {\n      background-color: var(--slate-200);\n    }\n  }\n"
    ]);
    $8119ab029ea7139e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $8119ab029ea7139e$var$_templateObject1() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: 0.25rem;\n  height: 2rem;\n  position: fixed;\n  top: 0;\n  right: 4rem;\n  padding: 0 0.5rem;\n\n  max-width: calc(100vw - ",
        "px);\n\n  @media ",
        " {\n    right: calc(",
        "px);\n  }\n\n  transform: translateY(var(--y-offset));\n  transition: transform 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);\n  z-index: 1000;\n  background-color: var(--slate-50);\n  align-items: center;\n"
    ]);
    $8119ab029ea7139e$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $8119ab029ea7139e$var$_templateObject2() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  background-color: var(--slate-50);\n  border-radius: 0 0 8px 8px;\n  font-size: 0.875rem;\n  font-family: monospace;\n  padding: 0rem 1rem;\n\n  display: flex;\n  align-items: center;\n\n  position: absolute;\n  z-index: 999;\n  right: 10rem;\n  color: inherit;\n  @media ",
        " {\n    right: calc(",
        "px);\n    bottom: 0;\n    border-radius: 8px 0 0 8px;\n  }\n\n  outline: none;\n  &:focus {\n    outline: none;\n  }\n  cursor: pointer;\n  transition: background-color 0.1s ease-in-out;\n  @media (hover: hover) {\n    &:hover {\n      background-color: var(--slate-400);\n    }\n  }\n"
    ]);
    $8119ab029ea7139e$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $8119ab029ea7139e$var$_templateObject3() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  font-family: monospace;\n  font-size: 1rem;\n  width: 100%;\n  padding: 0.25rem;\n  outline: none;\n  border: none;\n  background-color: var(--slate-50);\n\n  &:focus {\n    outline: none;\n  }\n"
    ]);
    $8119ab029ea7139e$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $8119ab029ea7139e$var$_templateObject4() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  flex: 1 1 38ch;\n  width: 38ch;\n  min-width: 6ch;\n"
    ]);
    $8119ab029ea7139e$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
var $8119ab029ea7139e$var$Button = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039)((0, $296bb10d3ede4de1$export$2e2bcd8739ae039))($8119ab029ea7139e$var$_templateObject());
var $8119ab029ea7139e$var$Wrapper = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).div($8119ab029ea7139e$var$_templateObject1(), (0, $25a868dbea23500b$export$9a6bb2acef5e644a), (0, $25a868dbea23500b$export$3d5e80817e1f8611), (0, $25a868dbea23500b$export$9a6bb2acef5e644a));
var $8119ab029ea7139e$var$ShowSearchButton = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039)((0, $296bb10d3ede4de1$export$2e2bcd8739ae039))($8119ab029ea7139e$var$_templateObject2(), (0, $25a868dbea23500b$export$3d5e80817e1f8611), (0, $25a868dbea23500b$export$9a6bb2acef5e644a));
var $8119ab029ea7139e$var$Input = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).input($8119ab029ea7139e$var$_templateObject3());
var $8119ab029ea7139e$var$Form = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).form($8119ab029ea7139e$var$_templateObject4());
function $8119ab029ea7139e$var$SearchWidget(param) {
    var search = param.search, setSearch = param.setSearch;
    var _React_useState = (0, $9f3f58c235e31b6d$export$71511d61b312f219)((0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useState(false), 2), searchDisplayed = _React_useState[0], setSearchDisplayed = _React_useState[1];
    var inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useRef(null);
    var cmdKey = (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useMemo(function() {
        var isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
        return isMac ? "metaKey" : "ctrlKey";
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useEffect(function() {
        var handleKeyDown = function(e) {
            if (e[cmdKey] && e.key === "f") {
                var _inputRef_current;
                e.preventDefault();
                setSearchDisplayed(true);
                (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
            } else if (e.key === "Escape") setSearchDisplayed(false);
        };
        window.addEventListener("keydown", handleKeyDown);
        return function() {
            return window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        cmdKey
    ]);
    return /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)((0, $5653a780cfe29e3e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($8119ab029ea7139e$var$ShowSearchButton, {
                onClick: function() {
                    setSearchDisplayed(function(prev) {
                        return !prev;
                    });
                },
                children: "search!"
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)($8119ab029ea7139e$var$Wrapper, {
                style: {
                    "--y-offset": searchDisplayed ? "0" : "-110%"
                },
                children: [
                    /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($8119ab029ea7139e$var$Form, {
                        onSubmit: function(e) {
                            e.preventDefault();
                        },
                        children: /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($8119ab029ea7139e$var$Input, {
                            ref: inputRef,
                            type: "text",
                            placeholder: "Search for an MPID",
                            value: search,
                            onChange: function(e) {
                                setSearch(e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($8119ab029ea7139e$var$Button, {
                        onClick: function() {
                            return setSearchDisplayed(false);
                        },
                        children: /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)((0, $b8b947fdcf551f8e$export$78acf4525d8a74c4), {
                            style: {
                                height: "100%",
                                width: "100%"
                            }
                        })
                    })
                ]
            })
        ]
    });
}
var $8119ab029ea7139e$export$2e2bcd8739ae039 = $8119ab029ea7139e$var$SearchWidget;




parcelRequire("e7uJ5");




function $60133eb991b65d86$var$_templateObject() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  background-color: var(--slate-50);\n  border-radius: 0 0 8px 8px;\n  font-size: 0.875rem;\n  font-family: monospace;\n  padding: 0.15rem 1rem;\n  height: 2rem;\n  display: flex;\n  align-items: center;\n  position: absolute;\n  z-index: 999;\n  right: 16rem;\n  color: inherit;\n\n  --fill-color: ",
        ";\n\n  @media ",
        " {\n    right: 8rem;\n    bottom: 0;\n    border-radius: 8px 8px 0 0;\n  }\n  outline: none;\n  &:focus {\n    outline: none;\n  }\n  cursor: pointer;\n  transition: background-color 0.1s ease-in-out;\n  @media (hover: hover) {\n    &:hover {\n      background-color: var(--slate-400);\n    }\n  }\n"
    ]);
    $60133eb991b65d86$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $60133eb991b65d86$var$FavoritesButton = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039)((0, $296bb10d3ede4de1$export$2e2bcd8739ae039))($60133eb991b65d86$var$_templateObject(), function(props) {
    return props.$isShowingFavorites ? "var(--yellow-500)" : "transparent";
}, (0, $25a868dbea23500b$export$3d5e80817e1f8611));
function $60133eb991b65d86$var$FavoritesWidget(param) {
    var setShowFavorites = param.setShowFavorites, isShowingFavorites = param.isShowingFavorites;
    return /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)((0, $5653a780cfe29e3e$exports.Fragment), {
        children: /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($60133eb991b65d86$var$FavoritesButton, {
            onClick: function() {
                setShowFavorites(function(prev) {
                    return !prev;
                });
            },
            $isShowingFavorites: isShowingFavorites,
            children: /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)((0, $b8b947fdcf551f8e$export$1644ba17714857f1), {
                fill: "var(--fill-color)",
                style: {
                    height: "100%",
                    aspectRatio: 1
                }
            })
        })
    });
}
var $60133eb991b65d86$export$2e2bcd8739ae039 = $60133eb991b65d86$var$FavoritesWidget;






var $e7uJ5 = parcelRequire("e7uJ5");

function $15b2fe4a32ee6ae2$export$7b1c8a0f149af98a() {
    var _React_useState = (0, $9f3f58c235e31b6d$export$71511d61b312f219)((0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useState(""), 2), search = _React_useState[0], setSearch = _React_useState[1];
    var _React_useState1 = (0, $9f3f58c235e31b6d$export$71511d61b312f219)((0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useState([]), 2), results = _React_useState1[0], setResults = _React_useState1[1];
    var searchMpins = (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useCallback(function(input) {
        setSearch(input);
        if (!input) {
            setResults([]);
            return;
        }
        var lowercasedInput = input.toLowerCase();
        var filtered = (0, $44e92e235e4eaad6$export$51fe096c4db50bc8).filter(function(mpid) {
            return mpid.mpid.toLowerCase().includes(lowercasedInput) || mpid.brokerName.toLowerCase().includes(lowercasedInput) || mpid.clearingBroker.toLowerCase().includes(lowercasedInput) || mpid.type.toLowerCase().includes(lowercasedInput);
        });
        setResults(filtered);
    }, []);
    return {
        search: search,
        results: results,
        searchMpins: searchMpins
    };
}



function $87a8edc07d3ef1ae$var$_templateObject() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: row;\n  height: 100svh;\n  max-height: 100svh;\n  height: 100dvh;\n  max-height: 100dvh;\n  overflow: hidden;\n  overscroll-behavior: none;\n"
    ]);
    $87a8edc07d3ef1ae$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $87a8edc07d3ef1ae$var$_templateObject1() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n"
    ]);
    $87a8edc07d3ef1ae$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $87a8edc07d3ef1ae$var$_templateObject2() {
    var data = (0, $aa21808cecea3360$export$71511d61b312f219)([
        "\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  min-height: 0;\n  overscroll-behavior: none;\n"
    ]);
    $87a8edc07d3ef1ae$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $87a8edc07d3ef1ae$var$Wrapper = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).div($87a8edc07d3ef1ae$var$_templateObject());
var $87a8edc07d3ef1ae$var$HeaderAndContent = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).div($87a8edc07d3ef1ae$var$_templateObject1());
var $87a8edc07d3ef1ae$var$Content = (0, $6a8d69d2aa3d57e7$export$2e2bcd8739ae039).div($87a8edc07d3ef1ae$var$_templateObject2());
function $87a8edc07d3ef1ae$var$App() {
    var _React_useState = (0, $9f3f58c235e31b6d$export$71511d61b312f219)((0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useState(false), 2), showFavorites = _React_useState[0], setShowFavorites = _React_useState[1];
    var _useMpidSearch = (0, $15b2fe4a32ee6ae2$export$7b1c8a0f149af98a)(), search = _useMpidSearch.search, results = _useMpidSearch.results, searchMpins = _useMpidSearch.searchMpins;
    var _React_useState1 = (0, $9f3f58c235e31b6d$export$71511d61b312f219)((0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useState(localStorage.getItem("favedMPIDs") ? JSON.parse(localStorage.getItem("favedMPIDs")) : {}), 2), favedMPIDs = _React_useState1[0], setFavedMPIDs = _React_useState1[1];
    var toggleFavedMPID = function(mpid) {
        setFavedMPIDs(function(prev) {
            var newFavedMPIDs = (0, $3726bb8d3c17940f$export$71511d61b312f219)({}, prev);
            if (newFavedMPIDs[mpid]) delete newFavedMPIDs[mpid];
            else newFavedMPIDs[mpid] = true;
            localStorage.setItem("favedMPIDs", JSON.stringify(newFavedMPIDs));
            return newFavedMPIDs;
        });
    };
    var displayedMpids = (0, (/*@__PURE__*/$parcel$interopDefault($e7uJ5))).useMemo(function() {
        if (search) return results;
        if (showFavorites) return (0, $44e92e235e4eaad6$export$51fe096c4db50bc8).filter(function(mpid) {
            return favedMPIDs[mpid.mpid];
        });
        return 0, $44e92e235e4eaad6$export$51fe096c4db50bc8;
    }, [
        search,
        results,
        showFavorites,
        favedMPIDs
    ]);
    return /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)((0, $5653a780cfe29e3e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)((0, $8119ab029ea7139e$export$2e2bcd8739ae039), {
                search: search,
                setSearch: searchMpins
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)((0, $60133eb991b65d86$export$2e2bcd8739ae039), {
                setShowFavorites: setShowFavorites,
                isShowingFavorites: showFavorites
            }),
            /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($87a8edc07d3ef1ae$var$Wrapper, {
                children: /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsxs)($87a8edc07d3ef1ae$var$HeaderAndContent, {
                    children: [
                        /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)((0, $905eccc5e8449d72$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)($87a8edc07d3ef1ae$var$Content, {
                            children: /*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)((0, $f4ec3911665869dd$export$2e2bcd8739ae039), {
                                mpids: displayedMpids,
                                favedMPIDs: favedMPIDs,
                                toggleFavedMPID: toggleFavedMPID,
                                search: search
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var $87a8edc07d3ef1ae$export$2e2bcd8739ae039 = $87a8edc07d3ef1ae$var$App;




var $1b796a2c02d8465c$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($75511b671e3d5c31$exports))).createRoot(document.getElementById('root'));
$1b796a2c02d8465c$var$root.render(/*#__PURE__*/ (0, $5653a780cfe29e3e$exports.jsx)((0, $87a8edc07d3ef1ae$export$2e2bcd8739ae039), {}));

})();
//# sourceMappingURL=index.93600b16.js.map
